webpackJsonp([1],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	
	
	window.main = true;
	
	if (!window.prefetch) {
	    window.beacon('info', ['angular_bootstrap_start']);
	    angular.bootstrap(document.body, ['app']);
	    window.beacon('info', ['angular_bootstrap_end']);
	    __webpack_require__("./js/app.js");
	}

/***/ },

/***/ "./..":
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../../node_modules/css-loader/index.js!./../../../../../../node_modules/less-loader/index.js!./styles.less", function() {
				var newContent = require("!!./../../../../../../node_modules/css-loader/index.js!./../../../../../../node_modules/less-loader/index.js!./styles.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "./css/app.less":
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./css/app.less");
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/less-loader/index.js!./app.less", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/less-loader/index.js!./app.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./css/app.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select>span{display:block;padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#loginSection .wallet_vprop_img{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png\") 0 0 no-repeat;height:104px}#loginSection .inline-prop{font-size:.85em}#loginSection .trayInner{margin:0 0 25px;padding:0}#loginSection #forgotPasswordSection{margin:16px auto 19px;padding-bottom:5px}#loginSection .alpha{margin-top:0}#loginSection .pr{position:relative;padding-top:25px}#loginSection .pr.hasError{margin-top:0}#loginSection .loginBtn{margin-top:5px}#loginSection .msgPage{padding:15px 0 5px}#loginSection .row-fluid>.span10{float:right}.login.guestBtnOnTop #loginSection .pr{padding-top:0}.login .infoLoader{position:fixed;top:0;left:0;background:#fff;width:100%;height:100%}.login .infoLoader .logo_wrapper{position:relative;display:inline-block;width:100%;height:40px;margin:70px 0 30px}.login .infoLoader .logo_wrapper .partner_logo{position:absolute;left:50%;margin-left:-48px;width:97px;height:40px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1.png\");background-repeat:no-repeat;background-position:-10px -10px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.login .infoLoader .logo_wrapper .partner_logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1_2x.png\");background-size:119px 209px}}.onboardingSection .inline-prop{font-size:.85em;text-align:center;margin-top:10px}.onboardingSection .guestHeading{position:relative}.onboardingSection .orSeparator{height:auto;border-top:1px solid #ccc;text-align:center;margin:25px 0 5px}.onboardingSection .orSeparator .textInDivider{background-color:#fff;color:#6c7378;display:inline-block;padding:0 .5em;position:relative;top:-.7em}.noscript{margin:0;padding:30px;width:58%;border:3px solid red;position:absolute;top:95px;left:20%;display:block;z-index:1001;background:#fff;font-size:18px;text-align:center}.login .span14.trayInner{padding:20px 0 15px}.capeRedirect{height:300px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){#loginSection .wallet_vprop_img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v2_2x.png\");background-size:195px 104px}}@media (min-width:0) and (max-width:30em){#loginSection .pr{margin-top:0}#loginSection .trayInner{margin:0 0 20px}}.trayOpen #main{float:right;margin-right:-320px;width:100%;border-left:1px solid #ddd;min-height:500px}.trayOpen .maskMember .trayViewMask{width:100%;height:170%;position:absolute;top:-85px;left:-30px;z-index:6;cursor:pointer;background-color:#edf2f5;-webkit-opacity:.5;-moz-opacity:.5;opacity:.5;min-height:550px}.trayOpen .justMember,.trayOpen .paypalHeaderWrapper{opacity:.5}.trayOpen .reviewButton{display:none}.asideContent{overflow-y:auto;overflow-x:hidden}.sidebar{position:absolute;left:-351px;top:-80px;width:320px}.sidebar .asideContent{overflow-y:auto;overflow-x:hidden}@media (max-width:41.25em){.trayOpen #main{margin-right:-295px}.trayOpen .sidebar{left:-295px;top:-65px;width:295px}.trayOpen .minibrowser #main{min-height:535px;margin-right:-320px}.trayOpen .minibrowser .sidebar{left:-320px;top:-75px;width:320px}.trayOpen .maskMember .trayViewMask{top:-80px;left:0}}.sidePageOpen .outerWrapper.tokenization{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.sidePageOpen.sidepageAddCardOpen .outerWrapper.tokenization{-webkit-transform:translateY(-100%);transform:translateY(-100%)}.outerWrapper.tokenization{-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.outerWrapper.tokenization #sliding-area{overflow:visible}.header{border-bottom:1px solid #ddd}@media (max-width:41.25em){.tokenization .frontArrow{top:0;left:auto;right:0;width:10px;height:18px;background:none}.tokenization .frontArrow:before{content:\"\";width:10px;height:18px;display:inline-block;background-size:119px 209px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1.png\");background-repeat:no-repeat;background-position:-67px -97px}.tokenization .aside .leftIcon{position:absolute;top:17px;left:25px;width:12px;height:22px;padding:5px;border-radius:3px}.tokenization .aside .leftIcon:before{position:absolute;content:\"\";width:12px;height:22px;display:inline-block;background-size:119px 209px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1.png\");background-repeat:no-repeat;background-position:-66px -123px}.tokenization .aside .primaryHeader .rightIcon{position:absolute;top:16px;right:25px;width:24px;height:24px;padding:5px;border-radius:3px}.tokenization .aside .primaryHeader .rightIcon:before{content:\"\";position:absolute;display:inline-block;width:24px;height:24px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1.png\");background-repeat:no-repeat;background-position:-65px -152px}.sidepage{position:fixed;top:0;left:100%;width:100%;height:100vh;background:#fff;display:flex;flex-direction:column}.sidepage.noSlide{left:0}.sidepage.noSlide .content{padding:5px 15px}.sidepage .content{padding:20px 30px;flex:1 1 auto}.sidepage .aside .header{padding:20px 30px}.sidepage #sidepageAddCard{position:absolute;top:0;background-color:#fff;min-height:100%;width:100%;-webkit-transform:translateY(100%);transform:translateY(100%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.sidepage #sidepageAddCard.noSlide{-webkit-transform:translateY(0);transform:translateY(0)}.sidepage #sidepageAddCard.slideLeft{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.sidepage #sidepageAddCard .content{padding:5px 15px}.sidepage #sidepageAddCard .dropdown.billingAddress{margin-bottom:20px}.sidepage #sidepageAddCard #proceedButton{float:none}.sidepage #sidepageAddCard .linkButton{margin-top:25px;text-align:center}.sidepage #sidepageAddCard #addBillingAddress{position:fixed;top:0;left:0;background:#fff;width:100vw;height:100vh;transform:translateX(100%)}.sidepage #sidepageAddCard #addBillingAddress .container{padding:20px 30px}.sidepage #sidepageAddCard #addBillingAddress .container #proceedButton{width:100%}.sidepage #sidepageAddCard #addBillingAddress .leftIcon{position:absolute;top:17px;left:25px;width:12px;height:22px;padding:5px;border-radius:3px}.sidepage #sidepageAddCard #addBillingAddress .leftIcon:before{position:absolute;content:\"\";width:12px;height:22px;display:inline-block;background-size:119px 209px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1.png\");background-repeat:no-repeat;background-position:-66px -123px}.sidepage #sidepageAddCard.sidepageAddCardOpen{-webkit-transform:translateY(0);transform:translateY(0)}.sidepage #sidepageAddCard.sidepageAddCardOpen.slideLeft{-webkit-transform:translateX(-100%);transform:translateX(-100%)}}@media (max-width:41.25em) and only screen and (-webkit-min-device-pixel-ratio:2),(max-width:41.25em) and only screen and (min--moz-device-pixel-ratio:2),(max-width:41.25em) and only screen and (min-device-pixel-ratio:2),(max-width:41.25em) and only screen and (min-resolution:2dppx),(max-width:41.25em) and only screen and (min-resolution:192dpi){.sidepage #sidepageAddCard #addBillingAddress .leftIcon:before,.tokenization .aside .leftIcon:before,.tokenization .aside .primaryHeader .rightIcon:before,.tokenization .frontArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1_2x.png\");background-size:119px 209px}}#fundingInstrumentList.fundingInstrumentList{width:100%;top:0;left:0;position:relative;z-index:1;background:#fff;border-bottom:1px solid #999}#fundingInstrumentList.fundingInstrumentList ul{margin:0;list-style-type:none;overflow:hidden}#fundingInstrumentList.fundingInstrumentList ul li{position:relative;width:50%;height:90px;float:left;color:#fff;background:#008bdf;cursor:pointer;text-align:center}#fundingInstrumentList.fundingInstrumentList ul li .icon{width:30px;height:25px;margin:0 auto;padding:0;vertical-align:middle;text-align:center}#fundingInstrumentList.fundingInstrumentList ul li .description,#fundingInstrumentList.fundingInstrumentList ul li .icon{display:block}#fundingInstrumentList.fundingInstrumentList ul li .description{margin-top:7px;vertical-align:middle}#fundingInstrumentList.fundingInstrumentList ul li.bank .icon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_icon_addFI_white_2x.png\") 0 -49px no-repeat;background-size:29px}#fundingInstrumentList.fundingInstrumentList ul li.cards .icon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_icon_addFI_white_2x.png\") 0 5px no-repeat;background-size:29px}#fundingInstrumentList.fundingInstrumentList ul li:hover{background:#0079c1;color:#fff}#fundingInstrumentList.fundingInstrumentList ul li a{position:relative;display:inline-block;width:100%;height:100%;-ms-box-sizing:border-box;box-sizing:border-box;padding:10px 15px;color:#fff;text-decoration:none}li.fundingsource{overflow:hidden}.allFundingInstrumentsList{margin:0;padding:0}.allFundingInstrumentsList li{width:99.8%;list-style:none;margin:0;padding:0;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out;border-bottom:1px solid #e3e3e3}.allFundingInstrumentsList li a:hover{background-color:#f7f9fa}.allFundingInstrumentsList li a.source{display:block;min-height:70px;padding:0;position:relative;text-decoration:none;color:#000;border:2px solid transparent}.allFundingInstrumentsList li a.source:focus{border:2px solid #009cde}.allFundingInstrumentsList li div.source{display:block;min-height:70px;padding:0;position:relative;text-decoration:none;color:#000}.allFundingInstrumentsList li div.source:focus{border:2px solid #009cde}.allFundingInstrumentsList li .fsIcon{margin:18px 10px 0 15px;top:0;left:0}.allFundingInstrumentsList li .fsIcon.pinlessIcon{left:-10px}.allFundingInstrumentsList li .fsdetails{width:210px;overflow:hidden;text-overflow:ellipsis;margin:0;padding:15px 0 0;position:relative}.allFundingInstrumentsList li .fsdetails span{display:block;margin-bottom:1px;text-overflow:ellipsis;overflow:hidden}.allFundingInstrumentsList li .fsdetails span.amount,.allFundingInstrumentsList li .fsdetails span.lastdigits{color:#6c7378;font-size:.85em}.allFundingInstrumentsList li .fsdetails span.subtype{display:inline;color:#2c2e2f}.allPlanList,.allPlanList li{margin:0;padding:0}.allPlanList li{width:99.8%;list-style:none;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out;border-bottom:1px solid #e3e3e3}.allPlanList li a:hover{background-color:#f7f9fa}.allPlanList li a.source{display:block;min-height:70px;padding:3px 0;position:relative;text-decoration:none;color:#000;border:2px solid transparent}.allPlanList li a.source:focus{border:2px solid #009cde}.allPlanList li div.source{display:block;min-height:70px;padding:0;position:relative;text-decoration:none;color:#000}.allPlanList li div.source:focus{border:2px solid #009cde}.allPlanList li .fsIcon{margin:0 3px 0 0;top:0;left:-2px}.allPlanList li .fsIcon.pinlessIcon{left:-10px;top:-7px;margin-left:-10px;margin-top:-5px;margin-right:10px}.allPlanList li .fsdetails{width:230px;overflow:hidden;text-overflow:ellipsis;margin:0;padding:0 3px;position:relative;font-size:15px;display:block}.allPlanList li .fsdetails span.amount{font-weight:500}.instrumentContainer{margin:15px 0 15px 10px}.singleInstrumentContainer{padding-top:9px}.disallowedContainer{margin:10px 0 10px 10px;padding-top:8px;opacity:.5}.bmlDetailsWalletTerms{margin-top:-20px}.fundingOverlay{width:100%;display:block;z-index:3;position:absolute;left:0;top:64px;bottom:0;border-radius:0 0 5px 5px;background-clip:padding-box}.disabledCardOpacity{opacity:.6;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\"}.disabledCardOpacity.balance{opacity:1;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\"}.disabledReasonContainer{-webkit-transition:all 1s ease-in-out;transition:all 1s ease-in-out}.disabledMessage{width:50%;opacity:1;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";transition:opacity .8s linear;-webkit-transition:opacity .8s linear;-webkit-backface-visibility:hidden}.disabledReason{float:right;display:inline-block;position:absolute;bottom:50px;width:80%;word-wrap:break-word;padding-bottom:9px;font-size:.85em}.expiredMsg{color:red;display:inline-block;position:relative;top:5px;padding-left:6px}.expired{border:1px solid #de746a}.checkIcon{width:24px;height:17px;display:inline-block;position:absolute;top:24px;right:17px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-192px -2px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoMsg{max-height:0;padding:0 10px}.showMsg .infoMsg{-webkit-transition:all .5s ease;transition:all .5s ease;max-height:100px;margin:10px 0;width:80%}@media (min-width:0) and (max-width:30em){.allFundingInstrumentsList li .fsdetails,.allPlanList li .fsdetails{width:200px}}.subHeader .leftIcon{display:inline-block;float:left;width:10px;height:10px;margin:4px 6px 0 0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-180px -180px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.subHeader .leftIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.subHeader .leftIcon:focus,.subHeader .leftIcon:hover{background-position:-180px -200px}.subHeader .rightIcon{float:right;width:6px;height:10px;margin:4px 0 0 6px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-200px -180px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.subHeader .rightIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.subHeader .rightIcon:focus,.subHeader .rightIcon:hover{background-position:-200px -200px}.review{min-height:250px}.review .textLink{font-weight:700}.review .paypalPoliciesLink{color:#2c2e2f}.review .paypalPoliciesLink.disclaimer{font-size:.85em}.review .selectedCreditDesc{margin:2px 0 0;font-weight:400;font-size:.85em;line-height:1.35em}.review .span10{margin-left:4%}.review .editable{cursor:pointer}.review .unconfirmedUpopMsg{color:#6c7378;font-size:.85em;line-height:1.35em}.review .redeemGC{margin-top:10px;font-size:.85em}.review .userEmail{margin-top:15px;margin-bottom:20px;font-size:.85em}.review .span14.trayInner{padding:0 0 15px}.review .reviewButton{margin-bottom:2px}.review .reviewLaterContainer{margin:10px 0 0}.review .topupMsg{padding-bottom:30px;margin-top:20px}.review .reviews{padding:10px 0;border-top:1px solid #e3e3e3}.review .reviews:first-child{padding-top:0;border-top:0}.review .reviews .msg-info{background-color:transparent;border:none}.review .reviews .msg-info ul li{background-color:transparent;color:#6c7378}.review .reviews .msg-info .icon{background-position:-139px -1px}.review .reviews .focusable{margin:-10px;padding:10px}.review .reviews .focusable:focus{outline:2px solid #009cde}.review .authUserNotify{margin:10px 0 10px 35px;font-size:.65em}.review .authUserContent{line-height:1.254em;margin-bottom:15px;font-size:.85em}.review .authUserContent+.authUserContent{margin-bottom:0}.review #authMsg .buttons{margin-top:0}.review .bmlPopupOpen .bmlPopup{margin-left:0}.review .bmlCtaWrap{padding:15px;margin-bottom:25px;background-color:#f7f9fa;position:relative;border-radius:5px;background-clip:padding-box}.review .bmlCtaWrap p{width:80%;margin-bottom:5px}.review .bmlCtaWrap .bmlApplyLink{cursor:pointer;position:absolute;top:0;right:0;font-size:.85em}.review .bmlCtaWrap .bmlSeeTerms{width:80%;color:#6c7378;margin-bottom:0}.review .bmlCtaWrap .bmlSeeTerms .seeTermsLink{display:inline-block;margin-top:10px}.review .bmlCtaWrap .trayInner{position:relative;margin:0;padding:0;background-color:transparent}.review .bmlCtaWrap .headerText{margin-left:35px}.review .bmlCtaWrap .plccAddNowLink{cursor:pointer;position:absolute;top:0;right:0;font-size:.85em}.review .bmlCtaWrap .plccOfferDesc{font-size:.68em;color:#6c7378;margin-left:35px}.review .bmlCtaWrap .fsIcon{float:left;position:inherit}.review .frame{position:fixed;left:0;bottom:0;width:100%;background-color:#fff}.review .frameborder{width:100%;margin:0;border:0;height:3px;background:-webkit-linear-gradient(#fff,#dbdbdb);background:linear-gradient(#fff,#dbdbdb);background:-webkit-gradient(linear,top,bottom,#fff,#dbdbdb);background:-ms-linear-gradient(top,#fff,#dbdbdb)}.review .fixed{padding:10px 0;margin:0 20px}.review .disclaimer a{font-weight:700}.review #creditExampleUK{margin-top:10px;border-top:1px solid #e3e3e3}.review .representativeEx td,.review .representativeEx th{border:0}.review .representativeEx td{padding:.1em}#memberReview .reviews .trayInner{padding:10px 0}#memberReview .reviews .edits{font-size:.85em;padding:7px 10px 4px;position:absolute;top:4px;right:0;color:#0070ba;cursor:pointer}#memberReview .reviews .creditEdit{top:-7px}#memberReview #installmentPlanInfo{position:relative}#memberReview .adr{margin:2px 0 0;font-weight:400;width:85%;line-height:1.35em}#memberReview .billingAddressConsent p{margin-bottom:0}#memberReview .emailOptin{width:100%;border:1px solid #ccc;border-radius:5px;position:relative;padding:20px 15px;box-sizing:border-box;margin-top:35px;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;letter-spacing:.2px}#memberReview .emailOptin span.optinFloatingName{position:absolute;top:-11px;font-size:13px;color:#2c2e2f;background-color:#fff;padding:0 5px;left:10px}#memberReview .emailOptin label{line-height:1.5;font-size:11px;color:#6c7378}#memberReview #pay-with-credit .trayInner .decreasedWidth{width:80%}#memberReview #pay-with-credit .trayInner .decreasedWidth p{width:100%}@media (min-width:0) and (max-width:30em){#memberReview .edits,#shippingAddress .edits{right:0}}#bmlHardDeclineModal,#bmlSuccessModal{display:none}.bmlModal{overflow:hidden}.bmlModal h2{margin:0 0 1em}.bmlModal .modal-wrap,.bmlModalDialog .modal-wrap{z-index:150;border-radius:5px;background-clip:padding-box;display:block;height:auto;padding:30px;position:absolute;left:50%;top:45%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:360px}.bmlModal .modal-wrap #decline-modal-title,.bmlModalDialog .modal-wrap #decline-modal-title{line-height:1.154em;margin-bottom:20px}.bmlModal .modal-wrap .alpha,.bmlModalDialog .modal-wrap .alpha{margin-top:0}.bmlModal .modal-wrap #cancelContinue,.bmlModalDialog .modal-wrap #cancelContinue{display:block}.bmlModal .chkbx,.bmlModalDialog .chkbx,.bmlModalDialog h2,.bmlModalDialog p,.bmlModal h2,.bmlModal p{margin-bottom:20px}.bmlModal .chkbxLabel,.bmlModalDialog .chkbxLabel{-ms-box-sizing:border-box;box-sizing:border-box;display:inline-block;margin-top:1em}.bmlModal .chkbx,.bmlModalDialog .chkbx{vertical-align:top;width:6%}.bmlModal .chkbxLabel,.bmlModalDialog .chkbxLabel{width:92%}.bmlModal .checkbox .chkbxLabel,.bmlModalDialog .checkbox .chkbxLabel{height:auto;margin-bottom:1em;margin-top:0}.bmlModal .close,.bmlModalDialog .close{-webkit-tap-highlight-color:rgba(0,0,0,.2);-webkit-appearance:none;background:transparent url(\"https://www.paypalobjects.com/webstatic/checkout/hermes/flat/hermes_window_sprite_v5_2x.png\") no-repeat 100% 0;background-repeat:no-repeat;background-size:250px 215px;background-position:-218px 0;border:0;cursor:pointer;height:22px;padding:0;position:absolute;right:15px;top:17px;text-indent:-999em;width:25px}.bmlModal .cancelUrl,.bmlModalDialog .cancelUrl{width:100%}@media (max-width:41.25em) and (min-width:0){.bmlModal .modal-wrap,.bmlModalDialog .modal-wrap{padding:20px;width:80%;margin:0}}.modal-open #main,.modal-open.largeScreen #wrapper{position:static}.incontext .modal-open .outerWrapper,.minibrowser .modal-open .outerWrapper{position:relative}.incontext .modal-open .bmlModal,.minibrowser .modal-open .bmlModal{background-color:hsla(0,0%,100%,.85);border-radius:0 0 6px 6px;background-clip:padding-box;position:absolute}.incontext .modal-open .modal-backdrop,.minibrowser .modal-open .modal-backdrop{display:none}.button-spacing{margin-bottom:12px}.merchantMsg{margin-top:10px;word-wrap:break-word}.messengerBAHeader{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter}.messengerBAPlugin{border-top:1px solid #e3e3e3}.messengerBAPlugin .paymentsHeader{padding-top:10px}.messengerBANotnow{text-align:center;padding:10px}.messengerLegalTxt{font-size:11px;line-height:1.3em;color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;padding-left:12px;padding-bottom:10px}#addCard .firstname{float:left;width:48.15%;padding:0}#addCard .lastname{float:right;width:48.15%;padding:0}#addCard .replaced{position:relative;z-index:8;width:100%;height:44px;border:0;line-height:2}#addCard #billingAddress{clear:both;width:100%;margin-top:8px}#addCard .dropdown .billingAddress{margin:5px 0 10px}#addCard .addNewBillingAddress{float:right}section#addCard h1{margin-bottom:0}section#addCard .prop-img{height:92px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#addCard .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags_2x.png\");background-size:206px 92px}}.addNewBillingAddress{float:right}#billingAddressUpdatedMsg #notifications{padding:0;width:100%;box-sizing:border-box;margin:0 0 5px;line-height:1.3em}.userEmail{margin:15px 0 0;font-size:.85em}.addressLabel{display:none}@media (min-width:0) and (max-width:30em){section#addCard #notifications,section#updateCard #notifications{margin-top:10px}}#addPhone .phoneTypeContainer{width:34%;padding-right:10px;float:left;-ms-box-sizing:border-box;box-sizing:border-box}#addPhone .telephoneField{width:62%;padding:0;float:right}#addPhone .countryCodeSelect .phoneTypeContainer{width:50%;padding:0 10px 10px 0;float:left;-ms-box-sizing:border-box;box-sizing:border-box}#addPhone .countryCodeSelect .phoneCodeContainer{width:50%;float:right}#addPhone .countryCodeSelect .telephoneField{width:100%;padding:0;float:right}.addFi .form-tabs{color:#6c7378;margin:auto 0 10px;list-style:none;border-bottom:1px solid #dbdbdb}.addFi .form-tabs>li{width:49%;text-align:center;display:inline-block;margin-right:0}.addFi .form-tabs>li.bankTab{cursor:pointer}.addFi .form-tabs>li.cardTab{float:right;cursor:pointer}.addFi .form-tabs>li{padding:0;font-weight:700;cursor:pointer}.addFi .form-tabs>li:focus,.addFi .form-tabs>li:hover{border-color:#ccc #ccc #ddd}.addFi .form-tabs>li a{display:inline-block;width:100%;line-height:40px;color:#666;text-decoration:none}.addFi .form-tabs>li.active{cursor:default;color:#fff;margin-right:0;border-bottom:2px solid #009cde}.addFi .form-tabs>li.active a{color:#2c2e2f}.addFi .container{padding:10px 0}.addFi .fieldLegend{margin-bottom:4px;padding-bottom:0;font-size:inherit}.addFi .inputField input[readonly=readonly],.addFi input[readonly=readonly]{background:#f5f5f5;color:#a8a8a8}.addFi .billingAddress{clear:both;margin:10px 0 15px}.addFi #sepaMandate .btn-secondary{display:none}.addFi .addressLabel{display:block;margin:10px 0}.pageSepaMandate .span14{width:100%}.pageSepaMandate .span10{display:none}#soldOut{width:50%;min-width:320px}#soldOut,#soldOut #soldouticon{text-align:center;margin:0 auto;position:relative}#soldOut #soldouticon{display:inline-block;margin-top:47%}#soldOut .left_section{width:40px;height:44px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v14.png\");background-position:-160px -252px;background-repeat:no-repeat;background-color:#fff;float:left}#soldOut .text_lines{float:left;border-top:2px solid #c72e2e;border-bottom:2px solid #c72e2e;box-sizing:border-box;line-height:39px}#soldOut #text{font-family:HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:18px;color:#c72f2e;white-space:nowrap}#soldOut #rightSection{float:left}#soldOut .shape-right{display:inline-block;width:14px;height:45px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v14.png\");background-position:-187px -306px;background-repeat:no-repeat;background-color:#fff}#soldOut .soldOutMessage{width:343px;height:auto;font-family:HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:24px;color:#2c2e2f;line-height:normal;margin-top:20px;float:left;max-width:290px;margin-left:10%;overflow-wrap:break-word}#soldOut #Continue-Shopping{margin-top:60px;margin-bottom:150px;max-width:345px}#soldOut #Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}@media (min-width:0) and (max-width:21em){#soldOut #soldouticon{margin-right:10%}#soldOut .left_section{margin-left:inherit}#soldOut .soldOutMessage{margin-left:0;margin-bottom:30px;max-width:280px}#soldOut #Continue-Shopping{margin:40px 10% 40px 0;max-width:280px}#Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}.footer{margin-top:25%}.props,header{display:BLOCK;transform:translateY(25%)}}@media (min-width:21em) and (max-width:23.438em){#soldOut .left_section{margin-left:inherit}#soldOut #Continue-Shopping{margin:40px 10%;max-width:280px}#Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}#soldOut .soldOutMessage{margin:20px 10% 30px;max-width:280px}.footer{margin-top:25%}.props,header{display:BLOCK;transform:translateY(25%)}}@media (min-width:23.438em) and (max-width:27.188em){#soldOut .left_section{margin-left:inherit}#soldOut #Continue-Shopping{margin:40px 5%;max-width:280px}#Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}#soldOut .soldOutMessage{margin:20px 5% 30px;max-width:280px}.footer{margin-top:25%}.props,header{display:BLOCK;transform:translateY(25%)}}#shippingAddress{position:relative}#shippingAddress:focus{outline:0}#shippingAddress .editable{cursor:pointer}#shippingAddress .addressDisplay{margin-top:10px;word-wrap:break-word;line-height:1.2em}#shippingAddress .addressDisplay .check{padding-left:20px;background:url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet.png) no-repeat 0 2px}#shippingAddress .changeShipping{cursor:pointer}#shippingAddress .frontArrow{top:8px;right:0}#shippingAddress .frontArrow.disabled,#shippingAddress .frontArrow.disabled:focus,#shippingAddress .frontArrow.disabled:hover{background-position:-161px -177px}#shippingAddress .edits{padding:7px 10px 4px;position:absolute;top:4px;right:0;color:#0070ba}#shippingAddress .edits.disabled,#shippingAddress .edits.disabled:focus,#shippingAddress .edits.disabled:hover{color:#6c7378;text-decoration:none}#shippingAddress .edits:focus,#shippingAddress .edits:hover{text-decoration:underline;color:#005ea6}#shippingAddress .merchantReq{margin-top:3px;color:#6c7378;font-size:.85em;width:90%;line-height:1.3em;display:block}.reviewPreferredShipping{margin:5px 0 15px}[dir=rtl] .paywith .charges li.fsicon-margin{margin-left:0;margin-right:42px}[dir=rtl] .paywith .charges li.nbr-line span.nbr-amt{display:inline-block}.paywith #paymentMethod{position:relative}.paywith #paymentMethod:focus{outline:0}.paywith .charges{display:table;width:100%;margin:10px 0 0}.paywith .charges a#msbToolTipClose,.paywith .charges a.msbDetails{cursor:pointer}.paywith .charges li{list-style:none;margin-bottom:7px}.paywith .charges li.backupFunding{margin-bottom:5px;margin-top:-14px;font-size:.85em;line-height:1em;color:#6c7378;padding-left:43px}.paywith .charges li.fsicon-margin{margin-left:42px}.paywith .charges li.fsicon-margin>.disclaimer{display:block;padding-top:5px}.paywith .charges li.nbr-line{font-size:.85em;line-height:1em}.paywith .charges li.nbr-line .currencyCode{font-size:.85em}.paywith .charges li.reviewEnterCvvContainer{margin-bottom:0;cursor:auto;padding-bottom:20px;padding-top:15px}.paywith .charges li.reviewEnterCvvContainer .reviewEnterCvv{float:right;width:calc(100% - 42px);border-top:1px solid #e3e3e3;border-bottom:1px solid #e3e3e3;padding-top:10px;padding-bottom:10px;text-align:right}.paywith .charges li.reviewEnterCvvContainer .reviewEnterCvv .enterCvvPrompt{font-size:.85em;display:inline-block;width:calc(100% - 132px);vertical-align:middle}.paywith .charges li.reviewEnterCvvContainer .reviewEnterCvv .xo-cvv-wrapper{display:inline-block;width:125px;margin-left:2px;vertical-align:middle}.paywith .charges li.reviewEnterCvvContainer .reviewEnterCvv .xo-cvv-wrapper .cvvField .cvvSecurityCode input,.paywith .charges li:last-child{margin-bottom:0}.paywith .methodAmount{float:right}.paywith .methodAmount .currencyCode{font-size:.75em;display:block;text-align:right;line-height:1.4em;color:#6c7378;margin-top:0}.paywith .AMEX .name{margin-left:-10px}.paywith .method{text-overflow:ellipsis;width:75%;float:left;line-height:1.25em}.paywith .method .name{display:inline-block;vertical-align:top;width:73%;margin-bottom:10px}.paywith .method .name .txt,.paywith .method .name a{vertical-align:inherit}.paywith .method .name .txt{font-size:.85em;white-space:nowrap}.paywith .method .fsname,.paywith .method .fsNamePinlessDebit{vertical-align:top;overflow:hidden;text-overflow:ellipsis;max-width:54%;display:inline-block;white-space:nowrap}.paywith .method .fslastdigits,.paywith .method .fsLastDigitsPinlessDebit{vertical-align:top;white-space:nowrap}.paywith .method.DELAYED_TRANSFER .fsname{max-width:39%}.paywith .method.DELAYED_TRANSFER .fsname.DE{max-width:34%}.paywith .method.check{padding-left:20px;background:url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet.png) no-repeat 0 2px}.paywith .method.pad{display:inline-block;max-width:72%}.paywith .method #padHelp{font-weight:700}.paywith .installments .method{width:56%}.paywith .frontArrow{top:8px;right:0}.paywith #paymentMethod .edits{padding:7px 10px 4px;position:absolute;top:3px;right:0;color:#0070ba}.paywith #paymentMethod .edits:focus,.paywith #paymentMethod .edits:hover{text-decoration:underline;color:#005ea6}.paywith .INCENTIVE+.methodAmount .amountFormatted{color:#56aa47}.paywith .conversion{display:table;width:100%;text-align:right;color:#757575;font-size:.88em}.paywith .cibTextBox{position:relative;z-index:1}.paywith .cibBillingTxt{margin-top:13px;font-size:.75em;line-height:1.25em;text-align:justify;border:1px solid #e3e3e3;padding:10px 0 10px 10px}.paywith .billingScrollBox{overflow-y:auto;padding-right:10px;max-height:100px}.paywith .billingTxt{margin-top:13px;font-size:.85em;text-align:left;line-height:1.2em}.paywith .getInstallments{background-color:#fff;border:1px solid #c5ccd1;float:right}.paywith .getInstallments,.paywith .getInstallmentsError{margin-bottom:10px;font-weight:400;text-align:start;padding:0 10px}.paywith .getInstallmentsError{border:1px solid #c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.paywith a.getInstallments.btn-secondary:focus,.paywith a.getInstallments.btn-secondary:hover,.paywith a.getInstallmentsError.btn-secondary:focus,.paywith a.getInstallmentsError.btn-secondary:hover{background-color:transparent;text-decoration:none}.paywith a.getInstallments.btn-secondary:focus span:nth-child(1),.paywith a.getInstallments.btn-secondary:hover span:nth-child(1),.paywith a.getInstallmentsError.btn-secondary:focus span:nth-child(1),.paywith a.getInstallmentsError.btn-secondary:hover span:nth-child(1){text-decoration:underline}.paywith a.popup{font-weight:700}.paywith .raq{display:inline-block;margin:5px 0 0 5px;width:12px;height:10px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-23px 2px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paywith .raq{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paywith .authUserNotify{margin:10px 0 0 5px;padding-left:30px}.paywith .padHelpToolTip .bul a,.paywith .padHelpToolTip .padHeader,.paywith .tipDesc a{font-weight:700}.paywith .padHelpToolTip .toolTip.balloon{line-height:1.35em}.paywith .padHelpToolTip p{margin-bottom:0}.paywith .padHelpToolTip ul{margin:8px 0}.paywith .padHelpToolTip ul li{margin:0}.paywith .bmlDetails{color:#6c7378;font-size:.85em;padding:5px 0 0 35px;width:100%;line-height:1.1em}.paywith .directDebitAgreement{margin-top:25px;margin-bottom:0}.row-fluid>.bmlPopup{box-sizing:border-box;margin-left:0;padding:40px 0}@media (min-width:0) and (max-width:30em){.paywith .cibBillingTxt{margin-top:13px;font-size:.75em;line-height:1.35em;text-align:justify;border:0;padding:0}.paywith .billingScrollBox{padding-right:0;max-height:none}}.adr{margin-top:3px;color:#6c7378;font-size:.85em;width:90%}.adr .adr-break{display:block}.adr .country,.adr .singleline{display:none}.adr .preferred{margin:15px 0 7px}.adr .preferred span{padding:5px 10px;background-color:#eaf7e9;color:#2a5327;font-size:1em}.addressDisplay .adr .streets{display:inline;white-space:normal}.addressDisplay .adr .adr-break,.addressDisplay .adr .postal-code,.addressDisplay .adr .singleline,.addressDisplay .adr .streets,.addressDisplay .adr .streets+div{display:inline}.FR .cvv input{padding-left:6px}#addCard .msg-error{position:relative;margin-top:20px}#addCard #addressAddedToolTip{margin:-10px 0 7px;border:1px solid #7cda7a;background-image:linear-gradient(180deg,#f9fcfa,#f1f8f2);min-height:17px;border-radius:3px}#addCard .addNewBillingAddress{font-size:.85em;margin-top:2px}#addCard xo-phone-input .inputField{padding:0;float:none}#addCard .otpVerification{margin-bottom:10px;color:#7b8388;font-size:.87em;line-height:1.3em}#addCard .btn{margin-top:10px}#addCard.aside #notifications{padding:0 15px;width:100%;box-sizing:border-box;margin:0 0 5px}#addCard.aside #billingAddressUpdatedMsg #notifications{padding:0}#addCard.aside .msg-error{padding:0;margin-bottom:20px;margin-top:10px}#addCard.aside .btn{margin-top:10px;margin-bottom:15px}#addCard.aside #billingAddressForm .btn{margin-top:0}.creditCardInput .plccCardNumberTitle{margin-bottom:5px}.creditCardInput .cardIconsGroup{padding:10px 13px;height:20px}.creditCardInput .cardIconsGroup,.creditCardInput .debitAndCreditIconsGroup{background-color:#f2f3f4;border:1px solid #e3e3e3;border-radius:4px;margin-bottom:10px}.creditCardInput .debitAndCreditIconsGroup{padding:10px 4px;overflow:auto}.creditCardInput .cardIconTitle{border-bottom:1px solid #dcd9d9;font-size:13px;padding-bottom:10px;margin-bottom:10px}.creditCardInput .creditIconLabel{color:#7b8388;font-size:11px;margin:-5px 0 5px}.creditCardInput .debitIconLabel{color:#7b8388;font-size:11px;margin:5px 0 2px}.creditCardInput .cardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_1x.png\") no-repeat 0 100px;height:22px;float:left;width:32px;padding:0 4px 0 0}.creditCardInput .cardIcon.ELO{background-position:0 -713px}.creditCardInput .cardIcon.CUP{background-position:0 -837px}.creditCardInput .cardIcon.VISA{background-position:0 -31px}.creditCardInput .cardIcon.MASTERCARD{background-position:0 -62px}.creditCardInput .cardIcon.HIPER{background-position:0 -682px}.creditCardInput .cardIcon.HIPERCARD{background-position:0 -744px}.creditCardInput .cardIcon.AMEX{background-position:0 -93px;margin-right:-10px}.creditCardInput .cardIcon.JCB{background-position:0 -527px}.creditCardInput .cardIcon.ELECTRON{background-position:0 -217px}.creditCardInput .cardIcon.MAESTRO,.creditCardInput .cardIcon.SWITCH{background-position:0 -248px}.creditCardInput .cardIcon.DISCOVER{background-position:0 -124px}.creditCardInput .cardIcon.CBNATIONALE{background-position:0 -310px}.creditCardInput .cardIcon.CETELEM{background-position:0 -465px}.creditCardInput .cardIcon.COFIDIS{background-position:0 -651px;margin-right:-10px}.creditCardInput .cardIcon.COFINOGA{background-position:0 -341px}.creditCardInput .cardIcon.QIWI{background-position:0 -806px;width:30px}.creditCardInput .debitcardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_bank_mx.png\") no-repeat 0 100px;height:21px;float:left;width:68px;padding:0 2px 0 0;margin-top:3px}.creditCardInput .debitcardIcon.BANAMEX{background-position:0 0;clear:both}.creditCardInput .debitcardIcon.BANCOARFACA{background-position:0 -22px}.creditCardInput .debitcardIcon.BBVA{background-position:0 -44px}.creditCardInput .debitcardIcon.BANORTE{background-position:0 -66px}.creditCardInput .debitcardIcon.HSBC{background-position:0 -88px}.creditCardInput .debitcardIcon.INBURSA{background-position:0 -110px}.creditCardInput .debitcardIcon.SANTANDER{background-position:0 -132px}.creditCardInput .cardType{clear:both;display:block;margin-bottom:10px}.creditCardInput #cardIssueInfo{display:block}.creditCardInput #expiration{min-height:80px}.creditCardInput .expires{position:relative;display:block;top:auto;left:auto;color:#2c2e2f;margin-bottom:5px}.creditCardInput .expirationField{width:48%;float:left;min-height:70px}.creditCardInput #expiration label,.creditCardInput label.cvv{margin-bottom:5px}.creditCardInput .expmonth{float:left;width:50%}.creditCardInput .expmonth .custom-select>span{border-radius:5px 0 0 5px;padding-right:30px}.creditCardInput .expmonth.BR .custom-select>span{padding-right:28px!important}.creditCardInput .expyear{float:left;width:50%}.creditCardInput .expyear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.creditCardInput .expyear .custom-select.active>span{border-left:1px solid #009cde}.creditCardInput .replaced{position:relative;z-index:8;width:100%;line-height:2}.creditCardInput .cvv{position:relative;top:auto;left:auto}.creditCardInput .cvvField{width:48%;float:right}.creditCardInput .cardNumber{clear:both}.guestWithSignup .creditCardInput .debitAndCreditIconsGroup{padding:0 0 15px}.guestWithSignup .creditCardInput .cardIconTitle{padding:15px 15px 10px}.guestWithSignup .creditCardInput .cardIconsSection{padding:5px 15px 15px}.validated .ng-invalid~#creditCard,.validated input.ng-invalid:active~#creditCard,.validated input.ng-invalid:focus~#creditCard,input.backendError~#creditCard{display:none}.inputField.error #cvv,.validated .inputField input.ng-invalid#cvv{background:none}#securityCode.creditCard,.ccard,.creditCardField .creditCard{position:absolute;right:4px;/*!@replace: 100%;white-space: nowrap;overflow: hidden;left: 8px;*/text-indent:-500em;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_1x.png\") no-repeat 0 100px;height:22px;width:40px;top:12px}#securityCode.creditCard.VISA,.ccard.VISA,.creditCardField .creditCard.VISA{background-position:0 -31px}#securityCode.creditCard.MASTERCARD,.ccard.MASTERCARD,.creditCardField .creditCard.MASTERCARD{background-position:0 -62px}#securityCode.creditCard.AMEX,.ccard.AMEX,.creditCardField .creditCard.AMEX{background-position:0 -93px;margin-right:-10px}#securityCode.creditCard.DINERSCLUB,#securityCode.creditCard.DISCOVER,.ccard.DINERSCLUB,.ccard.DISCOVER,.creditCardField .creditCard.DINERSCLUB,.creditCardField .creditCard.DISCOVER{background-position:0 -124px}#securityCode.creditCard.JCB,.ccard.JCB,.creditCardField .creditCard.JCB{background-position:0 -527px}#securityCode.creditCard.ccback,#securityCode.creditCard.three,.ccard.ccback,.ccard.three,.creditCardField .creditCard.ccback,.creditCardField .creditCard.three{background-position:0 -589px}#securityCode.creditCard.four,#securityCode.creditCard.front,.ccard.four,.ccard.front,.creditCardField .creditCard.four,.creditCardField .creditCard.front{background-position:0 -620px}#securityCode.creditCard.ELECTRON,.ccard.ELECTRON,.creditCardField .creditCard.ELECTRON{background-position:0 -217px}#securityCode.creditCard.MAESTRO,#securityCode.creditCard.SWITCH,.ccard.MAESTRO,.ccard.SWITCH,.creditCardField .creditCard.MAESTRO,.creditCardField .creditCard.SWITCH{background-position:0 -248px}#securityCode.creditCard.ELO,.ccard.ELO,.creditCardField .creditCard.ELO{background-position:0 -713px}#securityCode.creditCard.CUP,.ccard.CUP,.creditCardField .creditCard.CUP{background-position:0 -837px}#securityCode.creditCard.HIPER,.ccard.HIPER,.creditCardField .creditCard.HIPER{background-position:0 -682px}#securityCode.creditCard.HIPERCARD,.ccard.HIPERCARD,.creditCardField .creditCard.HIPERCARD{background-position:0 -744px}#securityCode.creditCard.CBNATIONALE,.ccard.CBNATIONALE,.creditCardField .creditCard.CBNATIONALE{background-position:0 -310px}#securityCode.creditCard.CETELEM,.ccard.CETELEM,.creditCardField .creditCard.CETELEM{background-position:0 -465px}#securityCode.creditCard.COFIDIS,.ccard.COFIDIS,.creditCardField .creditCard.COFIDIS{background-position:0 -651px;margin-right:-10px}#securityCode.creditCard.COFINOGA,.ccard.COFINOGA,.creditCardField .creditCard.COFINOGA{background-position:0 -341px}#securityCode.creditCard.VISA.QIWI,.ccard.VISA.QIWI,.creditCardField .creditCard.VISA.QIWI{background-position:0 -806px;width:30px}#securityCode.creditCard{/*!@replace: inherit; left: 8px;*/right:4px;height:21px;width:40px;top:12px;background-position:0 -589px;-webkit-transition:background-position .3s ease;transition:background-position .3s ease}#securityCode.creditCard.four{background-position:0 -620px}.de_DE #securityCode.creditCard{background-position:5px -606px}.de_DE #securityCode.creditCard.four{background-position:5px -693px}@media only screen and (max-device-width:480px){#editCard .disc,#editCard .discover{background-position:0 -585px}#securityCode.creditCard{background-position:0 -608px}#securityCode.creditCard.four{background-position:0 -695px}#editCard .mastercard,#editCard .mcard{background-position:0 -196px}#editCard visa{background-position:0 -96px}#editCard amex{background-position:0 -295px}#editCard maestro{background-position:0 -978px}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.creditCardInput .cardIconsGroup{padding:10px 15px;height:20px}.creditCardInput .cardIconsGroup,.creditCardInput .debitAndCreditIconsGroup{background-color:#f2f3f4;border:1px solid #e3e3e3;border-radius:4px;margin-bottom:10px}.creditCardInput .debitAndCreditIconsGroup{padding:10px 4px;overflow:auto}.creditCardInput .cardIconTitle{border-bottom:1px solid #dcd9d9;font-size:13px;padding-bottom:10px;margin-bottom:10px}.creditCardInput .creditIconLabel{color:#7b8388;font-size:11px;margin:-5px 0 5px}.creditCardInput .debitIconLabel{color:#7b8388;font-size:11px;margin:5px 0 2px}.creditCardInput .cardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_2x.png\") no-repeat 0 100px;background-size:31px;height:22px;float:left;width:32px;padding:0 4px 0 0}.creditCardInput .cardIcon.ELO{background-position:0 -713px}.creditCardInput .cardIcon.CUP{background-position:0 -837px}.creditCardInput .cardIcon.VISA{background-position:0 -31px}.creditCardInput .cardIcon.MASTERCARD{background-position:0 -62px}.creditCardInput .cardIcon.HIPER{background-position:0 -682px}.creditCardInput .cardIcon.HIPERCARD{background-position:0 -744px}.creditCardInput .cardIcon.AMEX{background-position:0 -93px;margin-right:-10px}.creditCardInput .cardIcon.JCB{background-position:0 -527px}.creditCardInput .cardIcon.ELECTRON{background-position:0 -217px}.creditCardInput .cardIcon.MAESTRO,.creditCardInput .cardIcon.SWITCH{background-position:0 -248px}.creditCardInput .cardIcon.DISCOVER{background-position:0 -124px}.creditCardInput .cardIcon.CBNATIONALE{background-position:0 -310px}.creditCardInput .cardIcon.CETELEM{background-position:0 -465px}.creditCardInput .cardIcon.COFIDIS{background-position:0 -651px;margin-right:-10px}.creditCardInput .cardIcon.COFINOGA{background-position:0 -341px}.creditCardInput .cardIconVISA.QIWI{background-position:0 -806px;width:30px}.creditCardInput .debitcardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_bank_mx_2x.png\") no-repeat 0 100px;background-size:66px;height:21px;float:left;width:68px;padding:0 2px 0 0;margin-top:3px}.creditCardInput .debitcardIcon.BANAMEX{background-position:0 0;clear:both}.creditCardInput .debitcardIcon.BANCOARFACA{background-position:0 -22px}.creditCardInput .debitcardIcon.BBVA{background-position:0 -44px}.creditCardInput .debitcardIcon.BANORTE{background-position:0 -66px}.creditCardInput .debitcardIcon.HSBC{background-position:0 -88px}.creditCardInput .debitcardIcon.INBURSA{background-position:0 -110px}.creditCardInput .debitcardIcon.SANTANDER{background-position:0 -132px}.creditCardInput .cardType{clear:both;display:block;margin-bottom:10px}.guestWithSignup .creditCardInput .debitAndCreditIconsGroup{padding:0 0 15px}.guestWithSignup .creditCardInput .cardIconTitle{padding:15px 15px 10px}.guestWithSignup .creditCardInput .cardIconsSection{padding:5px 15px 15px}#securityCode.creditCard,.ccard,.creditCardField .creditCard{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_2x.png\") no-repeat 0 100px;background-size:31px;height:22px;width:32px;top:11px;right:9px}#securityCode.creditCard.VISA,#securityCode.creditCard.visa,.ccard.VISA,.ccard.visa,.creditCardField .creditCard.VISA,.creditCardField .creditCard.visa{background-position:0 -31px}#securityCode.creditCard.MASTERCARD,#securityCode.creditCard.MCARD,#securityCode.creditCard.mcard,.ccard.MASTERCARD,.ccard.MCARD,.ccard.mcard,.creditCardField .creditCard.MASTERCARD,.creditCardField .creditCard.MCARD,.creditCardField .creditCard.mcard{background-position:0 -62px}#securityCode.creditCard.AMEX,#securityCode.creditCard.amex,.ccard.AMEX,.ccard.amex,.creditCardField .creditCard.AMEX,.creditCardField .creditCard.amex{background-position:0 -93px;margin-right:-10px}#securityCode.creditCard.dinersclub,#securityCode.creditCard.DINERSCLUB,#securityCode.creditCard.disc,#securityCode.creditCard.DISC,#securityCode.creditCard.DISCOVER,.ccard.DINERSCLUB,.ccard.dinersclub,.ccard.DISC,.ccard.disc,.ccard.DISCOVER,.creditCardField .creditCard.DINERSCLUB,.creditCardField .creditCard.dinersclub,.creditCardField .creditCard.disc,.creditCardField .creditCard.DISC,.creditCardField .creditCard.DISCOVER{background-position:0 -124px}#securityCode.creditCard.JCB #securityCode.creditCard.jcb,#securityCode.creditCard.JCB .ccard.jcb,#securityCode.creditCard.JCB .creditCardField .creditCard.jcb,.ccard.JCB #securityCode.creditCard.jcb,.ccard.JCB .ccard.jcb,.ccard.JCB .creditCardField .creditCard.jcb,.creditCardField .creditCard.JCB #securityCode.creditCard.jcb,.creditCardField .creditCard.JCB .ccard.jcb,.creditCardField .creditCard.JCB .creditCardField .creditCard.jcb{background-position:0 -527px}#securityCode.creditCard.ccback,#securityCode.creditCard.three,.ccard.ccback,.ccard.three,.creditCardField .creditCard.ccback,.creditCardField .creditCard.three{background-position:0 -589px}#securityCode.creditCard.four,#securityCode.creditCard.front,.ccard.four,.ccard.front,.creditCardField .creditCard.four,.creditCardField .creditCard.front{background-position:0 -620px}#securityCode.creditCard.split,.ccard.split,.creditCardField .creditCard.split{width:60%;float:left}#securityCode.creditCard.ELECTRON,#securityCode.creditCard.electron,.ccard.ELECTRON,.ccard.electron,.creditCardField .creditCard.ELECTRON,.creditCardField .creditCard.electron{background-position:0 -217px}#securityCode.creditCard.MAESTRO,#securityCode.creditCard.maestro,#securityCode.creditCard.mstro,#securityCode.creditCard.MSTRO,#securityCode.creditCard.SWITCH,.ccard.maestro,.ccard.MAESTRO,.ccard.MSTRO,.ccard.mstro,.ccard.SWITCH,.creditCardField .creditCard.MAESTRO,.creditCardField .creditCard.maestro,.creditCardField .creditCard.mstro,.creditCardField .creditCard.MSTRO,.creditCardField .creditCard.SWITCH{background-position:0 -248px}#securityCode.creditCard.ELO,.ccard.ELO,.creditCardField .creditCard.ELO{background-position:0 -713px}#securityCode.creditCard.CUP,.ccard.CUP,.creditCardField .creditCard.CUP{background-position:0 -837px}#securityCode.creditCard.HIPER,.ccard.HIPER,.creditCardField .creditCard.HIPER{background-position:0 -682px}#securityCode.creditCard.HIPERCARD,.ccard.HIPERCARD,.creditCardField .creditCard.HIPERCARD{background-position:0 -744px}#securityCode.creditCard.cbn,#securityCode.creditCard.CBN,#securityCode.creditCard.CBNATIONALE,.ccard.cbn,.ccard.CBN,.ccard.CBNATIONALE,.creditCardField .creditCard.cbn,.creditCardField .creditCard.CBN,.creditCardField .creditCard.CBNATIONALE{background-position:0 -310px}#securityCode.creditCard.celem,#securityCode.creditCard.CELEM,#securityCode.creditCard.CETELEM,.ccard.celem,.ccard.CELEM,.ccard.CETELEM,.creditCardField .creditCard.celem,.creditCardField .creditCard.CELEM,.creditCardField .creditCard.CETELEM{background-position:0 -465px}#securityCode.creditCard.COFID,#securityCode.creditCard.cofid,#securityCode.creditCard.COFIDIS,.ccard.cofid,.ccard.COFID,.ccard.COFIDIS,.creditCardField .creditCard.cofid,.creditCardField .creditCard.COFID,.creditCardField .creditCard.COFIDIS{background-position:0 -651px;margin-right:-10px}#securityCode.creditCard.COFINOGA,#securityCode.creditCard.conf,#securityCode.creditCard.CONF,.ccard.COFINOGA,.ccard.conf,.ccard.CONF,.creditCardField .creditCard.COFINOGA,.creditCardField .creditCard.conf,.creditCardField .creditCard.CONF{background-position:0 -341px}#securityCode.creditCard.VISA.QIWI,.ccard.VISA.QIWI,.creditCardField .creditCard.VISA.QIWI{background-position:0 -806px;width:30px}#securityCode.creditCard{height:21px;width:32px;background-size:31px;background-position:0 -589px}#securityCode.creditCard.four{background-position:0 -620px}}.ccard{width:100%;position:relative;margin-bottom:17px;padding-top:3px;padding-left:50px;height:25px;text-indent:0}.clearfix.hide{display:none}.issueNo .toolTip{right:0;text-align:right;width:auto}#addCard .tipDesc.tipStartDate{left:0;top:50px}#addCard .tipDesc.tipStartDate .tipDescArrowBack,#addCard .tipDesc.tipStartDate .tipDescArrowFront{left:70px}#addCard .tipDesc.tipIssueNo{left:-140px;top:50px;width:230px}#addCard .tipDesc.tipIssueNo .tipDescArrowBack,#addCard .tipDesc.tipIssueNo .tipDescArrowFront{left:160px}#addCard .tipDesc.tipOptionalCsc{left:-100px;top:50px;width:215px}#addCard .tipDesc.tipOptionalCsc .tipDescArrowBack,#addCard .tipDesc.tipOptionalCsc .tipDescArrowFront{left:160px}#ccFields input[type=text]::-ms-clear{display:none}#ccFields .tipDesc.tipCreditCard{top:42px;left:0;width:100%}#ccFields .tipDesc.tipCreditCard .tipDescText{background-color:#828a8d;font-size:13px}.cardType.show{display:block;margin-bottom:10px}#issueNo{padding-left:5px}.mxCardIconGroup{margin-bottom:5px}@media (max-width:40em) and (orientation:landscape),only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:0) and (max-width:25em){#securityCode.creditCard{background-position:0 -589px}#securityCode.creditCard.four{background-position:0 -620px}}@media (min-width:0) and (max-width:30em){.header{margin-bottom:15px}}#selectCardType .allFundingInstrumentsList li .fsdetails{width:226px;padding:18px 0 18px 25px;margin-top:.5px}#selectCardType .allFundingInstrumentsList li:first-of-type .fsIcon{width:40px;height:30px;background-size:33px;top:15px;background-position:0 -349px;border-radius:2px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v4.png\")}#selectCardType .allFundingInstrumentsList li:first-of-type .fsdetails{top:7px}#selectCardType .forwardIcon{transform:scaleX(-1);width:24px;height:18px;display:inline-block;position:absolute;top:24px;right:17px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectCardType .forwardIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectCardType .plccIcon{display:block;position:absolute;width:30px;height:20px;left:15px;top:20px}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#selectCardType .allFundingInstrumentsList li .fsdetails{width:190px}}.sidebar .addBillingTitle{position:absolute;top:-6px;background:#fff;left:45px;font-size:1.44em;width:230px}@media (min-width:0) and (max-width:30em){.sidebar .addBillingTitle{width:215px;top:-4px;left:40px}}.addressForm.TR{margin-top:3.5%}.addressForm.BR .streetNumber{width:31.15%;padding-right:0;float:left}.addressForm.BR .line1{width:66.15%;margin-right:2.7%;padding-right:0;float:left}.addressForm.BR .city{width:48.15%;margin-right:3.7%;padding-right:0;float:left}.addressForm.BR .state{width:48.15%;margin-right:0;padding-right:0;float:right}.addressForm.MX .state,.addressForm.RU .state,.addressForm.US .state{width:48.15%;margin-right:3.7%;padding-right:0;float:left}.addressForm.MX .postalCode,.addressForm.RU .postalCode,.addressForm.US .postalCode{padding-right:0;margin-right:0;width:48.15%;float:left}.addressForm.ES .state{margin-bottom:10px;clear:both}.addressForm.ES .postalCode{display:block;width:49%;float:left}.addressForm.ES .city{width:48%;float:right}.addressForm.GB .state{float:left;width:62%;margin:0 0 10px}.addressForm.GB .postalCode{float:right;width:35.3%}.addressForm.GB .lookupZip{width:100%;margin:0 10px 10px 0;float:none}.addressForm.GB .lookupHeading{margin:15px 0 10px}.addressForm.GB .lookupTitle{font-weight:700}.addressForm.GB .addressLookup{position:relative}.addressForm.GB .lookupFailureMsg{margin:5px 0 8px}.addressForm.GB .singleAddress{border:1px solid #c5ccd1;margin:10px 0;padding:13px;border-radius:4px;line-height:1.35em}.addressForm.BG .city,.addressForm.BG .postalCode,.addressForm.CZ .city,.addressForm.CZ .postalCode,.addressForm.DK .city,.addressForm.DK .postalCode,.addressForm.FI .city,.addressForm.FI .postalCode,.addressForm.FR .city,.addressForm.FR .postalCode,.addressForm.GR .city,.addressForm.GR .postalCode,.addressForm.HU .city,.addressForm.HU .postalCode,.addressForm.LU .city,.addressForm.LU .postalCode,.addressForm.NO .city,.addressForm.NO .postalCode,.addressForm.RO .city,.addressForm.RO .postalCode,.addressForm.TR .city,.addressForm.TR .postalCode,.addressForm.UA .city,.addressForm.UA .postalCode{width:100%}.addressForm.PT #shippingPostalCode{width:103%}.addressForm.EE .state.half,.addressForm.HR .state.half,.addressForm.LT .state.half,.addressForm.LV .state.half,.addressForm.SI .state.half{width:55%}.addressForm.EE .postalCode.half,.addressForm.HR .postalCode.half,.addressForm.LT .postalCode.half,.addressForm.LV .postalCode.half,.addressForm.SI .postalCode.half{width:41%}.addressForm.KR .fieldGroup .inputField,.addressForm.TH .fieldGroup .inputField{padding:0}.addressForm.KR .postalCode,.addressForm.KR .state{width:100%}.addressForm .editAddress{position:absolute;font-size:.85em;top:2px;right:0;color:#0070ba;cursor:pointer}.addressForm .btn{margin-bottom:15px}.addressForm #findAddressButton.processing{vertical-align:middle;font-size:32px}.addressForm #findAddressButton.processing .loader,.addressForm #findAddressButton.processing .spinner{height:25px;width:25px;position:static;display:inline-block}.addressForm #findAddressButton.processing .loader{margin:0;padding:0;background-color:transparent;border-left:2px solid rgba(0,0,0,.2);border-right:2px solid rgba(0,0,0,.2);border-width:1.5px;border-style:solid;border-color:#2180c0 #fff #fff}.addressForm #lookedupDropDown{margin-bottom:20px}.addressForm .addPreferredShipping{margin:0 0 15px}@media screen{.addressForm .buttons{margin-top:0}.TR .city{margin:0 0 10px}}#upopConfirmation .modalMask,#upopConfirmation .modalWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}#upopConfirmation .close{position:absolute;top:20px;right:20px;width:19px;height:19px;padding:5px;border-radius:3px}#upopConfirmation .close:before{content:\"\";position:absolute;width:19px;height:19px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#upopConfirmation .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#upopConfirmation .close:focus:before,#upopConfirmation .close:hover:before{background-position:-223px -22px}#upopConfirmation .modalMask{background:#cbd2d6;opacity:.7}#upopConfirmation .modalWrapperAnimation{-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}#upopConfirmation .modalWrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:80px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}#upopConfirmation .modalWrapper .logo{position:relative;margin-top:-60px;width:25px;height:30px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#upopConfirmation .modalWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#upopConfirmation .modalContainer{min-height:99%;width:380px;display:block}#upopConfirmation .modalContainer .pushlogo{height:90px}#upopConfirmation .processing input{background-color:#f2f3f4}#upopConfirmation .upopOpen .modalWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}#upopConfirmation .upopConfirm .header{border-bottom:none}#upopConfirmation .upopConfirm .timingFields{padding-bottom:35px}#upopConfirmation .upopConfirm .counter{float:left}#upopConfirmation .upopConfirm a.resendCode{float:right}#upopConfirmation .upopConfirm #notifications{padding:0 0 5px}#upopConfirmation .expiration{display:inline-flex}#upopConfirmation .expiration .expires{position:relative;top:auto;left:auto}#upopConfirmation .expiration .expirationField{margin-right:10px}#upopConfirmation .expiration input.ng-invalid{padding-right:13px}#upopConfirmation .expiration label{margin-bottom:5px;color:#000}#upopConfirmation .telephoneField{clear:both;padding:0;float:none}#upopConfirmation .heading{margin:5px 0 10px;font-size:1.6em;font-family:HelveticaNeue-Light,Helvetica Neue Light,Helvetica,Arial,sans-serif}#upopConfirmation .timer{margin-bottom:20px}#upopConfirmation .timeLeft{margin-left:5px;font-weight:700}#upopConfirmation .confirmMsg{color:#6c7378;margin-bottom:20px}#upopConfirmation .resendLink{font-size:.85em}#upopConfirmation .btn{margin-top:10px}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#upopConfirmation .modalWrapper{width:100%;padding:60px 15px 0}#upopConfirmation .modalWrapper .modalContainer{width:auto}}#addCard.aside #upopConfirmation #notifications{padding:0 0 5px;margin-bottom:0}#selectShipping .xo-adr{width:85%}#selectShipping .items{margin:0;width:100%;list-style:none}#selectShipping .address{margin:0;padding:0;position:relative;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out;cursor:pointer}#selectShipping .address a{border:2px solid transparent}#selectShipping .address a:hover{background-color:#f7f9fa}#selectShipping .address a:focus{border:2px solid #009cde}#selectShipping .address .fullName{word-break:break-all;line-height:1.35em}#selectShipping .address .msgPage{border-left-width:0;border-top-width:0}#selectShipping .address .msgPage ul li{margin-top:0}#selectShipping .disabled .shippingBlk{cursor:default;color:#d3d3d3}#selectShipping .disabled .adr{color:#d3d3d3}#selectShipping .disabled:focus,#selectShipping .disabled:hover{background-color:#fff}#selectShipping .items .addBtnItem{margin:0;padding:0;border-bottom:1px solid #e3e3e3}#selectShipping .items .addBtnItem:focus,#selectShipping .items .addBtnItem:hover{background-color:#f7f9fa}#selectShipping .address:after{content:\"\";width:100%;display:block;position:absolute;bottom:-2px;left:0}#selectShipping .addrHd{margin-bottom:10px;padding:0 15px;border:none}#selectShipping .backArrowContainer{margin-left:41px}#selectShipping .display .adr{margin-top:3px;color:#6c7378;font-weight:lighter;font-size:.85em;width:90%}#selectShipping .phone{clear:both}#selectShipping .phone form{overflow:hidden}#selectShipping .secondHalf{float:right}#selectShipping .review{float:left;width:65%}#selectShipping .editCard{font-size:1em}#selectShipping .add{padding:25px 20px;cursor:pointer;display:block}#selectShipping .add:hover{text-decoration:none}#selectShipping .add .btn{display:inline-block;vertical-align:middle;width:29px;height:29px;background:url(https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_flat.png) 7px -895px no-repeat}#selectShipping .checkIcon{width:24px;height:17px;display:inline-block;position:absolute;top:40%;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-192px -2px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectShipping .checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectShipping .addAddressContent{width:73%;display:inline-block;vertical-align:middle;color:#0070ba;font-weight:400;margin-left:5px;font-size:.85em}#selectShipping .addAddressContent:focus,#selectShipping .addAddressContent:hover{text-decoration:underline}#selectShipping li a{display:block;padding:17.5px 15px;text-decoration:none;color:#292929}#selectShipping li xo-message .msgPage{padding:15px 20px}#selectShipping li xo-message .msgPage ul li{margin-left:0}#selectShipping li xo-message .msgPage .icon{left:20px}#selectShipping .addIcon{display:inline-block;width:20px;height:20px;margin-left:5px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectShipping .addIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectShipping .header{padding:15px 15px 10px}#selectShipping .subHeader .leftIcon{display:inline-block;float:left;width:10px;height:10px;margin:4px 6px 0 0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-180px -180px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectShipping .subHeader .leftIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectShipping .subHeader .leftIcon:focus,#selectShipping .subHeader .leftIcon:hover{background-position:-180px -200px}#selectShipping .subHeader .rightIcon{float:right;width:6px;height:10px;margin:4px 0 0 6px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-200px -180px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectShipping .subHeader .rightIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectShipping .subHeader .rightIcon:focus,#selectShipping .subHeader .rightIcon:hover{background-position:-200px -200px}#shippingAddressForm .country{margin-bottom:10px}#shippingAddressForm .reversefirstname{float:right;width:48.15%;padding:0}#shippingAddressForm .firstname,#shippingAddressForm .reverselastname{float:left;width:48.15%;margin-right:3%;padding:0}#shippingAddressForm .lastname{float:right;width:48.15%;padding:0}#shippingAddressForm .buttons{margin-top:0}.fullpage .container{padding:20px 0}#addShipping.fullpage div.container h1.gamma{margin-bottom:8px}#deleteShipping .items{margin:0;width:100%;list-style:none}#deleteShipping .item{margin:0;position:relative;max-height:200px;overflow:hidden;border-bottom:1px solid #e3e3e3;-webkit-transition:max-height .5s ease;transition:max-height .5s ease}#deleteShipping .item.collapse{max-height:0}#deleteShipping .itemInner{padding:17.5px 15px}#deleteShipping .address{display:inline-block;width:70%;-webkit-transform:translate(0);transform:translate(0);-webkit-transition:-webkit-transform .5s ease;transition:transform .5s ease}#deleteShipping .address .fullName{word-break:break-all;line-height:1.35em}#deleteShipping .address.slide{-webkit-transform:translate(-32%);transform:translate(-32%)}#deleteShipping .address.slideFast{transition:transform .1s}#deleteShipping .item:after{content:\"\";width:100%;display:block;position:absolute;bottom:-2px;left:0}#deleteShipping .backArrowContainer{margin-left:41px}#deleteShipping .adr{margin-top:3px;color:#6c7378;font-size:.85em;width:inherit}#deleteShipping li{display:block;text-decoration:none;color:#292929}#deleteShipping .notDeletable .adr,#deleteShipping .notDeletable .fullName{color:#cbd2d6}#deleteShipping .msgIcon{width:20px;height:20px;display:inline-block;position:absolute;top:35%;right:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-139px -1px;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#deleteShipping .msgIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#deleteShipping .delete{font-size:.85em;display:inline-flex;position:absolute;height:100%;top:0;right:0;padding:0 15px;text-align:center;align-items:center;overflow:hidden;-webkit-transform:translate(0);transform:translate(0)}#deleteShipping .delete.slideOut{-webkit-transform:translate(102%);transform:translate(102%)}#deleteShipping .show{display:inline-flex}#deleteShipping .confirm{background-color:#009cde;cursor:pointer;-webkit-transform:translate(102%);transform:translate(102%);-webkit-transition:-webkit-transform .5s ease;transition:transform .5s ease}#deleteShipping .confirm a{font-weight:700;color:#fff;text-decoration:none}#deleteShipping .confirm.slidein{-webkit-transform:translate(0);transform:translate(0)}#deleteShipping .msg-inline{font-size:.85em;max-height:0;overflow:hidden;-webkit-transition:max-height .5s ease;transition:max-height .5s ease}#deleteShipping .msg-inline.expand{max-height:100px}#deleteShipping .msg-inlineInner{padding:12px 0 0}#deleteShipping .msg-error .icon{position:relative;float:left}#deleteShipping .msg-error .content{margin-left:29px;color:#c72e2e}#deleteShipping .header .backArrow{left:15px}#selectShippingCountry .disabled,#selectShippingCountry .disabled .custom-select>span,#selectShippingCountry .disabled span{color:#d3d3d3;margin-top:3px}#selectShippingCountry .disabled.country{min-height:53px}#selectShippingMethod #selectShippingMethodContainer{margin-top:-10px;padding-bottom:10px}#selectShippingMethod .shippingText{line-height:1.2em}#selectShippingMethod .shipTo{font-size:1.3em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;padding-top:10px;font-weight:lighter}#selectShippingMethod .storeLocation{margin-top:10px;word-wrap:break-word;line-height:1.2em}#selectShippingMethod .storeLocationInfo{margin-top:1%;color:#6c7378;font-size:.85em;width:90%;line-height:1.3em}#selectShippingMethod .changeShippingMethod{cursor:pointer}#selectShippingMethod .selectedShippingMethod{font-weight:500;margin-left:0;vertical-align:top;max-width:50%;overflow:hidden;text-overflow:ellipsis;display:inline-block;white-space:nowrap;-webkit-font-smoothing:antialiased;text-decoration:inherit}#selectShippingMethod #methodCharges{display:inline-block;margin-left:-10px;padding-left:10px;padding-right:10px}#selectShippingMethod .shippingAmt{font-weight:700;-webkit-font-smoothing:antialiased}#selectShippingMethod .noHighlight{background-color:#fff}#selectShippingMethod .highlight,#selectShippingMethod .noHighlight{-webkit-transition:background-color .4s linear;transition:background-color .4s linear}#selectShippingMethod .highlight{background-color:#eaf7e9}#selectShippingMethod .lightHR{border:none;height:1px;color:#e3e3e3;background-color:#e3e3e3;margin-bottom:10px;margin-top:10px}#selectShippingMethod .frontArrow{top:2px;right:-1px}#selectShippingMethod .modal-content{width:450px;height:95%;top:50%;position:fixed;overflow-y:scroll}#selectShippingMethod .modal-content>div{min-height:95%;position:relative}@media (min-width:0) and (max-width:30em){#selectShippingMethod .modal-content{width:100%}#selectShippingMethod .selectedShippingMethod{max-width:30%}}@media (max-width:40em) and (orientation:landscape){#selectShippingMethod .modal-content{width:100%}#selectShippingMethod .selectedShippingMethod{max-width:30%}}#selectShippingMethod .methodContents{margin-left:0}#selectShippingMethod .shippingOptions{padding-left:2px;padding-right:2px}#selectShippingMethod .shippingMethodsContainer{position:relative;min-height:95%;background-color:#fff;margin-top:40px;margin-left:30px;margin-right:30px}#selectShippingMethod .closeModal{position:fixed;margin-top:25px;margin-right:20px}#selectShippingMethod .logo{position:absolute;z-index:1;bottom:10px;left:0;right:0;width:29px;height:29px;background-position:0 -47px}#selectShippingMethod .shippingHeader{font-size:1.6em;color:#2c2e2f;font-weight:400;line-height:22px}#selectShippingMethod .gamma{font-size:13px;margin-top:5px;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#6c7378;font-weight:lighter;display:block;line-height:1.3em}#selectShippingMethod hr{width:100%;margin-top:20px;margin-bottom:20px;border-top:0 solid #dbdbdb}#selectShippingMethod .shippingCharge{font-weight:700;-webkit-font-smoothing:antialiased}#selectShippingMethod .methodName{font-weight:400;-webkit-font-smoothing:antialiased}#selectShippingMethod .deliveryTime{margin-left:0;color:#2c2e2f}#selectShippingMethod .deliveryTime,#selectShippingMethod .description{display:block;font-size:13px;line-height:1.3em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}#selectShippingMethod .description{margin-top:7.8px;color:#6c7378;font-weight:lighter}#selectShippingMethod .animate-show{max-height:100px;-webkit-transition:max-height .5s ease;transition:max-height .5s ease}#selectShippingMethod .animate-show.ng-hide{max-height:0;display:block!important;overflow:hidden}#selectShippingMethod div{margin-left:auto;margin-right:auto}#selectShippingMethod .confirmation{font-size:1.5em;text-align:center;color:#2c2e2f}#selectShippingMethod .btn{height:44px;margin-bottom:130px;margin-top:30px;border:1px solid #0070ba;background-color:#0070ba;border-radius:5px;display:inline-block;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased;text-rendering:auto;letter-spacing:normal;word-spacing:normal;text-transform:none;text-indent:0;text-shadow:none;-webkit-writing-mode:horizontal-tb;width:100%}#selectShippingMethod .btn:focus,#selectShippingMethod .btn:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}#selectShippingMethod .formatCurrency{font-weight:700;-webkit-font-smoothing:antialiased;text-decoration:inherit}#selectShippingMethod .formatCurrency .currencyCode{font-size:1em}#selectShippingMethod .modal-dialog{overflow-y:hidden;overflow-x:hidden}#selectFunding.asideContent{clear:both}#selectFunding .items{margin:0;width:100%;list-style:none}#selectFunding .items .addBtnItem{margin:0;padding:20px 10px;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out}#selectFunding .items .addBtnItem:focus,#selectFunding .items .addBtnItem:hover{background-color:#f7f9fa}#selectFunding .address:after{content:\"\";width:100%;display:block;position:absolute;bottom:-2px;left:0}#selectFunding .backArrowContainer{margin-left:41px}#selectFunding .display .adr{margin-top:3px;color:#6c7378;font-weight:lighter;font-size:.85em;width:90%}#selectFunding .secondHalf{float:right}#selectFunding .review{float:left;width:65%}#selectFunding .editCard{font-size:1em}#selectFunding .add{cursor:pointer;display:block}#selectFunding .add:hover{text-decoration:none}#selectFunding .add .btn{display:inline-block;vertical-align:middle;width:29px;height:29px;background:url(https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_flat.png) 7px -895px no-repeat}#selectFunding .fundingContainerPAD .name{color:#6c7378;font-size:.85em;margin-bottom:0}#selectFunding .checkIcon{width:24px;height:17px;display:inline-block;position:absolute;top:40%;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-192px -2px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectFunding .checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectFunding .addAddressContent{width:73%;display:inline-block;vertical-align:middle;color:#0070ba;font-weight:400}#selectFunding .addAddressContent:focus,#selectFunding .addAddressContent:hover{text-decoration:underline}#selectFunding .addIcon{display:inline-block;width:20px;height:20px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectFunding .addIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectFunding .bmlAsideOffer{padding:15px 10px}#selectFunding .offerTile{background-color:#f7f9fa}#selectFunding .fundingContainerBmlOffer{font-size:.7em;line-height:1.15em;padding:0;display:block}#selectFunding .fundingContainerBmlOffer .seeTermsLink{margin-top:5px}#selectFunding .fundingContainerPlcc{cursor:pointer;position:relative;min-height:35px}#selectFunding .fundingContainerPlcc .p{margin-left:30px}#selectFunding .redeemGC{margin-top:0;cursor:pointer}#selectFunding .bmlTermsLink{color:#0079ad}#selectFunding .bmlTermsLink:focus,#selectFunding .bmlTermsLink:hover{text-decoration:underline;background-color:transparent}#selectFunding .bmlDetails{display:inline-block;width:100%;font-size:.85em;padding-top:0}#selectFunding .plccAddNowLink{cursor:pointer;position:absolute;top:2px;right:0;font-size:.85em}#selectFunding .plccOfferDesc{margin-top:3px;font-size:.68em;color:#666}#selectFunding .headerText,#selectFunding .plccOfferDesc{margin-left:40px;margin-bottom:0}#selectFunding .fsIcon{float:left;position:inherit}#selectFunding .plccInstIcon{float:left;display:inline-block;height:20px;top:22px;left:15px;background:none;width:25px}#selectFunding .fsIcon.PLCC{background-image:none}#selectFunding #bmlApplyLink{line-height:1.75em}#addBank .fieldLegend{margin-bottom:4px;padding-bottom:0;font-size:inherit}#addBank .inputField input[readonly=readonly],#addBank input[readonly=readonly]{background:#f5f5f5;color:#a8a8a8}#sepaMandate .span{width:31%;float:none;display:inline-block;vertical-align:top}#sepaMandate span.col1{font-weight:700;vertical-align:top}#sepaMandate span.col1,#sepaMandate span.col2{display:block;word-wrap:break-word}#sepaMandate .asideContent p{font-size:.8em}#sepaMandate .asideContent span.col1{display:inline-block;width:30%}#sepaMandate .asideContent span.col2{display:inline-block;width:65%;margin-left:3%}#sepaMandate .asideContent .span{width:100%}#sepaMandate .creditorId{word-wrap:break-word}#sepaMandate .buttons{padding:0}#sepaMandate #cancelBtn{margin-top:10px}.conversionoptions{list-style:none;margin:0}.conversionoptions p{margin:0;padding:0}.conversionoptions label{font-weight:700}.conversionoptions ul{margin:0 0 0 30px;overflow-y:hidden}.conversionoptions .conversion{margin:3px 0 4px 35px}.conversionoptions input[name=ppconversion]{margin-bottom:5px;margin-right:5px;vertical-align:middle}.conversionoptions .conversionCC{margin-top:20px}.conversionoptions li{margin-bottom:5px;margin-left:5px;font-size:.92em}.conversionoptions .radioButton input[type=radio]~label{line-height:1.35em}.conversionoptions li:last-child .radioButton{margin:5px 0}.currencyConversion{overflow-y:auto;overflow-x:hidden;height:470px}#largeScreenDirectDebitAgreement_DE #proceedButton,#largeScreenSEPADirectDebit_DE #proceedButton,#sepaAgreementContingency #proceedButton,#sepaMandateContingency #proceedButton{float:none}#largeScreenDirectDebitAgreement_DE .de.cityPostalCode .city,#largeScreenSEPADirectDebit_DE .de.cityPostalCode .city,#sepaAgreementContingency .de.cityPostalCode .city,#sepaMandateContingency .de.cityPostalCode .city{width:56%}#largeScreenDirectDebitAgreement_DE .countryList .list,#largeScreenSEPADirectDebit_DE .countryList .list,#sepaAgreementContingency .countryList .list,#sepaMandateContingency .countryList .list{width:230px}#largeScreenDirectDebitAgreement_DE .button-as-link,#largeScreenSEPADirectDebit_DE .button-as-link,#sepaAgreementContingency .button-as-link,#sepaMandateContingency .button-as-link{font-size:1em}#largeScreenSEPADirectDebit_DE .sepaInfo,#sepaMandateContingency .sepaInfo{margin-bottom:10px}#largeScreenSEPADirectDebit_DE .sepaInfo .span,#sepaMandateContingency .sepaInfo .span{width:30%;float:none;display:inline-block;vertical-align:top}#largeScreenSEPADirectDebit_DE .sepaInfo p,#sepaMandateContingency .sepaInfo p{margin:0}#largeScreenSEPADirectDebit_DE .sepaInfo p.marginTop,#sepaMandateContingency .sepaInfo p.marginTop{margin-top:10px}#largeScreenSEPADirectDebit_DE .bankDetails,#largeScreenSEPADirectDebit_DE .personalInfo,#sepaMandateContingency .bankDetails,#sepaMandateContingency .personalInfo{word-break:break-all}#largeScreenSEPADirectDebit_DE .sepaInfo{margin:25px 0}#largeScreenSEPADirectDebit_DE .trayInner{padding:0 0 20px}@media (max-width:41.3125em){#largeScreenSEPADirectDebit_DE .trayInner{margin:0}.mobile .largeScreenSEPADirectDebitDE .centerTray{padding:0}.largeScreenSEPADirectDebitDE{margin:15px 25px 0}}.rightLink{float:right}.entryToggleLinks{margin-bottom:4px}.dateLocationMarker{color:#6c7378}.adr .darker{color:#2c2e2f}#meftDeclineAddCard #billingAddress .custom-select-container{margin-top:10px}#meftDeclineAddCard .useMeftInstead{margin-top:28px}#meftDeclineAddCard .cardImg{height:122px;margin-bottom:18px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_add_card.png\") no-repeat top}.incontext .useMeftInstead{margin-top:2px;margin-bottom:2px;font-size:77%}@media (max-width:30em) and (min-width:0){#largeScreenSEPADirectDebit_DE .sepaInfo .span,#sepaMandateContingency .sepaInfo .span{width:100%;margin:5px 0}#meftDeclineAddCard .trayInner{margin:15px 0 0}}.installmentOptions{height:400px;margin-left:-8px;margin-top:-8px}.installmentOptions .cardInfo{background-color:#f7f9fa;padding:15px 0 10px 20px;border-bottom:2px solid #e3e3e3;margin-top:0}.installmentOptions .cardInfo .ccard{background-size:31px;top:-2px;padding-left:48px;padding-bottom:3px;padding-top:0;right:-3px}.installmentOptions .cardInfo .installmentText{color:#6c7378;font-size:15px}.installmentOptions .items{margin:0;padding-left:7px;list-style:none}.installmentOptions .term{float:left}.installmentOptions .display{margin-left:0}.installmentOptions .display .total{margin-top:4px;color:#6c7378;font-size:.85em;width:90%}.installmentOptions .display .total .save{color:#2a5327;background-color:#eaf7e9;padding:4px;display:block;max-width:55%;margin-top:3px}.installmentOptions .installment{margin:0;padding:18px;position:relative;border-bottom:1px solid #e3e3e3;cursor:pointer;width:96%}.installmentOptions .installment:focus,.installmentOptions .installment:hover{background-color:#f7f9fa}.installmentOptions li a{text-decoration:none;color:#292929}.installmentOptions .installment:after{content:\"\";width:96%;display:block;position:absolute;bottom:-2px;left:0}.installmentOptions .asideContent{overflow-y:auto;overflow-x:hidden;height:400px}.MX .installmentOptions{height:1000px}.guestWithSignup .installmentOptions .asideContent{height:auto}@media (min-width:0) and (max-width:30em){.signupflow{margin-left:15px;margin-top:-12px}.installmentOptions .cardInfo,.signupflow .cardInfo{margin-top:5px}.header{margin-bottom:0}}#addressNormalization .addrRadio{position:relative}#addressNormalization .addrLabel{display:inline-block;padding-left:5px;vertical-align:top;width:75%}#addressNormalization .normalizedAdrSection{margin-bottom:10px}#addressNormalization .adr{margin-top:-2px;margin-left:10px}#addressNormalization .subContainer{border-top:none}@media (min-width:0) and (max-width:30em){#addressNormalization .addrRadio{position:relative;float:left}#addressNormalization .adr{margin-top:-2px;float:left;margin-left:10px}#addressNormalization .buttons{margin-top:-5px;overflow:visible}#addressNormalization .subContainer{border-top:none;margin-top:-10px}.row-fluid>[class*=span]{width:auto}}#taxIdForm .taxIdHead{font-size:14px}@media (min-width:41.3125em){section#genericError .container{width:400px}.genericError.footerWrapper{float:none;width:99.4%;padding:0 3px}.genericError.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#genericError{height:450px;background:none}section#genericError .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#genericError .title{font-size:1.5em;margin-bottom:15px;line-height:1.2}section#genericError .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#genericError .secondaryMessage{color:#979797;line-height:20px}section#genericError .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#genericError .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#genericError .cancelLink{margin-top:20px}@media (min-width:41.3125em){section#genericMessage .container{width:400px}.genericMessage.footerWrapper{float:none;width:99.4%;padding:0 3px}.genericMessage.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#genericMessage{height:450px;background:none}section#genericMessage .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#genericMessage .title{font-size:1.5em;margin-bottom:15px}section#genericMessage .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#genericMessage .secondaryMessage{color:#979797;line-height:20px}section#genericMessage .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#genericMessage .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#genericMessage .cancelLink{margin-top:20px}.overlayMask,.overlayWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}.overlayMask{background:#cbd2d6;opacity:.7}.overlayWrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:90px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.overlayWrapper .logo{position:relative;width:29px;height:29px;margin:0 auto;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.overlayWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.overlayContainer{width:380px;display:block;min-height:100%;height:auto!important;height:100%;margin:0 auto -50px}.overlayContainer .pushLogo{height:50px}.overlayOpen .overlayWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}.pageOverlay #spinner{top:0;left:0}body.loading .pageOverlay .aside{opacity:.1}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.overlayWrapper{width:100%;padding:30px 15px 0}.overlayWrapper .overlayContainer{width:auto}}.installmentInfo{padding-bottom:10px}.terms{font-size:.85em}.signupbml .title{margin-bottom:12px}.signupbml .adr{font-weight:400}.signupbml .bmlRow{border-top:1px solid #e3e3e3;margin-top:0;margin-bottom:0;padding:25px 0 0}.signupbml .bmlSeeTerms{font-size:13px;color:#666;line-height:1.35em}.signupbml .payInFullLink{font-weight:700}.signupbml .billingAddressRow{margin-bottom:15px}.signupbml .changeBillingAddress{float:right;margin-top:4px;cursor:pointer}.signupbml .sameLine{display:inline}.signupbml .bmlMargin{margin-top:15px}.signupbml .inputField input{height:44px}.signupbml .billingName{margin-bottom:0}.signupbml .fidobMonth{width:35%;float:left}.signupbml .fidobMonth .custom-select>span{border-radius:5px 0 0 5px;border-right:1px solid #fff}.signupbml .fidobDay{width:30%;float:left}.signupbml .fidobDay .custom-select>span{border-radius:0 0 0 0;border-right:1px solid rgba(0,0,0,.2)}.signupbml .fidobYear{width:35%;float:left}.signupbml .fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:1px solid #fff}.signupbml .custom-select.active>span{border:1px solid #009cde;outline:0}.signupbml .dobNatlIdGroup{margin-top:15px;margin-bottom:20px}.signupbml .dobNatlIdGroup input{margin-bottom:0}.signupbml .dobNatlIdGroup .inputField{-ms-box-sizing:border-box;box-sizing:border-box;padding:0}.signupbml .dobNatlIdGroup .toolTip{white-space:nowrap;right:0;position:absolute;margin-top:4px}.signupbml .dob,.signupbml .nationalId{width:68%;position:relative;padding:0}.signupbml .dob legend,.signupbml .nationalId label.topLabel{color:inherit;display:block;left:inherit;margin:0;padding-bottom:5px;position:relative;top:inherit}.signupbml .nationalId label.placeholder{top:32px;display:none}.signupbml .dob{float:left}.signupbml .dob legend{font-size:inherit}.signupbml .dob.fullWidth{width:100%}.signupbml .dob.fullWidth .custom-select-container{width:33.33%}.signupbml .nationalId{padding-right:0;width:29.5%}.signupbml .nationalId.inputField label.topLabel{left:0;top:0;white-space:nowrap}.signupbml .fieldGroup .nationalId{float:right;height:20px;margin-top:22px}.signupbml .verifyHelp{display:inline-block;height:18px;width:19px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-164px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.signupbml .verifyHelp{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.signupbml .postal-code.adr-break{display:inline}.signupbml .piHeight{height:25px}.signupbml .toolTip{font-size:12px;position:relative}@media (max-width:41.3125em){#bmlApplyEdu{display:none}.addPhone,.bmlSeeTerms,.city,.dobNatlIdGroup,.line1,.line2,.state,.zip{font-size:.95em}.toolTip{font-size:12px}}.mobile #applyForBml .tipNationalId{width:317px}.mobile #applyForBml .custom-select>span{padding:5px}.mobile .toolTip{font-size:12px}@media (min-width:30.0625em) and (max-width:41.25em){#bmlApplyEdu{display:none}.addPhone,.bmlSeeTerms,.city,.dobNatlIdGroup,.line1,.line2,.postalCode,.state{font-size:.95em}.toolTip{font-size:12px}}@media (min-width:0) and (max-width:40em){#bmlApplyEdu{display:none}.addPhone,.bmlSeeTerms,.city,.dobNatlIdGroup,.line1,.line2,.postalCode,.state{font-size:.95em}.toolTip{font-size:12px}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#bmlApplyEdu{display:none}.addPhone,.bmlSeeTerms,.city,.dobNatlIdGroup,.line1,.line2,.postalCode,.state{font-size:.95em}.toolTip{font-size:12px}}#bmlModal .chkbxLabel{line-height:inherit}#continueBml{margin-bottom:12px}.headerBar{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.bmlSignature .bmlSeeTerms{font-size:.68em;color:#666}.bmlSignature .sameLine{display:inline}.bmlSignature .bmlMargin{margin-top:15px}.bmlSignature .content{line-height:1.35em}.bmlSignature .agree{position:relative}.bmlSignature #confirmationMessage{line-height:1.2em}.bmlSignature .validated input[type=checkbox].ng-invalid+.errorTooltipRuleSpecific{width:300px;font-size:12px;top:30px;left:0;line-height:1.2em;width:275px}.bmlSignature .buttons{margin-top:20px}#bmlTermsAndConditions .trayInner{clear:both;padding:0 0 20px}#bmlTermsAndConditions .trayPaymentPlanDetails{padding:25px 0 15px;margin:0;border-top:none}#bmlTermsAndConditions .trayPaymentPlanDetails h2{margin-bottom:10px}#bmlTermsAndConditions .trayPaymentPlanDetails p{margin:0}#bmlTermsAndConditions .bmlTermsHeader{margin:20px 0 0}#bmlTermsAndConditions .bmlTermsInnerWrap{overflow:hidden;position:relative;height:450px}#bmlTermsAndConditions .bmlTermsHead{float:left}#bmlTermsAndConditions .printContent{float:right}#bmlTermsAndConditions .bmlTermsBody{overflow:auto;height:400px;clear:both;border:1px solid #dbdbdb}#bmlTermsAndConditions .bmlTermsBody iframe{height:99%;width:100%;overflow:scroll;-ms-box-sizing:border-box;box-sizing:border-box;border:none}#bmlTermsAndConditions .bmlTermsDirections,#bmlTermsAndConditions .bmlTermsFooter{background-color:#f1f4f5}#bmlTermsAndConditions .bmlTermsDirections{float:right;font-weight:700}#bmlTermsAndConditions .bmlTermsDirections p{margin:0}#bmlTermsAndConditions .bmlTermsDirections p.first{margin:8px 5px 0 0}#bmlTermsAndConditions .bmlAgreeToTerms{min-width:60%}#bmlTermsAndConditions #bmlAgreeToTermsSubmit{float:left;min-width:50%;margin:2px 0 0}#bmlTermsAndConditions .bmlTermsFooter{position:static;margin:0;padding:15px 20px;top:auto;bottom:0;position:absolute;left:0;width:100%;min-height:70px;border-radius:0 0 5px 5px;background-clip:padding-box;-ms-box-sizing:border-box;box-sizing:border-box}#bmlTermsAndConditions .trayInner{position:relative}#bmlTermsAndConditions .btn.disabled,#bmlTermsAndConditions .btn[disabled]{opacity:.35}#bmlTermsAndConditions #creditConfirmation{display:block}#bmlTermsAndConditions #creditConfirmation .modal-wrap{margin:0;padding:0;width:440px;border-radius:0}#bmlTermsAndConditions #creditConfirmation .close:hover{background-position:-218px -22px}#bmlTermsAndConditions #creditConfirmation .paypalHeaderWrapper{padding:30px}#bmlTermsAndConditions #creditConfirmation .paypalHeaderWrapper .logo{margin:0 auto;float:none}#bmlTermsAndConditions #creditConfirmation .paypalHeaderWrapper .close{top:36px;right:30px}#bmlTermsAndConditions #creditConfirmation .confirmationPopupContent{background-color:#f7f9fa;padding:20px 30px}#bmlTermsAndConditions #creditConfirmation .confirmationPopupContent h2{font-size:1.5em;text-align:center;color:#2c2e2f}#bmlTermsAndConditions #creditConfirmation .confirmationPopupContent ul{margin:1em}#bmlTermsAndConditions #creditConfirmation .confirmationPopupContent ul li{margin-bottom:20px}#bmlTermsAndConditions #creditConfirmation .cancelApplicationBlock{padding:15px;text-align:center}.largeScreen.pageBmlTermsAndConditions .cartVerB #main .logo{display:none}.largeScreen.pageBmlTermsAndConditions .cartVerB #main .cartContainer{margin:0 0 30px;position:relative;right:0;top:0}.largeScreen.pageBmlTermsAndConditions .cartVerB #main .cartContainer .transctionCartDetails{z-index:2}.largeScreen.pageBmlTermsAndConditions .cartVerB #main .cartContainer .transctionCartDetails .details{margin:10px 15px 10px 10px}.mobile.pageBmlTermsAndConditions #bmlTermsAndConditions .bmlTermsBody,.mobile.pageBmlTermsAndConditions #bmlTermsAndConditions .bmlTermsInnerWrap,.pageBmlTermsAndConditions #bmlTermsAndConditions.mobile .bmlTermsBody,.pageBmlTermsAndConditions #bmlTermsAndConditions.mobile .bmlTermsInnerWrap{height:auto}@media (min-width:30.0625em) and (max-width:41.25em){#bmlTermsAndConditions .bmlTermsInnerWrap{height:450px}#bmlTermsAndConditions #bmlAgreeToTermsSubmit{margin:0 30px 20px 0;float:none}#bmlTermsAndConditions .bmlTermsDirections{float:none;margin-bottom:10px}#bmlTermsAndConditions .printContent{float:none;margin-top:10px}.bmlTermsAndConditions #contents{padding:0}}@media (max-width:41.25em) and (min-width:0){#bmlTermsAndConditions #creditConfirmation .modal-wrap{padding:20px;width:80%;margin:0}}@media (min-width:30em) and (max-width:35em){.largeScreen.pageBmlTermsAndConditions .footer{padding:30px 5px 0}}@media (min-width:0) and (max-width:40em){.largeScreen.bmlTermsAndConditions .cancelUrl{display:none}.largeScreen.bmlTermsAndConditions .trayInner{padding:25px 30px}#bmlTermsAndConditions header{position:fixed;top:0;left:0;width:100%;z-index:3}#bmlTermsAndConditions .cancelLink{margin:0 0 20px;font-size:.86em}#bmlTermsAndConditions .printContent{float:none;margin-top:10px}#bmlTermsAndConditions .bmlTermsBody{height:auto;border:none;-webkit-overflow-scrolling:touch}#bmlTermsAndConditions .bmlTermsBody iframe{min-height:350px}#bmlTermsAndConditions h2{margin:0}#bmlTermsAndConditions .trayInner{padding:0;box-shadow:none}#bmlTermsAndConditions .trayInner.trayPaymentPlanDetails,#bmlTermsAndConditions .trayInner.trayTerms{padding:0}#bmlTermsAndConditions .bmlTermsHead{float:none;font-size:1.25em}#bmlTermsAndConditions .bmlTermsInnerWrap{height:auto}#bmlTermsAndConditions .bmlTermsHeader{margin:25px 0 0}#bmlTermsAndConditions .bmlTermsFooter{position:fixed;top:auto;bottom:-100%;min-height:0;padding:15px}#bmlTermsAndConditions .bmlTermsFooter.bmlFooterShow{bottom:0;transition:bottom .7s,0s ease}#bmlTermsAndConditions .bmlTermsFooter .bmlTermsDirections{width:100%;padding:0}#bmlTermsAndConditions .bmlTermsFooter .bmlTermsDirections p{margin:5px 0;text-align:center;line-height:1em;font-size:.8em}#bmlTermsAndConditions .bmlTermsFooter #bmlAgreeToTerms{width:100%;float:none;margin:0;display:none}#bmlTermsAndConditions .bmlTermsFooter.enabled{padding:10px}#bmlTermsAndConditions .bmlTermsFooter.enabled .bmlTermsDirections{display:none}#bmlTermsAndConditions .bmlTermsFooter.enabled #bmlAgreeToTerms{display:block}#bmlTermsAndConditions .bmlTermsBody,#bmlTermsAndConditions .trayPaymentPlanDetails{border:none}#bmlTermsAndConditions .termsTable{font-size:.9em}#bmlTermsAndConditions .learnMore{font-size:.8em}#bmlTermsAndConditions .trayInner{margin:0}#bmlTermsAndConditions .footer.inside,#bmlTermsAndConditions .footer.outside{display:none}}@media (min-width:41.3125em){.pageBmlTermsAndConditions .mobile .bmlTermsDirections{display:none}}.minibrowser .pageBmlTermsAndConditions #bmlTermsAndConditions .bmlTermsBody{margin:0}#creditoffer .cycoHeader{margin-bottom:5px}#creditoffer .mainDescription{color:#6c7378}#creditoffer .inputField input{height:40px}#creditoffer p{margin-bottom:5px}#creditoffer .ukOfferDescription{width:90%}#creditoffer .offerTitle{font-weight:700}#creditoffer .offerSmallText{width:100%;margin-bottom:0;font-size:1em}#creditoffer .moreInfoLink{padding:7px 33px 4px 18px;position:absolute;top:12px;right:0;color:#0070ba;cursor:pointer;font-weight:500}#creditoffer .noMargin{top:2px}#creditoffer .down{background-position:-219px -234px}#creditoffer .up{background-position:-219px -219px}#creditoffer .frontArrow{top:10px;right:0;width:22px}#creditoffer .bmlLender{font-size:.75em;margin-top:10px;color:#6c7378}#creditoffer .bmlMargin{margin-top:15px}#creditoffer .sameLine{display:inline}#creditoffer .payInFullLink{font-weight:700}#creditoffer .payInFullText{color:#6c7378}#creditoffer .buttons{width:100%;margin-top:10px;-ms-box-sizing:border-box;box-sizing:border-box;bottom:0}#creditoffer .btn{width:100%}#creditoffer .smallText{padding:3px 35px 0;font-size:.75em}#creditoffer .extendedOfferContent{display:inline-block;width:75%;padding:10px 0}#creditoffer .chooseOffer,#creditoffer .ukChooseOffer{width:25%;font-size:1em;display:inline-block;float:right;margin-bottom:0}#creditoffer .ukChooseOffer{margin-top:0}#creditoffer .terms{font-size:.85em;margin:0;font-weight:700}#creditoffer .installmentOfferWrapper,#creditoffer .sacOfferWrapper{margin-bottom:15px;margin-top:20px}#creditoffer .installmentOfferWrapper .extendedInstallmentCtaWrap,#creditoffer .installmentOfferWrapper .extendedSacCtaWrap,#creditoffer .installmentOfferWrapper .installmentCtaWrap,#creditoffer .installmentOfferWrapper .sacCtaWrap,#creditoffer .sacOfferWrapper .extendedInstallmentCtaWrap,#creditoffer .sacOfferWrapper .extendedSacCtaWrap,#creditoffer .sacOfferWrapper .installmentCtaWrap,#creditoffer .sacOfferWrapper .sacCtaWrap{padding:20px;background-color:#f7f9fa;position:relative;border-radius:5px;background-clip:padding-box}#creditoffer .installmentOfferWrapper .extendedInstallmentCtaWrap .trayInner,#creditoffer .installmentOfferWrapper .extendedSacCtaWrap .trayInner,#creditoffer .installmentOfferWrapper .installmentCtaWrap .trayInner,#creditoffer .installmentOfferWrapper .sacCtaWrap .trayInner,#creditoffer .sacOfferWrapper .extendedInstallmentCtaWrap .trayInner,#creditoffer .sacOfferWrapper .extendedSacCtaWrap .trayInner,#creditoffer .sacOfferWrapper .installmentCtaWrap .trayInner,#creditoffer .sacOfferWrapper .sacCtaWrap .trayInner{position:relative;margin:0;padding:0;background-color:transparent;overflow:hidden}#creditoffer .installmentOfferWrapper .extendedInstallmentCtaWrap,#creditoffer .sacOfferWrapper .extendedInstallmentCtaWrap{padding:0}#creditoffer .installmentOfferWrapper .extended,#creditoffer .sacOfferWrapper .extended{background-color:#fff;color:#6c7378;border:1px solid #e1e7eb}#creditoffer .installmentOfferWrapper .seeTermsWrap,#creditoffer .sacOfferWrapper .seeTermsWrap{padding:10px 0 10px 20px}#creditoffer .installmentOfferWrapper #extendedInstallmentOffer,#creditoffer .installmentOfferWrapper #extendedSacOffer,#creditoffer .sacOfferWrapper #extendedInstallmentOffer,#creditoffer .sacOfferWrapper #extendedSacOffer{margin-top:5px}#creditoffer .reverseOrder{display:table;width:100%}#creditoffer .reverseOrder .sacOfferWrapper{display:table-footer-group}#creditoffer .gceOffers .row-fluid .span12{width:49.9%}#creditoffer .gceOffers .row-fluid .span8{width:33.1%}#creditoffer .gceOffers .row-fluid .span6{width:24.8%}#creditoffer .gceOffers .row-fluid [class*=span]{margin-left:0}#creditoffer .gceOffers .postScriptCondition{clear:both;padding:10px 0 0;font-size:.73em}#creditoffer .gceOffers .span12.singleOffer{float:none}#creditoffer .gceOffers ul.installmentOptionsB{overflow:hidden;white-space:nowrap;border-radius:5px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner{padding:0;margin:0;background-color:#f7f9fa}#creditoffer .gceOffers ul.installmentOptionsB.trayInner.fullPageOffer{padding-bottom:20px;background-color:transparent}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .sacOffer{box-sizing:border-box;float:left;line-height:1.154em;list-style:outside none none;padding:20px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer{float:left;list-style:none;border-right:3px solid #fff;-ms-box-sizing:border-box;box-sizing:border-box;padding:15px 15px 0;line-height:1.154em}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form{position:relative;min-height:230px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.en{min-height:250px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.es,#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.fr,#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.zh{min-height:278px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer:last-child{border-right:none}#creditoffer .gceOffers ul.installmentOptionsB.trayInner ul.subSections{white-space:normal;margin:0;padding-bottom:10px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner ul.subSections li{list-style:none}#creditoffer .gceOffers ul.installmentOptionsB.trayInner ul.subSections li.offerHeading1{padding:0 0 5px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .theta{font-size:.85em}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .smallText{padding:3px 16px 0;font-size:.75em}#creditoffer .gceOffers .offerAmount{display:block;font-weight:700}#creditoffer .gceOffers .totalInstallment{margin:0 0 10px}#creditoffer .gceOffers .offerDetails{width:75%;white-space:normal;padding:10px 0 0}#creditoffer #creditExampleUK{margin:30px 0}#creditoffer #creditExampleUK .creditWorksTitle{margin-bottom:5px;color:#2c2e2f}#creditoffer #creditExampleUK .creditWorksDescription{color:#6c7378}#creditoffer #creditExampleUK .representativeExKey{font-size:.85em}#creditoffer #creditExampleUK .representativeExHeader{margin-top:-10px}#creditoffer #creditExampleUK .span6{text-align:center;margin:0}#creditoffer #creditExampleUK .representativeEx{margin:0 0 20px;list-style:none;padding:0;background:none;border-top:7px solid #e3e3e3;border-bottom:1px solid #e3e3e3}#creditoffer #creditExampleUK .representativeEx .creditExHeading{color:#6c7378}#creditoffer #creditExampleUK .representativeEx li{padding:10px 30px;vertical-align:middle;border-right:1px solid #e3e3e3;width:175px}#creditoffer #creditExampleUK .representativeEx li p{margin-bottom:5px}#creditoffer #creditExampleUK .representativeEx li .representativeExampleAPRAmount{margin:2px 0 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:700}#creditoffer #creditExampleUK .representativeEx li:last-child{border-right:none}#creditoffer .faq{text-align:center}@media (min-width:0) and (max-width:50em){#creditoffer .installmentOfferWrapper .installmentCtaWrap p,#creditoffer .installmentOfferWrapper .sacCtaWrap p,#creditoffer .sacOfferWrapper .installmentCtaWrap p,#creditoffer .sacOfferWrapper .sacCtaWrap p{width:52%}#creditoffer .buttons{position:absolute;top:40%;right:0;width:16px;height:16px;box-shadow:none;text-shadow:none;border:none;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -168px;text-indent:-200px;width:9px;height:18px}#creditoffer .buttons .btn{display:none}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.row-fluid .span6,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.row-fluid .span8,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.row-fluid .span12,#creditoffer .gceOffers ul.installmentOptionsB.row-fluid .span6,#creditoffer .gceOffers ul.installmentOptionsB.row-fluid .span8,#creditoffer .gceOffers ul.installmentOptionsB.row-fluid .span12{width:100%;border-right:none;border-bottom:1px solid #fff}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.trayInner li.offer,#creditoffer .gceOffers ul.installmentOptionsB.trayInner li.offer{padding:20px;border-bottom:5px solid #fff}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.trayInner li.offer form,#creditoffer .gceOffers ul.installmentOptionsB.trayInner li.offer form{min-height:0}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB ul.subSections,#creditoffer .gceOffers ul.installmentOptionsB ul.subSections{width:auto}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB ul.subSections:last-of-type,#creditoffer .gceOffers ul.installmentOptionsB ul.subSections:last-of-type{padding-bottom:0}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB .span6,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB .span8,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB .span12,#creditoffer .gceOffers ul.installmentOptionsB .span6,#creditoffer .gceOffers ul.installmentOptionsB .span8,#creditoffer .gceOffers ul.installmentOptionsB .span12{position:relative}#creditoffer .fourOffers .gceOffers .offerAmount,#creditoffer .gceOffers .offerAmount{display:inline}#creditoffer .fourOffers .gceOffers .offerDetails,#creditoffer .gceOffers .offerDetails{display:block;width:auto}#creditoffer #creditExampleUK .representativeEx li{padding:10px 30px 10px 0;vertical-align:middle;border-right:1px solid #e3e3e3;width:100%}}@media (min-width:0) and (max-width:50em) and only screen and (-webkit-min-device-pixel-ratio:2),(min-width:0) and (max-width:50em) and only screen and (min--moz-device-pixel-ratio:2),(min-width:0) and (max-width:50em) and only screen and (min-device-pixel-ratio:2),(min-width:0) and (max-width:50em) and only screen and (min-resolution:2dppx),(min-width:0) and (max-width:50em) and only screen and (min-resolution:192dpi){#creditoffer .buttons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.kmliCheckboxLabel{display:table-cell!important}.kmliHelpIcon{display:table-cell;vertical-align:top;padding:5px 0 0 5px}.inline-prop a{font-weight:700}.riskyTitle h1{max-width:inherit!important}.riskySubtitle p{color:#6c7378;font-size:15px!important}.singlePagePaymentForm .nationalID{width:100%!important;float:none}.singlePagePaymentForm .nationalID .custom-select>span{border-right:1px solid #c5ccd1;border-radius:5px 5px 5px 5px!important}.singlePagePaymentForm .nationalID .custom-select.active>span{border-right:1px solid #009cde}.singlePagePaymentForm .nationalIDValue{width:100%;float:none}.singlePagePaymentForm .additionalIDBox{border-radius:5px 5px 5px 5px!important}.nationalID{width:40%!important;float:left}.nationalID .custom-select>span{border-right:0;border-radius:5px 0 0 5px!important}.nationalID .custom-select.active>span{border-right:0}.nationalIDValue{width:60%;float:right}.additionalID{width:26%;float:left}.additionalID .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.additionalIDValue{width:74%;float:right}.additionalIDBox{border-radius:0 5px 5px 0!important;border-left:1px}.additionalIdHelper{position:relative;margin-left:5px;float:right}.additionalIdHelper .verifyHelp{display:inline-block;height:20px;width:20px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-164px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.additionalIdHelper .verifyHelp{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.additionalIdHelper:focus{background-position:-164px -44px}.lineSpacing{margin-top:10px}.xo-done #header,.xo-done #wrapper{max-width:480px}.xo-done #defaultCancelLink{width:0;height:0}.xo-done #stm-upsell-content{padding-bottom:10px}.xo-done .item-options{font-size:13px}.xo-done .item-selections{font-size:13px;color:#6c7378}.xo-done .item-selections .item-selection-name{font-weight:700}.xo-done .item-selections .item-selection-value{padding-right:1em}.xo-done .item-number-container{font-size:13px;margin-bottom:10px;color:#6c7378}.xo-done .item-number-container .item-number{word-wrap:break-word}.xo-done #transactionCart{display:none}.xo-done #contents{padding:0}.xo-done #circle{top:15px;right:-5px;margin:0 auto 30px;position:relative;width:90px;height:90px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/animation-checkmark.gif\");background-repeat:no-repeat;background-size:90px 90px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.xo-done #circle{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/animation-checkmark.gif\");background-size:90px 90px}}.xo-done #merchantReturnBtn{margin-top:10px}.xo-done #details-text{text-align:center;position:relative;z-index:1;font-size:15px;margin-top:16px;bottom:5px;color:#0070ba}.xo-done .receipt.basics{height:220px;width:auto;text-align:center;margin-bottom:-27.5px}.xo-done .receipt.basics #paid-text{text-align:center;font-size:24px;margin-bottom:10px;line-height:1.35}.xo-done .receipt.basics #merchant-text{text-align:center;font-size:13px}.xo-done .receipt.statement{font-size:10px}.xo-done .receipt.title{font-weight:700;margin-bottom:10px;margin-top:25px}.xo-done .row .currencyCode{font-size:11px;font-weight:400}.xo-done .essentials{margin:38px 30px 0}.xo-done .essentials.autoReturnSection{text-align:center;margin-bottom:38px}.xo-done .row{margin-bottom:10px}.xo-done .row div{margin-top:5px}.xo-done .amount{float:right;font-weight:500}.xo-done hr{height:1px}.xo-done .text div{margin-bottom:5px}.xo-done #receiptNumber{margin:10px 0}.xo-done .alert{color:#8a6d3b;background-color:#fcf8e3;margin:20px 10px;padding:5px;border:solid transparent;border-radius:4px}.xo-done .details-expand{margin-top:60px;margin-bottom:-57px;padding-bottom:1px;background:#f7f9fa;width:auto;max-height:0;overflow:hidden}.xo-done .details-expand,.xo-done .details-expand.expansion{-webkit-transition:max-height .5s ease-in;transition:max-height .5s ease-in}.xo-done .details-expand .grouping{border-bottom:1px double;border-color:#e3e3e3;padding:15px 0 5px}.xo-done .details-expand .totalAmount{border-bottom:20px transparent;margin:15px 0 20px}.xo-done .splash-receipt{padding-left:30px;padding-right:30px;margin-left:-30px;margin-right:-30px;margin-top:-1px;background-color:#f7f9fa;border-top:1px solid #e3e3e3;border-bottom:1px solid #e3e3e3}.xo-done .splash-receipt #details-button{margin:18px auto 0;position:relative;background:#f7f9fa;width:39px;height:39px;text-align:center;border-radius:100%;background-clip:padding-box;border-bottom:1px solid #e3e3e3;top:18px}.xo-done .splash-receipt #details-button .arrow{width:20px;height:16px;display:inline-block;position:absolute;top:17px;right:10px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.xo-done .splash-receipt #details-button .arrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.xo-done .splash-receipt #details-button .arrow.expand{background-position:-174px -144px}.xo-done .splash-receipt #details-button .arrow.collapse{background-position:-174px -156px}.xo-done .msg-warning .icon{background-position:-89px -22px;left:7px}.xo-done .footer{max-width:480px}@media (max-width:41.25em){.xo-done .splash-receipt{margin-left:0;margin-right:0}}@media (max-width:41.25em) and (min-width:30.0625em){.xo-done .merchantHeader,.xo-done header{display:block}.xo-done #wrapper{margin:0 auto;border:1px solid #e3e3e3}.xo-done .essentials{margin:38px 15px 0}.xo-done .essentials.autoReturnSection{text-align:center;margin-bottom:38px}.xo-done .copyright{float:none;width:auto}.xo-done .footerLinks{float:none;width:auto;text-align:center}.xo-done .footer{border:none;margin-top:0;padding-top:0}}[dir=rtl] .xo-done .amount{float:left}[dir=rtl] .xo-done .money-source{float:right}[dir=rtl] .xo-done #paid-text b{direction:ltr;unicode-bidi:bidi-override}.offerSmallText{line-height:1.35em;font-size:.75em}.bmlOfferText{font-size:1.15em}.seeTermsLink{margin-top:10px}.seeTermsLink a{font-weight:700}.frontArrow{top:8px;right:0}.bmlChangeLink{position:absolute;top:0;right:0;font-size:.85em;cursor:pointer}.bmlExistingOfferText{font-size:medium;color:#2c2e2f;line-height:1.2em}.creditIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;min-width:65px;width:65px;height:37px;padding-right:5px;background-position:-25px -129px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.creditIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.cycoApplyLink{cursor:pointer;position:absolute;top:-9px;right:0;padding:7px 10px 4px;font-size:.85em}.installmentDescription{width:70%!important}#bmlOffer .acquisitionBannerSeparator{display:none}#bmlOffer .acquisitionBannerRight .bmlOfferTitle{width:auto;margin-right:80px}@media (max-width:1050px){#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_control .acquisitionBannerRight .bmlOfferTitle{max-width:200px}}@media (max-width:830px){#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_left_logo .acquisitionBannerRight .bmlOfferTitle{max-width:200px}}#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_OR{background-color:#fff;padding-left:0;border-top:1px solid #e3e3e3}#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_OR .acquisitionBannerRight .bmlOfferTitle{margin-right:0}#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_OR .acquisitionBannerSeparator{display:block;position:absolute;width:100%;text-align:center;top:-25px;color:#6c7378;font-size:14px;line-height:14px}#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_OR .acquisitionBannerSeparator span{background:#fff;padding:5px}#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_OR .bmlOfferTitle{max-width:200px}@media (min-width:830px){#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_OR .acquisitionBannerLeft{float:left;width:75px}#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_OR .acquisitionBannerRight{float:left;width:220px}}@media (max-width:850px){#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_contentchange .acquisitionBannerRight .bmlOfferTitle{max-width:250px}}#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_contentchange .bmlOfferText{display:none}#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_contentchange .acquisitionBannerRight .bmlOfferTitle{margin-right:0}@media (max-width:830px){#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_right_logo .acquisitionBannerRight .bmlOfferTitle{max-width:200px}}#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_right_logo .creditIcon{position:absolute;bottom:0;right:0}#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_right_logo .acquisitionBannerRight{margin-right:80px}#bmlOffer.xo_hermesnodeweb_us_ryi_ppc_right_logo .acquisitionBannerRight p{width:100%}.light-box-3ds .light-box{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}.light-box-3ds .light-box-header{font-size:24px;font-weight:lighter;font-family:HelveticaNeue-Light;line-height:1.2em;margin-top:40px}.light-box-3ds .close{top:20px;right:20px;font-size:0}.light-box-3ds .close:hover{background-position:-223px -22px;text-decoration:none}.light-box-3ds .light-box.mask{background:#cbd2d6;opacity:.7}.light-box-3ds .light-box-iframe{height:400px;width:400px;border:1px solid #999;border-radius:5px;background-clip:padding-box;border-radius:0}.light-box-3ds .light-box.wrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:90px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.light-box-3ds .light-box.wrapper .logo{margin:30px auto;width:29px;height:29px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.light-box-3ds .light-box.wrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.light-box-3ds .light-box-container{width:420px;display:block;min-height:600px;overflow:scroll}.light-box-3ds .light-box.open .light-box.wrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}.light-box-3ds body.loading .light-box .aside{opacity:.1}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.light-box-3ds .light-box.wrapper{width:100%;padding:0 15px}.light-box-3ds .light-box.wrapper .light-box.container{width:auto;margin-top:30px}}.upsellMask,.upsellWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}.upsellMask{background:#cbd2d6;opacity:.7}.upsellWrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:90px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.upsellWrapper .logo{position:relative;width:29px;height:29px;margin:0 auto;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.upsellWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.upsellContainer{width:380px;display:block;min-height:100%;height:auto!important;height:100%;margin:0 auto -50px}.upsellContainer .pushLogo{height:60px}.upsellOpen .upsellWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}.kmliUpsell #spinner{top:0;left:0}body.loading.kmliUpsellActive #main{opacity:1}body.loading.kmliUpsellActive .kmliUpsell .aside{opacity:.1}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.upsellWrapper{width:100%;padding:0 15px}.upsellWrapper .upsellContainer{width:auto;margin-top:5px}}.logo{position:relative;width:29px;height:29px;margin:0 auto;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.pushLogo{height:30px}.spinnerBtn .spinner{margin:8px 0 0;height:25px;width:25px;position:static;display:inline-block;z-index:10;padding:0;background-color:transparent;border-width:1.5px;border-style:solid;border-radius:100%;border-color:#009cde #fff #fff;top:0;left:50%;opacity:1;filter:alpha(opacity=100);-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear}.loading #main{opacity:.1}.spinner{height:100%;width:100%;position:absolute;top:0;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .loadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100;outline:none}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.props .vprop-header{font-size:1.6em;color:#2c2e2f;margin:15px 0 10px;font-weight:lighter;line-height:1.2em}.props .prop-img{background-position:center 0}.props.login{padding:0 10px 0 0}.props.login .prop-img{height:104px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png\");background-repeat:no-repeat;margin-top:20px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.props.login .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v2_2x.png\");background-size:195px 104px}}.props.review .prop-img{height:92px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.props.review .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags_2x.png\");background-size:206px 92px}}.props.signature .prop-img{height:200px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_ballon.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.props.signature .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_ballon_2x.png\");background-size:250px 200px}}.props.addTaxId .prop-img{height:104px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png\");background-repeat:no-repeat;margin-top:-25px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.props.addTaxId .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v2_2x.png\");background-size:195px 104px}}.props li,.props p{color:#757575;font-size:.9em;font-weight:400;line-height:1.35em;margin:5px 0}.props li a,.props p a{font-weight:700}.errorTooltip{background-color:#c72e2e;border-radius:5px;color:#fff;display:none;padding:7px;position:absolute;top:49px;z-index:2;font-size:.8em}.errorTooltip.fixed{position:relative;top:0;margin-bottom:10px}.errorTooltipRequired{z-index:3}.validated .ng-invalid:focus~.errorTooltipRequired~.errorTooltipRuleSpecific,.validated .ng-invalid:focus~.errorTooltipRuleSpecific{display:block!important}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~.errorTooltipRuleSpecific,.validated .ignoreValidation input[type=checkbox].ng-invalid~.errorTooltipRuleSpecific,.validated .ng-invalid-required:focus~.errorTooltipRequired~.errorTooltipRuleSpecific,.validated .ng-invalid-required:focus~.errorTooltipRuleSpecific{display:none!important}.validated .ng-invalid-required:focus:not([type=checkbox])~.errorTooltipRequired,.validated input[type=checkbox].ng-invalid.hasErrorTooltipRuleSpecific:focus~.errorTooltipRuleSpecific,.validated input[type=checkbox].ng-invalid:focus:not(.hasErrorTooltipRuleSpecific)~.errorTooltipRequired{display:block!important}.validated input[type=checkbox].ng-invalid+.errorTooltipRequired+.errorTooltipRuleSpecific,.validated input[type=checkbox].ng-invalid+.errorTooltipRuleSpecific{top:35px;left:-20px}.validated .errorTooltip:empty{display:none!important}.backendError:focus~.errorTooltipRuleSpecific{display:block}.custom-select-container>select.backendError+span.custom-select>span,.inputField input.backendError,.validated .ng-invalid,.validated input.ng-invalid:active,.validated input.ng-invalid:focus,input.backendError{border:1px solid #c72e2e}.toolTip{display:none;font-size:.8em;color:#2c2e2f}.toolTip.balloon{position:absolute;z-index:2;padding:7px;text-align:left;border:1px solid #e1e7eb;border-radius:5px;background:#e1e7eb}.toolTip.displayInline{font-size:.9em;padding:10px 30px;font-size:.85em}.highZindexTooltip .toolTip.balloon{z-index:3}.left{left:0}.right{right:0}#notifications{position:relative}.aside #notifications{width:100%;box-sizing:border-box}.msgPage{padding:7px 0 8px;font-size:.85em}.msgPage ul{margin:0;padding-left:25px;list-style:none}.msgPage ul li{line-height:1.35em;margin:1px 8px}.msg-desc,.msg-error,.msg-info,.msg-success,.msg-warning{color:#c72e2e}.msg-desc .icon,.msg-error .icon,.msg-info .icon,.msg-success .icon,.msg-warning .icon{display:inline-block;width:21px;height:18px;position:absolute;left:0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-63px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.msg-desc .icon,.msg-error .icon,.msg-info .icon,.msg-success .icon,.msg-warning .icon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.msg-info{background-color:#636b6d;border:1px solid #636b6d;color:#fff}.msg-info .icon{background-position:-139px -22px;left:9px}.msg-warning .icon{background-position:-90px -22px;left:9px}.msg-warning,.msg-warning ul li{background-color:#ffad37;color:#5b3300;border:none}.msg-success{padding:5px;background-color:#8fcf8a;border:1px solid #8fcf8a;color:#295425}.msg-success .icon{background-position:-114px -22px;left:10px}.msg-desc{background-color:#fff;border:1px solid #e3e3e3;color:#636b6d}.msg-desc .icon{background-position:-139px -1px;left:9px}@media (max-width:30em) and (min-width:0){#notifications{width:100%}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.review #notifications{width:100%}}.languageToggleDisplay{text-decoration:none;font-size:15px;position:absolute;bottom:17px;right:0}.languageToggleDisplay .changeLanguage{display:inline-block;margin:5px 0 0 5px;width:12px;height:7px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-23px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.languageToggleDisplay .changeLanguage{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.languageToggleDisplay .changeLanguage.expand{background-position:-23px -10px}.languageToggleDisplay .displayText{margin-right:2px}.languageToggleDisplay a{cursor:pointer}.languageToggleDisplay a:focus,.languageToggleDisplay a:hover{outline:none;text-decoration:none;border-bottom:1px solid #0070ba;padding-bottom:4px}.footer .languageToggleDisplay{position:static;display:inline-block;font-size:13px}.footer .languageToggleDisplay span{position:relative}.footer .languageToggleDisplay #langDropdownBlock{right:0;margin-bottom:25px}@media (min-width:30.0625em) and (max-width:41.25em){.languageToggleDisplay .popover{left:auto;top:46px;right:3px}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.languageToggleDisplay .popover{left:auto;top:50px;right:-6px}}@media (min-width:41.3125em){.pageLogin .languageToggleEnabled .languageToggle.outside{display:block;position:relative;width:100%;max-width:780px;margin:10px auto 0}#login .languageToggle{display:block}}#langDropdownBlock{position:absolute;z-index:10;background:#fff;border:1px solid #ccc;border-radius:6px;margin-top:15px;right:-15px;min-width:100px;background-clip:padding-box;box-shadow:0 5px 10px rgba(0,0,0,.2);white-space:normal;text-align:left}#langDropdownBlock ul{list-style:outside none disc;margin:0;padding:9px 14px}#langDropdownBlock ul li{list-style-type:none;padding:5px 0;white-space:nowrap}#langDropdownBlock>.arrow,#langDropdownBlock>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}#langDropdownBlock>.arrow{border-width:11px}#langDropdownBlock>.arrow:after{border-width:10px;content:\"\"}#langDropdownBlock.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}#langDropdownBlock.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}#langDropdownBlock.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}#langDropdownBlock.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}#langDropdownBlock.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}#langDropdownBlock.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}#langDropdownBlock.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}#langDropdownBlock.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.cartContainer{float:left;display:block;width:184px}.formatCurrency{display:inline-block}.cartContainer .hasAmount .cartIcon{margin-right:6px}.cartContainer .hasAmount .pointer{right:57px}.transactionDetailsContainer{border-radius:5px 5px 0 0;background-clip:padding-box;-webkit-tap-highlight-color:rgba(0,0,0,.2)}.transactionDetailsContainer.cart #transactionCart{border-bottom:0 none;border-color:#ddd #ddd -moz-use-text-color}.transactionDetailsContainer.cart #transactionCart .arrow{background-position:-23px -10px}.transactionDetailsContainer.cart .transctionCartDetails{visibility:visible}.transactionDetailsContainer .merchantName{width:calc(92% - 36px);padding:15px 15px 10px;line-height:1.35em;font-size:13px;margin-top:0;margin-bottom:0}.transactionDetailsContainer .merchantTitle{margin-bottom:-3px}.transactionDetailsContainer .note{color:#6c7378;font-size:12px;line-height:1.35em;padding:0 15px 1em;margin-bottom:0;text-overflow:ellipsis;overflow:hidden}.transactionDetailsContainer .note.noteHighlighted{font-size:13px;padding-top:10px;padding-bottom:10px;color:#6c7378;background-color:#f1f4f5;border-radius:0 0 5px 5px;background-clip:padding-box}.transactionDetails{display:block;padding-right:1px;margin:0 auto;overflow:auto;color:#393f44}.transactionDetails:focus,.transactionDetails:hover{text-decoration:none;background-image:none;color:#6c7378;overflow:visible}.transactionDetails:focus .totalWrapper,.transactionDetails:hover .totalWrapper{overflow:visible}.transactionDetails:focus .totalWrapper #transactionCart,.transactionDetails:hover .totalWrapper #transactionCart{border-bottom:1px solid #2c2e2f;margin-bottom:-1px}.transactionDetails:active{background-image:none}.transactionDetails:active #yourCart{background-position:5px -95px}#transactionCart.hasItems:focus,#transactionCart.hasItems:hover{-webkit-opacity:.7;-moz-opacity:.7;opacity:.7;filter:alpha(opacity=70)}.totalWrapper{display:block;overflow:auto}.hasNoItems .totalWrapper{background-image:none}#yourCart{float:left;left:0}#transactionCart{float:right;z-index:1;padding:8px 0 0;margin-bottom:0;border-bottom:0;-ms-box-sizing:border-box;box-sizing:border-box;border-color:#ddd;font-size:1em;font-weight:700;text-align:right;color:#2c2e2f;text-shadow:1px 1px 1px #fff;background-size:24px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#transactionCart:active{background-position:right -290px}#transactionCart .cartIcon{display:inline-block;width:15px;height:14px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#transactionCart .cartIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#transactionCart .arrow{display:inline-block;margin:5px 0 0 5px;width:12px;height:10px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-23px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#transactionCart .arrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#transactionCart span{vertical-align:middle}#transactionCart format-currency span{vertical-align:inherit}#transactionCart format-currency span .currencyCode{font-size:1em}@-moz-document url-prefix(){#transactionCart .cartIcon{margin-top:-2px}}.transctionCartDetails{position:relative;overflow:hidden;visibility:hidden;padding-bottom:0;-webkit-transition:max-height .7s ease;transition:max-height .7s ease}.transctionCartDetails .pointer{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_flyoutArrow_up_2x.png\") no-repeat scroll 0 0 transparent;height:10px;position:absolute;right:38px;top:0;width:34px}.details{-ms-box-sizing:border-box;box-sizing:border-box;background:#fff;border-radius:5px;background-clip:padding-box;box-shadow:1px 1px 1px 0 #ccc;max-height:450px}.details ul{list-style-type:none;margin:0;font-size:.85em;background-color:#f1f4f5}.details ul.detail-items>li{padding-top:0;padding-bottom:10px;min-height:0}.details ul.itemDetails{width:100%;font-size:1em;max-height:none;margin:0;padding:0}.details ul.itemDetails>li{padding:0;color:#6c7378;border:none;line-height:16px;margin:10px 0 0}.details ul.itemDetails>li .item-selections{font-size:13px}.details ul.itemDetails>li .item-selection-name{font-weight:700}.details ul.itemDetails>li .item-selection-value{padding-right:1em}.details li{margin:0;padding:5px 15px;overflow:auto;line-height:16px;border-bottom:1px solid #ccc}.details li:last-of-type{border-bottom:none}.details li.actions{margin:15px;padding:10px 1px 10px 15px;border-top:1px solid #ccc;border-radius:0 0 5px 5px;background-clip:padding-box;text-align:right}.details a.less,.details a.more{cursor:pointer}.details a.more{display:inline-block;float:right}.details a.more.inline-more{display:inline;float:none}.details ul.detail-extras{border-top:1px solid #ccc;padding-top:10px;padding-bottom:15px}.details ul.detail-extras .itemNameContainer,.details ul.detail-extras .itemPrice{margin-top:5px}.details ul.detail-extras li{overflow:hidden;line-height:normal;border-bottom:0;padding-top:0;padding-bottom:0}.details div.subTotal{font-size:.85em;background-color:#f1f4f5;padding:5px 15px 15px;margin-top:0;font-weight:700;border-top:1px solid #ccc;height:auto;line-height:1;border-radius:0 0 5px 5px;background-clip:padding-box}.scrollable-middle{overflow:auto}.notes{font-weight:400;margin-top:3px;line-height:100%;width:100%;overflow:hidden;min-height:1em;white-space:nowrap;text-overflow:ellipsis}.itemNameContainer{display:inline-block;width:60%;min-height:1em;vertical-align:top;margin-top:10px}.itemName{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:block;margin-bottom:0}.expanded .itemName{text-overflow:clip;line-height:16px;white-space:normal}.itemPrice{margin-top:10px;width:38%;overflow:hidden;font-size:1em;text-align:right;white-space:nowrap;text-overflow:ellipsis;-webkit-font-feature-settings:\"tnum\";display:inline-block;vertical-align:top}.currencyCode{float:left;margin-top:5px;font-size:.8em;text-align:right;float:none}#transactionDetails.cart .hasNoItems,.hasNoItems.transactionDetails,.hasNoItems.transactionDetails:active,.hasNoItems.transactionDetails:focus{float:right;background:none;border:none;box-shadow:none;cursor:default}#transactionDetails.cart .hasNoItems #yourCart,.hasNoItems.transactionDetails #yourCart,.hasNoItems.transactionDetails:active #yourCart,.hasNoItems.transactionDetails:focus #yourCart{display:none}#transactionDetails.cart .hasNoItems #transactionCart,.hasNoItems.transactionDetails #transactionCart,.hasNoItems.transactionDetails:active #transactionCart,.hasNoItems.transactionDetails:focus #transactionCart{padding:8px 0 0 30px;width:auto}#transactionDetails.cart .hasNoItems #transactionCart .arrow,.hasNoItems.transactionDetails #transactionCart .arrow,.hasNoItems.transactionDetails:active #transactionCart .arrow,.hasNoItems.transactionDetails:focus #transactionCart .arrow{display:none}#transactionDetails.cart .hasNoItems #transactionCart:focus,#transactionDetails.cart .hasNoItems #transactionCart:hover,.hasNoItems.transactionDetails #transactionCart:focus,.hasNoItems.transactionDetails #transactionCart:hover,.hasNoItems.transactionDetails:active #transactionCart:focus,.hasNoItems.transactionDetails:active #transactionCart:hover,.hasNoItems.transactionDetails:focus #transactionCart:focus,.hasNoItems.transactionDetails:focus #transactionCart:hover{text-decoration:none;background-image:none;color:#393f44}#transactionDetails.cart .hasNoItems #transactionCart .cartIcon,.hasNoItems.transactionDetails #transactionCart .cartIcon,.hasNoItems.transactionDetails:active #transactionCart .cartIcon,.hasNoItems.transactionDetails:focus #transactionCart .cartIcon{background-position:0 0}#closeCart{position:static;float:right;width:10px;height:10px;margin:15px 15px 0 0;padding:5px;border-radius:3px;cursor:pointer}#closeCart:before{content:\"\";position:absolute;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-44px 0;width:10px;height:11px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#closeCart:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#closeCart:focus:before,#closeCart:hover:before{background-position:-44px -15px}.largeScreen .transactionDetails{float:right;margin:0}.largeScreen #transactionDetails{position:relative}.largeScreen #transactionDetails .transctionCartDetails{clear:both}.cartContainer{float:right}.transctionCartDetails{position:absolute;right:43.42553193%;width:320px}.paypalCredit .transctionCartDetails{right:0}.details{margin:10px;box-shadow:0 1px 4px 1px rgba(0,0,0,.3);-webkit-box-shadow:0 1px 2px 1px rgba(0,0,0,.3);-moz-box-shadow:0 1px 2px 1px rgba(0,0,0,.3);list-style-type:none}@media (max-width:41.3125em){.cartContainer{display:block;position:absolute;right:15px;top:10px;z-index:151;width:160px}.minibrowser .cartContainer{right:0}.transctionCartDetails{left:auto;right:0;width:320px}.cartVerB header .cartContainer{display:block}.cartVerB #main .cartContainer{display:none}.incontext .paypalHeaderWrapper .cartContainer{right:35px;top:12px;margin-top:10px;margin-right:41px}.incontext .paypalHeaderWrapper .transctionCartDetails{width:350px}.incontext .cartContainer.hidePayPalLogo{right:214px}.incontext .viewTypeOnePage .hidePayPalLogo .transctionCartDetails{left:-15px}.incontext .viewTypeOnePage .hidePayPalLogo .transctionCartDetails .pointer{right:300px}}@media (min-width:0) and (max-width:30em){.cartContainer{right:0;top:15px}#closeCart{right:20px}.transactionDetails{padding-right:0}}.modal-wrapper .modal-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:#000;opacity:.8;z-index:150}.modal-wrapper .modal-dialog{overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal-wrapper .modal-content{display:block;position:absolute;left:50%;top:45%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.modal-wrapper .modal-default{height:auto;width:200px;padding:30px;background-color:#fff;background-clip:padding-box}.modal-wrapper .modal-default .close{position:absolute;top:15px;right:20px;width:19px;height:19px;padding:0;font-size:0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.modal-wrapper .modal-default .close{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.modal-wrapper .modal-default .close:focus,.modal-wrapper .modal-default .close:hover{background-position:-223px -22px;text-decoration:none}.modal-wrapper .popLink{word-break:break-all;font-size:.8em}@font-face{font-family:consumer-icons;src:url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-3-0/fonts/ConsumerIcons-Regular.eot\");src:url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-3-0/fonts/ConsumerIcons-Regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-3-0/fonts/ConsumerIcons-Regular.woff\") format(\"woff\"),url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-3-0/fonts/ConsumerIcons-Regular.ttf\") format(\"truetype\"),url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-3-0/fonts/ConsumerIcons-Regular.svg#69ac2c9fc1e0803e59e06e93859bed03\") format(\"svg\");font-style:normal;font-weight:400}.icon{font-family:consumer-icons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-small:before{font-size:1.58rem}.icon-medium:before{font-size:2.6rem}.icon-large:before{font-size:7.8rem}.icon-burger-small:before{content:\"\\E000\"}.icon-slider-small:before{content:\"\\E001\"}.icon-slider-half-small:before{content:\"\\E002\"}.icon-close-small:before{content:\"\\E003\"}.icon-add-small:before{content:\"\\E004\"}.icon-arrow-down-small:before{content:\"\\E005\"}.icon-arrow-up-small:before{content:\"\\E006\"}.icon-arrow-left-small:before{content:\"\\E007\"}.icon-arrow-right-small:before{content:\"\\E008\"}.icon-arrow-down-half-small:before{content:\"\\E009\"}.icon-arrow-up-half-small:before{content:\"\\E010\"}.icon-arrow-left-half-small:before{content:\"\\E011\"}.icon-arrow-right-half-small:before{content:\"\\E012\"}.icon-clear-half-small:before{content:\"\\E013\"}.icon-checkmark-small:before{content:\"\\E014\"}.icon-checkmark-small-bold:before{content:\"\\E015\"}.icon-action-arrow-half-small:before{content:\"\\E016\"}.icon-tooltip-outline-small:before{content:\"\\E017\"}.icon-tooltip-small:before{content:\"\\E018\"}.icon-info-small:before{content:\"\\E019\"}.icon-positive-small:before{content:\"\\E020\"}.icon-attention-small:before{content:\"\\E021\"}.icon-critical-small:before{content:\"\\E022\"}.icon-info-large:before{content:\"\\E023\"}.icon-positive-large:before{content:\"\\E024\"}.icon-attention-large:before{content:\"\\E025\"}.icon-critical-large:before{content:\"\\E026\"}.icon-pp-logo:before{content:\"\\E029\"}.icon-visa-logo:before{content:\"\\E030\"}.icon-mastercard-logo:before{content:\"\\E031\"}.icon-maestro-logo:before{content:\"\\E032\"}.icon-amex-logo:before{content:\"\\E033\"}.icon-discover-logo:before{content:\"\\E034\"}.icon-card-half-solid:before{content:\"\\E035\"}.icon-bank-half-solid:before{content:\"\\E036\"}.icon-profile-large:before{content:\"\\E037\"}.icon-profile-add-large:before{content:\"\\E038\"}.icon-notification-small:before{content:\"\\E039\"}.icon-settings-small:before{content:\"\\E040\"}.icon-profile-small:before{content:\"\\E041\"}.icon-funnel-small:before{content:\"\\E042\"}.icon-delete-small:before{content:\"\\E043\"}.icon-edit-small:before{content:\"\\E044\"}.icon-lock-small:before{content:\"\\E045\"}.icon-pdf-small:before{content:\"\\E046\"}.icon-contact-small:before{content:\"\\E047\"}.icon-undo-small:before{content:\"\\E048\"}.icon-cancel-small:before{content:\"\\E049\"}.icon-simple-list-small:before{content:\"\\E050\"}.icon-detailed-list-small:before{content:\"\\E051\"}.icon-print-small:before{content:\"\\E052\"}.icon-camera-small:before{content:\"\\E053\"}.icon-info-outline-small:before{content:\"\\E054\"}.icon-us-dollar-outline-small:before{content:\"\\E055\"}.icon-calendar-half-small:before{content:\"\\E056\"}.icon-hiper-logo:before{content:\"\\E057\"}.icon-hipercard-logo:before{content:\"\\E058\"}.icon-elo-logo:before{content:\"\\E059\"}.icon-star-small:before{content:\"\\E060\"}.icon-jcb-logo:before{content:\"\\E061\"}.icon-attention-outline-small:before{content:\"\\E062\"}.icon-unionpay-logo:before{content:\"\\E063\"}.icon-search-small:before{content:\"\\E064\"}.icon-desktop-small:before{content:\"\\E065\"}.icon-mobile-small:before{content:\"\\E066\"}.icon-laptop-small:before{content:\"\\E067\"}.icon-tablet-small:before{content:\"\\E068\"}.icon-send-money:before{content:\"\\E500\"}.icon-request-money:before{content:\"\\E501\"}.icon-photo:before{content:\"\\E502\"}.icon-gift-cards:before{content:\"\\E503\"}.icon-credit-card:before{content:\"\\E504\"}.icon-truck:before{content:\"\\E505\"}.icon-email:before{content:\"\\E506\"}.icon-email-solid:before{content:\"\\E507\"}.icon-bank-check:before{content:\"\\E508\"}.icon-calendar:before{content:\"\\E509\"}.icon-holiday:before{content:\"\\E510\"}.icon-gift:before{content:\"\\E511\"}.icon-wallet:before{content:\"\\E512\"}.icon-play-video:before{content:\"\\E513\"}.icon-heart:before{content:\"\\E514\"}.icon-shield:before{content:\"\\E515\"}.icon-tunes:before{content:\"\\E516\"}.icon-invoice:before{content:\"\\E517\"}.icon-shopping-bag:before{content:\"\\E518\"}.icon-phone:before{content:\"\\E519\"}.icon-phone-solid:before{content:\"\\E520\"}.icon-tag:before{content:\"\\E521\"}.icon-delivery:before{content:\"\\E522\"}.icon-questionmark:before{content:\"\\E523\"}.icon-cut-coupons:before{content:\"\\E524\"}.icon-register:before{content:\"\\E525\"}.icon-house:before{content:\"\\E526\"}.icon-gift-card:before{content:\"\\E527\"}.icon-messages:before{content:\"\\E528\"}.icon-add-money:before{content:\"\\E529\"}.icon-send-check:before{content:\"\\E530\"}.icon-paypal-me:before{content:\"\\E531\"}.icon-pp-logo-outline:before{content:\"\\E532\"}.icon-money-bag:before{content:\"\\E533\"}.icon-chip-pin:before{content:\"\\E534\"}.icon-boleto-ready:before{content:\"\\E535\"}.icon-boleto-topup:before{content:\"\\E536\"}.icon-clock-pay:before{content:\"\\E537\"}.icon-speeding-cart:before{content:\"\\E538\"}.icon-international-transfer:before{content:\"\\E539\"}.fiIconsGroup .cardIconsGroup{border-radius:4px;padding:10px 13px;height:20px;margin-bottom:10px}.fiIconsGroup .cardIconsGroup .cardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_2x.png\") no-repeat 0 100px;background-size:31px;height:20px;float:left;width:32px;padding:0 4px 0 0}.fiIconsGroup .cardIconsGroup .cardIcon.ELO{background-position:0 -713px}.fiIconsGroup .cardIconsGroup .cardIcon.CUP{background-position:0 -837px}.fiIconsGroup .cardIconsGroup .cardIcon.VISA{background-position:0 -31px}.fiIconsGroup .cardIconsGroup .cardIcon.MASTERCARD{background-position:0 -62px}.fiIconsGroup .cardIconsGroup .cardIcon.HIPER{background-position:0 -682px}.fiIconsGroup .cardIconsGroup .cardIcon.HIPERCARD{background-position:0 -744px}.fiIconsGroup .cardIconsGroup .cardIcon.AMEX{background-position:0 -93px;margin-right:-10px}.fiIconsGroup .cardIconsGroup .cardIcon.JCB{background-position:0 -527px}.fiIconsGroup .cardIconsGroup .cardIcon.ELECTRON{background-position:0 -217px}.fiIconsGroup .cardIconsGroup .cardIcon.MAESTRO,.fiIconsGroup .cardIconsGroup .cardIcon.SWITCH{background-position:0 -248px}.fiIconsGroup .cardIconsGroup .cardIcon.DISCOVER{background-position:0 -124px}.fiIconsGroup .cardIconsGroup .cardIcon.CBNATIONALE{background-position:0 -310px}.fiIconsGroup .cardIconsGroup .cardIcon.CETELEM{background-position:0 -465px}.fiIconsGroup .cardIconsGroup .cardIcon.COFIDIS{background-position:0 -651px;margin-right:-10px}.fiIconsGroup .cardIconsGroup .cardIcon.COFINOGA{background-position:0 -341px}.fiIconsGroup .cardIconsGroup .cardIconVISA.QIWI{background-position:0 -806px;width:30px}.onboardingSection .fiIconsGroup .cardIconsGroup{display:flex;justify-content:center;padding:0;margin-bottom:12px}.marketingOffers{text-align:center}.marketingOffers .prop-img{background-size:contain;background-repeat:no-repeat}.marketingOffers li,.marketingOffers p{color:#757575;font-size:.9em;font-weight:400;line-height:1.35em;margin:5px 0}.marketingOffers li a,.marketingOffers p a{font-weight:700}@media (min-width:42em){.mobileApp header{display:none}.mobileApp #wrapper{margin:0;max-width:inherit;width:100%}.mobileApp .paypalHeader{width:100%}.mobileApp .footer{max-width:inherit}.mobileApp section .row-fluid .span14{width:100%}.mobileApp .feedback,.mobileApp section .row-fluid .span10{display:none}}@keyframes pulse{0%{transform:scale(1);-webkit-transform:scale(1)}50%{transform:scale(1.1);-webkit-transform:scale(1.1)}to{transform:scale(1);-webkit-transform:scale(1)}}@-webkit-keyframes pulse{0%{transform:scale(1);-webkit-transform:scale(1)}50%{transform:scale(1.1);-webkit-transform:scale(1.1)}to{transform:scale(1);-webkit-transform:scale(1)}}.pulseAnimation{animation-name:pulse;animation-duration:1s;animation-iteration-count:1;animation-delay:0s;-webkit-animation-name:pulse;-webkit-animation-duration:1s;-webkit-animation-iteration-count:1;-webkit-animation-delay:0s}@keyframes shake{0%,to{-webkit-transform:translateX(0);transform:translateX(0)}10%,30%,50%,70%,90%{-webkit-transform:translateX(-10px);transform:translateX(-10px)}20%,40%,60%,80%{-webkit-transform:translateX(10px);transform:translateX(10px)}}@-webkit-keyframes shake{0%,to{-webkit-transform:translateX(0);transform:translateX(0)}10%,30%,50%,70%,90%{-webkit-transform:translateX(-10px);transform:translateX(-10px)}20%,40%,60%,80%{-webkit-transform:translateX(10px);transform:translateX(10px)}}.shakeAnimation{animation-name:shake;animation-duration:1s;animation-iteration-count:1;animation-delay:0s;-webkit-animation-name:shake;-webkit-animation-duration:1s;-webkit-animation-iteration-count:1;-webkit-animation-delay:0s}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 33px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1182px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.error .custom-select.active>span,.error .custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.framed ul.footerLinks:before{width:12px;height:12px;margin:3px 10px 10px 0;display:block;float:left;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;content:\"\"}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.framed ul.footerLinks:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.framed .btn.escapeHatch{width:22px;height:20px;border:0;margin-left:0;display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:200px;background-position:-151px -35px;background-color:transparent;cursor:pointer}.framed #closeButton{width:11px;height:14px;padding:0;position:absolute;top:29px;right:20px;display:block;z-index:5;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-44px 1px;-webkit-tap-highlight-color:rgba(0,0,0,.2);text-indent:-999em;overflow:hidden}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.framed #closeButton{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.framed .paypalHeaderWrapper .cartContainer{margin-top:10px;margin-right:35px}@media (max-width:30em) and (min-width:0){.framed .DE footerLinks,.framed .footerLinks,.framed .fr.FR .footerLinks{width:45%}.framed .paypalHeaderWrapper .paypalHeader{padding-bottom:15px}.framed .paypalHeaderWrapper .cartContainer{margin-top:10px;margin-right:35px}.framed .paypalHeaderWrapper .logo{margin:18px 0 0}.framed .footer{padding:5px 22px}.framed .secureIcon{display:none}}@media (max-width:41.3125em){.framed .paypalHeaderWrapper .cartContainer{margin-top:10px;margin-right:35px}}[dir=rtl]{direction:rtl;unicode-bidi:embed}[dir=rtl] .ltrOverride{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] .row-fluid>[class*=span]{float:right}[dir=rtl] .row-fluid>.span10{float:left;margin-left:0}[dir=rtl] .paypalHeaderWrapper .logo{float:right;margin-right:5px}[dir=rtl] .fieldGroup.name .inputField.last-child{margin-right:3.7%}[dir=rtl] .fieldGroup.name .inputField:not(.last-child){float:right;margin-right:0}[dir=rtl] input::-webkit-input-placeholder{direction:rtl}[dir=rtl] input:-moz-placeholder,[dir=rtl] input::-moz-placeholder{direction:rtl;text-align:right}[dir=rtl] input:-ms-input-placeholder{direction:rtl}[dir=rtl] .msg-desc .icon,[dir=rtl] .msg-error .icon,[dir=rtl] .msg-info .icon,[dir=rtl] .msg-success .icon,[dir=rtl] .msg-warning .icon{left:auto;right:0}[dir=rtl] .msgPage ul{padding:0 25px 0 0}[dir=rtl] .merchantHeader .merchantName{text-align:right}[dir=rtl] .cartContainer{float:left;right:auto;left:0;margin-left:0}[dir=rtl] #transactionCart{float:left}[dir=rtl] #transactionCart .arrow{margin:5px 5px 0 0}[dir=rtl] #transactionCart .cartIcon{margin:0 0 0 6px}[dir=rtl] #transactionDetails.cart .hasNoItems #transactionCart,[dir=rtl] .hasNoItems.transactionDetails #transactionCart,[dir=rtl] .hasNoItems.transactionDetails:active #transactionCart,[dir=rtl] .hasNoItems.transactionDetails:focus #transactionCart{background-position:right 9px;padding-right:27px;padding-left:0}[dir=rtl] .transctionCartDetails{left:43.42553193%;right:auto}[dir=rtl] .transctionCartDetails .pointer{right:auto;left:38px}[dir=rtl] .transctionCartDetails .detail-extras .amounts .itemName,[dir=rtl] .transctionCartDetails .detail-extras .amounts .itemPrice,[dir=rtl] .transctionCartDetails .detail-items .items .itemName,[dir=rtl] .transctionCartDetails .detail-items .items .itemPrice,[dir=rtl] .transctionCartDetails .subTotal .itemName,[dir=rtl] .transctionCartDetails .subTotal .itemPrice{text-align:right}[dir=rtl] .cartContainer .hasAmount .pointer{right:auto;left:57px}[dir=rtl] .emailField input,[dir=rtl] .passwordField input{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] .checkbox input[type=checkbox]~label{padding-left:0;background-position:right 0;margin-right:-5px;padding-right:40px}[dir=rtl] .checkbox.error input[type=checkbox]:focus~label,[dir=rtl] .checkbox.error input[type=checkbox]~label{background-position:right -600px}[dir=rtl] .checkbox input[type=checkbox]:checked~label{background-position:right -400px}[dir=rtl] .checkbox input[type=checkbox]:focus:checked~label{background-position:right -4801px}[dir=rtl] .checkbox input[type=checkbox]:focus~label{background-position:right -4601px}[dir=rtl] .validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,[dir=rtl] .validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:right 0}[dir=rtl] .validated input[type=checkbox].ng-invalid~label{background-position:right -600px}[dir=rtl] .validated input[type=radio].ng-invalid+label,[dir=rtl] .validated input[type=radio].ng-invalid:focus+label{background-position:right -2200px}[dir=rtl] .sCheckbox.checkbox input[type=checkbox]~label{background-position:right -2600px}[dir=rtl] .sCheckbox.checkbox.error input[type=checkbox]:focus~label,[dir=rtl] .sCheckbox.checkbox.error input[type=checkbox]~label{background-position:right -3200px}[dir=rtl] .sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:right -3000px}[dir=rtl] .sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:right -5409px}[dir=rtl] .sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:right -2800px}[dir=rtl] .radioButton input[type=radio]~label{padding-left:0;background-position:right -1600px;margin-right:-5px;padding-right:40px}[dir=rtl] .radioButton.error input[type=radio]+label,[dir=rtl] .radioButton.error input[type=radio]:focus+label{background-position:right -2200px}[dir=rtl] .radioButton.warning input[type=radio]+label,[dir=rtl] .radioButton.warning input[type=radio]:focus+label{background-position:right -7405px}[dir=rtl] .radioButton input[type=radio]:checked+label{background-position:right -2000px}[dir=rtl] .radioButton input[type=radio]:focus:checked+label{background-position:right -6010px}[dir=rtl] .radioButton input[type=radio]:focus+label{background-position:right -1800px}[dir=rtl] .inputField label{text-align:right}[dir=rtl] .dropdown.billingAddress a{float:left}[dir=rtl] .allFundingInstrumentsList li .fsIcon{margin:18px 15px 0 10px}[dir=rtl] .allPlanList li .fsIcon{margin:2px 10px 0;padding:0}[dir=rtl] .allPlanList li .fsdetails{width:228px;padding:0}[dir=rtl] .validated select.backendError+.custom-select>span,[dir=rtl] .validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat left 10px center;background-size:18px}[dir=rtl] .validated div.inputField:not(.ltrOverride).error input,[dir=rtl] .validated div.inputField:not(.ltrOverride) input.backendError,[dir=rtl] .validated div.inputField:not(.ltrOverride) input.ng-invalid{background-size:18px;background-position:10px;padding:0 14px 0 29px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){[dir=rtl] .inputField.error input,[dir=rtl] .validated .inputField input.backendError,[dir=rtl] .validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat 98% left;background-size:18px;background-position:10px}[dir=rtl] .validated select.backendError+.custom-select>span,[dir=rtl] .validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat left 10px center;background-size:18px}}[dir=rtl] .fsIcons{padding-right:0;float:right;margin-left:10px}[dir=rtl] div.inputField:not(.ltrOverride) .inputField input{padding-right:10px}[dir=rtl] div.inputField:not(.ltrOverride) #securityCode.creditCard,[dir=rtl] div.inputField:not(.ltrOverride) .ccard,[dir=rtl] div.inputField:not(.ltrOverride) .creditCardField .creditCard{left:10px;right:inherit}[dir=rtl] .verifyHelp{text-indent:100%;white-space:nowrap;overflow:hidden}[dir=rtl] .toolTip.balloon{text-align:right;top:125px}[dir=rtl] #payUponInvoice .edits{padding:7px 10px 4px 0}[dir=rtl] .cardType.split{float:left}[dir=rtl] .creditCardField.split,[dir=rtl] div#phoneTypeSelection{float:right}[dir=rtl] .custom-select>span{background-position:left 5px top -1182px;padding:7px 13px 7px 30px}[dir=rtl] .error .custom-select.active>span,[dir=rtl] .error .custom-select>span{background-position:left 10px center}[dir=rtl] .emailHelper{left:10px;right:inherit}[dir=rtl] .footer .languageToggleDisplay #langDropdownBlock{right:-50px;left:5px}[dir=rtl] .footer .languageToggleDisplay #langDropdownBlock.bottom>.arrow:after{margin-left:0;margin-right:-10px}[dir=rtl] .footer .languageToggleDisplay .changeLanguage{margin:5px 5px 0 0}[dir=rtl] .footer .cancelUrl{float:right}[dir=rtl] .footer .footerWrapper{float:left;text-align:left}[dir=rtl] .footer .footerWrapper .footerLinks{float:none;background-position:100%;padding-right:0;width:auto}[dir=rtl] .footer .footerWrapper .footerLinks li{padding-right:0;padding-left:12px}[dir=rtl] .footer .footerWrapper .copyright{width:auto;padding-right:10px}[dir=rtl] .paywith .method{float:right}[dir=rtl] .paywith .method .name{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] .paywith .method .forceRTL{direction:rtl;unicode-bidi:normal}[dir=rtl] .paywith .methodAmount{float:left}[dir=rtl] .paywith .conversion,[dir=rtl] .paywith .methodAmount .currencyCode{text-align:left}[dir=rtl] .paywith #currencyConversion a{unicode-bidi:embed}[dir=rtl] .paywith .ltrOverride{unicode-bidi:normal!important}[dir=rtl] .paywith .billingTxt{text-align:right}[dir=rtl] #paymentMethod .edits,[dir=rtl] #shippingAddress .edits{right:auto;left:0}[dir=rtl] .sidebar{left:0;right:-357px}[dir=rtl] .trayOpen #main{margin-left:-327px}[dir=rtl] #disclaimerWithBmlCta span{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] #main{float:left;margin-right:0}[dir=rtl] .trayOpen .maskMember .trayViewMask{left:38px}[dir=rtl] #selectFunding .checkIcon,[dir=rtl] #selectFunding .infoIcon,[dir=rtl] #selectShipping .checkIcon,[dir=rtl] #selectShipping .infoIcon{left:15px;right:auto}[dir=rtl] #currencyConversion a,[dir=rtl] .currencyConversion .conversion{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] #manageFunding .fsIcon,[dir=rtl] #selectFunding .fsIcon{float:right}[dir=rtl] #manageFunding .BANK .lastdigits,[dir=rtl] #manageFunding .CARD .lastdigits,[dir=rtl] #selectFunding .BANK .lastdigits,[dir=rtl] #selectFunding .CARD .lastdigits{direction:ltr;unicode-bidi:bidi-override;float:right}[dir=rtl] #manageFunding .BANK .fsName,[dir=rtl] #manageFunding .CARD .fsName,[dir=rtl] #selectFunding .BANK .fsName,[dir=rtl] #selectFunding .CARD .fsName{padding-right:5px}[dir=rtl] #manageFunding .BANK .amount,[dir=rtl] #manageFunding .BANK .colon,[dir=rtl] #manageFunding .CARD .amount,[dir=rtl] #manageFunding .CARD .colon,[dir=rtl] #selectFunding .BANK .amount,[dir=rtl] #selectFunding .BANK .colon,[dir=rtl] #selectFunding .CARD .amount,[dir=rtl] #selectFunding .CARD .colon{direction:rtl}[dir=rtl] #manageFunding .BALANCE .fsName,[dir=rtl] #selectFunding .BALANCE .fsName{direction:ltr;unicode-bidi:bidi-override;float:right}[dir=rtl] #manageFunding .BALANCE .amount,[dir=rtl] #manageFunding .BALANCE .colon,[dir=rtl] #selectFunding .BALANCE .amount,[dir=rtl] #selectFunding .BALANCE .colon{direction:rtl}[dir=rtl] #closeCart{float:left;margin:15px 0 0 15px}[dir=rtl] .languageToggleDisplay{left:0;right:auto}[dir=rtl] .languageToggleDisplay .displayText{margin-right:0}[dir=rtl] .languageToggleDisplay .changeLanguage{margin:5px 10px 0 0}[dir=rtl] .aside .close{left:10px;right:auto}[dir=rtl] .aside .backArrow{right:10px}[dir=rtl] .aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -256px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){[dir=rtl] .aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}[dir=rtl] .aside .backArrow:focus:before,[dir=rtl] .aside .backArrow:hover:before{background-position:-232px -278px}[dir=rtl] .right{left:0;float:left}[dir=rtl] .left{float:right}[dir=rtl] #selectShipping .subHeader .rightIcon,[dir=rtl] .subHeader .rightIcon{float:left!important;margin:4px 6px 0 0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-200px -220px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){[dir=rtl] #selectShipping .subHeader .rightIcon,[dir=rtl] .subHeader .rightIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}[dir=rtl] #selectShipping .subHeader .rightIcon:focus,[dir=rtl] #selectShipping .subHeader .rightIcon:hover,[dir=rtl] .subHeader .rightIcon:focus,[dir=rtl] .subHeader .rightIcon:hover{background-position:-200px -235px}[dir=rtl] #selectShipping .subHeader .leftIcon,[dir=rtl] .subHeader .leftIcon{float:right!important;margin:4px 0 0 6px}[dir=rtl] #addCard .addNewBillingAddress{float:left}[dir=rtl] .creditCardInput .cardIcon,[dir=rtl] .creditCardInput .expirationField{float:right}[dir=rtl] .creditCardInput .cvvField{float:left}[dir=rtl] .inputField.noFloatingLabel label{right:14px;left:auto;text-align:right}[dir=rtl] .tipCreditCard{direction:rtl}[dir=rtl] .addressDisplay .adr .adr-break{float:right;margin-left:5px}[dir=rtl] .BALANCE .fsName,[dir=rtl] .fsDetails .fsName{direction:rtl!important;unicode-bidi:normal!important}[dir=rtl] #manageFunding .manageLinks{position:absolute;top:25px;left:0;right:auto}[dir=rtl] #manageFunding .manageLinks .updateButton{padding:0 0 0 10px}[dir=rtl] #manageFunding .manageLinks .deleteButton{padding:0 10px 0 15px}[dir=rtl] #manageFunding .infoIcon{right:auto;left:15px}[dir=rtl] #manageFunding .confirm{left:0;right:auto;transform:translate(-100%)}[dir=rtl] #manageFunding .slideIn{transform:translate(0)}[dir=rtl] #manageFunding .slide{transform:translate(6%)}[dir=rtl] #deleteShipping .delete{left:0;right:auto;-webkit-transform:translate(0);transform:translate(0)}[dir=rtl] #deleteShipping .delete.slideOut{-webkit-transform:translate(-102%);transform:translate(-102%)}[dir=rtl] #deleteShipping .msgIcon{right:auto;left:15px}[dir=rtl] #deleteShipping .slide{transform:translate(15%)}[dir=rtl] #deleteShipping .confirm{-webkit-transform:translate(-102%);transform:translate(-102%)}[dir=rtl] #deleteShipping .confirm.slidein{-webkit-transform:translate(0);transform:translate(0)}[dir=rtl] .overlayWrapper{right:auto}[dir=rtl] #langDropdownBlock{left:-15px;right:auto}[dir=rtl] #langDropdownBlock.bottom>.arrow:after{margin:0 -10px 0 0}[dir=rtl] #shippingAddress .frontArrow,[dir=rtl] .paywith .frontArrow{left:0;right:auto;background-position:-200px -216px}[dir=rtl] .footer .footerWrapper .copyright{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] .footer .footerWrapper .copyright .secureIcon{float:left;margin:3px 8px 0 0}[dir=rtl][lang=ar] .footer .footerWrapper .copyright{unicode-bidi:inherit;direction:rtl}@media (max-width:41.25em){[dir=rtl] .trayOpen .sidebar{right:-327px}[dir=rtl] .trayOpen .maskMember .trayViewMask{left:32px}[dir=rtl] .footer .footerWrapper .footerLinks{float:right;width:50%;text-align:right}[dir=rtl] .footer .footerWrapper .footerLinks li{padding-left:0;margin-left:10px;margin-right:0}[dir=rtl] .footer .footerWrapper .copyright{float:left}[dir=rtl] .transctionCartDetails{left:0;right:auto;width:320px}}@media (max-width:30em) and (min-width:0){[dir=rtl] .footer li{margin-right:0}[dir=rtl] .footer .footerWrapper .footerLinks{width:48%;padding-right:0}}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/css-loader/lib/css-base.js":
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },

/***/ "../node_modules/style-loader/addStyles.js":
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },

/***/ "./components/xo-beaver/dist/logger.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/xo-beaver/dist/level.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('beaver', ['beaver.level']).factory('$Logger', function ($injector, $http, $window, $interval, $timeout, $log, $q, $rootScope, $logLevel, $consoleLogLevel) {
	
	        var logger = {};
	        var HERMES_DEV_COOKIE = 'hermesdev';
	
	        angular.forEach($logLevel, function (level) {
	            logger[level] = function (event, payload, settings) {
	                return this.log(level, event, payload, settings);
	            };
	        });
	
	        var hostname = $window.location && $window.location.hostname || '';
	
	        var uniqueEvents = [];
	
	        angular.extend(logger, {
	
	            autoLog: [$logLevel.WARNING, $logLevel.ERROR],
	            flushInterval: 10 * 60 * 1000,
	            heartbeatInterval: 5000,
	            sizeLimit: 300,
	            debounceInterval: 10,
	            uri: '/api/log',
	            hearbeatMaxThreshold: 50,
	
	            deploy: {
	                isLocal: function isLocal() {
	                    return hostname === 'localhost' || hostname === 'localhost.paypal.com';
	                },
	
	                isStage: function isStage() {
	                    return Boolean(hostname.match(/^.*\.qa\.paypal\.com$/));
	                },
	
	                isLive: function isLive() {
	                    return hostname === 'www.paypal.com';
	                }
	            },
	
	            init: function init() {
	                var self = this;
	
	                this.buffer = [];
	
	                var previousBeforeUnloadHandler = $window.onbeforeunload;
	
	                $window.onbeforeunload = function (event) {
	
	                    if (self.isDone) {
	                        return;
	                    }
	
	                    self.info('window_beforeunload');
	
	                    if (previousBeforeUnloadHandler) {
	                        return previousBeforeUnloadHandler.apply(this, arguments);
	                    }
	                };
	
	                var previousUnloadHandler = $window.onunload;
	
	                $window.onunload = function (event) {
	
	                    if (self.isDone) {
	                        return;
	                    }
	
	                    self.info('window_unload')._flush(true);
	
	                    self.done();
	
	                    if (previousUnloadHandler) {
	                        return previousUnloadHandler.apply(this, arguments);
	                    }
	                };
	
	                this.heartbeat();
	                this.daemon();
	            },
	
	            heartbeat: function heartbeat() {
	                var self = this;
	
	                if (!window.enablePerformance) {
	                    return;
	                }
	
	                function timestamp() {
	                    var perf = window.performance;
	
	                    return parseInt(perf.now() - (perf.timing.connectEnd - perf.timing.navigationStart), 10);
	                }
	
	                var howBusy = {
	                    lastSampledTime: timestamp(),
	                    lastLag: 0,
	                    maxLag: 0,
	                    dampendedLag: 0
	                };
	
	                var count = 0;
	
	                $interval(function () {
	
	                    if (!self.buffer.length || self.buffer[self.buffer.length - 1].event !== 'heartbeat') {
	                        count = 0;
	                    }
	
	                    if (!self.buffer.length || count > self.hearbeatMaxThreshold) {
	                        return;
	                    }
	
	                    count += 1;
	
	                    var payload = {
	                        count: count
	                    };
	
	                    var now = timestamp();
	
	                    howBusy.lastLag = now - howBusy.lastSampledTime - self.heartbeatInterval;
	                    howBusy.maxLag = howBusy.lastLag > howBusy.maxLag ? howBusy.lastLag : howBusy.maxLag;
	                    howBusy.dampendedLag = (howBusy.lastLag + howBusy.dampendedLag * 2) / 3;
	                    howBusy.lastSampledTime = now;
	
	                    payload.lastLag = howBusy.lastLag.toFixed(4);
	                    payload.maxLag = howBusy.maxLag.toFixed(4);
	                    payload.dampendedLag = howBusy.dampendedLag.toFixed(4);
	                    payload.lastSampledTime = howBusy.lastSampledTime.toFixed(4);
	
	                    if (howBusy.lastLag > 10000) {
	                        self.info('toobusy', {}, {
	                            noConsole: true,
	                            unique: true
	                        });
	                    }
	
	                    self.info('heartbeat', payload, {
	                        noConsole: true
	                    });
	                }, this.heartbeatInterval);
	            },
	
	            done: function done() {
	                this.isDone = true;
	            },
	
	            addPerformanceData: function addPerformanceData(payload) {
	
	                if (window.enablePerformance) {
	                    var performance = window.performance;
	                    var timing = window.performance.timing || {};
	                    var now = performance.now();
	
	                    if (window.clientStartTime && angular.isUndefined(payload.client_elapsed)) {
	                        payload.client_elapsed = parseInt(now - window.clientStartTime, 10);
	                    }
	
	                    if (timing.connectEnd && timing.navigationStart && angular.isUndefined(payload.req_elapsed)) {
	                        payload.req_elapsed = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
	                    }
	                }
	            },
	
	            addLocaleData: function addLocaleData(payload) {
	
	                var context = {};
	
	                try {
	                    context = $injector.get('$metaBuilder').buildContext();
	                } catch (err) {
	                    return; // Continue without adding locale data
	                }
	                if (context.locale && context.locale.country) {
	                    payload.site_cntry = context.locale.country;
	                }
	            },
	
	            /* jslint maxcomplexity: false */
	            log: function log(level, event, payload, settings) {
	
	                var self = this;
	
	                payload = payload || {};
	
	                if (angular.isArray(payload) || !angular.isObject(payload)) {
	                    payload = {
	                        payload: payload
	                    };
	                }
	                settings = settings || {};
	
	                if (settings.unique) {
	                    var hash = event + ':' + angular.toJson(payload);
	
	                    if (uniqueEvents.indexOf(hash) > -1) {
	                        return self;
	                    }
	                    uniqueEvents.push(hash);
	                }
	
	                payload.pageID = window.meta && window.meta.pageID;
	
	                this.addPerformanceData(payload);
	                this.addLocaleData(payload);
	
	                self.print(level, event, payload, settings);
	
	                if (this.buffer.length >= this.sizeLimit) {
	                    if (this.buffer.length === this.sizeLimit) {
	                        return self.enqueue('info', 'logger_max_buffer_length');
	                    }
	                    return self;
	                }
	
	                return self.enqueue(level, event, payload, settings);
	            },
	
	            getTimestamp: function getTimestamp() {
	                var now = Date.now();
	
	                return window.logOffset ? window.logOffset + now : now;
	            },
	
	            enqueue: function enqueue(level, event, payload, settings) {
	
	                payload = payload || {};
	                settings = settings || {};
	
	                var data = {
	                    level: level,
	                    event: event,
	                    timestamp: this.getTimestamp(),
	                    payload: payload
	                };
	
	                this.buffer.push(data);
	
	                // If the log level is classified as autolog, then flush the data
	                if (this.autoLog.indexOf(level) > -1) {
	                    this.flush();
	                }
	
	                return this;
	            },
	
	            shouldPrintLogsToConsole: function shouldPrintLogsToConsole(settings) {
	
	                if (settings.noConsole) {
	                    return false;
	                }
	
	                if (window.meta && window.meta.corp) {
	                    return true;
	                }
	
	                if (this.deploy.isLocal() || this.deploy.isStage()) {
	                    return true;
	                }
	
	                var cookies = window.cookies || {};
	
	                if (cookies[HERMES_DEV_COOKIE] && cookies[HERMES_DEV_COOKIE] === '1') {
	                    return true;
	                }
	
	                return false;
	            },
	
	            print: function print(level, event, payload, settings) {
	
	                if (!this.shouldPrintLogsToConsole(settings)) {
	                    return;
	                }
	
	                var args = [event];
	
	                if (payload) {
	                    args.push(payload);
	
	                    if (payload.stack || payload.error || payload.warning) {
	                        args.push('\n\n', payload.stack || payload.error || payload.warning);
	                    }
	                }
	
	                $log[$consoleLogLevel[level] || 'info'].apply($log, args);
	            },
	
	            flush: function flush(immediate) {
	                var self = this;
	
	                if (!this.buffer.length) {
	                    return $q.when();
	                }
	
	                if (immediate) {
	                    return $q.when(this._flush());
	                }
	
	                if (self.debouncer_timeout) {
	                    $timeout.cancel(self.debouncer_timeout);
	                }
	
	                self.debouncer_timeout = $timeout(function () {
	
	                    var resolver = self.debouncer_resolver;
	
	                    delete self.debouncer_promise;
	                    delete self.debouncer_resolver;
	                    delete self.debouncer_timeout;
	
	                    self._flush().then(function () {
	                        resolver();
	                    });
	                }, this.debounceInterval);
	
	                self.debouncer_promise = self.debouncer_promise || $q(function (resolver) {
	                    self.debouncer_resolver = resolver;
	                });
	
	                return self.debouncer_promise;
	            },
	
	            _flush: function _flush(sync) {
	                var self = this;
	
	                if (!self.buffer.length) {
	                    return $q.when();
	                }
	
	                var meta = {};
	
	                try {
	                    meta = $injector.get('$metaBuilder').build();
	                } catch (err) {
	                    // @TODO - Log error
	                }
	
	                var req = this.ajax('post', $window.config.urls.baseUrl + this.uri, {
	                    data: {
	                        events: self.buffer
	                    },
	                    meta: meta
	                }, sync);
	
	                self.buffer = [];
	
	                return req;
	            },
	
	            ajax: function ajax(method, url, json, sync) {
	
	                return $q(function (resolve) {
	                    var XRequest = window.XMLHttpRequest || ActiveXObject; // eslint-disable-line no-undef, block-scoped-var
	                    var req = new XRequest('MSXML2.XMLHTTP.3.0');
	
	                    req.open(method.toUpperCase(), url, !sync);
	                    req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	                    req.setRequestHeader('Content-type', 'application/json');
	                    req.onreadystatechange = function () {
	                        if (req.readyState > 3) {
	                            resolve();
	                        }
	                    };
	                    req.send(angular.toJson(json).replace(/&/g, '%26')); // eslint-disable-line angular/ng_json_functions
	                });
	            },
	
	            daemon: function daemon() {
	                this.stop();
	
	                var self = this;
	
	                this.timer = $interval(function () {
	                    self.flush();
	                }, this.flushInterval);
	            },
	
	            stop: function stop() {
	                if (this.timer) {
	                    $interval.cancel(this.timer);
	                }
	            }
	        });
	
	        function Logger(val) {
	            angular.extend(this, val);
	            this.init();
	        }
	
	        Logger.prototype = logger;
	        Logger.prototype.constructor = Logger;
	
	        return Logger;
	    }).factory('$logger', function ($Logger) {
	        return new $Logger();
	    }).run(function ($logger) {
	        angular.forEach(window.beaconQueue, function (payload) {
	            $logger.log(payload.level, payload.event, payload);
	        });
	
	        window.beacon = function (level, events, payload) {
	            angular.forEach(events, function (event) {
	                $logger.log(level, event, payload);
	            });
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-beaver/dist", "components/xo-beaver/dist/logger.js"))

/***/ },

/***/ "./components/xo-beaver/dist/level.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('beaver.level', []).factory('$logLevel', function () {
	
	        return {
	            INFO: 'info',
	            DEBUG: 'debug',
	            ERROR: 'error',
	            WARN: 'warn',
	            ALERT: 'alert'
	        };
	    }).factory('$consoleLogLevel', function () {
	
	        return {
	            info: 'info',
	            debug: 'debug',
	            error: 'error',
	            warn: 'warn',
	            alert: 'info'
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-beaver/dist", "components/xo-beaver/dist/level.js"))

/***/ },

/***/ "./pages/xo-checkout/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	__webpack_require__("./components/jquery/dist/jquery.min.js");
	
	__webpack_require__("./components/angular-shims-placeholder/dist/angular-shims-placeholder.min.js");
	
	__webpack_require__("./js/lib/index.js");
	
	__webpack_require__("./components/xo-tracking/dist/index.js");
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _middleware = __webpack_require__("./js/lib/middleware.js");
	
	__webpack_require__("./pages/xo-landing/route.js");
	
	__webpack_require__("./pages/xo-login/route.js");
	
	__webpack_require__("./pages/xo-generic-error/route.js");
	
	__webpack_require__("./pages/xo-generic-message/route.js");
	
	__webpack_require__("./pages/xo-review/route.js");
	
	__webpack_require__("./pages/xo-authorization-message/route.js");
	
	__webpack_require__("./pages/xo-add-card/route.js");
	
	__webpack_require__("./pages/xo-add-fi/route.js");
	
	__webpack_require__("./pages/xo-add-card-meft/route.js");
	
	__webpack_require__("./pages/xo-add-tax-id/route.js");
	
	__webpack_require__("./pages/xo-add-shipping/route.js");
	
	__webpack_require__("./pages/xo-add-national-id/route.js");
	
	__webpack_require__("./pages/xo-update-card/route.js");
	
	var _route = __webpack_require__("./pages/xo-eConsent/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	var _route3 = __webpack_require__("./pages/xo-nbr/route.js");
	
	var _route4 = _interopRequireDefault(_route3);
	
	var _route5 = __webpack_require__("./pages/xo-framebust/route.js");
	
	__webpack_require__("./pages/xo-sepa/route.js");
	
	__webpack_require__("./pages/xo-end/route.js");
	
	__webpack_require__("./components/xo-login-components/src/fullpage-onetouch-upsell/route.js");
	
	var _route6 = __webpack_require__("./pages/xo-create-password/route.js");
	
	var _route7 = _interopRequireDefault(_route6);
	
	var _route8 = __webpack_require__("./pages/xo-tokenization-info/route.js");
	
	var _route9 = _interopRequireDefault(_route8);
	
	__webpack_require__("./pages/xo-inventory-soldout/route.js");
	
	__webpack_require__("./components/xo-page-components/src/done/route.js");
	
	__webpack_require__("./components/xo-form-components/src/phone/route.js");
	
	__webpack_require__("./components/xo-credit-components/src/bml-display/route.js");
	
	__webpack_require__("./components/xo-credit-components/src/choose-credit-offer/route.js");
	
	__webpack_require__("./components/xo-credit-components/src/redirect-to-cape/route.js");
	
	__webpack_require__("./pages/xo-checkout/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoCheckoutRoute', {
	
	    path: 'checkout',
	    directive: 'xo-checkout',
	    titleContent: 'base.payPal',
	
	    defaultState: 'checkout.landing',
	    middleware: _middleware.$Middleware,
	
	    children: [{
	        name: '$LandingRoute'
	    }, {
	        name: '$LoginRoute',
	        attributes: {
	            token: 'token'
	        }
	    }, {
	        name: '$GenericErrorRoute'
	    }, {
	        name: '$ChooseCreditOfferRoute',
	        attributes: {
	            token: 'token'
	        }
	    }, {
	        name: '$RedirectToCapeRoute',
	        attributes: {
	            token: 'token'
	        }
	    }, {
	        name: '$GenericMessageRoute'
	    }, {
	        name: '$FullpageOnetouchUpsellRoute'
	    }, {
	        name: '$ReviewRoute'
	    }, {
	        name: '$AuthorizationMessageRoute'
	    }, {
	        name: '$AddPhoneRoute'
	    }, {
	        name: '$AddCardPageRoute'
	    }, {
	        name: '$AddFiPageRoute'
	    }, {
	        route: _route9['default'],
	        props: function props() {
	            return { token: this.token };
	        }
	    }, {
	        name: '$AddCardMeftRoute'
	    }, {
	        name: '$AddTaxIdRoute'
	    }, {
	        name: '$AddNationalIdRoute'
	    }, {
	        name: '$UpdateCardPageRoute'
	    }, {
	        name: '$AddShippingPageRoute',
	        attributes: {
	            token: 'token'
	        }
	    }, {
	        name: '$xoSoldOutPageRoute'
	    }, {
	        route: _route2['default'],
	        props: function props() {
	            var _this = this;
	
	            return {
	                token: this.token,
	                success: function success() {
	                    return _this.goto('this.review');
	                }
	            };
	        }
	    }, {
	        route: _route4['default'],
	        props: function props() {
	            return { token: this.token };
	        }
	    }, {
	        route: _route5.$xoFrameBustRoute
	    }, {
	        name: '$SepaPageRoute',
	        attributes: {
	            token: 'token'
	        }
	    }, {
	        name: '$EndRoute'
	    }, {
	        name: '$BMLDisplay',
	        attributes: {
	            'review-url': 'reviewUrl'
	        }
	    }, {
	        name: '$DoneRoute'
	    }, {
	        route: _route7['default'],
	        props: function props() {
	            return {
	                token: this.token
	            };
	        }
	    }]
	});
	
	
	_index.$Route;
	
	_middleware.$Middleware;
	
	_route5.$xoFrameBustRoute;
	module.exports = exports['default'];

/***/ },

/***/ "./js/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _error = __webpack_require__("./js/lib/error.js");
	
	Object.keys(_error).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _error[key];
	    }
	  });
	});
	
	var _fallback = __webpack_require__("./js/lib/fallback.js");
	
	Object.keys(_fallback).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _fallback[key];
	    }
	  });
	});
	
	var _contingency = __webpack_require__("./js/lib/contingency.js");
	
	Object.keys(_contingency).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _contingency[key];
	    }
	  });
	});
	
	var _metaBuilder = __webpack_require__("./js/lib/metaBuilder.js");
	
	Object.keys(_metaBuilder).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _metaBuilder[key];
	    }
	  });
	});
	
	var _middleware = __webpack_require__("./js/lib/middleware.js");
	
	Object.keys(_middleware).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _middleware[key];
	    }
	  });
	});
	
	var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");
	
	Object.keys(_miniBrowser).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _miniBrowser[key];
	    }
	  });
	});
	
	var _security = __webpack_require__("./js/lib/security.js");
	
	Object.keys(_security).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _security[key];
	    }
	  });
	});

/***/ },

/***/ "./js/lib/error.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$forbiddenHandler = $forbiddenHandler;
	exports.$exceptionHandler = $exceptionHandler;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _fallback = __webpack_require__("./js/lib/fallback.js");
	
	var _contingency = __webpack_require__("./js/lib/contingency.js");
	
	function constructEventName(toState, fromState) {
	    var from = fromState.name.replace(/\./g, '_') || 'start';
	    var to = toState.name.replace(/\./g, '_') || 'end';
	
	    return 'state_change_' + from + '_to_' + to;
	}
	
	function $forbiddenHandler(err) {
	    _logger.$logger.warn('forbidden_handler');
	    if (!err.transient) {
	        _index.$AuthModel.instance().invalidate();
	
	        if (_angular.$rootScope.paymentComplete) {
	            throw new _squid.$Contingency('PAYMENT_ALREADY_DONE');
	        }
	
	        _uiRouter.$state.go('checkout.login');
	    }
	}
	
	var ERROR_HANDLERS = [{
	    type: _squid.$FallbackError,
	    handler: _fallback.$fallbackErrorHandler
	}, {
	    type: _squid.$Contingency,
	    handler: _contingency.$contingencyHandler
	}, {
	    type: _squid.$Forbidden,
	    handler: $forbiddenHandler
	}];
	
	function $exceptionHandler(err, cause) {
	
	    if (_angular.$rootScope.ERROR_STATE) {
	
	        if (_angular.$rootScope.ERROR_PREVENTED) {
	            throw err;
	        }
	
	        return;
	    }
	
	    var handled = _squid.$util.some(ERROR_HANDLERS, function (errorHandler) {
	        if (err instanceof errorHandler.type) {
	            errorHandler.handler(err);
	
	            return true;
	        }
	    });
	
	    if (handled) {
	        return;
	    } else if (!err.transient) {
	        _angular.$rootScope.ERROR_STATE = err;
	    }
	
	    var errType = (err.constructor.name || 'error').toLowerCase();
	    var errName = 'ui_unhandled_' + errType;
	    var errMsg = err.message || '';
	
	    if (errMsg.indexOf('infdig') > -1) {
	        errName = 'infinite_digest';
	    } else if (errMsg.indexOf('inprog') > -1) {
	        errName = 'digest_inprog';
	    } else if (errMsg.indexOf('badparse') > -1) {
	        errName = 'sanitize_badparse';
	    } else if (errMsg.match(/^[\w_]+$/)) {
	        errName = 'ui_unhandled_' + errMsg;
	    }
	
	    if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
	        if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
	            errName = 'ui_unhandled_framework_error';
	        }
	    }
	
	    if (err.transient) {
	        errName += '_transient';
	    }
	
	    var payload = {
	        error: err.stack || err.toString(),
	        message: errMsg,
	        cause: cause && cause.toString(),
	        state: _uiRouter.$state.current.name,
	        url: window.location.toString()
	    };
	
	    angular.extend(payload, err.payload || {});
	
	    _logger.$logger.error(errName, payload);
	
	    // emit the error object for subscribers like xo-tracking
	    var event = _angular.$rootScope.$emit('unhandled_error', {
	        err: err,
	        route: (_uiRouter.$state || {}).current,
	        message: payload.error,
	        code: payload.cause
	    });
	
	    if (event.defaultPrevented) {
	        _angular.$rootScope.ERROR_PREVENTED = true;
	        throw err;
	    } else if (!err.transient) {
	        return (0, _fallback.$fallbackErrorHandler)(new _squid.$FallbackError({
	            reason: errName
	        }));
	    }
	}
	
	_angular.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
	    // Set prevent default to avoid angular UI router to keep looping back to same state
	    event.preventDefault();
	    $exceptionHandler(err, constructEventName(toState, fromState));
	});
	
	_angular.$rootScope.$on('$windowError', function (event, details) {
	    _logger.$logger.error('window_error', details, {
	        unique: true
	    });
	});
	
	angular.value("$forbiddenHandler", $forbiddenHandler);
	angular.value("$exceptionHandlerLazy", $exceptionHandler);
	_angular.$rootScope;
	
	_uiRouter.$state;
	
	_squid.$util;
	
	_squid.$FallbackError;
	
	_squid.$Forbidden;
	
	_squid.$Contingency;
	
	_logger.$logger;
	
	_index.$AuthModel;
	
	_fallback.$fallbackErrorHandler;
	
	_contingency.$contingencyHandler;

/***/ },

/***/ "./components/squid/dist/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _ng = __webpack_require__("./components/squid/dist/ng/index.js");
	
	Object.keys(_ng).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ng[key];
	    }
	  });
	});
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	Object.keys(_core).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _core[key];
	    }
	  });
	});
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	Object.keys(_locale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locale[key];
	    }
	  });
	});
	
	var _paypal = __webpack_require__("./components/squid/dist/paypal/index.js");
	
	Object.keys(_paypal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _paypal[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/ng/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _core = __webpack_require__("./components/squid/dist/ng/core.js");
	
	Object.keys(_core).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _core[key];
	    }
	  });
	});
	
	var _route = __webpack_require__("./components/squid/dist/ng/route.js");
	
	Object.keys(_route).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _route[key];
	    }
	  });
	});
	
	var _component = __webpack_require__("./components/squid/dist/ng/component.js");
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});
	
	var _feature = __webpack_require__("./components/squid/dist/ng/feature.js");
	
	Object.keys(_feature).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _feature[key];
	    }
	  });
	});
	
	var _locale = __webpack_require__("./components/squid/dist/ng/locale.js");
	
	Object.keys(_locale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locale[key];
	    }
	  });
	});
	
	var _module = __webpack_require__("./components/squid/dist/ng/module.js");
	
	Object.keys(_module).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _module[key];
	    }
	  });
	});
	
	var _ng = __webpack_require__("./components/squid/dist/ng/ng.js");
	
	Object.keys(_ng).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ng[key];
	    }
	  });
	});
	
	var _directive = __webpack_require__("./components/squid/dist/ng/directive.js");
	
	Object.keys(_directive).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _directive[key];
	    }
	  });
	});
	
	var _events = __webpack_require__("./components/squid/dist/ng/events.js");
	
	Object.keys(_events).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _events[key];
	    }
	  });
	});
	
	var _pxp = __webpack_require__("./components/squid/dist/ng/pxp.js");
	
	Object.keys(_pxp).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _pxp[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/ng/core.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	_core.$event.use({
	    on: function on() {
	        return _angular.$rootScope.$on.apply(_angular.$rootScope, arguments);
	    },
	    once: function once(name, handler) {
	        var cancel = _core.$event.on(name, function () {
	            cancel();
	            handler.apply(this, arguments);
	        }, true);
	
	        return cancel;
	    },
	    emit: function emit() {
	        return _angular.$rootScope.$emit.apply(_angular.$rootScope, arguments);
	    },
	    broadcast: function broadcast() {
	        return _angular.$rootScope.$broadcast.apply(_angular.$rootScope, arguments);
	    }
	});
	
	_core.$promise.use(_angular.$q);
	
	_angular.$q;
	
	_angular.$rootScope;
	
	_core.$event;
	
	_core.$promise;

/***/ },

/***/ "./components/squid/dist/core/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _api = __webpack_require__("./components/squid/dist/core/api.js");
	
	Object.keys(_api).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api[key];
	    }
	  });
	});
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	Object.keys(_class).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _class[key];
	    }
	  });
	});
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	Object.keys(_config).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _config[key];
	    }
	  });
	});
	
	var _error = __webpack_require__("./components/squid/dist/core/error.js");
	
	Object.keys(_error).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _error[key];
	    }
	  });
	});
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	Object.keys(_event).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _event[key];
	    }
	  });
	});
	
	var _integration = __webpack_require__("./components/squid/dist/core/integration.js");
	
	Object.keys(_integration).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _integration[key];
	    }
	  });
	});
	
	var _model = __webpack_require__("./components/squid/dist/core/model.js");
	
	Object.keys(_model).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _model[key];
	    }
	  });
	});
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	Object.keys(_promise).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _promise[key];
	    }
	  });
	});
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	Object.keys(_util).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _util[key];
	    }
	  });
	});
	
	var _loader = __webpack_require__("./components/squid/dist/core/loader.js");
	
	Object.keys(_loader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _loader[key];
	    }
	  });
	});
	
	var _dom = __webpack_require__("./components/squid/dist/core/dom.js");
	
	Object.keys(_dom).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _dom[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/core/api.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$Api = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.$getLatestCorrelationID = $getLatestCorrelationID;
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	var _error = __webpack_require__("./components/squid/dist/core/error.js");
	
	var _loader = __webpack_require__("./components/squid/dist/core/loader.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	 API
	 ---
	
	 This layer is responsible for handling api requests. It has a number of responsibilities:
	
	 - Caching responses
	 - Transparently returning data that has been preloaded into the initial page response
	 - Instrumentation
	 - Batching multiple api calls into a single http request
	 - Handling multiple types of responses and dispatching to the correct handlers
	 - Emitting loading events for all http calls
	 */
	
	_config.$meta.headers = _config.$meta.headers || {};
	_config.$meta.headers['x-cookies'] = _typeof(_config.$meta.headers['x-cookies']) !== 'object' ? JSON.parse(_config.$meta.headers['x-cookies'] || '{}') : _config.$meta.headers['x-cookies'];
	
	// Are we in 'cookies disabled' mode? (Do we need to keep a local store of cookies)
	function cookiesEnabled() {
	    return _util.$util.cookiesEnabled() && window.location.hostname.indexOf('.paypal.com') > -1;
	}
	
	// Cache for api responses, when cache: true
	var cache = {};
	
	var latestCorrelationID = _config.$meta.correlationId;
	
	// Window load promise
	var windowLoad = _util.$util.memoize(function () {
	    return _promise.$promise.resolver(function (resolve) {
	        if (document.readyState === 'complete') {
	            resolve();
	        } else {
	            window.addEventListener('load', resolve);
	        }
	    });
	});
	
	// Buffer for batch requests made within the same frame
	var batchQueue = {};
	
	// Backwards compat
	window.pre = {};
	
	// Transient cache resolvers
	var transientCache = {};
	
	// Transient cache resolvers
	var transientCacheResolvers = {};
	
	// Metabuilder
	var metaBuilder = void 0;
	
	// Add to transientCache
	window.preload = function (method, url, data, name) {
	
	    if (name) {
	        window.pre[name] = {
	            method: method,
	            uri: url,
	            res: data
	        };
	    }
	
	    var key = method + ':' + url;
	    var resolvers = transientCacheResolvers[key] || [];
	
	    transientCache[key] = data;
	
	    while (resolvers.length) {
	        resolvers.pop().call();
	    }
	};
	
	// Preload complete
	var preloadComplete = false;
	
	window.preloadComplete = function () {
	    preloadComplete = true;
	    Object.keys(transientCacheResolvers).forEach(function (key) {
	        var resolvers = transientCacheResolvers[key] || [];
	        while (resolvers.length) {
	            resolvers.pop().call();
	        }
	    });
	};
	
	_logger.$logger.info(cookiesEnabled() ? 'cookies_enabled' : 'cookies_disabled');
	
	var $Api = exports.$Api = _class.$Class.extend('$Api', {
	
	    // Cache any GET responses indefinitely
	    cache: false,
	
	    // Http timeout for all requests
	    timeout: 45000,
	
	    // Default number of attempts on aborted requests and 500 server errors
	    getAttempts: 3,
	    postAttempts: 1,
	
	    // POST on a resource with an action name myapi.action('foo') -> POST /my/api/foo
	    action: function action(_action, options) {
	        options.action = _action;
	        return this.post(options);
	    },
	
	    // GET on a resource myapi.retrieve() -> GET /my/api
	    retrieve: function retrieve(options) {
	        options.method = 'get';
	        return this.call(options);
	    },
	
	    // POST on a resource myapi.retrieve() -> POST /my/api
	    post: function post(options) {
	        options.method = 'post';
	        return this.call(options);
	    },
	
	    // Generic handler for calling an api and dispatching requests to the right place
	    call: function call(options) {
	        var self = this;
	
	        // Set up request options and params. `options` is an object which should contain everything
	        // the request needs to run and handle the response
	
	        options.api = this;
	        options.uri = this.getURI(options.model, options.action);
	        options.params = options.params || {};
	        options.cache = options.cache || self.cache && options.method === 'get';
	        options.name = this.buildAPIName(options);
	        options.meta = this.buildMeta();
	        options.transientError = options.transientError || false;
	        options.cacheKey = _util.$util.buildURL(options.uri, options.params);
	
	        _logger.$logger.info(options.name + '_call', {
	            name: options.name,
	            method: options.method,
	            uri: options.uri
	        });
	
	        if (!options.silent) {
	            _event.$event.emit('loading');
	        }
	
	        // Decide where to get the response
	        return _promise.$promise.first([
	
	        // If caching is enabled and we have the data in local cache, use the cache
	        function () {
	            if (options.cache && cache[options.cacheKey]) {
	                return cache[options.cacheKey];
	            }
	        },
	
	        // Otherwise if we have transient cache data for this api, we can use that
	        function () {
	            return _promise.$promise.providing(self.hasTransientCacheData(options), function () {
	
	                // The reason we use self.attemptRequest here is so any errors in the cached response
	                // can trigger the retry code path, as if it were a regular request
	                return self.attemptRequest(options);
	            });
	        },
	
	        // If we're in batch mode, queue up a batch request
	        function () {
	            if (options.batch) {
	                return self.batchRequest(options);
	            }
	        },
	
	        // Otherwise attempt a regular http request (at this point an http call is guaranteed)
	        function () {
	            return self.attemptRequest(options);
	        }])['finally'](function () {
	
	            if (!options.silent) {
	                _event.$event.emit('loaded');
	            }
	        }).then(function (res) {
	
	            // Cache the response if we need to
	            if (options.cache) {
	                cache[options.cacheKey] = res;
	            }
	
	            // Handle the response
	            return self.handleResponse(res.data, options);
	        }, function (err) {
	
	            // $BatchShortCircuit will be thrown if:
	            //
	            // 1. batch api call B depends on api call A, but-
	            // 2. api call A fails
	            //
	            // In which case we end up in a situation where had it been a regular chain of events,
	            // api B would never have been called in the first place.
	            //
	            // One possibility here is to return $unresolved, which prevents the promise from ever
	            // resolving, but this has the potential to cause a lot of difficulty debugging and strange
	            // corner cases.
	            //
	            // Instead we opt to simply reject the promise, and not call any of the response handlers
	
	            if (err instanceof _error.$BatchShortCircuit) {
	                return _promise.$promise.reject(err);
	            }
	
	            // Otherwise, handle the error normally
	            return self.handleErrorResponse(err, options);
	        });
	    },
	
	    // Set up a batch request for processing in the next frame
	    batchRequest: function batchRequest(options) {
	
	        // Batch Requests are an optimization layer on top of regular api calls. The purpose of this
	        // layer is to combine multiple atomic api calls into a single http request, without forcing
	        // developers to create large orchestration layers on the client/server with cross-cutting concerns.
	        //
	        // This layer will queue up multiple requests made in the same frame whenever batch-mode is enabled,
	        // attach them all to an http call to /api/batch/:name, then on the response it will dispatch each
	        // individual api call to the correct handler.
	        //
	        // The way this is implemented is to place each response in the transient api cache, then to yield
	        // control to the regular api request handler, which will handle instrumentation and retries
	
	        // For quick dev-time feedback...
	        _util.$util.assert(options.batch.name, 'Must define a "name" for batch request: ' + options.batch);
	        _util.$util.assert(options.batch.id, 'Must define a "id" for batch request: ' + options.batch);
	
	        var name = options.batch.name;
	        var id = options.batch.id;
	
	        // Add the batch request options to the batchQueue for processing on the next frame
	        var batch = batchQueue[name] = batchQueue[name] || {};
	        batch[id] = options;
	
	        // Fire off a batch request. This will be debounced: calls in the same frame will be combined to one
	        return this.buildBatchRequest(name).then(function (results) {
	
	            // We get back a mapping of id->response, so we now extract the response for our api
	            // call. If we have no response, we can assume the call was never made, and short circuit.
	            return results[id].then(function (result) {
	                return result || _promise.$promise.reject(new _error.$BatchShortCircuit());
	            });
	        });
	    },
	
	    // Process all of the accumulated batch api requests
	    buildBatchRequest: _promise.$promise.debounce(function (name) {
	
	        var self = this;
	        var batch = batchQueue[name];
	        var batchIds = _class.$Class.keys(batch);
	        var batchData = {};
	        var headers = {};
	
	        delete batchQueue[name];
	
	        // If we have just a single request, we can short-circuit and just hit that api
	
	        if (batchIds.length === 1) {
	
	            var batchId = batchIds[0];
	            var opts = batch[batchId];
	
	            var results = {};
	            results[batchId] = opts.api.attemptRequest(opts);
	            return results;
	        }
	
	        // Build the request to send to the server side. This is an mapping of id->request, each containing
	        // the method, uri, data, and dependencies for each api.
	        //
	        // Specifying a dependency for an api essentially means the back-end will only
	        // call api-B if api-A returns ack=success. Otherwise there will be no response for api B.
	
	        _util.$util.forEach(batch, function (options, id) {
	
	            batchData[id] = {
	                method: options.method,
	                uri: options.api.getURI(options.model, options.action, true),
	                data: options.data,
	                params: options.params,
	                dependencies: options.batch.dependencies
	            };
	
	            _util.$util.extend(headers, options.headers);
	        });
	
	        // Unfortunate circular dependency... $Api depends on another api.
	        //
	        // $batchApi is subject to all of the same rules regarding retries, so if for some reason the server
	        // does not respond the first time, our batch request can still get through.
	
	        return $batchApi.action(name, {
	            data: batchData,
	            headers: headers
	        }).then(function (res) {
	
	            // The final response will be a mapping of id->response-promise.
	            //
	            // However, we do not treat this data as our final response. Instead, we simply use it to
	            // prime our transient cache, then proceed to jump to our regular request handler. This will
	            // take care of retries and instrumentation as if this were a regular request.
	            //
	            // Note that a retry for $batchApi is different to a retry for an individual api. If
	            // an *individual* api call fails, we do not want to re-do the entire batch call; instead we
	            // can just retry the individual api call.
	
	            return self.handleBatchResponse(batch, res.data);
	        });
	    }),
	
	    // Process the responses for all of the batch requests we sent to the server
	    handleBatchResponse: function handleBatchResponse(batch, data) {
	
	        var self = this;
	
	        var promises = {};
	
	        // Loop over each individual api response contained in the batch response, and process the result
	
	        _util.$util.forEach(batch, function (options, id) {
	
	            // Store each response promise so we can check and wait for api dependencies
	
	            promises[id] = _promise.$promise.run(function () {
	
	                // Check if all of the dependencies are present for our individual api call. To do this
	                // we must wait until the dependent api call is entirely complete, including any retries.
	
	                var depsPresent = _promise.$promise.every(options.batch.dependencies || [], function (depName) {
	
	                    if (!batch[depName]) {
	                        _logger.$logger.info('missing_batch_dependency', {
	                            dependency: depName,
	                            available: Object.keys(batch).join('|')
	                        });
	                    }
	
	                    return !batch[depName] || promises[depName].then(function (dependency) {
	                        return dependency && dependency.data && dependency.data.ack === 'success';
	                    });
	                });
	
	                // If our dependencies are present, we can continue, otherwise we are not interested in
	                // the result of the individual api call - if its dependency is not present, it will not be.
	
	                return _promise.$promise.providing(depsPresent, function () {
	
	                    // If there is data returned for the individual call, add it to the transient cache
	
	                    return _promise.$promise.providing(data[id], function (result) {
	
	                        self.addTransientCacheData(options.method, options.api.getURI(options.model, options.action), result);
	                    }).then(function () {
	
	                        // Regardless of whether or not there is data, we can now attempt the request.
	                        // This will either get the data from the transient cache, or make an http call,
	                        // and handle any retries that need to be made.
	
	                        return options.api.attemptRequest(options);
	                    });
	                });
	            });
	        });
	
	        return promises;
	    },
	
	    // Handle the request and any retries, using either the transient cache or http calls
	    attemptRequest: function attemptRequest(options) {
	        var self = this;
	
	        var attempts = options.method === 'get' ? this.getAttempts : this.postAttempts;
	
	        // We allow a certain number of attempts/retries for each api call
	        return _promise.$promise.attempt(attempts, function (remaining) {
	
	            // Query the transient cache
	            return self.getTransientCacheResponse(options).then(function (res) {
	
	                // If we can get a response from the transient cache, then use it
	                if (res) {
	                    return res;
	                }
	
	                // Otherwise resort to making an http call
	                return self.getHttpResponse(options);
	            })['catch'](function (res) {
	
	                // If our request was aborted without even a status code, force a single retry
	                if ((!res || !res.status) && attempts === 1) {
	
	                    _logger.$logger.warn('api_retry_aborted', {
	                        method: options.method,
	                        uri: options.uri
	                    });
	
	                    return self.getHttpResponse(options);
	                }
	
	                return _promise.$promise.reject(res);
	            })['catch'](function (res) {
	
	                // If our request was 401 denied (probably due to a CSRF error), force a single retry
	                if (res.status === 401) {
	
	                    _logger.$logger.warn('api_retry_401', {
	                        method: options.method,
	                        uri: options.uri
	                    });
	
	                    return self.getHttpResponse(options);
	                }
	
	                return _promise.$promise.reject(res);
	            })['catch'](function (res) {
	
	                // Set the correct response and ack for 401
	                if (res.status === 401) {
	                    return {
	                        data: {
	                            ack: 'permission_denied'
	                        }
	                    };
	                }
	
	                // If we have any remaining retries, log and reject
	                if (remaining) {
	
	                    _logger.$logger.warn('api_retry', {
	                        method: options.method,
	                        uri: options.uri
	                    });
	
	                    return _promise.$promise.reject(res);
	                }
	
	                // Otherwise reject the request with the appropriate error
	
	                // We got ack=error in the response
	                if (res && res.data && res.data.ack === 'error') {
	                    return _promise.$promise.reject(new _error.$ApiError('api_error', { // eslint-disable-line no-reserved-keys
	                        name: options.name,
	                        method: options.method,
	                        uri: options.uri,
	                        stack: res.data.stack,
	                        transient: options.transientError
	                    }));
	                }
	
	                // We got a response error status
	                else if (res && res.status) {
	                        return _promise.$promise.reject(new _error.$ApiError('response_status_' + res.status, { // eslint-disable-line no-reserved-keys
	                            uri: options.uri,
	                            transient: options.transientError
	                        }));
	                    } else if (res && res.error) {
	                        return _promise.$promise.reject(new _error.$ApiError('request_' + res.error, { // eslint-disable-line no-reserved-keys
	                            uri: options.uri,
	                            transient: options.transientError
	                        }));
	                    }
	
	                    // The request was aborted
	                    else {
	                            return _promise.$promise.reject(new _error.$ApiError('request_aborted', { // eslint-disable-line no-reserved-keys
	                                uri: options.uri,
	                                transient: options.transientError
	                            }));
	                        }
	            });
	        });
	    },
	
	    // Get an api response via http
	    getHttpResponse: function getHttpResponse(options) {
	        var self = this;
	
	        var startTime = _util.$util.now();
	
	        var request = this.http(options);
	
	        return request['finally'](function () {
	
	            // Calculate the end-to-end duration of the request from the client's perspective
	            options.duration = _util.$util.now() - startTime;
	        })['catch'](function (res) {
	
	            // Turn responses with an ack into a 'success' so it makes it to the standard handlers
	            if (res && res.status && res.data && res.data.ack && res.data.ack !== 'error') {
	                return res;
	            }
	
	            return _promise.$promise.reject(res);
	        }).then(function (res) {
	            self.saveResponseState(res);
	
	            var loggerPayload = {
	                name: options.name,
	                method: options.method,
	                uri: options.uri,
	                server: res.data.server,
	                time: options.duration,
	                duration: options.duration,
	                corrid: res && res.headers('Paypal-Debug-Id')
	            };
	
	            // In certain browsers we can match up this api call to the performance data from the browser
	            if (window.performance && window.performance.getEntries) {
	                _util.$util.forEach(window.performance.getEntries(), function (resource) {
	                    if (resource.name && resource.name.indexOf(options.uri) > -1) {
	                        _util.$util.extend(loggerPayload, resource);
	                    }
	                });
	            }
	
	            _logger.$logger.info('api_response', loggerPayload);
	
	            if (res && res.status) {
	                _logger.$logger.info('http_response_' + res.status);
	            }
	
	            return res;
	        }, function (res) {
	            self.saveResponseState(res);
	
	            if (res && res.status) {
	                _logger.$logger.info('http_response_' + res.status);
	            }
	
	            return _promise.$promise.reject(res);
	        });
	    },
	
	    setTransientCache: function setTransientCache(data) {
	        throw new Error('NotImplemented');
	    },
	
	    // Get an individual api response from the transient cache, as an object
	    getTransientCacheData: function getTransientCacheData(options, pop) {
	
	        if (!_config.$config.enablePreload) {
	            return _promise.$promise.resolve();
	        }
	
	        var preMethod = options.method.toLowerCase();
	        var preUri = _util.$util.buildURL(options.uri, options.params);
	
	        var key = preMethod + ':' + preUri;
	
	        return _promise.$promise.resolver(function (resolve) {
	
	            function res() {
	                var data = transientCache[key];
	                if (pop) {
	                    delete transientCache[key];
	                }
	                resolve(data);
	            }
	
	            transientCacheResolvers[key] = transientCacheResolvers[key] || [];
	            transientCacheResolvers[key].push(res);
	
	            if (transientCache[key] || document.readyState === 'complete' || preloadComplete) {
	                return res();
	            }
	
	            windowLoad().then(res);
	        });
	    },
	
	    // Check if the transient cache has the data for a particular api
	    hasTransientCacheData: function hasTransientCacheData(options) {
	        return this.getTransientCacheData(options, false).then(function (data) {
	            return Boolean(data);
	        });
	    },
	
	    // Add data to the transient cache
	    addTransientCacheData: function addTransientCacheData(method, uri, data) {
	        window.preload(method, uri, data);
	    },
	
	    // Get an individual api response from transient cache, as a res promise with the correct status code
	    getTransientCacheResponse: function getTransientCacheResponse(options) {
	
	        return this.getTransientCacheData(options, true).then(function (data) {
	
	            // Preload data does not come with a response code, so massage it into a response promise
	            if (data) {
	                if (data.ack === 'error') {
	                    return _promise.$promise.reject({
	                        status: 500,
	                        data: data
	                    });
	                } else if (data.ack === 'permission_denied') {
	                    return _promise.$promise.reject({
	                        status: 401,
	                        data: data
	                    });
	                } else if (data.ack === 'contingency' || data.ack === 'validation_error') {
	                    return {
	                        status: 400,
	                        data: data
	                    };
	                } else {
	                    return {
	                        status: 200,
	                        data: data
	                    };
	                }
	            }
	
	            // Log a cache miss if we are currently in the first-page load
	            else if (options.method === 'get' && !_loader.$loader.firstLoad() && !options.silent) {
	                    _logger.$logger.info('preload_cache_miss', {
	                        uri: options.uri
	                    });
	                }
	        });
	    },
	
	    getHeaders: function getHeaders(options) {
	
	        if (!_config.$meta.headers['x-csrf-jwt'] && !_config.$meta.csrfJwt) {
	            _logger.$logger.warn('missing_csrf_jwt');
	        }
	
	        var headers = {
	            'X-Requested-With': 'XMLHttpRequest',
	            'x-csrf-jwt': _config.$meta.headers['x-csrf-jwt'] || _config.$meta.csrfJwt
	        };
	
	        if (!cookiesEnabled()) {
	            headers['x-cookies'] = JSON.stringify(_config.$meta.headers['x-cookies']);
	        }
	
	        if (options.headers) {
	            _util.$util.extend(headers, options.headers);
	        }
	
	        return headers;
	    },
	    http: function http(options) {
	        return this.httpJQuery(options);
	    },
	
	
	    /*
	     // Raw http call
	    httpAngular: function(options) {
	         let request = {
	            method: options.method,
	            url: options.uri,
	            data: {
	                data: options.data,
	                meta: options.meta
	            },
	            headers: this.getHeaders(options),
	            params: options.params,
	            requestType: 'json',
	            responseType: 'json',
	            timeout: this.timeout
	        };
	         if (options.method === 'get' && options.meta && Object.keys(options.meta).length) {
	            request.params.meta = JSON.stringify(options.meta);
	        }
	         return $http(request);
	    },
	     */
	
	    httpJQuery: function httpJQuery(options) {
	
	        var request = {
	            method: options.method,
	            data: options.method === 'get' ? options.params : JSON.stringify({
	                data: options.data,
	                meta: options.meta || {}
	            }),
	            headers: this.getHeaders(options),
	            timeout: this.timeout
	        };
	
	        if (options.method === 'post') {
	            request.headers['Content-Type'] = 'application/json;charset=UTF-8';
	        } else if (options.method === 'get') {
	            request.data.meta = JSON.stringify(options.meta);
	        }
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	
	            function getRes(res, data) {
	                return {
	                    status: res.status,
	                    data: data,
	                    headers: function headers(name) {
	                        return res.getResponseHeader(name);
	                    }
	                };
	            }
	
	            request.success = function (data, status, res) {
	                return resolve(getRes(res, data));
	            };
	
	            request.error = function (res) {
	                if (res && res.status) {
	                    if (res.status >= 400) {
	                        return reject(getRes(res, res.responseJSON));
	                    } else {
	                        return resolve(getRes(res, res.responseJSON));
	                    }
	                }
	
	                return reject({
	                    status: 0,
	                    headers: _util.$util.noop,
	                    error: res && res.statusText
	                });
	            };
	
	            _jquery2['default'].ajax(options.uri, request);
	        });
	    },
	
	    // Save cookies and jwt-csrf token from the response
	    saveResponseState: function saveResponseState(res) {
	
	        if (res.headers('x-csrf-jwt')) {
	            _config.$meta.headers['x-csrf-jwt'] = res.headers('x-csrf-jwt');
	            _config.$meta.csrfJwt = res.headers('x-csrf-jwt');
	            _config.$meta.headers['x-csrf-jwt-hash'] = res.headers('x-csrf-jwt-hash');
	        }
	
	        if (res.headers('X-cookies')) {
	
	            _config.$meta.headers['x-cookies-hash'] = res.headers('x-cookies-hash');
	
	            // Extend local cookie jar of encrypted-cookie-name->encrypted-cookie-value with any new cookies
	            _util.$util.extend(_config.$meta.headers['x-cookies'], JSON.parse(res.headers('X-cookies') || '{}'));
	        }
	
	        latestCorrelationID = res.headers('Paypal-Debug-Id') || latestCorrelationID;
	    },
	
	    // Dispatch the response to the correct handlers
	    handleResponse: function handleResponse(res, options) {
	        var loggerName = 'ui_' + options.name;
	
	        var loggerPayload = {
	            name: options.name,
	            method: options.method,
	            uri: options.uri,
	            time: options.duration,
	            duration: options.duration
	        };
	
	        // Here we dispatch the response to the correct handler based on the ack.
	        //
	        // ack=success     -> options.success()
	        // ack=error       -> options.error()
	        // ack=validation  -> options.validation()
	        // ack=contingency -> options.contingencies[contingency]()
	        //
	        // Why do this rather than just rejecting the promise with a custom error?
	        //
	        // a) Angular promises have no `.catchType()`, so this saves us a lot of `instanceof` checks
	        // b) Angular promises have no `.done()`, so callers can not assert that they have handled
	        //    every error they want to. This is exacerbated by the fact that there is no single thread
	        //    of execution on the front-end a la node, so we can't just call `.done()` at the very end :(
	        //
	        // This way, if somebody passes a handler, it will be called. Otherwise, an error will be thrown
	        // and the global error handler will be invoked. The api responses are also given as promises.
	
	        var resultModel = options.resultModel || options.model;
	
	        /* jshint maxcomplexity: 17 */
	        return _promise.$promise.call(function () {
	
	            // If we are given a `resultModel`, we always extend it with `res.data`, no matter the ack
	
	            if (res.data && resultModel) {
	
	                if (resultModel.populate) {
	                    resultModel.populate(res.data);
	                } else {
	                    _util.$util.extend(resultModel, res.data);
	                }
	            }
	
	            if (res && res.ack === 'success' && resultModel && resultModel.fetchChildren) {
	                return _promise.$promise.resolve(resultModel.fetchChildren()).then(function (children) {
	                    return _util.$util.extend(resultModel, children);
	                });
	            }
	        }).then(function () {
	
	            // Handle each ack type, throw errors accordingly
	
	            if (res.ack === 'success') {
	                _logger.$logger.info(loggerName + '_success', loggerPayload);
	
	                if (options.success) {
	                    if (options.success instanceof Function) {
	                        return options.success(res.data);
	                    }
	                    return options.success;
	                }
	
	                return res;
	            }
	
	            if (options.failSilently) {
	                return;
	            }
	
	            if (res.ack === 'contingency') {
	                _logger.$logger.info(loggerName + '_contingency', _util.$util.extend(loggerPayload, {
	                    contingency: res.contingency
	                }));
	
	                if (!res.contingency) {
	                    throw new _error.$ApiError('expected_contingency_name', {
	                        api: options.name
	                    });
	                }
	
	                var contingency = new _error.$Contingency(res.contingency, { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	
	                if (resultModel) {
	                    resultModel.errorData = res.errorData || {};
	                }
	
	                var handler = options.contingencies && (options.contingencies[contingency.message] || options.contingencies['DEFAULT']);
	
	                _util.$util.extend(contingency, res.errorData);
	
	                if (handler) {
	                    if (handler instanceof Function) {
	                        return handler(contingency.message, contingency);
	                    }
	                    return handler;
	                }
	
	                throw contingency;
	            } else if (res.ack === 'validation') {
	                _logger.$logger.info(loggerName + '_validation', _util.$util.extend(loggerPayload, {
	                    validation: res.validation
	                }));
	
	                if (options.validation) {
	                    return options.validation(res.validation);
	                }
	
	                throw new _error.$ApiError('validation', { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	            } else if (res.ack === 'permission_denied') {
	                _logger.$logger.info(loggerName + '_denied', loggerPayload);
	
	                throw new _error.$Forbidden(options.uri + ': forbidden', { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	            } else {
	                _logger.$logger.info(loggerName + '_noack', loggerPayload);
	
	                throw new _error.$ApiError('noack', { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	            }
	        });
	    },
	
	    // Handle http error responses (ack=error or unhandled errors)
	    handleErrorResponse: function handleErrorResponse(err, options) {
	
	        return _promise.$promise.run(function () {
	
	            // If the caller provides an error handler, let them handle it
	            if (options.error) {
	                return options.error(err);
	            }
	
	            // Otherwise we throw the error. Please not that this is NOT just rejecting the promise,
	            // this will always end up in the global error handler due to how angular promises work.
	            throw err;
	        });
	    },
	
	    // Build the uri for the api call
	    getURI: function getURI(model, action, relative) {
	        var self = this;
	
	        // build the uri as a seriest of segments
	        var uri = [];
	
	        uri.push(this.uri.replace(/\/:[\w\.]+\?/g, function (key) {
	
	            // Add any *optional* dynamic keys from the model (/foo/:bar? -> /foo/{{model.bar}})
	
	            key = key.slice(2);
	            key = key.substring(0, key.length - 1);
	
	            var component = model.get ? model.get(key) : model[key];
	
	            if (!component) {
	                return '';
	            }
	
	            return '/' + component;
	        }).replace(/:[\w\.]+/g, function (key) {
	
	            // Add any dynamic keys from the model (/foo/:bar -> /foo/{{model.bar}})
	
	            key = key.slice(1);
	
	            var component = model.get ? model.get(key) : model[key];
	
	            if (!component) {
	                throw new Error('Property "' + key + '" not found in model for: ' + self.uri);
	            }
	
	            return component;
	        }));
	
	        // Add the action, if provided (`foo.action('bar', {...})` -> /api/foo/bar
	        if (action) {
	            uri.push(action);
	        }
	
	        // Add the extension (e.g. for doing a GET on a .json resource)
	        if (this.ext) {
	            uri[uri.length - 1] += '.' + this.ext;
	        }
	
	        // Join the uri segments and strip any extra slashes
	        uri = '/' + uri.join('/').replace(/\/{2,}/g, '/').replace(/^\//, '');
	
	        // Add on the base uri, e.g. /webapps/hermes
	        if (!relative) {
	            uri = (this.baseURI || _config.$config.urls.baseUrl) + uri;
	        }
	
	        return uri;
	    },
	
	    // Attach meta data provided by the parent app
	    buildMeta: function buildMeta() {
	        if (metaBuilder) {
	            return metaBuilder();
	        }
	    },
	
	    // Build the name of the api for logging. /api/foo/bar -> api_foo_bar
	    buildAPIName: function buildAPIName(options) {
	        var self = this;
	        var apiName = self.uri.replace(/^\/+/, ''). // Remove leading '/'
	        replace(/\//g, '_'). // Replace remaining '/' with '_'
	        replace(/\?(.*)/, ''). // Remove everything after '?'
	        replace(/[^a-zA-Z0-9_]/g, '');
	        apiName = options.action ? apiName + '_' + options.action : apiName;
	        apiName = apiName.charAt(0) === '_' ? apiName.slice(1) : apiName;
	        return apiName;
	    }
	});
	
	$Api.reopenClass({
	    clearCache: function clearCache() {
	        cache = {};
	    }
	});
	
	$Api.registerMetaBuilder = function (builder) {
	    metaBuilder = builder;
	};
	
	var $batchApi = new $Api({
	    uri: '/api/batch',
	    postAttempts: 3
	});
	
	function $getLatestCorrelationID() {
	    return latestCorrelationID;
	}
	
	angular.value("$Api", $Api);
	angular.value("$getLatestCorrelationID", $getLatestCorrelationID);
	_logger.$logger;
	
	_event.$event;
	
	_class.$Class;
	
	_util.$util;
	
	_promise.$promise;
	
	_config.$config;
	
	_config.$meta;
	
	_error.$Contingency;
	
	_error.$Forbidden;
	
	_error.$ApiError;
	
	_error.$BatchShortCircuit;
	
	_loader.$loader;

/***/ },

/***/ "./components/squid/dist/core/event.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$event = undefined;
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var handlers = {};
	
	var customEventEmitter = void 0;
	
	var $event = exports.$event = {
	    use: function use(eventEmitter) {
	        customEventEmitter = eventEmitter;
	
	        for (var _iterator = Object.keys(handlers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var eventName = _ref;
	
	            if (handlers[eventName]) {
	                for (var _iterator2 = handlers[eventName], _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	                    var _ref2;
	
	                    if (_isArray2) {
	                        if (_i2 >= _iterator2.length) break;
	                        _ref2 = _iterator2[_i2++];
	                    } else {
	                        _i2 = _iterator2.next();
	                        if (_i2.done) break;
	                        _ref2 = _i2.value;
	                    }
	
	                    var handler = _ref2;
	
	                    customEventEmitter.on(eventName, handler);
	                }
	            }
	        }
	    },
	    on: function on(eventName, method) {
	
	        if (customEventEmitter) {
	            return customEventEmitter.on(eventName, method);
	        }
	
	        handlers[eventName] = handlers[eventName] || [];
	        handlers[eventName].push(method);
	
	        var cancelled = false;
	
	        function cancel() {
	            if (!cancelled) {
	                handlers[eventName].splice(handlers[eventName].indexOf(method), 1);
	                cancelled = true;
	            }
	        }
	
	        cancel.cancel = cancel;
	        return cancel;
	    },
	    once: function once(eventName, method) {
	
	        if (customEventEmitter) {
	            return customEventEmitter.once(eventName, method);
	        }
	
	        var listener = $event.on(eventName, function () {
	            listener.cancel();
	            return method.apply(this, arguments);
	        });
	
	        return listener;
	    },
	    emit: function emit(eventName) {
	
	        if (customEventEmitter) {
	            var _customEventEmitter;
	
	            return (_customEventEmitter = customEventEmitter).emit.apply(_customEventEmitter, arguments);
	        }
	
	        var event = {
	            preventDefault: function preventDefault() {
	                event.defaultPrevented = true;
	            }
	        };
	
	        if (handlers[eventName]) {
	            for (var _iterator3 = Array.prototype.slice.apply(handlers[eventName]), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	                var _ref3;
	
	                if (_isArray3) {
	                    if (_i3 >= _iterator3.length) break;
	                    _ref3 = _iterator3[_i3++];
	                } else {
	                    _i3 = _iterator3.next();
	                    if (_i3.done) break;
	                    _ref3 = _i3.value;
	                }
	
	                var handler = _ref3;
	
	                handler.apply.apply(handler, [this, event].concat(Array.prototype.slice.call(arguments)));
	            }
	        }
	
	        return event;
	    },
	    broadcast: function broadcast(eventName) {
	
	        if (customEventEmitter) {
	            var _customEventEmitter2;
	
	            return (_customEventEmitter2 = customEventEmitter).broadcast.apply(_customEventEmitter2, arguments);
	        }
	
	        return $event.emit.apply($event, arguments);
	    },
	
	
	    refCount: function refCount($scope, start, stop) {
	        return _promise.$promise.resolver(function (resolve) {
	
	            var count = 0;
	
	            function res() {
	                if (!count) {
	
	                    if (cancelStartListener && cancelStopListener) {
	                        cancelStartListener();
	                        cancelStopListener();
	                    }
	
	                    return resolve();
	                }
	            }
	
	            var cancelStartListener = $scope.$on(start, function (event, data) {
	                count += 1;
	            });
	
	            var cancelStopListener = $scope.$on(stop, function (event, data) {
	                setTimeout(function () {
	                    count -= 1;
	                    res();
	                }, 50);
	            });
	
	            setTimeout(res, 50);
	        });
	    },
	
	    compose: function compose(start, end, startAll, endAll) {
	
	        var count = 0;
	
	        $event.on(start, function () {
	
	            if (!count) {
	                setTimeout(function () {
	                    $event.emit(startAll);
	                });
	            }
	
	            count += 1;
	        });
	
	        $event.on(end, function () {
	
	            setTimeout(function () {
	                count -= 1;
	
	                if (!count) {
	                    $event.emit(endAll);
	                }
	            }, 50);
	        });
	
	        return {
	            getCount: function getCount() {
	                return count;
	            },
	            isActive: function isActive() {
	                return Boolean(count);
	            },
	            reset: function reset() {
	                count = 0;
	            }
	        };
	    }
	};
	
	angular.value("$event", $event);
	_promise.$promise;

/***/ },

/***/ "./components/squid/dist/core/promise.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$promise = $promise;
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var Promise = window.Promise;
	
	function $promise(obj) {
	    return Promise.resolve(obj);
	}
	
	_util.$util.extend($promise, {
	    use: function use(CustomPromise) {
	        Promise = CustomPromise;
	    },
	    resolver: function resolver(method) {
	        return new Promise(method);
	    },
	    resolve: function resolve(value) {
	        return Promise.resolve(value);
	    },
	    reject: function reject(value) {
	        return Promise.reject(value);
	    },
	
	
	    run: function run(method) {
	        return Promise.resolve().then(method);
	    },
	
	    call: function call(method) {
	        return Promise.resolve().then(method);
	    },
	
	    sequential: function sequential(methods) {
	
	        var prom = Promise.resolve();
	
	        _util.$util.forEach(methods, function (method) {
	            prom = prom.then(method);
	        });
	
	        return prom;
	    },
	
	    sleep: function sleep(time) {
	        return new Promise(function (resolve) {
	            setTimeout(resolve, time);
	        });
	    },
	
	    map: function map(items, method) {
	
	        var promises = void 0;
	
	        if (items instanceof Array) {
	            promises = [];
	        } else if (items instanceof Object) {
	            promises = {};
	        } else {
	            return Promise.resolve();
	        }
	
	        return this.all(_util.$util.map(items, function (item, key) {
	
	            promises[key] = Promise.resolve(item).then(function (result) {
	                return method(result, key, promises);
	            });
	
	            return promises[key];
	        }));
	    },
	
	    all: function all(items) {
	
	        if (items instanceof Array) {
	            return Promise.all(items);
	        } else if (items instanceof Object) {
	            return this.hash(items);
	        }
	
	        return Promise.resolve([]);
	    },
	
	    hash: function hash(obj) {
	        var results = {};
	
	        return Promise.all(_util.$util.map(obj, function (item, key) {
	            return Promise.resolve(item).then(function (result) {
	                results[key] = result;
	            });
	        })).then(function () {
	            return results;
	        });
	    },
	
	    extend: function extend(obj, hash) {
	        return this.hash(hash || {}).then(function (data) {
	            _util.$util.extend(obj, data);
	        });
	    },
	
	    attempt: function attempt(attempts, method) {
	
	        attempts -= 1;
	
	        return Promise.resolve().then(function () {
	            return method(attempts);
	        })['catch'](function (err) {
	
	            if (attempts) {
	                return $promise.attempt(attempts, method);
	            }
	
	            return Promise.reject(err);
	        });
	    },
	
	    debounce: function debounce(method, time) {
	
	        var timeout = void 0;
	        var resolvers = {};
	
	        return function () {
	
	            var self = this;
	            var args = arguments;
	            var key = JSON.stringify(args);
	
	            resolvers[key] = resolvers[key] || [];
	
	            return new Promise(function (resolve) {
	                resolvers[key].push(resolve);
	                clearTimeout(timeout);
	
	                timeout = setTimeout(function () {
	
	                    var result = method.apply(self, args);
	
	                    _util.$util.forEach(resolvers[key], function (resolver) {
	                        resolver(result);
	                    });
	
	                    delete resolvers[key];
	                }, time);
	            });
	        };
	    },
	
	    every: function every(collection, handler) {
	        return this.map(collection, function (item) {
	            return handler(item);
	        }).then(function (results) {
	            return _util.$util.every(results);
	        });
	    },
	
	    providing: function providing(condition, handler) {
	        return Promise.resolve(condition).then(function (result) {
	            if (result) {
	                return handler(result);
	            }
	        });
	    },
	
	    until: function until(condition, pollTime, timeout, alwaysResolve) {
	
	        return new Promise(function (resolve, reject) {
	            if (condition()) {
	                return resolve();
	            }
	
	            var interval = setInterval(function () {
	                if (condition()) {
	                    clearInterval(interval);
	                    return resolve();
	                }
	            }, pollTime);
	
	            if (timeout) {
	                setTimeout(function () {
	                    clearInterval(interval);
	                    return alwaysResolve ? resolve() : reject();
	                }, timeout);
	            }
	        });
	    },
	
	    first: function first(handlers) {
	
	        var prom = $promise.resolve();
	        var result = void 0;
	
	        _util.$util.forEach(handlers, function (handler) {
	            prom = prom.then(function () {
	                return result || handler();
	            }).then(function (handlerResult) {
	                result = handlerResult;
	                return result;
	            });
	        });
	
	        return prom;
	    }
	});
	
	angular.value("$promise", $promise);
	_util.$util;

/***/ },

/***/ "./components/squid/dist/core/util.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$unresolved = exports.$util = undefined;
	exports.$getRedirectUrl = $getRedirectUrl;
	exports.$dispatch = $dispatch;
	exports.$experiment = $experiment;
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _base = __webpack_require__("./components/base64/base64.min.js");
	
	var base64 = _interopRequireWildcard(_base);
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	var _integration = __webpack_require__("./components/squid/dist/core/integration.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var redirected = false;
	var paramCache = {};
	
	// incase base64 has been CJS packed, it will export itself
	if (typeof window.atob === 'undefined' || typeof window.btoa === 'undefined') {
	    window.atob = base64.atob;
	    window.btoa = base64.btoa;
	}
	
	var $util = exports.$util = {
	
	    forEach: function forEach(collection, method) {
	        if (collection instanceof Array) {
	            for (var i = 0; i < collection.length; i++) {
	                method(collection[i], i);
	            }
	        } else if (collection instanceof Object) {
	            for (var key in collection) {
	                if (collection.hasOwnProperty(key)) {
	                    method(collection[key], key);
	                }
	            }
	        }
	    },
	
	    idleTimeout: function idleTimeout(time) {
	        setTimeout(function () {
	            _logger.$logger.info('page_idle');
	            $util.reload();
	        }, time);
	    },
	
	
	    reload: function reload() {
	        _logger.$logger.info('reload');
	        _event.$event.emit('loading');
	        window.location.reload();
	    },
	
	    redirect: function redirect(url, options) {
	
	        if (url.toLowerCase().indexOf('javascript:') !== -1) {
	            // eslint-disable-line
	            _logger.$logger.error('unsafe_redirect_url', {
	                url: url
	            });
	            throw new Error('Unsafe redirect url: ' + url);
	        }
	
	        _logger.$logger.info('redirect', {
	            url: url
	        });
	
	        _event.$event.on('$stateChangeStart', function (event) {
	            _logger.$logger.info('state_change_after_redirect');
	            event.preventDefault();
	        });
	
	        function redir() {
	
	            if (redirected) {
	                return;
	            }
	
	            _logger.$logger.info('redirect', {
	                url: url
	            });
	
	            window.onunload = window.onbeforeunload = function () {};
	
	            if (_integration.$integration.getConfig('REDIRECT_TOP') !== false) {
	                window.top.location = url;
	            } else {
	                window.location = url;
	            }
	
	            redirected = true;
	        }
	
	        _event.$event.emit('loading');
	
	        _logger.$logger.flush().then(redir);
	        setTimeout(redir, 500);
	
	        _logger.$logger.done();
	    },
	
	    cookiesEnabled: function cookiesEnabled() {
	        var cookiesEnabled = void 0;
	
	        document.cookie = '_cookiecheck=1';
	        cookiesEnabled = Boolean(document.cookie.indexOf('_cookiecheck') > -1);
	        document.cookie = '_cookiecheck=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	        document.cookie = '_cookiecheck; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	
	        return cookiesEnabled;
	    },
	
	    storageEnabled: function storageEnabled(api) {
	        try {
	            window[api].setItem('__feature_test__', '0');
	            window[api].removeItem('__feature_test__');
	            return true;
	        } catch (e) {
	            return false;
	        }
	    },
	
	    sessionStorageEnabled: function sessionStorageEnabled() {
	        return this.storageEnabled('sessionStorage');
	    },
	
	    localStorageEnabled: function localStorageEnabled() {
	        return this.storageEnabled('localStorage');
	    },
	
	    params: function params(string) {
	
	        if (typeof string !== 'string') {
	            string = this.queryString().slice(1);
	        }
	
	        var params = {};
	
	        if (!string) {
	            return params;
	        }
	
	        if (paramCache[string]) {
	            return paramCache[string];
	        }
	
	        $util.forEach(string.split('&'), function (pair) {
	            pair = pair.split('=');
	
	            if (pair[0] && pair[1]) {
	                params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	            }
	        });
	
	        paramCache[string] = params;
	
	        return params;
	    },
	
	    queryString: function queryString() {
	        if (window.location.search) {
	            return window.location.search;
	        } else {
	            var string = window.location.href;
	            var idx = string.indexOf('&');
	            var rIdx = string.lastIndexOf('#');
	
	            if (idx) {
	                return '?' + string.substring(idx, rIdx >= 0 ? rIdx : string.length);
	            }
	        }
	        return '';
	    },
	
	    queryStringSplice: function queryStringSplice(qs, insert, remove) {
	        if (qs.indexOf('?') === 0) {
	            qs = qs.slice(1);
	        }
	
	        var params = $util.extend(this.params(qs), insert);
	
	        $util.forEach(remove, function (key) {
	            delete params[key];
	        });
	
	        return '?' + this.paramToQueryString(params);
	    },
	
	    extend: function extend(obj, source) {
	
	        if (!source) {
	            return obj;
	        }
	
	        for (var key in source) {
	            if (source.hasOwnProperty(key)) {
	                obj[key] = source[key];
	            }
	        }
	
	        return obj;
	    },
	
	
	    paramToQueryString: function paramToQueryString(params) {
	        return this.filter(this.map(Object.keys(params).sort(), function (key) {
	            if (!params[key]) {
	                return;
	            }
	
	            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
	        })).join('&');
	    },
	
	    param: function $param(name) {
	        return this.params()[name];
	    },
	
	    hashParam: function hashParam(name) {
	        return this.params(window.location.hash.slice(1))[name];
	    },
	
	    base64Decode: function base64Decode(encodedString) {
	        return encodedString && window.atob(encodedString); // eslint-disable-line block-scoped-var,no-undef
	    },
	
	    /*
	     * decodeAndParse :
	     * 1 - Base64Decode
	     * 2 - URI Decode
	     * 3 - Split string into a nvp object
	     * return obj
	     */
	    decodeAndParse: function decodeAndParse(encodedString) {
	        if (encodedString) {
	            return this.params(decodeURIComponent(this.base64Decode(encodedString)));
	        }
	    },
	
	    assert: function $assert(value, message, payload) {
	        if (!value) {
	            throw new Error(message, payload || {});
	        }
	    },
	
	    map: function $map(array, method) {
	
	        array = array || [];
	
	        var results = void 0;
	
	        if (array instanceof Array) {
	            results = [];
	
	            $util.forEach(array, function () {
	                results.push(method.apply(this, arguments));
	            });
	
	            return results;
	        } else if (array instanceof Object) {
	
	            results = {};
	
	            $util.forEach(array, function (val, key) {
	                results[key] = method.apply(this, arguments);
	            });
	
	            return results;
	        } else {
	            throw new Error('$util.map expects array or object');
	        }
	    },
	
	    filter: function $filter(array, method) {
	        method = method || Boolean;
	        var results = [];
	
	        $util.forEach(array, function (item) {
	            if (method.apply(this, arguments)) {
	                results.push(item);
	            }
	        });
	
	        return results;
	    },
	
	    find: function $find(array, method) {
	
	        if (!array) {
	            return;
	        }
	
	        for (var i = 0; i < array.length; i++) {
	            if (method(array[i])) {
	                return array[i];
	            }
	        }
	    },
	
	    findIndex: function $find(array, method) {
	
	        if (!array) {
	            return;
	        }
	
	        for (var i = 0; i < array.length; i++) {
	            if (method(array[i])) {
	                return i;
	            }
	        }
	    },
	
	    range: function range(start, end) {
	        if (!end) {
	            end = start;
	            start = 0;
	        }
	
	        var result = [];
	
	        for (var i = start; i < end; i++) {
	            result.push(i);
	        }
	
	        return result;
	    },
	
	    pad: function $pad(string, n, char) {
	
	        n = n || 0;
	        char = char || '0';
	
	        var padding = Array(n + 1).join(char.toString());
	
	        return (padding + string).slice(-n);
	    },
	
	    some: function $some(array, method) {
	        var result = void 0;
	
	        $util.forEach(array, function (item, key) {
	            if (!result) {
	                result = method(item, key);
	            }
	        });
	
	        return result;
	    },
	
	    every: function $every(array, method) {
	        method = method || Boolean;
	
	        var result = true;
	
	        $util.forEach(array, function (item) {
	            if (!method(item)) {
	                result = false;
	            }
	        });
	
	        return result;
	    },
	
	    reduce: function $reduce(array, method, intial) {
	        $util.forEach(array, function (item) {
	            intial = method(intial, item);
	        });
	
	        return intial;
	    },
	
	    isPopup: function isPopup() {
	        return _integration.$integration.isPopup();
	    },
	
	    isIFrame: function isIFrame() {
	        return _integration.$integration.isIFrame();
	    },
	
	    buildURL: function buildURL(url, params) {
	        /*
	         * Do NOT add a check for anchor cause this function is also used for building XO success / cancel urls.
	         * These urls are defined by the merchants and can also contain urls like "abc.com#merchantanchor" and merchants
	         * expect (!) the following outcome: abc.com#merchantanchor?paypalparam=2
	         */
	        this.assert(url, 'buildURL :: expected url');
	
	        var paramKeys = Object.keys(params || {});
	
	        if (JSON.stringify(params) === '{}') {
	            return url;
	        }
	
	        if (!paramKeys.length) {
	            return url;
	        }
	
	        if (url.indexOf('?') === -1) {
	            url += '?';
	        } else {
	            url += '&';
	        }
	
	        url += this.paramToQueryString(params);
	
	        return url;
	    },
	
	    paypalURL: function paypalURL(url, params) {
	        url = 'https://' + (_config.$meta.stage ? _config.$meta.stage : window.location.host) + url;
	
	        return this.buildURL(url, params);
	    },
	
	    override: function override(obj, methodName, handler) {
	        var existing = obj[methodName];
	
	        obj[methodName] = function () {
	            if (existing) {
	                try {
	                    existing.apply(obj, arguments);
	                } catch (err) {
	                    _logger.$logger.error(methodName + 'event_error', {
	                        error: err.toString
	                    });
	                }
	            }
	
	            return handler.apply(obj, arguments);
	        };
	    },
	
	    result: function result(method) {
	        return method();
	    },
	
	    memoize: function memoize(method) {
	        var result = void 0;
	        var called = false;
	
	        function memoized() {
	            if (!called) {
	                result = method.apply(this, arguments);
	            }
	            called = true;
	            return result;
	        }
	
	        memoized.flush = function () {
	            called = false;
	        };
	
	        return memoized;
	    },
	
	    now: function now() {
	        return window.enablePerformance ? parseInt(window.performance.now(), 10) : Date.now();
	    },
	
	    bindObject: function bindObject(obj, self) {
	        return $util.map(obj, function (method) {
	            return method.bind(self);
	        });
	    },
	
	    hashStr: function hashStr(str) {
	        var hash = 0,
	            i = void 0,
	            chr = void 0,
	            len = void 0;
	        if (str.length === 0) {
	            return hash;
	        }
	        for (i = 0, len = str.length; i < len; i++) {
	            chr = str.charCodeAt(i);
	            hash = (hash << 5) - hash + chr; // eslint-disable-line no-bitwise, no-extra-parens
	            // Convert to 32bit integer
	            hash |= 0; // eslint-disable-line no-bitwise
	        }
	        return Math.abs(hash);
	    },
	
	    hash: function hash() {
	        return this.hashStr(Math.random());
	    },
	
	    popup: function popup(name, url, options, callback) {
	
	        callback = $util.once(callback);
	
	        var win = window.open(url, name, $util.map(Object.keys(options), function (key) {
	            return key + '=' + options[key];
	        }).join(', '));
	
	        var interval = void 0;
	
	        function checkWindowClosed() {
	            if (win.closed) {
	                clearInterval(interval);
	                callback();
	            }
	        }
	
	        interval = setInterval(checkWindowClosed, 50);
	        setTimeout(checkWindowClosed);
	
	        try {
	            (function () {
	                var close = win.close;
	                win.close = function () {
	                    close.apply(this, arguments);
	                    checkWindowClosed();
	                };
	            })();
	        } catch (err) {
	            // pass
	        }
	
	        return win;
	    },
	
	    unique: function unique(collection) {
	        return collection.filter(function (value, index, self) {
	            return self.indexOf(value) === index;
	        });
	    },
	
	    monkeyPatch: function monkeyPatch(mod, prop, method) {
	        var original = mod[prop];
	
	        mod[prop] = function () {
	            var _this = this,
	                _arguments = arguments;
	
	            return method.call(this, arguments, function (self, args) {
	                if (original) {
	                    return original.apply(self || _this, args || _arguments);
	                }
	            });
	        };
	    },
	    once: function once(method) {
	        var called = false;
	
	        return function () {
	            if (!called) {
	                called = true;
	                return method.apply(this, arguments);
	            }
	        };
	    },
	    camelToDasherize: function camelToDasherize(string) {
	        return string.replace(/([A-Z])/g, function (g) {
	            return '-' + g.toLowerCase();
	        });
	    },
	    camelToCapsUnderscore: function camelToCapsUnderscore(string) {
	        return string.replace(/([a-z][A-Z])/g, function (g) {
	            return g[0] + '_' + g[1];
	        }).toUpperCase();
	    },
	    dasherizeToCamel: function dasherizeToCamel(string) {
	        return string.replace(/-([a-z])/g, function (g) {
	            return g[1].toUpperCase();
	        });
	    },
	
	
	    parentWindow: function parentWindow() {
	        if (window.opener) {
	            return window.opener;
	        } else if (window.parent !== window) {
	            return window.parent;
	        }
	    },
	
	    hasRTL: function hasRTL(str) {
	        return new RegExp('[\u0590-\u07BF]').test(str);
	    },
	    noop: function noop() {}
	};
	
	var $unresolved = exports.$unresolved = { then: $util.noop, 'catch': $util.noop };
	
	function $getRedirectUrl(product, params) {
	    var url = '';
	    var urlParams = $util.params();
	
	    if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
	        url = _config.$config.urls.dispatch && _config.$config.urls.dispatch[product] || '';
	    }
	
	    url += _config.$config.urls.fallbackUrl[product];
	
	    $util.extend(urlParams, params || {});
	
	    // cmd is a reserved slingshot param
	    if (urlParams.cmd) {
	        delete urlParams.cmd;
	    }
	
	    return $util.buildURL(url, urlParams);
	}
	
	function $dispatch(product, params, stateChange) {
	    $util.assert(product, 'expected product');
	
	    _logger.$logger.log('info', 'dispatch', {
	        product: product
	    });
	
	    _event.$event.emit('loading');
	
	    var url = '';
	
	    url = $getRedirectUrl(product, params);
	
	    // fire an event for xo-tracking to listen to and do fpti logging
	    if (stateChange) {
	        _event.$event.emit('page_loaded', stateChange.fromState, stateChange.toState);
	    }
	
	    return $util.redirect(url);
	}
	
	function $experiment(name, sample, id, loggerPayload) {
	
	    var throttle = $util.hashStr(name + '_' + id) % 100;
	
	    var group = void 0;
	
	    if ($util.param(name) === 'true') {
	        group = 'test_forced';
	    } else if ($util.param(name) === 'false') {
	        group = 'control_forced';
	    } else if (throttle < sample) {
	        group = 'test';
	    } else if (sample >= 50 || sample <= throttle && throttle < sample * 2) {
	        // eslint-disable-line no-extra-parens
	        group = 'control';
	    } else {
	        group = 'throttle';
	    }
	
	    _logger.$logger.info('fpti_pxp_check', {
	        from: 'PXP_CHECK',
	        to: 'process_pxp_check',
	        pxp_exp_id: name,
	        pxp_trtmnt_id: group
	    });
	
	    _logger.$logger.info(name + '_' + group, loggerPayload || {});
	
	    if (group === 'test' || group === 'test_forced') {
	        return true;
	    } else if (group === 'control') {
	        return false;
	    }
	}
	
	angular.value("$util", $util);
	angular.value("$unresolved", $unresolved);
	angular.value("$getRedirectUrl", $getRedirectUrl);
	angular.value("$dispatch", $dispatch);
	angular.value("$experiment", $experiment);
	_event.$event;
	
	_logger.$logger;
	
	_config.$config;
	
	_config.$meta;
	
	_integration.$integration;

/***/ },

/***/ "./components/base64/base64.min.js":
/***/ function(module, exports, __webpack_require__) {

	!function(){function t(t){this.message=t}var r= true?exports:this,e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";t.prototype=new Error,t.prototype.name="InvalidCharacterError",r.btoa||(r.btoa=function(r){for(var o,n,a=String(r),i=0,c=e,d="";a.charAt(0|i)||(c="=",i%1);d+=c.charAt(63&o>>8-i%1*8)){if(n=a.charCodeAt(i+=.75),n>255)throw new t("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");o=o<<8|n}return d}),r.atob||(r.atob=function(r){var o=String(r).replace(/=+$/,"");if(o.length%4==1)throw new t("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,a,i=0,c=0,d="";a=o.charAt(c++);~a&&(n=i%4?64*n+a:a,i++%4)?d+=String.fromCharCode(255&n>>(-2*i&6)):0)a=e.indexOf(a);return d})}();


/***/ },

/***/ "./components/squid/dist/core/config.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	var $meta = exports.$meta = window.meta || {};
	var $cookies = exports.$cookies = window.cookies || {};
	var $config = exports.$config = window.config || {};
	angular.value("$meta", $meta);
	angular.value("$cookies", $cookies);
	angular.value("$config", $config);

/***/ },

/***/ "./components/squid/dist/core/integration.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$integration = exports.$CONTEXT = exports.$DEFAULT = undefined;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var $DEFAULT = exports.$DEFAULT = 'DEFAULT';
	
	var $CONTEXT = exports.$CONTEXT = {
	
	    // Full page checkout
	    FULLPAGE: 'FULLPAGE',
	
	    // Checkout in popup
	    POPUP: 'POPUP',
	
	    // Checkout in lightbox (iframe)
	    LIGHTBOX: 'LIGHTBOX',
	
	    // Web view
	    WEBVIEW: 'WEBVIEW',
	
	    // Native checkout
	    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
	};
	
	var $integration = exports.$integration = {
	
	    flow: $DEFAULT,
	
	    init: function init(flow, config) {
	        this.config = config || {};
	
	        if (flow) {
	            this.setFlow(flow);
	        }
	
	        this.setContext(this.getContext());
	    },
	    getContext: function getContext() {
	
	        if (this.isIFrame()) {
	            return $CONTEXT.LIGHTBOX;
	        } else if (this.isPopup()) {
	            return $CONTEXT.POPUP;
	        } else {
	            return $CONTEXT.FULLPAGE;
	        }
	    },
	    isPopup: function isPopup() {
	        return Boolean(window.opener);
	    },
	    isIFrame: function isIFrame() {
	        return window.top !== window.self;
	    },
	    setContext: function setContext(context) {
	        _logger.$logger.info('integration_context_' + context);
	        this.context = context;
	    },
	    setFlow: function setFlow(flow) {
	        _logger.$logger.info('integration_flow_' + flow);
	        this.flow = flow;
	    },
	    is: function is(context, flow) {
	        return this.isContext(context) && this.isFlow(flow);
	    },
	    isContext: function isContext(context) {
	        return this.context === context;
	    },
	    isFlow: function isFlow(flow) {
	        return this.flow === flow;
	    },
	    getConfig: function getConfig(key) {
	
	        this.context = this.getContext();
	
	        if (!this.config) {
	            return;
	        }
	
	        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(this.flow) && this.config[this.context][this.flow].hasOwnProperty(key)) {
	
	            return this.config[this.context][this.flow][key];
	        }
	
	        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(key)) {
	
	            return this.config[this.context][key];
	        }
	
	        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(this.flow) && this.config[$DEFAULT][this.flow].hasOwnProperty(key)) {
	
	            return this.config[$DEFAULT][this.flow][key];
	        }
	
	        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(key)) {
	
	            return this.config[$DEFAULT][key];
	        }
	    },
	    error: function error(message) {
	        return new Error('Integration error: ' + this.context + ' / ' + this.flow + ' :: ' + message);
	    }
	};
	
	angular.value("$integration", $integration);
	_logger.$logger;

/***/ },

/***/ "./components/squid/dist/core/class.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 Class
	 -----
	
	 A class pattern, adding sugar on top of javascript prototypes
	
	 ### Basic Usage
	
	 let MyClass = Class.extend({
	 foo: 'bar';
	 });
	
	 myInstance = new MyClass({
	 hello: 'world'
	 });
	
	 console.log(myInstance.foo, myInstance.hello)
	
	 In this example, `foo` becomes a property on `MyClass`'s prototype,
	 and `hello` becomes a property on `myInstance`.
	
	 ### Default Object Methods
	
	 - `init()`: Called after the object is first instantiated, with all properties available
	
	 - `get(<path>, <default>)`: Get an object an arbitrary number of levels deep, or return a default
	
	 e.g. `myInstance.get('foo.bar.baz', 'some_default');`
	
	 Default return value is undefined
	
	 - `set(<path>, <value>)`: Set an object an arbitrary number of levels deep
	
	 e.g. `myInstance.set('foo.bar.baz', 'some_value');`
	
	 Error is thrown if no object is found to set the value on
	
	 - `setProperties(<object>)`: Set all the properties from an object onto your object
	
	 e.g. `myInstance.setProperties({foo: 'bar', hello: 'world'})`
	
	 Can not be used with nested properties
	
	 - `forEach(<callback>)`: Loop through the object and call callback(<key>, <value>) for each key/val pair
	
	 */
	
	// Object Create
	// -------------
	//
	// Shim for Object.create, if it is not supported by our browser
	//
	// let myPrototype = {foo: 'bar'}
	// let myObject = create(myPrototype)
	
	// Create an empty anonymous constructor with no side effects, for re-use later
	var EmptyConstructor = function EmptyConstructor() {};
	
	var create = Object.create || function create(obj) {
	
	    // Set a temporary prototype
	    EmptyConstructor.prototype = obj;
	
	    // Create an object using our temporary constructor/prototype
	    var instance = new EmptyConstructor();
	
	    // Reset the prototype for next time
	    EmptyConstructor.prototype = null;
	
	    // Return our new object, created without side effects
	    return instance;
	};
	
	function _extend(obj, source) {
	
	    if (!source) {
	        return obj;
	    }
	
	    for (var key in source) {
	        if (source.hasOwnProperty(key)) {
	            obj[key] = source[key];
	        }
	    }
	
	    return obj;
	}
	
	// Is Object
	// ---------
	//
	// Check of a let is an object or not
	//
	// isobject({}) -> true
	// isobject('foo') -> false
	
	function isobject(obj) {
	    return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj instanceof Object;
	}
	
	// Transpose properties
	// -------------------------------------------------------------------
	//
	// Transpose properties from a list of objects onto a recipient object
	//
	// let recipient = {};
	// transpose(recipient, [{a: 1, b: 2}, {c: 3}])
	// recipient -> {a: 1, b: 2, c:3}
	
	function transpose(recipient, args) {
	
	    // Loop through all args
	    for (var i = 0; i < args.length; i++) {
	        var ob = args[i];
	
	        // Ignore anything that is not an object
	        if (!isobject(ob)) {
	            continue;
	        }
	
	        // Loop through all keys in our object
	        for (var key in ob) {
	
	            // Ignore any prototypal properties
	            if (!ob.hasOwnProperty(key)) {
	                continue;
	            }
	
	            var item = ob[key];
	
	            // Give the function a name
	            if (item instanceof Function) {
	                item.__name__ = key;
	            }
	
	            recipient[key] = item;
	        }
	    }
	}
	
	// Construct a Class
	// -----------------
	//
	// This is the primary constructor for all $Class objects
	
	function construct() {
	    // eslint-disable-line no-unused-vars
	
	    // Call any custom constructor;
	    if (this.construct) {
	        var ob = this.construct.apply(this, arguments);
	
	        // If we get a new object back, return that to the user
	        if (isobject(ob)) {
	            return ob;
	        }
	    }
	
	    // Load any provided properties directly onto the object
	    transpose(this, arguments);
	
	    // Initialize the object
	    if (this.init) {
	        this.init();
	    }
	}
	
	// Reopen an object
	// ----------------
	//
	// Add properties to the constructor's prototype
	//
	//     let Animal = $Class.extend();
	//
	//     Animal.reopen({
	//       type: 'animal',
	//     });
	//
	//     let cat = new Animal;
	//     console.log(cat.type);
	function reopen() {
	
	    // Add some more properies to our prototype
	    transpose(this.prototype, arguments);
	
	    return this;
	}
	
	// Reopen a class
	// --------------
	//
	// Add properties to the constructor. These will propogate through future extends
	//
	//     let Animal = $Class.extend();
	//
	//     Animal.reopenClass({
	//       fromCache: function(id) {
	//         return cache[id] || new this({id: id});
	//       }
	//     }
	//
	//     let cat = Animal.fromCache('cat_54');
	
	function reopenClass() {
	
	    // Add some more properies to our class
	    transpose(this, arguments);
	
	    // Add to __classmethods__
	    transpose(this.__classmethods__, arguments);
	
	    return this;
	}
	
	function isChild(Cls) {
	    return Cls && Cls.prototype instanceof this;
	}
	
	// Generate a new class
	// --------------------
	//
	// Generate a new constructor, with the specified name, and attach all static and prototypal methods
	
	var id = 0;
	
	function extend(name) {
	
	    var Cls = void 0,
	        className = void 0,
	        args = void 0,
	        argsLength = void 0,
	        startIndex = void 0;
	
	    // Accept an optional class name
	    if (typeof name === 'string') {
	
	        // Guard against javascript injection
	        if (!name.match(/^[\w$][\w\d]*$/)) {
	            throw new Error('Class name can not include special characters: ' + name);
	        }
	
	        // Use the provided name and slice out the first argument
	        className = name;
	        argsLength = arguments.length && arguments.length - 1;
	        startIndex = 1;
	    } else {
	
	        // Otherwise default to the parent name, or 'Object' if generating our first class
	        className = this.name || 'Object';
	        argsLength = arguments.length;
	        startIndex = 0;
	    }
	
	    args = new Array(argsLength);
	    for (var i = startIndex; i < arguments.length; i++) {
	        args[i - startIndex] = arguments[i];
	    }
	
	    // Dynamically create our constructor with a custom name
	    eval('Cls = function ' + className + '() { return construct.apply(this, arguments) }'); // eslint-disable-line no-eval
	
	    // Store the class name for future reference
	    Cls.__name__ = className;
	
	    // Set up a classmethods object. These will be inherited through subsequent extend() calls
	    Cls.__classmethods__ = {
	        extend: extend,
	        reopen: reopen,
	        reopenClass: reopenClass,
	        isChild: isChild
	    };
	
	    id += 1;
	    Cls.id = id;
	
	    // If we're being called on an existing class, e.g. Class.extend(), we should inherit from that class
	    if (this && this !== window) {
	
	        // Inherit everything from superclass prototype
	        Cls.prototype = create(this.prototype);
	
	        // Re-set the constructor, which is overwritten by create
	        Cls.prototype.constructor = Cls;
	
	        // Add a reference to the superclass prototype for super method calls
	        Cls.prototype._super = this.prototype;
	
	        // Inherit any class methods from the superclass
	        _extend(Cls.__classmethods__, this.__classmethods__);
	    }
	
	    // Add the class methods to our existing class
	    _extend(Cls, Cls.__classmethods__);
	
	    // Load any provided properties onto the constructor's prototype
	    transpose(Cls.prototype, args);
	
	    // Temporary: allow access from console/debugger
	    if (className.indexOf('$') === 0) {
	        window[className] = Cls;
	    } else {
	        window['$' + className] = Cls;
	    }
	
	    return Cls;
	}
	
	// Multi-layer get
	// ---------------
	//
	// Recursively gets a deep path from an object, returning a default value if any level is not found
	//
	// let obj = {bar: {baz: 1}}
	// get(obj, 'bar.baz', 'default') -> 1
	// get(obj, 'aaa.bbb', 'default') -> default
	
	function _get(item, path, def) {
	
	    if (!path) {
	        return def;
	    }
	
	    path = path.split('.');
	
	    // Loop through each section of our key path
	    for (var i = 0; i < path.length; i++) {
	
	        // If we have an object, we can get the key
	        if (isobject(item)) {
	            item = item[path[i]];
	            // Otherwise, we should return the default (undefined if not provided)
	        } else {
	            return def;
	        }
	    }
	
	    // If our final result is undefined, we should return the default
	    return item === undefined ? def : item;
	}
	
	// Multi-layer set
	// ---------------
	//
	// Recursively sets a deep path from an object
	//
	// let obj = {bar: {baz: 1}}
	// set(obj, 'bar.baz', 2)
	// obj.bar.baz -> 1
	
	function _set(item, path, value) {
	    path = path.split('.');
	
	    // Loop through each section of our key path except the last
	    for (var i = 0; i < path.length - 1; i++) {
	
	        // Get the next item down
	        item = item[path[i]];
	
	        // If we have an object, we're good
	        if (isobject(item)) {
	            continue;
	            // Otherwise, there's nothing to set our key on
	        } else {
	            throw new Error(path[i - 1] + '.' + path[i] + ' is not an object');
	        }
	    }
	
	    // Do the set on the retrieved object with our value
	    item[path[path.length - 1]] = value;
	}
	
	// Loop through object
	// -------------------
	//
	// Loop an object and apply a function for each key/value
	//
	// let ob = {a: 1, b: 2, c: 3}
	// each(ob, console.log) -> a 1  b 2  c 3
	
	function each(ob, callback) {
	    for (var key in ob) {
	        if (ob.hasOwnProperty(key)) {
	            callback.call(ob, key, ob[key]);
	        }
	    }
	}
	
	// Gey keys of object
	// ------------------
	//
	// Shim for Object.keys if it does not already exist
	//
	// let ob = {a: 1, b: 2, c: 3}
	// keys(ob) -> ['a', 'b', 'c']
	
	function _keys(ob) {
	
	    if (Object.keys) {
	        return Object.keys(ob);
	    }
	
	    var result = [];
	
	    for (var key in ob) {
	        if (ob.hasOwnProperty(key)) {
	            result.push(key);
	        }
	    }
	
	    return result;
	}
	
	// Create a base class that can be inherited from
	// ----------------------------------------------
	//
	// This is the public interface to the Class module.
	// All classes with extend from Class and be provided with a set of base convenience methods.
	
	var $Class = exports.$Class = extend('Class', {
	
	    init: function init() {
	        // Empty init class, so calls to _super can be safely made
	    },
	
	    get: function get(path, def) {
	        return _get(this, path, def);
	    },
	
	    set: function set(path, value) {
	        _set(this, path, value);
	    },
	
	    setProperties: function setProperties() {
	        transpose(this, arguments);
	    },
	
	    forEach: function forEach(callback) {
	        each(this, callback);
	    },
	
	    keys: function keys() {
	        return _keys(this);
	    }
	});
	
	$Class.get = _get;
	$Class.set = _set;
	$Class.keys = _keys;
	
	angular.value("$Class", $Class);

/***/ },

/***/ "./components/squid/dist/core/error.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$FallbackError = exports.$BatchShortCircuit = exports.$ApiError = exports.$Forbidden = exports.$Contingency = exports.$Error = undefined;
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	_util.$util.monkeyPatch(window, 'onerror', function (_ref, original) {
	    var message = _ref[0],
	        file = _ref[1],
	        line = _ref[2],
	        col = _ref[3],
	        err = _ref[4];
	
	
	    original();
	
	    _event.$event.emit('$windowError', {
	        message: message && (message.stack || message).toString(),
	        file: file && file.toString(),
	        line: line && line.toString(),
	        col: col && col.toString(),
	        stack: err && (err.stack || err).toString()
	    });
	});
	
	var $Error = exports.$Error = _class.$Class.extend.call(Error, '$Error', {
	
	    construct: function construct(err, properties) {
	
	        if (err instanceof Error) {
	            err = err.message;
	        }
	
	        if (properties) {
	            _util.$util.extend(this, properties);
	        }
	
	        this.payload = properties;
	
	        this.message = err;
	    }
	});
	
	var $Contingency = exports.$Contingency = $Error.extend('$Contingency', {
	    handle: function handle(handlers) {
	        var handler = handlers[this.message] || handlers['DEFAULT'];
	        if (handler) {
	            var result = handler.call(this, this.message, this);
	            if (typeof result !== 'undefined') {
	                return result;
	            }
	            return true;
	        }
	    }
	});
	
	var $Forbidden = exports.$Forbidden = $Error.extend('$Forbidden');
	
	var $ApiError = exports.$ApiError = $Error.extend('$ApiError');
	
	var $BatchShortCircuit = exports.$BatchShortCircuit = $Error.extend('$BatchShortCircuit');
	
	var $FallbackError = exports.$FallbackError = $Error.extend('$FallbackError', {
	    init: function init() {
	        this.reason = this.reason || '';
	        this.product = this.product || '';
	        this.entryPoint = this.entryPoint || '';
	    }
	});
	
	angular.value("$Error", $Error);
	angular.value("$Contingency", $Contingency);
	angular.value("$Forbidden", $Forbidden);
	angular.value("$ApiError", $ApiError);
	angular.value("$BatchShortCircuit", $BatchShortCircuit);
	angular.value("$FallbackError", $FallbackError);
	_event.$event;
	
	_class.$Class;
	
	_util.$util;

/***/ },

/***/ "./components/squid/dist/core/loader.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$loader = undefined;
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _firstLoad = false;
	
	var loader = _event.$event.compose('loading', 'loaded', 'startLoad', 'allLoaded');
	
	var $loader = exports.$loader = {
	
	    isLoading: function isLoading() {
	        return Boolean(loader.getCount());
	    },
	    firstLoad: function firstLoad() {
	        return _firstLoad;
	    },
	    reset: function reset() {
	        loader.reset();
	    }
	};
	
	_event.$event.on('allLoaded', function () {
	    _firstLoad = true;
	});
	
	angular.value("$loader", $loader);
	_event.$event;

/***/ },

/***/ "./components/squid/dist/core/model.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {
	
	exports.__esModule = true;
	exports.$Model = undefined;
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var $Model = exports.$Model = _class.$Class.extend('$Model', {
	
	    init: function init() {
	
	        if (this.keys().length) {
	            this.onPopulate();
	        }
	
	        if (this.id) {
	            var _cache = this.constructor._modelCache = this.constructor._modelCache || {};
	            _cache[this.id] = this;
	        }
	
	        this.meta = {
	            populated: false
	        };
	    },
	
	    /**
	     * Add the passed in properties to this Model.
	     * Sets the meta.populated to true. This flag
	     * can be used later to determine if the model is populated.
	     * Calls onPopulate() in the end.
	     */
	    populate: function populate() {
	
	        this.meta.populated = true;
	        this.setProperties.apply(this, arguments);
	        delete this.meta.invalidated;
	        this.onPopulate();
	        return this;
	    },
	
	    fetchChildren: function fetchChildren() {
	        return _promise.$promise.resolve();
	    },
	
	    /**
	     * Override this method, to execute any logic after model is populated.
	     */
	    onPopulate: function onPopulate() {},
	
	    /**
	     * Override this method to return a Mock instance. Must return a promise which resolves to model.
	     */
	    fetchMock: function fetchMock() {},
	
	    /**
	     * Retrieves the model.
	     *
	     * If model is already populated just returns a promise which resolves to `this`
	     * If there is a retriever for this model, then return the retreiver.
	     * Else calls the api to retrieve the model.
	     *
	     * @param options
	     * @returns {*}
	     */
	    retrieve: function retrieve(options) {
	        var self = this;
	
	        options = options || {};
	
	        if (self.meta.populated) {
	
	            if (options.success) {
	                return _promise.$promise.resolve(options.success(self));
	            }
	
	            return _promise.$promise.resolve(this);
	        }
	
	        if (this.retriever) {
	            return this.retriever;
	        }
	
	        if (!this.api) {
	            throw new Error('Tried to populate a model with no api');
	        }
	
	        options.model = this;
	
	        this.retriever = this.api.retrieve(options).then(function (res) {
	            return self;
	        })['finally'](function () {
	            delete self.retriever;
	        });
	
	        return this.retriever;
	    },
	
	    /**
	     * Calls a post on the api to save this model. Takes options as parameters.
	     * options will passed down to api.post.
	     *
	     * @param options
	     * @returns {*|HttpPromise}
	     */
	    save: function save(options) {
	        options = options || {};
	        options.model = this;
	
	        options.data = options.data || this.serialize();
	
	        return this.api.post(options);
	    },
	
	    /**
	     * Calls Api.action to perform any action on the model.
	     *
	     * Takes action name and optional 'options' object as parameters.
	     *
	     * Ex: $CheckoutSession.actions('create', [options])
	     *
	     * @param action
	     * @param options
	     * @returns {*}
	     */
	    action: function action(_action, options) {
	        options = options || {};
	        options.model = this;
	
	        return this.api.action(_action, options);
	    },
	
	    /**
	     * Use this method to force a api call to get the data.
	     *
	     * @param options
	     * @returns {*}
	     */
	    reload: function reload(options) {
	        this.meta.populated = false;
	        return this.retrieve(options);
	    },
	
	    stringify: function stringify() {
	        return JSON.stringify(this, 2);
	    },
	
	    log: function log() {
	        console.log(this.stringify());
	    },
	
	    serialize: function serialize() {},
	
	    /**
	     * Invalidate the current model. Sets the meta.populated to false and sets meta.invalidated to true.
	     */
	    invalidate: function invalidate() {
	        this.meta.populated = false;
	        this.meta.invalidated = true;
	    },
	
	    /**
	     * Creates a new Class with properties from `child`. Then assigns `this` as parent to the new Class.
	     *
	     * @param Cls
	     * @param child
	     * @returns {*}
	     */
	    child: function child(Cls, _child) {
	
	        if (!_child) {
	            return;
	        }
	
	        return Cls.create(_child.id || this.id, { parent: this }).populate(_child);
	    },
	
	    /**
	     *
	     * @param Cls
	     * @param children
	     * @returns {*}
	     */
	    children: function children(Cls, _children) {
	        var self = this;
	
	        if (!_children) {
	            return _children;
	        }
	
	        return _util.$util.map(_children, function (child) {
	            return self.child(Cls, child);
	        });
	    }
	});
	
	var cache = {};
	
	$Model.reopenClass({
	
	    instance: function instance(id) {
	
	        var modelCache = cache[this.id] = cache[this.id] || {};
	        var instance = modelCache[id || 0] || this.create.apply(this, arguments);
	
	        return instance;
	    },
	
	    retrieveInstance: function retrieveInstance() {
	        return this.instance.apply(this, arguments).retrieve();
	    },
	
	    create: function create(id) {
	
	        var modelCache = cache[this.id] = cache[this.id] || {};
	        var instance = modelCache[id || 0] = new this({ // eslint-disable-line new-cap
	            id: id || 0
	        });
	
	        instance.setProperties.apply(instance, Array.prototype.slice.call(arguments, 1));
	
	        return instance;
	    },
	
	    fetch: function fetch() {
	        console.warn('Model.fetch is deprecated, please use Model.instance');
	        return this.instance.apply(this, arguments);
	    },
	
	    clearCache: function clearCache() {
	        cache = {};
	    }
	});
	
	angular.value("$Model", $Model);
	_class.$Class;
	
	_util.$util;
	
	_promise.$promise;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "./components/squid/dist/core/dom.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$dom = undefined;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var $dom = exports.$dom = {
	
	    elementReady: function elementReady(id) {
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	
	            if (document.getElementById(id)) {
	                return resolve();
	            }
	
	            var interval = setInterval(function () {
	                if (document.getElementById(id)) {
	                    clearInterval(interval);
	                    return resolve();
	                }
	            }, 10);
	
	            setTimeout(60000, reject);
	        });
	    },
	
	    loadScript: function loadScript(name, src, timeout) {
	        var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	            var script = document.createElement('script');
	            var loadTimeout = void 0;
	
	            function clearScriptLoadTimeout() {
	                if (loadTimeout) {
	                    clearTimeout(loadTimeout);
	                    loadTimeout = undefined;
	                }
	            }
	
	            script.onload = function () {
	                clearScriptLoadTimeout();
	                setTimeout(resolve, 10);
	            };
	
	            // For Internet explorer 8 support
	            script.onreadystatechange = function () {
	                if (this.readyState === 'complete' || this.readyState === 'loaded') {
	                    clearScriptLoadTimeout();
	                    setTimeout(resolve, 10);
	                }
	            };
	
	            script.onerror = function (event) {
	                _logger.$logger.info('script_error', {
	                    script: src
	                });
	                return reject(new Error(name + '_loading_error'));
	            };
	
	            if (timeout) {
	                loadTimeout = setTimeout(function () {
	                    _logger.$logger.info('script_load_timedout', {
	                        script: src
	                    });
	                    return reject(new Error(name + '_loading_timed_out'));
	                }, timeout);
	            }
	
	            script.setAttribute('src', src);
	
	            for (var _iterator = Object.keys(attributes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                var _ref;
	
	                if (_isArray) {
	                    if (_i >= _iterator.length) break;
	                    _ref = _iterator[_i++];
	                } else {
	                    _i = _iterator.next();
	                    if (_i.done) break;
	                    _ref = _i.value;
	                }
	
	                var attribute = _ref;
	
	                script.setAttribute(attribute, attributes[attribute]);
	            }
	
	            document.body.appendChild(script);
	        });
	    },
	
	    cssReady: function cssReady(id) {
	
	        var el = document.getElementById(id);
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	
	            var timeout = void 0;
	            var interval = void 0;
	
	            function check() {
	                _util.$util.forEach(document.styleSheets, function (stylesheet) {
	                    if (stylesheet.href === el.href) {
	                        clearInterval(interval);
	                        clearTimeout(timeout);
	                        resolve();
	                    }
	                });
	            }
	
	            timeout = setTimeout(function () {
	                clearInterval(interval);
	                reject();
	                throw new Error('css_loading_timed_out');
	            }, 30000);
	
	            interval = setInterval(check, 20);
	            check();
	        });
	    }
	};
	
	angular.value("$dom", $dom);
	_logger.$logger;
	
	_promise.$promise;
	
	_util.$util;

/***/ },

/***/ "./components/squid/dist/ng/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ComponentRoute = exports.$Route = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var _component = __webpack_require__("./components/squid/dist/ng/component.js");
	
	var _ng = __webpack_require__("./components/squid/dist/ng/ng.js");
	
	var $Route = exports.$Route = _core.$Class.extend('$ComponentRoute', {
	
	    childSpec: {},
	
	    init: function init() {
	        var _this = this;
	
	        this.validate();
	
	        this.url = '/' + (this.path || this.name);
	
	        if (this.query) {
	            this.url += '?' + this.query.join('&');
	        }
	
	        this.hasResolver = Boolean(this.resolve);
	
	        var controller = this.controller = function ($scope) {
	            $scope.route = _this;
	            if ($scope.componentScope) {
	                delete $scope.componentScope.view;
	            }
	        };
	
	        if (this.get('resolve.action')) {
	            this.controller = function ($scope, action) {
	                _angular.$injector.invoke(controller, this, { $scope: $scope });
	                if (action) {
	                    _angular.$location.replace();
	                    if (angular.isObject(action) && action.to && action.params) {
	                        _uiRouter.$state.go(action.to, action.params);
	                    } else {
	                        _uiRouter.$state.go(action);
	                    }
	                }
	            };
	        }
	    },
	
	    validate: function validate() {
	
	        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
	            return;
	        }
	
	        var routeName = this.constructor.name;
	
	        if (!this.name && !this.path) {
	            throw new Error(routeName + ' :: expected property \'path\'');
	        }
	
	        if (this.url) {
	            _logger.$logger.warn(routeName + ' :: unexpected property \'url\' :: ' + this.url);
	        }
	
	        if (this.query && !(this.query instanceof Array)) {
	            throw new Error(routeName + ' :: expected property \'query\' to be array of query params');
	        }
	
	        if (this.controller) {
	            // throw new Error(`${routeName} :: unexpected property 'controller'`);
	        }
	
	        if (this.resolve) {
	            if (this.resolve.action && !(this.resolve.action instanceof Function)) {
	                throw new Error(routeName + ' :: expected property \'resolve.action\' to be a function');
	            }
	
	            Object.keys(this.resolve).forEach(function (name) {
	                if (name === 'data') {
	                    _logger.$logger.warn(routeName + ' :: unexpected resolver :: ' + name);
	                } else if (name !== 'action') {
	                    throw new Error(routeName + ' :: unexpected resolver :: ' + name);
	                }
	            });
	        }
	
	        if (this.template) {
	            throw new Error(routeName + ' :: unexpected property \'template\'');
	        }
	
	        if (!this.directive && !this.resolve && !this.resolve.action) {
	            throw new Error(routeName + ' :: expected property \'directive\'');
	        }
	
	        if (this.directive && angular.isString(this.directive) && !this.getDirective()) {
	            throw new Error(routeName + ' :: unknown directive \'' + this.directive + '\'');
	        }
	
	        if (this.directive && !angular.isString(this.directive) && !_component.$Component.isChild(this.directive)) {
	            throw new Error(routeName + ' :: expected directive to be subclass of $Component');
	        }
	
	        if (this.children) {
	            this.children.forEach(function (childSpec) {
	
	                if (!childSpec.route && !childSpec.name) {
	                    throw new Error(routeName + ' :: child expected property \'route\'');
	                }
	
	                var ChildRoute = childSpec.route;
	                var childName = childSpec.name || ChildRoute.name;
	
	                if (!ChildRoute && childSpec.name) {
	                    try {
	                        ChildRoute = _angular.$injector.get(childSpec.name);
	                    } catch (err) {
	                        throw new Error(routeName + ' :: could not find child route \'' + childName + '\'');
	                    }
	                }
	
	                if (!$Route.isChild(ChildRoute)) {
	                    throw new Error(routeName + ' :: ' + childName + ' :: expected child to be instance of $Route');
	                }
	            });
	        }
	    },
	    goto: function goto(route) {
	        return _uiRouter.$state.go(route.replace('this.', this.absolutePath + '.'));
	    },
	    getDirective: function getDirective() {
	        return _angular.$injector.get(_core.$util.dasherizeToCamel(this.getDirectiveTag() + 'Directive'))[0];
	    },
	    getDirectiveTag: function getDirectiveTag() {
	        return angular.isString(this.directive) ? this.directive : this.directive.prototype.tag;
	    },
	
	
	    bootstrap: function bootstrap(defaultState, middleware) {
	        var _this2 = this;
	
	        return (0, _ng.$angularInvoke)(function () {
	
	            // only bootstrap if not bootstrapped already
	            var element = angular.element(document.body);
	            if (!element.injector()) {
	                angular.bootstrap(element, ['app']);
	            }
	
	            return _this2.load(defaultState, middleware);
	        });
	    },
	
	    load: function load(defaultState, middleware) {
	
	        defaultState = defaultState || this.defaultState;
	        middleware = middleware || this.middleware;
	
	        _logger.$logger.info('bootstrap_route', {
	            route: this.path || this.name
	        });
	
	        (0, _ng.$once)('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
	            event.preventDefault();
	
	            _logger.$logger.error('state_not_found', {
	                name: unfoundState.to,
	                from: fromState.name,
	                fromParams: fromParams,
	                hash: window.location.hash
	            });
	
	            throw new Error('state_not_found: ' + unfoundState.to);
	        });
	
	        this.register();
	
	        _uiRouter.$urlRouterProvider.otherwise(function () {
	            return _logger.$logger.info('otherwise_after_bootstrap', {
	                hash: window.location.hash
	            });
	        });
	
	        this.runMiddleware(middleware).then(function () {
	
	            var targetState = void 0,
	                targetParams = void 0;
	
	            if (window.location.hash && window.location.hash.indexOf('#/') === 0) {
	
	                targetState = window.location.hash.slice(2).split('?')[0].replace(/^\/+/, '').replace(/\/+$/, '').replace(/\//g, '.');
	
	                targetParams = _core.$util.params(window.location.hash.slice(2).split('?')[1] || '');
	            }
	
	            _logger.$logger.info('initializing_route', {
	                target: targetState,
	                defaultState: defaultState,
	                hash: window.location.hash
	            });
	
	            _angular.$location.replace();
	
	            if (targetState) {
	                if (_uiRouter.$state.get(targetState)) {
	                    _logger.$logger.info('existing_state', {
	                        stateName: targetState
	                    });
	                    return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
	                        // lib/js/security.js event listener handles auth required state changes
	                        // and cancels transitions if user not authenticated
	                        if (err.message === 'transition prevented') {
	                            _logger.$logger.warn('transition_prevented', {
	                                targetState: targetState
	                            });
	                            return _core.$promise.resolve();
	                        }
	                        return _core.$promise.reject(err);
	                    });
	                }
	
	                _logger.$logger.info('unknown_state', {
	                    stateName: targetState
	                });
	            }
	
	            if (_uiRouter.$state.get(defaultState)) {
	                _logger.$logger.info('default_state', {
	                    stateName: defaultState
	                });
	                return _uiRouter.$state.go(defaultState)['catch'](function (err) {
	                    if (err.message === 'transition prevented') {
	                        _logger.$logger.warn('transition_prevented', {
	                            targetState: defaultState
	                        });
	                        return _core.$promise.resolve();
	                    }
	                    return _core.$promise.reject(err);
	                });
	            }
	
	            throw new Error('Default state not found: ' + defaultState);
	        })['catch'](function (err) {
	            return _angular.$injector.get('$exceptionHandler')(err);
	        });
	    },
	
	    runMiddleware: function runMiddleware(middleware) {
	
	        _logger.$logger.info('middleware', {
	            priority: _core.$util.map(middleware, function (method) {
	                return method.name;
	            }).join('|')
	        });
	
	        var promise = _core.$promise.resolve();
	
	        angular.forEach(middleware, function (method) {
	            promise = promise.then(function () {
	
	                if (method.name) {
	                    _logger.$logger.info('middleware_' + method.name);
	                }
	
	                return method();
	            });
	        });
	
	        return promise;
	    },
	
	    register: function register() {
	        var _this3 = this;
	
	        this.template = this.constructTemplate(this.childAttributes || {});
	
	        this.absolutePath = this.path || this.name;
	
	        if (this.parent) {
	            this.absolutePath = this.parent.absolutePath + '.' + this.absolutePath;
	        }
	
	        if (!_uiRouter.$state.get(this.absolutePath)) {
	            _uiRouter.$stateProvider.state(this.absolutePath, this);
	        }
	
	        angular.forEach(this.children, function (childSpec) {
	
	            var ChildRoute = childSpec.route || _angular.$injector.get(childSpec.name);
	
	            var childRoute = new ChildRoute({
	                parent: _this3,
	                childSpec: childSpec,
	                childAttributes: childSpec.attributes
	            });
	
	            childRoute.register();
	        });
	    },
	
	    /**
	     * Constructs the template string for this route. If route.directive = 'xo-add-bank', then the template will be
	     * '<xo-add-bank/>'.
	     * If attributes are specified, they will be passed to directive. Ex: <xo-add-bank attrname = "attrvalue"/>
	     *
	     * @param attributes - A map of name value pairs - {name: value}.
	     * @returns {string}
	     */
	    constructTemplate: function constructTemplate(attributes) {
	        var self = this;
	
	        if (!self.directive) {
	            return;
	        }
	
	        attributes['component-route'] = 'route';
	
	        if (this.parent) {
	            attributes['export'] = 'view';
	        }
	
	        var tag = this.getDirectiveTag();
	
	        var paramString = '';
	
	        angular.forEach(attributes, function (value, key) {
	            paramString += ' ' + key + '="' + value + '"';
	        });
	
	        return '<div ' + tag + ' ' + paramString + '></div>';
	    }
	});
	
	_uiRouter.$stateProvider.state('default', {
	    auth: false
	});
	
	$Route.reopenClass({
	    render: function render() {
	
	        _core.$Model.clearCache();
	        _core.$Api.clearCache();
	
	        _core.$event.emit('$resetState');
	        (0, _locale.$flushContent)();
	
	        _core.$loader.reset();
	
	        _uiRouter.$state.go('default');
	
	        setTimeout.flush();
	
	        var $scope = _angular.$rootScope.$new();
	
	        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
	
	        var element = (0, _angular.$compile)('<div><ui-view></ui-view></div>')($scope);
	
	        afterEach(_core.$util.once(function () {
	            $scope.$destroy();
	            cleanRootScope();
	            _core.$loader.reset();
	            _core.$Model.clearCache();
	            _core.$Api.clearCache();
	        }));
	
	        var route = new this();
	        route.bootstrap();
	
	        setTimeout.flush();
	
	        element.isolateScope = function () {
	            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
	        };
	
	        return element;
	    },
	
	
	    assertActive: function assertActive() {
	        assert(_uiRouter.$state.current instanceof this, 'Current state should be "' + (this.prototype.path || this.prototype.name) + '", found "' + _uiRouter.$state.current.name + '"');
	    }
	});
	
	function getPageTitle(stateName) {
	
	    var state = _uiRouter.$state.get(stateName);
	
	    if (!state) {
	        return;
	    }
	
	    if (state.titleContent) {
	        return _locale.$locale.content.get(state.titleContent);
	    }
	}
	
	function changePageTitle() {
	
	    document.documentElement.setAttribute('lang', _locale.$locale.lang);
	
	    if (!_uiRouter.$state.current || !_uiRouter.$state.current.name) {
	        return;
	    }
	
	    var fullStateTitle = [];
	
	    _uiRouter.$state.current.name.split('.').reduce(function (a, b) {
	
	        var stateName = [a, b].filter(Boolean).join('.');
	        var stateTitle = getPageTitle(stateName);
	
	        if (stateTitle) {
	            fullStateTitle.push(stateTitle);
	        }
	
	        return stateName;
	    }, null);
	
	    document.title = _core.$util.unique(fullStateTitle).join(' - ');
	}
	
	_core.$event.on('$stateChangeSuccess', changePageTitle);
	_core.$event.on('contentChange', changePageTitle);
	
	var $ComponentRoute = exports.$ComponentRoute = $Route;
	
	angular.value("$Route", $Route);
	angular.value("$ComponentRoute", $ComponentRoute);
	_angular.$rootScope;
	
	_angular.$location;
	
	_angular.$injector;
	
	_angular.$compile;
	
	_uiRouter.$state;
	
	_uiRouter.$stateProvider;
	
	_uiRouter.$urlRouterProvider;
	
	_logger.$logger;
	
	_core.$config;
	
	_core.$Class;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$util;
	
	_core.$promise;
	
	_core.$event;
	
	_core.$loader;
	
	_locale.$locale;
	
	_locale.$flushContent;
	
	_component.$Component;
	
	_ng.$cleanRootScope;
	
	_ng.$once;
	
	_ng.$angularInvoke;

/***/ },

/***/ "./components/squid/dist/locale/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	Object.keys(_locale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locale[key];
	    }
	  });
	});
	
	var _currency = __webpack_require__("./components/squid/dist/locale/currency.js");
	
	Object.keys(_currency).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _currency[key];
	    }
	  });
	});
	
	var _feature = __webpack_require__("./components/squid/dist/locale/feature.js");
	
	Object.keys(_feature).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _feature[key];
	    }
	  });
	});
	
	var _name = __webpack_require__("./components/squid/dist/locale/name.js");
	
	Object.keys(_name).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _name[key];
	    }
	  });
	});
	
	var _quantity = __webpack_require__("./components/squid/dist/locale/quantity.js");
	
	Object.keys(_quantity).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _quantity[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/locale/locale.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$localeHelper = exports.$locale = exports.$LocaleModel = exports.$MetadataModel = exports.$ContentModel = undefined;
	exports.sanitize = sanitize;
	exports.Content = Content;
	exports.$contentVersion = $contentVersion;
	exports.$flushContent = $flushContent;
	exports.$renderContent = $renderContent;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	function sanitize(html) {
	    return html && html.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
	}
	
	var JSONStringify = JSON.stringify;
	
	JSON.stringify = function (item) {
	    if (item instanceof Content) {
	        return item.toString();
	    }
	    return JSONStringify.apply(this, arguments);
	};
	
	function Content(key, props) {
	    this.key = key;
	    this.props = props;
	}
	
	Content.cache = {};
	
	Content.get = function (key, props) {
	
	    if (!key) {
	        return '';
	    }
	
	    props = props || {};
	
	    var cacheKey = $locale.country + '_' + $locale.lang + '_' + key + '_' + JSONStringify.call(JSON, props);
	    var cacheVal = Content.cache[cacheKey];
	
	    if (cacheVal !== undefined) {
	        return cacheVal;
	    }
	
	    cacheVal = Content.cache[cacheKey] = new Content(key, props);
	
	    return cacheVal;
	};
	
	Content.prototype.toString = Content.prototype.valueOf = function () {
	    if (this.string) {
	        return this.string;
	    }
	
	    this.string = this.render(false);
	
	    return this.string;
	};
	
	Content.prototype.toSafeString = function () {
	    if (this.safeString) {
	        return this.safeString;
	    }
	
	    this.safeString = this.render(true);
	
	    return this.safeString;
	};
	
	Content.prototype.render = function (safe) {
	    var _this = this;
	
	    if (!this.key) {
	        return '';
	    }
	
	    var value = contentCache[$locale.country] && contentCache[$locale.country][$locale.lang];
	    var keys = this.key.split('.');
	
	    for (var i = 0; i < keys.length; i++) {
	        if (value) {
	            value = value[keys[i]];
	        } else {
	            break;
	        }
	    }
	
	    if (!value) {
	        return '';
	    }
	
	    return value.replace(/\{\w+\}/g, function (prop) {
	        prop = prop.slice(1, prop.length - 1);
	
	        if (prop === 'country') {
	            return $locale.country;
	        }
	
	        if (prop === 'lang') {
	            return $locale.lang;
	        }
	
	        if (_this.props[prop] === undefined) {
	            if (!_core.$loader.isLoading()) {
	                _logger.$logger.warn('missing_content_prop', {
	                    key: _this.key,
	                    prop: prop
	                }, { unique: true });
	            }
	
	            return '';
	        }
	
	        var propStr = _this.props[prop].toString();
	
	        if (safe) {
	            return sanitize(propStr);
	        }
	
	        return propStr;
	    });
	};
	
	var contentCache = {};
	var currentVersion = void 0;
	
	window.addContent = function (country, lang, content, version) {
	    var countryCache = contentCache[country] = contentCache[country] || {};
	    countryCache[lang] = content;
	    currentVersion = version;
	};
	
	var metadataCache = {};
	
	window.addMetadata = function (country, lang, metadata) {
	    var countryCache = metadataCache[country] = metadataCache[country] || {};
	    countryCache[lang] = metadata;
	};
	
	function $contentVersion() {
	    return currentVersion || '';
	}
	
	function $flushContent() {
	    contentCache = {};
	    metadataCache = {};
	}
	
	var PP_SPECIAL_COUNTRIES_ISO_CODES = {
	    C2: 'CN'
	};
	
	var $ContentModel = exports.$ContentModel = _core.$Model.extend('$ContentModel', {
	
	    api: new _core.$Api({
	
	        baseURI: _core.$meta.staticUrl,
	        uri: '/locales/:countryCode/:lang',
	        ext: 'js',
	
	        retrieve: function retrieve(options) {
	            var self = this;
	            var model = options.model;
	
	            var uri = self.getURI(model);
	
	            return _core.$promise.resolve().then(function () {
	
	                if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
	                    _logger.$logger.info('cached_content');
	                    return contentCache[model.countryCode][model.lang];
	                }
	
	                _logger.$logger.info('retrieve_content', {
	                    uri: uri
	                });
	
	                _core.$event.emit('loading');
	
	                return _core.$promise.attempt(3, function () {
	                    return _core.$dom.loadScript('content', uri, 10000).then(function () {
	                        if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
	                            _logger.$logger.info('content_retrieved');
	                            return contentCache[model.countryCode][model.lang];
	                        }
	
	                        throw new Error('content_not_available');
	                    });
	                })['catch'](function (err) {
	                    throw err;
	                })['finally'](function () {
	                    _core.$event.emit('loaded');
	                });
	            }).then(function (content) {
	                model.setProperties(content);
	                return content;
	            });
	        }
	    }),
	
	    change: function change(country, lang) {
	
	        if (country === this.countryCode && lang === this.lang) {
	            return _core.$promise.resolve(this);
	        }
	
	        this.countryCode = country;
	        this.lang = lang;
	
	        return this.reload().then(function () {
	            _core.$event.broadcast('contentChange');
	        });
	    }
	});
	
	var $MetadataModel = exports.$MetadataModel = _core.$Model.extend('$MetadataModel', {
	
	    api: new _core.$Api({
	
	        baseURI: _core.$meta.staticUrl,
	        uri: '/metadata/:country/:lang/metadata',
	        ext: 'js',
	
	        retrieve: function retrieve(options) {
	            var self = this;
	            var model = options.model;
	
	            var uri = self.getURI(model);
	
	            return _core.$promise.resolve().then(function () {
	
	                if (metadataCache[model.country] && metadataCache[model.country][model.lang]) {
	                    _logger.$logger.info('cached_metadata');
	                    return metadataCache[model.country][model.lang];
	                }
	
	                _logger.$logger.info('retrieve_metadata', {
	                    uri: uri
	                });
	
	                _core.$event.emit('loading');
	
	                return _core.$promise.attempt(3, function () {
	                    return _core.$dom.loadScript('metadata', uri, 10000).then(function () {
	                        if (metadataCache[model.country] && metadataCache[model.country][model.lang]) {
	                            _logger.$logger.info('metadata_retrieved', {
	                                uri: uri
	                            });
	                            return metadataCache[model.country][model.lang];
	                        }
	
	                        // Retry if not found in cache
	                        _logger.$logger.info('metadata_not_available', {
	                            uri: uri
	                        });
	                        return _core.$promise.reject(new Error('metadata_not_available'));
	                    });
	                })['catch'](function (err) {
	                    throw err;
	                })['finally'](function () {
	                    _core.$event.emit('loaded');
	                });
	            }).then(function (metadata) {
	                model.setProperties(metadata);
	                return metadata;
	            });
	        }
	    }),
	
	    change: function change(country, lang) {
	        var _this2 = this;
	
	        this.country = country;
	        this.lang = lang;
	
	        return this.reload().then(function () {
	            if (!_this2.noBroadcast) {
	                _core.$event.broadcast('metadataChange');
	            }
	        });
	    },
	
	    choose: function choose(country, lang, override) {
	
	        if (country && (!this.chosenCountry || override !== false)) {
	            this.chosenCountry = country;
	        }
	
	        if (lang && (!this.chosenLang || override !== false)) {
	            this.chosenLang = lang;
	        }
	
	        country = this.chosenCountry || this.country;
	        lang = this.chosenLang;
	
	        if (_core.$config.supportedCountries) {
	            if (!_core.$config.supportedCountries[country]) {
	                country = this.country;
	            }
	
	            if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
	                lang = _core.$config.supportedCountries[country][0];
	            }
	        }
	
	        if (!lang) {
	            lang = this.lang;
	        }
	
	        return this.change(country, lang);
	    },
	
	    normalizeAddressFields: function normalizeAddressFields(content) {
	
	        var CONTENT_MAPPING = {
	            line1Label: 'streetAddress',
	            line2Label: 'streetAddress2',
	            cityLabel: 'city',
	            stateLabel: 'state',
	            postcodeLabel: 'postalCode'
	        };
	
	        // Loop over all layout props, if they don't exist in Griffin, get them from xo-content
	        for (var prop in CONTENT_MAPPING) {
	            if (this.addressEntry && this.addressEntry.strings[prop]) {
	                this.addressEntry.strings[prop] = this.addressEntry.strings[prop] || content.get('common.' + CONTENT_MAPPING[prop]);
	            }
	        }
	    }
	});
	
	function mapLanguage(lang) {
	    var unselectableLanguages = _core.$config.unselectableLanguages || [];
	    if (unselectableLanguages.indexOf(lang) !== -1) {
	        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
	            return 'en';
	        }
	    }
	
	    var unsupportedLanguages = _core.$config.unsupportedLanguages || [];
	    if (unsupportedLanguages.indexOf(lang) !== -1) {
	        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
	            var s = lang + '_locale_not_supported';
	            throw new Error(s);
	        }
	    }
	
	    return lang;
	}
	
	var $LocaleModel = exports.$LocaleModel = _core.$Model.extend('LocaleModel', {
	
	    api: new _core.$Api({
	        uri: '/api/locale'
	    }),
	
	    init: function init() {
	        this._super.init.apply(this);
	        this.content = $ContentModel.instance();
	        this.metadata = $MetadataModel.instance();
	    },
	
	    retrieve: function retrieve() {
	        var self = this;
	        return this._super.retrieve.apply(this, arguments).then(function (result) {
	            self.lang = mapLanguage(self.lang);
	            return _core.$promise.all([self.content.change(self.country, self.lang), self.metadata.change(self.country, self.lang)]).then(function () {
	
	                // TODO: This at build time... or make sure griffin metadata is complete
	                self.metadata.normalizeAddressFields(self.content);
	
	                return result;
	            });
	        });
	    },
	
	    change: function change(country, lang) {
	
	        var self = this;
	
	        lang = mapLanguage(lang);
	
	        if (country === this.country && lang === this.lang) {
	            return _core.$promise.resolve(this);
	        }
	
	        _logger.$logger.info('locale_change', {
	            country: country,
	            lang: lang
	        });
	
	        this.country = country;
	        this.lang = lang;
	
	        return _core.$promise.all([this.content.change(country, lang), this.metadata.change(country, lang)]).then(function (loadedData) {
	
	            // TODO: This at build time... or make sure griffin metadata is complete
	            self.metadata.normalizeAddressFields(self.content);
	
	            _core.$event.broadcast('localeChange'); // broadcast only when data has all been loaded
	            return loadedData;
	        });
	    },
	
	    choose: function choose(country, lang, override) {
	
	        if (country && (!this.chosenCountry || override !== false)) {
	            this.chosenCountry = country;
	        }
	
	        if (lang && (!this.chosenLang || override !== false)) {
	            this.chosenLang = lang;
	        }
	
	        country = this.chosenCountry || this.country;
	        lang = this.chosenLang;
	
	        if (!_core.$config.supportedCountries[country]) {
	            country = this.country;
	        }
	
	        if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
	            lang = _core.$config.supportedCountries[country][0];
	        }
	
	        if (!lang) {
	            lang = this.lang;
	        }
	
	        return this.change(country, lang);
	    },
	
	    chooseCountry: function chooseCountry(country) {
	        return this.choose(country, null);
	    },
	
	    chooseLang: function chooseLang(lang) {
	        return this.choose(null, lang);
	    },
	
	    getLocaleCode: function getLocaleCode() {
	        return this.lang + '_' + this.country;
	    },
	
	    getCountryCodeISO: function getCountryCodeISO() {
	        return PP_SPECIAL_COUNTRIES_ISO_CODES[this.country] || this.country;
	    }
	});
	
	var $locale = exports.$locale = $LocaleModel.instance();
	
	function $renderContent(key, props) {
	    return Content.get(key, props);
	}
	
	var $localeHelper = exports.$localeHelper = {
	    /**
	     *
	     * @param locale - Ex: en_US
	     * @returns {{country: *, dialect}}
	     */
	    normalizeLocale: function normalizeLocale(locale) {
	        if (!locale) {
	            return {};
	        }
	
	        locale = locale.replace('-', '_');
	
	        var country = void 0,
	            language = void 0;
	
	        if (locale.match(/^\w{2}_\w{2}$/)) {
	            locale = locale.split('_');
	
	            language = locale[0];
	            country = locale[1];
	        } else {
	            language = locale;
	        }
	
	        return {
	            country: country,
	            language: language
	        };
	    }
	};
	
	angular.value("sanitize", sanitize);
	angular.value("Content", Content);
	angular.value("$contentVersion", $contentVersion);
	angular.value("$flushContent", $flushContent);
	angular.value("$ContentModel", $ContentModel);
	angular.value("$MetadataModel", $MetadataModel);
	angular.value("$LocaleModel", $LocaleModel);
	angular.value("$locale", $locale);
	angular.value("$renderContent", $renderContent);
	angular.value("$localeHelper", $localeHelper);
	_logger.$logger;
	
	_core.$event;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$meta;
	
	_core.$promise;
	
	_core.$config;
	
	_core.$loader;
	
	_core.$dom;

/***/ },

/***/ "./components/squid/dist/locale/currency.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // everything to do with currency formatting
	
	// quick Griffin reference on currency format:
	// ¤ : Currency Symbol = $
	// # : Amount = 186432.431
	// C : Currency Code = USD
	
	exports.roundingAndSeparators = roundingAndSeparators;
	exports.formatCurrency = formatCurrency;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	// This seems to be the only currency / locale specific exception in Griffin
	var STYLE_EXCEPTION = {
	    'tr TR TRY': '# ¤;-# ¤'
	};
	
	var ALL_NON_BREAKING_SPACE = new RegExp('\xa0+', 'g');
	var CODE_IN_FRONT = new RegExp('^([^¤#]*)(C[\\s]*)(.*)$'); // matching groups: (any negative symbol)(code)(the rest)
	var ENDS_IN_WHITESPACE = new RegExp('\s$');
	var THOUSANDS_SPLITTER = /\B(?=(\d{3})+(?!\d))/g; // eslint-disable-line fasec/no-unsafe-regex
	
	// Griffin "fuzzy logic"
	// apparently if the symbol is at least "66% similar" to the code, ignore it
	function maybeIgnoreSymbol(style, symbol, code) {
	
	    // THIS IS NOT COMMUTATIVE
	    function fuzzyMatch(code, symbol) {
	        // eslint-disable-line no-shadow
	        if (code === symbol) {
	            return 100;
	        } else {
	            var _ret = function () {
	                var codeParts = code.split('');
	                var symbolParts = symbol.split('');
	
	                var equivalency = codeParts.reduce(function (equiv, codePart) {
	                    var symbolPos = symbolParts.indexOf(codePart);
	
	                    if (symbolPos !== -1) {
	                        symbolParts.splice(symbolPos, 1);
	                        return equiv + 1;
	                    }
	                    return equiv;
	                }, 0);
	
	                var weight = equivalency / codeParts.length;
	
	                return {
	                    v: weight * 100
	                };
	            }();
	
	            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	        }
	    }
	
	    var ignoreSymbol = symbol.length > 1 && fuzzyMatch(code, symbol) >= 66;
	
	    return ignoreSymbol ? style.replace(/¤\s*/g, '') : style;
	}
	
	// deal with rounding due to truncation (Griffin rounds up) as well as dot/comma symbols
	// and thousand separators
	function roundingAndSeparators(amountString, _ref) {
	    var decimalPlaces = _ref.decimalPlaces,
	        dot = _ref.dot,
	        comma = _ref.comma;
	
	    var value = parseFloat(amountString);
	    var truncate = decimalPlaces === 0;
	
	    var amountParts = truncate && !isNaN(value) ? Math.round(value).toString().split('.') : amountString.split('.');
	    var wholeString = amountParts[0].replace(THOUSANDS_SPLITTER, comma);
	    var decimalString = amountParts[1] || '00';
	
	    return truncate ? wholeString : '' + wholeString + dot + decimalString;
	}
	
	// this is an agreement with UED for visual consistency - the currency code, if displayed, is always on the right
	function forceCodeToRight(style) {
	    var parts = CODE_IN_FRONT.exec(style) || [];
	    var endsWithWhitespace = ENDS_IN_WHITESPACE.test(style);
	    var newStyle = style;
	
	    // if CODE_IN_FRONT regex matches, array indexes -
	    // [1] negative symbol plus whitespace, if any,
	    // [2] the "C" plus any whitespace,
	    // [3] whatever is after "C"
	    if (parts.length === 4) {
	        newStyle = parts[1] + parts[3] + (endsWithWhitespace ? 'C' : ' C');
	    }
	
	    return newStyle;
	}
	
	// deal with
	// 1. exceptions for specific locales
	// 2. positive and negative styles
	// 3. griffin fuzzy logic
	// 4. UED consistency logic
	function getFinalStyle() {
	    var styleString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ';';
	    var _ref2 = arguments[1];
	    var lang = _ref2.lang,
	        country = _ref2.country;
	    var _ref3 = arguments[2];
	    var value = _ref3.value,
	        _ref3$symbol = _ref3.symbol,
	        symbol = _ref3$symbol === undefined ? '' : _ref3$symbol,
	        code = _ref3.code;
	
	
	    var exception = STYLE_EXCEPTION[[lang, country, code].join(' ')]; // special exceptions
	    var currencyStyle = exception || styleString;
	
	    var _currencyStyle$split = currencyStyle.split(';'),
	        positiveStyle = _currencyStyle$split[0],
	        negativeStyle = _currencyStyle$split[1]; // the style is separated by postive and negative notation via a ;
	
	    var baseStyle = value < 0 ? negativeStyle || '-¤# C' : positiveStyle || '¤# C';
	    var griffinStyle = exception ? baseStyle : maybeIgnoreSymbol(baseStyle, symbol, code); // don't apply fuzzy logic on exceptions
	
	    return forceCodeToRight(griffinStyle);
	}
	
	// take the style and the formatted amount (rounded / truncated / thousands separator / decimal separator)
	// and produce the final result.
	//
	// wrapCodeInSpan - wraps the currency code in a span.currencyCode for styling purposes
	function applyCurrencyStyle(finalStyle, amountFormatted, _ref4) {
	    var symbol = _ref4.symbol,
	        code = _ref4.code,
	        _ref4$wrapCodeInSpan = _ref4.wrapCodeInSpan,
	        wrapCodeInSpan = _ref4$wrapCodeInSpan === undefined ? false : _ref4$wrapCodeInSpan;
	
	    // the style will take care of negative symbol (see getFinalStyle function above)
	    var absoluteAmountFormatted = amountFormatted.replace('-', '');
	
	    // parallel operation is safer than serial replace
	    return finalStyle.split('').map(function (char) {
	        switch (char) {
	            case 'C':
	                return wrapCodeInSpan ? '<span class="currencyCode">' + code + '</span>' : code;
	            case '¤':
	                return symbol;
	            case '#':
	                return absoluteAmountFormatted;
	            default:
	                return char;
	        }
	    }).join('').replace(ALL_NON_BREAKING_SPACE, ' ');
	}
	
	function formatCurrency(amount, code, wrapCodeInSpan) {
	    var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'SymbolISOCurrency';
	
	    var _ref5 = _locale.$locale.metadata || {},
	        _ref5$number = _ref5.number,
	        numberConfig = _ref5$number === undefined ? {} : _ref5$number,
	        _ref5$currency = _ref5.currency,
	        currencyConfig = _ref5$currency === undefined ? {} : _ref5$currency;
	
	    var _currencyConfig$digit = currencyConfig.digits,
	        digits = _currencyConfig$digit === undefined ? {} : _currencyConfig$digit,
	        _currencyConfig$style = currencyConfig.styles,
	        styles = _currencyConfig$style === undefined ? {} : _currencyConfig$style,
	        _currencyConfig$suppo = currencyConfig.supportedSymbols,
	        currencySymbols = _currencyConfig$suppo === undefined ? {} : _currencyConfig$suppo;
	
	    var value = parseFloat(amount);
	
	    var dot = numberConfig.DECIMAL_SEP === undefined ? '.' : numberConfig.DECIMAL_SEP;
	    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;
	
	    var amountFormatted = roundingAndSeparators(amount.toString(), { decimalPlaces: digits[code], dot: dot, comma: comma });
	
	    if (code) {
	        var symbol = currencySymbols[code];
	        var finalStyle = getFinalStyle(styles[style], _locale.$locale, { value: value, symbol: symbol, code: code });
	
	        return applyCurrencyStyle(finalStyle, amountFormatted, { symbol: symbol, code: code, wrapCodeInSpan: wrapCodeInSpan });
	    }
	
	    return amountFormatted; // HTML?
	}
	
	_locale.$locale;

/***/ },

/***/ "./components/squid/dist/locale/feature.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$feature = $feature;
	exports.$featureCountries = $featureCountries;
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	function $feature(prop, def, country) {
	
	    var features = _core.$config.features || {};
	
	    country = country || _locale.$locale.country;
	    // 1. Check the feature is present in country
	    var result = _core.$Class.get(features[country], prop);
	
	    if (result !== undefined) {
	        return result;
	    }
	    // 2. Check the feature is present in feature group
	    _core.$util.some(_core.$config.regions, function (countries, region) {
	        if (countries.indexOf(country) !== -1) {
	            result = _core.$Class.get(features[region], prop);
	            return result !== undefined;
	        }
	    });
	
	    if (result !== undefined) {
	        return result;
	    }
	    // 3. Check the feature is present in default group
	    result = _core.$Class.get(features.DEFAULT, prop);
	
	    if (result !== undefined) {
	        return result;
	    }
	    return def;
	}
	
	// Build a list of all countries in our feature list and regions
	// populate countries with out REGION names in the list
	var allCountries = _core.$Class.keys(_core.$config.features || {}).filter(function (country) {
	    return country !== 'DEFAULT' && !(_core.$config.regions && _core.$config.regions.hasOwnProperty(country));
	});
	
	// populate all the region countries in to allcountries
	_core.$util.forEach(_core.$config.regions, function (countries, region) {
	    _core.$util.forEach(countries, function (country) {
	        if (allCountries.indexOf(country) === -1) {
	            allCountries.push(country);
	        }
	    });
	});
	
	function $featureCountries(prop) {
	    // Find the countries with a certain feature enabled
	    return allCountries.filter(function (country) {
	        return $feature(prop, false, country);
	    });
	}
	
	angular.value("$feature", $feature);
	angular.value("$featureCountries", $featureCountries);
	_core.$config;
	
	_core.$Class;
	
	_core.$util;
	
	_locale.$locale;

/***/ },

/***/ "./components/squid/dist/locale/name.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.formatNameInformal = formatNameInformal;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	// Mapping of Griffin fields to name fields that should be used
	var SUBSTITUTED_FIELDS = {
	    givenName: 'first_name',
	    surname: 'last_name'
	};
	
	// Taken from griffin-paypal: test if a string is Latin
	function isLatin(str) {
	    if (!str) {
	        return true;
	    }
	
	    for (var i = 0; i < str.length; i++) {
	        if (str.charCodeAt(i) > 0x24F) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	/**
	 * Formats name into informal format based on Griffin metadata
	 * @param  {Object} name The name to be formatted, containing first_name and last_name properties
	 * @return {String}      The formatted string, or null if data is missing
	 */
	function formatNameInformal(name) {
	    var layoutMetadata = _locale.$locale.metadata.nameInformal;
	    var layout = null;
	
	    if (!layoutMetadata) {
	        return name.first_name || null; // Default to first name if metadata not loaded
	    }
	
	    // According to Griffin, if the name is all Latin and there is a Latin formatting variant, use that one
	    if (layoutMetadata['latinLayout'] && isLatin(name.first_name) && isLatin(name.last_name)) {
	        layout = layoutMetadata['latinLayout'];
	    } else {
	        layout = layoutMetadata['layout'];
	    }
	
	    // Map griffin layout parts to the name passed in. If it requires a value not passed in name, returns null early
	    var formattedName = [];
	    for (var i = 0; i < layout.length; i++) {
	        var namePart = layout[i];
	
	        if (name[SUBSTITUTED_FIELDS[namePart['$']]]) {
	            formattedName.push(name[SUBSTITUTED_FIELDS[namePart['$']]]);
	        }
	    }
	
	    return formattedName.join('');
	}
	
	_locale.$locale;

/***/ },

/***/ "./components/squid/dist/locale/quantity.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.formatQuantity = formatQuantity;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	var _currency = __webpack_require__("./components/squid/dist/locale/currency.js");
	
	// format a quantity to add a thousand separator based on a locality
	function formatQuantity(quantity) {
	    var _ref = _locale.$locale.metadata || {},
	        _ref$number = _ref.number,
	        numberConfig = _ref$number === undefined ? {} : _ref$number;
	
	    var dot = '';
	    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;
	
	    return (0, _currency.roundingAndSeparators)(quantity.toString(), { decimalPlaces: 0, dot: dot, comma: comma });
	}
	
	_locale.$locale;
	
	_currency.roundingAndSeparators;

/***/ },

/***/ "./components/squid/dist/ng/component.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {
	
	exports.__esModule = true;
	exports.$Component = undefined;
	exports.$populate = $populate;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var _ng = __webpack_require__("./components/squid/dist/ng/ng.js");
	
	var _directive = __webpack_require__("./components/squid/dist/ng/directive.js");
	
	(0, _directive.$registerDirective)('prevent-default', function () {
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $element.on('click', function (event) {
	                event.preventDefault();
	            });
	        }
	    };
	});
	
	(0, _directive.$registerDirective)('stop-propagation', function () {
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $element.on('click', function (event) {
	                event.stopPropagation();
	            });
	        }
	    };
	});
	
	(0, _directive.$registerDirective)('validate-submit', function () {
	
	    return {
	        link: function link($scope, $element, $attrs) {
	
	            var $form = $element.closest('form');
	            var form = $scope[$form.prop('name')];
	
	            $element.on('click', function (event) {
	                event.preventDefault();
	
	                $form.addClass('validated');
	                $scope.validated = true;
	                form.$setSubmitted();
	
	                if (form.$valid) {
	                    try {
	                        $scope.$eval($attrs.validateSubmit);
	                    } catch (err) {
	                        _angular.$injector.get('$exceptionHandler')(err);
	                    }
	                } else {
	                    $form.find('.ng-invalid:first').focus();
	                }
	            });
	        }
	    };
	});
	
	function assertModelsRetrievedOrEmpty(items) {
	    if (_core.$config.deploy.isLocal() || _core.$config.deploy.isStage()) {
	        angular.forEach(items, function (item, name) {
	            if (item instanceof _core.$Model) {
	                if (item.meta.populated) {
	                    throw new Error(name + ' is already populated. Please call .retrieve() to ensure your code is not relying on cache being present.');
	                }
	            }
	        });
	    }
	}
	
	var $Component = exports.$Component = _core.$Class.extend('$Component', {
	
	    onPopulate: angular.noop,
	
	    init: function init() {
	        var _this = this,
	            _arguments = arguments;
	
	        this.validate();
	
	        this.name = _core.$util.dasherizeToCamel(this.tag);
	        this.template = '<div class="' + this.tag + '-wrapper" ng-if="populated && display">' + this.template + '</div>';
	
	        this.scope = this.scope || {};
	        this.resolve = this.resolve || {};
	        this.props = this.props || {};
	        this.rootEvents = this.rootEvents || {};
	
	        this.actions = this.actions || {};
	
	        this.lifecycle = this.lifecycle || {};
	        this.lifecycle.enter = this.lifecycle.enter || angular.noop;
	        this.lifecycle.reenter = this.lifecycle.reenter || angular.noop;
	        this.lifecycle.exit = this.lifecycle.exit || angular.noop;
	        this.lifecycle.populate = this.lifecycle.populate || angular.noop;
	
	        if (this.scope && Object.keys(this.scope).length) {
	
	            if (this.props && Object.keys(this.props).length) {
	                throw new Error('Can not defined scope and props on the same component');
	            }
	
	            this.scope.componentRoute = '=';
	            this.scope['export'] = '@';
	
	            this.props = _core.$util.map(this.scope, function (type, key) {
	                return {
	                    type: {
	                        '=': 'var',
	                        '@': 'str'
	                    }[type],
	                    required: false
	                };
	            });
	        } else {
	
	            this.props.componentRoute = {
	                type: 'var',
	                required: false
	            };
	
	            this.props['export'] = {
	                type: 'str',
	                required: false
	            };
	
	            this.scope = _core.$util.map(this.props, function (spec, key) {
	                return {
	                    'var': '=',
	                    'str': '@'
	                }[spec.type || 'var'];
	            });
	        }
	
	        var originalController = this.controller || angular.noop;
	
	        this.controller = function ($scope, $element) {
	            $scope.$element = $element;
	
	            $scope.$on('$destroy', function () {
	                if ($scope.componentRoute && $scope.componentRoute.parent && $scope.componentRoute.parent.scope) {
	                    delete $scope.componentRoute.parent.scope.viewConfig;
	                }
	                _this.lifecycle.exit.call($scope);
	            });
	
	            $scope.props = {};
	
	            if ($scope.componentRoute) {
	                (function () {
	                    var componentRoute = $scope.componentRoute;
	
	                    componentRoute.scope = $scope;
	
	                    componentRoute.scope.goto = function (route) {
	                        componentRoute.goto(route);
	                    };
	
	                    var parentRoute = componentRoute.parent;
	
	                    if (parentRoute) {
	
	                        var parentScope = parentRoute.scope;
	                        var parentDirective = parentRoute.getDirective();
	                        var childSpec = componentRoute.childSpec;
	
	                        if (childSpec.config) {
	                            if (parentDirective instanceof $Component) {
	                                parentScope.viewConfig = childSpec.config.call(parentScope);
	                            } else {
	                                throw new Error('In order to use config() for child routes, ' + parentRoute.getDirectiveTag() + ' must be instance of new style $Component');
	                            }
	                        }
	
	                        if (childSpec.props) {
	
	                            if (parentDirective instanceof $Component) {
	                                angular.extend($scope, childSpec.props.call(parentScope));
	                            } else {
	                                throw new Error('In order to use props() for child routes, ' + parentRoute.getDirectiveTag() + ' must be instance of new style $Component');
	                            }
	                        }
	                    }
	                })();
	            }
	
	            angular.forEach(_this.props, function (type, key) {
	
	                var prop = _this.props[key];
	                var required = prop.required !== false;
	                var def = void 0;
	
	                if (prop['default'] instanceof Function) {
	                    def = _core.$util.memoize(prop['default'].bind($scope));
	                } else {
	                    def = function def() {
	                        return prop['default'];
	                    };
	                }
	
	                var UNDEFINED = {
	                    'var': undefined,
	                    str: ''
	                }[prop.type];
	
	                Object.defineProperty($scope.props, key, {
	                    get: function get() {
	                        var val = $scope[key];
	
	                        if (val === UNDEFINED) {
	                            if (required) {
	                                throw new Error('Prop required for component :: ' + _this.tag + ' :: ' + key);
	                            }
	
	                            return def();
	                        }
	
	                        return val;
	                    },
	
	                    set: function set() {
	                        throw new Error('Prop is immutable :: ' + _this.tag + ' :: ' + key);
	                    }
	                });
	            });
	
	            $scope.fields = {};
	
	            $scope.actions = _core.$util.bindObject(_this.actions, $scope);
	
	            Object.keys(_this.rootEvents).forEach(function (eventName) {
	                var cancel = _core.$event.on(eventName, function (event) {
	                    _this.rootEvents[eventName].apply($scope, _arguments);
	                });
	
	                $scope.$on('$destroy', cancel);
	            });
	
	            $scope.display = true;
	
	            $scope.reload = function () {
	
	                if (!$scope.populated) {
	                    throw new Error('Can not reload unpopulated component');
	                }
	
	                $scope.display = false;
	                setTimeout(function () {
	                    $scope.display = true;
	                });
	            };
	
	            $scope.componentScope = $scope;
	
	            if ($scope.props['export'] && $scope.$parent.componentScope) {
	
	                $scope.exports = angular.extend({}, _this.exports || {}, {
	                    reload: $scope.reload
	                });
	
	                Object.defineProperty($scope.$parent.componentScope, $scope.props['export'], {
	                    get: function get() {
	                        return $scope.exports;
	                    },
	
	                    configurable: true
	                });
	            }
	
	            $scope._enablePopulateEvents = true;
	
	            _angular.$injector.invoke(originalController, _this, { $scope: $scope, $element: $element });
	            _this.lifecycle.enter.call($scope);
	
	            $scope._enablePopulateEvents = false;
	
	            var cancelReEnterEvent = _core.$event.on('$stateChangeSuccess', function (event, toState) {
	                if (toState === $scope.props.componentRoute) {
	                    _this.lifecycle.reenter.call($scope);
	                }
	            });
	
	            $scope.$on('$destroy', cancelReEnterEvent);
	
	            return _core.$promise.sequential([function () {
	                $scope.$emit('_populating');
	            }, function () {
	                return _core.$promise.map(_this.resolve, function (resolver, name, resolverPromises) {
	
	                    if (angular.isObject(resolver)) {
	                        $scope[name] = resolver;
	                        return resolver;
	                    }
	
	                    return _core.$promise.resolve(resolver.call($scope, resolverPromises)).then(function (data) {
	                        assertModelsRetrievedOrEmpty(data);
	
	                        return _core.$promise.hash(data).then(function (resolvedData) {
	
	                            $scope[name] = resolvedData;
	                            return resolvedData;
	                        });
	                    });
	                });
	            }, function () {
	
	                $scope.populated = true;
	
	                $scope.$emit('_populated');
	
	                _core.$event.refCount($scope, '_populating', '_populated').then(function () {
	
	                    $scope.$on('populated', function (populatedEvent) {
	                        populatedEvent.stopPropagation();
	                    });
	
	                    $scope.$emit('populated');
	                    _this.onPopulate.call($scope);
	                    _this.lifecycle.populate.call($scope);
	                });
	            }]);
	        };
	    },
	
	    validate: function validate() {
	
	        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
	            return;
	        }
	
	        var componentName = this.constructor.name;
	
	        if (!this.tag) {
	            throw new Error(componentName + ' :: expected property \'tag\'');
	        }
	
	        if (!this.tag.match(/^[a-z0-9-]+$/)) {
	            throw new Error(componentName + ' :: tag should contain only lowercase alphanumeric characters and dashes');
	        }
	
	        if (!this.template) {
	            throw new Error(componentName + ' :: expected property \'template\'');
	        }
	
	        if (this.resolve) {
	            angular.forEach(this.resolve, function (resolver, name) {
	                if (!(resolver instanceof Function)) {
	                    throw new Error(componentName + ' :: expected \'resolve.' + name + '\' to be a function');
	                }
	            });
	        }
	
	        if (this.props) {
	            angular.forEach(this.props, function (prop, name) {
	
	                if (!(prop instanceof Object)) {
	                    throw new Error(componentName + ' :: expected \'props.' + name + '\' to be a function');
	                }
	
	                if (prop.type && ['var', 'str'].indexOf(prop.type) === -1) {
	                    throw new Error(componentName + ' :: expected \'props.' + name + '.type\' to be one of var, str');
	                }
	
	                if (prop['default'] && prop.required) {
	                    throw new Error(componentName + ' :: unnecessary \'props.' + name + '.default\', since prop is required');
	                }
	
	                if (prop['default'] && prop['default'] instanceof Object && !(prop['default'] instanceof Function)) {
	                    throw new Error(componentName + ' :: expected \'props.' + name + '.default\' to be a primitive or a function - please do not pass mutable objects');
	                }
	            });
	        }
	
	        if (this.actions) {
	            angular.forEach(this.actions, function (action, name) {
	                if (!(action instanceof Function)) {
	                    throw new Error(componentName + ' :: expected \'actions.' + name + '\' to be a function');
	                }
	            });
	        }
	
	        if (this.lifecycle) {
	            Object.keys(this.lifecycle).forEach(function (name) {
	                if (['enter', 'populate', 'exit', 'reenter'].indexOf(name) === -1) {
	                    throw new Error(componentName + ' :: unexpected \'lifecycle.' + name + '\'');
	                }
	            });
	        }
	    }
	});
	
	$Component.reopenClass({
	
	    extend: function extend() {
	
	        var SubClass = _core.$Class.extend.apply(this, arguments);
	
	        var spec = new SubClass();
	
	        angular.module().directive(spec.name, function () {
	            return spec;
	        });
	
	        return SubClass;
	    },
	
	    render: function render(scope) {
	
	        _core.$Model.clearCache();
	        _core.$Api.clearCache();
	
	        _core.$event.emit('$resetState');
	        (0, _locale.$flushContent)();
	
	        var $scope = _angular.$rootScope.$new();
	        angular.extend($scope, scope);
	
	        var attrs = Object.keys(scope).map(function (key) {
	            return _core.$util.camelToDasherize(key) + '="' + (this.prototype.props[key].type === 'var' ? key : scope[key]) + '"';
	        }.bind(this)).join(' ');
	
	        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
	
	        var html = '<' + this.prototype.tag + ' ' + attrs + '></' + this.prototype.tag + '>';
	
	        console.log('RENDER', html, scope);
	
	        var element = (0, _angular.$compile)(html)($scope);
	
	        afterEach(_core.$util.once(function () {
	            $scope.$destroy();
	            cleanRootScope();
	        }));
	
	        setTimeout.flush();
	
	        element.isolateScope = function () {
	            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
	        };
	
	        return element;
	    }
	});
	
	function autoConvertDirectiveToComponent(_ref, original) {
	    var name = _ref[0],
	        factory = _ref[1];
	
	
	    if (!angular.isFunction(factory)) {
	        return original();
	    }
	
	    var tag = _core.$util.camelToDasherize(name);
	    var spec = _angular.$injector.invoke(factory);
	
	    if (spec.controller) {
	        (function () {
	            var originalController = spec.controller;
	
	            spec.controller = function ($scope, $element) {
	                $scope._enablePopulateEvents = true;
	                var result = _angular.$injector.invoke(originalController, this, { $scope: $scope, $element: $element });
	                $scope._enablePopulateEvents = false;
	                return result;
	            };
	        })();
	    }
	
	    if (spec instanceof $Component || !spec.template || !spec.controller || name.indexOf('xo') !== 0 || spec.transclude) {
	        return original(this, [name, function () {
	            return spec;
	        }]);
	    }
	
	    if (spec.componentize) {
	
	        $Component.extend('$' + name + 'Component', spec, {
	            tag: tag
	        });
	
	        return this;
	    }
	
	    return original(this, [name, function () {
	        return spec;
	    }]);
	}
	
	_core.$util.monkeyPatch(_angular.$compileProvider, 'directive', autoConvertDirectiveToComponent);
	_core.$util.monkeyPatch(angular.module(), 'directive', autoConvertDirectiveToComponent);
	
	// $populate needs to go away
	
	function $populate($scope, instances) {
	
	    $scope.$on = $scope.$on || angular.noop;
	    $scope.$emit = $scope.$emit || angular.noop;
	
	    var _enablePopulateEvents = $scope._enablePopulateEvents;
	
	    if (_enablePopulateEvents) {
	        _core.$event.refCount($scope, '_populating', '_populated').then(function () {
	            $scope.$emit('populated');
	        });
	    }
	
	    $scope.$on('populated', function (populatedEvent) {
	        populatedEvent.stopPropagation();
	    });
	
	    if (_enablePopulateEvents) {
	        $scope.$emit('_populating');
	    }
	
	    return _core.$promise.all(_core.$util.map(instances, function (instance, name) {
	
	        var promise = void 0;
	
	        if (instance.then) {
	            promise = instance;
	        } else {
	            promise = instance.retrieve();
	            $scope[name] = instance;
	        }
	
	        return promise.then(function (result) {
	            $scope[name] = result;
	            return result;
	        });
	    })).then(function (result) {
	
	        if (_enablePopulateEvents) {
	            $scope.$emit('_populated');
	        }
	
	        return result;
	    });
	}
	
	angular.value("$Component", $Component);
	angular.value("$populate", $populate);
	_angular.$rootScope;
	
	_angular.$compile;
	
	_angular.$injector;
	
	_angular.$compileProvider;
	
	_core.$Class;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$util;
	
	_core.$promise;
	
	_core.$config;
	
	_core.$event;
	
	_locale.$flushContent;
	
	_ng.$cleanRootScope;
	
	_directive.$registerDirective;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "./components/squid/dist/ng/ng.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$angularInvoke = $angularInvoke;
	exports.$once = $once;
	exports.$cleanRootScope = $cleanRootScope;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	function $angularInvoke(method) {
	    try {
	        return method();
	    } catch (err) {
	        _angular.$injector.get('$exceptionHandler')(err);
	    }
	}
	
	function $once(name, handler) {
	    var cancel = _core.$event.on(name, function () {
	        cancel();
	        handler.apply(this, arguments);
	    }, true);
	}
	
	function $cleanRootScope(rootScope) {
	
	    var keys = Object.keys(rootScope);
	
	    var autoCleanupEventHandlers = [];
	    var eventHandlers = [];
	    var eventCancelers = [];
	
	    _core.$util.monkeyPatch(rootScope, '$on', function (_ref, original) {
	        var name = _ref[0],
	            handler = _ref[1],
	            once = _ref[2];
	
	
	        var cancel = original();
	
	        var $state = void 0;
	
	        try {
	            $state = _angular.$injector.get('$state');
	        } catch (err) {
	            // pass
	        }
	
	        if (name === '$destroy' || !$state || !$state.current || !$state.current.name || $state.current.name === 'default') {
	            autoCleanupEventHandlers.push(cancel);
	            return function autoCleanedUpCancel() {};
	        }
	
	        if (once) {
	            eventCancelers.push(cancel);
	            return cancel;
	        }
	
	        // Let ng-router do its thing
	        if (handler.toString().indexOf('updateView') !== -1) {
	            return cancel;
	        }
	
	        var stack = void 0;
	
	        try {
	            throw new Error('$rootScope.$on');
	        } catch (err) {
	            stack = err.stack;
	        }
	
	        var reference = {
	            name: name,
	            handler: handler.toString(),
	            stack: stack
	        };
	        eventHandlers.push(reference);
	
	        return function () {
	            cancel();
	            eventHandlers.splice(eventHandlers.indexOf(reference), 1);
	        };
	    });
	
	    return function () {
	
	        _core.$event.emit('$destroy');
	
	        autoCleanupEventHandlers.forEach(function (canceler) {
	            return canceler();
	        });
	        autoCleanupEventHandlers = [];
	
	        Object.keys(rootScope).forEach(function (key) {
	            if (keys.indexOf(key) === -1) {
	                delete rootScope[key];
	            }
	        });
	
	        if (eventHandlers.length) {
	            throw new Error('$rootScope event handlers not cleaned up:\n\n' + eventHandlers.map(function (eventHandler) {
	                return eventHandler.name + '\n\n' + eventHandler.handler + '\n\n' + eventHandler.stack;
	            }).join('\n\n'));
	        }
	
	        eventCancelers.forEach(function (cancel) {
	            return cancel();
	        });
	    };
	}
	
	angular.value("$angularInvoke", $angularInvoke);
	angular.value("$once", $once);
	angular.value("$cleanRootScope", $cleanRootScope);
	_angular.$injector;
	
	_core.$util;
	
	_core.$event;

/***/ },

/***/ "./components/squid/dist/ng/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$registerDirective = $registerDirective;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function $registerDirective(tag, definition) {
	
	    var directiveName = tag.replace(/-([a-z])/g, function (g) {
	        return g[1].toUpperCase();
	    });
	
	    return _angular2["default"].module().directive(directiveName, definition);
	}
	
	_angular2["default"].value("$registerDirective", $registerDirective);

/***/ },

/***/ "./components/squid/dist/ng/feature.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _directive = __webpack_require__("./components/squid/dist/ng/directive.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	(0, _directive.$registerDirective)('feature', function () {
	    return {
	        restrict: 'A',
	        transclude: true,
	        scope: {},
	        template: '<span ng-if="enabled()" ng-transclude></span>',
	        link: function link($scope, element, attr) {
	            $scope.enabled = function () {
	                return (0, _locale.$feature)(attr.feature) || _core.$integration.getConfig(attr.feature);
	            };
	        }
	    };
	});
	
	(0, _directive.$registerDirective)('unless-feature', function () {
	    return {
	        restrict: 'A',
	        transclude: true,
	        scope: {},
	        template: '<span ng-if="!enabled()" ng-transclude></span>',
	        link: function link($scope, element, attr) {
	            $scope.enabled = function () {
	                return (0, _locale.$feature)(attr.unlessFeature) || _core.$integration.getConfig(attr.unlessFeature);
	            };
	        }
	    };
	});
	_directive.$registerDirective;
	
	_locale.$feature;
	
	_core.$integration;

/***/ },

/***/ "./components/squid/dist/ng/locale.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	(0, _angular.$registerDirective)('content', function () {
	    return {
	        restrict: 'A',
	
	        link: function link($scope, element, attributes) {
	            $scope.content = $scope.htmlContent = function (key, props) {
	                if (attributes.content) {
	                    key = attributes.content + '.' + key;
	                }
	                var content = _locale.Content.get(key, props);
	
	                if (content.toString()) {
	                    return content;
	                } else {
	                    return;
	                }
	            };
	        }
	    };
	});
	
	(0, _angular.$registerDirective)('bind-html-compile', function () {
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $scope.$watch(function () {
	                return $scope.$eval($attrs.bindHtmlCompile);
	            }, function (value) {
	                $element.html(value && value.toString());
	                (0, _angular.$compile)($element.contents())($scope);
	            });
	        }
	    };
	});
	
	(0, _angular.$registerDirective)('format-currency', function () {
	
	    return {
	        restrict: 'E',
	        template: '<span ng-bind-html="amount_formatted" class="ltrOverride"></span>',
	        scope: {
	            amount: '=',
	            symbol: '=',
	            code: '=',
	            currencyStyle: '@'
	        },
	        controller: function controller($scope) {
	
	            function format() {
	                $scope.amount_formatted = _angular.$sce.trustAsHtml((0, _locale.formatCurrency)($scope.amount, $scope.code, true, $scope.currencyStyle));
	            }
	
	            $scope.$on('$destroy', _core.$event.on('localeChange', format));
	
	            $scope.$watch('amount', function (newValue, oldValue) {
	                if (newValue !== oldValue && _locale.$locale.country) {
	                    format();
	                }
	            });
	
	            if (_locale.$locale.country) {
	                format();
	            }
	        } // controller
	    }; // return
	}); // registerDirective
	
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	angular.module().value('$sanitize', function (val) {
	    if (val instanceof _locale.Content) {
	        return val.toSafeString();
	    }
	    return (0, _locale.sanitize)(val);
	});
	
	_angular.$sce;
	
	_angular.$registerDirective;
	
	_angular.$compile;
	
	_core.$event;
	
	_locale.formatCurrency;
	
	_locale.sanitize;
	
	_locale.Content;
	
	_locale.$locale;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/squid/dist/ng", "components/squid/dist/ng/locale.js"))

/***/ },

/***/ "./components/squid/dist/ng/module.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.module = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _module = _angular2['default'].module;
	exports.module = _module;

/***/ },

/***/ "./components/squid/dist/ng/events.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	angular.module().run(function () {
	
	    _core.$event.on('$stateChangeStart', function (event) {
	        _core.$event.emit('loading');
	        _core.$event.emit('loaded');
	    });
	
	    var startLoadTime = 0;
	    var currentState = 'checkout_init';
	
	    function currentStateName() {
	        return _uiRouter.$state.current.name && _uiRouter.$state.current.name.replace(/\./g, '_');
	    }
	
	    _core.$event.on('startLoad', function () {
	
	        if (startLoadTime) {
	            startLoadTime = _core.$util.now();
	        } else if (window.enablePerformance && window.performance.timing.connectEnd && window.performance.timing.navigationStart) {
	
	            var performance = window.performance;
	            var timing = window.performance.timing || {};
	            var now = performance.now();
	
	            startLoadTime = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
	        }
	    });
	
	    _core.$event.on('allLoaded', function () {
	
	        var newState = currentStateName();
	
	        if (!newState) {
	            return;
	        }
	
	        if (currentState === newState) {
	            _core.$event.emit('page_reloaded', currentState);
	        } else {
	
	            var duration = void 0;
	
	            if (startLoadTime) {
	                duration = _core.$util.now() - startLoadTime;
	            }
	
	            var payload = {
	                start: currentState,
	                end: newState,
	                time: duration,
	                duration: duration
	            };
	
	            _core.$event.emit('$transition', {
	                from: currentState,
	                toState: _uiRouter.$state.current,
	                duration: duration
	            });
	
	            _logger.$logger.info('transition', payload);
	            _logger.$logger.info('transition_' + currentState + '_to_' + newState, payload);
	
	            _core.$event.emit('page_loaded', currentState, newState);
	
	            currentState = newState;
	        }
	    });
	
	    _core.$event.emit('loading');
	
	    var cancel = _core.$event.on('$stateChangeSuccess', function () {
	        if (_uiRouter.$state.current.template) {
	            cancel();
	            setTimeout(function () {
	                _core.$event.emit('loaded');
	            }, 50);
	        }
	    });
	});
	
	_uiRouter.$state;
	
	_logger.$logger;
	
	_core.$event;
	
	_core.$util;

/***/ },

/***/ "./components/squid/dist/ng/pxp.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	_core.$event.on('pxp_res', function (event, pxpRes) {
	    _uiRouter.$state.current.trackingData = _uiRouter.$state.current.trackingData || {};
	    _uiRouter.$state.current.trackingData.pxpData = _uiRouter.$state.current.trackingData.pxpData || [];
	    _uiRouter.$state.current.trackingData.pxpData.push(pxpRes);
	});
	
	_uiRouter.$state;
	
	_core.$event;

/***/ },

/***/ "./components/squid/dist/paypal/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _env = __webpack_require__("./components/squid/dist/paypal/env.js");
	
	Object.keys(_env).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _env[key];
	    }
	  });
	});
	
	var _config = __webpack_require__("./components/squid/dist/paypal/config.js");
	
	Object.keys(_config).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _config[key];
	    }
	  });
	});
	
	var _pxp = __webpack_require__("./components/squid/dist/paypal/pxp.js");
	
	Object.keys(_pxp).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _pxp[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/paypal/env.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	var $env = exports.$env = {
	
	    isLocal: function isLocal() {
	        return window.location.hostname === 'localhost' || window.location.hostname === 'localhost.paypal.com';
	    },
	
	    isStage: function isStage() {
	        return Boolean(window.location.hostname.match(/^.*\.qa\.paypal\.com$/));
	    },
	
	    isSandbox: function isSandbox() {
	        return Boolean(window.location.hostname.match(/^.*\.sandbox\.paypal\.com$/));
	    },
	
	    isLive: function isLive() {
	        return window.location.hostname === 'www.paypal.com';
	    },
	
	    isTest: function isTest() {
	        return false;
	    }
	};
	
	angular.value("$env", $env);

/***/ },

/***/ "./components/squid/dist/paypal/config.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _env = __webpack_require__("./components/squid/dist/paypal/env.js");
	
	_core.$config.deploy = _core.$config.deploy || _env.$env;
	
	_core.$config;
	
	_env.$env;

/***/ },

/***/ "./components/squid/dist/paypal/pxp.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$PXPModel = undefined;
	exports.$getPxpTreatments = $getPxpTreatments;
	exports.$pxp = $pxp;
	exports.$pxpMatch = $pxpMatch;
	exports.$pxpFactors = $pxpFactors;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var $PXPModel = exports.$PXPModel = _core.$Model.extend({
	    api: new _core.$Api({
	        uri: '/api/pxp/:pagename'
	    })
	});
	
	function logPxp(pxpRes, params, logPayload) {
	
	    var exp_name = [],
	        xe = [],
	        xt = [];
	
	    angular.forEach(pxpRes.treatments, function (treatment) {
	
	        _logger.$logger.info('treatment_' + treatment.treatment_name, angular.extend({
	            experiment: pxpRes.pagename,
	            treatment: treatment.treatment_name,
	            experiment_id: treatment.experiment_id,
	            treatment_id: treatment.treatment_id,
	            loc_country: _locale.$locale.country,
	            loc_lang: _locale.$locale.lang
	        }, params, logPayload));
	
	        exp_name.push(treatment.treatment_name);
	        xe.push(treatment.experiment_id);
	        xt.push(treatment.treatment_id);
	    });
	
	    _logger.$logger.info('pxp_' + pxpRes.pagename, angular.extend({
	        pxp_exp_id: xe.join('|'),
	        pxp_trtmnt_id: xt.join('|'),
	        treatments: exp_name.join('|'),
	        loc_country: _locale.$locale.country,
	        loc_lang: _locale.$locale.lang
	    }, params, logPayload));
	
	    _logger.$logger.info('fpti_pxp_check', {
	        from: 'PXP_CHECK',
	        to: 'process_pxp_check',
	        pxp_exp_id: xe.join(','),
	        pxp_trtmnt_id: xt.join(',')
	    });
	
	    _core.$event.emit('pxp_res', pxpRes);
	}
	
	function $getPxpTreatments(id, params, logPayload) {
	    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	
	    return _core.$promise.run(function () {
	
	        var pxp = $PXPModel.instance(_core.$util.buildURL(id, params), { pagename: id });
	
	        var forceTreatments = _core.$util.param('pxp_' + id);
	
	        if (forceTreatments) {
	            pxp.treatments = _core.$util.map(forceTreatments.split(','), function (treatment_name) {
	                return {
	                    treatment_name: treatment_name
	                };
	            });
	
	            return pxp;
	        }
	
	        if (forceApiCall) {
	            return pxp.reload({
	                params: params
	            });
	        }
	
	        return pxp.retrieve({
	            params: params
	        });
	    }).then(function (pxp) {
	
	        if (!pxp.cached) {
	            logPxp(pxp, params, logPayload);
	        }
	
	        pxp.cached = true;
	
	        return pxp;
	    });
	}
	
	function $pxp(id, params, pattern) {
	    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	
	    if (!pattern) {
	        pattern = params;
	        params = {};
	    }
	    pattern = new RegExp('^' + pattern + '$');
	
	    return $getPxpTreatments(id, params, null, forceApiCall).then(function (pxpResponse) {
	        var result = void 0;
	        _core.$util.some(pxpResponse.treatments, function (treatment) {
	            if (pattern.test(treatment.treatment_name)) {
	                result = {
	                    treatment_name: treatment.treatment_name,
	                    factors: treatment.factors
	                };
	                return result;
	            }
	        });
	        return result;
	    });
	}
	
	function $pxpMatch(id, params, patterns, logPayload) {
	
	    if (!patterns) {
	        patterns = params;
	        params = {};
	    }
	    return $getPxpTreatments(id, params, logPayload).then(function (pxpResponse) {
	
	        var result = {};
	
	        angular.forEach(patterns, function (pattern, name) {
	            pattern = new RegExp('^' + pattern + '$');
	
	            result[name] = false;
	
	            _core.$util.some(pxpResponse.treatments, function (treatment) {
	                if (pattern.test(treatment.treatment_name)) {
	                    result[name] = true;
	                    return result[name];
	                }
	            });
	        });
	
	        return result;
	    });
	}
	
	function $pxpFactors(id, params, pattern) {
	    params.factors = 'true';
	    return $pxp(id, params, pattern).then(function (pxpResponse) {
	        var result = void 0;
	        if (pxpResponse && pxpResponse.factors) {
	            result = { treatment_name: pxpResponse.treatment_name };
	            var pxpFactors = pxpResponse.factors;
	            var length = pxpFactors.length;
	            for (var i = 0; i < length; i++) {
	                result[pxpFactors[i].name] = pxpFactors[i].value;
	            }
	        }
	        return result;
	    });
	}
	
	window.$pxp = $pxp;
	
	angular.value("$PXPModel", $PXPModel);
	angular.value("$getPxpTreatments", $getPxpTreatments);
	angular.value("$pxp", $pxp);
	angular.value("$pxpMatch", $pxpMatch);
	angular.value("$pxpFactors", $pxpFactors);
	_logger.$logger;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$util;
	
	_core.$promise;
	
	_core.$event;
	
	_locale.$locale;

/***/ },

/***/ "./components/xo-models/src/auth/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.auth', ['squid']).factory('$AuthApi', function ($Api, $config) {
	        return $Api.extend('AuthApi', {
	            baseURI: $config.urls.baseUrl,
	            uri: '/api/auth',
	            postAttempts: 3
	        });
	    }).factory('$AuthModel', function ($Model, $AuthApi) {
	
	        return $Model.extend('AuthModel', {
	            api: new $AuthApi(),
	
	            loggedIn: function loggedIn() {
	                return this.logged_in;
	            },
	
	            visitorId: function visitorId() {
	                return this.visitor_id;
	            },
	
	            accessToken: function accessToken() {
	                return this.access_token;
	            },
	
	            accessTokenPresent: function accessTokenPresent() {
	                return this.access_token_present;
	            },
	
	            refreshToken: function refreshToken() {
	                return this.refresh_token;
	            }
	        });
	    }).factory('$ULoginModel', function ($Model, $Api) {
	
	        return $Model.extend('ULoginModel', {
	            api: new $Api({
	                uri: '/api/auth/ulogin',
	                postAttempts: 1,
	                cache: false
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/auth", "components/xo-models/src/auth/index.js"))

/***/ },

/***/ "./js/lib/fallback.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _icFallback = __webpack_require__("./js/lib/icFallback.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	_angular2['default'].module().factory('$fallbackErrorHandler', function ($q, $config, $meta, $timeout, $window, $logger, $log, $feature, $ReturnToMerchant, $locale, $util, $FallbackError, $state, $rootScope, $populate, $CheckoutCartModel, $CheckoutAppDataModel, $pxp, $experiment) {
	    return function (err) {
	        var reason = err.reason;
	        var product = err.product;
	        var entry_point = err.entryPoint;
	        var params = err.params;
	        var model = {};
	
	        function getFallbackUrl(urlParams, waType) {
	            if ($rootScope.wps || $rootScope.invoice) {
	                return $populate(model, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($meta.token)
	                }).then(function () {
	                    // defaulting for now to ensure backward compatibility
	                    var base = $config.urls.fallbackUrl['buyNow'];
	                    if (model.checkoutAppData.flags.is_cart_upload_flow || waType === 'CartUpload' || waType === 'AddToCart' || model.checkoutAppData.flags.is_shopping_cart_flow || waType === 'ShoppingCart') {
	                        base = $config.urls.fallbackUrl['cartUpload'];
	                    }
	
	                    if (model.checkoutAppData.flags.is_invoice_flow) {
	                        urlParams.id = model.checkoutAppData.invoice_id;
	                        base = $config.urls.fallbackUrl['invoice'];
	                    }
	
	                    return $util.paypalURL(base, urlParams);
	                });
	            } else {
	                return $q.when().then(function () {
	                    var base = $config.urls.fallbackUrl[product];
	                    return $util.paypalURL(base, urlParams);
	                });
	            }
	        }
	
	        function showGenericErrorPage(errorReason) {
	            if ($rootScope.partnerIntegration) {
	                $logger.info('partner_integration_fallback_to_genericErrorPage');
	            }
	
	            var code = errorReason || reason;
	            code = code ? window.btoa(code) : code;
	
	            $state.go('checkout.genericError', {
	                code: code
	            });
	        }
	
	        function doFallback() {
	            $util.assert(reason, 'expected fallback reason');
	
	            product = product || 'ux';
	
	            var urlParams = params || {};
	
	            _angular2['default'].extend(urlParams, {
	                token: $meta.token,
	                fallback: 1,
	                reason: reason,
	                landing: entry_point,
	                useraction: $util.param('useraction')
	            });
	
	            if ($rootScope.partnerIntegration) {
	                urlParams.incontext = '1';
	                urlParams.nolegacy = '1';
	            } else if ($rootScope.miniBrowser) {
	                urlParams.incontext = '1';
	            }
	
	            var wpsParams = void 0;
	            if ($rootScope.wps) {
	                wpsParams = $util.decodeAndParse($meta.xclickParams);
	                $logger.info('wps_fallback', {
	                    token: $meta.token,
	                    reason: reason
	                });
	                $logger.info('wps_fallback_reason_' + reason, {
	                    reason: reason
	                });
	            }
	
	            var waType = wpsParams && wpsParams.wa_type;
	
	            return getFallbackUrl(urlParams, waType).then(function (url) {
	                // Fallback whitelist experiment in config to determine if we should fallback or instead redirect to generic error page.
	                // We go to generic error page if the reason is not in the whitelist and random number is below the throttle value
	                var fallbackWhitelist = $config.fallbackWhitelist;
	
	                if (fallbackWhitelist && fallbackWhitelist.throttle > 0) {
	                    var whitelist = fallbackWhitelist.whitelisted || [];
	
	                    if (whitelist.indexOf(reason) === -1) {
	                        if ($util.sessionStorageEnabled() && $experiment('fallback_reason_not_whitelisted', fallbackWhitelist.throttle, $rootScope.token, { reason: reason })) {
	                            // we're using sessionStorage for retry detection
	                            var RETRY_KEY = 'retry_page_shown';
	                            var RETRY_PAGE_LIMIT = 3; // Only show the retry page at most 3 times
	                            var timesSeen = Number(sessionStorage.getItem(RETRY_KEY));
	                            var destination = 'RETRY';
	
	                            if (!timesSeen || timesSeen < 0) {
	                                // Reset if there's an invalid value for timesSeen for some reason
	                                timesSeen = 0;
	                            }
	
	                            if (timesSeen < RETRY_PAGE_LIMIT) {
	                                // Only try to go to retry page if we're within retry attempts
	                                timesSeen++;
	                                sessionStorage.setItem(RETRY_KEY, timesSeen);
	                            } else {
	                                destination = 'DEFAULT';
	                            }
	
	                            $logger.info('checkout_fpti', {
	                                'enable_refresh_prompt': reason
	                            });
	
	                            return showGenericErrorPage(destination);
	                        }
	                    } else {
	                        $logger.info('fallback_reason_whitelisted', {
	                            reason: reason,
	                            product: product
	                        });
	                    }
	                }
	
	                if (!$config.fallbackEnabled && !entry_point) {
	                    return $log.warn('Fallback inhibited by config', url);
	                }
	
	                if ($config.deploy.isLocal() && !entry_point) {
	                    return $log.warn('Fallback inhibited in local mode.', url);
	                }
	
	                $logger.log(product ? 'info' : 'error', 'fallback', {
	                    reason: reason,
	                    product: product,
	                    entry_point: entry_point,
	                    error_desc: reason,
	                    from: $rootScope.currentState || 'fallback',
	                    to: product ? 'process_fallback_' + product : 'process_fallback'
	                });
	
	                $logger.info('fallback_reason_' + reason, {
	                    reason: reason
	                });
	
	                if (window.paypalCheckout) {
	                    if (window.opener) {
	                        return (0, _icFallback.$incontextFallback)(window, url);
	                    }
	
	                    return $state.go('checkout.framebust', { action: 'fallback', url: url });
	                }
	
	                $rootScope.$emit('loading');
	
	                if (product === 'ux') {
	                    // Otherwise we can make a decision based on whether we're in the minibrowser or not
	                    return $rootScope.wps && !$rootScope.invoice ? $ReturnToMerchant.postTo(url, wpsParams) : $ReturnToMerchant.goTo(url);
	                }
	
	                // Safe to always return to Aries
	                return $util.redirect(url);
	            });
	        }
	
	        if (product === 'error') {
	            $logger.error(reason, {
	                url: window.location.href
	            });
	
	            var _$config$urls = $config.urls,
	                baseUrl = _$config$urls.baseUrl,
	                errorUrl = _$config$urls.errorUrl;
	
	
	            return $util.redirect(baseUrl + errorUrl);
	        }
	
	        if ($rootScope.wps && $rootScope.paymentComplete) {
	            // Do not fallback. UX has no context of hermes token and will result in duplicate payment
	            $logger.info('wps_error_after_payment', {
	                reason: reason
	            });
	
	            return showGenericErrorPage('PAYMENT_ALREADY_DONE');
	        }
	
	        var beamPattern = /^BA-[0-9A-Z]{17}$/;
	        var isBeamIntegration = $meta.baToken && beamPattern.test($meta.baToken);
	        var cartExchangeFailed = isBeamIntegration && beamPattern.test($meta.token);
	        if (cartExchangeFailed) {
	            product = 'ux';
	        }
	
	        // For Beam Integration - always show generic Error when cart exchange fails.
	        // On successful Cart Exchange - disable fallback until MPWEB supports BA token support.
	        if (product === 'ux' && isBeamIntegration && cartExchangeFailed) {
	            return showGenericErrorPage();
	        }
	
	        return $populate(model, {
	            checkoutCart: $CheckoutCartModel.instance($meta.token),
	            checkoutAppData: $CheckoutAppDataModel.instance($meta.token)
	        }).then(function () {
	            // No fallback for Tokenized_Wallet usecases
	            if (model.checkoutCart.isWalletTokenization()) {
	                return showGenericErrorPage();
	            }
	            // V.zero always fallback (no longer controlled by PXP)
	            if (product === 'ux' && $rootScope.partnerIntegration) {
	                $logger.info('partner_integration_fallback_to_UX');
	                $window.resizeTo(screen.availWidth, screen.availHeight);
	                return doFallback();
	            }
	            // Others - Do not fallback if appdata flag dictates no fallback
	            if (model.checkoutAppData.flags.disable_legacy_fallback) {
	                $logger.error('fallback_inhibited_for_xo_order_tokens');
	                return showGenericErrorPage();
	            } else {
	                return doFallback();
	            }
	        });
	    };
	});
	
	_icFallback.$incontextFallback;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/fallback.js"))

/***/ },

/***/ "./components/xo-return-to-merchant/dist/util.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var postRobot = void 0;
	
	if (window.ppxo && window.ppxo.PayPalCheckout.isXComponent()) {
	    postRobot = window.ppxo.postRobot;
	} else {
	    if (window.ppxo && window.ppxo.postRobot) {
	        window.ppxo.postRobot.disable();
	    }
	    postRobot = __webpack_require__("./components/post-robot/dist/post-robot.min.js");
	}
	
	function match(str, pattern) {
	    var regmatch = str.match(pattern);
	    if (regmatch) {
	        return regmatch[1];
	    }
	}
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-return-to-merchant', ['squid', 'xo-device-info']).factory('$ReturnToMerchant', function ($window, $DeviceInfo, $rootScope, $util, $feature, $logger, $state, $timeout, $CheckoutSessionModel, $CheckoutCartModel) {
	        return {
	            goTo: function goTo(url, forceRedirect) {
	
	                $logger.info(url.indexOf('PayerID') > -1 ? 'return_to_merchant' : 'cancel_to_merchant', {
	                    url: url
	                });
	
	                if (window.xchild && !window.paypalCheckout) {
	                    window.paypalCheckout = window.xchild;
	                }
	
	                if (window.paypalCheckout) {
	                    $logger.done();
	                    $rootScope.$emit('loading');
	
	                    var params = {
	                        paymentToken: match(url, /token=((EC-)?[A-Z0-9]+)/),
	                        billingToken: match(url, /ba_token=((BA-)?[A-Z0-9]+)/),
	                        payerID: match(url, /PayerID=([A-Z0-9]+)/),
	                        paymentID: match(url, /paymentId=((PAY-)?[A-Z0-9]+)/),
	                        intent: $CheckoutCartModel.instance($rootScope.token).payment_action
	                    };
	
	                    if (params.payerID || params.billingToken) {
	                        params.returnUrl = url;
	                        return window.paypalCheckout.props.onAuthorize(params);
	                    }
	
	                    if (window.paypalCheckout.props.onPaymentCancel) {
	                        params.cancelUrl = url;
	                        return window.paypalCheckout.props.onCancel(params);
	                    }
	
	                    return window.paypalCheckout.close();
	                }
	
	                var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
	                var showPaymentSuccess = Boolean($DeviceInfo.isDevice() && !isHTTPUrl);
	
	                if (showPaymentSuccess) {
	                    $logger.info('redirect', {
	                        url: url
	                    });
	                    $window.onunload = $window.onbeforeunload = function () {};
	                    $window.location = url;
	                    return $state.go('checkout.genericMessage', {
	                        code: 'PAYMENT_SUCCESS'
	                    });
	                }
	
	                if (forceRedirect) {
	                    $util.redirect(url);
	                }
	
	                var isVZeroIframe = Boolean($rootScope.partnerIntegration) && $util.isIFrame();
	
	                if (isVZeroIframe) {
	                    $util.redirect(url, { redirectImmediateParent: true });
	                }
	
	                // If we are not in minibrowser, do a hard redirect
	                else if ($rootScope.partnerIntegration || !$rootScope.miniBrowser && !$util.isIFrame()) {
	                        $util.redirect(url);
	                    } else {
	
	                        // Construct a message to send to the parent
	                        var result = this.postToMerchant({
	                            operation: 'return_to_merchant',
	                            returnUrl: url,
	                            updateParent: true
	                        });
	
	                        // Otherwise we have no choice but to return to the merchant
	                        if (!result) {
	                            $util.redirect(url);
	                        }
	
	                        postRobot.sendToParent('return', {
	                            url: url
	
	                        }, function (err) {
	
	                            if (err) {
	                                return;
	
	                                /*
	                                    TODO: uncomment this when integration script moves to post-robot
	                                     $logger.error('post_return_error', {
	                                        error: err.stack || err.toString()
	                                    });
	                                  return $util.redirect(url);
	                                */
	                            }
	                        });
	                    }
	
	                var userStatus = function userStatus() {
	                    $logger.info('redirected_user_still_on_page_second_checkpoint');
	                };
	
	                $timeout(function () {
	                    $logger.info('redirected_user_still_on_page_first_checkpoint');
	                    $timeout(userStatus, 10000);
	                }, 10000);
	            },
	
	            postToMerchant: function postToMerchant(msg) {
	
	                try {
	                    msg = angular.toJson(msg, 0);
	
	                    // If we are not in IE, attempt to send a postMessage
	                    if ($window.opener && ($window.navigator.userAgent.match(/edge/i) || $window.opener.postMessage && !$window.navigator.userAgent.match(/msie|trident/i))) {
	                        $window.opener.postMessage(msg, '*');
	                        $logger.info('minibrowser_postmessage');
	                        return true;
	                    }
	                    // Otherwise, attempt to send a message through the iframe bridge
	                    var bridge = $window.opener && $window.opener.frames && $window.opener.frames.length && $window.opener.frames.PayPalBridge;
	
	                    if (bridge && bridge.returnToParent) {
	                        bridge.returnToParent(msg);
	                        $logger.info('minibrowser_bridgemessage');
	                        return true;
	                    }
	
	                    $logger.warn('minibrowser_nopostback');
	                } catch (err) {
	                    $logger.error('minibrowser_postback_error', {
	                        error: err.stack || err.toString()
	                    });
	                }
	
	                return false;
	            },
	
	            postTo: function postTo(url, msg) {
	                var form = document.createElement('form');
	                form.method = 'POST';
	                form.action = url;
	                form.className = 'hide';
	
	                for (var key in msg) {
	                    var input = document.createElement('input');
	                    input.name = key;
	                    input.value = msg[key];
	                    form.appendChild(input);
	                }
	
	                $window.document.body.appendChild(form);
	                form.submit();
	                $logger.info('web_postmessage');
	                return true;
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-return-to-merchant/dist", "components/xo-return-to-merchant/dist/util.js"))

/***/ },

/***/ "./components/post-robot/dist/post-robot.min.js":
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("postRobot",[],t):"object"==typeof exports?exports.postRobot=t():e.postRobot=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){function r(){(0,a.registerGlobals)(),u.util.debug("ID",(0,i.getWindowID)()),u.util.listen(window,"message",s.messageListener),u.childWindows.register((0,i.getWindowID)(),window,u.util.getType()),(0,u.propagate)((0,i.getWindowID)())}Object.defineProperty(t,"__esModule",{value:!0});var o=n(1);Object.keys(o).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}})});var i=n(3),u=n(13),s=n(11),a=n(15);r(),t["default"]=e.exports},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.util=t.openBridge=t.reset=t.parent=void 0;var r=n(2);Object.keys(r).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}})});var o=n(23);Object.keys(o).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}})});var i=n(24);Object.keys(i).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}})});var u=n(25);Object.keys(u).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}})});var s=n(11);Object.defineProperty(t,"reset",{enumerable:!0,get:function(){return s.resetListeners}});var a=n(16);Object.defineProperty(t,"openBridge",{enumerable:!0,get:function(){return a.openBridge}});var c=n(7);Object.defineProperty(t,"util",{enumerable:!0,get:function(){return c.util}});t.parent=c.util.getParent()},function(e,t,n){function r(e){return a.promise.nodeify(new a.promise.Promise(function(t,n){if(!e.name)throw new Error("Expected options.name");if(!e.window)throw new Error("Expected options.window");if(u.CONFIG.MOCK_MODE)e.window=window;else if("string"==typeof e.window){var r=document.getElementById(e.window);if(!r)throw new Error("Expected options.window "+e.window+" to be a valid element id");if("iframe"!==r.tagName.toLowerCase())throw new Error("Expected options.window "+e.window+" to be an iframe");if(e.window=r.contentWindow,!e.window)throw new Error("Expected options.window")}var o=e.name+"_"+a.util.uniqueID();if(s.listeners.response[o]=e,e.window.closed)throw new Error("Target window is closed");e.timeout&&setTimeout(function(){return n(new Error("Post message response timed out after "+e.timeout+" ms"))},e.timeout),e.respond=function(e,r){return e?n(e):t(r)},(0,s.sendMessage)(e.window,{hash:o,type:u.CONSTANTS.POST_MESSAGE_TYPE.REQUEST,name:e.name,data:e.data||{}})["catch"](n),setTimeout(function(){return e.ack?void 0:n(new Error("No ack for postMessage "+e.name))},u.CONFIG.ACK_TIMEOUT)}),e.callback)}function o(e,t,n,o){return!o&&n instanceof Function&&(o=n,n={}),r({window:e,name:t,data:n,callback:o})}function i(e,t,n){if(!a.util.getParent())throw new Error("Window does not have a parent");return o(a.util.getParent(),e,t,n)}Object.defineProperty(t,"__esModule",{value:!0}),t.request=r,t.send=o,t.sendToParent=i;var u=n(3),s=n(11),a=n(13)},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=n(4);Object.keys(r).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}})});var o=n(5);Object.keys(o).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}})});var i=n(6);Object.keys(i).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}})})},function(e,t){Object.defineProperty(t,"__esModule",{value:!0});t.CONFIG={ALLOW_POSTMESSAGE_POPUP:!0,DEBUG:!1,ACK_TIMEOUT:3e3,LOG_TO_PAGE:!1,MOCK_MODE:!1}},function(e,t){Object.defineProperty(t,"__esModule",{value:!0});t.CONSTANTS={POST_MESSAGE_TYPE:{REQUEST:"postrobot_message_request",RESPONSE:"postrobot_message_response",ACK:"postrobot_message_ack"},POST_MESSAGE_ACK:{SUCCESS:"success",ERROR:"error"},POST_MESSAGE_NAMES:{IDENTIFY:"identify"},WINDOW_TYPES:{FULLPAGE:"fullpage",POPUP:"popup",IFRAME:"iframe"},WINDOW_PROPS:{POSTROBOT:"__postRobot__"}}},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.getWindowID=void 0;var r=n(7);t.getWindowID=r.util.memoize(function(){return window.name||r.util.uniqueID()})},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.util=void 0;var r=n(3),o=n(8),i=t.util={isPopup:function(){return Boolean(window.opener)},isIframe:function(){return Boolean(window.parent&&window!==window.parent)},isFullpage:function(){return Boolean(!i.isIframe()&&!i.isPopup())},windowReady:new o.promise.Promise(function(e,t){return"complete"===document.readyState?e():void window.addEventListener("load",e)}),getType:function(){return i.isPopup()?r.CONSTANTS.WINDOW_TYPES.POPUP:i.isIframe()?r.CONSTANTS.WINDOW_TYPES.IFRAME:r.CONSTANTS.WINDOW_TYPES.FULLPAGE},once:function(e){if(!e)return e;var t=!1;return function(){return t?void 0:(t=!0,e.apply(this,arguments))}},getParent:function(){return i.isPopup()?window.opener:i.isIframe()?window.parent:void 0},eachParent:function(e,t){var n=window;for(t&&e(window);;){var r=n.opener||n.parent;if(n===r)return;n=r,e(n)}},eachFrame:function(e,t){for(var n=0;n<e.frames.length;n++){var r=void 0;try{r=e.frames[n]}catch(o){continue}t(r)}},noop:function(){},getDomain:function(){return window.location.host},clearLogs:function(){if(window.console&&window.console.clear&&window.console.clear(),r.CONFIG.LOG_TO_PAGE){var e=document.getElementById("postRobotLogs");e&&e.parentNode.removeChild(e)}},writeToPage:function(e,t){setTimeout(function(){var n=document.getElementById("postRobotLogs");n||(n=document.createElement("div"),n.id="postRobotLogs",n.style.cssText="width: 800px; font-family: monospace; white-space: pre-wrap;",document.body.appendChild(n));var r=document.createElement("div"),o=(new Date).toString().split(" ")[4],u=i.map(t,function(e){if("string"==typeof e)return e;if(!e)return toString.call(e);var t=void 0;try{t=JSON.stringify(e,0,2)}catch(n){t="[object]"}return"\n\n"+t+"\n\n"}).join(" "),s=o+" "+e+" "+u;r.innerHTML=s;var a={log:"#ddd",warn:"orange",error:"red",info:"blue",debug:"#aaa"}[e];r.style.cssText="margin-top: 10px; color: "+a+";",n.childNodes.length?n.insertBefore(r,n.childNodes[0]):n.appendChild(r)})},logLevel:function(e,t){t=Array.prototype.slice.call(t),t.unshift(i.getDomain()),t.unshift(i.getType().toLowerCase()),t.unshift("[post-robot]"),r.CONFIG.LOG_TO_PAGE&&i.writeToPage(e,t),window.console&&(window.console[e]||(e="log"),window.console[e]&&window.console[e].apply(window.console,t))},log:function(){i.logLevel("info",arguments)},debug:function(){r.CONFIG.DEBUG&&i.logLevel("debug",arguments)},debugError:function(){r.CONFIG.DEBUG&&i.logLevel("error",arguments)},safeHasProp:function(e,t){try{return!!e[t]}catch(n){return!1}},warn:function(){i.logLevel("warn",arguments)},error:function(){i.logLevel("error",arguments)},listen:function(e,t,n){return e.addEventListener?e.addEventListener(t,n):e.attachEvent("on"+t,n),{cancel:function(){e.removeEventListener?e.removeEventListener(t,n):e.detachEvent("on"+t,n)}}},apply:function(e,t,n){return e.apply instanceof Function?e.apply(t,n):e(n[0],n[1],n[2],n[3],n[4],n[5],n[6],n[7],n[8],n[9])},find:function(e,t,n){if(!e)return n;for(var r=0;r<e.length;r++)if(t(e[r]))return e[r];return n},map:function(e,t){for(var n=[],r=0;r<e.length;r++)n.push(t(e[r]));return n},some:function(e,t){t=t||Boolean;for(var n=0;n<e.length;n++)if(t(e[n]))return!0;return!1},keys:function(e){var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push(n);return t},values:function(e){var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push(e[n]);return t},getByValue:function(e,t){for(var n in e)if(e.hasOwnProperty(n)&&e[n]===t)return n},uniqueID:function(){var e="0123456789abcdef";return"xxxxxxxxxx".replace(/./g,function(){return e.charAt(Math.floor(Math.random()*e.length))})},isFrameOwnedBy:function(e,t){try{return t.parent===e}catch(n){try{for(var r=0;r<e.frames.length;r++)if(e.frames[r]===t)return!0}catch(o){return!1}}return!1},memoize:function(e){var t={};return function(){var n=JSON.stringify(Array.prototype.slice.call(arguments));return t.hasOwnProperty(n)||(t[n]=e.apply(this,arguments)),t[n]}}}},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.promise=void 0;var r=n(9),o=t.promise={get Promise(){return window.Promise?window.Promise:r.Promise},asyncPromise:function(e){return new o.Promise(function(t,n){setTimeout(function(){try{return e(t,n)}catch(r){return n(r)}})})},run:function(e){return o.Promise.resolve().then(e)},method:function(e){return function(){var t=this,n=arguments;return o.Promise.resolve().then(function(){return e.apply(t,n)})}},nodeify:function(e,t){return t?void e.then(function(e){t(null,e)},function(e){t(e)}):e}}},function(e,t,n){var r;(function(o,i){/*!
		 * @overview es6-promise - a tiny implementation of Promises/A+.
		 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
		 * @license   Licensed under MIT license
		 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
		 * @version   2.0.1
		 */
	(function(){function u(e,t){W[C]=e,W[C+1]=t,C+=2,2===C&&A()}function s(e){return"function"==typeof e}function a(){return function(){o.nextTick(l)}}function c(){var e=0,t=new j(l),n=document.createTextNode("");return t.observe(n,{characterData:!0}),function(){n.data=e=++e%2}}function f(){var e=new MessageChannel;return e.port1.onmessage=l,function(){e.port2.postMessage(0)}}function d(){return function(){setTimeout(l,1)}}function l(){for(var e=0;C>e;e+=2)(0,W[e])(W[e+1]),W[e]=void 0,W[e+1]=void 0;C=0}function p(){}function w(e,t,n,r){try{e.call(t,n,r)}catch(o){return o}}function h(e,t,n){u(function(e){var r=!1,o=w(n,t,function(n){r||(r=!0,t!==n?g(e,n):S(e,n))},function(t){r||(r=!0,v(e,t))});!r&&o&&(r=!0,v(e,o))},e)}function O(e,t){1===t.a?S(e,t.b):2===e.a?v(e,t.b):m(t,void 0,function(t){g(e,t)},function(t){v(e,t)})}function g(e,t){if(e===t)v(e,new TypeError("You cannot resolve a promise with itself"));else if("function"==typeof t||"object"==typeof t&&null!==t)if(t.constructor===e.constructor)O(e,t);else{var n;try{n=t.then}catch(r){R.error=r,n=R}n===R?v(e,R.error):void 0===n?S(e,t):s(n)?h(e,t,n):S(e,t)}else S(e,t)}function E(e){e.f&&e.f(e.b),y(e)}function S(e,t){void 0===e.a&&(e.b=t,e.a=1,0!==e.e.length&&u(y,e))}function v(e,t){void 0===e.a&&(e.a=2,e.b=t,u(E,e))}function m(e,t,n,r){var o=e.e,i=o.length;e.f=null,o[i]=t,o[i+1]=n,o[i+2]=r,0===i&&e.a&&u(y,e)}function y(e){var t=e.e,n=e.a;if(0!==t.length){for(var r,o,i=e.b,u=0;u<t.length;u+=3)r=t[u],o=t[u+n],r?P(n,r,o,i):o(i);e.e.length=0}}function T(){this.error=null}function P(e,t,n,r){var o,i,u,a,c=s(n);if(c){try{o=n(r)}catch(f){G.error=f,o=G}if(o===G?(a=!0,i=o.error,o=null):u=!0,t===o)return void v(t,new TypeError("A promises callback cannot return that same promise."))}else o=r,u=!0;void 0===t.a&&(c&&u?g(t,o):a?v(t,i):1===e?S(t,o):2===e&&v(t,o))}function b(e,t){try{t(function(t){g(e,t)},function(t){v(e,t)})}catch(n){v(e,n)}}function _(e,t,n,r){this.n=e,this.c=new e(p,r),this.i=n,this.o(t)?(this.m=t,this.d=this.length=t.length,this.l(),0===this.length?S(this.c,this.b):(this.length=this.length||0,this.k(),0===this.d&&S(this.c,this.b))):v(this.c,this.p())}function N(e){if(D++,this.b=this.a=void 0,this.e=[],p!==e){if(!s(e))throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");if(!(this instanceof N))throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");b(this,e)}}var A,M=Array.isArray?Array.isArray:function(e){return"[object Array]"===Object.prototype.toString.call(e)},C=0,I="undefined"!=typeof window?window:{},j=I.MutationObserver||I.WebKitMutationObserver,I="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,W=Array(1e3);A="undefined"!=typeof o&&"[object process]"==={}.toString.call(o)?a():j?c():I?f():d();var R=new T,G=new T;_.prototype.o=function(e){return M(e)},_.prototype.p=function(){return Error("Array Methods must be provided an Array")},_.prototype.l=function(){this.b=Array(this.length)},_.prototype.k=function(){for(var e=this.length,t=this.c,n=this.m,r=0;void 0===t.a&&e>r;r++)this.j(n[r],r)},_.prototype.j=function(e,t){var n=this.n;"object"==typeof e&&null!==e?e.constructor===n&&void 0!==e.a?(e.f=null,this.g(e.a,t,e.b)):this.q(n.resolve(e),t):(this.d--,this.b[t]=this.h(e))},_.prototype.g=function(e,t,n){var r=this.c;void 0===r.a&&(this.d--,this.i&&2===e?v(r,n):this.b[t]=this.h(n)),0===this.d&&S(r,this.b)},_.prototype.h=function(e){return e},_.prototype.q=function(e,t){var n=this;m(e,void 0,function(e){n.g(1,t,e)},function(e){n.g(2,t,e)})};var D=0;N.all=function(e,t){return new _(this,e,!0,t).c},N.race=function(e,t){function n(e){g(o,e)}function r(e){v(o,e)}var o=new this(p,t);if(!M(e))return v(o,new TypeError("You must pass an array to race.")),o;for(var i=e.length,u=0;void 0===o.a&&i>u;u++)m(this.resolve(e[u]),void 0,n,r);return o},N.resolve=function(e,t){if(e&&"object"==typeof e&&e.constructor===this)return e;var n=new this(p,t);return g(n,e),n},N.reject=function(e,t){var n=new this(p,t);return v(n,e),n},N.prototype={constructor:N,then:function(e,t){var n=this.a;if(1===n&&!e||2===n&&!t)return this;var r=new this.constructor(p),o=this.b;if(n){var i=arguments[n-1];u(function(){P(n,r,i,o)})}else m(this,r,e,t);return r},"catch":function(e){return this.then(null,e)}};var x={Promise:N,polyfill:function(){var e;e="undefined"!=typeof i?i:"undefined"!=typeof window&&window.document?window:self,"Promise"in e&&"resolve"in e.Promise&&"reject"in e.Promise&&"all"in e.Promise&&"race"in e.Promise&&function(){var t;return new e.Promise(function(e){t=e}),s(t)}()||(e.Promise=N)}};r=function(){return x}.call(t,n,t,e),!(void 0!==r&&(e.exports=r))}).call(this)}).call(t,n(10),function(){return this}())},function(e,t){function n(){c=!1,u.length?a=u.concat(a):f=-1,a.length&&r()}function r(){if(!c){var e=setTimeout(n);c=!0;for(var t=a.length;t;){for(u=a,a=[];++f<t;)u&&u[f].run();f=-1,t=a.length}u=null,c=!1,clearTimeout(e)}}function o(e,t){this.fun=e,this.array=t}function i(){}var u,s=e.exports={},a=[],c=!1,f=-1;s.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];a.push(new o(e,t)),1!==a.length||c||setTimeout(r,0)},o.prototype.run=function(){this.fun.apply(null,this.array)},s.title="browser",s.browser=!0,s.env={},s.argv=[],s.version="",s.versions={},s.on=i,s.addListener=i,s.once=i,s.off=i,s.removeListener=i,s.removeAllListeners=i,s.emit=i,s.binding=function(e){throw new Error("process.binding is not supported")},s.cwd=function(){return"/"},s.chdir=function(e){throw new Error("process.chdir is not supported")},s.umask=function(){return 0}},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=n(12);Object.keys(r).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}})});var o=n(19);Object.keys(o).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}})});var i=n(21);Object.keys(i).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}})})},function(e,t,n){function r(e){try{e=JSON.parse(e)}catch(t){return}if(e.type&&l.RECEIVE_MESSAGE_TYPES[e.type])return e}function o(e,t){if(!s.CONFIG.MOCK_MODE&&t&&(t.type!==s.CONSTANTS.POST_MESSAGE_TYPE.REQUEST||!t.name||!d.listeners.request[t.name]||d.listeners.request[t.name].proxy!==!1)){var n=(t.type===s.CONSTANTS.POST_MESSAGE_TYPE.REQUEST||t.type===s.CONSTANTS.POST_MESSAGE_TYPE.ACK)&&d.listeners.response[t.hash];if(!n)for(var r=0;r<d.listeners.proxies.length;r++){var o=d.listeners.proxies[r];if(e===o.from)return o.to}if("parent.opener"===t.target){var i=void 0;try{i=window.parent.opener}catch(u){throw new Error("Can not get window.parent.opener to proxy to")}if(!i)throw new Error("Can not get window.parent.opener to proxy to");return i}if(t.target&&t.target!==(0,s.getWindowID)()){var c=a.childWindows.getWindowById(t.target);if(!c)throw new Error("Unable to find window to proxy message to: "+t.target);return c}}}function i(e,t){var n=r(t);if(n&&-1===p.indexOf(n.id)){p.push(n.id),a.childWindows.register(n.source,e,n.windowType);var i=o(e,n);return i?(delete n.target,(0,f.sendMessage)(i,n,!0)):(a.util.log("#receive",n.type,n.name,n),s.CONFIG.MOCK_MODE?l.RECEIVE_MESSAGE_TYPES[n.type](e,n):void l.RECEIVE_MESSAGE_TYPES[n.type](e,n))}}function u(e){var t=e.source||e.sourceElement,n=e.data;(0,c.emulateIERestrictions)(t,window),i(t,n)}Object.defineProperty(t,"__esModule",{value:!0}),t.receiveMessage=i,t.messageListener=u;var s=n(3),a=n(13),c=n(15),f=n(19),d=n(21),l=n(22),p=[]},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=n(8);Object.keys(r).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}})});var o=n(7);Object.keys(o).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}})});var i=n(14);Object.keys(i).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}})})},function(e,t,n){function r(e,t){return u.util.find(a,function(n){return n[e]===t},{})}function o(e){function t(t,r){t&&t!==window&&-1===n.indexOf(t)&&(u.util.debug("propagating to",r,t),n.push(t),u.util.safeHasProp(t,i.CONSTANTS.WINDOW_PROPS.POSTROBOT)?t[i.CONSTANTS.WINDOW_PROPS.POSTROBOT].registerSelf(e,window,u.util.getType()):(0,s.send)(t,i.CONSTANTS.POST_MESSAGE_NAMES.IDENTIFY,{id:e,type:u.util.getType()}).then(function(e){c.register(e.id,t,e.type)},function(e){u.util.debugError("Error sending identify:",e.stack||e.toString())}))}(0,s.on)(i.CONSTANTS.POST_MESSAGE_NAMES.IDENTIFY,function(t,n,r){return t?void 0:{id:e}});var n=[];u.util.eachParent(function(e){t(e,"parent"),u.util.eachFrame(e,function(e){t(e,"frame")})},!0)}Object.defineProperty(t,"__esModule",{value:!0}),t.childWindows=void 0,t.propagate=o;var i=n(3),u=n(13),s=n(1),a=[],c=t.childWindows={getWindowId:function(e){return r("win",e).id},getWindowById:function(e){return r("id",e).win},getWindowType:function(e){var t=r("win",e);if(t&&t.type)return t.type;if(u.util.safeHasProp(e,"parent")&&e.parent!==e)return i.CONSTANTS.WINDOW_TYPES.IFRAME;if(u.util.safeHasProp(e,"opener"))return i.CONSTANTS.WINDOW_TYPES.POPUP;var n=u.util.some(a,function(t){return u.util.isFrameOwnedBy(t.win,e)});return n?i.CONSTANTS.WINDOW_TYPES.IFRAME:void 0},register:function(e,t,n){var r=u.util.find(a,function(n){return n.id===e&&n.win===t});r||(u.util.debug("Registering window:",n,e,t),a.push({id:e,win:t,type:n}))}},f=window.open;window.open=function(e,t,n,r){t||(t=u.util.uniqueID(),arguments[1]=t);var o=u.util.apply(f,this,arguments);return c.register(t,o,i.CONSTANTS.WINDOW_TYPES.POPUP),o}},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0});var r=n(16);Object.keys(r).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}})});var o=n(17);Object.keys(o).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}})});var i=n(18);Object.keys(i).forEach(function(e){"default"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}})})},function(e,t,n){function r(){return s}function o(e){try{if(!e||!e.frames||!e.frames.length)return;for(var t=0;t<e.frames.length;t++)try{var n=e.frames[t];if(n&&n[i.CONSTANTS.WINDOW_PROPS.POSTROBOT])return n}catch(r){continue}}catch(r){return}}Object.defineProperty(t,"__esModule",{value:!0}),t.openBridge=void 0,t.getBridge=r,t.getBridgeFor=o;var i=n(3),u=n(13),s=void 0;t.openBridge=u.util.memoize(function(e){if(s)throw new Error("Only one bridge supported");return s=new u.promise.Promise(function(t,n){u.util.debug("Opening bridge:",e);var r=document.createElement("iframe");r.setAttribute("id","postRobotBridge"),r.setAttribute("style","margin: 0; padding: 0; border: 0px none; overflow: hidden;"),r.setAttribute("frameborder","0"),r.setAttribute("border","0"),r.setAttribute("scrolling","no"),r.setAttribute("allowTransparency","true"),r.setAttribute("tabindex","-1"),r.setAttribute("hidden","true"),r.setAttribute("title",""),r.setAttribute("role","presentation"),r.onload=function(){return t(r)},r.onerror=n,r.src=e,document.body.appendChild(r)})})},function(e,t,n){function r(){if(window[o.CONSTANTS.WINDOW_PROPS.POSTROBOT])throw new Error("Attempting to load postRobot twice on the same window");window[o.CONSTANTS.WINDOW_PROPS.POSTROBOT]={registerSelf:function(e,t,n){i.childWindows.register(e,t,n)},postMessage:i.promise.method(function(e,t){(0,u.receiveMessage)(e,t)}),postMessageParent:i.promise.method(function(e,t){window.parent.postMessage(t,"*")})}}Object.defineProperty(t,"__esModule",{value:!0}),t.registerGlobals=r;var o=n(3),i=n(13),u=n(11)},function(e,t,n){function r(e,t){if(!o.CONFIG.ALLOW_POSTMESSAGE_POPUP){var n=i.childWindows.getWindowType(e)===o.CONSTANTS.WINDOW_TYPES.IFRAME&&i.util.isFrameOwnedBy(t,e),r=i.childWindows.getWindowType(t)===o.CONSTANTS.WINDOW_TYPES.IFRAME&&i.util.isFrameOwnedBy(e,t);if(!n&&!r)throw e===window?new Error("Can not send post messages to another window (disabled by config to emulate IE)"):new Error("Can not receive post messages sent from another window (disabled by config to emulate IE)")}}Object.defineProperty(t,"__esModule",{value:!0}),t.emulateIERestrictions=r;var o=n(3),i=n(13)},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.sendMessage=void 0;var r=n(3),o=n(13),i=n(20);t.sendMessage=o.promise.method(function(e,t,n){if(t.id=t.id||o.util.uniqueID(),t.source=(0,r.getWindowID)(),t.originalSource=t.originalSource||(0,r.getWindowID)(),t.windowType=o.util.getType(),t.originalWindowType=t.originalWindowType||o.util.getType(),t.target||(t.target=o.childWindows.getWindowId(e)),o.util.log(n?"#proxy":"#send",t.type,t.name,t),r.CONFIG.MOCK_MODE)return delete t.target,window[r.CONSTANTS.WINDOW_PROPS.POSTROBOT].postMessage(window,JSON.stringify(t));if(e===window)throw new Error("Attemping to send message to self");return o.util.debug("Waiting for window to be ready"),o.util.windowReady.then(function(){return o.util.debug("Running send message strategies",t),o.promise.Promise.all(o.util.map(o.util.keys(i.SEND_MESSAGE_STRATEGIES),function(n){return i.SEND_MESSAGE_STRATEGIES[n](e,t).then(function(){return o.util.debug(n,"success"),!0},function(e){return o.util.debugError(n,"error\n\n",e.stack||e.toString()),!1})})).then(function(e){if(!o.util.some(e))throw new Error("No post-message strategy succeeded")})})})},function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.SEND_MESSAGE_STRATEGIES=void 0;var r=n(3),o=n(13),i=n(15);t.SEND_MESSAGE_STRATEGIES={POST_MESSAGE:o.promise.method(function(e,t){return(0,i.emulateIERestrictions)(window,e),e.postMessage(JSON.stringify(t,0,2),"*")}),POST_MESSAGE_GLOBAL_METHOD:o.promise.method(function(e,t){if(!o.util.safeHasProp(e,r.CONSTANTS.WINDOW_PROPS.POSTROBOT))throw new Error("postRobot not found on window");return e[r.CONSTANTS.WINDOW_PROPS.POSTROBOT].postMessage(window,JSON.stringify(t,0,2))}),POST_MESSAGE_UP_THROUGH_BRIDGE:o.promise.method(function(e,t){var n=(0,i.getBridgeFor)(e);if(!n)throw new Error("No bridge available in window");if(!o.util.safeHasProp(n,r.CONSTANTS.WINDOW_PROPS.POSTROBOT))throw new Error("postRobot not installed in bridge");return n[r.CONSTANTS.WINDOW_PROPS.POSTROBOT].postMessageParent(window,JSON.stringify(t,0,2))}),POST_MESSAGE_DOWN_THROUGH_BRIDGE:o.promise.method(function(e,t){var n=(0,i.getBridge)();if(!n)throw new Error("Bridge not initialized");if(e===n.contentWindow)throw new Error("Message target is bridge");if(!t.target){if(e!==window.opener)throw new Error("Can not post message down through bridge without target");t.target="parent.opener"}return n.then(function(e){e.contentWindow.postMessage(JSON.stringify(t,0,2),"*")})})}},function(e,t){function n(){t.listeners=r={request:{},response:{},proxies:[]}}Object.defineProperty(t,"__esModule",{value:!0}),t.resetListeners=n;var r=t.listeners=void 0;n()},function(e,t,n){function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}Object.defineProperty(t,"__esModule",{value:!0}),t.RECEIVE_MESSAGE_TYPES=void 0;var o,i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=n(3),s=n(13),a=n(19),c=n(21);t.RECEIVE_MESSAGE_TYPES=(o={},r(o,u.CONSTANTS.POST_MESSAGE_TYPE.ACK,function(e,t){var n=c.listeners.response[t.hash];if(!n)throw new Error("No handler found for post message ack for message: "+t.name+" in "+window.location.href);n.ack=!0}),r(o,u.CONSTANTS.POST_MESSAGE_TYPE.REQUEST,function(e,t){function n(n){return(0,a.sendMessage)(e,i({target:t.originalSource?t.originalSource:s.childWindows.getWindowId(e),hash:t.hash,name:t.name},n))["catch"](function(e){if(r)return r.handleError(e);throw e})}var r=c.listeners.request[t.name],o=s.util.once(function(e){return n({type:u.CONSTANTS.POST_MESSAGE_TYPE.RESPONSE,ack:u.CONSTANTS.POST_MESSAGE_ACK.SUCCESS,response:e||{}})}),f=s.util.once(function(e){return n({type:u.CONSTANTS.POST_MESSAGE_TYPE.RESPONSE,ack:u.CONSTANTS.POST_MESSAGE_ACK.ERROR,error:e.stack||e.toString()})});if(!r)return f(new Error("No postmessage request handler for "+t.name+" in "+window.location.href));if(!r.window||!e||r.window===e){n({type:u.CONSTANTS.POST_MESSAGE_TYPE.ACK});var d=void 0;try{d=r.handler(null,t.data,function(e,t){return e?f(e):o(t)})}catch(l){return f(l)}return d&&d.then instanceof Function?d.then(o,f):r.handler.length<=2?o(d):void 0}}),r(o,u.CONSTANTS.POST_MESSAGE_TYPE.RESPONSE,function(e,t){var n=c.listeners.response[t.hash];if(!n)throw new Error("No response handler found for post message response "+t.name+" in "+window.location.href);return delete c.listeners.response[t.hash],t.ack===u.CONSTANTS.POST_MESSAGE_ACK.ERROR?n.respond(t.error):t.ack===u.CONSTANTS.POST_MESSAGE_ACK.SUCCESS?n.respond(null,t.response):void 0}),o)},function(e,t,n){function r(e){if(!e.name)throw new Error("Expected options.name");if(a.listeners.request[e.name]&&!e.override&&!u.CONFIG.MOCK_MODE)throw new Error("Post message response handler already registered: "+e.name);if(!e.handler)throw new Error("Expected options.handler");return e.errorHandler=e.errorHandler||s.util.noop,e.once&&(e.handler=s.util.once(e.handler)),a.listeners.request[e.name]=e,e.handleError=function(t){delete a.listeners.request[e.name],e.errorHandler(t)},e.window&&e.errorOnClose&&!function(){var t=setInterval(function(){e.window.closed&&(clearInterval(t),e.handleError(new Error("Post message target window is closed")))},50)}(),{cancel:function(){delete a.listeners.request[e.name]}}}function o(e,t,n,o){return t instanceof Function&&(o=n,n=t,t={}),t.name=e,t.handler=n||t.handler,t.errorHandler=o||t.errorHandler,r(t)}function i(e,t,n,o){return t instanceof Function&&(o=n,n=t,t={}),t.name=e,t.handler=n||t.handler,t.errorHandler=o||t.errorHandler,t.once=!0,r(t)}Object.defineProperty(t,"__esModule",{value:!0}),t.listen=r,t.on=o,t.once=i;var u=n(3),s=n(13),a=n(11)},function(e,t,n){function r(e,t){i.listeners.proxies.push({from:e,to:t}),i.listeners.proxies.push({from:t,to:e})}function o(e,t){for(var n=[],r=0;r<i.listeners.proxies.length;r++){var o=i.listeners.proxies[r];(o.to===e&&o.from===t||o.to===t&&o.from===e)&&n.push(o)}for(var u=0;u<n.length;u++)i.listeners.proxies.splice(i.listeners.proxies.indexOf(n[u]),1)}Object.defineProperty(t,"__esModule",{value:!0}),t.proxy=r,t.unproxy=o;var i=n(11)},function(e,t,n){function r(){i.CONFIG.MOCK_MODE=!0}function o(){i.CONFIG.MOCK_MODE=!1}Object.defineProperty(t,"__esModule",{value:!0}),t.enableMockMode=r,t.disableMockMode=o;var i=n(3)}])});


/***/ },

/***/ "./components/xo-device-info/dist/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-device-info', ['squid']).factory('$DeviceInfo', function ($window, $meta, $logger) {
	        var userAgent = $window.navigator.userAgent;
	        var standalone = $window.navigator.standalone;
	        var DEVICE_PATTERN = /iPod|iPhone|iPad|Android|BlackBerry|BB10|Palm|CriOS|IEMobile|Windows Phone OS|webOS|Symbian|silk|Kindle|Opera Mini|mobile/i;
	        var TABLET_PATTERN = /ip(a|ro)d|silk|xoom|playbook|tablet|kindle|Nexus 7|GT-P10|SC-01C|SHW-M180S|SM-T320|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC( Flyer|_Flyer)|Sprint ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos S7|Dell Streak 7|Advent Vega|A101IT|A70BHT|MID7015|Next2|nook|FOLIO|MB511.*RUTEM|Mac OS.*Silk/i;
	
	        // Supports iOS and Android. Updated / more accurate method of detecting webviews
	        function isWebView() {
	            var logEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	            var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : userAgent;
	
	            var ios = /iphone|ipod|ipad/i.test(ua),
	                android = /Android/i.test(ua);
	
	            if (ios) {
	                // Unfortunately no perfectly reliable way, this will detect some 3rd party browsers as ui webview
	                // Major browsers: chrome, safari, firefox, uc browser, puffin, are detected reliably.
	                var ios_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
	
	                if (!standalone && ios_uiwebview && !isSafariViewController()) {
	                    // uiwebview
	                    logWebView('iOS');
	                    return true;
	                }
	            } else if (android) {
	                // not iOS, Android platform handling
	                // Whitelist for x-requested-with header values for web view detection
	                var allowedXRequestedWithRegexMap = {
	                    ajax: /XMLHttpRequest/i,
	                    baiduBrowser: /com.baidu.browser.inter/i,
	                    operaMini: /com.opera.mini.native/i,
	                    maxthon: /com.mx.browser/i,
	                    litterPenguinBrowser: /com.explore.web.browser/i
	                };
	                var xRequestedWithHeaderVal = $meta.requestHeaders['x-requested-with'];
	
	                if (xRequestedWithHeaderVal) {
	                    // check if x-requested-with header val is in whitelist
	                    for (var key in allowedXRequestedWithRegexMap) {
	                        if (allowedXRequestedWithRegexMap.hasOwnProperty(key)) {
	                            if (allowedXRequestedWithRegexMap[key].test(xRequestedWithHeaderVal)) {
	                                return false;
	                            }
	                        }
	                    }
	                    logWebView('Android');
	                    return true;
	                }
	            }
	
	            return false;
	
	            function logWebView(device) {
	                if (!logEnabled) {
	                    return;
	                }
	                // cal log
	                $logger.info('WebView :: ' + device);
	            }
	        }
	
	        /**
	         * Check if the given the user-agent string is belongs to a device.
	         */
	        function isDevice() {
	            if (angular.isString(userAgent)) {
	                return DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent);
	            }
	
	            return false;
	        }
	
	        /**
	         * Check if the given the user-agent string is belongs to a tablet.
	         */
	        function isTablet() {
	            if (angular.isString(userAgent)) {
	                return TABLET_PATTERN.test(userAgent);
	            }
	
	            return false;
	        }
	
	        /**
	         * Check if the given the user-agent string is belongs to a mobile
	         */
	        function isMobile() {
	            return isDevice(userAgent) && !isTablet(userAgent);
	        }
	
	        /**
	         * Get the mobile platform value given the user-agent string.
	         */
	        function getDevicePlatform() {
	            if (angular.isString(userAgent)) {
	                var matched = userAgent.match(/iPod|iPhone|iPad|Android|BlackBerry|Windows Phone OS|webOS|Symbian|mobile/g);
	
	                if (matched && matched.length > 0) {
	                    return matched[0];
	                }
	            }
	        }
	
	        /**
	         * Check if the give user agent is from an app.
	         */
	        function isApp(uaString) {
	            userAgent = uaString || userAgent;
	
	            if (DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent)) {
	                if (getDevicePlatform(userAgent) === 'Android') {
	                    return (/Version\/\d.\d/i.test(userAgent)
	                    );
	                }
	
	                return (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test(userAgent)
	                );
	            }
	
	            return false;
	        }
	
	        function isSafariViewController() {
	            if (angular.isString(userAgent)) {
	                var ios = /iphone|ipod|ipad/i.test(userAgent);
	                return ios && $window.indexedDB && isApp();
	            } else {
	                return false;
	            }
	        }
	
	        /**
	         * Get the device capabilities
	         */
	        function getCapabilities() {
	            var capabilities = {},
	                device = DEVICE_PATTERN.test(userAgent),
	                tablet = TABLET_PATTERN.test(userAgent),
	                app = isApp(userAgent);
	
	            if (angular.isString(userAgent)) {
	                capabilities.isWireless = device || tablet;
	                capabilities.isTablet = tablet;
	                capabilities.isMobile = device && !tablet;
	                capabilities.isDesktop = !device;
	                capabilities.isApp = app;
	            }
	
	            return capabilities;
	        }
	
	        /**
	         * Get various AppIntegrationType
	         */
	        function getAppIntegrationType() {
	            var app_int_type;
	            if (isDevice()) {
	                if (isApp()) {
	                    if (isSafariViewController()) {
	                        app_int_type = 'SFVC';
	                    } else {
	                        app_int_type = 'WebView';
	                    }
	                } else {
	                    app_int_type = 'Browser';
	                }
	            }
	            return app_int_type;
	        }
	
	        return {
	            isDevice: isDevice,
	            isTablet: isTablet,
	            isMobile: isMobile,
	            isApp: isApp,
	            isSafariViewController: isSafariViewController,
	            getCapabilities: getCapabilities,
	            getAppIntegrationType: getAppIntegrationType,
	            isWebView: isWebView
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-device-info/dist", "components/xo-device-info/dist/index.js"))

/***/ },

/***/ "./components/xo-models/src/checkout/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$CheckoutSessionModel = exports.$CheckoutPlanModel = exports.$CheckoutShippingAddressesModel = exports.$CreditOptionsModel = exports.$CheckoutPayeeModel = exports.$ShippingAddressModel = exports.$CheckoutShippingAddressModel = exports.$FlowEligibilityModel = exports.$InstallmentOptionsModel = exports.$FundingOptionsModel = exports.$FundingSourceModel = exports.$CheckoutAppDataModel = exports.$CheckoutCartModel = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $CheckoutCartModel = exports.$CheckoutCartModel = _squid.$Model.extend('$CheckoutCartModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/cart',
	        cache: true
	    }),
	
	    isPurchase: function isPurchase() {
	        return Boolean(this.purchase);
	    },
	
	    isBilling: function isBilling() {
	        return Boolean(this.billing);
	    },
	
	    isBillingPurchase: function isBillingPurchase() {
	        return this.isPurchase() && this.isBilling();
	    },
	
	    isBillingNoPurchase: function isBillingNoPurchase() {
	        return this.isBilling() && !this.isPurchase();
	    },
	
	    getBillingDescription: function getBillingDescription() {
	        return this.billing && this.billing.description;
	    },
	
	    isMultiSellerPurchase: function isMultiSellerPurchase() {
	        return this.purchaseUnits && this.purchaseUnits.length > 1;
	    },
	
	    isShippingMethodStorePickUp: function isShippingMethodStorePickUp() {
	        return this.purchase && (this.purchase.shipping_method === '29' || this.purchase.shipping_method === '21');
	    },
	
	    isWalletTokenization: function isWalletTokenization() {
	        return this.billing && this.billing.intent === 'TOKENIZED_WALLET';
	    }
	});
	
	var $CheckoutAppDataModel = exports.$CheckoutAppDataModel = _squid.$Model.extend('$CheckoutAppDataModel', {
	
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/appData'
	    }),
	
	    useraction: function useraction() {
	        // user_action from session takes precedence over CGI param.
	        var user_action = this.flags && this.flags.user_action === 'PAY' ? 'commit' : undefined;
	
	        return user_action || _squid.$util.param('useraction');
	    },
	
	    doec_on_approve: function doec_on_approve() {
	        return this.flags && this.flags.doec_on_approve;
	    }
	});
	
	var $FundingSourceModel = exports.$FundingSourceModel = _squid.$Model.extend('$FundingSourceModel', {
	
	    formatLast4: function formatLast4() {
	        var last4;
	
	        if (this.last4) {
	            last4 = this.last4;
	
	            if (!this.parent.isAuthRequired) {
	                last4 = 'x-' + last4;
	            }
	        }
	
	        return last4;
	    }
	});
	
	var $FundingOptionsModel = exports.$FundingOptionsModel = _squid.$Model.extend('$FundingOptionsModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/fundingOptions',
	        postAttempts: 2
	    }),
	
	    hasECheck: function hasECheck() {
	        return _squid.$util.some(this.instruments, function (instrument) {
	            return instrument.type === 'ECHECK' || instrument.subtype === 'ECHECK';
	        });
	    },
	
	    hasCredit: function hasCredit() {
	        return _squid.$util.some(this.instruments, function (instrument) {
	            return instrument.type === 'CREDIT';
	        });
	    }
	});
	
	var $InstallmentOptionsModel = exports.$InstallmentOptionsModel = _squid.$Model.extend('$InstallmentOptionsModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/installmentOptions/',
	        postAttempts: 2
	    })
	});
	
	var $FlowEligibilityModel = exports.$FlowEligibilityModel = _squid.$Model.extend('$FlowEligibilityModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/flowEligibility'
	    })
	});
	
	var $CheckoutShippingAddressModel = exports.$CheckoutShippingAddressModel = _squid.$Model.extend('$CheckoutShippingAddressModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:parent.id/shipping/:id'
	    })
	});
	
	var $ShippingAddressModel = exports.$ShippingAddressModel = _squid.$Model.extend('$ShippingAddressModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/shipping/add'
	    }),
	
	    serialize: function serialize() {
	        return {
	            first_name: this.first_name,
	            last_name: this.last_name,
	            recipient_name: this.recipient_name,
	            line1: this.line1,
	            line2: this.line2,
	            city: this.city,
	            state: this.state,
	            postal_code: this.postal_code,
	            country: this.country
	        };
	    }
	});
	
	var $CheckoutPayeeModel = exports.$CheckoutPayeeModel = _squid.$Model.extend('$CheckoutPayeeModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/payee'
	    }),
	
	    getId: function getId() {
	        return this.merchant && this.merchant.id;
	    },
	
	    isGambling: function isGambling() {
	        return this.merchant && this.merchant.isGambling;
	    }
	});
	
	var $CreditOptionsModel = exports.$CreditOptionsModel = {
	    sacEligibleAmount: {
	        US: 99,
	        GB: 150
	    }
	};
	
	var $CheckoutShippingAddressesModel = exports.$CheckoutShippingAddressesModel = _squid.$Model.extend('$CheckoutShippingAddressesModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/shipping'
	    }),
	
	    onPopulate: function onPopulate() {
	        this.addresses = this.children($CheckoutShippingAddressModel, this.addresses);
	    },
	
	    getPreferredShippingAddress: function getPreferredShippingAddress() {
	        var preferredAddress = {};
	
	        if (this.addresses) {
	            var i = void 0;
	            var address = void 0;
	
	            for (i = 0; i < this.addresses.length; i++) {
	                address = this.addresses[i];
	
	                if (address && address.preferred_address) {
	                    preferredAddress = {
	                        'line1': address.line1,
	                        'line2': address.line2,
	                        'city': address.city,
	                        'state': address.state,
	                        'postal_code': address.postal_code,
	                        'country_code': address.country_code
	                    };
	
	                    break;
	                }
	            }
	        }
	        return preferredAddress;
	    },
	
	    getPrimaryShippingAddress: function getPrimaryShippingAddress() {
	        var primaryAddress = {};
	
	        if (this.addresses) {
	            var i = void 0;
	            var address = void 0;
	
	            for (i = 0; i < this.addresses.length; i++) {
	                address = this.addresses[i];
	
	                if (address && address.primary_address) {
	                    primaryAddress = {
	                        'line1': address.line1,
	                        'line2': address.line2,
	                        'city': address.city,
	                        'state': address.state,
	                        'postal_code': address.postal_code,
	                        'country_code': address.country_code
	                    };
	
	                    break;
	                }
	            }
	        }
	        return primaryAddress;
	    }
	});
	
	var $CheckoutPlanModel = exports.$CheckoutPlanModel = _squid.$Model.extend('$CheckoutPlanModel', {
	
	    onPopulate: function onPopulate() {
	        this.sources = this.children($FundingSourceModel, this.sources);
	    },
	
	    eachSource: function eachSource(method, context) {
	        angular.forEach(this.sources, method, this);
	    },
	
	    hasFundingMethodType: function hasFundingMethodType(name) {
	        var found = false;
	
	        this.eachSource(function (source) {
	            if (source.type === name) {
	                found = true;
	            }
	        }, this);
	
	        return found;
	    },
	
	    hasFundingMethodSubType: function hasFundingMethodSubType(name) {
	        var found = false;
	
	        this.eachSource(function (source) {
	            if (source.sub_type === name) {
	                found = true;
	            }
	        }, this);
	
	        return found;
	    },
	
	    isPAD: function isPAD() {
	        return this.hasFundingMethodSubType('DELAYED_TRANSFER');
	    },
	
	    isMSB: function isMSB() {
	        return this.sources && this.sources.length === 1 && this.sources[0].type === 'INCENTIVE';
	    },
	
	    isBalance: function isBalance() {
	        return this.sources && this.sources.length === 1 && this.sources[0].type === 'BALANCE';
	    }
	});
	
	var $CheckoutSessionModel = exports.$CheckoutSessionModel = _squid.$Model.extend('$CheckoutSessionModel', {
	
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/session',
	        postAttempts: 2
	    }),
	
	    onPopulate: function onPopulate() {
	        this.plan = new $CheckoutPlanModel(this.plan);
	        this.shipping = this.child($CheckoutShippingAddressModel, this.shipping);
	        this.fundingOptions = this.child($FundingOptionsModel, this.fundingOptions);
	    },
	
	    getSelectedStickyInstrument: function getSelectedStickyInstrument() {
	
	        if (this.selectedFuturePaymentInstrument) {
	            return this.selectedFuturePaymentInstrument;
	        }
	
	        if (!this.futurePaymentInstruments) {
	            return;
	        }
	
	        if (!(this.plan && this.plan.sources) && this.futurePaymentInstruments) {
	            return this.futurePaymentInstruments[0];
	        }
	
	        var selectedInstrumentId = _squid.$util.some(this.plan.sources, function (fi) {
	            return fi.instrument_id ? fi.instrument_id : undefined;
	        });
	
	        var stickyInstrument = _squid.$util.find(this.futurePaymentInstruments, function (fi) {
	            return fi.instrument_id === selectedInstrumentId;
	        });
	
	        return stickyInstrument;
	    },
	
	    getPlanList: function getPlanList() {
	        return this.fundingOptions && this.fundingOptions.plans;
	    },
	
	    getDisallowedInstruments: function getDisallowedInstruments() {
	        return this.fundingOptions && this.fundingOptions.disallowedInstruments;
	    },
	
	    getDisallowedPreferred: function getDisallowedPreferred() {
	        var disallowedInstrument = this.getDisallowedInstruments();
	
	        // find only the disallowed instrument that has been marked as preferred.
	        disallowedInstrument = disallowedInstrument && _squid.$util.find(disallowedInstrument, function (fi) {
	            return fi.isPreferred;
	        });
	
	        // if the disallowed instrument is in the plan list (in the case that the instrument has a BUF)
	        // we do not show it in the disallowed section.
	        var isDisallowedInstrumentInPlanList = disallowedInstrument && _squid.$util.some(this.getPlanList(), function (plan) {
	            var instrumentID = plan.primaryFs && plan.primaryFs.id;
	            if (instrumentID && disallowedInstrument.id) {
	                return instrumentID === disallowedInstrument.id;
	            } else {
	                return false;
	            }
	        });
	
	        return !isDisallowedInstrumentInPlanList && disallowedInstrument;
	    },
	
	    getShippingAddressMinimalDetails: function getShippingAddressMinimalDetails() {
	        return {
	            'line1': this.shipping.line1,
	            'line2': this.shipping.line2,
	            'city': this.shipping.city,
	            'state': this.shipping.state,
	            'postal_code': this.shipping.postal_code,
	            'country_code': this.shipping.country
	        };
	    }
	});
	
	angular.value("$CheckoutCartModel", $CheckoutCartModel);
	angular.value("$CheckoutAppDataModel", $CheckoutAppDataModel);
	angular.value("$FundingSourceModel", $FundingSourceModel);
	angular.value("$FundingOptionsModel", $FundingOptionsModel);
	angular.value("$InstallmentOptionsModel", $InstallmentOptionsModel);
	angular.value("$FlowEligibilityModel", $FlowEligibilityModel);
	angular.value("$CheckoutShippingAddressModel", $CheckoutShippingAddressModel);
	angular.value("$ShippingAddressModel", $ShippingAddressModel);
	angular.value("$CheckoutPayeeModel", $CheckoutPayeeModel);
	angular.value("$CreditOptionsModel", $CreditOptionsModel);
	angular.value("$CheckoutShippingAddressesModel", $CheckoutShippingAddressesModel);
	angular.value("$CheckoutPlanModel", $CheckoutPlanModel);
	angular.value("$CheckoutSessionModel", $CheckoutSessionModel);
	_squid.$Model;
	
	_squid.$Api;
	
	_squid.$util;

/***/ },

/***/ "./js/lib/icFallback.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$incontextFallback = $incontextFallback;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	function $incontextFallback(win, url) {
	
	    _angular.$rootScope.$emit('loading');
	
	    window.onbeforeunload = function () {};
	    window.onunload = function () {};
	
	    var parent = window.opener || window.parent;
	
	    if (!window.paypalCheckout.props.fallback) {
	        parent.location = url;
	        win.close();
	        return;
	    }
	
	    try {
	
	        var frame;
	
	        try {
	            if (typeof parent.onLegacyFallback === 'function') {
	                frame = parent;
	            }
	        } catch (err) {
	            // pass
	        }
	
	        if (!frame) {
	            for (var i = 0; i < parent.frames.length; i++) {
	
	                try {
	                    if (typeof parent.frames[i].onLegacyFallback === 'function') {
	                        frame = parent.frames[i];
	                        break;
	                    }
	                } catch (err) {
	                    // pass
	                }
	            }
	        }
	
	        if (!frame) {
	            parent.location = url;
	            win.close();
	            return;
	        }
	
	        frame.onLegacyFallback(win);
	
	        window.addEventListener('unload', function () {
	
	            var width = 970;
	            var height = 900;
	            var left = void 0;
	            var top = void 0;
	
	            if (window.outerWidth) {
	                left = Math.round((window.outerWidth - width) / 2) + window.screenX;
	                top = Math.round((window.outerHeight - height) / 2) + window.screenY;
	            } else if (window.screen.width) {
	                left = Math.round((window.screen.width - width) / 2);
	                top = Math.round((window.screen.height - height) / 2);
	            }
	
	            window.resizeTo(width, height);
	            window.moveTo(left, top);
	        });
	
	        win.location = url;
	    } catch (err) {
	
	        parent.location = url;
	        win.close();
	    }
	
	    window.paypalCheckout.props.fallback(url);
	}
	
	angular.value("$incontextFallback", $incontextFallback);
	_angular.$rootScope;

/***/ },

/***/ "./js/lib/contingency.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	__webpack_require__("./js/lib/fallback.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	_angular2['default'].module().factory('$contingencyHandler', function ($Contingency, $logger, $location, $feature, $state, $config, $meta, $window, $util, $populate, $q, $pxp, $AuthModel, $CheckoutCartModel, $CheckoutPayeeModel, $locale, $Forbidden, $rootScope, $FallbackError) {
	
	    function showGenericError(code) {
	        return function () {
	            var encoded = code ? window.btoa(code) : code;
	            $state.go('checkout.genericError', {
	                code: encoded
	            });
	        };
	    }
	
	    function route(path) {
	        return function () {
	            $state.go(path, { message: arguments[0] });
	        };
	    }
	
	    function forbidden(err) {
	        throw new $Forbidden(err);
	    }
	
	    function fallback(product) {
	        return function (err) {
	            throw new $FallbackError({
	                reason: err,
	                product: product
	            });
	        };
	    }
	
	    function handleStepupAuth(code, authModel, step_up_context) {
	        authModel.stepupAuthRequired = true;
	
	        var reasons = {
	            VERIFY_USER_IDENTITY: 'step_up_auth_needed',
	            PAYER_AUTHENTICATION_REQUIRED: 'login_required'
	        };
	
	        if (authModel.remembered) {
	            $logger.debug('PLANNING_STEP_UP_REMEBERED_USER');
	            authModel.action('logout').then(function () {
	                $state.go('checkout.login', {
	                    targetPage: 'ONETOUCH_GENERIC_ERROR',
	                    source: 'FRESH_START'
	                });
	            });
	        } else if (step_up_context && !_angular2['default'].isObject(step_up_context)) {
	            $logger.debug('PLANNING_STEP_UP_LOGIN_USER_TEST_TRAFFIC');
	
	            var authChallengeNodeUrl = $config.urls.authChallengeNodeUrl;
	
	            if ($config.deploy.isLocal() || $config.deploy.isStage()) {
	                authChallengeNodeUrl = authChallengeNodeUrl.replace('www.paypal.com', $meta.stage);
	            }
	
	            authChallengeNodeUrl = $util.buildURL(authChallengeNodeUrl, {
	                stepupContext: step_up_context,
	                stsReturnUrl: $config.ulMeta.stsReturnUrl,
	                returnUri: $config.ulMeta.authChallengeReturnUri + $window.location.search + '&atoSuccess',
	                locale: $locale.lang,
	                flowId: 'xo',
	                flowContext: 'funding'
	            });
	
	            if (authChallengeNodeUrl) {
	                $util.redirect(authChallengeNodeUrl);
	            }
	        } else {
	            $logger.debug('PLANNING_STEP_UP_LOGIN_USER_CONTROL_TRAFFIC');
	            throw new $FallbackError({
	                reason: reasons[code],
	                product: 'ux'
	            });
	        }
	    }
	
	    function handleMerchantBANocards(contingency) {
	        var FALL_BACK_LIST = ['INSTANT_FUNDING_SOURCE_UPSELL_NEEDED', 'ELV_DECLINE', 'NEED_CREDIT_CARD', 'NEED_CONFIRMED_CARD', 'NEED_AUTHENTICATED_CARD', 'NEED_CREDIT_CARD_OR_BANK_ACCOUNT', 'EXPIRED_CREDIT_CARD'];
	
	        if (FALL_BACK_LIST.indexOf(contingency.message) !== -1) {
	            var _ret = function () {
	                var models = {};
	
	                return {
	                    v: $populate(models, {
	                        checkoutCart: $CheckoutCartModel.instance($rootScope.token),
	                        payee: $CheckoutPayeeModel.instance($rootScope.token)
	                    }).then(function () {
	                        return $pxp('xo_hermes_ba_nocards', { 'uid': models.payee.merchant.id }, 'xo_hermesnode_ba_nocards_whitelist_treatment').then(function (result) {
	                            if (result && models.checkoutCart.isBilling()) {
	                                $logger.info('ba_nocard_contingency_triggered');
	                                throw new $FallbackError({
	                                    reason: 'fallback_merchant_BA_nocards',
	                                    product: 'ux'
	                                });
	                            } else {
	                                return $q.when();
	                            }
	                        });
	                    })
	                };
	            }();
	
	            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	        } else {
	            return $q.when();
	        }
	    }
	
	    return function (contingency) {
	
	        // Leave a footprint here. The subsequent state where log how it goes..
	        $logger.warn('contingency_handler', contingency);
	
	        return handleMerchantBANocards(contingency).then(function () {
	
	            return contingency.handle({
	                // Route
	                ECONSENT_REQUIRED: route('checkout.econsent'),
	                INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: route('checkout.pageAddCardMeft.addCardFlow.addCard'),
	                ELV_DECLINE: route('checkout.pageAddCard.addCardFlow.addCard'),
	                NEED_CREDIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
	                NEED_CONFIRMED_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
	                NEED_AUTHENTICATED_CARD: route('checkout.updateCard.addCardFlow.addCard'),
	                NEED_CREDIT_CARD_OR_BANK_ACCOUNT: route('checkout.pageAddFi.bank.add'),
	                EXPIRED_CREDIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),
	                NEGATIVE_BALANCE_RECOVERY: route('checkout.negativeBalanceRecovery'),
	                PHONE_NUMBER_REQUIRED: route('checkout.addPhone'),
	                SEPA_MANDATE_ACCEPTANCE_NEEDED: route('checkout.review'),
	                TAX_ID_REQUIRED: route('checkout.addTaxId'),
	                NEED_SHIPPING_ADDRESS: route('checkout.pageAddShipping.addShipping'),
	
	                NEED_DEBIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
	                EXPIRED_DEBIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),
	
	                PAYER_AUTHENTICATION_REQUIRED: function PAYER_AUTHENTICATION_REQUIRED() {
	                    $state.go('checkout.login', {
	                        targetPage: 'PAYER_AUTHENTICATION_REQUIRED'
	                    });
	                },
	
	                // Generic Error Pages
	                RESTRICTED_USER: showGenericError('RESTRICTED_USER'),
	                PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
	                PAYMENT_ALREADY_DONE: showGenericError('PAYMENT_ALREADY_DONE'),
	                PAYMENT_DENIED: showGenericError('PAYMENT_DENIED'),
	                PAYEE_ACCOUNT_RESTRICTED: showGenericError('RESTRICTED_USER'),
	                INVALID_RESOURCE_ID: showGenericError('INVALID_RESOURCE_ID'),
	                EXPIRED_SESSION: showGenericError('EXPIRED_SESSION'),
	                PAYER_CANNOT_PAY: showGenericError('PAYER_CANNOT_PAY'),
	                PAYER_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_COUNTRY_NOT_ALLOWED'),
	                PAYER_COUNTRY_NOT_ENABLED: showGenericError('PAYER_COUNTRY_NOT_ENABLED'),
	                PAYER_LOGIN_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_LOGIN_COUNTRY_NOT_ALLOWED'),
	                GAMING_FUNDING_SOURCE_VALIDATION_FAILED: showGenericError('GAMING_FUNDING_SOURCE_VALIDATION_FAILED'),
	                COMPLIANCE_VIOLATION: showGenericError('COMPLIANCE_VIOLATION'),
	                DOMESTIC_TRANSACTION_REQUIRED: showGenericError('DOMESTIC_TRANSACTION_REQUIRED'),
	                INTERNAL_SERVICE_ERROR: showGenericError('TRANSACTION_REFUSED'),
	                NEGATIVE_BALANCE_TRANSACTION_REFUSED: showGenericError('NEGATIVE_BALANCE_TRANSACTION_REFUSED'),
	                ACCOUNT_CANNOT_BE_FETCHED: showGenericError('ACCOUNT_CANNOT_BE_FETCHED'),
	                BAD_RESPONSE: showGenericError('DEFAULT'),
	                TRANSACTION_REFUSED_LEGACY_FALLBACK: showGenericError('TRANSACTION_REFUSED'),
	                RISK_DENIED: showGenericError('TRANSACTION_REFUSED'),
	
	                // Non-specific errors - update with proper content ASAP
	                AGREEMENT_ALREADY_CREATED: showGenericError('DEFAULT'),
	                PAYMENT_NOT_APPROVED_FOR_EXECUTION: showGenericError('DEFAULT'),
	                PAYER_ACCOUNT_LOCKED_OR_CLOSED: showGenericError('DEFAULT'),
	
	                // This could be a generic error or fallback, depending on the country feature.
	                UNSUPPORTED_PAYEE_CURRENCY: $feature('unsupportedPayeeCurrency') ? showGenericError('UNSUPPORTED_PAYEE_CURRENCY') : fallback('ux'),
	
	                // Fallbacks
	                SENDING_LIMIT_EXCEEDED: fallback('ux'),
	                PAYMENT_CANNOT_BE_INITIATED: fallback('ux'),
	                PERMISSION_DENIED: fallback('ux'),
	                INVALID_TOKEN: fallback('ux'),
	                INVALID_FUNDING_OPTION: fallback('ux'),
	                VALIDATION_ERROR: fallback('ux'),
	                SHIPPING_ADDRESS_INVALID: fallback('ux'),
	                INVALID_ARGUMENT: fallback('ux'),
	                CREDIT_PAYMENT_NOT_ALLOWED: fallback('ux'),
	                PAYEE_ACCOUNT_LOCKED_OR_CLOSED: fallback('ux'),
	                MALFORMED_REQUEST: fallback('ux'),
	                TWOFA_INACTIVE: fallback('ux'),
	                ERROR: fallback('ux'),
	                ISSUER_DECLINE: fallback('ux'),
	                UNSUPPORTED_CUP_SECURECARD: fallback('ux'),
	
	                // Forbidden
	
	                BUYER_NOT_SET: forbidden,
	
	                // Other
	
	                TRANSACTION_REFUSED: function TRANSACTION_REFUSED(message, data) {
	                    var clearedRT = data.clearedRT;
	
	                    if (clearedRT) {
	                        $logger.info('checkout_fpti', {
	                            from: 'CONTINGENCY',
	                            to: 'process_fallback',
	                            routing_reason: 'TRANSACTION_REFUSED'
	                        });
	                    }
	
	                    // always go to generic error page, even if logout fails
	                    $AuthModel.instance().action('logout')['finally'](showGenericError('TRANSACTION_REFUSED'));
	                },
	
	                PAYER_INVALID_FOR_PAYMENT: function PAYER_INVALID_FOR_PAYMENT() {
	                    // Payer is not same payer checkout session was created for.
	                    return $AuthModel.instance().action('logout')['finally'](function () {
	                        $AuthModel.instance().invalidate();
	
	                        return $state.go('checkout.login', {}, {
	                            reload: true
	                        });
	                    });
	                },
	
	                CANNOT_PAY_SELF: function CANNOT_PAY_SELF() {
	                    $AuthModel.instance().meta.selfPay = true;
	                    $rootScope.contingency = {};
	                    $rootScope.contingency.message = 'CANNOT_PAY_SELF';
	
	                    return $state.go($state.current, {}, {
	                        reload: true
	                    });
	                },
	
	                VERIFY_USER_IDENTITY: function VERIFY_USER_IDENTITY(message, data) {
	                    var clearedRT = data.clearedRT;
	
	                    if (clearedRT) {
	                        $logger.info('checkout_fpti', {
	                            from: 'CONTINGENCY',
	                            to: 'process_fallback',
	                            routing_reason: 'VERIFY_USER_IDENTITY'
	                        });
	                    }
	
	                    return handleStepupAuth('VERIFY_USER_IDENTITY', $AuthModel.instance(), data.step_up_context);
	                },
	
	                LOGIN_CONTINGENCY: function LOGIN_CONTINGENCY() {
	                    if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
	                        return _miniBrowser.$miniBrowser.frameBust($rootScope.token);
	                    }
	
	                    return fallback('ux');
	                },
	
	                DEFAULT: function logUnhandledContingency() {
	                    $logger.warn('ui_unhandled_contingency_' + this.message);
	                    throw new $FallbackError({
	                        reason: 'unhandled_contingency',
	                        product: 'ux'
	                    });
	                }
	            });
	        });
	    };
	});
	
	_miniBrowser.$miniBrowser;
	
	_integration.$integration;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/contingency.js"))

/***/ },

/***/ "./js/lib/miniBrowser.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$miniBrowser = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _util = __webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	var _error = __webpack_require__("./js/lib/error.js");
	
	var postRobot = void 0;
	
	if (window.ppxo && window.ppxo.Checkout.isXComponent()) {
	    postRobot = window.ppxo.postRobot;
	} else {
	    if (window.ppxo && window.ppxo.postRobot) {
	        window.ppxo.postRobot.disable();
	    }
	    postRobot = __webpack_require__("./components/post-robot/dist/post-robot.min.js");
	}
	
	var _$stateGo = _uiRouter.$state.go;
	
	_uiRouter.$state.go = function (name) {
	
	    if (!window.paypalCheckout) {
	        return _$stateGo.apply(this, arguments);
	    }
	
	    var state = _uiRouter.$state.get(name);
	
	    if (!state.loginRequired) {
	        return _$stateGo.apply(this, arguments);
	    }
	
	    // If we're allowed to collect data in this integration, we don't need this functionality
	    if (_integration.$integration.getConfig('ALLOW_COLLECT_DATA')) {
	        return _$stateGo.apply(this, arguments);
	    }
	
	    // First check our integration supports falling back to a popup
	    if (!_integration.$integration.getConfig('CAN_FALLBACK_TO_POPUP')) {
	        throw _integration.$integration.error('Can not fallback to popup for data collection');
	    }
	
	    window.paypalCheckout.hide();
	
	    var url = window.location.href.split('#')[0] + '#/' + state.name.replace(/\./g, '/');
	    var props = window.paypalCheckout.props;
	
	    window.ppxo.Checkout.renderPopupTo(window.top, {
	
	        url: url,
	        payment: props.payment,
	        billingAgreement: props.billingAgreement,
	        onAuthorize: props.onAuthorize,
	        onCancel: props.onCancel
	
	    })['catch'](_error.$exceptionHandler);
	};
	
	var $miniBrowser = exports.$miniBrowser = {
	
	    flags: {},
	    config: {},
	
	    isMiniBrowser: function isMiniBrowser() {
	        return window.name && window.name.indexOf('PPFrame') === 0 && _squid.$util.isPopup() || _squid.$util.param('incontext') === '1' || window.xchild && _squid.$util.isPopup();
	    },
	
	    isFramed: function isFramed() {
	        return _squid.$util.isIFrame();
	    },
	
	    openChildWindow: function openChildWindow(childFlow, targetState, dimensions, callback) {
	
	        if (this.childWindow) {
	            _logger.$logger.warn('child_window_already_open');
	            return this.childWindow;
	        }
	
	        _logger.$logger.info('popup_flow_start_' + childFlow);
	
	        // Mask the page
	        _angular.$rootScope.$emit('loading');
	
	        // Let the parent know to show an overlay
	        postRobot.sendToParent('popup_opened');
	
	        // Determine the url based on the target page, and open the window
	        var name = 'PPFrame' + _squid.$util.hash();
	        var url = window.location.href.split('#')[0] + '#/' + targetState.replace(/\./g, '/');
	
	        this.childWindow = _squid.$util.popup(name, url, {
	            top: dimensions.top,
	            left: dimensions.left,
	            width: dimensions.width,
	            height: dimensions.height,
	            location: 1,
	            status: 1,
	            toolbar: 0,
	            menubar: 0,
	            resizable: 1,
	            scrollbars: 1
	
	        }, callback);
	
	        // If we're staying in the popup, we can just hide the current page entirely, and proxy all future post messages between our parent and the new window
	        if (childFlow === _integration.$FLOWS.CHECKOUT) {
	            $(document.body).hide();
	            postRobot.proxy(postRobot.parent, this.childWindow);
	        }
	
	        return this.childWindow;
	    },
	    closeChildWindow: function closeChildWindow(childFlow, targetState, err) {
	
	        if (!this.childWindow) {
	            return;
	        }
	
	        postRobot.unproxy(postRobot.parent, this.childWindow);
	
	        _logger.$logger.info('popup_flow_complete_' + childFlow);
	
	        // Unmask the page
	        _angular.$rootScope.$emit('loaded');
	
	        // Let the parent know to hide their overlay
	        postRobot.sendToParent('popup_closed');
	
	        var childWindow = this.childWindow;
	
	        delete this.childWindow;
	
	        // Close the window if it is not already
	        childWindow.close();
	
	        if (err) {
	
	            _logger.$logger.warn('popup_flow_error', {
	                error: err.stack || err.toString()
	            });
	
	            // If we had intended to stay in the popup, message our parent to let them know things didn't work out
	            if (childFlow === _integration.$FLOWS.CHECKOUT) {
	                postRobot.sendToParent('cancel');
	            }
	
	            _angular.$rootScope.$emit('loading');
	        }
	
	        // Otherwise go to the target page of the user in the popup, and reload the page to get the latest models
	        else if (targetState) {
	                _uiRouter.$state.go(targetState);
	                window.location.reload();
	            }
	    },
	
	
	    getPartnerIntegration: function getPartnerIntegration(token) {
	        return _squid.$promise.call(function () {
	
	            if (window.name === 'PPFrameRedirect' || _squid.$util.param('nolegacy') === '1') {
	                return true;
	            }
	
	            return _checkout.$CheckoutCartModel.instance(token).retrieve().then(function (cart) {
	                return Boolean(cart.partnerIntegration);
	            });
	        });
	    },
	
	    getNativeCheckoutIntegration: function getNativeCheckoutIntegration(token) {
	        return _squid.$promise.call(function () {
	
	            if (_squid.$util.param('native_xo') === '1') {
	                return true;
	            }
	
	            return false;
	        });
	    },
	
	    getMessengerBAIntegration: function getMessengerBAIntegration(token) {
	        return _squid.$promise.call(function () {
	
	            if (_squid.$util.param('messenger_ba') === '1') {
	                _logger.$logger.info('getMessengerBAIntegration == true');
	                return true;
	            }
	
	            return false;
	        });
	    },
	
	    getDirectIntegration: function getDirectIntegration(token) {
	        return _squid.$promise.call(function () {
	
	            if (_squid.$util.param('incontext')) {
	                return true;
	            }
	
	            if (this.isMiniBrowser() || this.isFramed()) {
	                return true;
	            }
	
	            if (window.location.pathname.indexOf('/checkoutnow') > -1 || window.location.pathname.indexOf('/webapps/hermes') > -1) {
	                return true;
	            }
	
	            return this.getPartnerIntegration(token);
	        }.bind(this));
	    },
	
	    getFlags: function getFlags(token) {
	        _logger.$logger.info('miniBrowser_getFlags');
	        return _squid.$promise.hash({
	            isMiniBrowser: this.isMiniBrowser(),
	            isFramed: this.isFramed(),
	            isPartnerIntegration: this.getPartnerIntegration(token),
	            isDirectIntegration: this.getDirectIntegration(token),
	            isNativeCheckout: this.getNativeCheckoutIntegration(token),
	            isMessengerBAIntegration: this.getMessengerBAIntegration(token)
	        }).then(function (flags) {
	
	            // TODO: Remove these, we should not use $rootScope
	            _angular.$rootScope.miniBrowser = flags.isMiniBrowser;
	            _angular.$rootScope.partnerIntegration = flags.isPartnerIntegration;
	
	            if (flags.isPartnerIntegration) {
	                _integration.$integration.setFlow(_integration.$FLOWS.PARTNER);
	            } else if (flags.isFramed) {
	                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_LIGHTBOX);
	                if (flags.isMessengerBAIntegration) {
	                    _integration.$integration.setFlow(_integration.$FLOWS.MESSENGER_BA_INTEGRATION);
	                    _logger.$logger.info('$integration.setFlow($FLOWS.MESSENGER_BA_INTEGRATION)');
	                }
	            } else if (flags.isMiniBrowser) {
	                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_POPUP);
	            } else if (flags.isNativeCheckout) {
	                _integration.$integration.setFlow(_integration.$FLOWS.NATIVE_CHECKOUT);
	            } else {
	                _integration.$integration.setFlow(_integration.$FLOWS.CHECKOUT);
	            }
	
	            return flags;
	        });
	    },
	
	    init: function init(token) {
	        var _this = this;
	
	        _logger.$logger.info('miniBrowser_init');
	        return _squid.$promise.sequential([function () {
	            return _this.getFlags(token);
	        }, function () {
	            return _this.logIntegration(token);
	        }, function () {
	            return _this.sendPostMessage(token);
	        }, function () {
	            return _this.handleWindowOpenerClose();
	        }, function () {
	            return _this.handleLightboxToPopup();
	        }, function () {
	            return _this.handlePopupFromLightBox();
	        }]);
	    },
	
	    logIntegration: function logIntegration(token) {
	        _logger.$logger.info('miniBrowser_logIntegration');
	        return this.getFlags(token).then(function (flags) {
	
	            var match = window.name.match(/PPFrame(\w+)/);
	            var guid = match && match[1];
	
	            if (guid) {
	                _logger.$logger.info('integration_guid', {
	                    guid: guid
	                });
	            }
	
	            if (window.paypalCheckout || guid) {
	                var beacon = new Image();
	                beacon.src = '/webapps/hermes/api/logger?event=ppxo_uid_token&uid=' + (window.paypalCheckout ? window.paypalCheckout.props.uid : guid) + '&token=' + token;
	            }
	
	            _logger.$logger.info(flags.isMiniBrowser ? 'minibrowser_flow' : 'non_minibrowser_flow');
	            _logger.$logger.info(flags.isFramed ? 'framed_flow' : 'non_framed_flow');
	            _logger.$logger.info(flags.isDirectIntegration ? 'direct_integration_flow' : 'non_direct_integration_flow');
	            _logger.$logger.info(flags.isPartnerIntegration ? 'partner_integration_flow' : 'non_partner_integration_flow');
	        });
	    },
	
	    handleWindowOpenerClose: function handleWindowOpenerClose() {
	        _logger.$logger.info('miniBrowser_handleWindowOpenerClose');
	        if (_integration.$integration.isContext(_integration.$CONTEXT.POPUP)) {
	            var interval = setInterval(function () {
	                try {
	                    if (!window.opener || window.opener.closed) {
	                        clearInterval(interval);
	                        _logger.$logger.info('window_opener_closed');
	                        // TODO: close this window if opener closed?
	                    }
	                } catch (err) {
	                    // pass
	                }
	            }, 50);
	        }
	    },
	    handleLightboxToPopup: function handleLightboxToPopup() {
	        var _this2 = this;
	
	        _logger.$logger.info('miniBrowser_handleLightboxToPopup');
	
	        // If we're allowed to collect data in this integration, we don't need this functionality
	        if (_integration.$integration.getConfig('ALLOW_COLLECT_DATA')) {
	            return;
	        }
	
	        // First check our integration supports falling back to a popup
	        if (!_integration.$integration.getConfig('CAN_FALLBACK_TO_POPUP')) {
	            throw _integration.$integration.error('Can not fallback to popup for data collection');
	        }
	
	        _angular.$rootScope.$on('$stateChangeStart', function (event, newState) {
	
	            // If we're in a context where we can't collect sensitive data and we enter a privileged state, try falling back to a popup window
	
	            if (newState.loginRequired) {
	                var _ret = function () {
	                    event.preventDefault();
	
	                    if (window.paypalCheckout) {
	                        return {
	                            v: void 0
	                        };
	                    }
	
	                    // If we already have a child window, don't do anything.
	                    if (_this2.childWindow) {
	                        return {
	                            v: void 0
	                        };
	                    }
	
	                    // There are two fallback flows we support here:
	                    //
	                    // 1. COLLECT_DATA - Collect the form data in the popup and return control to the lightbox
	                    // 2. CHECKOUT - Complete the entire remaining checkout flow in the popup
	                    //
	                    // Right now COLLECT_DATA is kinda janky, as we need to refresh the lightbox when we get back control to get the latest
	                    // models. So CHECKOUT is probably going to be a smoother experience.
	
	                    var childFlow = _integration.$integration.getConfig('RETURN_FROM_DATA_COLLECTION_POPUP') ? _integration.$FLOWS.COLLECT_DATA : _integration.$FLOWS.CHECKOUT;
	
	                    $miniBrowser.openChildWindow(childFlow, newState.name, $miniBrowser.config.dimensions, function (err) {
	                        if (_this2.childWindow) {
	                            $miniBrowser.closeChildWindow(childFlow, null, err || new Error('Child window closed'));
	                        }
	                    });
	
	                    // Initialize the popup and pass down the desired flow, along with other config values
	                    postRobot.once('init', {
	                        window: _this2.childWindow,
	
	                        handler: function handler(err, data) {
	
	                            if (err) {
	                                $miniBrowser.closeChildWindow(childFlow, null, err);
	                            } else {
	                                return {
	                                    id: $miniBrowser.config.id,
	                                    flow: childFlow,
	                                    dimensions: $miniBrowser.config.dimensions
	                                };
	                            }
	                        }
	                    });
	
	                    postRobot.on('focus', {
	                        proxy: false,
	                        override: true,
	
	                        handler: function handler() {
	                            if ($miniBrowser.childWindow) {
	                                $miniBrowser.childWindow.focus();
	                            } else {
	                                throw new Error('No child window to focus');
	                            }
	                        }
	                    });
	
	                    postRobot.on('close', {
	                        proxy: false,
	                        override: true,
	
	                        handler: function handler(err, data, callback) {
	
	                            if (err) {
	                                return callback(err);
	                            }
	
	                            if ($miniBrowser.childWindow) {
	                                $miniBrowser.closeChildWindow(childFlow);
	                            }
	
	                            callback();
	                        }
	                    });
	
	                    // If we're in the data-collection flow, wait for the popup to tell us it's done
	                    if (childFlow === _integration.$FLOWS.COLLECT_DATA) {
	
	                        postRobot.once('collect_data_complete', {
	                            window: _this2.childWindow,
	
	                            handler: function handler(err, data) {
	
	                                if (err) {
	                                    $miniBrowser.closeChildWindow(childFlow, null, err);
	                                } else {
	                                    $miniBrowser.closeChildWindow(childFlow, data.targetPage);
	                                }
	                            }
	                        });
	                    }
	                }();
	
	                if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	            }
	        });
	    },
	    handlePopupFromLightBox: function handlePopupFromLightBox() {
	
	        _logger.$logger.info('miniBrowser_handlePopupFromLightBox');
	        // If we're not in a collect-data flow, we can just stay in the popup
	        if (!_integration.$integration.isFlow(_integration.$FLOWS.COLLECT_DATA)) {
	            return;
	        }
	
	        _angular.$rootScope.$on('$stateChangeStart', function (event, newState) {
	
	            if (!newState.loginRequired) {
	                event.preventDefault();
	
	                // Mask the page, since we're done
	                _angular.$rootScope.$emit('loading');
	
	                // Tell the parent the data collection is complete, and pass the target page for it to transition to
	                postRobot.sendToParent('collect_data_complete', {
	                    targetPage: newState.name
	                })['catch'](function (err) {
	
	                    // In case of any error communicating with the parent, all we can do is close the popup
	                    _logger.$logger.warn('popup_flow_error', {
	                        error: err.stack || err.toString()
	                    });
	                    window.close();
	                });
	            }
	        });
	    },
	
	
	    sendPostMessage: function sendPostMessage(token) {
	
	        if (window.paypalCheckout) {
	            return;
	        }
	
	        return _squid.$promise.hash({
	
	            isPartnerIntegration: this.getPartnerIntegration(token),
	            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(token).retrieve()
	
	        }).then(function (data) {
	
	            if (!_integration.$integration.getConfig('POST_MESSAGE_PARENT')) {
	                return;
	            }
	
	            postRobot.on('focus', {
	                handler: function handler() {
	                    throw new Error('Can not focus self');
	                }
	            });
	
	            postRobot.on('close', {
	                handler: function handler(err, _data, callback) {
	
	                    if (err) {
	                        return callback(err);
	                    }
	
	                    if (!_integration.$integration.getConfig('CAN_CLOSE_SELF')) {
	                        return callback(new Error('Can not close self'));
	                    }
	
	                    callback();
	                    window.close();
	                }
	            });
	
	            var msg = void 0;
	
	            try {
	                msg = {
	                    operation: 'init',
	                    cancelUrl: data.checkoutAppData.urls.cancel_url,
	                    landingUrl: window.location.href,
	                    secureWindowmsg: _squid.$locale.content.scripts.secureWindowmsg
	                };
	            } catch (err) {
	                return _logger.$logger.error('minibrowser_msg_construction_failed', {
	                    error: err
	                });
	            }
	
	            if (!_util.$ReturnToMerchant.postToMerchant(msg)) {
	                _logger.$logger.error('minibrowser_post_failed');
	            }
	
	            return postRobot.sendToParent('init', {
	
	                cancelUrl: data.checkoutAppData.urls.cancel_url,
	                landingUrl: window.location.href,
	                secureWindowmsg: _squid.$locale.content.get('scripts.secureWindowmsg')
	
	            }).then(function (result) {
	
	                if (result.flow) {
	                    _integration.$integration.setFlow(result.flow);
	                }
	
	                $miniBrowser.config = result;
	            })['catch'](function (err) {
	
	                _logger.$logger.info('postmessage_init_failed', {
	                    error: err.stack || err.toString()
	                });
	            });
	        });
	    },
	
	    frameBust: function frameBust(token) {
	
	        return _squid.$promise.hash({
	            isFramed: this.isFramed()
	        }).then(function (flags) {
	
	            if (flags.isFramed) {
	                _logger.$logger.info('frame_bust');
	                _squid.$util.redirect(window.location.href);
	            }
	        });
	    },
	
	    resize: function resize() {
	        if (window.paypalCheckout) {
	            return;
	        }
	
	        var wrapper = document.getElementById('outerWrapper');
	        var height = wrapper ? wrapper.offsetHeight : document.body.offsetHeight;
	        var width = wrapper ? wrapper.offsetWidth : document.body.offsetWidth;
	
	        var isResizeSuccess = void 0;
	
	        if (height && width) {
	            isResizeSuccess = _util.$ReturnToMerchant.postToMerchant({
	                operation: 'lightbox_resize',
	                height: height,
	                width: width
	            });
	
	            _logger.$logger.info('lightbox_resize', {
	                height: height,
	                width: width
	            });
	
	            if (!isResizeSuccess) {
	                _logger.$logger.error('lightbox_resize_failed');
	            }
	        }
	    }
	};
	
	angular.value("$miniBrowser", $miniBrowser);
	_angular.$rootScope;
	
	_logger.$logger;
	
	_squid.$promise;
	
	_squid.$util;
	
	_squid.$locale;
	
	_uiRouter.$state;
	
	_checkout.$CheckoutAppDataModel;
	
	_checkout.$CheckoutCartModel;
	
	_util.$ReturnToMerchant;
	
	_integration.$integration;
	
	_integration.$FLOWS;
	
	_integration.$CONTEXT;
	
	_error.$exceptionHandler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./js/lib/integration.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$CONTEXT = exports.$integration = exports.$FLOWS = undefined;
	
	var _$DEFAULT, _$CONTEXT$FULLPAGE, _$CONTEXT$LIGHTBOX, _$integration$init;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	Object.defineProperty(exports, '$integration', {
	    enumerable: true,
	    get: function get() {
	        return _squid.$integration;
	    }
	});
	Object.defineProperty(exports, '$CONTEXT', {
	    enumerable: true,
	    get: function get() {
	        return _squid.$CONTEXT;
	    }
	});
	var $FLOWS = exports.$FLOWS = {
	
	    // Regular end-to-end checkout flow with one entry and one exit point
	    CHECKOUT: 'CHECKOUT',
	
	    // Flow for collecting user data, then messaging back to parent once done
	    COLLECT_DATA: 'COLLECT_DATA',
	
	    // Partner flow [ TODO: FACTOR THIS OUT ]
	    PARTNER: 'PARTNER',
	
	    // Incontext lightbox flow
	    INCONTEXT_LIGHTBOX: 'INCONTEXT_LIGHTBOX',
	
	    // Incontext popup flow
	    INCONTEXT_POPUP: 'INCONTEXT_POPUP',
	
	    // Native checkout flow
	    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT',
	
	    // Messenger Integration flow
	    MESSENGER_BA_INTEGRATION: 'MESSENGER_BA_INTEGRATION'
	};
	
	_squid.$integration.init($FLOWS.CHECKOUT, (_$integration$init = {}, _$integration$init[_squid.$DEFAULT] = (_$DEFAULT = {
	
	    ALLOW_AUTH: true,
	    ALLOW_COLLECT_DATA: true,
	    ALLOW_ONETOUCH_TOKEN_EXCHANGE: false,
	
	    FALLBACK: true,
	    REDIRECT_TOP: true,
	    REDIRECT_QUERY_PARAM: false,
	    POST_MESSAGE_PARENT: false
	
	}, _$DEFAULT[$FLOWS.PARTNER] = {
	
	    FALLBACK: false,
	    REDIRECT_TOP: false,
	    POST_MESSAGE_PARENT: false
	}, _$DEFAULT[$FLOWS.INCONTEXT_LIGHTBOX] = {
	
	    ALLOW_ONETOUCH_TOKEN_EXCHANGE: true,
	    POST_MESSAGE_PARENT: true
	}, _$DEFAULT[$FLOWS.INCONTEXT_POPUP] = {
	
	    POST_MESSAGE_PARENT: true
	}, _$DEFAULT), _$integration$init[_squid.$CONTEXT.FULLPAGE] = (_$CONTEXT$FULLPAGE = {
	
	    CAN_FRAMEBUST: false,
	    CAN_FALLBACK_TO_POPUP: false,
	    CAN_CLOSE_SELF: false
	
	}, _$CONTEXT$FULLPAGE[$FLOWS.NATIVE_CHECKOUT] = {
	
	    REDIRECT_QUERY_PARAM: true
	
	}, _$CONTEXT$FULLPAGE), _$integration$init[_squid.$CONTEXT.LIGHTBOX] = (_$CONTEXT$LIGHTBOX = {
	
	    ALLOW_AUTH: false,
	    ALLOW_COLLECT_DATA: false,
	
	    CAN_FRAMEBUST: true,
	    CAN_FALLBACK_TO_POPUP: true,
	    CAN_CLOSE_SELF: false,
	
	    RETURN_FROM_DATA_COLLECTION_POPUP: false
	
	}, _$CONTEXT$LIGHTBOX[$FLOWS.MESSENGER_BA_INTEGRATION] = {
	
	    IS_MESSENGER_BA_INTEGRATION: true
	
	}, _$CONTEXT$LIGHTBOX[$FLOWS.PARTNER] = {
	
	    ALLOW_AUTH: true,
	    ALLOW_COLLECT_DATA: true,
	    CAN_FALLBACK_TO_POPUP: false,
	    POST_MESSAGE_PARENT: false
	}, _$CONTEXT$LIGHTBOX), _$integration$init[_squid.$CONTEXT.POPUP] = {
	    ALLOW_AUTH: true,
	    ALLOW_COLLECT_DATA: true,
	
	    CAN_FRAMEBUST: true,
	    CAN_FALLBACK_TO_POPUP: true,
	    CAN_CLOSE_SELF: false
	}, _$integration$init));
	
	_squid.$integration;
	
	_squid.$DEFAULT;
	
	_squid.$CONTEXT;

/***/ },

/***/ "./js/lib/metaBuilder.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$metaBuilder = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _model = __webpack_require__("./components/xo-tracking/dist/model.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function buildMeta() {
	    return {
	        token: _angular.$rootScope.token || _squid.$config.token || _squid.$meta.token || _squid.$util.param('token'),
	        calc: _model.$CalDataModel.getCalCorrId(),
	        csci: _model.$CalDataModel.getUUID(),
	        locale: {
	            country: _squid.$locale && _squid.$locale.country,
	            language: _squid.$locale && _squid.$locale.lang
	        },
	        state: 'ui_' + (_angular.$rootScope.currentState || 'checkout_init'),
	        app_name: 'hermesnodeweb'
	    };
	}
	
	function buildContext() {
	    return {
	        locale: {
	            country: _squid.$locale && _squid.$locale.country,
	            language: _squid.$locale && _squid.$locale.lang
	        }
	    };
	}
	
	_squid.$Api.registerMetaBuilder(buildMeta);
	
	var $metaBuilder = exports.$metaBuilder = {
	    build: buildMeta,
	    buildContext: buildContext
	};
	
	angular.value("$metaBuilder", $metaBuilder);
	_angular.$rootScope;
	
	_model.$CalDataModel;
	
	_squid.$util;
	
	_squid.$meta;
	
	_squid.$Api;
	
	_squid.$locale;
	
	_squid.$config;

/***/ },

/***/ "./components/xo-tracking/dist/model.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/node-uuid/uuid.js") // Using the same module as used in NodeInfra
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, uuid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('tracking.model', ['squid']).constant('$FptiConstants', {
	        // The prototype of buzname data object
	        buznameMap: {
	            country: {
	                placeHolder: 'glb',
	                fptiKey: 'ccpg'
	            },
	
	            flowgatename: {
	                placeHolder: '',
	                fptiKey: 'fltp'
	            },
	
	            'flowname': {
	                placeHolder: 'ec:hermes:',
	                fptiKey: 'flnm'
	            },
	            'hier1': {
	                placeHolder: 'main_ec_hermes_',
	                fptiKey: 'shir'
	            },
	            /*
	             * No key defined in FPTI
	             */
	            //            'hier2': '',
	            //            'hier3': '',
	            //            'hier4': '',
	            //            'hier5': '',
	            'inout': {
	                placeHolder: 'inout',
	                fptiKey: 'lgin'
	            },
	            'pagename': {
	                placeHolder: 'main:ec:hermes',
	                fptiKey: 'pgrp'
	            },
	            'pagename2': {
	                placeHolder: 'main:ec:hermes',
	                fptiKey: 'page'
	            },
	            'version': {
	                placeHolder: 'hermes',
	                fptiKey: 'vers'
	            }
	            /*
	             * Deprecated SiteCatalyst keys
	             */
	            //            'feature': 'ec',
	            //            'oldpagename': '',
	            //            'product': ';ec',
	            //            'subfeature1': 'hermes',
	            //            'subfeature2': '',
	            //            'website': 'main'
	        },
	
	        // Full list of FPTI keys indexed by readable names
	        // This mapping can also be served as default decorator
	        fptiKeys: {
	            'businessType': 'bztp',
	            'correlationId': 'calc', // CalDataModel
	            'countryOfPage': 'ccpg', // buzname
	            'cust': 'cust',
	            'errorCode': 'eccd',
	            'fieldError': 'erfd',
	            'flowgatename': 'fltp', // buzname
	            'flowname': 'flnm', // buzname
	            'locale': 'rsta', // LocaleModel
	            'loggedIn': 'lgin', // buzname
	            'merchantId': 'mrid',
	            'merchantType': 'mbtp',
	            'pageError': 'erpg',
	            'pageGoal': 'goal', // route
	            'pageGroup': 'pgrp', // buzname
	            'pageName': 'page', // buzname
	            'pageQualifer': 'qual', // buzname
	            'pageStartTime': 'pgst', // FptiBuilder
	            'pageTechnologyFlag': 'pgtf', // productConfig
	            'paymentFlowId': 'pfid',
	            'rLogId': 'teal',
	            'sessionId': 'fpti',
	            'siteHierarchy': 'shir', // buzname
	            'sourceCi': 's', // productConfig
	            'tealeaf': 'teal',
	            'templateName': 'tmpl', // route
	            'transition_time': 'transition_time',
	            'uuid': 'csci', // CalDataModel
	            'version': 'vers', // buzname
	            'visitorId': 'vid',
	            'ecToken': 'fltk', // metadata
	            'pxpExpSelected': 'xe',
	            'pxpTreatementSelected': 'xt',
	            'pxpQualifiedTreatment': 'qt',
	            'pxpContextId': 'qc',
	            'dc': 'dc',
	            'az': 'az'
	        },
	
	        landing_page: {
	            login: 'LOGIN',
	            econsent: 'eConsent',
	            review: 'Review',
	            error_page: 'error_page',
	            add_card: 'add_card',
	            add_bank: 'add_bank',
	            billing: 'billing',
	            done_page: 'done_page',
	            shoppingCart: 'shoppingCart',
	            emptyCart: 'emptyCart',
	            soldout: 'soldout',
	            openButton: 'openButton'
	        },
	
	        stateName: {
	            checkout_login: 'login',
	            checkout_genericError: 'error_page',
	            checkout_fastlogin: 'login',
	            checkout_econsent: 'econsent',
	            checkout_review: 'review',
	            checkout_pageAddCard_addCardFlow_addCard: 'add_card',
	            checkout_updateCard_addCardFlow_addCard: 'add_card',
	            checkout_pageAddFi_bank_add: 'add_bank',
	            guest: 'billing',
	            checkout_done: 'done_page',
	            checkout_guest: 'billing',
	            checkout_signup: 'billing',
	            guestupgrade_genericError: 'error_page',
	            checkout_multistepsignup_multistepsignupaddcard: 'billing',
	            checkout_shoppingCart: 'shoppingCart',
	            checkout_emptyCart: 'emptyCart',
	            checkout_soldout: 'soldout',
	            checkout_openButton: 'openButton'
	        }
	    }).factory('$FptiDataModel', function ($Class, $FptiConstants, $util, $config) {
	        var productConfig = {};
	        // TODO to read from config.json
	        productConfig[$FptiConstants.fptiKeys.sourceCi] = 'ci';
	        productConfig[$FptiConstants.fptiKeys.pageTechnologyFlag] = 'NodeJS';
	
	        /**
	         * Utilizing Decorator pattern to allow defining additional logic for specific keys
	         */
	        return $Class.extend('FptiDataModel', {
	            init: function init() {
	                this._dataObj = angular.extend({}, productConfig);
	                this._decoratorList = [];
	            },
	            decorators: {
	                buzname: function buzname(trackingData, pageQualifier, isInContext) {
	
	                    if (!trackingData) {
	                        return;
	                    }
	
	                    var buzname = trackingData.buzname;
	                    if (!buzname) {
	                        return;
	                    }
	
	                    var buznameDiff = buzname[pageQualifier];
	                    if (!buznameDiff) {
	                        return;
	                    }
	
	                    var dataObj = this._dataObj;
	                    var buznameMap = $FptiConstants.buznameMap;
	                    // read app specific place holder from config
	                    var placeHolderConfig = $config && $config.fpti && $config.fpti.buznameEntryPlaceHolder;
	
	                    Object.keys(buznameMap).forEach(function (key) {
	                        var buznameEntry = buznameMap[key];
	                        var fptiKey = buznameEntry.fptiKey;
	                        var placeHolder = buznameEntry.placeHolder;
	
	                        if (buznameDiff[key]) {
	                            if (placeHolderConfig && placeHolderConfig[key]) {
	                                placeHolder = placeHolderConfig[key];
	                            }
	                            dataObj[fptiKey] = buznameDiff[key].replace('%', placeHolder);
	                        } else {
	                            dataObj[fptiKey] = placeHolder;
	                        }
	                    });
	                    dataObj[$FptiConstants.fptiKeys.pageQualifer] = pageQualifier;
	                },
	
	                locale: function locale(_locale) {
	                    if (_locale && _locale.country) {
	                        this._dataObj[$FptiConstants.fptiKeys.locale] = _locale.country;
	                    }
	                },
	
	                pxptrackingdata: function pxptrackingdata(pxpData) {
	                    var qt = [];
	                    var qc = [];
	                    var xe = [];
	                    var xt = [];
	                    $util.some(pxpData, function (trackInfo) {
	                        var match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqt=([^;]+);');
	                        if (match) {
	                            qt.push(match[1]);
	                        }
	
	                        match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqc=([^;]+);');
	                        if (match) {
	                            qc.push(match[1]);
	                        }
	
	                        $util.some(trackInfo.treatments, function (treatment) {
	                            xe.push(treatment.experiment_id);
	                            xt.push(treatment.treatment_id);
	                        });
	                    });
	
	                    this._dataObj[$FptiConstants.fptiKeys.pxpQualifiedTreatment] = qt.join(',');
	                    this._dataObj[$FptiConstants.fptiKeys.pxpContextId] = qc.join(',');
	                    this._dataObj[$FptiConstants.fptiKeys.pxpExpSelected] = xe.join(',');
	                    this._dataObj[$FptiConstants.fptiKeys.pxpTreatementSelected] = xt.join(',');
	                },
	
	                templateName: function templateName(trackingData, pageQualifier, isInContext) {
	                    if (trackingData && trackingData.templateName) {
	                        var templateName = (trackingData.templateName || '') + (pageQualifier ? ':' + pageQualifier : '');
	
	                        this._dataObj[$FptiConstants.fptiKeys.templateName] = templateName;
	                    }
	                },
	
	                fieldError: function fieldError(err) {
	                    if (err && err.type === 'fieldError') {
	                        this._dataObj[$FptiConstants.fptiKeys.fieldError] = err.field;
	                        this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
	                    }
	                },
	
	                pageError: function pageError(err) {
	                    if (err && err.type === 'pageError') {
	
	                        this._dataObj[$FptiConstants.fptiKeys.pageError] = err.msg;
	                        this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
	                    }
	                }
	
	            },
	            decorate: function decorate(name) {
	                this._decoratorList.push({
	                    name: name,
	                    params: Array.prototype.slice.call(arguments, 1)
	                });
	                return this;
	            },
	            getDataObject: function getDataObject(isInContext) {
	                var i;
	                var decorator;
	
	                for (i = 0; i < this._decoratorList.length; i++) {
	                    decorator = this._decoratorList[i];
	                    if (!decorator) {
	                        continue;
	                    }
	                    var name = decorator.name;
	                    var params = decorator.params;
	                    if (angular.isFunction(this.decorators[name])) {
	                        // Invoke the decorator and pass in the parameter list
	                        this.decorators[name].apply(this, params);
	                    } else {
	                        var fptiKey = $FptiConstants.fptiKeys[name];
	                        // If the fptiKey is defined and value is present, add the k-v pair
	                        if (fptiKey && params && params.length > 0) {
	                            this._dataObj[fptiKey] = params[0];
	                        }
	                    }
	                }
	
	                // 'fullpage' was widely used as default key in page routs definition
	                // finally replace it here if it's incontext
	                var dataObj = this._dataObj;
	                if (isInContext) {
	                    Object.keys(dataObj).forEach(function (k) {
	                        if (angular.isString(dataObj[k])) {
	                            // some values can be number
	                            dataObj[k] = dataObj[k].replace('fullpage', 'incontext');
	                        }
	                    });
	                }
	
	                return this._dataObj;
	            }
	        });
	    }).factory('$CalDataModel', function ($Model) {
	
	        var uuid_v4_mask = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	        var uuid_v1_mask = 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX';
	
	        function _generateCorrelationId() {
	            var uidRandomArr = (uuid.v4() || uuid_v4_mask).split('-');
	            var uidTime = (uuid.v1() || uuid_v1_mask).split('-');
	            return uidTime[0] + uidRandomArr[0].substr(0, 5);
	        }
	
	        function _generateUUID() {
	            return (uuid.v4() || uuid_v4_mask).replace(/-/g, '');
	        }
	
	        var CalModel = $Model.extend({
	            _calCorrId: _generateCorrelationId(),
	            _uuid: _generateUUID(),
	
	            generateCalCorrId: function generateCalCorrId() {
	                this._calCorrId = _generateCorrelationId();
	            },
	            generateUUID: function generateUUID() {
	                this._uuid = _generateUUID();
	            },
	            generateMetaIds: function generateMetaIds() {
	                this.generateCalCorrId();
	                this.generateUUID();
	            },
	
	            getCalCorrId: function getCalCorrId() {
	                return this._calCorrId;
	            },
	
	            getUUID: function getUUID() {
	                return this._uuid;
	            }
	        });
	
	        return new CalModel();
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/model.js"))

/***/ },

/***/ "./components/node-uuid/uuid.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(console) {
	
	//     uuid.js
	//
	//     Copyright (c) 2010-2012 Robert Kieffer
	//     MIT License - http://opensource.org/licenses/mit-license.php
	
	/*global window, require, define */
	(function (_window) {
	  
	
	  // Unique ID creation requires a high quality random # generator.  We feature
	  // detect to determine the best RNG source, normalizing to a function that
	  // returns 128-bits of randomness, since that's what's usually required
	
	  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;
	
	  function setupBrowser() {
	    // Allow for MSIE11 msCrypto
	    var _crypto = _window.crypto || _window.msCrypto;
	
	    if (!_rng && _crypto && _crypto.getRandomValues) {
	      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	      //
	      // Moderately fast, high quality
	      try {
	        var _rnds8 = new Uint8Array(16);
	        _whatwgRNG = _rng = function whatwgRNG() {
	          _crypto.getRandomValues(_rnds8);
	          return _rnds8;
	        };
	        _rng();
	      } catch (e) {}
	    }
	
	    if (!_rng) {
	      // Math.random()-based (RNG)
	      //
	      // If all else fails, use Math.random().  It's fast, but is of unspecified
	      // quality.
	      var _rnds = new Array(16);
	      _mathRNG = _rng = function _rng() {
	        for (var i = 0, r; i < 16; i++) {
	          if ((i & 0x03) === 0) {
	            r = Math.random() * 0x100000000;
	          }
	          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	        }
	
	        return _rnds;
	      };
	      if ('undefined' !== typeof console && console.warn) {
	        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
	      }
	    }
	  }
	
	  function setupNode() {
	    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
	    //
	    // Moderately fast, high quality
	    if (true) {
	      try {
	        var _rb = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"crypto\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())).randomBytes;
	        _nodeRNG = _rng = _rb && function () {
	          return _rb(16);
	        };
	        _rng();
	      } catch (e) {}
	    }
	  }
	
	  if (_window) {
	    setupBrowser();
	  } else {
	    setupNode();
	  }
	
	  // Buffer class to use
	  var BufferClass = 'function' === typeof Buffer ? Buffer : Array;
	
	  // Maps for number <-> hex string conversion
	  var _byteToHex = [];
	  var _hexToByte = {};
	  for (var i = 0; i < 256; i++) {
	    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
	    _hexToByte[_byteToHex[i]] = i;
	  }
	
	  // **`parse()` - Parse a UUID into it's component bytes**
	  function parse(s, buf, offset) {
	    var i = buf && offset || 0,
	        ii = 0;
	
	    buf = buf || [];
	    s.toLowerCase().replace(/[0-9a-f]{2}/g, function (oct) {
	      if (ii < 16) {
	        // Don't overflow!
	        buf[i + ii++] = _hexToByte[oct];
	      }
	    });
	
	    // Zero out remaining bytes if string was short
	    while (ii < 16) {
	      buf[i + ii++] = 0;
	    }
	
	    return buf;
	  }
	
	  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
	  function unparse(buf, offset) {
	    var i = offset || 0,
	        bth = _byteToHex;
	    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
	  }
	
	  // **`v1()` - Generate time-based UUID**
	  //
	  // Inspired by https://github.com/LiosK/UUID.js
	  // and http://docs.python.org/library/uuid.html
	
	  // random #'s we need to init node and clockseq
	  var _seedBytes = _rng();
	
	  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	  var _nodeId = [_seedBytes[0] | 0x01, _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]];
	
	  // Per 4.2.2, randomize (14 bit) clockseq
	  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	  // Previous uuid creation time
	  var _lastMSecs = 0,
	      _lastNSecs = 0;
	
	  // See https://github.com/broofa/node-uuid for API details
	  function v1(options, buf, offset) {
	    var i = buf && offset || 0;
	    var b = buf || [];
	
	    options = options || {};
	
	    var clockseq = options.clockseq != null ? options.clockseq : _clockseq;
	
	    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	    var msecs = options.msecs != null ? options.msecs : new Date().getTime();
	
	    // Per 4.2.1.2, use count of uuid's generated during the current clock
	    // cycle to simulate higher resolution clock
	    var nsecs = options.nsecs != null ? options.nsecs : _lastNSecs + 1;
	
	    // Time since last uuid creation (in msecs)
	    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
	
	    // Per 4.2.1.2, Bump clockseq on clock regression
	    if (dt < 0 && options.clockseq == null) {
	      clockseq = clockseq + 1 & 0x3fff;
	    }
	
	    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	    // time interval
	    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
	      nsecs = 0;
	    }
	
	    // Per 4.2.1.2 Throw error if too many uuids are requested
	    if (nsecs >= 10000) {
	      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	    }
	
	    _lastMSecs = msecs;
	    _lastNSecs = nsecs;
	    _clockseq = clockseq;
	
	    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	    msecs += 12219292800000;
	
	    // `time_low`
	    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	    b[i++] = tl >>> 24 & 0xff;
	    b[i++] = tl >>> 16 & 0xff;
	    b[i++] = tl >>> 8 & 0xff;
	    b[i++] = tl & 0xff;
	
	    // `time_mid`
	    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
	    b[i++] = tmh >>> 8 & 0xff;
	    b[i++] = tmh & 0xff;
	
	    // `time_high_and_version`
	    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	    b[i++] = tmh >>> 16 & 0xff;
	
	    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	    b[i++] = clockseq >>> 8 | 0x80;
	
	    // `clock_seq_low`
	    b[i++] = clockseq & 0xff;
	
	    // `node`
	    var node = options.node || _nodeId;
	    for (var n = 0; n < 6; n++) {
	      b[i + n] = node[n];
	    }
	
	    return buf ? buf : unparse(b);
	  }
	
	  // **`v4()` - Generate random UUID**
	
	  // See https://github.com/broofa/node-uuid for API details
	  function v4(options, buf, offset) {
	    // Deprecated - 'format' argument, as supported in v1.2
	    var i = buf && offset || 0;
	
	    if (typeof options === 'string') {
	      buf = options === 'binary' ? new BufferClass(16) : null;
	      options = null;
	    }
	    options = options || {};
	
	    var rnds = options.random || (options.rng || _rng)();
	
	    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	    rnds[6] = rnds[6] & 0x0f | 0x40;
	    rnds[8] = rnds[8] & 0x3f | 0x80;
	
	    // Copy bytes to buffer, if provided
	    if (buf) {
	      for (var ii = 0; ii < 16; ii++) {
	        buf[i + ii] = rnds[ii];
	      }
	    }
	
	    return buf || unparse(rnds);
	  }
	
	  // Export public API
	  var uuid = v4;
	  uuid.v1 = v1;
	  uuid.v4 = v4;
	  uuid.parse = parse;
	  uuid.unparse = unparse;
	  uuid.BufferClass = BufferClass;
	  uuid._rng = _rng;
	  uuid._mathRNG = _mathRNG;
	  uuid._nodeRNG = _nodeRNG;
	  uuid._whatwgRNG = _whatwgRNG;
	
	  if ('undefined' !== typeof module && module.exports) {
	    // Publish as node.js module
	    module.exports = uuid;
	  } else if (true) {
	    // Publish as AMD module
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return uuid;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Publish as global (in browsers)
	    _previousRoot = _window.uuid;
	
	    // **`noConflict()` - (browser only) to reset global 'uuid' var**
	    uuid.noConflict = function () {
	      _window.uuid = _previousRoot;
	      return uuid;
	    };
	
	    _window.uuid = uuid;
	  }
	})('undefined' !== typeof window ? window : null);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "./js/lib/middleware.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	__webpack_require__("./js/lib/stateChangeListener.js");
	
	var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-models/src/app/index.js");
	
	__webpack_require__("./components/xo-login-components/src/login/fn.js");
	
	__webpack_require__("./components/xo-device-info/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	_angular2['default'].module().factory('$Middleware', function ($rootScope, $q, $util, $CheckoutAppDataModel, $CheckoutPayeeModel, $CheckoutCartModel, $DeviceInfo, $config, $meta, $FallbackError, $locale, $promise, $populate, $window, $timeout, $experiment, $TransactionEligibilityModel, $AuthModel, $dispatch, $logger, $pxp, $Class, $Api, $fn, $feature) {
	    return [function angularDebug() {
	
	        window.root = $rootScope;
	        window.injector = _angular2['default'].element(document.body).injector();
	
	        /**
	         * Config experiment to overwrite the $apply method and use $eval instead of $apply if it would throw a digest inprog error.
	         * This is mainly to address a Firefox bug with angular digest and timeouts, where timeouts can interrupt normal execution flow under certain circumstances
	         * Bug described here: https://github.com/angular/angular.js/issues/10083
	         *
	         * Can remove as a config option if this is a stable change
	         */
	        if ($config.safeApply) {
	            $logger.info('overwriting_angular_apply');
	            var proto = Object.getPrototypeOf && Object.getPrototypeOf($rootScope);
	
	            if (!proto) {
	                $logger.warn('overwriting_angular_apply_failed', {
	                    reason: 'failed_to_get_prototype'
	                });
	            } else {
	                (function () {
	                    var originalApply = proto.$apply;
	                    // If this gets used so many times, something is probably wrong so use original apply instead
	                    var skipAttempts = 10;
	
	                    proto.$apply = function (fn) {
	                        if (skipAttempts && ($rootScope.$$phase === '$digest' || $rootScope.$$phase === '$apply')) {
	                            skipAttempts--;
	
	                            $logger.warn('inprog_error_skipped', {
	                                stack: new Error().stack
	                            });
	
	                            this.$eval(fn);
	                        } else {
	                            originalApply.call(this, fn);
	                        }
	                    };
	                })();
	            }
	        }
	    }, function waitForToken() {
	
	        if ($util.isIFrame() && !$util.param('token') && !$meta.token) {
	            return $q(function (resolve, reject) {
	                $logger.info('await_token');
	
	                window.addEventListener('message', function (event) {
	
	                    var message = JSON.parse(event.data);
	
	                    if (message.operation !== 'pass_token') {
	                        return;
	                    }
	
	                    var token = message.token;
	
	                    $logger.info('passed_token', {
	                        token: token
	                    });
	
	                    $meta.token = token;
	
	                    var $preloadApi = new $Api({
	                        uri: 'preload'
	                    });
	
	                    $preloadApi.retrieve({
	                        params: {
	                            token: token
	                        }
	                    }).then(function (response) {
	
	                        $preloadApi.setTransientCache(response.data);
	                        resolve();
	                    })['catch'](reject);
	                }, false);
	            });
	        }
	    }, function checkToken() {
	
	        var pattern = /^EC-[0-9A-Z]{17}$/;
	        var beamPattern = /^BA-[0-9A-Z]{17}$/;
	
	        // wps token are not preceeded with 'EC-'
	        var wpsPattern = /^[0-9A-Z]{17}$/;
	
	        var urlToken = ($util.param('token') || '').trim().slice(0, 20);
	        var bodyToken = ($meta.token || '').trim().slice(0, 20);
	
	        if (urlToken && bodyToken && urlToken !== bodyToken) {
	            $logger.error('token_mismatch', {
	                server: bodyToken,
	                client: urlToken
	            });
	        }
	
	        var isWpsPattern = false;
	
	        if (pattern.test(urlToken)) {
	            $rootScope.token = urlToken;
	        } else if (pattern.test(bodyToken)) {
	            $rootScope.token = bodyToken;
	        } else if (wpsPattern.test(urlToken)) {
	            $logger.info('isWpsPattern');
	            $rootScope.token = urlToken;
	            isWpsPattern = true;
	        } else if (wpsPattern.test(bodyToken)) {
	            $logger.info('isWpsPattern');
	            $rootScope.token = bodyToken;
	            isWpsPattern = true;
	        } else if (beamPattern.test(urlToken)) {
	            $rootScope.token = urlToken;
	            $logger.info('cart_exchange_failed', {
	                token: $rootScope.token
	            });
	        } else if (beamPattern.test(bodyToken)) {
	            $rootScope.token = bodyToken;
	            $logger.info('cart_exchange_failed', {
	                token: $rootScope.token
	            });
	        } else {
	            return $q.reject(new $FallbackError({
	                reason: 'no_token',
	                product: 'error'
	            }));
	        }
	
	        if (isWpsPattern) {
	            return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	                $rootScope.wps = appData.doec_on_approve();
	                $rootScope.invoice = appData.flags.is_invoice_flow;
	                if ($rootScope.wps) {
	                    $logger.info('hermes_wps_flow', {
	                        token: $rootScope.token
	                    });
	                } else {
	                    $logger.info('hermes_xo_order_flow', {
	                        token: $rootScope.token
	                    });
	                }
	            });
	        }
	    }, function resolveLocale() {
	
	        var models = {};
	
	        return $populate(models, {
	            appData: $CheckoutAppDataModel.instance($rootScope.token),
	            cart: $CheckoutCartModel.instance($rootScope.token)
	        })['finally'](function () {
	            return $locale.retrieve({
	                params: {
	                    ipCountry: $meta.ipcountry,
	                    localeTestUrlParam: $util.param('locale.test'),
	                    checkoutShippingCountry: models.cart.get('purchase.shipping_address.country_code'),
	                    merchantCountry: models.appData.get('merchant.merchant_country'),
	                    checkoutSessionLocale: models.appData.get('merchant.merchant_locale'),
	                    countryParam: $util.param('country.x'),
	                    localeParam: $util.param('locale.x')
	                }
	            });
	        });
	    }, function fraudentInit() {
	        return $fn.init();
	    }, function setupIntegration() {
	        return _miniBrowser.$miniBrowser.init($rootScope.token);
	    }, function tokenExchange() {
	
	        if (!_integration.$integration.getConfig('ALLOW_ONETOUCH_TOKEN_EXCHANGE')) {
	            return;
	        }
	
	        if ($rootScope.isPartnerIntegration || !$util.isIFrame()) {
	            return;
	        }
	
	        var auth = $AuthModel.instance();
	
	        return auth.retrieve().then(function () {
	
	            if (auth.logged_in || auth.remembered || !auth.refresh_token) {
	                return;
	            }
	
	            return auth.action('onetouch');
	        });
	    }, function xcomponent() {
	
	        if (window.ppxo && window.ppxo.Checkout.isXComponent()) {
	            var _ret2 = function () {
	
	                var paypalCheckout = window.ppxo.Checkout.child({});
	
	                window.paypalCheckout = paypalCheckout;
	
	                return {
	                    v: $promise.run(function () {
	                        return paypalCheckout.init();
	                    }).then(function () {
	                        return $CheckoutAppDataModel.instance($rootScope.token).retrieve();
	                    }).then(function (checkoutAppData) {
	
	                        if (paypalCheckout.props.init) {
	                            return paypalCheckout.props.init({
	                                paymentToken: $rootScope.token,
	                                cancelUrl: checkoutAppData.urls.cancel_url
	                            });
	                        }
	                    })
	                };
	            }();
	
	            if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	        }
	    }, function xcomponentAuth() {
	        if (window.xprops && window.xprops.onAuth) {
	            var _ret3 = function () {
	
	                var auth = $AuthModel.instance();
	
	                return {
	                    v: auth.retrieve().then(function () {
	
	                        if (auth.access_token && (auth.logged_in || auth.remembered)) {
	                            return window.xprops.onAuth({
	                                accessToken: auth.access_token
	                            });
	                        }
	                    })
	                };
	            }();
	
	            if ((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object") return _ret3.v;
	        }
	    }, function logPage() {
	
	        $logger.info('href', {
	            href: window.location.href,
	            windowName: $window.name
	        });
	
	        var match = document.cookie.toString().match(/ectoken=([^;]+)/);
	
	        if (match && match[1] === $rootScope.token) {
	            $logger.info('returning_user_same_token');
	        } else if (match && match[1] !== $rootScope.token) {
	            $logger.info('returning_user_diff_token');
	        } else {
	            $logger.info('non_returning_user');
	        }
	
	        document.cookie = 'ectoken=' + $rootScope.token + '; expires=Fri, 31 Dec 9999 23:59:59 GMT;';
	
	        if (window.performance && window.performance.navigation && _angular2['default'].isDefined(window.performance.navigation.type)) {
	
	            var navigationType = {
	                0: 'regular',
	                1: 'reload',
	                2: 'back_forward'
	            }[window.performance.navigation.type];
	
	            if (navigationType) {
	                $logger.info('navigation_' + navigationType);
	            }
	        }
	    }, function handleTagManager() {
	        // The following section is added for AB testing
	        return $pxp('xo_hermesnode_ec_tag_manager', {
	            'ctx.COUNTRY': $locale.country
	        }, '(xo_hermesnode_ec_tag_manager_)(.*)').then(function (result) {
	            if (result) {
	                if (result.treatment_name === 'xo_hermesnode_ec_tag_manager_treatment') {
	
	                    // ****** Tag Manager Code Start Here ***********
	                    window.dataLayer = {
	                        // Two letter country code of the current page's content
	                        contentCountry: $locale.country.toLowerCase(),
	                        // Two letter locale
	                        contentLanguage: $locale.lang.toLowerCase()
	                    };
	
	                    var tagManagerUrl = $config.urls.tagProdUrl;
	
	                    // Based on the environment, Tag Manager end point can be changed.
	                    // For now the local and stage end points are same.
	                    if ($config.deploy.isLocal() || $config.deploy.isStage()) {
	                        tagManagerUrl = $config.urls.tagStageUrl;
	                    }
	
	                    // Load bootstrap.js asynchronously
	                    (function (i, s, o, g, r, a, m) {
	                        i['tagManagerObject'] = r;
	                        i[r] = i[r] || function () {
	                            (i[r].q = i[r].q || []).push(arguments);
	                        };
	                        i[r].l = 1 * new Date();
	                        a = s.createElement(o);
	                        m = s.getElementsByTagName(o)[0];
	                        a.async = 1;
	                        a.src = g;
	                        m.parentNode.insertBefore(a, m);
	                    })(window, document, 'script', tagManagerUrl, 'tagManager');
	                }
	            }
	        });
	    }, function logoutGuest() {
	        return $AuthModel.instance().retrieve().then(function (auth) {
	            if (auth.guest) {
	                $logger.info('guest_logout');
	
	                return auth.action('logout');
	            }
	        });
	    }, function checkGCEFallback() {
	
	        var appData = $CheckoutAppDataModel.instance($rootScope.token);
	        var cart = $CheckoutCartModel.instance($rootScope.token);
	        var merchantCountry = appData.get('merchant.merchant_country');
	        var throttle = $feature('redirectToCape', false, merchantCountry);
	        var capeRedirect = throttle ? $experiment('cape_redirect_exp', throttle, $rootScope.token, {}) : false;
	
	        return appData.retrieve().then(function () {
	            return cart.retrieve().then(function () {
	                if ((cart.payment_action === 'order' || cart.payment_action === 'sale') && appData.user_selected_funding_source_type === 'BML' && !capeRedirect) {
	                    return $q.reject(new $FallbackError({
	                        reason: 'gce_not_supported',
	                        product: 'aries'
	                    }));
	                }
	            });
	        });
	    }, function updatePaymentExperience() {
	        $CheckoutAppDataModel.instance($rootScope.token).action('updatePaymentExperience', {
	            data: {
	                payment_experience: 'HERMESNODE',
	                payment_experience_form_factor: _miniBrowser.$miniBrowser.isMiniBrowser() ? 'IN_CONTEXT' : 'FULL_PAGE'
	            },
	            silent: true,
	            transientError: true
	        });
	    }, function checkProcessorDecline() {
	        return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	
	            if (appData.flags.processor_declined) {
	                $logger.info('processor_decline_transaction');
	                var authModel = $AuthModel.instance();
	
	                if (authModel.auth_state === 'IDENTIFIED' && !$util.param('redirectToHermes')) {
	                    // guest
	                    return $dispatch('xoon', {
	                        token: $rootScope.token,
	                        hermesXoonRedirect: true
	                    }, {
	                        fromState: 'checkout_init',
	                        toState: 'guest',
	                        'locale.x': $locale.lang + '_' + $locale.country,
	                        'country.x': $locale.country
	                    });
	                }
	
	                return;
	            }
	        });
	    }, function checkTransactionEligibility() {
	        return $promise.hash({
	            transactionEligibility: $TransactionEligibilityModel.instance($rootScope.token).retrieve(),
	            isPartnerIntegration: _miniBrowser.$miniBrowser.getPartnerIntegration($rootScope.token),
	            isDirectIntegration: _miniBrowser.$miniBrowser.getDirectIntegration($rootScope.token)
	        }).then(function (data) {
	
	            if (data.transactionEligibility.eligible && !data.transactionEligibility.lipp) {
	                return $logger.info('transaction_eligible');
	            }
	
	            if (data.isPartnerIntegration) {
	                return $logger.warn('partner_integration_ineligible_transaction');
	            }
	
	            if (!data.isDirectIntegration) {
	                return $logger.warn('ineligible_indirect_transaction');
	            }
	
	            var appData = $CheckoutAppDataModel.instance($rootScope.token);
	
	            if (appData.user_selected_funding_source_type === 'BML' && ($config.deploy.isLocal() || $config.deploy.isStage())) {
	                return $logger.warn('ineligible_ppcbtn_transaction');
	            }
	
	            $logger.info('transaction_ineligible');
	
	            return $q.reject(new $FallbackError({
	                reason: 'transaction_ineligible',
	                product: 'ux'
	            }));
	        });
	    }, function logStart() {
	        return $promise.hash({
	            isMiniBrowser: _miniBrowser.$miniBrowser.isMiniBrowser(),
	            isDirectIntegration: _miniBrowser.$miniBrowser.getDirectIntegration($rootScope.token),
	            isIframe: _miniBrowser.$miniBrowser.isFramed()
	        }).then(function (flags) {
	            var app_int_type = $DeviceInfo.getAppIntegrationType();
	            $logger.info('app_start_design', {
	                'from': 'client_middleware',
	                'to': 'process_app_start_design',
	                is_directintegration: flags.isDirectIntegration ? 1 : 0,
	                is_incontext: flags.isMiniBrowser || flags.isIframe ? 1 : 0,
	                app_int_type: app_int_type
	            });
	        });
	    }, function logPerformance() {
	        if (window.enablePerformance) {
	            (function () {
	
	                var keys = ['connectEnd', 'connectStart', 'domComplete', 'domContentLoadedEventEnd', 'domContentLoadedEventStart', 'domInteractive', 'domLoading', 'domainLookupEnd', 'domainLookupStart', 'fetchStart', 'loadEventEnd', 'loadEventStart', 'navigationStart', 'redirectEnd', 'redirectStart', 'requestStart', 'responseEnd', 'responseStart', 'secureConnectionStart', 'unloadEventEnd', 'unloadEventStart'];
	
	                var timing = {};
	
	                _angular2['default'].forEach(keys, function (key) {
	                    timing[key] = parseInt(window.performance.timing[key], 10) || 0;
	                });
	
	                var offset = timing.connectEnd - timing.navigationStart;
	
	                if (timing.connectEnd && window.clientStartTime) {
	                    _angular2['default'].forEach(timing, function (time, name) {
	                        if (time && _angular2['default'].isNumber(time)) {
	                            $logger.info('timing_' + name, {
	                                client_elapsed: time - timing.connectEnd - (window.clientStartTime - offset),
	                                req_elapsed: time - timing.connectEnd
	                            });
	                        }
	                    });
	                }
	
	                $logger.info('timing', timing);
	
	                if (window.performance.memory) {
	                    $logger.info('memory', window.performance.memory);
	                }
	
	                if (window.performance.navigation) {
	                    $logger.info('navigation', window.performance.navigation);
	                }
	
	                if (window.performance.getEntries) {
	                    (function () {
	                        var logged = [];
	
	                        var logResources = function logResources() {
	                            _angular2['default'].forEach(window.performance.getEntries(), function (resource) {
	
	                                if (!resource || !resource.name) {
	                                    return;
	                                }
	
	                                if (logged.indexOf(resource.name) === -1) {
	                                    logged.push(resource.name);
	                                } else {
	                                    return;
	                                }
	
	                                if (resource.initiatorType) {
	                                    $logger.info(resource.initiatorType, resource);
	                                }
	                            });
	                        };
	
	                        logResources();
	                        setInterval(logResources, 500);
	                    })();
	                }
	
	                if (timing.connectEnd && timing.navigationStart && window.clientStartTime) {
	                    $logger.info('js_init', {
	                        client_elapsed: 0,
	                        req_elapsed: window.clientStartTime - offset
	                    });
	                }
	            })();
	        } else {
	            $logger.info('no_performance_data');
	        }
	    }, function logAuthState() {
	        return $AuthModel.instance().retrieve().then(function (auth) {
	            if (auth.logged_in) {
	                $logger.info('user_logged_in');
	            } else if (auth.remembered) {
	                $logger.info('user_remembered');
	            } else {
	                $logger.info('user_not_logged_in');
	            }
	        });
	    },
	
	    // check for access token in the hash.
	    function checkAccessToken() {
	        var euat = $util.param('euat');
	
	        if (euat) {
	            var accessToken = euat === '1' ? window.location.hash.substr(2) : euat;
	
	            if (accessToken) {
	                $logger.info(euat === '1' ? 'access_token_from_hash' : 'access_token_from_param', {
	                    access_token: accessToken
	                });
	
	                /* if (euat === '1') {
	                    window.location.hash = '';
	                } */
	
	                var authModel = $AuthModel.instance();
	
	                authModel.access_token = accessToken;
	            }
	        }
	    },
	
	    // check for FraudNet for Mobile View
	    function enableFraudNetForMobileWebView() {
	        if ($DeviceInfo.isApp()) {
	            return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	                return $pxp($config.ulMeta.hermesnodePxpConfig, {
	                    'ctx.COUNTRY': appData.merchant.merchant_country
	                }, 'xo_hermesnode_fraudnet_webview_treatment').then(function (result) {
	                    if (result && result.treatment_name) {
	                        $window.enableFraudNetForMobileWebView = true;
	                    }
	                });
	            });
	        }
	    },
	
	    // Logs if service workers are enabled
	    function isServiceWorkerSupported() {
	        if ('serviceWorker' in navigator) {
	            $logger.info('service_worker_supported');
	        } else {
	            $logger.info('service_worker_not_supported');
	        }
	    }, function forceCookiesDisabled() {
	        if ($DeviceInfo.isApp()) {
	            return $CheckoutPayeeModel.instance($rootScope.token).retrieve().then(function (payee) {
	                if (~$config.forceCookiesDisabled.indexOf(payee.merchant.id)) {
	                    $logger.info('force_cookies_disabled');
	                    $Api.forceCookiesDisabled = true;
	                }
	            });
	        }
	    }, function checkFramed() {
	        if ($util.isIFrame()) {
	            // Set this as "framed" mode (X icon, escape hatch, etc.)
	            document.documentElement.className += ' framed';
	
	            // After the page settles down on the initial render, resize.
	            var cancelAllLoadedListener = $rootScope.$on('allLoaded', function () {
	                _miniBrowser.$miniBrowser.resize();
	
	                // After the initial 'allLoaded', start resizing on page transitions.
	                window.addEventListener('hashchange', _miniBrowser.$miniBrowser.resize);
	            });
	            $rootScope.$on('$destroy', cancelAllLoadedListener);
	        }
	    }];
	});
	
	_integration.$integration;
	
	_miniBrowser.$miniBrowser;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/middleware.js"))

/***/ },

/***/ "./js/lib/stateChangeListener.js":
/***/ function(module, exports) {



/***/ },

/***/ "./components/xo-models/src/app/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.app', ['squid']).factory('$TransactionEligibilityModel', function ($Model, $Api) {
	        return $Model.extend('TransactionEligibilityModel', {
	            api: new $Api({
	                uri: '/api/eligibility/transaction/:id'
	            })
	        });
	    }).factory('$BuyerEligibilityModel', function ($Model, $Api) {
	        return $Model.extend('BuyerEligibilityModel', {
	            api: new $Api({
	                uri: '/api/eligibility/buyer/:id'
	            })
	        });
	    }).factory('$PXPModel', function ($Model, $Api) {
	        return $Model.extend({
	            api: new $Api({
	                uri: '/api/pxp/:id'
	            })
	        });
	    }).factory('$LocaleConfigModel', function ($Model, $Api) {
	        return $Model.extend({
	            api: new $Api({
	                uri: '/api/localeConfig'
	            })
	        });
	    }).factory('$AppDataModel', function ($Model, $Api) {
	        return $Model.extend('AppDataModel', {
	            api: new $Api({
	                uri: '/api/app'
	            }),
	
	            isMobile: function isMobile() {
	                return this.platform === 'mobile';
	            }
	        });
	    }).factory('$MessengerIntegrationDataModel', function ($Model, $Api) {
	        return $Model.extend('MessengerIntegrationDataModel', {
	            api: new $Api({
	                uri: '/api/messenger'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/app", "components/xo-models/src/app/index.js"))

/***/ },

/***/ "./components/xo-login-components/src/login/fn.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-fn', ['squid', 'xo-device-info', 'beaver']).factory('$fn', function ($populate, $rootScope, $CheckoutAppDataModel, $window, $DeviceInfo, $logger, $config, $util, $meta, $pxp, $q) {
	        var fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99';
	        var fnCorrId;
	        var fraudnetConfig = $config.fraudnet;
	        var token = $rootScope.token || $meta.token;
	
	        if ($meta.baToken) {
	            $logger.info('BEAM_In_Hermes_Checkout');
	            fnCorrId = $meta.baToken;
	        } else if ($rootScope.fraudNetId) {
	            fnCorrId = $rootScope.fraudNetId;
	        } else {
	            fnCorrId = $rootScope.token || $meta.token;
	        }
	
	        var options = {
	            fnSessionId: fnCorrId,
	            sourceId: fraudnetConfig && fraudnetConfig.sourceId || 'HERMES_SIGNIN',
	            allowsCustomEvent: typeof CustomEvent !== 'undefined' && angular.isFunction(CustomEvent)
	        };
	
	        function init() {
	
	            $logger.info('FN_contexts', {
	                'token': token,
	                'fnSessionId': options.fnSessionId
	            });
	
	            var appData = {};
	            return $populate(appData, { checkoutAppData: $CheckoutAppDataModel.instance(token) }).then(function () {
	                var country = appData.checkoutAppData.merchant.merchant_country;
	                return $pxp('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_fraudnet_switch_treatment');
	            }).then(function (result) {
	                var treatmentName = result && result.treatment_name || '';
	                if (treatmentName) {
	                    $logger.info('FN_passive_treatment');
	                    options.fnUrl = $config.urls.fraudnetUrl && $config.urls.fraudnetUrl.passive;
	                    options.passive = true;
	                } else {
	                    $logger.info('FN_active_treatment');
	                    options.fnUrl = $config.urls.fraudnetUrl && $config.urls.fraudnetUrl.active;
	                    options.passive = false;
	                }
	                $logger.info('FN_Initialised', {
	                    'allowsCustomEvent': options.allowsCustomEvent
	                });
	            });
	        }
	
	        var enableFraudnet = function enableFraudnet() {
	            var userAgent = $window.navigator.userAgent;
	
	            // Disable for web view
	            if ($DeviceInfo.isApp()) {
	                if ($window.enableFraudNetForMobileWebView) {
	                    $logger.info('Enable_FN_MobileApp_PXP_Decision');
	                    return true;
	                }
	
	                $logger.info('Disable_FN_Mobileapp');
	                return false;
	            } else if (userAgent.indexOf('EtsyInc') > -1) {
	                $logger.info('Disable_FN_Etsy');
	                return false;
	            }
	            $logger.info('Enable_FN');
	            return true;
	        };
	
	        function injectScript(fnUrl) {
	            var script = document.createElement('script');
	            script.id = 'js-sync';
	            script.src = fnUrl;
	            document.body.appendChild(script);
	        }
	
	        function injectIframe(beaconOptions) {
	            var iframe = document.createElement('iframe');
	            var dom;
	            var doc;
	            var where;
	
	            iframe.src = 'javascript:false'; // eslint-disable-line no-script-url
	            iframe.title = '';
	            iframe.role = 'presentation';
	            (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0; display: none;';
	
	            where = document.getElementsByTagName('script');
	            where = where[where.length - 1];
	            where.parentNode.insertBefore(iframe, where);
	
	            try {
	                doc = iframe.contentWindow.document;
	            } catch (e) {
	                dom = document.domain;
	                iframe.src = 'javascript:var d=document.open();d.domain="' + dom + '";void(0);'; // eslint-disable-line no-script-url
	                doc = iframe.contentWindow.document;
	            }
	
	            doc.open()._l = function () {
	                var js = this.createElement('script');
	                if (dom) {
	                    this.domain = dom;
	                }
	                js.id = 'js-iframe-async';
	                js.src = beaconOptions.fnUrl;
	                this.body.appendChild(js);
	            };
	
	            doc.write('<body onload="document._l();">');
	            doc.close();
	        }
	
	        function _injectConfig(configOptions) {
	            var script = document.getElementById('fconfig');
	
	            if (script) {
	                if (script.parentNode) {
	                    script.parentNode.removeChild(script);
	                }
	            }
	
	            script = document.createElement('script');
	            script.id = 'fconfig';
	            script.type = 'application/json';
	            script.setAttribute('fncls', fncls);
	
	            script.text = '{"f": "' + configOptions.fnSessionId + '", "s": "' + configOptions.sourceId + '", "cb": "fnCallback"}';
	            document.body.appendChild(script);
	        }
	
	        /**
	         * Loads the fraudnet beacons (triggers 2 image beacons to c.paypal.com and c6.paypal.com)
	         *
	         * Integration pattern ripped from the Fraudnet Integration guide:
	         * https://confluence.paypal.com/display/RiskDataAcquisition/FraudNet+Client+System+Integration+Guide+3.0#FraudNetClientSystemIntegrationGuide3.0-IntegrationCode
	         */
	        function _loadBeacon(beaconOptions) {
	            if ($DeviceInfo.isApp() && $window.enableFraudNetForMobileWebView) {
	                injectScript(beaconOptions.fnUrl);
	            } else {
	                injectIframe(beaconOptions);
	            }
	        }
	
	        function trigger(scope) {
	            var fnLoaded = !!$rootScope.fnLoaded;
	
	            if (fnLoaded) {
	                return false;
	            }
	
	            if (options.fnUrl) {
	                if (enableFraudnet()) {
	                    $window.fnCallback = function () {
	                        if (scope) {
	                            scope.$emit('fnCallback');
	                        }
	                    };
	                    _injectConfig(options);
	                    _loadBeacon(options);
	                    $rootScope.fnLoaded = true;
	                    return true;
	                }
	            }
	            return false;
	        }
	
	        /**
	         * send a payload to fraudnet for analysing typing speed
	         * @param type
	         */
	        function sendTypingSpeedPayload(type) {
	
	            var tsLoadPayload = {
	                'detail': {
	                    'type': type
	                }
	            };
	
	            if (type === 'Hermes') {
	                tsLoadPayload.detail['fields'] = ['username', 'password'];
	            }
	            if (type === 'HermesUL') {
	                tsLoadPayload.detail['frame'] = 'injectedUl';
	                tsLoadPayload.detail['fields'] = ['email', 'password'];
	            }
	
	            if (type && options.passive) {
	                var event;
	                if (options.allowsCustomEvent) {
	                    // document.createEvent deprecated
	                    $logger.info('fn_CustomEvent_type1');
	                    event = new CustomEvent('tsLoad', tsLoadPayload);
	                } else {
	                    // IE does not support CustomEvent constructor
	                    try {
	                        $logger.info('fn_CustomEvent_type2');
	                        event = window.document.createEvent('CustomEvent');
	                        event.initCustomEvent('tsLoad', true, true, tsLoadPayload.detail);
	                    } catch (err) {
	                        $logger.info('fn_CustomEvent_None', {
	                            'error': err
	                        });
	                    }
	                }
	                if (event) {
	                    window.document.dispatchEvent(event);
	                    $logger.info('Dispatched_FN_TS_Payload_' + type);
	                }
	            }
	        }
	
	        return {
	            init: init,
	            trigger: trigger,
	            sendTypingSpeedPayload: sendTypingSpeedPayload
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/login", "components/xo-login-components/src/login/fn.js"))

/***/ },

/***/ "./js/lib/security.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-models/src/auth/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_angular2['default'].module().run(function ($rootScope, $log, $state, $AuthModel, $Forbidden, $logger, $timeout, $interval) {
	
	    var errorCount = 0;
	
	    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	
	        var auth = $AuthModel.instance();
	
	        if (toState.auth !== false && !auth.logged_in) {
	            errorCount += 1;
	            if (errorCount === 10) {
	                $logger.error('max_state_requires_auth');
	            }
	            if (errorCount >= 10) {
	                return;
	            }
	            $logger.warn('state_requires_auth', {
	                stateName: toState.name
	            });
	            event.preventDefault();
	            throw new $Forbidden('state_transition_forbidden', { fromState: fromState, toState: toState });
	        }
	    });
	
	    $interval(function () {
	
	        var auth = $AuthModel.instance();
	
	        if (auth.logged_in) {
	            auth.reload({
	                silent: true
	            }).then(function () {
	                if ($state.current.auth !== false && !auth.logged_in) {
	                    errorCount += 1;
	                    if (errorCount === 10) {
	                        $logger.error('max_state_requires_auth');
	                    }
	                    if (errorCount >= 10) {
	                        return;
	                    }
	                    $logger.info('idle_timeout');
	                    $logger.warn('state_requires_auth', {
	                        stateName: $state.current.name
	                    });
	                    errorCount += 1;
	                    throw new $Forbidden();
	                }
	            });
	        }
	    }, 30 * 60 * 1000);
	
	    _squid.$util.idleTimeout(10 * 60 * 60 * 1000);
	});
	
	_squid.$util;

/***/ },

/***/ "./components/xo-tracking/dist/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	/**
	 * xo-tracking encapsulates all the details about instrumentation
	 * and only register event listeners during bootstrap
	 *
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/xo-tracking/dist/listener.js"), __webpack_require__("./components/xo-tracking/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    // Declare the dependency to register the listeners
	    return angular.module('tracking', ['tracking.listener', 'tracking.directive']);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-tracking/dist/listener.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-tracking/dist/fpti.js"), __webpack_require__("./components/xo-tracking/dist/button.js"), __webpack_require__("./components/xo-models/src/auth/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, $) {
	    angular.module('tracking.listener', ['beaver', 'tracking.fpti', 'button.tracking']).run(function ($rootScope, $logger, $CalDataModel, $AuthModel, $fpti, $fptiError, $FptiConstants, $ButtonTrackingService, $timeout, $FptiBuilder, $meta, $config) {
	
	        function logTransition(state) {
	            return !(state.trackingData && state.trackingData.suppressTransitionLog);
	        }
	
	        function logStateExit(state) {
	            return state.trackingData && state.trackingData.trackStateExit;
	        }
	
	        /*
	         * Triggers pa.js recordClick with custom parameters
	         */
	        function fptiCustomRecordClick(route, customData) {
	            var analyticsInstance, fptiData, pxpData, fptiDataObj;
	            var PAYPAL = window.PAYPAL;
	
	            if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
	                PAYPAL.core = PAYPAL.core || {};
	
	                analyticsInstance = new PAYPAL.analytics.Analytics();
	
	                fptiData = new $FptiBuilder({
	                    trackingData: route.trackingData,
	                    isInContext: $rootScope.miniBrowser
	                    // ... Other flow data pass-in here to resolve page qualifier
	                }).build();
	
	                // Add the pxp data in fptiData as custom Attributes
	                fptiDataObj = fptiData._dataObj;
	                if (fptiDataObj) {
	                    pxpData = {
	                        qc: fptiDataObj.qc,
	                        qt: fptiDataObj.qt,
	                        xe: fptiDataObj.xe,
	                        xt: fptiDataObj.xt
	                    };
	                    $.extend(customData, pxpData);
	                }
	
	                // Logic to switch between production/staging urls. This way we don't pollute live logs,
	                // and we are able to test on stage using the fpti log viewing tool.
	                var _beaconUrl;
	                if ($config.deploy.isLocal() || $config.deploy.isStage()) {
	                    _beaconUrl = 'https://tracking.qa.paypal.com/webapps/tracking/ts'; // stage url
	                } else {
	                    _beaconUrl = $config.urls && $config.urls.fptiBeaconUrl;
	                }
	
	                analyticsInstance.setRequestData(customData);
	                analyticsInstance.recordClick({
	                    url: _beaconUrl
	                });
	            }
	        }
	
	        $rootScope.$on('trackInput', function (event, trackInput) {
	            if (!trackInput) {
	                return;
	            }
	            var customData = {
	                link: trackInput.transition,
	                page: trackInput.page
	            };
	
	            fptiCustomRecordClick(trackInput.currentRoute, customData);
	        });
	
	        $rootScope.$on('trackSubmit', function (event, trackSubmit) {
	            if (!trackSubmit) {
	                return;
	            }
	            var currentRoute = trackSubmit.currentRoute;
	            var routeName = currentRoute ? currentRoute.name : 'noRoute';
	
	            $logger.info('track_submit', {
	                route_name: routeName
	                // ID stuff here later
	            });
	
	            if (logTransition(currentRoute)) {
	                routeName = routeName.replace(/\./g, '_');
	                var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
	                var transition = trackSubmit.transition || state;
	
	                $logger.info(routeName + '_exit', {
	                    fptiState: state,
	                    fptiTransition: transition
	                });
	            }
	
	            var errors = trackSubmit.errors;
	            if (angular.isArray(errors)) {
	                errors.forEach(function (err) {
	                    $logger.debug('track_submit_error', err);
	                    if ($fpti) {
	                        $fpti.setupDataString(currentRoute, new $fptiError({
	                            type: 'fieldError',
	                            field: err.fieldName,
	                            code: err.errorMessage
	                        }));
	                    }
	                });
	
	                if (errors.length) {
	                    $logger.flush(true);
	                }
	            }
	        });
	
	        $rootScope.$on('unhandled_error', function (event, exception) {
	            if ($fpti) {
	                $fpti.setupDataString(exception.currentRoute, new $fptiError({
	                    type: 'pageError',
	                    message: exception.message,
	                    code: exception.cause
	                }));
	            }
	        });
	
	        $rootScope.$on('trackLink', function (event, trackLink) {
	            if (!trackLink) {
	                return;
	            }
	
	            var currentRoute = trackLink.currentRoute;
	            var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
	            var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
	
	            $logger.info(routeName + '_exit', {
	                fptiState: state,
	                fptiTransition: trackLink.transition
	            });
	        });
	
	        $rootScope.$on('$transition', function (event, data) {
	
	            $timeout(function () {
	                if ($fpti) {
	
	                    var $auth = $AuthModel.instance();
	
	                    var fptiData = $fpti.setupDataString(data.toState, null, {
	                        transition_time: data.duration,
	                        dc: $meta.dc,
	                        az: $meta.az,
	                        cust: $auth.buyer_id || ''
	                    });
	
	                    // Fire and forget button tracking beacon.
	                    $ButtonTrackingService.fireBeacon(fptiData);
	                }
	            });
	        });
	
	        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
	
	            var from = fromState.name.replace(/\./g, '_');
	            var to = toState.name.replace(/\./g, '_');
	            if (from && logTransition(fromState) && logStateExit(fromState)) {
	                var trackingData = fromState.trackingData && fromState.trackingData || {};
	                $logger.info(from + '_exit', { fptiState: trackingData.fptiState || from, fptiTransition: trackingData.fptiState || from });
	            }
	
	            $logger.info('state_change', {
	                from: from || 'start',
	                to: to || 'end'
	            });
	
	            $logger.flush(true);
	
	            // Generate a new CAL correlation_id to be shared until next flow transition (only for view states)
	            if (toState.template) {
	                $CalDataModel.generateMetaIds();
	            }
	
	            $rootScope.currentState = to;
	
	            if (to && logTransition(toState)) {
	                $logger.info(to + '_enter', { fptiState: toState.trackingData && toState.trackingData.fptiState || to });
	            }
	        });
	
	        $rootScope.$on('page_loaded', function (event, from, to) {
	            if (from !== 'checkout_init') {
	                return;
	            }
	            var key = $FptiConstants.stateName[to] || 'review';
	            var landing_page = $FptiConstants.landing_page[key];
	            $logger.info('landing_page', {
	                'from': landing_page,
	                'to': 'process_page_loaded',
	                fpti_landing_page: landing_page
	            });
	        });
	
	        $rootScope.$on('page_reloaded', function () {
	            $logger.flush(true);
	            $CalDataModel.generateMetaIds();
	        });
	
	        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
	            var to = toState.name.replace(/\./g, '_');
	            if (toState.hasResolver && to) {
	                $logger.info(to + '_load');
	            } else if (to) {
	                $logger.info(to + '_rendering');
	            }
	        });
	
	        $rootScope.$on('addrDiff', function (event, addrDiff) {
	            if (!addrDiff) {
	                return;
	            }
	
	            $logger.info('checkout_fpti', addrDiff);
	        });
	
	        function getHash(url) {
	            if (!url || !~url.indexOf('#')) {
	                // eslint-disable-line no-bitwise
	                return;
	            }
	
	            url = url.split('#');
	            return url[url.length - 1];
	        }
	
	        var oldHash = window.location.hash;
	
	        window.addEventListener('hashchange', function (event) {
	            $logger.info('hashchange', {
	                from: getHash(event.oldURL || oldHash),
	                to: getHash(event.newURL || window.location.hash)
	            });
	            oldHash = window.location.hash;
	        });
	
	        $(document).on('click', function (event) {
	            if (event && event.target && event.target.tagName) {
	                var name = event.target.tagName.toLowerCase();
	
	                if (event.target.id) {
	                    name += '#' + event.target.id;
	                } else if (event.target.attributes && event.target.attributes['ng-model']) {
	                    name += ':' + event.target.attributes['ng-model'].value;
	                } else if (event.target.className) {
	                    name += '.' + event.target.className.split(' ').join('.');
	                }
	
	                $logger.info('click', {
	                    el: name
	                });
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-tracking/dist/fpti.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-tracking/dist/builder.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('tracking.fpti', ['squid', 'tracking.builder']).factory('$fpti', function ($config, $FptiBuilder, $rootScope, $window, $util) {
	
	        var _beaconUrl;
	
	        // Logic to switch between production/staging urls. This way we don't pollute live logs,
	        // and we are able to test on stage using the fpti log viewing tool.
	        if ($config.deploy.isLocal() || $config.deploy.isStage()) {
	            _beaconUrl = 'https://tracking.qa.paypal.com/webapps/tracking/ts'; // stage url
	        } else {
	            _beaconUrl = $config.urls && $config.urls.fptiBeaconUrl;
	        }
	
	        // Get all the tracking data defined at the page level
	        function getPageTrackingData(route) {
	            route = route || {};
	
	            var trackingData = route.trackingData || {};
	            var routeParent = route.parent;
	
	            trackingData.token = $rootScope.token;
	
	            while (routeParent) {
	                trackingData = angular.merge({}, routeParent.trackingData || {}, trackingData);
	                routeParent = routeParent.parent;
	            }
	            return trackingData;
	        }
	
	        return {
	            setupDataString: function setupDataString(route, err, data) {
	
	                var trackingData = getPageTrackingData(route);
	                var fptiData;
	
	                var PAYPAL = window.PAYPAL;
	                if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
	                    PAYPAL.core = PAYPAL.core || {};
	
	                    var payload = {
	                        trackingData: trackingData,
	                        error: err,
	                        isInContext: $rootScope.miniBrowser
	                    };
	
	                    angular.extend(payload, data || {});
	
	                    fptiData = new $FptiBuilder(payload).build().toString();
	
	                    // FPTI client side tracking only if we have template
	                    if (route && route.template) {
	                        PAYPAL.core.pta = PAYPAL.analytics.setup({
	                            data: fptiData,
	                            url: _beaconUrl
	                        });
	                    }
	                }
	
	                return fptiData;
	            }
	        };
	    }).factory('$fptiError', function ($Error) {
	        function stringifyErrorMessage(msg) {
	            return encodeURIComponent(angular.isString(msg) ? msg.split('\n').slice(0, 2).join('@') // Get the first two lines of stack
	            : (angular.toJson(msg) || 'undefined').substring(0, 128));
	        }
	
	        return $Error.extend({
	            construct: function construct(err) {
	                if (!err) {
	                    return;
	                }
	                this.type = err.type;
	                this.field = err.field;
	                this.msg = stringifyErrorMessage(err.message || err.error);
	                this.code = err.code || err.cause;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/fpti.js"))

/***/ },

/***/ "./components/xo-tracking/dist/builder.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-tracking/dist/model.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('tracking.builder', ['squid', 'tracking.model']).factory('$FptiBuilder', function ($Class, $locale, $rootScope, $FptiConstants, $FptiDataModel, $CalDataModel, $util, $getLatestCorrelationID) {
	        /**
	         *  Build the front-end FPTI event from three data sources
	         *      1. the per-product configuration
	         *      2. the buzname defined per-route
	         *      3. the additional attributes that only available at a specific checkpoint
	         *
	         */
	
	        return $Class.extend('FptiBuilder', {
	
	            resolvePageQualifier: function resolvePageQualifier(trackingData) {
	                // The pages can populated pageQualifier to override the default one
	                this.pageQualifier = trackingData && trackingData.pageQualifier ? trackingData.pageQualifier
	                // because 'fullpage' has been widely embedded into routes
	                // we had better to keep it as a place holder
	                : 'fullpage'; // update later if it's in-context
	            },
	
	            build: function build() {
	
	                if (!this.trackingData && !this.error) {
	                    // do nothing if neither page nor error tracking
	                    return this;
	                }
	
	                this.resolvePageQualifier(this.trackingData);
	
	                this._dataObj = new $FptiDataModel().decorate('buzname', this.trackingData, this.pageQualifier).decorate('templateName', this.trackingData, this.pageQualifier).decorate('locale', $locale).decorate('pageGoal', this.trackingData.pageGoal).decorate('ecToken', this.trackingData.token).decorate('correlationId', $getLatestCorrelationID()).decorate('uuid', $CalDataModel.getUUID()).decorate('fieldError', this.error).decorate('pageError', this.error).decorate('pageStartTime', new Date().getTime()).decorate('pxptrackingdata', this.trackingData.pxpData).decorate('transition_time', this.transition_time).decorate('cust', this.cust).decorate('dc', this.dc).decorate('az', this.az).getDataObject(this.isInContext);
	
	                return this;
	            },
	
	            toString: function toString() {
	
	                var dataAry = [];
	                angular.forEach(this._dataObj, function (v, k) {
	                    dataAry.push(k + '=' + v);
	                });
	
	                return dataAry.join('&');
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/builder.js"))

/***/ },

/***/ "./components/xo-tracking/dist/button.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('button.tracking', ['squid', 'xomodel.checkout']).factory('$ButtonTrackingService', function ($rootScope, $http, $populate, $CheckoutAppDataModel, $CheckoutPayeeModel, $meta, $cookies) {
	
	        var _beaconUrl = 'https://www.paypalobjects.com/en_US/i/scr/btn_tracking_pixel.gif?teal=null&Id=null&ru=null';
	        var _beaconParams = ['fltk', 'calc', 'page', 'xe', 'xt'];
	        var _alreadyFired = false;
	
	        function _strToElements(str) {
	            var elements = {};
	            if (str && str.length) {
	                str.split('&').forEach(function (param) {
	                    var nvp = param.split('=');
	                    elements[nvp[0]] = nvp[1];
	                });
	            }
	            return elements;
	        }
	
	        function _fireButtonTrackingBeacon(elements) {
	            var url = _beaconUrl;
	            var xoData = {};
	
	            function buildParam(param, value) {
	                var p = '&' + param + '=' + (value ? value : 'null');
	                return p;
	            }
	
	            function getGUIID(ts) {
	                return _strToElements(ts).vr;
	            }
	
	            function addToDocument(uri) {
	                var img = document.createElement('img');
	                img.setAttribute('src', uri);
	                document.body.appendChild(img);
	            }
	
	            // Get some params from FPTI data.
	            _beaconParams.forEach(function (param) {
	                url += buildParam(param, elements[param]);
	            });
	
	            // Build the rest of the params.
	            url += buildParam('fpti', getGUIID($cookies && $cookies.ts));
	            url += buildParam('WWW_AKA_MVT_BUTTONS', $cookies && $cookies.WWW_AKA_MVT_BUTTONS);
	            url += buildParam('WWW_AKA_MVT_ID', $cookies && $cookies.WWW_AKA_MVT_ID);
	            url += buildParam('ip', $meta && $meta.ipaddress);
	
	            if ($rootScope.token) {
	                $populate(xoData, {
	                    payee: $CheckoutPayeeModel.instance($rootScope.token),
	                    appData: $CheckoutAppDataModel.instance($rootScope.token)
	                }).then(function () {
	                    url += buildParam('mrid', xoData.payee && xoData.payee.getId());
	                    url += buildParam('calf', xoData.appData && xoData.appData.flow_id);
	
	                    addToDocument(url);
	                });
	            } else {
	                url += buildParam('mrid', null);
	                url += buildParam('calf', null);
	                addToDocument(url);
	            }
	        }
	
	        return {
	            fireBeacon: function fireBeacon(fptiData) {
	                if (!_alreadyFired && fptiData) {
	                    var elements = _strToElements(fptiData);
	
	                    // Fire the beacon if this is a page render.
	                    if (elements.page) {
	                        _alreadyFired = true;
	                        return _fireButtonTrackingBeacon(elements);
	                    }
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/button.js"))

/***/ },

/***/ "./components/xo-tracking/dist/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular) {
	
	    angular.module('tracking.directive', ['ui.router']).directive('trackSubmit', function ($state, $rootScope) {
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('mousedown', function (event) {
	                    var transition = attr && attr.trackSubmit;
	
	                    var trackSubmit = {
	                        currentRoute: $state.current,
	                        transition: transition,
	                        errors: []
	                    };
	                    angular.forEach($('input.ng-invalid, select.ng-invalid'), function (el) {
	                        var modelName = $(el).attr('ng-model');
	                        var errorText = $(el).attr('data-error-text');
	                        trackSubmit.errors.push({
	                            fieldName: modelName ? modelName : 'no-model',
	                            errorMessage: errorText ? errorText : // eslint-disable-line no-nested-ternary
	                            $(el).has('required') ? 'required' : 'no error text'
	                        });
	                    });
	
	                    $rootScope.$broadcast('trackSubmit', trackSubmit);
	                });
	            }
	        };
	    }).directive('trackLink', function ($state, $rootScope) {
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('mousedown', function (event) {
	
	                    var state = attr && attr.trackLink;
	
	                    if (state) {
	                        var trackLink = {
	                            currentRoute: $state.current,
	                            transition: state
	                        };
	                        $rootScope.$broadcast('trackLink', trackLink);
	                    }
	                });
	            }
	        };
	    }).directive('trackInput', function ($state, $rootScope) {
	        /*
	         * Track an input tag with track-input attribute
	         * you can use the value of track-input attribute as
	         * a tracking attr Eg.: track-input="xo_guest_yes"
	         */
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('click', function (event) {
	
	                    var state;
	
	                    if (event.target.type === 'checkbox') {
	                        if (event.target.checked) {
	                            state = attr && attr.trackInput + '_CHECKED';
	                        } else {
	                            state = attr && attr.trackInput + '_UNCHECKED';
	                        }
	                    } else {
	                        state = attr && attr.trackInput;
	                    }
	
	                    var trackInput = {
	                        currentRoute: $state.current,
	                        page: 'main:ec:hermes::fullpage-billing:guest:aries:'
	                    };
	
	                    if (state) {
	                        trackInput.transition = state;
	                    }
	
	                    $rootScope.$broadcast('trackInput', trackInput);
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./pages/xo-landing/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$LandingRoute = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	__webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-models/src/auth/index.js");
	
	__webpack_require__("./components/xo-models/src/shippingMethod/index.js");
	
	__webpack_require__("./components/xo-models/src/inventory/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('$LandingRoute', {
	
	    path: 'landing',
	
	    trackingData: {
	        fptiState: 'landing',
	        trackStateExit: true
	    },
	
	    auth: false,
	
	    resolve: {
	
	        action: function action($window, $feature, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutPayeeModel, $ShippingRuleSummaryModel, $Class, $experiment, $rootScope, $state, $populate, $logger, $q, $config, $AuthModel, $FallbackError, $util, $dispatch, $locale, $pxp, $InventoryModel, $InstallmentOptionsModel, $CreditDataModel, $FlowEligibilityModel) {
	
	            var models = {};
	
	            return $populate(models, {
	                checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
	                checkoutCart: $CheckoutCartModel.instance($rootScope.token),
	                auth: $AuthModel.instance(),
	                checkoutPayeeModel: $CheckoutPayeeModel.instance($rootScope.token),
	                flowEligibility: $FlowEligibilityModel.instance($rootScope.token).retrieve({
	                    params: {
	                        localeCountry: $locale.country // We need this till we completely migrate to server side locale resolution
	                    }
	                })
	            }).then(function () {
	                var forced_signup_offered = models.flowEligibility.guest ? 0 : 1;
	                $logger.info('checkout_fpti', { 'from': 'LANDING_PAGE_PARAM', 'forced_signup_offered': forced_signup_offered });
	
	                var landingFlow = function landingFlow() {
	                    var merchantCountry = models.checkoutAppData.get('merchant.merchant_country', 'US');
	                    var supportBlockNonDomesticShipping = $feature('supportBlockNonDomesticShipping', false, merchantCountry);
	                    var prefillShippingAddress = models.checkoutCart.get('purchase.shipping_address');
	                    var blockNonDomesticShipping = models.checkoutAppData.get('flags.block_non_domestic_shipping');
	                    var allowChangeShipping = models.checkoutAppData.get('flags.allow_change_shipping');
	
	                    if (supportBlockNonDomesticShipping && blockNonDomesticShipping) {
	                        $logger.info('block_non_domestic_shipping', {
	                            block_non_domestic_shipping: blockNonDomesticShipping,
	                            allow_change_shipping: allowChangeShipping,
	                            setec_shipping_country_code: prefillShippingAddress
	                        });
	                    }
	
	                    var shouldBlockBuyer = supportBlockNonDomesticShipping && blockNonDomesticShipping && !allowChangeShipping && prefillShippingAddress && prefillShippingAddress.country_code !== merchantCountry && prefillShippingAddress.country_code !== '';
	
	                    if (shouldBlockBuyer) {
	                        return {
	                            to: 'checkout.genericError',
	                            params: {
	                                code: 'BLOCK_NON_DOMESTIC_SHIPPING'
	                            }
	                        };
	                    }
	
	                    if (models.checkoutAppData.is_second_button_txn) {
	                        var creditDataModel;
	                        var isCapeReturnKey;
	                        var isChangeInstallments;
	                        var offers;
	                        var installmentOptions;
	                        var isInstallmentEligible;
	
	                        var _ret = function () {
	                            creditDataModel = $CreditDataModel.instance($rootScope.token);
	                            isCapeReturnKey = creditDataModel.getCapeKey();
	                            isChangeInstallments = creditDataModel.isChangeStatus();
	                            offers = $InstallmentOptionsModel.instance($rootScope.token);
	                            isInstallmentEligible = models.flowEligibility.installment;
	
	                            var country = models.checkoutAppData.get('merchant.merchant_country');
	                            return {
	                                v: offers.save({
	                                    data: {
	                                        payee: models.checkoutPayeeModel,
	                                        checkoutCart: models.checkoutCart,
	                                        checkoutAppData: models.checkoutAppData,
	                                        isMemberCredit: true
	                                    },
	                                    success: function success(result) {
	                                        installmentOptions = result && result.installments && result.installments[0] && result.installments[0].installment_options && result.installments[0].installment_options.length > 0;
	
	                                        if (isCapeReturnKey) {
	                                            return 'checkout.login';
	                                        } else if (country === 'GB' || isInstallmentEligible && (installmentOptions && isChangeInstallments || installmentOptions)) {
	                                            $logger.info('ppc_second_btn_acquisition');
	                                            return 'checkout.chooseCreditOffer';
	                                        } else {
	                                            $logger.info('ppc_second_btn_resuse');
	                                            return 'checkout.login';
	                                        }
	                                    },
	                                    contingencies: {
	                                        DEFAULT: function DEFAULT(name, err) {
	                                            // Check error message === currencyNotCompatible
	                                            return 'checkout.login';
	                                        }
	                                    }
	                                })
	                            };
	                        }();
	
	                        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	                    }
	
	                    return 'checkout.login';
	                };
	
	                var cartHasInventory = models.checkoutCart.get('cartHasInventory');
	                if ($config.enableInventoryWPS && cartHasInventory) {
	                    var inventoryModel = $InventoryModel.instance($rootScope.token);
	                    var inventoryInput = {
	                        items: models.checkoutCart.get('purchase.items'),
	                        merchantId: models.checkoutPayeeModel.getId()
	                    };
	                    return inventoryModel.action('getInventory', {
	                        data: inventoryInput,
	                        success: function success(inventoryResponse) {
	                            if (inventoryResponse.showSoldoutPage) {
	                                return {
	                                    to: 'checkout.soldout',
	                                    params: {
	                                        items: encodeURIComponent(inventoryResponse.soldoutItems),
	                                        soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
	                                    }
	                                };
	                            } else {
	                                inventoryModel.setInvetoryItems(inventoryResponse);
	                                return landingFlow();
	                            }
	                        }
	                    });
	                } else {
	                    return landingFlow();
	                }
	            });
	        }
	    }
	});
	
	angular.value("$LandingRoute", $LandingRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./components/xo-models/src/shippingMethod/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.shippingMethod', ['squid']).factory('$ShippingMethodModel', function ($Model, $Api) {
	        return $Model.extend('ShippingMethodModel', {
	            api: new $Api({
	                uri: '/api/shippingtax/charges'
	            }),
	
	            getShippingMethodId: function getShippingMethodId(shippingMethodType) {
	                var shippingMethodsMap = {
	                    DEFAULT: '0',
	                    AIR_SERVICE: '1',
	                    ECONOMY: '2',
	                    EXPEDITED_AIR_SERVICE: '3',
	                    EXPEDITED_FLAT_RATE_SHIPPING: '4',
	                    EXPRESS: '5',
	                    EXPRESS_DOMESTIC: '6',
	                    FREE_SHIPPING: '7',
	                    GROUND: '8',
	                    GLOBAL_PRIORITY: '9',
	                    INTERNATIONAL_ECONOMY: '10',
	                    INTERNATIONAL_EXPEDITED: '11',
	                    INTERNATIONAL_EXPRESS: '12',
	                    INTERNATIONAL_EXPRESS_AIR: '13',
	                    INTERNATIONAL_PRIORITY_AIR: '14',
	                    NEXT_DAY: '15',
	                    NEXT_DAY_AIR: '16',
	                    NEXT_DAY_AIR_ECONOMY: '17',
	                    ONE_DAY_SHIPPING: '18',
	                    OVERNIGHT: '19',
	                    OVERNIGHT_FLAT_RATE_SHIPPING: '20',
	                    PICKUP: '21',
	                    PRIORITY: '22',
	                    RUSH_DELIVERY: '23',
	                    STANDARD_DOMESTIC: '24',
	                    STANDARD_EXPEDITED: '25',
	                    STANDARD_FLAT_RATE_SHIPPING: '26',
	                    STANDARD_INTERNATIONAL: '27',
	                    STANDARD_SHIPPING: '28',
	                    STORE_PICKUP: '29',
	                    TWO_DAY_SHIPPING: '30',
	                    WORLDWIDE_SHIPPING: '31',
	                    TWO_DAY_AIR: '32'
	                };
	
	                return shippingMethodsMap[shippingMethodType];
	            },
	
	            isStorePickUp: function isStorePickUp(shipping_method_type) {
	                return shipping_method_type === 'STORE_PICKUP' || shipping_method_type === 'PICKUP';
	            }
	        });
	    }).factory('$ShippingRuleSummaryModel', function ($Model, $Api) {
	        return $Model.extend('ShippingRuleSummaryModel', {
	            api: new $Api({
	                uri: '/api/shippingtax/:id/rulesSummary'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/shippingMethod", "components/xo-models/src/shippingMethod/index.js"))

/***/ },

/***/ "./components/xo-models/src/inventory/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.inventory', ['squid']).factory('$InventoryModel', function ($Model, $Api) {
	        return $Model.extend('$InventoryModel', {
	            api: new $Api({
	                uri: '/api/catalog/:id/item/',
	                postAttempts: 2,
	                cache: true
	            }),
	
	            setInvetoryItems: function setInvetoryItems(inventoryItems) {
	                this.inventoryItems = inventoryItems;
	            },
	
	            getInventoryItems: function getInventoryItems() {
	                return this.inventoryItems;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/inventory", "components/xo-models/src/inventory/index.js"))

/***/ },

/***/ "./pages/xo-login/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$LoginRoute = undefined;
	
	__webpack_require__("./pages/xo-login/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $LoginRoute = exports.$LoginRoute = _squid.$ComponentRoute.extend('$LoginRoute', {
	
	    path: 'login',
	
	    directive: 'xo-login-page',
	
	    params: {
	        targetPage: null,
	        source: null,
	        showNotYou: null
	    },
	
	    auth: false,
	
	    titleContent: 'base.logIn',
	
	    trackingData: {
	        fptiState: 'login',
	        suppressTransitionLog: true, // We will be suppressing the Server Side Tracking for this page
	        templateName: 'login.dust',
	        pageGoal: 'Payment Start',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-login',
	                'pagename2': '%::fullpage-login:member:hermes:',
	                'version': 'member:%:'
	            },
	            'ulLogin': {
	                'pagename': '%::fullpage-ullogin',
	                'pagename2': '%::fullpage-ullogin:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	
	    children: []
	});
	
	angular.value("$LoginRoute", $LoginRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-login/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$xoLoginPageComponent = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	var _template = __webpack_require__("./pages/xo-login/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./js/lib/index.js");
	
	__webpack_require__("./pages/xo-login/loginEligibility.js");
	
	__webpack_require__("./pages/xo-login/onboarding/directive.js");
	
	__webpack_require__("./pages/xo-login/util.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-models/src/app/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	__webpack_require__("./components/xo-title/dist/directive.js");
	
	__webpack_require__("./components/xo-login-components/src/login/handler/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/language-options/directive.js");
	
	__webpack_require__("./components/xo-login-components/src/unified-login/directive.js");
	
	__webpack_require__("./components/xo-device-info/dist/index.js");
	
	__webpack_require__("./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");
	
	__webpack_require__("./pages/xo-landing/route.js");
	
	__webpack_require__("./components/xo-ui-components/src/card-loader/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoLoginPageComponent = exports.$xoLoginPageComponent = _squid.$Component.extend('$xoLoginPageComponent', {
	    tag: 'xo-login-page',
	    template: _template2['default'],
	    scope: {
	        token: '='
	    },
	    link: function link($scope) {
	        _logger.$logger.info('login_link');
	    },
	    lifecycle: {
	        populate: function populate() {
	            var $scope = this;
	            (0, _squid.$populate)($scope, {
	                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
	            }).then(function () {
	
	                var country = $scope.checkoutAppData.merchant.merchant_country;
	                (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment').then(function (result) {
	                    var treatmentName = result && result.treatment_name || '';
	                    if (treatmentName) {
	                        _logger.$logger.info('xo_hermesnode_hide_cart_logo_treatment');
	                        $('.cartContainer').hide();
	                        $('.merchantHeader > .headerWrapper').hide();
	                    }
	                });
	            });
	        },
	        exit: function exit() {
	
	            var $scope = this;
	            (0, _squid.$populate)($scope, {
	                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
	            }).then(function () {
	
	                var country = $scope.checkoutAppData.merchant.merchant_country;
	                (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment').then(function (result) {
	                    var treatmentName = result && result.treatment_name || '';
	                    if (treatmentName) {
	                        $('.cartContainer').show();
	                        $('.merchantHeader > .headerWrapper').show();
	                    }
	                });
	            });
	        }
	    },
	
	    rootEvents: {
	        allLoaded: function allLoaded() {
	            if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
	                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
	                    if (window.paypalCheckout) {
	                        _uiRouter.$state.go('checkout.framebust', { action: 'open', url: window.location.href.split('#')[0] });
	                    } else {
	                        return _miniBrowser.$miniBrowser.frameBust(this.props.token);
	                    }
	                } else {
	                    throw _integration.$integration.error('Can not framebust');
	                }
	            }
	        }
	    },
	
	    controller: function controller($scope, $FallbackError, $window, $location, $locale, // eslint-disable-line no-shadow
	    $FlowEligibilityModel, $CheckoutSessionModel, $BuyerEligibilityModel, $EConsentModel, $AuthModel, $feature, // eslint-disable-line no-shadow
	    $AppDataModel, $config, $logger, // eslint-disable-line no-shadow
	    $q, $pxp, // eslint-disable-line no-shadow
	    $pxpFactors, $timeout, $util, // eslint-disable-line no-shadow
	    $experiment, $loginEligibility, $dispatch, $DeviceInfo, $KmliUpsell, $ReturnToMerchant, $meta, $stateParams, $CheckoutCartModel, $CreditDataModel, $capeRedirectUtil) {
	
	        $logger.info('login_controller');
	
	        var fptiHardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];
	
	        $scope.ulEligibility = false;
	        $scope.useTokenizationAnimation = false;
	
	        /* If we detect a back/forward button click to land on the app, do not auto-login. In this case, the buyer
	         is attempting to navigate to a specific page, so we should not auto-redirect them.
	          This also fixes an issue with users:
	         - Authorizing the checkout session
	         - Redirecting to the merchant
	         - Hitting back and landing on login page
	         - Calling create on checkout and overwriting the authorization
	         - Hitting forward and landing again on merchant page
	         */
	
	        if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
	            _angular.$rootScope.forceLogin = true;
	        }
	
	        if (!_angular.$rootScope.forceLogin) {
	            $scope.autoLogin = true;
	        }
	
	        _angular.$rootScope.forceLogin = true;
	
	        $scope.hideGuest = $stateParams.targetPage === 'PAYER_AUTHENTICATION_REQUIRED' || $stateParams.showNotYou;
	        $scope.promptlogin = $scope.hideGuest && !$feature('riskyLoginContingency');
	
	        // log statement for mobile webview
	        if ($DeviceInfo.isApp()) {
	            $logger.debug('HERMES_IN_MOBILE_WEBVIEW');
	        }
	
	        if (!_miniBrowser.$miniBrowser.isMiniBrowser() && $locale.country === 'BR') {
	            var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_login_design;
	
	            $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
	                $scope.loginDesignExp = result;
	            });
	        }
	
	        var ROUTE_MAPPING = {
	            ECONSENT_REQUIRED: 'checkout.econsent'
	        };
	
	        $scope.onContingency = function (name, contingency) {
	
	            if (!ROUTE_MAPPING[name]) {
	                throw new $FallbackError({
	                    reason: name.toLowerCase(),
	                    product: 'ux'
	                });
	            }
	
	            _uiRouter.$state.go(ROUTE_MAPPING[name]);
	        };
	
	        $scope.isWPS = _angular.$rootScope.wps; // used in template. do not remove
	        $scope.buyerEligibility = $BuyerEligibilityModel.instance($scope.token);
	        $scope.checkoutSession = $CheckoutSessionModel.instance($scope.token);
	        $scope.eConsent = $EConsentModel.instance($scope.token);
	
	        // Temporary light eligibility check for tokenized wallet flow.
	        function isWalletTokenizationEligible() {
	            // Only US buyer is eligible for tokenized wallet.
	            if ($scope.auth.country === 'US') {
	                return true;
	            }
	            return false;
	        }
	
	        $scope.setBuyer = function () {
	
	            var fptiData = {
	                from: 'CREATE_XO_SESSION',
	                to: 'process_create_xo_session'
	            };
	
	            $logger.info('checkout_fpti', {
	                from: 'CREATE_XO_SESSION',
	                to: 'prepare_create_xo_session'
	            });
	
	            $scope.useTokenizationAnimation = $scope.checkoutCart.isWalletTokenization();
	            if ($scope.useTokenizationAnimation) {
	                _angular.$rootScope.$emit('allLoaded');
	
	                $scope.setbuyerProgress = 'notStarted';
	                $logger.info('tokenized_wallet', {
	                    'from': 'adding_pp_ap_animation',
	                    'to': 'prepare_adding_pp_ap_animation',
	                    'context_id': $scope.token,
	                    'context_type': 'EC-Token',
	                    'ba_token': $meta.baToken
	                });
	
	                $timeout(function () {
	                    $scope.setbuyerProgress = 'pending'; // sets animation state to 80%
	                    $logger.info('tokenized_wallet', {
	                        'from': 'adding_pp_ap_animation',
	                        'to': 'process_adding_pp_ap_animation',
	                        'context_id': $scope.token,
	                        'context_type': 'EC-Token',
	                        'ba_token': $meta.baToken
	                    });
	                }, 300);
	            }
	
	            $scope.eConsent.retrieve({
	                batch: {
	                    name: 'setbuyer',
	                    silent: $scope.useTokenizationAnimation,
	                    id: 'eConsent',
	                    dependencies: $scope.ulEligibility ? ['securityCtx'] : []
	                },
	                contingencies: {
	                    ECONSENT_REQUIRED: function ECONSENT_REQUIRED(name, err) {
	                        $logger.debug('ULLOGIN_ECONSENT_REQUIRED');
	                        _uiRouter.$state.go('checkout.econsent');
	                    }
	                }
	            });
	
	            $scope.buyerEligibility.retrieve({
	                batch: {
	                    name: 'setbuyer',
	                    id: 'buyerEligibility',
	                    silent: $scope.useTokenizationAnimation,
	                    dependencies: ['eConsent']
	                },
	                success: function success(result) {
	                    $logger.info(result.eligible ? 'buyer_eligible' : 'buyer_ineligible');
	
	                    if ($config.blockStudentAccount && $scope.auth.student_account) {
	                        $logger.info('stop_fallback_for_student_account');
	                        return;
	                    }
	
	                    if ($scope.checkoutCart.isWalletTokenization() && !isWalletTokenizationEligible()) {
	                        var msg = 'ineligible_tokenized_wallet_' + $scope.auth.country + '_account';
	                        $logger.info(msg);
	
	                        // ANDROID_PAY_ELIGIBILITY_ERROR is currently mapped to generic error.  We need adapted/
	                        // localized content for eligibility error.  Mapping needs to be updated once we have
	                        // adpated and localized content.
	                        _uiRouter.$state.go('checkout.genericError', {
	                            code: 'ANDROID_PAY_ELIGIBILITY_ERROR'
	                        });
	                    }
	
	                    if (result.clearedRT) {
	                        $logger.info('checkout_fpti', {
	                            from: 'CONTINGENCY',
	                            to: 'process_fallback',
	                            routing_reason: 'BUYER_INELIGIBLE'
	                        });
	                    }
	
	                    if (!result.eligible) {
	                        throw new $FallbackError({
	                            reason: 'buyer_ineligible',
	                            product: 'ux'
	                        });
	                    }
	                }
	            });
	
	            $scope.checkoutSession.action('create', {
	                data: {
	                    baToken: $scope.checkoutCart.billing && $scope.checkoutCart.billing.ba_token,
	                    preselected_fi_type: $scope.checkoutAppData.is_second_button_txn ? 'credit' : undefined
	                },
	                batch: {
	                    name: 'setbuyer',
	                    id: 'createCheckoutSession',
	                    silent: $scope.useTokenizationAnimation,
	                    dependencies: ['eConsent', 'buyerEligibility']
	                },
	                success: function success(result) {
	                    $logger.info('checkout_fpti', fptiData);
	
	                    if ($config.blockStudentAccount && $scope.auth.student_account) {
	                        $logger.info('blocking_student_account');
	                        _uiRouter.$state.go('checkout.genericError', {
	                            code: 'STUDENT_ACCOUNT'
	                        });
	                        return;
	                    } else if (!$scope.buyerEligibility.eligible) {
	                        return;
	                    } else if ($scope.checkoutCart.isWalletTokenization() && !isWalletTokenizationEligible()) {
	                        return;
	                    }
	
	                    if ($scope.auth.password_less && $scope.checkoutCart.isBilling()) {
	                        if ($feature('pomaPasswordRecovery')) {
	                            _uiRouter.$state.go('checkout.createPassword', { targetPage: 'BILLING_AGREEMENTS' });
	                        }
	                        return;
	                    }
	
	                    if ($scope.checkoutAppData.is_second_button_txn) {
	                        return $capeRedirectUtil.handleCapeRouting(result, $scope.token);
	                    }
	
	                    return $KmliUpsell.eligible($scope.token).then(function (isEligible) {
	                        if (isEligible.eligible) {
	
	                            var stateName = isEligible.type === 'member' ? 'KMLI_UPSELL' : 'KMLI_reactivation';
	
	                            $logger.info('checkout_fpti', {
	                                from: stateName,
	                                to: 'prepare_kmli_upsell'
	                            });
	
	                            var path = $DeviceInfo.isMobile() ? 'checkout.FullpageOnetouchUpsell' : 'checkout.review.oneTouchUpsell';
	
	                            return _uiRouter.$state.go(path, { oneTouchFlowName: 'checkout' });
	                        }
	
	                        if ($scope.auth.rtExchanged && $feature('rmSpinnerText')) {
	                            $scope.checkoutSession.message = {
	                                type: 'success',
	                                msgKeys: ['login.loggedInWithOneTouch']
	                            };
	                        }
	
	                        if ($scope.checkoutSession.negBals) {
	                            return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
	                        }
	
	                        if ($scope.checkoutCart.isWalletTokenization()) {
	                            $logger.info('tokenized_wallet', {
	                                'from': 'PP_AndroidPay_Info',
	                                'to': 'prepare_PP_AndroidPay_Info',
	                                'context_id': $scope.token,
	                                'context_type': 'EC-Token',
	                                'ba_token': $meta.baToken
	                            });
	                            $timeout(function () {
	                                return _uiRouter.$state.go('checkout.tokenizationInfo');
	                            }, 1200);
	                        } else {
	                            _uiRouter.$state.go('checkout.review');
	                        }
	                    });
	                },
	                contingencies: {
	                    // override contingency.js handler with custom logic to support both xoon/hermes flows
	                    NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, err) {
	                        // come from guest or have alternate FI options, go to review
	                        if ($util.param('redirectToHermesOnUpopCancel') === 'xoon' || err && err.resolution && err.resolution.data && err.resolution.data.alternate_options) {
	                            _uiRouter.$state.go('checkout.review');
	                        } else {
	                            // else go to addCard
	                            _uiRouter.$state.go('checkout.updateCard.addCardFlow.addCard');
	                        }
	                    },
	                    DEFAULT: function DEFAULT(name, err) {
	                        fptiData.int_error_code = err.cause;
	                        fptiData.error_source = 'paymentapiplatformserv';
	                        fptiData.error_type = fptiHardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
	                        $logger.info('checkout_fpti', fptiData);
	                        throw err;
	                    }
	                }
	            });
	        };
	
	        // Sorry for the indirection here.  There's postAuth, so "preAuth" compliments it well (easier on the brain)
	        $scope.preAuth = function () {
	
	            // For UL, batch up eConsent, buyerEligibility, xoSession
	            if ($scope.ulEligibility) {
	                $scope.setBuyer();
	            }
	        };
	
	        $scope.onSuccess = function () {
	
	            // If the experiment is enabled, we already have what we need, so /quit.
	            if ($scope.ulEligibility) {
	                return;
	            }
	
	            $scope.setBuyer();
	        };
	
	        function fetchGuestButtonPxpVarients() {
	            $scope.guestVariant = {};
	            // PXP for showing Guest button Call-To-Actions
	            return $pxp('xo_hermesnode_guest_cta', {
	                'ctx.COUNTRY': $locale.country
	            }, '(xo_hermesnode_guest_cta_)(.*)').then(function (result) {
	                var treatmentName = result && result.treatment_name || '';
	
	                switch (treatmentName) {
	                    case 'xo_hermesnode_guest_cta_standard_label_treatment':
	                        $scope.guestVariant.standardGuestBtn = true;
	                        $scope.guestVariant.test = true;
	                        break;
	                    case 'xo_hermesnode_guest_cta_card_icons_treatment':
	                        $scope.guestVariant.cardIconsAboveGuestBtn = true;
	                        $scope.guestVariant.test = true;
	                        break;
	                    default:
	                    // Do nothing
	                }
	            });
	        }
	
	        (0, _squid.$populate)($scope, {
	            flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
	                params: {
	                    geolocation: $meta.geolocation,
	                    localeCountry: $locale.country // We need this till we completely migrate to server side locale resolution
	                }
	            }),
	            auth: $AuthModel.instance(),
	            checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
	            checkoutCart: $CheckoutCartModel.instance(_angular.$rootScope.token)
	        }).then(function () {
	            if ($scope.flowEligibility.guest) {
	                return fetchGuestButtonPxpVarients();
	            }
	            $('.paypalHeaderWrapper').removeClass('paypalCredit');
	            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
	        }).then(function () {
	            if ($scope.auth.accessToken()) {
	                return $scope.auth.reload({
	                    headers: {
	                        'x-paypal-internal-euat': $scope.auth.accessToken()
	                    },
	                    resultModel: $scope.auth,
	                    success: function success() {
	                        delete $scope.auth.access_token;
	                    },
	                    contingencies: {
	                        DEFAULT: function DEFAULT(name) {
	                            throw new $FallbackError({
	                                reason: name.toLowerCase(),
	                                product: 'ux'
	                            });
	                        }
	                    }
	                });
	            }
	        }).then(function () {
	            return $loginEligibility($scope.token, !$scope.autoLogin).then(function (result) {
	                if (result === 'unifiedLogin') {
	                    $scope.ulEligibility = true;
	                } else if (result === 'apsIntegration') {
	                    $scope.apsIntegration = 'apsIntegration';
	                } else if (result === 'apsIntegrationRM') {
	                    $scope.apsIntegration = 'apsIntegrationRM';
	                }
	            }).then(function () {
	
	                var reinitDisplay = function reinitDisplay() {
	                    $scope.promptlogin = false;
	                    $scope.hideGuest = false;
	                    $scope.autoLogin = true;
	                    delete $stateParams.targetPage;
	                    delete $stateParams.showNotYou;
	                };
	
	                $scope.logout = $scope.promptlogin ? function () {
	                    $logger.info('not_you_logout');
	                    $logger.info('checkout_fpti', {
	                        from: 'LOGIN_UL',
	                        to: 'login_with_diff_user'
	                    });
	                    $scope.auth.action('logout').then(function () {
	                        $scope.auth.reload().then(function () {
	                            reinitDisplay();
	                            $scope.reload();
	                        });
	                    });
	                } : function () {
	                    $logger.info('logout_switch_display');
	                    reinitDisplay();
	                };
	            });
	        });
	    }
	});
	
	angular.value("$xoLoginPageComponent", $xoLoginPageComponent);
	_angular.$rootScope;
	
	_miniBrowser.$miniBrowser;
	
	_integration.$integration;
	
	_squid.$Component;
	
	_squid.$pxp;
	
	_squid.$populate;
	
	_logger.$logger;
	
	_index.$CheckoutAppDataModel;
	
	_uiRouter.$state;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./pages/xo-login/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"login\"\n         ng-class=\"{standardGuestBtn: guestVariant.standardGuestBtn, guestBtnOnTop: guestVariant.guestBtnOnTop, cardIconsAboveGuestBtn: guestVariant.cardIconsAboveGuestBtn}\"\n         id=\"login\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n\n            <xo-login-handler token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\"\n                              contingency-callback=\"onContingency\" ul-eligibility=\"ulEligibility\" pre-auth=\"preAuth\"\n                              aps-integration=\"apsIntegration\" batch=\"batch\"\n                              login-submit=\"loginSubmit\" flowcontext=\"flowcontext\" logout=\"logout\" export=\"loginHandler\"></xo-login-handler>\n\n            <div ng-if=\"promptlogin\" class=\"centerText\">\n                <hr class=\"sepPlain\" />\n\n                <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout(auth)\" class=\"ng-binding\" tabindex=\"0\">{{ content('memberReview.notYou')}}</a>\n            </div>\n\n            <xo-onboarding-section token=token is-wps=isWPS\n                                   guest-variant=guestVariant ng-hide=\"hideGuest\"></xo-onboarding-section>\n\n        </div>\n        <div class=\"span10\" ng-if=\"!loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\"\n                            text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" ng-if=\"loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content(loginDesignExp.propHeader)}}\"\n                            text-content=\"{{loginDesignExp.propText}}\"\n                            image-url=\"{{loginDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n    <div class=\"infoLoader\"  ng-if='useTokenizationAnimation'>\n        <div class='logo_wrapper'>\n            <div class='partner_logo'></div>\n        </div>\n        <div class=\"loader\">\n            <xo-card-loader state=\"setbuyerProgress\" email=\"auth.email\" message=\"{{content('topup.addingAndroidPay')}}\"></xo-card-loader>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-login/loginEligibility.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$forceLoginExperience = $forceLoginExperience;
	exports.$loginEligibility = $loginEligibility;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _index3 = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	function $forceLoginExperience(auth, merchant_country, forcedLogin) {
	    var ULParam = _squid.$util.param('ul');
	
	    if (auth.loggedIn() && !auth.stepupAuthRequired && !forcedLogin) {
	        return {
	            experience: 'apsIntegration',
	            reason: 'sessionActive'
	        };
	    } else if (ULParam === '0' && !_squid.$config.deploy.isLive()) {
	        return {
	            experience: 'apsIntegration',
	            reason: 'ulParamDisabled'
	        };
	    } else if (ULParam && ULParam.match(/[12]/)) {
	        return {
	            experience: 'unifiedLogin',
	            reason: 'ulParam'
	        };
	    } else if (ULParam === '3') {
	        return {
	            experience: 'apsIntegrationRM',
	            reason: 'ulParamApsRM'
	        };
	    } else if (auth.refreshToken()) {
	        return {
	            experience: 'unifiedLogin',
	            reason: 'rememberedUser'
	        };
	    } else if (_squid.$meta.corp && _squid.$config.ulMeta.allowKMLIForInternalIP && (0, _squid.$feature)('enableOneTouchInternalIP', false, merchant_country)) {
	        return {
	            experience: 'unifiedLogin',
	            reason: 'internalIP'
	        };
	    }
	}
	
	function $loginEligibility(token, forcedLogin) {
	
	    var $scope = {};
	
	    $scope.token = token;
	
	    var routingReason = void 0;
	
	    return (0, _squid.$populate)($scope, {
	        auth: _index2.$AuthModel.instance(),
	        checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
	    }).then(function () {
	
	        var country = $scope.checkoutAppData.merchant.merchant_country;
	        var forceLoginExperience = $forceLoginExperience($scope.auth, $scope.checkoutAppData.merchant.merchant_country, forcedLogin);
	        var isIneligible = angular.isDefined(forceLoginExperience);
	
	        return (0, _squid.$pxpMatch)(_squid.$config.ulMeta.pxpExpId, {
	            'ctx.COUNTRY': country
	        }, {
	            pxpControl: 'xo_hermesnode_ul_(mobile|web)_control',
	            pxpTreatment: 'xo_hermesnode_ul_(mobile|web)_treatment',
	            apsIntegration: 'xo_hermesnode_ul_(mobile|web)_aps_treatment',
	            apsIntegrationRM: 'xo_hermesnode_ul_(mobile|web)_aps_kmli_treatment'
	        }, {
	            ineligible: isIneligible
	        }).then(function (loginExperience) {
	
	            // To do: do this before calling pxp... otherwise every treatment has ineligible buyers
	            if (forceLoginExperience) {
	                routingReason = forceLoginExperience.reason;
	                return forceLoginExperience.experience;
	            }
	
	            var pxpGroup = 'na';
	
	            angular.forEach(loginExperience, function (value, key) {
	                if (value) {
	                    pxpGroup = key;
	                }
	            });
	
	            routingReason = pxpGroup;
	
	            switch (pxpGroup) {
	                case 'pxpTreatment':
	                    return 'unifiedLogin';
	                case 'pxpControl':
	                    return 'apsIntegration';
	                case 'apsIntegration':
	                    return 'apsIntegration';
	                case 'apsIntegrationRM':
	                    return 'apsIntegrationRM';
	                default:
	                    // For those countries where PXP is not setup, make UL as default
	                    if ((0, _squid.$feature)('defaultLoginMethodUL', false, country)) {
	                        return 'unifiedLogin';
	                    }
	                    // Non-UL experience ONLY in case of PXP setup but returned control
	                    return 'apsIntegration';
	            }
	        });
	    }).then(function (finalLoginExperience) {
	
	        _logger.$logger.debug(finalLoginExperience === 'unifiedLogin' ? 'ULLOGIN_ELIGIBLE' : 'ULLOGIN_NOT_ELIGIBLE', {
	            userGroup: [routingReason],
	            routing_reason: routingReason
	        });
	
	        var app_int_type = _index3.$DeviceInfo.getAppIntegrationType();
	
	        _logger.$logger.info('checkout_fpti', {
	            'from': 'UL_ELG_CHK',
	            'to': 'process_ul_elg_chk',
	            'routing_reason': routingReason,
	            'app_int_type': app_int_type
	        });
	
	        return finalLoginExperience;
	    });
	}
	
	angular.value("$forceLoginExperience", $forceLoginExperience);
	angular.value("$loginEligibility", $loginEligibility);
	_squid.$util;
	
	_squid.$meta;
	
	_squid.$config;
	
	_squid.$feature;
	
	_squid.$pxpMatch;
	
	_squid.$populate;
	
	_logger.$logger;
	
	_index.$CheckoutAppDataModel;
	
	_index2.$AuthModel;
	
	_index3.$DeviceInfo;

/***/ },

/***/ "./pages/xo-login/onboarding/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoOnboardingSectionComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-login/onboarding/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-login/guestThrottle.js");
	
	__webpack_require__("./components/xo-wallet-components/src/fi-logos/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _paypalplus = __webpack_require__("./pages/xo-login/paypalplus.js");
	
	var _index = __webpack_require__("./components/xo-models/src/credit/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoOnboardingSectionComponent = exports.$xoOnboardingSectionComponent = _squid.$Component.extend('$xoOnboardingSectionComponent', {
	    tag: 'xo-onboarding-section',
	    template: _template2['default'],
	    scope: {
	        token: '=',
	        isWps: '=',
	        guestVariant: '='
	    },
	
	    controller: function controller($scope, $guestThrottle, $locale, $populate, $FlowEligibilityModel, $feature, $CheckoutAppDataModel, $state) {
	
	        function throttleOnboardingFlow(flow) {
	            return $guestThrottle(flow, $scope.token, $locale.lang, $locale.country);
	        }
	
	        $scope.signupThrottle = function () {
	            if ($scope.forceCAPESignup) {
	                $state.go('checkout.redirectToCape');
	            } else {
	                throttleOnboardingFlow('signup');
	            }
	        };
	
	        $scope.guestThrottle = function () {
	            throttleOnboardingFlow('guest');
	        };
	
	        function getFlowEligibility() {
	            return $FlowEligibilityModel.instance($scope.token).reload({
	                params: {
	                    'localeCountry': $locale.country
	                }
	            }).then(function (flowEligibility) {
	                $scope.flowEligibility = flowEligibility;
	            });
	        }
	
	        $populate($scope, {
	            checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	        }).then(function () {
	            return getFlowEligibility();
	        }).then(function () {
	            $scope.creditDataModel = _index.$CreditDataModel.instance($scope.token);
	            $scope.forceCAPESignup = $scope.checkoutAppData.is_second_button_txn && !$scope.creditDataModel.payInFull;
	            var useForcedSignupFlow = (0, _paypalplus.$isPayPalPlus)($scope.token) || $scope.forceCAPESignup;
	            var wps = $scope.isWps;
	            var guest = $scope.flowEligibility.guest;
	            var signup = $scope.flowEligibility.signup;
	
	            $scope.showGuestBtn = !useForcedSignupFlow && (wps || guest);
	            $scope.showSignupBtn = useForcedSignupFlow || !wps && !guest && signup;
	            $scope.hideOrSeparator = !$scope.showGuestBtn && !$scope.showSignupBtn;
	        });
	    }
	});
	
	angular.value("$xoOnboardingSectionComponent", $xoOnboardingSectionComponent);
	_squid.$Component;
	
	_paypalplus.$isPayPalPlus;
	
	_index.$CreditDataModel;

/***/ },

/***/ "./pages/xo-login/onboarding/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"onboardingSection\" id=\"onboardingSection\" content>\n    <div class=\"guestHeading\" ng-if=\"guestVariant.guestBtnOnTop\">\n        <xo-title title-txt=\"{{content('login.guestTitle')}}\"></xo-title>\n        <xo-language-options class=\"span7\"></xo-language-options>\n    </div>\n\n    <div class=\"orSeparator\" ng-if=\"!hideOrSeparator\">\n        <span class=\"textInDivider\">\n            {{content('login.orLowercase')}}\n        </span>\n    </div>\n    <xo-fi-logos token=token ng-if=\"guestVariant.cardIconsAboveGuestBtn\"></xo-fi-logos>\n\n    <a link-button track-link=\"guest\" class=\"btn btn-secondary full submit\" id=\"checkoutAsAGuestBtn\" ng-if=\"showGuestBtn\" ng-click=\"guestThrottle()\">\n        {{ content( (guestVariant && guestVariant.test) ? 'login.guestLinkBtnB' : 'login.guestLinkBtn') }}\n    </a>\n\n    <a link-button track-link=\"signup\" class=\"btn btn-secondary full submit\" id=\"signupBtn\" ng-if=\"showSignupBtn\" ng-click=\"signupThrottle()\">\n        {{ content('login.createAccount') }}\n    </a>\n\n    <div class=\"inline-prop\" ng-if=\"guestVariant.test && !guestVariant.guestBtnOnTop\" ng-bind-html=\"content('login.guestProp')\"></div>\n    <div class=\"orSeparator\" ng-if=\"guestVariant.guestBtnOnTop\">\n        <span class=\"textInDivider\">\n            {{content('login.orLowercase')}}\n        </span>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-login/guestThrottle.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$guestThrottle = $guestThrottle;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/shippingMethod/index.js");
	
	function $guestThrottle(flowName, token, lang, country) {
	    var models = {};
	
	    function redirectToXoon() {
	        return (0, _squid.$dispatch)('xoon', {
	            exp: flowName,
	            token: token,
	            'locale.x': lang + '_' + country,
	            'country.x': country
	        });
	    }
	
	    function fallback(product, reason, params) {
	        throw new _squid.$FallbackError({
	            product: product || 'ux',
	            reason: reason,
	            entryPoint: flowName,
	            params: params
	        });
	    }
	
	    function checkShippingRulesExist() {
	        if (_angular.$rootScope.wps) {
	            return (0, _squid.$populate)(models, {
	                checkoutCart: _index.$CheckoutCartModel.instance(token).retrieve(),
	                checkoutPayee: _index.$CheckoutPayeeModel.instance(token).retrieve()
	            }).then(function () {
	                return (0, _squid.$populate)(models, {
	                    shippingRulesSummary: _index2.$ShippingRuleSummaryModel.instance(token).retrieve({
	                        params: {
	                            merchant_id: models.checkoutPayee.merchant.id,
	                            currency_code: models.checkoutCart.purchase.amounts.total.currency_code
	                        }
	                    })
	                }).then(function () {
	                    var response = models.shippingRulesSummary;
	
	                    if (response.isSnTEnabled && !_squid.$config.enableShippingTaxGuestWPS) {
	                        return true;
	                    }
	                    return;
	                });
	            });
	        } else {
	            return _angular.$q.when();
	        }
	    }
	
	    if (_angular.$rootScope.wps) {
	        if (!_squid.$config.enableGuestWps) {
	            // Fallback to UX for WPS transactions if guest option disabled
	            return fallback('ux', flowName + '_to_ux_wps');
	        } else {
	            return checkShippingRulesExist().then(function (response) {
	                var inventoryGuestFallback = models.checkoutCart.get('cartHasInventory') && !_squid.$config.enableInventoryGuestWPS;
	
	                if (response || inventoryGuestFallback) {
	                    if (response) {
	                        _logger.$logger.info('snt_enabled_guest_to_ux_wps');
	                    } else if (inventoryGuestFallback) {
	                        _logger.$logger.info('inventory_enabled_guest_to_ux_wps');
	                    }
	                    return fallback('ux', 'guest' + '_to_ux_wps');
	                } else {
	                    return redirectToXoon();
	                }
	            });
	        }
	    } else {
	        return redirectToXoon();
	    }
	}
	
	angular.value("$guestThrottle", $guestThrottle);
	_angular.$rootScope;
	
	_angular.$q;
	
	_squid.$dispatch;
	
	_squid.$populate;
	
	_squid.$config;
	
	_squid.$FallbackError;
	
	_logger.$logger;
	
	_index.$CheckoutCartModel;
	
	_index.$CheckoutPayeeModel;
	
	_index2.$ShippingRuleSummaryModel;

/***/ },

/***/ "./components/xo-wallet-components/src/fi-logos/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/fi-logos/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-fi-logos.directive', ['squid']).directive('xoFiLogos', function () {
	
	        return {
	            template: template,
	            scope: {
	                token: '='
	            },
	
	            controller: function controller($scope, $populate, $locale, $CardTypesModel) {
	
	                $populate($scope, {
	                    cardTypes: $CardTypesModel.instance($scope.token + ':' + $locale.country, {
	                        token: $scope.token,
	                        country: $locale.country
	                    })
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/fi-logos/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"fiIconsGroup\">\n    <div class=\"cardIconsGroup\">\n        <div class=\"icons\" ng-repeat = \"cardType in cardTypes.allowed\">\n            <div class = \"cardIcon {{cardType}}\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-login/paypalplus.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$isPayPalPlus = $isPayPalPlus;
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	function $isPayPalPlus(token) {
	    var checkoutAppDataModel = _index.$CheckoutAppDataModel.instance(token);
	    var experienceInitiator = checkoutAppDataModel.get('flags.payment_experience_initiator');
	    return experienceInitiator === 'PAYPAL_PLUS';
	}
	
	angular.value("$isPayPalPlus", $isPayPalPlus);
	_index.$CheckoutAppDataModel;

/***/ },

/***/ "./components/xo-models/src/credit/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.credit', ['squid']).factory('$CreditDataModel', function ($Model, $Api, $util) {
	
	        return $Model.extend('CreditDataModel', {
	            init: function init() {
	                this._super.init.apply(this);
	                this.setProperties({
	                    flow_type: $util.param('flow'),
	                    cape_key: $util.param('key'),
	                    cape_success: $util.param('success'),
	                    credit_signup: $util.param('creditSignup'),
	                    userAction: $util.param('action'),
	                    merchantAction: $util.param('merchantAction'),
	                    credit_login_failure: false,
	                    cape_service_error: $util.param('isInternalServiceError'),
	                    cape_redirect_uri: '',
	                    change_installment: $util.param('changeStatus'),
	                    nextState: ''
	                });
	            },
	
	            api: new $Api({
	                uri: '/api/credit/:id/creditData',
	                postAttempts: 2
	            }),
	
	            isCreditSignup: function isCreditSignup() {
	                return this.credit_signup && this.credit_signup === 'true';
	            },
	
	            setCapeRedirectUri: function setCapeRedirectUri(input) {
	                this.cape_redirect_uri = input;
	            },
	
	            getCapeRedirectUri: function getCapeRedirectUri() {
	                return this.cape_redirect_uri;
	            },
	
	            getMerchantAction: function getMerchantAction() {
	                return this.merchantAction || '';
	            },
	
	            setCreditSignup: function setCreditSignup(input) {
	                this.credit_signup = input;
	            },
	
	            getCapeKey: function getCapeKey() {
	                return this.cape_key;
	            },
	
	            getFlow: function getFlow() {
	                if (this.userAction === 'addCredit') {
	                    return 'credit';
	                }
	                return this.flow_type;
	            },
	            setFlow: function setFlow(flowType) {
	                this.flow_type = flowType;
	            },
	
	            setNextState: function setNextState(nextState) {
	                this.nextState = nextState;
	            },
	
	            isCapeSuccess: function isCapeSuccess() {
	                return this.cape_success && this.cape_success === 'true';
	            },
	
	            isCreditTxn: function isCreditTxn() {
	                return this.flow_type && this.flow_type === 'credit' || this.userAction && this.userAction === 'addCredit';
	            },
	
	            setCreditLoginFailure: function setCreditLoginFailure(input) {
	                this.credit_login_failure = input;
	            },
	
	            getCreditLoginFailure: function getCreditLoginFailure() {
	                return this.credit_login_failure;
	            },
	
	            isCapeReturn: function isCapeReturn() {
	                return this.flow_type && this.flow_type === 'capeReturn';
	            },
	
	            isCapeInternalServiceError: function isCapeInternalServiceError() {
	                return this.cape_service_error && this.cape_service_error === 'true';
	            },
	
	            getNextState: function getNextState() {
	                return this.nextState;
	            },
	
	            isChangeStatus: function isChangeStatus() {
	                return this.change_installment === 'changeInstallment';
	            },
	
	            isRedirectFromCape: function isRedirectFromCape() {
	                return Boolean(this.cape_key && this.cape_success === 'true' || $util.param('applyCredit'));
	            }
	        });
	    }).factory('$CreditInstallmentModel', function ($Model, $Api) {
	
	        return $Model.extend('CreditInstallmentModel', {
	            api: new $Api({
	                uri: '/api/checkout/:id/creditOptions/'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/credit", "components/xo-models/src/credit/index.js"))

/***/ },

/***/ "./pages/xo-login/util.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-login.capeUtil', ['squid']).factory('$capeRedirectUtil', function ($util, $CreditDataModel, $state) {
	        return {
	            handleCapeRouting: function handleCapeRouting(checkoutSession, token) {
	                var fundingInstruments = checkoutSession.fundingOptions && checkoutSession.fundingOptions.instruments;
	                var isCreditInWallet = fundingInstruments && $util.find(fundingInstruments, function (fi) {
	                    return fi.name === 'BILL_ME_LATER';
	                });
	
	                var creditDataModel = $CreditDataModel.instance(token);
	                var isCapeReturnKey = creditDataModel.getCapeKey();
	                var isCapeReturn = isCapeReturnKey && $util.param('success');
	                var isPPCEligible = checkoutSession.creditOffer || checkoutSession.bmlOffer;
	
	                // User does not have any FI in wallet but they choose to pay in full.
	                // Show add card contingency page instead of redirecting to CAPE.
	
	                if (checkoutSession.isCreditPromoted && !fundingInstruments && creditDataModel.payInFull || !fundingInstruments && !isPPCEligible) {
	
	                    return $state.go('checkout.pageAddCard.addCardFlow.addCard');
	                }
	
	                // Handle case where it was timeout and status is to go back to cape
	                else if (isCreditInWallet || isCapeReturn || creditDataModel.payInFull) {
	                        return $state.go('checkout.review');
	                    }
	
	                    // Handle "checkout with paypal" link on cyco
	                    else if (!isCreditInWallet && isPPCEligible) {
	                            return $state.go('checkout.redirectToCape');
	                        } else {
	                            // show error message
	                            return $state.go('checkout.review');
	                        }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-login", "pages/xo-login/util.js"))

/***/ },

/***/ "./components/xo-ui-components/src/message/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-message.directive', ['squid']).directive('xoMessage', function ($timeout, $loader, $rootScope) {
	        return {
	            scope: {
	                message: '=' // Expected type - {msgs: [], type: "info|error|success|warning"}
	            },
	            template: template,
	            link: function link(scope, element, attrs) {
	
	                // Hide and show the alerts so that messages can be registered by
	                // screen reader even if they are repeats. Uses $timeout to
	                // wait for DOM before showing alerts again.
	                var toggleAlert = function toggleAlert() {
	                    var $alert = element.find('ul');
	                    $alert.detach();
	                    $timeout(function () {
	                        element.find('#pageLevelErrors').append($alert);
	                    });
	                };
	
	                // Toggle the alert whenever message changes by removing it and reappending it
	                // to the DOM. Should fire even if message
	                // is changed to the same, as assumes that the message should be reapplied.
	                var cancel;
	                scope.$watchCollection('message', function () {
	                    if ($loader.isLoading() && !cancel) {
	                        // If loading, toggle the alert after all loading calls have been made.
	                        // This is so that the alert can be read by screen reader after focus
	                        cancel = $rootScope.$on('allLoaded', function () {
	                            cancel();
	                            toggleAlert();
	
	                            cancel = null;
	                        });
	                    } else {
	                        toggleAlert();
	                    }
	                });
	
	                scope.$on('$destroy', function () {
	                    if (cancel) {
	                        cancel();
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/message/template.html":
/***/ function(module, exports) {

	module.exports = "<div role=\"alert\" aria-live=\"assertive\">\n    <div id=\"notifications\" ng-if=\"message.msgs || message.msgKeys\" content >\n        <div id=\"pageLevelErrors\" class=\"msgPage msg-{{message.type}}\">\n            <span class=\"icon\"></span>\n            <ul role=\"presentation\">\n                <li ng-repeat=\"msg in message.msgs\">\n                    <span data-ng-bind-html=\"msg\"></span>\n                </li>\n                <li ng-repeat=\"keys in message.msgKeys\" ng-if=\"message.msgKeys\">\n                    <div data-ng-bind-html=\"htmlContent(keys)\"></div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-title/dist/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-title/dist/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-title.directive', ['squid']).directive('xoTitle', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                titleTxt: '@',
	                className: '@'
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-title/dist/template.html":
/***/ function(module, exports) {

	module.exports = "<h1 class=\"alpha\">\n    {{ titleTxt }}\n</h1>\n"

/***/ },

/***/ "./components/xo-login-components/src/login/handler/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/login/handler/template.html"), __webpack_require__("./components/xo-login-components/src/login/directive.js"), __webpack_require__("./components/xo-login-components/src/login/props.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/app/index.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-form-components/src/language-options/directive.js"), __webpack_require__("./components/xo-login-components/src/unified-login/directive.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return angular.module('xo-login-handler.directive', ['squid', 'beaver', 'xomodel.checkout', 'xomodel.app', 'xo-message.directive', 'xo-title.directive', 'xo-login.directive', 'xo-language-options.directive', 'xo-unified-login.directive', 'xo-login-props', 'xo-device-info']).directive('xoLoginHandler', function ($util, $pxp, $logger, $locale, $loginProps) {
	
	        return {
	
	            componentize: true,
	
	            template: template,
	
	            scope: {
	                token: '=',
	                successCallback: '=',
	                contingencyCallback: '=',
	                autoLogin: '=',
	                ulEligibility: '=',
	                subFlowTitleKey: '=',
	                apsIntegration: '=',
	                batch: '=',
	                loginSubmit: '=',
	                logout: '=',
	                preAuth: '=',
	                hideloginpp: '=',
	                flowcontext: '='
	            },
	
	            controller: function controller($scope, $rootScope, $populate, $window, $location, $state, $AuthModel, $feature, $AppDataModel, $CheckoutCartModel, $loginProps, // eslint-disable-line no-shadow
	            $config, $logger, // eslint-disable-line no-shadow
	            $timeout, $util, // eslint-disable-line no-shadow
	            $localeHelper, $stateParams, $FallbackError) {
	
	                // Login Contingency Handling
	                var CONTENT_KEY = {
	                    INVALID_EMAIL_PASSWORD: 'invalidEmailPasswordPageError',
	                    ACCOUNT_LOCKED: 'accountLockedPageError',
	                    ACCOUNT_CLOSED: 'accountLockedPageError',
	                    INVALID_PHONE: 'invalidPhone',
	                    INVALID_PIN: 'invalidPin',
	                    INVALID_ACCESS_TOKEN: 'invalidAccessToken',
	                    TIMED_OUT: 'loginStatusTimedOut',
	                    CANNOT_PAY_SELF: 'cannotPaySelf',
	                    RISK_DECLINE: 'riskDeclinePageError',
	                    LOGIN_ADD_PHONE: 'loginAddPhone',
	                    LOGIN_PREFILLED_SHIPPING_ADDRESS: 'loginMerchantPassedAddress',
	                    LOGIN_CONTINGENCY: 'loginContingency',
	                    LOGIN_REACTIVATE: 'checkOneTouch',
	                    LOGIN_LEAVECHECKED: 'leaveOneTouchChecked',
	                    LOGIN_OT_GENERIC_ERROR: 'reactivateOneTouch'
	                };
	
	                var CONTENT_MAPPING = {
	                    INVALID_USER: { content: CONTENT_KEY.INVALID_EMAIL_PASSWORD, type: 'error' },
	                    INVALID_PHONE_PIN: { content: CONTENT_KEY.INVALID_PIN, type: 'error' },
	                    INVALID_ACCESS_TOKEN: { content: CONTENT_KEY.INVALID_ACCESS_TOKEN, type: 'error' },
	                    LOCKED_USER: { content: CONTENT_KEY.ACCOUNT_LOCKED, type: 'error' },
	                    ACCOUNT_LOCKED: { content: CONTENT_KEY.ACCOUNT_LOCKED, type: 'error' },
	                    CLOSED_USER: { content: CONTENT_KEY.ACCOUNT_CLOSED, type: 'error' },
	                    TIMED_OUT: { content: CONTENT_KEY.TIMED_OUT, type: 'error' },
	                    CANNOT_PAY_SELF: { content: CONTENT_KEY.CANNOT_PAY_SELF, type: 'error' },
	                    RISK_DECLINE: { content: CONTENT_KEY.RISK_DECLINE, type: 'error' },
	                    addPhone: { content: CONTENT_KEY.LOGIN_ADD_PHONE, type: 'error' },
	                    PAYER_AUTHENTICATION_REQUIRED: {
	                        content: CONTENT_KEY.LOGIN_PREFILLED_SHIPPING_ADDRESS,
	                        type: 'info'
	                    },
	                    LOGIN_CONTINGENCY: { content: CONTENT_KEY.LOGIN_CONTINGENCY, type: 'error' },
	                    ONETOUCH_REACTIVATE: { content: CONTENT_KEY.LOGIN_REACTIVATE, type: 'warning' },
	                    ONETOUCH_LEAVECHECKED: { content: CONTENT_KEY.LOGIN_LEAVECHECKED, type: 'warning' },
	                    ONETOUCH_GENERIC_ERROR: { content: CONTENT_KEY.LOGIN_OT_GENERIC_ERROR, type: 'warning' }
	                };
	
	                function populateMessage(name, type) {
	                    var contentKey = CONTENT_MAPPING[name];
	                    if (contentKey) {
	                        $scope.message = {
	                            msgKeys: ['login.' + contentKey.content],
	                            type: type || contentKey.type
	                        };
	                    } else {
	                        $logger.debug('unresolved content for login ' + type + ' message ' + name + ' in xo-login page');
	                    }
	                }
	
	                function handleAuthChallengeFailure(urlParams) {
	                    if (urlParams.acRedirect === '2fa') {
	                        var userLocale = urlParams['locale.test'];
	
	                        if (userLocale) {
	                            $locale.chosenLang = $localeHelper.normalizeLocale(userLocale).language;
	                        }
	
	                        if (urlParams.ulMethod === 'phone') {
	                            $logger.debug('2FA_RETURNED_FAILED_PHONE');
	                            populateMessage('INVALID_PHONE_PIN', 'error');
	                        } else {
	                            $logger.debug('2FA_RETURNED_FAILED_EMAIL');
	                            populateMessage('INVALID_USER', 'error');
	                        }
	                    } else if (urlParams.acRedirect === 'loginato') {
	                        $logger.debug('LOGIN_ATO_RETURNED_FAILED');
	                        $state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
	                    } else if (urlParams.acRedirect === 'safe') {
	                        $logger.debug('SAFE_RETURNED_FAILED');
	                        $state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
	                    }
	                }
	
	                function handleAuthChallengeSuccess(urlParams) {
	                    switch (urlParams.acRedirect) {
	                        case '2fa':
	                            $logger.debug('2FA_RETURNED_SUCCESS');
	                            break;
	                        case 'loginato':
	                            $logger.debug('LOGIN_ATO_RETURNED_SUCCESS');
	                            break;
	                        case 'safe':
	                            $logger.debug('SAFE_RETURNED_SUCCESS');
	                            break;
	                        default:
	                        // do nothing
	                    }
	                    $scope.auth.is_auth_api_call = !urlParams.acRedirect;
	                }
	
	                $scope.onComplete = function (auth) {
	                    // Dont show the login contingency message once poma password recovery is enabled.
	                    if (!$feature('pomaPasswordRecovery') && $scope.auth.password_less && $scope.checkoutCart.isBilling()) {
	                        populateMessage('LOGIN_CONTINGENCY', 'info');
	                    }
	
	                    if ($rootScope.contingency && $rootScope.contingency.message) {
	                        populateMessage($rootScope.contingency.message, 'error');
	                    } else {
	                        $locale.choose(auth.country, auth.language, false);
	                        $scope.successCallback();
	                    }
	                };
	
	                // Make country and lang available to htmlContent for dynamically generating content
	                $scope.locale = $locale;
	
	                if ($stateParams.targetPage) {
	                    if ($loginProps.inList($stateParams.targetPage) && $feature('riskyLoginContingency')) {
	                        var riskyLoginInfo = $loginProps.mapInfo($stateParams.targetPage);
	                        $scope.subFlowTitleKey = riskyLoginInfo.title;
	                        $scope.contingencyDesc = riskyLoginInfo.subtitle;
	                        $scope.hideloginpp = true;
	                        $scope.postlogout = function () {
	                            delete $scope.subFlowTitleKey;
	
	                            if ($scope.contingencyDesc) {
	                                delete $scope.contingencyDesc;
	                            }
	
	                            delete $scope.hideloginpp;
	                            $scope.showLanguageDropdown = $feature('languageToggle');
	                            $scope.logout();
	                        };
	                    } else {
	                        var errMessage = CONTENT_MAPPING[$stateParams.targetPage] ? $stateParams.targetPage : 'LOGIN_CONTINGENCY';
	                        var type = errMessage.type ? errMessage.type : 'info';
	                        populateMessage(errMessage, type);
	                    }
	                }
	
	                if ($AuthModel.instance().meta.invalidated) {
	                    populateMessage('TIMED_OUT', 'error');
	                } else if ($AuthModel.instance().meta.selfPay) {
	                    populateMessage('CANNOT_PAY_SELF', 'error');
	                    $AuthModel.instance().meta.selfPay = false;
	                }
	
	                $populate($scope, {
	                    auth: $AuthModel.instance(),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token).retrieve()
	                }).then(function () {
	                    // Land on create password info page in case poma user was routed to login, after the
	                    // initial login/auth.
	                    if ($feature('pomaPasswordRecovery') && $scope.auth.password_less && !$scope.autoLogin) {
	                        $state.go('checkout.createPassword', { targetPage: $stateParams.targetPage });
	                        return;
	                    }
	
	                    var ULCallbacks = {
	                        showErrorMessages: function showErrorMessages(errorCase) {
	                            populateMessage(errorCase);
	                            $timeout(function () {
	                                $scope.$digest(); // eslint-disable-line angular/ng_no_digest
	                            });
	                        },
	                        toggleUnifiedLogin: function toggleUnifiedLogin(value) {
	                            $scope.ulEligibility = value;
	                            $scope.apsIntegration = true;
	                            $rootScope.continueLoadingForUL = value;
	                            $timeout(function () {
	                                $scope.$digest(); // eslint-disable-line angular/ng_no_digest
	                            });
	                        }
	                    };
	
	                    $scope.ULCallback = function (name, value) {
	                        var callback = ULCallbacks[name];
	                        if (callback) {
	                            callback(value);
	                        }
	                    };
	
	                    if ($scope.auth.timed_out) {
	                        populateMessage('TIMED_OUT', 'error');
	                    }
	
	                    if (!$scope.subFlowTitleKey) {
	                        $scope.showLanguageDropdown = $feature('languageToggle');
	                    }
	
	                    var urlParams = $util.params();
	
	                    if (urlParams.acRedirect) {
	                        // Returning from auth challenge
	                        if (urlParams.failedBecause) {
	                            handleAuthChallengeFailure(urlParams);
	                        } else {
	                            handleAuthChallengeSuccess(urlParams);
	                        }
	                    }
	
	                    var handleContingency = {
	                        // Errors - Show Page Level Error
	                        INVALID_USER: populateMessage,
	                        LOCKED_USER: populateMessage,
	                        ACCOUNT_LOCKED: populateMessage,
	                        CLOSED_USER: populateMessage,
	                        ONETOUCH_REACTIVATE: populateMessage,
	                        ONETOUCH_LEAVECHECKED: populateMessage
	
	                    };
	
	                    $scope.onContingency = function (name, contingency, type) {
	                        // eslint-disable-line no-shadow
	
	                        $locale.choose($scope.auth.country, $scope.auth.language, false);
	
	                        if (!handleContingency[name]) {
	                            return $scope.contingencyCallback(name, contingency);
	                        }
	
	                        var message_type = type || 'error';
	                        return handleContingency[name](name, message_type);
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/login/handler/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"login\" id=\"loginSection\" content>\n    <xo-message message=\"message\"></xo-message>\n    <div class=\"pr row-fluid\" ng-class=\"{hasError: message}\">\n        <xo-title title-txt=\"{{content(subFlowTitleKey ? subFlowTitleKey : 'login.loginTitle')}}\" ng-class=\"{span17: showLanguageDropdown, riskyTitle: subFlowTitleKey}\"></xo-title>\n        <xo-language-options class=\"span7\" ng-if=\"showLanguageDropdown\"></xo-language-options>\n    </div>\n    <div class=\"inline-prop\" unless-feature=\"propValue\" ng-hide=\"hideloginpp\">\n        <p ng-bind-html=\"htmlContent('login.propValAlt', {country: locale.country, lang: locale.lang})\")>\n    </div>\n    <div class=\"inline-prop\" ng-show= \"contingencyDesc\" ng-class=\"{riskySubtitle: contingencyDesc}\">\n        <p ng-bind-html=\"htmlContent(contingencyDesc, {country: locale.country, lang: locale.lang})\")>\n    </div>\n    <xo-login ng-if=\"!ulEligibility\" token=token auth=auth done-fn=\"onComplete\" error-fn=\"onContingency\" auto-login=\"autoLogin\" aps-integration=\"apsIntegration\" batch=\"batch\" login-submit=\"loginSubmit\"></xo-login>\n    <xo-unified-login ng-if=\"ulEligibility\" token=token error-fn=\"onContingency\" parent-callback=\"ULCallback\" pre-auth=\"preAuth\" post-auth=\"onComplete\" auto-login=\"autoLogin\" flowcontext=\"flowcontext\" login-submit=\"loginSubmit\" logout-callback=\"postlogout\" ></xo-unified-login>\n</section>\n"

/***/ },

/***/ "./components/xo-login-components/src/login/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/login/template.html"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-ui-components/src/popup/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/credit/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-login-components/src/login/fn.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-login.directive', ['squid', 'xomodel.auth', 'xomodel.checkout', 'xomodel.credit', 'xomodel.user', 'xo-popup.directive', 'xo-error-tooltip.directive', 'xo-device-info', 'xo-fn']).directive('xoLogin', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                doneFn: '=',
	                errorFn: '=',
	                clientId: '=',
	                redirectUri: '=',
	                scope: '=',
	                autoLogin: '=',
	                apsIntegration: '=',
	                batch: '=',
	                loginSubmit: '='
	            },
	
	            controller: function controller($scope, $element, $populate, $rootScope, $locale, $config, $window, $AuthModel, $CheckoutCartModel, $CheckoutInputDataModel, $CreditDataModel, $logger, $feature, $DeviceInfo, $util, $fn) {
	
	                $scope.locale = $locale;
	
	                var localeNVP = $locale.lang && $locale.country ? 'locale.x=' + $locale.lang.toLowerCase() + '_' + $locale.country : 'locale.x=en_US';
	                var forgotPasswordUrl = 'https://www.paypal.com/' + $locale.country.toLowerCase() + '/webapps/accountrecovery/passwordrecovery?' + localeNVP;
	                var legacyForgotPasswordUrl = 'https://www.paypal.com/' + $locale.country.toLowerCase() + '/merchantpaymentweb?cmd=_account-recovery&from=PayPal&' + localeNVP;
	                var checkoutInputData = $CheckoutInputDataModel.instance($rootScope.token);
	                var creditData = $CreditDataModel.instance($rootScope.token);
	                var apsRemMe = $scope.apsIntegration === 'apsIntegrationRM';
	                var fptiStateName = $scope.apsIntegration ? 'LOGIN_APS' : 'LOGIN';
	                var $passwordField = $element.find('[ng-model="auth.password"]');
	
	                $scope.forgotPasswordUrl = $feature('newForgotPasswordSupported') ? forgotPasswordUrl : legacyForgotPasswordUrl;
	
	                $fn.sendTypingSpeedPayload('Hermes');
	
	                /* ******** Here goes the Remember User controls *************************** */
	
	                // Show the RM consent section when
	                // 1. feature is ON
	                // 2. when its not a contingency flow
	                // 3. eBay doesn't want to hide it explicitly
	
	                if (checkoutInputData.rmEnabled(Boolean($config.rememberMeFeatureEnabled)) && !checkoutInputData.hideRM()) {
	                    fptiStateName = 'LOGIN_RM';
	                    $scope.rememberMe = 'nonKmli';
	                } else if (apsRemMe) {
	                    $scope.rememberMe = 'kmli';
	                }
	                $scope.rememberMeChkBox = {
	                    // Leave the consent box un-ticked by default
	                    agreed: false
	                };
	
	                // Show the RM details only if user clicks on 'learn more' link or clicks on Checkbox
	                $scope.showRmMore = false;
	
	                // Expand details when RM check-box is ticked and Remember the user
	                $scope.toggleRMDetails = function () {
	                    $scope.showRmMore = $scope.rememberMeChkBox.agreed;
	                };
	
	                function setRememberUser() {
	
	                    if (checkoutInputData.rmEnabled(Boolean($config.rememberMeFeatureEnabled))) {
	                        if (checkoutInputData.hideRM() === 'true') {
	                            // Feature is ON but consent box is hidden since hideRM param is true
	                            // Do not remember user in this case
	                            $scope.auth.rememberUser = false;
	                        } else {
	                            // RM is enabled and consent box displayed on login page
	                            // Remember the user based on the consent of user
	                            $scope.auth.rememberUser = $scope.rememberMeChkBox.agreed ? true : false;
	                        }
	                    } else {
	                        // Feature is wired off
	                        // If RM is not enabled that means the control is with eBay and we should retain current behavior by remembering the user
	                        $scope.auth.rememberUser = true;
	                    }
	                }
	
	                /* ************ Remember User Ends *************************************** */
	
	                function showLoadingMessage() {
	                    $rootScope.$emit('loadingMessage', $locale.content.get(creditData.isRedirectFromCape() || creditData.isChangeStatus() ? 'base.processing' : 'base.loggingIn'));
	                }
	
	                function loginAction() {
	                    showLoadingMessage();
	                    var loginInput = {
	                        user: {
	                            email: $scope.auth.email,
	                            password: $scope.auth.password
	                        }
	                    };
	
	                    if ($scope.clientId) {
	                        loginInput.client = {
	                            redirect_uri: $config.app_redirect_uri,
	                            client_id: $config.app_clientId || '',
	                            target_client_id: $util.base64Decode($scope.clientId), // eslint-disable-line block-scoped-var,no-undef
	                            scope: $scope.scope,
	                            response_type: 'token id_token',
	                            skip_oauth: false,
	                            skip_consent: true
	                        };
	                    } else if ($scope.apsIntegration) {
	                        loginInput.client = {
	                            remember_me: Boolean(apsRemMe && $scope.rememberMeChkBox.agreed)
	                        };
	                        loginInput.fastLogin = true;
	                    }
	
	                    // updated the product to decide the entry point
	                    loginInput.product = $rootScope.wps ? 'wps' : 'ec';
	
	                    $scope.auth.action('login', {
	
	                        data: loginInput,
	
	                        success: function success(result) {
	                            var transition_name = $scope.rememberMeChkBox.agreed ? 'process_login_rm' : 'process_login';
	                            $logger.info('checkout_fpti', { 'from': fptiStateName, 'to': transition_name });
	
	                            if (window.xprops && window.xprops.onAuth && $scope.auth.access_token) {
	                                return window.xprops.onAuth({
	                                    accessToken: $scope.auth.access_token
	                                }).then(function () {
	                                    return $scope.doneFn($scope.auth);
	                                });
	                            }
	
	                            return $scope.doneFn($scope.auth);
	                        },
	
	                        contingencies: {
	                            DEFAULT: function handleContingency(name, contingency) {
	                                var transition_name = $scope.rememberMeChkBox.agreed ? 'process_login_rm' : 'process_login';
	                                var error_source = $scope.apsIntegration ? 'aps' : 'userauth';
	
	                                $logger.info('checkout_fpti', {
	                                    'from': fptiStateName,
	                                    'to': transition_name,
	                                    'int_error_description': contingency && contingency.message,
	                                    'error_type': 'soft_decline',
	                                    'error_source': error_source
	                                });
	                                $scope.auth.password = '';
	                                $passwordField.focus();
	                                return $scope.errorFn(name, contingency);
	                            }
	                        }
	                    });
	                }
	
	                $scope.$on('$destroy', function () {
	                    $scope.auth.password = '';
	                });
	
	                $populate($scope, {
	                    auth: $AuthModel.instance(),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token)
	                }).then(function () {
	                    if ($scope.auth.loggedIn()) {
	                        if ($scope.autoLogin) {
	                            showLoadingMessage();
	                            if ($scope.auth.remembered) {
	                                $logger.info('REMEMBERED_ACTIVE_SESSION');
	                            } else {
	                                $logger.info('ACTIVE_SESSION');
	                            }
	                            return $scope.doneFn($scope.auth);
	                        }
	                    } else if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.email && !$scope.auth.timed_out) {
	                        $scope.auth.email = $scope.checkoutCart.payer.email;
	                    }
	                    var transition_name;
	                    if (apsRemMe) {
	                        transition_name = 'prepare_login_rm';
	                    } else if (creditData.isCreditTxn()) {
	                        transition_name = 'prepare_login_ppc';
	                    } else {
	                        transition_name = 'prepare_login';
	                    }
	
	                    var app_int_type = $DeviceInfo.getAppIntegrationType();
	                    $logger.info('checkout_fpti', {
	                        'from': fptiStateName,
	                        'to': transition_name,
	                        'app_int_type': app_int_type
	                    });
	                    $scope.onSubmit = function () {
	                        setRememberUser();
	                        loginAction();
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-ui-components/src/popup/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid) {
	
	    squid.module('xo-popup.directive', ['squid']).directive('xoPopup', function ($window, $util) {
	        return {
	            restrict: 'A',
	
	            link: function link(scope, element, attr) {
	
	                element.on('click', function (event) {
	                    event.preventDefault();
	                    event.stopPropagation();
	
	                    var config = {
	                        popupUrl: attr.href,
	                        popupWindowName: 'popup',
	                        width: 835,
	                        height: 500,
	
	                        popupWindowFeatures: {
	                            location: 1,
	                            status: 1,
	                            scrollbars: 1,
	                            resizable: 1,
	                            toolbar: 0,
	                            menubar: 0
	                        }
	                    };
	
	                    scope.trackExternalLink(attr.id || 'external_link');
	
	                    var isOneTouch = $util.param('isOneTouch');
	
	                    if (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test($window.navigator.userAgent) && isOneTouch !== '1') {
	                        scope.$emit('showModal', config);
	                        return false;
	                    }
	
	                    if ($(element).hasClass('smallPopup')) {
	                        config.width = 385;
	                    }
	
	                    var left = 0;
	                    var top = 0;
	
	                    if (window.outerWidth) {
	                        left = Math.round((window.outerWidth - config.width) / 2) + window.screenX;
	                        top = Math.round((window.outerHeight - config.height) / 2) + window.screenY;
	                    } else if (window.screen.width) {
	                        left = Math.round((window.screen.width - config.width) / 2);
	                        top = Math.round((window.screen.height - config.height) / 2);
	                    }
	
	                    var features = Object.keys(config.popupWindowFeatures).map(function (k) {
	                        return k + '=' + config.popupWindowFeatures[k];
	                    }).join(',');
	
	                    // put together WindowFeatures, since, window.open needs it as a string
	                    features += ',width=' + config.width + ',height=' + config.height + ',left=' + left + ',top=' + top;
	
	                    var popup = $window.open(config.popupUrl, config.popupWindowName, features);
	
	                    if (popup.focus) {
	                        popup.focus();
	                    }
	                });
	            },
	
	            controller: function controller($scope, $logger) {
	                $scope.trackExternalLink = function (linkName) {
	                    $logger.info(linkName);
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-ui-components/src/error-tooltip/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angularAria = __webpack_require__("./components/angular-aria/angular-aria.min.js");
	
	// Configure angular aria.
	// Note that aria configuration applies globally
	_angularAria.$ariaProvider.config({ // eslint-disable-line angular/di
	    // Remove bindRoleForClick since we use ngClick for several items that shouldn't be treated as buttons.
	    bindRoleForClick: false,
	
	    // Remove ariaInvalid and ariaRequired as we want to handle them ourselves.
	    // These attributes should only be set once the form is submitted, to match what
	    // visually what we display
	    ariaInvalid: false,
	    ariaRequired: false
	});
	
	(0, _angular.$registerDirective)('xo-error-tooltip', function () {
	
	    return {
	        restrict: 'A',
	        require: ['?^form', '?ngModel'],
	        link: function link(scope, element, attrs, ctrls) {
	            var formCtrl = ctrls[0],
	                modelCtrl = ctrls[1];
	
	
	            function shouldBeRequired() {
	                if (formCtrl) {
	                    // If input is a checkbox and has error-text, show the error text instead of the required text.
	                    var showCheckboxRequired = !(element.attr('type') === 'checkbox' && attrs.errorText);
	                    return formCtrl.$submitted && modelCtrl.$error.required && showCheckboxRequired;
	                } else {
	                    return modelCtrl.$error.required;
	                }
	            }
	
	            function shouldBeInvalid() {
	                if (formCtrl) {
	                    return formCtrl.$submitted && modelCtrl.$invalid;
	                } else {
	                    return modelCtrl.$invalid;
	                }
	            }
	
	            // Add or remove a string into a space split string (eg. aria-describedby ids, class names)
	            function formatSpaceSplitString(str, id, add) {
	                var strArray;
	                if (str) {
	                    strArray = str.split(' ');
	                } else {
	                    strArray = [];
	                }
	
	                var idIndex = strArray.indexOf(id);
	
	                if (~idIndex && !add) {
	                    strArray.splice(idIndex, 1);
	                } else if (!~idIndex && add) {
	                    strArray.push(id);
	                }
	
	                return strArray.join(' ');
	            }
	
	            // Add tooltip behavior after DOM settles
	            (0, _angular.$timeout)(function () {
	                var generateId = function generateId() {
	                    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
	                };
	
	                var requiredId = generateId();
	                var invalidId = generateId();
	                var requiredError;
	                var invalidError;
	
	                if (attrs.errorText) {
	                    element.addClass('hasErrorTooltipRuleSpecific');
	                    invalidError = $('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">' + attrs.errorText + '</div>');
	                    element.after(invalidError);
	                }
	
	                if (attrs.required || (0, _angular.$parse)(attrs.ngRequired)(scope)) {
	                    element.addClass('hasErrorTooltipRequired');
	                    requiredError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRequired" id="' + requiredId + '">{{content("validation.required")}}</div>')(scope);
	                    element.after(requiredError);
	
	                    element.removeAttr('aria-required');
	                }
	
	                function setAriaAttributes() {
	                    var addTooltips = {
	                        required: false,
	                        invalid: false
	                    };
	
	                    // Do not associate "Required" error with aria-describedby
	                    // because this should already be read out either by "required"
	                    // attribute or "aria-required"=true, and only associate "Invalid"
	                    // error if "Required" is not showing to match visuals
	                    if (shouldBeRequired()) {
	                        addTooltips.required = true;
	                    } else if (shouldBeInvalid()) {
	                        addTooltips.invalid = true;
	                    }
	
	                    var describedby = element.attr('aria-describedby');
	                    describedby = formatSpaceSplitString(describedby, requiredId, addTooltips.required);
	                    describedby = formatSpaceSplitString(describedby, invalidId, addTooltips.invalid);
	                    element.attr('aria-describedby', describedby);
	                }
	
	                scope.$watch(shouldBeRequired, function (newVal) {
	                    setAriaAttributes();
	                });
	                scope.$watch(shouldBeInvalid, function (newVal) {
	                    element.attr('aria-invalid', newVal);
	                    setAriaAttributes();
	                });
	
	                // Set scroll so that the error message is in view when element receives focus
	                element.on('focus', function (event) {
	                    var windowBot = $(window).scrollTop() + $(window).height();
	                    var requiredBot = requiredError ? requiredError.offset().top + requiredError.outerHeight() : 0;
	                    var invalidBot = invalidError ? invalidError.offset().top + invalidError.outerHeight() : 0;
	                    if (windowBot < Math.max(requiredBot, invalidBot)) {
	                        $(window).scrollTop(Math.max(requiredBot, invalidBot) - $(window).height());
	                    }
	                });
	            });
	        }
	    };
	});
	_angular.$registerDirective;
	
	_angular.$parse;
	
	_angular.$compile;
	
	_angular.$timeout;
	
	_angularAria.$ariaProvider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/login/template.html":
/***/ function(module, exports) {

	module.exports = "<form name=\"loginForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\">\n    <div class=\"inputField emailField confidential\">\n        <label for=\"username\" class=\"focus accessAid\">\n            {{ content('index.EmailLabel') }}\n        </label>\n        <input ng-model=\"auth.email\" id=\"username\" name=\"username\" type=\"email\" ng-readonly=\"auth.emailReadOnly\" value=\"\"\n               autocapitalize=\"off\" aria-required=\"false\" autocomplete=\"off\" placeholder=\"{{ content('index.EmailLabel') }}\" data-error-text=\"{{ content('email.invalid') }}\" xo-error-tooltip required autofocus/>\n    </div>\n\n    <div class=\"inputField passwordField confidential\">\n        <label for=\"password\" class=\"focus accessAid\">\n            {{ content('login.passwordLabel') }}\n        </label>\n        <input ng-model=\"auth.password\" id=\"password\" name=\"password\" type=\"password\" value=\"\" aria-required=\"true\" autocapitalize=\"off\" autocomplete=\"off\" placeholder=\"{{ content('login.passwordLabel') }}\" xo-error-tooltip required>\n    </div>\n\n    <div ng-switch class=\"checkbox\" id=\"rmSection\" on=\"rememberMe\">\n        <div ng-switch-when=\"nonKmli\" class=\"secondary\">\n            <input ng-model=\"rememberMeChkBox.agreed\" type=\"checkbox\" id=\"agree\" ng-click=\"toggleRMDetails()\"/>\n            <label for=\"agree\">\n                {{content('rememberMe.remember')}}\n                <a ng-click=\"showRmMore=!showRmMore\">\n                    <span ng-bind=\"showRmMore ? content('rememberMe.close'): content('rememberMe.more')\"></span>\n                </a>\n            </label>\n            <ul id=\"rmLearnMore\" ng-show=\"showRmMore\">\n                <li>{{ content('rememberMe.skipLogin') }}</li>\n                <li>{{ content('rememberMe.toCancel') }}</li>\n                <li>{{ content('rememberMe.protectAccounts') }}</li>\n            </ul>\n        </div>\n        <div ng-switch-when=\"kmli\">\n            <input ng-model=\"rememberMeChkBox.agreed\" type=\"checkbox\" id=\"agree\">\n            <label for=\"agree\" ng-bind=\"content('login.keepMeLoggedIn')\" class=\"kmliCheckboxLabel\"></label>\n            <div class=\"signupbml kmliHelpIcon\">\n                <a href=\"#\" id=\"verifyHelp\" class=\"verifyHelp\"><img alt=\"{{ content('login.kmliTooltipTitle') }}\" /></a>\n            </div>\n        </div>\n    </div>\n\n    <xo-tooltip trigger=\"#verifyHelp\" display-inline=\"true\">\n        <div class=\"keepMeLoginTerms\" id=\"keepMeLoginTerms\">\n            <p>{{ content('login.kmliTooltipLine1') }}</p>\n            <p>{{ content('login.kmliTooltipLine2') }}</p>\n            <p>{{ content('login.kmliTooltipLine3') }}</p>\n        </div>\n    </xo-tooltip>\n\n    <input track-submit type=\"submit\" value=\"{{ content('login.loginBtn') }}\" class=\"btn full loginBtn\" validate-submit=\"onSubmit()\" />\n\n    <div class=\"center mt10 secondary\" id=\"forgotPasswordSection\">\n        <a href=\"{{forgotPasswordUrl}}\" id=\"forgot_password_link\" target=\"_blank\" class=\"smallPopup\" xo-popup>\n            {{ content('common.forgotYourPassword') }}</a>\n    </div>\n</form>\n"

/***/ },

/***/ "./components/xo-models/src/user/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.user', ['squid']).factory('$CheckoutClientDataModel', function ($Model, $Api) {
	
	        return $Model.extend('CheckoutClientDataModel', {
	
	            api: new $Api({
	                uri: '/api/user/:id/clientData'
	            }),
	
	            merchantIdentityData: function merchantIdentityData() {
	                return {
	                    email: this.email,
	                    brand_name: this.display_name,
	                    logo_uri: this.logo_uri,
	                    identity_uri: this.identity_uri
	                };
	            },
	
	            validateClient: function validateClient() {
	                if (this.partner_id && this.identity_uri) {
	                    return {
	                        success: true
	                    };
	                } else {
	                    return {
	                        success: false,
	                        error: 'invalid_client'
	                    };
	                }
	            },
	            validateRedirectUri: function validateRedirectUri(redirectUrl) {
	                if (this.identity_uri && this.identity_uri.indexOf(redirectUrl) > -1) {
	                    return {
	                        success: true
	                    };
	                } else {
	                    return {
	                        success: false,
	                        error: 'invalid_redirect_url'
	                    };
	                }
	            }
	        });
	    }).factory('$CheckoutInputDataModel', function ($Model, $Api, $config, $util) {
	
	        var ACTION = {
	            login: 'login',
	            resolve: 'resolve',
	            addCard: 'addCard',
	            addBank: 'addBank',
	            changeCurrencyConv: 'changeCurrencyConv',
	            signup: 'signup',
	            mandate: 'mandate',
	            addCredit: 'addCredit',
	            ulReturn: 'ulReturn',
	            creditReturn: 'creditReturn'
	        };
	
	        return $Model.extend('CheckoutInputDataModel', {
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.setProperties({
	                    client_id: $util.param('client_id'),
	                    action: $util.param('action'),
	                    redirect_uri: $util.param('redirect_uri'),
	                    scope: $util.param('scope'),
	                    state: $util.param('state'),
	                    flow: $util.param('flow'),
	                    payer_id: $util.param('payer_id'),
	                    mandate_reference_number: $util.param('mandate_reference_number'),
	                    funding_option_id: $util.param('funding_option_id'),
	                    locale: $util.param('locale'),
	                    logout: $util.param('logout'),
	                    refresh_parent: $util.param('refresh_parent'),
	                    escape_hatch: $util.param('escape_hatch'),
	                    failedBecause: $util.param('failedBecause'),
	                    redirectReferrer: $util.param('redirectReferrer'),
	                    id_token: $util.param('prox_id'),
	                    nonce: $util.param('nonce'),
	                    hide_rm: $util.param('hideRM'),
	                    payloadEnc: $util.param('payloadEnc'),
	                    xcancel: $util.param('x-cancel'),
	                    xsuccess: $util.param('x-success')
	                });
	            },
	
	            api: new $Api({
	                baseURI: $config.urls.baseUrl,
	                uri: '/api/user/:id/payerId'
	            }),
	
	            isEbayTxn: function isEbayTxn() {
	                return Boolean(this.client_id);
	            },
	
	            validAction: function validAction() {
	                var actions = {
	                    login: 'login',
	                    resolve: 'resolve',
	                    addCard: 'addCard',
	                    addBank: 'addBank',
	                    changeCurrencyConv: 'changeCurrencyConv',
	                    signup: 'signup',
	                    mandate: 'mandate',
	                    addCredit: 'addCredit',
	                    ulReturn: 'ulReturn',
	                    creditReturn: 'creditReturn'
	                };
	
	                return actions.hasOwnProperty(this.action);
	            },
	
	            showRYP: function showRYP() {
	                return !this.isEbayTxn();
	            },
	
	            requiresOAuth: function requiresOAuth() {
	                return this.action === ACTION.login || this.action === ACTION.signup;
	            },
	
	            requiresRedirectUri: function requiresRedirectUri() {
	                return this.action === ACTION.mandate || !this.requiresOAuth();
	            },
	
	            validRedirectUri: function validRedirectUri() {
	                if (this.requiresRedirectUri()) {
	                    return Boolean(this.redirect_uri);
	                }
	                return true;
	            },
	
	            validate: function validate() {
	                var error;
	                var success = true;
	
	                if (this.isEbayTxn()) {
	                    if (!this.validAction()) {
	                        success = false;
	                        error = 'invalid_action';
	                    } else if (!this.validRedirectUri()) {
	                        success = false;
	                        error = 'invalid_redirect_uri';
	                    }
	                }
	
	                return {
	                    success: success,
	                    error: error
	                };
	            },
	
	            errorUrl: function errorUrl(err, errorDesc) {
	                var url = this.redirect_uri;
	
	                url += url && url.indexOf('?') < 0 ? '?' : '&';
	                url += 'state=' + encodeURIComponent(this.state);
	
	                if (err) {
	                    url += '&error=' + err;
	                }
	                if (errorDesc) {
	                    url += '&error_description=' + errorDesc;
	                }
	
	                return url;
	            },
	
	            successUrl: function successUrl(code) {
	                var url = this.redirect_uri;
	
	                url += url && url.indexOf('?') < 0 ? '?' : '&';
	                url += 'state=' + encodeURIComponent(this.state);
	
	                url += '&code=' + code;
	
	                return url;
	            },
	
	            rmEnabled: function rmEnabled(featureEnabled) {
	                return featureEnabled && this.action === ACTION.login;
	            },
	
	            hideRM: function hideRM() {
	                return angular.isDefined(this.hide_rm) ? this.hide_rm.toLowerCase() === 'true' : false;
	            }
	        });
	    }).factory('$UserInfoModel', function ($Model, $Api) {
	        return $Model.extend('UserInfoModel', {
	            api: new $Api({
	                uri: '/api/user/:id/session'
	            })
	        });
	    }).factory('$ValidatePhoneModel', function ($Model, $Api) {
	
	        return $Model.extend('validatePhoneModel', {
	            api: new $Api({
	                uri: '/api/user/:token/session/validatePhone',
	                cache: false
	            })
	        });
	    }).factory('$AddKYCModel', function ($Model, $Api) {
	        return $Model.extend('AddKYCModel', {
	            api: new $Api({
	                uri: '/api/user/:token/session/addKYC'
	            })
	        });
	    }).factory('$PatchPhoneModel', function ($Model, $Api) {
	
	        return $Model.extend('patchPhoneModel', {
	            api: new $Api({
	                uri: '/api/checkout/:token/session/patch',
	                cache: false
	            })
	        });
	    }).factory('$WaxUserModel', function ($Model, $Api) {
	        return $Model.extend('WaxUserModel', {
	            api: new $Api({
	                uri: '/api/user/:id/waxUser'
	            })
	        });
	    }).factory('$EConsentModel', function ($Model, $Api) {
	        return $Model.extend('EConsentModel', {
	            api: new $Api({
	                uri: '/api/user/eConsent'
	            })
	        });
	    }).factory('$UserPhotoModel', function ($Model, $Api, $config) {
	        return $Model.extend('UserPhotoModel', {
	            api: new $Api({
	                baseURI: $config.urls.baseUrl,
	                uri: 'api/user/photo'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/user", "components/xo-models/src/user/index.js"))

/***/ },

/***/ "./components/xo-login-components/src/login/props.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-login-props', ['squid']).factory('$loginProps', function ($rootScope, $window, $logger) {
	
	        var RISKY_LOGIN_TITLE = {
	            ECONSENT_REQUIRED: '',
	            ELV_DECLINE: '',
	            EXPIRED_CREDIT_CARD: 'login.riskyLoginUpdateCard',
	            INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: '',
	            NEED_CREDIT_CARD: 'login.riskyLoginAddCard',
	            NEED_CREDIT_CARD_OR_BANK_ACCOUNT: 'login.riskyLoginAddFi',
	            NEED_CONFIRMED_CARD: '',
	            NEED_AUTHENTICATED_CARD: 'login.riskyLoginUpdateCard',
	            NEED_SHIPPING_ADDRESS: 'login.riskyLoginAddShipping',
	            PHONE_NUMBER_REQUIRED: 'login.riskyLoginAddPhone',
	            PAYER_AUTHENTICATION_REQUIRED: 'login.riskyLoginShippingPassed',
	            SEPA_MANDATE_ACCEPTANCE_NEEDED: 'login.riskyLoginSepa',
	            TAX_ID_REQUIRED: ''
	        };
	        var RISKY_LOGIN_SUBTITLE = {
	            EXPIRED_CREDIT_CARD: 'login.riskyLoginExpiredCardST',
	            NEED_SHIPPING_ADDRESS: 'login.riskyLoginAddShippingST',
	            PHONE_NUMBER_REQUIRED: 'login.riskyLoginAddPhoneST',
	            SEPA_MANDATE_ACCEPTANCE_NEEDED: 'login.riskyLoginSepaST',
	            PAYER_AUTHENTICATION_REQUIRED: 'login.riskyLoginShippingPassedST'
	        };
	
	        return {
	            mapInfo: function mapInfo(contingency) {
	                var contingencyTitle = RISKY_LOGIN_TITLE[contingency] ? RISKY_LOGIN_TITLE[contingency] : 'login.loginContingency';
	                var contingencySubTitle = RISKY_LOGIN_SUBTITLE[contingency];
	                return { title: contingencyTitle, subtitle: contingencySubTitle };
	            },
	
	            inList: function inList(contingency) {
	                return RISKY_LOGIN_TITLE.hasOwnProperty(contingency);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/login", "components/xo-login-components/src/login/props.js"))

/***/ },

/***/ "./components/xo-form-components/src/language-options/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/language-options/template.html"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	    squid.module('xo-language-options.directive', ['squid', 'xo-accessibility.directive']).directive('xoLanguageOptions', function () {
	        return {
	            template: template,
	
	            scope: {},
	
	            controller: function controller($scope, $populate, $locale, $Class, $config, $meta) {
	                $scope.showLanguages = false;
	
	                function setLanguageVars() {
	                    $scope.localeModel = $locale;
	                    $scope.currentLanguage = $scope.localeModel.lang;
	                    $scope.currentCountry = $scope.localeModel.country;
	                    $scope.languageList = $scope.localeModel.metadata.languageLabel;
	                    $scope.supportedLanguages = $config.supportedCountries[$scope.currentCountry];
	                    $scope.hasMultipleLanguages = $scope.supportedLanguages && $scope.supportedLanguages.length > 1 ? true : false;
	                }
	
	                $scope.selectLanguage = function (language) {
	                    $scope.currentLanguage = language;
	                    $locale.chooseLang(language);
	                };
	
	                $scope.toggle = function ($event) {
	                    if ($event) {
	                        $event.preventDefault();
	                    }
	
	                    $scope.showLanguages = !$scope.showLanguages;
	                };
	
	                setLanguageVars();
	
	                // Reset locale properties for languageToggle
	                $scope.$on('localeChange', function () {
	                    setLanguageVars();
	                });
	
	                // "clickBody" is an artifical event broadcast by the xo-checkout component (essentially document.click)
	                $scope.$on('clickBody', function ($event, target) {
	                    if ($(target).parents('.languageToggleDisplay div').length === 0) {
	                        $scope.showLanguages = false;
	                        $scope.$apply();
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/language-options/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"languageToggleDisplay\" content feature=\"languageToggle\" ng-if=\"hasMultipleLanguages\">\n    <div>\n        <a id=\"clickLanguageToggle\" lang=\"{{ currentLanguage }}\" aria-expanded=\"{{showLanguages}}\" aria-label=\"{{ content('languages.label', {language: languageList[currentLanguage]}) }}\" ng-click=\"toggle()\" select-button focus-when=\"!showLanguages\" focused-once-before><span class=\"displayText\">{{languageList[currentLanguage]}}</span><span class=\"changeLanguage\" ng-class=\"{expand:showLanguages}\"></span></a>\n    </div>\n    <div id=\"langDropdownBlock\" ng-show=\"showLanguages\" class=\"bottom\">\n        <div class=\"arrow\"></div>\n        <div ng-click=\"toggle()\">\n            <ul aria-labelledby=\"clickLanguageToggle\" select-box=\"showLanguages && supportedLanguages\" select-cancel=\"toggle()\">\n                <li role=\"presentation\" ng-repeat=\"lang in supportedLanguages\" lang=\"{{ lang }}\">\n                    <a track-link=\"language_change\" class=\"submit\" ng-click=\"selectLanguage(lang)\" link-button select-option=\"lang == currentLanguage\" focus-when=\"showLanguages && lang == currentLanguage\">{{languageList[lang]}}</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>"

/***/ },

/***/ "./components/xo-ui-components/src/accessibility/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _ui = __webpack_require__("./components/xo-ui-components/src/accessibility/ui.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Adds role='button' and tabindex='0' to anchor elements
	// so that it is keyboard navigable and recognized by screen
	// readers as a button.
	//
	// As anchors without href do not fire their click event
	// automatically on a Space or ENTER key, this directive forces
	// that functionality.
	//
	// If something is assigned to the link-button attribute, then
	// it is used as an aria-label.
	(0, _angular.$registerDirective)('link-button', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var ariaLabel = (0, _angular.$parse)(attrs.linkButton)(scope);
	            var $element = (0, _jquery2['default'])(element);
	
	            $element.attr('role', 'button');
	            $element.attr('tabindex', '0');
	            if (ariaLabel) {
	                $element.attr('aria-label', ariaLabel);
	            }
	            $element.on('keydown', function (event) {
	                // do nothing if there is an alt or ctrl key as well
	                if (!(event.altKey || event.ctrlKey)) {
	                    switch (event.keyCode) {
	                        case _ui.KEYS.SPACE:
	                        case _ui.KEYS.ENTER:
	                            element[0].click();
	                            return false;
	                        default:
	                            break;
	                    }
	                }
	                return true;
	            });
	        }
	    };
	});
	
	// this directive gives an element characteristics of a native
	// select element in terms of keyboard navigation. It becomes reachable
	// via the tab key, reflects screenreader characteristics and
	// can be activated by any of the DOWN, SPACE or ENTER KEYS.
	(0, _angular.$registerDirective)('select-button', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var $element = (0, _jquery2['default'])(element);
	            $element.attr('role', 'button').attr('aria-haspopup', 'true').attr('tabindex', '0').on('keydown', function (event) {
	                // do nothing if there is an alt or ctrl key as well
	                if (!(event.altKey || event.ctrlKey)) {
	                    switch (event.keyCode) {
	                        case _ui.KEYS.DOWN:
	                        case _ui.KEYS.SPACE:
	                        case _ui.KEYS.ENTER:
	                            element[0].click();
	                            return false;
	                        default:
	                            break;
	                    }
	                }
	                return true;
	            });
	        }
	    };
	});
	
	// this directive makes a container with links act as if it were a select dropdown
	// in terms of keyboard accessibility. The following characteristics are implemented:
	//
	// * UP/RIGHT and DOWN/lEFT KEYS navigate through the options.
	// * ESC cancels and closes the dropdown
	// * SPACE or ENTER select an option
	// * You cannot TAB out of a dropdown until you select or cancel
	//
	// in addition, the following extra characteristics are implemented
	//
	// * The TAB (and SHIFT-TAB) key will also function to move between options
	// * Upon reaching the end of the list, the focus will shift back to the first item, and vice versa
	//
	// How to use:
	// 1. The select-cancel attribute is an agnostic expression to implement the cancel / back mechanic.
	//    The expression is run whenever the ESC key is pressed.
	// 2. The select-allow-tab-escape attribute can be added alongside the select-box attribute to allow
	//    tabs to escape the select-box element.
	(0, _angular.$registerDirective)('select-box', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var allowTabEscape = (0, _angular.isDefined)(attrs.selectAllowTabEscape);
	
	            function escapeToggle() {
	                if (attrs.selectCancel) {
	                    (0, _angular.$parse)(attrs.selectCancel)(scope);
	                    scope.$apply();
	                }
	            }
	
	            element.attr('role', 'menu');
	
	            element.on('keydown.selectBox', function (event) {
	                var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
	                var $origin = (0, _jquery2['default'])(event.target);
	
	                if (!(event.altKey || event.ctrlKey)) {
	                    var index = $allTabbable.index($origin);
	
	                    switch (event.keyCode) {
	                        case _ui.KEYS.TAB:
	                            if (allowTabEscape && (index === 0 && event.shiftKey || index === $allTabbable.length && !event.shiftKey)) {
	                                // Enable default behavior to escape select-box
	                                escapeToggle();
	                                break;
	                            } else if (event.shiftKey) {
	                                index = (index - 1 + $allTabbable.length) % $allTabbable.length;
	                            } else {
	                                index = (index + 1) % $allTabbable.length;
	                            }
	                            $allTabbable.eq(index).focus();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.DOWN:
	                        case _ui.KEYS.RIGHT:
	                            index = (index + 1) % $allTabbable.length;
	                            $allTabbable.eq(index).focus();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.UP:
	                        case _ui.KEYS.LEFT:
	                            index = (index - 1 + $allTabbable.length) % $allTabbable.length;
	                            $allTabbable.eq(index).focus();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.SPACE:
	                        case _ui.KEYS.ENTER:
	                            $origin.click();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.ESC:
	                            escapeToggle();
	                            break;
	                        default:
	                            break;
	                    }
	                }
	            });
	        }
	    };
	});
	
	// similar to select-box, this directive restrains tabbing within a container
	// to the container itself.
	//
	// 1. modal-cancel is the equivalent of select-cancel from select-box, and
	// should define a cancellation / ESC function.
	(0, _angular.$registerDirective)('modal-box', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function escapeToggle() {
	                (0, _angular.$parse)(attrs.modalCancel)(scope);
	                scope.$apply();
	            }
	
	            // Gets the index of the element that should be focused after pressing Tab
	            function getNextIndex($element, $elements, shift) {
	                if (shift) {
	                    return ($elements.index($element) - 1 + $elements.length) % $elements.length;
	                } else {
	                    return ($elements.index($element) + 1) % $elements.length;
	                }
	            }
	
	            if ((0, _angular.$parse)(attrs.modalBox)(scope) !== false) {
	                element.on('keydown.modalBox', function (event) {
	                    var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
	                    var $origin = (0, _jquery2['default'])(event.target);
	
	                    if (!(event.altKey || event.ctrlKey)) {
	                        switch (event.keyCode) {
	                            case _ui.KEYS.TAB:
	                                var index = getNextIndex($origin, $allTabbable, event.shiftKey);
	                                $allTabbable.eq(index).focus();
	                                event.preventDefault();
	                                event.stopPropagation();
	                                break;
	                            case _ui.KEYS.ESC:
	                                escapeToggle();
	                                event.preventDefault();
	                                event.stopPropagation();
	                                break;
	                            default:
	                                break;
	                        }
	                    }
	                });
	            }
	        }
	    };
	});
	
	// A simple version of modal that doesn't rely on controlling keyboard behavior
	// as strictly. Should be used in cases where tab items are not as easily accessible
	// via JS (ie. iframes)
	// Redirects focus to container when focusin event fired on element not in container
	(0, _angular.$registerDirective)('simple-modal', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.attr('tabindex', '-1');
	
	            var cancelFn;
	            if (attrs.modalCancel) {
	                cancelFn = function cancelFn() {
	                    (0, _angular.$parse)(attrs.modalCancel)(scope);
	                    scope.$apply();
	                };
	            }
	
	            function registerModal() {
	                (0, _jquery2['default'])(document).on('focusin.simple-modal', function (event) {
	                    if (!element[0].contains(event.target)) {
	                        event.stopPropagation();
	                        element.focus();
	                    }
	                });
	                if (cancelFn) {
	                    (0, _jquery2['default'])(document).on('click.simple-modal', function (event) {
	                        if (!element[0].contains(event.target)) {
	                            deregisterModal();
	                            cancelFn();
	                        }
	                    });
	                }
	            }
	
	            function deregisterModal() {
	                (0, _jquery2['default'])(document).off('focusin.simple-modal');
	                (0, _jquery2['default'])(document).off('click.simple-modal');
	            }
	
	            // Watch the expression provided to simpleModal and add modal behavior when
	            // expression result changes to truthy
	            if ((0, _angular.isDefined)(element.attr('simpleModal'))) {
	                scope.$watch(attrs['simpleModal'], function (newVal) {
	                    if (newVal) {
	                        registerModal();
	                    } else {
	                        deregisterModal();
	                    }
	                });
	            } else {
	                registerModal();
	            }
	
	            scope.$on('$destroy', deregisterModal);
	        }
	    };
	});
	
	// this directive gives an element characteristics of a native
	// option element in terms of aria attributes. It must be used
	// as a child of a selectBox for proper keyboard behavior as it
	// disables default tabbing behavior.
	//
	// The expression provided to the directive is used to set the
	// aria-selected attribute when the expression evaluates to true.
	(0, _angular.$registerDirective)('select-option', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            (0, _jquery2['default'])(element).attr('role', 'menuitem');
	            if ((0, _angular.$parse)(attrs.selectOption)(scope)) {
	                (0, _jquery2['default'])(element).attr('aria-selected', 'true');
	            }
	        }
	    };
	});
	
	// adapted from http://stackoverflow.com/a/24416690
	// This directive makes the element focused when the expression
	// provided _changes_ to true.
	//
	// In order to avoid conflicts with autofocus when a page first loads,
	// adding the focused-once-before attribute will enable the expression
	// only if it has been focused on before.
	//
	// * if the element itself is not focusable, then it will locate the first focusable
	// element within it.
	// * if the additional attribute focus-element is provided, it is wrapped
	// as a jQuery element (could be selector string or actual element) and focused on
	// it will be parsed when the focus-when attribute is true
	// * if the attribute focus-on is provided, then the focus-when attribuet is ignored and
	// the directive listens to the event specified by focus-on
	(0, _angular.$registerDirective)('focus-when', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	
	            function locateAndFocus(active) {
	                (0, _angular.$timeout)(function () {
	                    if (active) {
	                        // deal with figuring out which element to focus on
	                        var $elementToFocus = (0, _jquery2['default'])(); // start with "monad" to make life easier
	                        var directiveElementFocusable = (0, _ui.focusable)(element[0]);
	
	                        // this works by fallthrough. it will try each one
	                        // in succession until an element is found
	                        if (attrs.focusElement) {
	                            // scenario 1 - specific element provided
	                            $elementToFocus = (0, _ui.filterAll)((0, _angular.$parse)(attrs.focusElement)(scope), _ui.focusable);
	                        }
	
	                        if ($elementToFocus.length === 0 && !directiveElementFocusable) {
	                            // scenario 2 - element with directive is not focusable
	                            $elementToFocus = (0, _ui.findAll)(element, _ui.focusable);
	                        }
	
	                        // default / scenario 3 - no valid targets specified or found
	                        if ($elementToFocus.length === 0) {
	                            $elementToFocus = (0, _jquery2['default'])(element);
	                        }
	
	                        $elementToFocus.first().focus();
	                    }
	                });
	            }
	
	            var active = true;
	
	            if ('focusedOnceBefore' in attrs) {
	                active = false;
	                (0, _jquery2['default'])(element).on('focus', function () {
	                    active = true;
	                });
	            }
	
	            if (attrs.focusRefreshOn) {
	                scope.$on((0, _angular.$parse)(attrs.focusRefreshOn)(scope), function () {
	                    locateAndFocus(active);
	                });
	            } else {
	                scope.$watch(attrs.focusWhen, function (val) {
	                    locateAndFocus(active && val);
	                });
	            }
	        }
	    };
	});
	
	// angularUI router specific - listens to a specific transition
	// defined in two attributes, focusWhenState (this directive) and TransitionsTo
	var FOCUS_EVENT_NAME = 'accessible-focus';
	(0, _angular.$registerDirective)('focus-when-state', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var startState = attrs.focusWhenState;
	            var endState = attrs.transitionsTo;
	            var transitionMessage = startState + ' > ' + endState;
	            var unregisterEventFn = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	                if (fromState.name === startState && toState.name === endState) {
	                    scope.$broadcast(FOCUS_EVENT_NAME, transitionMessage);
	                }
	            });
	
	            scope.$on(FOCUS_EVENT_NAME, function (event, message) {
	                if (message === transitionMessage) {
	                    (0, _angular.$timeout)(function () {
	                        return element[0].focus();
	                    });
	                }
	            });
	
	            // see http://stackoverflow.com/a/27016855
	            scope.$on('$destroy', unregisterEventFn);
	        }
	    };
	});
	
	// Listens for the next state transition and focuses an element provided by selector
	// Use with links where focus is needed to return to a specific element after the transition
	(0, _angular.$registerDirective)('focus-after-transition', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.on('click', function () {
	                var focusSelector = attrs['focusAfterTransition'];
	                var cancel = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	                    cancel();
	                    (0, _angular.$timeout)(function () {
	                        (0, _jquery2['default'])(focusSelector).focus();
	                    });
	                });
	            });
	        }
	    };
	});
	
	// focuses on the first focusable element on a container containing form elements
	(0, _angular.$registerDirective)('form-autofocus', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            // wait for the entire DOM to settle down first
	            (0, _angular.$timeout)(function () {
	                var $allFocusable = (0, _ui.findAll)(element, _ui.focusable);
	                if ($allFocusable.length > 0) {
	                    $allFocusable.first().focus();
	                }
	            });
	        }
	    };
	});
	
	// Change element to be focusable and tabbable or unfocusable if it is
	// not typically a focusable element by removing the tabindex attribute.
	(0, _angular.$registerDirective)('focusable', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function setFocusable(value) {
	                if (value) {
	                    element.attr('tabindex', 0);
	                } else {
	                    element.removeAttr('tabindex');
	                }
	            }
	
	            if (attrs.focusable) {
	                scope.$watch(attrs.focusable, function (newVal) {
	                    if (newVal) {
	                        setFocusable(true);
	                    } else {
	                        setFocusable(false);
	                    }
	                });
	            } else {
	                setFocusable(true);
	            }
	        }
	    };
	});
	
	_angular.$registerDirective;
	
	_angular.$parse;
	
	_angular.$timeout;
	
	_angular.$rootScope;
	
	_angular.isDefined;
	
	_ui.KEYS;
	
	_ui.focusable;
	
	_ui.tabbable;
	
	_ui.findAll;
	
	_ui.filterAll;

/***/ },

/***/ "./components/xo-ui-components/src/accessibility/ui.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.filterAll = exports.findAll = exports.tabbable = exports.focusable = exports.visible = exports.KEYS = undefined;
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var KEYS = {
	    TAB: 0x09,
	    ENTER: 0x0D,
	    ESC: 0x1B,
	    SPACE: 0x20,
	    LEFT: 0x25,
	    UP: 0x26,
	    RIGHT: 0x27,
	    DOWN: 0x28
	};
	
	function visible(element) {
	    return _jquery2['default'].expr.filters.visible(element) && !(0, _jquery2['default'])(element).parents().addBack().filter(function () {
	        return _jquery2['default'].css(this, 'visibility') === 'hidden';
	    }).length;
	}
	
	// ripped from http://stackoverflow.com/a/7668761
	/* istanbul ignore next */
	function focusable(element) {
	    var nodeName = element.nodeName.toLowerCase();
	    var isTabIndexNotNaN = !isNaN(_jquery2['default'].attr(element, 'tabindex'));
	    var map;
	    var mapName;
	    var img;
	
	    if (nodeName === 'area') {
	        map = element.parentNode;
	        mapName = map.name;
	        if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
	            return false;
	        }
	        img = (0, _jquery2['default'])('img[usemap=#' + mapName + ']')[0];
	        return !!img && visible(img);
	    }
	    return (/^(input|select|textarea|button|object)$/.test(nodeName) ? // eslint-disable-line no-nested-ternary
	    !element.disabled : nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) &&
	    // the element and all of its ancestors must be visible
	    visible(element);
	}
	
	/* istanbul ignore next */
	function tabbable(element) {
	    var tabIndex = _jquery2['default'].attr(element, 'tabindex');
	    var isTabIndexNaN = isNaN(tabIndex);
	
	    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
	}
	
	function filterAll(elements, filterFn) {
	    return (0, _jquery2['default'])(elements).filter(function () {
	        return filterFn(this);
	    });
	}
	
	function findAll(container, filterFn) {
	    return filterAll((0, _jquery2['default'])(container).find('*'), filterFn);
	}
	
	exports.KEYS = KEYS;
	exports.visible = visible;
	exports.focusable = focusable;
	exports.tabbable = tabbable;
	exports.findAll = findAll;
	exports.filterAll = filterAll;

/***/ },

/***/ "./components/xo-login-components/src/unified-login/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/unified-login/template.html"), __webpack_require__("./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js"), __webpack_require__("./components/xo-tracking/dist/index.js"), __webpack_require__("./components/ul-inline/dist/inject.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	    return angular.module('xo-unified-login.directive', ['squid', 'xo-unified-login.kmliUpsell', 'tracking', 'xolocale', 'xo-device-info', 'xo-fn']).directive('xoUnifiedLogin', function () {
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                redirectUri: '=',
	                parentCallback: '=',
	                doneFn: '=',
	                errorFn: '=',
	                autoLogin: '=',
	                promptlogin: '=',
	                logoutCallback: '=',
	                kmli: '=',
	                preAuth: '=',
	                postAuth: '=',
	                flowcontext: '='
	            },
	            controller: function controller($scope, $populate, $rootScope, $CheckoutAppDataModel, $LocaleModel, $config, $state, $stateParams, $timeout, $FallbackError, $KmliUpsell, $logger, $locale, $fpti, $AuthModel, $ULoginModel, $util, $pxp, $CalDataModel, $meta, $DeviceInfo, $pxpMatch, $feature, $q, $promise, $CheckoutCartModel, $fn, $window) {
	                var PAYPAL = window.PAYPAL || {};
	                var loginAttemptedMethod = '';
	                var userSelectedLanguage = '';
	                var failureReasons = {
	                    timeout: 'TIMEDOUT',
	                    error: 'INTERNALERROR',
	                    blacklistedDevice: 'PLATFORM_NOT_SUPPORTED',
	                    fallback: 'FALLBACK'
	                };
	                var enteringTime = Date.now();
	                $logger.debug('ENTERING_LOADING_UL_IFRAME', { enteringTime: enteringTime });
	                $scope.locale = $LocaleModel.instance();
	                $scope.forcedLogin = !$scope.autoLogin; // change to true during forcedLogin scenario
	
	                if ($stateParams.source === 'NOT_YOU' || $stateParams.source === 'FRESH_START') {
	                    $scope.forcedLogin = false;
	                }
	
	                var ulTimeoutLimit = 35000;
	                var ulTimeoutPromise = null;
	
	                var loadCnt = 0;
	
	                function setLoading(tag, isRT) {
	                    $rootScope.$emit('loading');
	                    if (isRT && !$scope.auth.loggedIn()) {
	
	                        if ($feature('rmSpinnerText')) {
	                            $rootScope.$emit('loadingMessage', {
	                                heading: $locale.content.get('base.loggingIn'),
	                                subHeading: $locale.content.get('login.rmSubHeading')
	                            });
	                        } else {
	                            $rootScope.$emit('loadingMessage', $locale.content.get('base.loggingIn'));
	                        }
	                    }
	                    loadCnt++;
	                    $logger.debug('setLoading by ' + tag + ' cnt ' + loadCnt);
	                }
	
	                function setLoaded(tag) {
	                    if (loadCnt > 0) {
	                        $rootScope.$emit('loaded');
	                        loadCnt--;
	                    } else {
	                        $logger.error('loadCnt_zero');
	                    }
	                    $logger.debug('setLoaded by ' + tag + ' cnt ' + loadCnt);
	                }
	
	                function fallback(product, reason, params) {
	                    throw new $FallbackError({
	                        product: product || 'ux',
	                        reason: reason,
	                        params: params
	                    });
	                }
	
	                function appLoginHandler(status) {
	                    $logger.debug('ULLOGIN_' + status);
	                    $logger.info('checkout_fpti', { 'from': 'LOGIN', 'to': 'prepare_login' });
	                    fallback('ux', 'ul_server_error');
	                }
	
	                var startTimerTS;
	                function startTimer(tag) {
	                    startTimerTS = Date.now();
	
	                    $logger.debug('startTimer by ' + tag, {
	                        startTime: startTimerTS
	                    });
	                    $logger.info('checkout_fpti', {
	                        'from': 'UL_Timer',
	                        'to': 'prepare_' + tag
	                    });
	
	                    ulTimeoutPromise = $timeout(function () {
	                        $logger.error('load_ul_timeout');
	                        var stop_time = Date.now();
	                        var time_taken = stop_time - startTimerTS;
	                        $logger.info('checkout_fpti', {
	                            'from': 'UL_Timer',
	                            'to': 'process_timeout',
	                            'int_error_code': 'ULLOGIN_TIMEOUT',
	                            'int_error_description': 'ULLOGIN_TIMEOUT',
	                            'error_source': 'unifiedloginnodeweb',
	                            'error_type': 'soft_decline',
	                            'page_load_time': time_taken
	                        });
	                        if (!$config.disableUlTimeout) {
	                            fallback('ux', 'ul_load_timeout');
	                        }
	                    }, ulTimeoutLimit);
	                }
	
	                function stopTimer(tag, keepLoading) {
	                    var stopTimerTS = Date.now();
	                    var timeTaken = stopTimerTS - startTimerTS;
	
	                    $logger.debug('stopTimer by ' + tag, {
	                        stopTimer: stopTimerTS,
	                        page_load_time: timeTaken
	                    });
	
	                    $logger.info('checkout_fpti', {
	                        'from': 'UL_Timer',
	                        'to': 'process_' + tag,
	                        'page_load_time': timeTaken
	                    });
	
	                    if (!keepLoading) {
	                        setLoaded('stopTimer');
	                    }
	
	                    if (ulTimeoutPromise) {
	                        $timeout.cancel(ulTimeoutPromise);
	                    }
	                }
	
	                function logFptiData(fptiData, eventName) {
	                    var errorDescription;
	                    switch (eventName) {
	                        case '2fa':
	                            errorDescription = '2fa_required';
	                            break;
	                        case 'safeRequired':
	                            errorDescription = 'SAFE_required';
	                            break;
	                        case 'stepupRequired':
	                            errorDescription = 'Login_ATO_required';
	                            break;
	                        default:
	                        // nothing to do here
	                    }
	                    $logger.info('checkout_fpti', {
	                        'from': fptiData.fptiState,
	                        'to': fptiData.fptiTransition,
	                        'int_error_code': eventName,
	                        'int_error_description': errorDescription,
	                        'error_type': 'soft_decline',
	                        'error_source': 'unifiedloginnodeweb'
	                    });
	                }
	
	                function buildRedirectURL(contingencyUrl, eventName) {
	                    var authChallengeUrl = contingencyUrl;
	                    var paramIndex = authChallengeUrl.indexOf('?');
	                    var urlParams = $util.params(authChallengeUrl.substring(paramIndex + 1));
	
	                    urlParams.returnUri = $config.ulMeta.authChallengeReturnUri;
	                    if (userSelectedLanguage) {
	                        urlParams['locale.x'] = $locale.getLocaleCode();
	                        urlParams['state'] += '&locale.test=' + $locale.getLocaleCode();
	                    }
	                    switch (eventName) {
	                        case '2fa':
	                            urlParams['state'] += '&acRedirect=2fa&ulMethod=' + loginAttemptedMethod;
	                            break;
	                        case 'safeRequired':
	                            urlParams['state'] += '&acRedirect=safe';
	                            break;
	                        case 'stepupRequired':
	                            urlParams['state'] += '&acRedirect=loginato';
	                            break;
	                        default:
	                        // nothing to do here
	                    }
	                    var redirectUrl = $util.buildURL(authChallengeUrl.substring(0, paramIndex), urlParams);
	                    return redirectUrl;
	                }
	
	                if (!$config.ulMeta) {
	                    $logger.error('config_no_ulMeta');
	                }
	
	                var ulMeta = $config.ulMeta || {};
	
	                $populate($scope, {
	                    auth: $AuthModel.instance(),
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token)
	                }).then(function () {
	                    var country = $scope.checkoutAppData.merchant.merchant_country;
	                    var pxpKmli = $pxp(ulMeta.pxpExpId, { 'ctx.COUNTRY': country }, 'xo_hermesnode_kmli_(web|mobile)_treatment');
	                    var pxpTimeoutTrt = $pxp(ulMeta.pxpExpId, { 'ctx.COUNTRY': country }, 'xo_hermes_ul_timeout_treatment.*');
	                    var preloadUL = $pxp(ulMeta.pxpExpId, { 'ctx.COUNTRY': country }, 'xo_hermes_ul_preload_treatment');
	                    var configPxpResults = $pxpMatch(ulMeta.hermesnodePxpConfig, { 'ctx.COUNTRY': country }, {
	                        pxpSAFE: 'xo_hermesnode_ul_safe_treatment'
	                    });
	
	                    return $q.all([pxpKmli, configPxpResults, pxpTimeoutTrt, preloadUL]).then(function (result) {
	                        var kmliTreatments = result[0];
	                        var config_pxp_treatments = result[1];
	                        if (config_pxp_treatments) {
	                            $scope.safeEligibility = config_pxp_treatments['pxpSAFE'];
	                        }
	                        $scope.kmliEligibility = Boolean(kmliTreatments && kmliTreatments.treatment_name);
	                        var timeoutTrtFact = result[2] && angular.isArray(result[2].factors);
	                        var pxpTimeoutVal = timeoutTrtFact && result[2].factors[0] && result[2].factors[0].value;
	                        if (pxpTimeoutVal) {
	                            ulTimeoutLimit = pxpTimeoutVal;
	                            $logger.info('pxp_timeout_treatment', {
	                                'ulTimeoutLimit': ulTimeoutLimit
	                            });
	                        }
	                        var preloadULTreatments = result[3];
	
	                        // Allow all IE traffic irrespective of PXP
	                        var userAgent = $window.navigator.userAgent;
	                        var isIE = !!userAgent.match(/MSIE|trident|edge/i);
	                        // Check force param
	                        var forceUlss = $util.param('_ulss') === 'true';
	
	                        $scope.preloadUL = Boolean(preloadULTreatments && preloadULTreatments.treatment_name) || isIE || forceUlss;
	                    });
	                }).then(function () {
	                    if ($scope.preloadUL) {
	                        $logger.debug('ULSS_CLIENT_PRELOAD_TREATMENT');
	                        return $populate($scope, { ulSource: $ULoginModel.instance() });
	                    }
	                }).then(function () {
	                    var isRememberedUser = $scope.auth.refreshToken();
	                    setLoading('loadUL', isRememberedUser);
	
	                    // STEP1: Check PXP response
	                    var pxpGroup = $scope.kmliEligibility ? 'pxpTreatment' : 'pxpControl';
	
	                    var reasons = [];
	                    reasons.push(pxpGroup);
	
	                    // STEP2: Check for conditions that deviates from the PXP eligibility
	                    function routingReason() {
	                        if ($scope.kmli === true) {
	                            return 'kmliMandated';
	                        } else if (isRememberedUser) {
	                            return 'rememberedUser';
	                        } else if ($util.param('ul') === '2') {
	                            return 'ulParam';
	                        } else if ($meta.corp && ulMeta.allowKMLIForInternalIP) {
	                            var merchantCountry = $scope.checkoutAppData.merchant.merchant_country;
	                            if ($feature('enableOneTouchInternalIP', false, merchantCountry)) {
	                                return 'internalIP';
	                            }
	                        } else if (ulMeta.enableOneTouchByDefault) {
	                            return 'oneTouchByDefault';
	                        }
	                    }
	
	                    // Reasons that deviates from control to treatment
	                    var rr = pxpGroup === 'pxpControl' && routingReason();
	                    if (rr) {
	                        $scope.kmliEligibility = true;
	                        reasons.push(rr);
	                    }
	
	                    // STEP3: Check for compatibility/environment issues which impacts UL/KMLI overall
	                    // This should override previous decisions
	                    if ($DeviceInfo.isApp()) {
	                        $scope.kmliEligibility = false;
	                        reasons.push('Webview');
	                    } else if (!$util.cookiesEnabled()) {
	                        $scope.kmliEligibility = false;
	                        reasons.push('cookiesDisabled');
	                    } else if ($scope.auth.ota) {
	                        $scope.kmliEligibility = false;
	                        reasons.push('otaDevice');
	                    }
	
	                    if ($scope.forcedLogin === true) {
	                        $scope.kmliEligibility = false;
	                        reasons.push('forcedLogin');
	                    }
	                    if ($scope.logoutCallback) {
	                        $scope.kmliEligibility = true;
	                        reasons.push('riskyLoginContingency');
	                    }
	
	                    var routing_reason = reasons[reasons.length - 1];
	
	                    // STEP4: Instrument deterministically whether KMLI is shown to the user or not
	                    var rememberMe = $scope.kmliEligibility;
	                    $logger.debug($scope.kmliEligibility ? 'KMLI_ELIGIBLE_USER' : 'KMLI_INELIGIBLE_USER', { userGroup: reasons, routing_reason: routing_reason });
	                    $logger.info('checkout_fpti', {
	                        'from': 'KMLI_ELG_CHK',
	                        'to': 'process_kmli_elg_chk',
	                        'routing_reason': routing_reason
	                    });
	
	                    var app_int_type = $DeviceInfo.getAppIntegrationType();
	
	                    if (isRememberedUser && !$scope.forcedLogin) {
	                        $logger.info('checkout_fpti', {
	                            'from': 'LOGIN_UL_RM',
	                            'to': 'prepare_login_ul_RM',
	                            'app_int_type': app_int_type
	                        });
	                    }
	
	                    function getPostLoginFpti(data) {
	                        var result;
	
	                        if (data.event === 'tokenExchanged') {
	                            result = { fptiState: 'LOGIN_UL_RM', fptiTransition: 'process_RT_AT_exch' };
	                        } else {
	                            var fptiTransitionName = data.keepMeLoggedIn === true ? 'process_login_UL_RM' : 'process_login_UL';
	                            var ULState = rememberMe === true ? 'LOGIN_UL_RM' : 'LOGIN_UL';
	                            result = { fptiState: ULState, fptiTransition: fptiTransitionName };
	                        }
	
	                        return result;
	                    }
	
	                    var cancelLocaleChange;
	
	                    function loginComplete(data) {
	                        $promise.run(function () {
	                            // eslint-disable-line
	
	                            $scope.auth.stepupAuthRequired = false;
	
	                            stopTimer('loginComplete');
	
	                            if (cancelLocaleChange) {
	                                cancelLocaleChange();
	                            }
	
	                            $scope.auth.isKmliSet = data.keepMeLoggedIn || data.event === 'tokenExchanged';
	                            $scope.auth.rtExchanged = data.event === 'tokenExchanged';
	
	                            var fptiData = getPostLoginFpti(data);
	
	                            $logger.info('checkout_fpti', {
	                                'from': fptiData.fptiState,
	                                'to': fptiData.fptiTransition
	                            });
	
	                            if (window.xprops && window.xprops.onAuth && data && data.accessToken) {
	                                return window.xprops.onAuth({
	                                    accessToken: data.accessToken
	                                });
	                            }
	                        }).then(function () {
	
	                            var upsellEligibilityData = {
	                                ulData: data
	                            };
	
	                            // Doesn't exist in risky login case
	                            if ($scope.preAuth) {
	
	                                // Fires off eligibility + econsent + xosession in batch mode
	                                $scope.preAuth();
	                            }
	
	                            if (data.event === 'tokenExchanged') {
	                                if ($feature('rmSpinnerText')) {
	                                    $rootScope.$emit('loadingMessage', {
	                                        heading: $locale.content.get('base.planning'),
	                                        subHeading: $locale.content.get('login.rmSubHeading')
	                                    });
	                                } else {
	                                    $rootScope.$emit('loadingMessage', $locale.content.get('base.planning'));
	                                }
	                            }
	
	                            return $scope.auth.reload({
	                                resultModel: $scope.auth,
	                                headers: {
	                                    'x-paypal-internal-euat': data.accessToken
	                                },
	                                batch: {
	                                    name: 'setbuyer',
	                                    id: 'securityCtx',
	                                    dependencies: []
	                                },
	
	                                success: function success() {
	                                    $scope.auth.is_auth_api_call = data.event === 'tokenExchanged';
	
	                                    angular.extend(upsellEligibilityData, {
	                                        buyerCountry: $scope.auth.country,
	                                        idToken: $scope.auth.idTokenPresent,
	                                        kmliEligible: $scope.kmliEligibility,
	                                        upsellOptInDisplayed: $scope.auth.upsellOptInDisplayed,
	                                        showReactivationInterstitial: $scope.showReactivationInterstitial
	                                    });
	
	                                    $KmliUpsell.init(upsellEligibilityData);
	
	                                    $scope.postAuth($scope.auth);
	                                },
	                                contingencies: {
	                                    DEFAULT: function handleContingency(name, contingency) {
	                                        $scope.auth.password = '';
	                                        $scope.errorFn(name, contingency);
	                                    }
	                                }
	                            });
	                        });
	                    }
	
	                    var ulEventHandlers = {
	                        'loginRendered': function loginRendered() {
	                            var loadingCompletedTime = Date.now();
	                            $logger.debug('ULLOGIN_FRAME_LOADED_SUCCESSFULLY', {
	                                page_load_time: loadingCompletedTime - enteringTime
	                            });
	                        },
	                        'loginFullyLoaded': function loginFullyLoaded(data) {
	                            stopTimer(data.event);
	
	                            if ($scope.notYou) {
	                                $rootScope.$emit('loaded');
	                                delete $scope.notYou;
	                                $logger.info('checkout_fpti', {
	                                    'from': 'LOGIN_UL_RM',
	                                    'to': 'prepare_login_ul'
	                                });
	                                $fn.sendTypingSpeedPayload('HermesUL');
	                                return $scope.logoutCallback();
	                            }
	
	                            if (!$state.current.trackingData) {
	                                $state.current.trackingData = { fptiState: 'ulLoginDefault' };
	                            }
	                            $state.current.trackingData.pageQualifier = 'ulLogin';
	                            var loadingCompletedTime = Date.now();
	                            var timeTaken = loadingCompletedTime - enteringTime;
	                            $logger.debug('ULLOGIN_LOADED_SUCCESSFULLY', {
	                                page_load_time: timeTaken
	                            });
	
	                            if ($scope.preLoadedSource) {
	                                $logger.debug('ULSS_CLIENT_LOADED_SUCCESSFULLY', {
	                                    page_load_time: timeTaken
	                                });
	                            }
	
	                            var ULState = rememberMe === true && !$scope.logoutCallback ? 'LOGIN_UL_RM' : 'LOGIN_UL';
	
	                            $logger.info('checkout_fpti', {
	                                'from': ULState,
	                                'to': 'prepare_iframe',
	                                'page_load_time': timeTaken
	                            });
	
	                            var payload = {
	                                'from': ULState,
	                                'to': 'prepare_login_ul',
	                                'app_int_type': app_int_type
	                            };
	
	                            if ($stateParams.targetPage) {
	                                angular.extend(payload, { 'int_error_code': $stateParams.targetPage });
	                            }
	
	                            $logger.info('checkout_fpti', payload);
	
	                            $fn.sendTypingSpeedPayload('HermesUL');
	                        },
	                        'loginEmailPasswordAttempted': function loginEmailPasswordAttempted() {
	                            loginAttemptedMethod = 'email';
	                        },
	                        'loginPhonePinAttempted': function loginPhonePinAttempted() {
	                            loginAttemptedMethod = 'phone';
	                        },
	                        'loginAttempted': function loginAttempted(data) {
	                            setLoading(data.event);
	                            $rootScope.$emit('loadingMessage', $locale.content.get('base.loggingIn'));
	                            if (rememberMe === true) {
	                                var kmliStatus = data.keepMeLoggedIn === true ? 'KMLI_CHECKED' : 'KMLI_UNCHECKED';
	                                $logger.debug(kmliStatus);
	                            }
	                            startTimer(data.event);
	                        },
	                        'loginSuccess': loginComplete,
	                        'tokenExchanged': loginComplete,
	                        'notYouLinkClicked': function notYouLinkClicked(data) {
	                            $rootScope.$emit('loading');
	                            $scope.notYou = true;
	                            $logger.info('checkout_fpti', {
	                                from: 'LOGIN_UL',
	                                to: 'login_with_diff_user'
	                            });
	                            startTimer(data.event);
	                        },
	                        '2fa': function fa(data) {
	                            stopTimer(data.event);
	                            var fptidata = getPostLoginFpti(data);
	                            logFptiData(fptidata, data.event);
	                            if (data.contingencyUrl) {
	                                $logger.debug('ULLOGIN_TWO_FA_AUTH_REDIRECT');
	                                var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);
	                                $util.redirect(authChallengeRedirectUrl);
	                            } else {
	                                $logger.debug('ULLOGIN_TWO_FA_GENERIC_ERROR');
	                                $state.go('checkout.genericError', { code: 'DEFAULT' });
	                            }
	                        },
	                        'safeRequired': function safeRequired(data) {
	                            stopTimer(data.event);
	                            var fptidata = getPostLoginFpti(data);
	                            logFptiData(fptidata, data.event);
	                            if ($scope.safeEligibility && data.contingencyUrl) {
	                                if (data.authorizationType && data.authorizationType === 'token') {
	                                    // for remembered user redirect to login instead of SAFE APP
	                                    $logger.debug('LOGIN_REDIRECTION_SAFE_RM_USER');
	                                    $state.go('checkout.login', { targetPage: 'LOGIN_CONTINGENCY' });
	                                }
	                                $logger.debug('ULSAFE_REDIRECTION');
	                                var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);
	                                $util.redirect(authChallengeRedirectUrl);
	                            } else {
	                                $logger.debug('ULSAFE_GENERIC_ERROR');
	                                $state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
	                            }
	                        },
	                        'serverError': function serverError(data) {
	                            stopTimer(data.event);
	                            var error_code = 'INVALID_USER';
	                            var error = {
	                                type: 'pageError',
	                                code: 500
	                            };
	                            // internalServerError, code: 500, take user to hermes login, no need for error message
	                            switch (data.reason) {
	                                case 'serverValidationError':
	                                    if (data.authorizationType === 'token') {
	                                        error_code = 'ONETOUCH_GENERIC_ERROR';
	                                        error.msg = $locale.content.get('login.reactivateOneTouch');
	                                    } else if (loginAttemptedMethod === 'phone') {
	                                        error_code = 'INVALID_PHONE_PIN';
	                                        error.msg = $locale.content.get('login.invalidPin');
	                                    } else {
	                                        error.msg = $locale.content.get('login.invalidEmailPasswordPageError');
	                                    }
	                                    break;
	                                case 'invalidUser':
	                                    if (data.authorizationType === 'token') {
	                                        error_code = 'ONETOUCH_GENERIC_ERROR';
	                                        error.msg = $locale.content.get('login.reactivateOneTouch');
	                                    }
	                                    break;
	                                case 'internalServerError':
	                                    if (data.authorizationType === 'token') {
	                                        error_code = 'ONETOUCH_GENERIC_ERROR';
	                                        error.msg = $locale.content.get('login.reactivateOneTouch');
	                                    } else {
	                                        error.msg = $locale.content.get('login.invalidEmailPasswordPageError');
	                                    }
	                                    $fpti.setupDataString($state.current, error);
	                                    return appLoginHandler(failureReasons.error);
	                                case 'accountTemporaryLocked':
	                                case 'accountPermanentlyLocked':
	                                    error.code = data.code;
	                                    error.msg = $locale.content.get('login.accountLockedPageError');
	                                    error_code = 'ACCOUNT_LOCKED';
	                                    break;
	                                case 'riskDecline':
	                                    error.code = data.code;
	                                    if (data.authorizationType === 'token') {
	                                        error_code = 'ONETOUCH_GENERIC_ERROR';
	                                        error.msg = $locale.content.get('login.reactivateOneTouch');
	                                    } else {
	                                        error.msg = $locale.content.get('login.riskDeclinePageError');
	                                        error_code = 'RISK_DECLINE';
	                                    }
	                                    break;
	                                default:
	                                // Do nothing
	                            }
	                            var fptidata = getPostLoginFpti(data);
	                            $logger.info('checkout_fpti', {
	                                'from': fptidata.fptiState,
	                                'to': fptidata.fptiTransition,
	                                'int_error_code': data.code,
	                                'int_error_description': data.reason,
	                                'error_type': 'soft_decline',
	                                'error_source': 'unifiedloginnodeweb'
	                            });
	                            $fpti.setupDataString($state.current, error);
	                            $scope.parentCallback('showErrorMessages', error_code);
	                        },
	                        'client_validation_error': function client_validation_error(data) {
	                            var error = {
	                                type: 'pageError',
	                                msg: $locale.content.get('login.invalidEmailPasswordPageError')
	                            };
	                            var fptidata = getPostLoginFpti(data);
	                            $logger.info('checkout_fpti', {
	                                'from': fptidata.fptiState,
	                                'to': fptidata.fptiTransition,
	                                'int_error_code': data.event,
	                                'int_error_description': 'invalid_credentials',
	                                'error_type': 'soft_decline',
	                                'error_source': 'unifiedloginnodeweb'
	                            });
	                            $fpti.setupDataString($state.current, error);
	                        },
	                        'stepupRequired': function stepupRequired(data) {
	                            stopTimer(data.event);
	                            var fptidata = getPostLoginFpti(data);
	                            logFptiData(fptidata, data.event);
	
	                            if (data.authorizationType && data.authorizationType === 'token') {
	                                // for remembered user redirect to login instead of AuthChallenge APP
	                                $logger.debug('LOGIN_ATO_RM_USER');
	
	                                // doing nothing, ul will render the login page, we need to show warning on top though
	                                var error_code = 'ONETOUCH_GENERIC_ERROR';
	                                var error = { // eslint-disable-line no-unused-vars
	                                    type: 'pageError',
	                                    msg: $locale.content.get('login.reactivateOneTouch')
	                                };
	                            } else if (data.contingencyUrl) {
	                                $logger.debug('LOGIN_ATO_USER');
	                                var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);
	                                $util.redirect(authChallengeRedirectUrl);
	                            } else {
	                                $logger.debug('LOGIN_ATO_GENERIC_ERROR');
	                                $state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
	                            }
	                            // to show error message on login page
	                            $scope.parentCallback('showErrorMessages', error_code); // eslint-disable-line block-scoped-var
	                        },
	
	                        'captcha': function captcha(data) {
	                            var fptiData = getPostLoginFpti(data);
	                            $logger.info('checkout_fpti', {
	                                'from': fptiData.fptiState,
	                                'to': 'prepare_captcha'
	                            });
	                        },
	                        'bodyClick': function bodyClick() {
	                            $rootScope.$broadcast('clickBody');
	                        },
	                        'expiredRefreshToken': function expiredRefreshToken(data) {
	
	                            var treatment = data.treatment;
	
	                            $logger.info('EXPIRED_RT_' + treatment);
	
	                            $logger.info('checkout_fpti', {
	                                'from': 'LOGIN_UL_RM',
	                                'to': 'process_RT_AT_exch',
	                                'int_error_code': 'expired_RT_Token',
	                                'int_error_desc': treatment,
	                                'error_source': 'unifiedloginnodeweb',
	                                'error_type': 'soft_decline'
	                            });
	
	                            switch (treatment) {
	
	                                case 'showInterstitial':
	                                    $scope.showReactivationInterstitial = true;
	                                    break;
	
	                                case 'checkboxPreselectedWithNotification':
	                                    $scope.errorFn('ONETOUCH_LEAVECHECKED', {}, 'warning');
	                                    break;
	
	                                case 'checkboxNotPreselectedWithNotification':
	                                    $scope.errorFn('ONETOUCH_REACTIVATE', {}, 'warning');
	                                    break;
	
	                                case 'expiredRefreshTokenControl':
	                                    break;
	
	                                default:
	                                    break;
	
	                            }
	                        }
	                    };
	
	                    function postMessageHandler(response) {
	                        $timeout(function () {
	                            $logger.info('ul_postmessaged_received', response);
	                            var data = response.data || response.error;
	                            var eventId = data && data.event;
	                            if (eventId) {
	                                $logger.debug('ULLOGIN_' + eventId, response);
	                                var handler = ulEventHandlers[eventId];
	                                if (handler) {
	                                    handler(data);
	                                }
	                            }
	                        });
	                    }
	
	                    function loadUnifiedLogin(iframeCopy) {
	                        var queryString = $util.queryStringSplice($util.queryString(), {
	                            'flow': '1-P',
	                            'token': $scope.token
	                        }, ['cmd']);
	                        var isHermesInsideIframe = $util.isIFrame();
	                        if (isHermesInsideIframe) {
	                            $logger.info('MERCHANT_IFRAME_INTEGRATION');
	                        }
	                        var options = {
	                            targetElement: document.getElementById('injectedUnifiedLogin'),
	                            xhrRequest: isHermesInsideIframe,
	                            queryParams: {
	                                'stsRedirectUri': ulMeta.stsReturnUrl,
	                                'country.x': $scope.locale.country,
	                                'locale.x': $scope.locale.getLocaleCode(),
	                                'returnUri': ulMeta.ulReturnUri,
	                                'state': queryString,
	                                'flowId': $scope.token,
	                                'correlationId': $CalDataModel.getCalCorrId()
	                            },
	                            config: {
	                                title: 'PayPal - ' + $locale.content.get('common.login')
	                            },
	                            onPostMessage: postMessageHandler
	                        };
	
	                        if ($meta.baToken) {
	                            angular.extend(options.queryParams, { 'fn_dt': $meta.baToken });
	                        }
	
	                        if ($scope.forcedLogin) {
	                            angular.extend(options.queryParams, { 'prompt': 'login' });
	                        }
	
	                        if ($scope.logoutCallback) {
	                            angular.extend(options.queryParams, { 'showNotYou': true });
	                        }
	
	                        if ($stateParams.source !== 'NOT_YOU') {
	                            $scope.flowcontext = $scope.checkoutCart.flow_context;
	                        } else {
	                            $scope.flowcontext = $scope.checkoutCart.flow_context_without_email;
	                        }
	
	                        if ($scope.flowcontext) {
	                            angular.extend(options.queryParams, { 'flowContextData': $scope.flowcontext });
	                        }
	
	                        if ($config.deploy.isLocal()) {
	                            options.origin = 'https://' + $meta.stage;
	                            if (!$meta.stage) {
	                                // if no stage url shows up then use any backup url for origin
	                                var backupURL = $config.onboarding.url.split('/webapps/')[0];
	                                options.origin = backupURL;
	                            }
	                        }
	
	                        // preload only for first time login attempts
	                        if ($scope.preloadUL && $scope.ulSource && $scope.ulSource.src && !$scope.forcedLogin && $stateParams.source !== 'NOT_YOU' && !userSelectedLanguage && rememberMe) {
	                            $logger.debug('ULSS_CLIENT_PRELOAD_INJECT');
	                            $scope.preLoadedSource = true;
	                            options.preLoadedSource = decodeURI($scope.ulSource.src);
	                        }
	
	                        function ulInvoke() {
	                            if (PAYPAL && PAYPAL.unifiedLogin) {
	                                startTimer('ulInvoke');
	                                if (!iframeCopy) {
	                                    PAYPAL.unifiedLogin.inject(options);
	                                } else {
	                                    PAYPAL.unifiedLogin.copyPasteIframe({
	                                        targetElement: document.getElementById('injectedUnifiedLogin'),
	                                        onPostMessage: postMessageHandler
	                                    });
	                                }
	                            } else {
	                                return appLoginHandler(failureReasons.fallback);
	                            }
	                        }
	
	                        var kmliContentMapping = {
	                            xo_hermesnode_kmli_content_control: '0',
	                            xo_hermesnode_kmli_content_t1: '1',
	                            xo_hermesnode_kmli_content_t2: '2',
	                            xo_hermesnode_kmli_content_t3: '3'
	                        };
	
	                        if (rememberMe === true) {
	                            options.queryParams.rememberMe = true;
	                            var country = $scope.checkoutAppData.merchant.merchant_country;
	                            return $pxp(ulMeta.kmliContentExpId, { 'ctx.COUNTRY': country }, 'xo_hermesnode_kmli_content_.*').then(function (result) {
	                                var contentKey = result && result.treatment_name;
	
	                                if (contentKey && kmliContentMapping[contentKey]) {
	                                    options.queryParams.rememberMeContent = kmliContentMapping[contentKey];
	                                }
	
	                                ulInvoke();
	                            });
	                        }
	
	                        return ulInvoke();
	                    }
	
	                    var cancelAllLoaded = $rootScope.$on('allLoaded', function () {
	                        cancelLocaleChange = $scope.$on('localeChange', function () {
	                            userSelectedLanguage = $locale.lang;
	                            setLoading('localeChange');
	                            loadUnifiedLogin();
	                        });
	                        cancelAllLoaded();
	                    });
	
	                    $scope.$on('$destroy', cancelAllLoaded);
	
	                    loadUnifiedLogin(ulMeta.iframeCopy);
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/unified-login/template.html":
/***/ function(module, exports) {

	module.exports = "<div>\n    <input id=\"email\" name=\"login_email\" type=\"email\" value=\"\" autocomplete=\"off\" placeholder=\"Email\" style=\"display:none\">\n    <input id=\"password\" name=\"login_password\" type=\"password\" value=\"\" placeholder=\"Password\" style=\"display:none\">\n    <div id=\"injectedUnifiedLogin\">\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-unified-login.kmliUpsell', ['squid']).factory('$KmliUpsell', function ($pxp, $CheckoutAppDataModel, $config, $populate, $q) {
	
	        var pxpTreatment;
	        var idToken;
	        var kmliEligible;
	        var successfulLogin;
	        var kmliChecked;
	        var upsellOptInDisplayed;
	        var showReactivationInterstitial;
	
	        return {
	
	            init: function init(upsellEligibilityData) {
	                if (upsellEligibilityData) {
	                    idToken = Boolean(upsellEligibilityData.idToken);
	                    successfulLogin = upsellEligibilityData.ulData && upsellEligibilityData.ulData.event === 'loginSuccess';
	                    kmliEligible = upsellEligibilityData.kmliEligible;
	                    kmliChecked = upsellEligibilityData.ulData && upsellEligibilityData.ulData.keepMeLoggedIn === true;
	                    upsellOptInDisplayed = upsellEligibilityData.upsellOptInDisplayed;
	                    showReactivationInterstitial = upsellEligibilityData.showReactivationInterstitial === true;
	                }
	            },
	
	            eligible: function eligible(token) {
	
	                var $scope = {};
	
	                if (showReactivationInterstitial && !kmliChecked && kmliEligible && idToken) {
	                    return $q(function (resolve, reject) {
	                        resolve({ eligible: true, type: 'reactivation' });
	                    });
	                } else {
	                    return $populate($scope, {
	                        checkoutAppData: $CheckoutAppDataModel.instance(token)
	                    }).then(function () {
	                        var merchantCountry = $scope.checkoutAppData.merchant.merchant_country;
	                        return $pxp($config.ulMeta.pxpExpId, { 'ctx.COUNTRY': merchantCountry }, 'xo_hermes_kmli_upsell_(web|mobile)_treatment');
	                    }).then(function (result) {
	                        pxpTreatment = Boolean(result);
	                        if (Boolean(pxpTreatment && idToken && kmliEligible && successfulLogin && !kmliChecked && !upsellOptInDisplayed)) {
	                            return { eligible: true, type: 'member' };
	                        } else {
	                            return { eligible: false };
	                        }
	                    });
	                }
	            },
	
	            getOptions: function getOptions() {
	
	                if (showReactivationInterstitial) {
	                    return {
	                        flowName: 'expiredUpsell'
	                    };
	                }
	            },
	
	            getFPTIAttributes: function getFPTIAttributes() {
	
	                if (showReactivationInterstitial) {
	                    return {
	                        stateName: 'KMLI_reactivation',
	                        transInfix: '_kmli_reactivation_'
	                    };
	                } else {
	                    return {
	                        stateName: 'KMLI_UPSELL',
	                        transInfix: '_kmli_upsell_'
	                    };
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/onetouch-interstitial", "components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js"))

/***/ },

/***/ "./components/ul-inline/dist/inject.js":
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	!function(a,b){a.PAYPAL=a.PAYPAL||{},a.PAYPAL.unifiedLogin=b()}(this,function(){function a(a,b){var c,d={src:a,height:b.height||239,style:"width: 100%;",name:b.name||"injectedUl",frameborder:0,scrolling:b.scrolling||"no",title:b.title||"PayPal",sandbox:"allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"},e=document.createElement("iframe");b.hide&&(d.style=d.style+"display: none;");for(c in d)e.setAttribute(c,d[c]);return e}function b(a,b,c){var d,e=a||window.location.origin||window.location.protocol+"//"+window.location.host,f=e+(c||"/signin/inject/"),g=b?"?":"",h=0;if(!b)return f;for(d in b)h>0&&(g+="&"),g=g+d+"="+encodeURIComponent(b[d]),h+=1;return f+g}function c(a){var b,c="";try{if(a.source.name!==q.name)return}catch(d){return}if(b=g(a.origin),!f(b))throw new Error("PostMessage iframe domain ("+b+"), must be a *.paypal.com domain");if(c=a&&a.data,"string"==typeof c)try{c=JSON.parse(c)}catch(h){throw new Error("Invalid JSON string sent to onPostMessage handler: "+c)}c.data&&"resize"===c.data.event?e(q,c.data.heightInPx):c.data&&"htmlRendered"===c.data.event?x=!0:!w&&p?p(c):w&&v.push(c)}function d(a){a&&"resize"===a.event?e(s,a.heightInPx):r(a)}function e(a,b){a.setAttribute("height",b)}function f(a){var b=/\.paypal\.com$/gi;return b.test(a)}function g(a){if(a){var b=/^https?:\/\/(.*\.paypal\.com)(:[0-9]+)?$/gi,c=b.exec(a);return c&&c[1]}}function h(){var a;if(p){for(a=0;a<v.length;a++)p(v[a]);v=[],w=!1}}function i(c){var d,e,h,i,k;if(!c||!c.targetElement)throw h="targetElement",new Error("The "+h+" option is required");if(c.origin&&(i=g(c.origin),!f(i)))throw new Error('All values for the "origin" setting must match *.paypal.com');for(u=c.config||{},e=b(c.origin,c.queryParams,c.iframePathname),k=c.xhrRequest&&c.xhrRequest===!0,d=k||c.preLoadedSource?a("about:blank",u):a(e,u),t=c.targetElement;c.targetElement.hasChildNodes();)c.targetElement.removeChild(c.targetElement.lastChild);return c.targetElement.appendChild(d),"directMessageIframe"===c.iframeType?(s=d,r=c.onPostMessage):(q=d,p=c.onPostMessage,j()),k?n(e,function(a){a&&o(d,a)}):c.preLoadedSource&&o(d,c.preLoadedSource),w=p?!1:!0,{iframe:d,onPostMessageCallback:p}}function j(){window.addEventListener?window.addEventListener("message",c,!1):window.attachEvent("onmessage",c)}function k(a){p=a,h()}function l(){t.parentNode&&t.parentNode.removeChild(t)}function m(b){var c,d,e,f,g="about:blank";if(!x)return void setTimeout(function(){m(b)},50);for(b.onPostMessage&&k(b.onPostMessage),u.hide=!1,c=a(g,u);b.targetElement.hasChildNodes();)b.targetElement.removeChild(b.targetElement.lastChild);b.targetElement.appendChild(c),d=q.contentWindow.document,e=d.documentElement.outerHTML,f=c.contentWindow.document,f.open(),f.write(e),f.close(),l(),q=c,t=b.targetElement}function n(a,b){var c;window.XMLHttpRequest?c=new XMLHttpRequest:window.ActiveXObject&&(c=new ActiveXObject("Microsoft.XMLHTTP")),c&&(c.onreadystatechange=function(){4==c.readyState&&200==c.status&&b(c.responseText)},c.open("GET",a,!0),c.send())}function o(a,b){a.contentWindow.inlineUlContents=b,a.src='javascript:window["inlineUlContents"]'}var p,q,r,s,t,u,v=[],w=!1,x=!1;return{inject:i,copyPasteIframe:m,removeTargetElement:l,messageDispatcher:c,nonPostMessageDispatcher:d}});
	
	}.call(window));

/***/ },

/***/ "./components/xo-page-components/src/value-props/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/value-props/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-value-props.directive', ['squid']).directive('xoValueProps', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                type: '@',
	                title: '@',
	                text: '@',
	                textContent: '@',
	                imageUrl: '@'
	            },
	            link: function link(scope, element, attrs) {
	                if (angular.isString(attrs.imageUrl)) {
	                    // Only do this when image-url is defined so that we do not affect default behavior. These image-url
	                    // are configured through pxp tool for factor based experiments, hence they should all should adhere
	                    // to standard size i.e. 150X150 pixels.
	                    attrs.$observe('imageUrl', function (imageUrl) {
	                        var url = imageUrl;
	                        var propImg = angular.element(element[0].querySelector('div.prop-img'));
	                        var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;
	
	                        if (isRetina) {
	                            var index = url.lastIndexOf('.'); // index at which file extension start
	                            url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
	                            propImg.css({
	                                'background-image': 'url(' + url + ')',
	                                'height': '150px',
	                                'background-size': '150px 150px',
	                                'margin-top': '0px'
	                            });
	                        } else {
	                            propImg.css({
	                                'background-image': 'url(' + url + ')',
	                                'height': '150px',
	                                'margin-top': '0px'
	                            });
	                        }
	                    });
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/value-props/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"props {{type}}\" content>\n    <div class=\"prop-img\"></div>\n    <h2 class=\"vprop-header\">{{ title }}</h2>\n    <p ng-if=\"textContent\" ng-bind-html=\"htmlContent(textContent)\"></p>\n    <p ng-if=\"!textContent\" ng-bind-html=\"text\"></p>\n</div>\n"

/***/ },

/***/ "./components/xo-ui-components/src/card-loader/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoCardLoader = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/card-loader/styles.less");
	
	var _template = __webpack_require__("./components/xo-ui-components/src/card-loader/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoCardLoader = exports.$xoCardLoader = _squid.$Component.extend('xoCardLoader', {
	    tag: 'xo-card-loader',
	    template: _template2['default'],
	    props: {
	        message: {
	            type: 'str'
	        },
	        state: {
	            type: 'var'
	        },
	        email: {
	            type: 'var'
	        }
	    }
	});
	
	angular.value("$xoCardLoader", $xoCardLoader);
	_squid.$Component;

/***/ },

/***/ "./components/xo-ui-components/src/card-loader/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/card-loader/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/card-loader/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#virtual_card{position:absolute;z-index:1;width:240px;height:151px;border-radius:7.2px;background-image:linear-gradient(90deg,#009be1,#002c8a);margin-left:-120px;left:50%}#card_header{height:60px;width:100%}#card_logo{height:23px;width:96px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/simplified/pp_logo_h_white.png\");background-repeat:no-repeat;margin-top:10px;margin-left:10px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#card_logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/simplified/pp_h_white@2x.png\");background-size:96px 23px}}#card_footer{z-index:3;height:16px;margin-top:50px}#card_user{width:199.1px;height:15.5px;font-family:PayPalSansBig,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:11.2px;font-weight:400;font-style:normal;font-stretch:normal;text-align:left;color:#fff;margin-top:15px;margin-left:15px}#slider{z-index:2;width:inherit;border-top-left-radius:7.2px;border-top-right-radius:7.2px;background-color:hsla(0,0%,100%,.8);top:0;position:absolute}#slider.notStarted{animation:strech_state_off .1s ease-in-out;-moz-animation:strech_state_off .1s ease-in-out;-webkit-animation:strech_state_off .1s ease-in-out;-o-animation:strech_state_off .1s ease-in-out;-ms-animation:strech_state_off .1s ease-in-out;animation-fill-mode:forwards}#slider.pending{animation:strech_state_A 3s ease-in-out;-moz-animation:strech_state_A 3s ease-in-out;-webkit-animation:strech_state_A 3s ease-in-out;-o-animation:strech_state_A 3s ease-in-out;-ms-animation:strech_state_A 3s ease-in-out;animation-fill-mode:forwards}#slider.completed{animation:strech_state_B 1s ease-in-out;-moz-animation:strech_state_B 1s ease-in-out;-webkit-animation:strech_state_B 1s ease-in-out;-o-animation:strech_state_B 1s ease-in-out;-ms-animation:strech_state_B 1s ease-in-out;animation-fill-mode:forwards}#virtual_card_message_wrapper{width:100%}#virtual_card_message{padding-top:176px;width:100%;text-align:center;font-size:1.2em;line-height:1.35em}@keyframes strech_state_off{0%{height:100%}to{height:100%}}@keyframes strech_state_A{0%{height:100%}to{height:30%}}@keyframes strech_state_B{0%{height:20%}to{height:0}}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-ui-components/src/card-loader/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"virtual_card\">\n    <div id=\"card_header\">\n        <div id=\"card_logo\"></div>\n    </div>\n    <div id=\"card_footer\">\n        <div id=\"card_user\">{{email}}</div>\n    </div>\n    <div id=\"slider\" class=\"{{state}}\"></div>\n</div>\n<div id=\"virtual_card_message\">{{message}}</div>\n\n"

/***/ },

/***/ "./pages/xo-generic-error/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$GenericErrorRoute = undefined;
	
	__webpack_require__("./pages/xo-generic-error/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $GenericErrorRoute = exports.$GenericErrorRoute = _squid.$ComponentRoute.extend('$GenericErrorRoute', {
	
	    path: 'genericError',
	    directive: 'xo-generic-error-page',
	    titleContent: 'genericError.pleaseTryAgain',
	    query: ['code'],
	    // need to find these values
	    trackingData: {
	        fptiState: 'fatal_error',
	        templateName: 'genericError.dust',
	        pageGoal: 'Generic Error',
	        pageQualifier: 'blockNonDomesticShipping',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-generic-error',
	                'pagename2': '%::fullpage-generic-error:member:hermes:',
	                'version': 'member:%:'
	            }
	        }
	    },
	
	    auth: false,
	
	    children: []
	});
	
	angular.value("$GenericErrorRoute", $GenericErrorRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-generic-error/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoGenericErrorPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-generic-error/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/generic-error/directive.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoGenericErrorPageComponent = exports.$xoGenericErrorPageComponent = _squid.$Component.extend('$xoGenericErrorPageComponent', {
	    tag: 'xo-generic-error-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
	    $stateParams, $state, $logger, $CheckoutAppDataModel, $util, $ReturnToMerchant, $q, $populate) {
	
	        $scope.token = $rootScope.token;
	
	        var terminalKey = 'terminal-error-' + $scope.token,
	            refreshKey = 'has-seen-error-' + $scope.token;
	
	        if (!$util.sessionStorageEnabled() || !$scope.token || sessionStorage.getItem(terminalKey)) {
	            return renderErrorPage();
	        }
	
	        // is not a refresh
	        if (!sessionStorage.getItem(refreshKey)) {
	            sessionStorage.setItem(refreshKey, '1');
	            return renderErrorPage();
	        }
	
	        // is a refresh
	        else {
	                $logger.info('checkout_fpti', {
	                    user_refresh: 1
	                });
	
	                sessionStorage.removeItem(refreshKey);
	
	                $state.go('checkout.review')['catch'](function () {
	                    return (
	                        // don't try to do this again
	                        sessionStorage.setItem(terminalKey, '1')
	                    );
	                });
	            }
	
	        function renderErrorPage() {
	            // prevent render flicker
	            $scope.shouldRender = true;
	
	            var cancelBlockStateChange = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	                $logger.info('state_change_from_generic_error_blocked');
	                event.preventDefault();
	            });
	
	            $scope.$on('$destroy', cancelBlockStateChange);
	        }
	    }
	});
	
	angular.value("$xoGenericErrorPageComponent", $xoGenericErrorPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-generic-error/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-generic-error ng-if=shouldRender token=token></xo-generic-error>\n"

/***/ },

/***/ "./components/xo-ui-components/src/generic-error/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _util = __webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _template = __webpack_require__("./components/xo-ui-components/src/generic-error/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-ui-components/src/generic-error/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TITLE_KEY_MAPPING = {
	    PAYMENT_PROCESS_ERROR: 'paymentProcessError',
	    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingTitle',
	    PAYER_COUNTRY_NOT_ALLOWED: 'sorry',
	    PAYER_COUNTRY_NOT_ENABLED: 'sorry',
	    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'sorry',
	    TRANSACTION_REFUSED: 'transactionRefusedTitle',
	    COMPLIANCE_VIOLATION: 'transactionRefusedTitle',
	    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredTitle',
	    INTERNAL_SERVICE_ERROR: 'transactionRefusedTitle',
	    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedTitle',
	    STUDENT_ACCOUNT: 'studentAccountTitle',
	    RETRY: 'sorry'
	};
	
	var CONTENT_KEY_MAPPING = {
	    INVALID_RESOURCE_ID: 'expiredOrTokenNotFoundError',
	    EXPIRED_SESSION: 'expiredOrTokenNotFoundError',
	    PAYMENT_ALREADY_DONE: 'paymentAlreadyCompletedError',
	    PAYEE_BLOCKED_TRANSACTION: 'paymentDeniedError',
	    PAYER_CANNOT_PAY: 'paymentDeniedError',
	    RESTRICTED_USER: 'buyerRestrictedError',
	    PAYMENT_DENIED: 'paymentDeniedError',
	    UNSUPPORTED_PAYEE_CURRENCY: 'unsupportedPayeeCurrency',
	    GUEST_UPGRADE_SESSION_ERROR: 'guestUpgradeSessionError',
	    GUEST_UPGRADE_ERROR: 'guestUpgradeError',
	    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingMessage',
	    PAYER_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryAccountRegistered',
	    PAYER_COUNTRY_NOT_ENABLED: 'rpUnauthorizedCountryMessage',
	    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryLogin',
	    PAYMENT_PROCESS_ERROR: 'chooseOtherWayToPay',
	    GAMING_FUNDING_SOURCE_VALIDATION_FAILED: 'unauthorizedCountryAccountRegistered',
	    SENDING_LIMIT_EXCEEDED: 'sendingLimitExceeded',
	    TRANSACTION_LIMIT_EXCEEDED: 'transactionLimitExceeded',
	    TRANSACTION_REFUSED: 'transactionRefusedMessage',
	    COMPLIANCE_VIOLATION: 'complianceViolationMessage',
	    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredMessage',
	    INTERNAL_SERVICE_ERROR: 'transactionRefusedMessage',
	    DEFAULT: 'genericError',
	    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedMessage',
	    ACCOUNT_CANNOT_BE_FETCHED: 'genericError',
	    STUDENT_ACCOUNT: 'studentAccountMessage',
	    RETRY: 'genericError',
	    DEFAULT_ANDROID_PAY_ERROR: 'androidPayGenericError',
	    ANDROID_PAY_ELIGIBILITY_ERROR: 'genericError'
	};
	
	// handle non-standard merchant error title strings
	var TITLE_KEY_HANDLER = {
	    DOMESTIC_TRANSACTION_REQUIRED: function DOMESTIC_TRANSACTION_REQUIRED(key) {
	        var merchantName = this.props.merchant;
	
	        if (merchantName) {
	            return (0, _squid.$renderContent)(key, { merchantName: merchantName });
	        }
	
	        return (0, _squid.$renderContent)(key + 'Default');
	    }
	};
	
	// handle non-standard merchant error content strings
	var CONTENT_KEY_HANDLER = {
	    DOMESTIC_TRANSACTION_REQUIRED: TITLE_KEY_HANDLER.DOMESTIC_TRANSACTION_REQUIRED
	};
	
	var HIDE_CANCEL_LINK_CODES = ['PAYER_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED'];
	
	var RETRY_LINK = ['RETRY'];
	
	/* eslint-disable fasec/no-unsafe-regex */
	var base64regex = new RegExp('^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$');
	
	exports['default'] = _squid.$Component.extend('$xoGenericErrorComponent', {
	
	    tag: 'xo-generic-error',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: false
	        },
	        isUnbranded: {
	            type: 'var',
	            required: false
	        },
	        cancelUrl: {
	            type: 'str',
	            required: false
	        },
	        merchant: {
	            type: 'str',
	            required: false,
	            'default': function _default() {
	                if (this.models) {
	                    var merchant = this.models.checkoutAppData.merchant;
	                    return merchant.brand_name || merchant.merchant_name;
	                }
	            }
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            if (this.props.token) {
	                return {
	                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](angular.noop),
	                    cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](angular.noop),
	                    checkoutPayee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](angular.noop)
	                };
	            }
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            var errorCode = void 0;
	
	            var cancelPreventStateChange = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	                event.preventDefault();
	            });
	
	            this.$on('$destroy', cancelPreventStateChange);
	
	            var self = this;
	            self.noWalletTokenizationButtonMapping = false;
	
	            // to not break other application's error integration, we'll still support base64 decoded code parameters
	            if (_uiRouter.$stateParams.code && base64regex.test(_uiRouter.$stateParams.code)) {
	                self.errorCode = _squid.$util.base64Decode(_uiRouter.$stateParams.code);
	            } else {
	                self.errorCode = _uiRouter.$stateParams.code;
	            }
	
	            self.hideCancelLink = HIDE_CANCEL_LINK_CODES.indexOf(self.errorCode) > -1;
	            self.retryLink = RETRY_LINK.indexOf(self.errorCode) > -1;
	
	            _angular.$rootScope.allowUnload = true;
	            self.cancelLink = self.props.cancelUrl;
	
	            self.cancelRedirect = function ($event) {
	                $event.preventDefault();
	                var redirectUrl = self.cancelLink;
	
	                if (_angular.$rootScope.partnerIntegration) {
	                    _logger.$logger.info('genericerror_partner_integration');
	                    redirectUrl = _squid.$util.buildURL(self.cancelLink, { error: 'true' });
	                }
	
	                _util.$ReturnToMerchant.goTo(redirectUrl);
	            };
	
	            self.retryCheckout = function ($event) {
	                $event.preventDefault();
	
	                _squid.$util.reload();
	            };
	
	            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
	            (0, _jquery2['default'])('#defaultCancelLink').hide();
	            (0, _jquery2['default'])('.footerWrapper').addClass('genericError');
	
	            self.$on('$destroy', function (event) {
	                (0, _jquery2['default'])('.paypalHeaderWrapper').show();
	                (0, _jquery2['default'])('#defaultCancelLink').show();
	                (0, _jquery2['default'])('.footerWrapper').removeClass('genericError');
	            });
	
	            // Returns the title string, based on custom key handler
	            self.getTitle = function () {
	                var key = self.titleKey;
	
	                if (TITLE_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
	                    return TITLE_KEY_HANDLER[self.errorCode].call(_this, key);
	                }
	
	                return (0, _squid.$renderContent)(key);
	            };
	
	            // Returns the content string, based on custom key handler
	            self.getContent = function () {
	
	                var key = self.contentKey;
	
	                if (CONTENT_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
	                    return CONTENT_KEY_HANDLER[self.errorCode].call(_this, key);
	                }
	
	                return (0, _squid.$renderContent)(key);
	            };
	
	            // Returns the cancel button label, based on presence of brand/merchant name
	            self.getCancelLabel = function () {
	                if (self.walletTokenization && !self.noWalletTokenizationButtonMapping) {
	                    return (0, _squid.$renderContent)('common.backToAndroidPay');
	                } else {
	                    var merchantName = _this.props.merchant;
	
	                    if (merchantName) {
	                        return (0, _squid.$renderContent)('common.returnToMerchant', { merchantName: merchantName });
	                    }
	
	                    return (0, _squid.$renderContent)('common.returnToDefaultMerchant');
	                }
	            };
	        },
	        populate: function populate() {
	            if (this.models.checkoutAppData) {
	                this.cancelLink = this.models.checkoutAppData.urls.cancel_url;
	            }
	
	            if (this.models.checkoutPayee) {
	                var merchant = this.models.checkoutPayee.merchant;
	
	                if (merchant.id && !this.hideCancelLink) {
	                    var hcl = _squid.$config.hideCancelLink;
	
	                    this.hideCancelLink = hcl && hcl.indexOf(merchant.id) !== -1;
	                }
	            }
	
	            if (this.models.cart) {
	                this.walletTokenization = this.models.cart.isWalletTokenization();
	            }
	
	            // Map error code for Android Pay
	            if (this.walletTokenization) {
	                // ANDROID_PAY_ELIGIBILITY_ERROR is a temporary error code that is mapped to DEFAULT error content.
	                // We need to change once content has been adapted.
	                if (this.errorCode !== 'ANDROID_PAY_ELIGIBILITY_ERROR') {
	                    this.errorCode = 'DEFAULT_ANDROID_PAY_ERROR';
	                } else {
	                    this.noWalletTokenizationButtonMapping = true;
	                }
	            }
	
	            var titleKey = this.errorCode && TITLE_KEY_MAPPING[this.errorCode];
	            if (titleKey) {
	                this.titleKey = 'genericError.' + titleKey;
	            }
	
	            var contentKey = this.errorCode && CONTENT_KEY_MAPPING[this.errorCode] || CONTENT_KEY_MAPPING.DEFAULT;
	            this.contentKey = 'genericError.' + contentKey;
	        }
	    }
	
	});
	
	
	_angular.$rootScope;
	
	_uiRouter.$stateParams;
	
	_squid.$Component;
	
	_squid.$util;
	
	_squid.$renderContent;
	
	_squid.$config;
	
	_logger.$logger;
	
	_index.$CheckoutAppDataModel;
	
	_index.$CheckoutCartModel;
	
	_index.$CheckoutPayeeModel;
	
	_util.$ReturnToMerchant;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-ui-components/src/generic-error/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"genericError\" content>\n    <div class=\"container\">\n        <div class=\"logo\" ng-if=\"!props.isUnbranded\"></div>\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{ getTitle() }}\n        </div>\n        <div class=\"message\"\n            ng-if=\"contentKey\"\n            ng-bind-html=\"getContent()\">\n        </div>\n        <p class=\"retryLink\" ng-if=\"retryLink\">\n            <a link-button ng-click=\"retryCheckout($event)\" id=\"retryLink\" class=\"btn full\">\n                {{ content('genericError.pleaseTryAgain') }}\n            </a>\n        </p>\n        <p class=\"cancelLink\" ng-if=\"cancelLink && !hideCancelLink\">\n            <a href=\"{{cancelLink}}\" ng-click=\"cancelRedirect($event)\" id=\"cancelLink\" ng-class=\"['btn', 'full', {'btn-secondary': retryLink}]\">\n                {{ getCancelLabel() }}\n            </a>\n        </p>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-ui-components/src/generic-error/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/generic-error/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/generic-error/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}@media (min-width:41.3125em){section#genericError .container{width:400px}.genericError.footerWrapper{float:none;width:99.4%;padding:0 3px}.genericError.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#genericError{height:450px;background:none}section#genericError .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#genericError .title{font-size:1.5em;margin-bottom:15px;line-height:1.2}section#genericError .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#genericError .secondaryMessage{color:#979797;line-height:20px}section#genericError .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#genericError .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#genericError .cancelLink{margin-top:20px}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-generic-message/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$GenericMessageRoute = undefined;
	
	__webpack_require__("./pages/xo-generic-message/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $GenericMessageRoute = exports.$GenericMessageRoute = _squid.$ComponentRoute.extend('$GenericMessageRoute', {
	
	    path: 'genericMessage',
	
	    directive: 'xo-generic-message-page',
	
	    query: ['code'],
	
	    // need to find these values
	    trackingData: {},
	
	    auth: false,
	
	    children: []
	});
	
	angular.value("$GenericMessageRoute", $GenericMessageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-generic-message/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoGenericMessagePageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _template = __webpack_require__("./pages/xo-generic-message/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/generic-message/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoGenericMessagePageComponent = exports.$xoGenericMessagePageComponent = _squid.$Component.extend('$xoGenericMessagePageComponent', {
	    tag: 'xo-generic-message-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
	    $stateParams, $state, $logger, $CheckoutAppDataModel, $CheckoutCartModel, $ReturnToMerchant, $util, $q, $populate) {
	
	        $scope.token = $rootScope.token;
	
	        (0, _jquery2['default'])('#defaultCancelLink').hide();
	
	        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	            event.preventDefault();
	        });
	
	        $populate($scope, {
	            appData: $CheckoutAppDataModel.instance($scope.token),
	            cart: $CheckoutCartModel.instance($scope.token)
	        });
	
	        $scope.redirect = function (event) {
	            event.preventDefault();
	            var url = $scope.appData.get('urls.return_url');
	            return $ReturnToMerchant.goTo($util.buildURL(url, {
	                ba_token: $scope.cart.get('billing.ba_token')
	            }));
	        };
	    }
	});
	
	angular.value("$xoGenericMessagePageComponent", $xoGenericMessagePageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-generic-message/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-generic-message token=token></xo-generic-message>\n<button ng-if=\"cart.isWalletTokenization()\" ng-click=\"redirect($event)\" class=\"btn full\" content>\n    {{content('memberReview.continueLabel')}}\n</button>\n"

/***/ },

/***/ "./components/xo-ui-components/src/generic-message/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/generic-message/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-generic-message.directive', ['squid', 'xomodel.checkout']).directive('xoGenericMessage', function ($rootScope) {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '='
	            },
	
	            controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
	            $stateParams, $state, $logger, $CheckoutAppDataModel, $populate) {
	
	                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	                    event.preventDefault();
	                });
	
	                $('.paypalHeaderWrapper').hide();
	                $('.footerWrapper').addClass('genericMessage');
	
	                var titleKeyMapping = {
	                    PAYMENT_SUCCESS: 'paymentSuccessTitle',
	                    DEFAULT: 'paymentSuccessTitle'
	                };
	
	                $scope.titleKey = 'genericMessage.' + ($stateParams.code && titleKeyMapping[$stateParams.code]) || titleKeyMapping.DEFAULT;
	
	                var contentKeyMapping = {
	                    PAYMENT_SUCCESS: 'paymentSuccessMessage',
	                    DEFAULT: 'paymentSuccessMessage'
	                };
	                var contentKey = $stateParams.code && contentKeyMapping[$stateParams.code];
	
	                if (contentKey) {
	                    $scope.contentKey = 'genericMessage.' + contentKey;
	                }
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                }).then(function () {
	                    var merchant = $scope.checkoutAppData.merchant;
	                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	                });
	
	                $scope.$on('$destroy', function (event) {
	                    $('.paypalHeaderWrapper').show();
	                    $('.footerWrapper').removeClass('genericMessage');
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/generic-message/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"genericMessage\" content>\n    <div class=\"container\">\n        <div class=\"logo\"></div>\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{content(titleKey)}}\n        </div>\n        <div class=\"message\" ng-if=\"contentKey\">\n            {{content(contentKey)}}\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-review/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ReviewRoute = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _route = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	var _route3 = __webpack_require__("./components/xo-credit-components/src/apply-ppc/route.js");
	
	var _route4 = _interopRequireDefault(_route3);
	
	__webpack_require__("./components/xo-login-components/src/onetouch-interstitial/route.js");
	
	var _route5 = __webpack_require__("./pages/xo-sidebar/route.js");
	
	var _route6 = _interopRequireDefault(_route5);
	
	var _route7 = __webpack_require__("./pages/xo-sidepage/route.js");
	
	var _route8 = _interopRequireDefault(_route7);
	
	var _directive = __webpack_require__("./pages/xo-review/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $ReviewRoute = exports.$ReviewRoute = _squid.$ComponentRoute.extend('$ReviewRoute', {
	
	    path: 'review',
	    directive: _directive.$xoReviewPageComponent,
	    titleContent: 'memberReview.memberReviewTitle',
	
	    trackingData: {
	        fptiState: 'review',
	        templateName: 'memberReview.dust',
	        pageGoal: 'Payment Review',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-review',
	                'pagename2': '%::fullpage-review:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	
	    children: [{
	        route: _route6['default'],
	        attributes: {
	            'back-uri': 'backUri',
	            'promotion': 'promotion',
	            'update': 'update',
	            'token': 'token',
	            'installment': 'installment'
	        }
	    }, {
	        name: '$OneTouchUpsellRoute',
	        attributes: {
	            'token': 'token',
	            'on-complete': 'onComplete'
	        }
	    }, {
	        route: _route2['default'],
	        attributes: {
	            'token': 'token',
	            'cardmodel': 'cardModel',
	            'on-success': 'onConfirmUpopSuccess',
	            'on-cancel': 'onConfirmUpopCancel'
	        }
	    }, {
	        route: _route4['default'],
	        props: function props() {
	            return {
	                token: this.token
	            };
	        }
	    }, {
	        route: _route8['default'],
	        props: function props() {
	            return {
	                token: this.token
	            };
	        }
	    }]
	});
	
	angular.value("$ReviewRoute", $ReviewRoute);
	_squid.$ComponentRoute;
	
	_directive.$xoReviewPageComponent;

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoConfirmUpopRoute', {
	    path: 'confirmUpop',
	    directive: _directive2['default'],
	    titleContent: 'confirmUpop.confirm',
	    trackingData: {
	        fptiState: 'confirm_upop'
	    },
	    query: ['fromLoginOverlay'],
	    loginRequired: true,
	    pageOnOverlay: true,
	    children: []
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _addCard = __webpack_require__("./components/xo-wallet-components/src/add-card/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__("./components/xo-wallet-components/src/confirm-upop/init/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/confirm-upop/confirm/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/confirm-upop/styles.less");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoConfirmUpopDirective', {
	    tag: 'xo-confirm-upop',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        phone: {
	            type: 'var',
	            required: false
	        },
	        cardmodel: {
	            type: 'var',
	            required: true
	        },
	        onSuccess: {
	            type: 'var',
	            required: false
	        },
	        onCancel: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.phone = this.props.phone || {};
	            this.cardLast4 = this.cardmodel.card.number.slice(-4);
	            this.fromLoginOverlay = _uiRouter.$stateParams.fromLoginOverlay;
	
	            (0, _angular.$timeout)(function () {
	                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').addClass('upopOpen');
	                if (_this.fromLoginOverlay) {
	                    (0, _angular.$timeout)(function () {
	                        (0, _jquery2['default'])('#upopConfirmation .modalWrapper').addClass('modalWrapperAnimation');
	                    });
	                }
	            });
	
	            var hideModal = function hideModal() {
	                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').removeClass('upopOpen');
	            };
	
	            var done = function done(handler, target) {
	                hideModal();
	                (0, _angular.$timeout)(function () {
	                    return handler ? handler() : _this.goto(target);
	                }, 300);
	            };
	
	            var _success = function _success() {
	                done(_this.props.onSuccess, 'checkout.review');
	            };
	
	            this.closeModal = function (event) {
	                if (event) {
	                    event.preventDefault();
	                }
	
	                done(_this.props.onCancel, '^');
	            };
	
	            this.initSuccess = function () {
	                _this.collectOtpInput = false;
	            };
	
	            this.confirmed = function () {
	                if (_this.props.onSuccess) {
	                    return _success();
	                }
	
	                _this.models.checkoutSession.fundingOptions.action('update', {
	                    resultModel: _this.models.checkoutSession,
	                    silent: true,
	                    data: {
	                        planId: _this.cardmodel.id
	                    },
	                    success: function success() {
	                        if (_this.models.checkoutSession.cvvData) {
	                            _this.models.checkoutSession.set('cvvData.security_code', _this.cardmodel.get('card.security_code'));
	                        }
	                        var isNewCard = !_this.cardmodel.card.isExisting();
	
	                        var msg = isNewCard ? ['smallToolTip.cardAddedConfirmed'] : ['smallToolTip.cardConfirmed'];
	
	                        _this.models.checkoutSession.message = {
	                            type: 'success',
	                            msgKeys: msg
	                        };
	
	                        _success();
	                    },
	                    contingencies: {
	                        TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
	                            _this.models.checkoutSession.message = {
	                                type: 'info',
	                                msgKeys: 'creditcard.addedButCannotUse'
	                            };
	
	                            _success();
	                        }
	                    }
	                });
	            };
	
	            this.flag = function (field) {
	                return _addCard.$CardMetaData.getMetaData(_this.cardmodel.card, field);
	            };
	
	            this.setMessage = function (message) {
	                _this.message = message;
	            };
	
	            this.collectOtpInput = this.flag('fields.expiry') && !this.cardmodel.get('card.expiry_month') || this.flag('fields.cvv') && !this.cardmodel.get('card.expiry_month') || this.flag('fields.phone') && !(this.phone && this.phone.telephone);
	        }
	    }
	});
	
	
	_angular.$timeout;
	
	_squid.$Component;
	
	_uiRouter.$stateParams;
	
	_addCard.$CardMetaData;
	
	_index.$CheckoutSessionModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _directive = __webpack_require__("./components/xo-wallet-components/src/add-card/cardExpiry/directive.js");
	
	Object.keys(_directive).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _directive[key];
	    }
	  });
	});
	
	var _cardMetaData = __webpack_require__("./components/xo-wallet-components/src/add-card/cardMetaData/index.js");
	
	Object.keys(_cardMetaData).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _cardMetaData[key];
	    }
	  });
	});
	
	var _directive2 = __webpack_require__("./components/xo-wallet-components/src/add-card/cvv/directive.js");
	
	Object.keys(_directive2).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _directive2[key];
	    }
	  });
	});

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/cardExpiry/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$xoCardExpiryDirective = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/add-card/cardExpiry/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoCardExpiryDirective = exports.$xoCardExpiryDirective = _squid.$Component.extend('$xoCardExpiryDirective', {
	    tag: 'xo-card-expiry',
	    template: _template2['default'],
	
	    props: {
	        expiryMonth: {
	            type: 'var',
	            required: false
	        },
	        expiryYear: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.expiryFormat = (0, _squid.$feature)('ccExpiryDateFormat', 'MMYY', _squid.$locale.country);
	
	            if (this.expiryMonth && this.expiryYear) {
	                if (this.expiryFormat === 'MMYY') {
	                    this.expiryDate = this.expiryMonth + '/' + this.expiryYear.substring(2, 4);
	                } else if (this.expiryFormat === 'MMYYYY') {
	                    this.expiryDate = this.expiryMonth + '/' + this.expiryYear;
	                }
	            }
	
	            if (this.expiryFormat === 'MMYY') {
	                this.maxlength = 5;
	                this.expiryMask = '99/99';
	            } else {
	                this.maxlength = 7;
	                this.expiryMask = '99/9999';
	            }
	
	            this.formatExpiry = function (event) {
	                var key = event.keyCode || event.charCode;
	                var $el = $(event.target);
	                var val = $el.val().replace(/[^0-9\/]/gi, '');
	                var strokes = val.length;
	
	                // Ignore delete keys
	                if (key === 8 || key === 46) {
	                    return;
	                }
	
	                // after two characters add a slash char
	                if (strokes === 2) {
	                    val += '/';
	                }
	
	                _this.expiryDate = val;
	                $el.mask(_this.expiryMask);
	            };
	
	            var currentYear = new Date().getFullYear().toString();
	            var validMonths = _squid.$util.map(_squid.$util.range(1, 13), function (num) {
	                return ('0' + num).substr(-2);
	            });
	
	            this.validate = function (expiryDate) {
	                if (!expiryDate) {
	                    return;
	                }
	
	                var month = void 0,
	                    year = void 0,
	                    unformatted = void 0;
	                var isValid = false;
	
	                unformatted = expiryDate.replace(/[^0-9]/gi, '');
	                if (unformatted.length > 3) {
	                    month = unformatted.substring(0, 2);
	                    if (_this.expiryFormat === 'MMYY') {
	                        year = currentYear.substring(0, 2) + unformatted.substring(2, 4);
	                    } else if (_this.expiryFormat === 'MMYYYY') {
	                        year = unformatted.substring(2, 6);
	                    }
	
	                    isValid = validMonths.indexOf(month) > -1 && year >= currentYear;
	
	                    if (isValid) {
	                        var expDate = new Date(year, parseInt(month, 10) - 1);
	                        var today = new Date();
	                        isValid = expDate > today;
	                    }
	                }
	
	                _this.expiryYear = year;
	                _this.expiryMonth = month;
	
	                return isValid;
	            };
	        }
	    }
	});
	
	angular.value("$xoCardExpiryDirective", $xoCardExpiryDirective);
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$feature;
	
	_squid.$util;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-ui-components/src/tooltip/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/tooltip/template.html"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template, $) {
	    squid.module('xo-tooltip.directive', ['squid']).directive('xoTooltip', function () {
	
	        return {
	            template: template,
	            restrict: 'E',
	            transclude: true,
	            scope: {
	                trigger: '@',
	                showEvent: '@',
	                hideEvent: '@',
	                displayInline: '=',
	                align: '@' // can take left/right
	            },
	
	            link: function link($scope, $element) {
	                $($element).find('.toolTip').on('click', function (event) {
	                    event.stopPropagation();
	                });
	            },
	
	            controller: function controller($scope, $element, $timeout) {
	
	                function isLink() {
	                    return $($scope.trigger).is('a');
	                }
	
	                $timeout(function () {
	                    var $trigger = $($scope.trigger);
	                    var isMouseOver = false;
	                    var toolTip = $($element).find('.toolTip');
	
	                    var toolTipID = $scope.toolTipID = 'toolTip_' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
	
	                    $scope.showEvent = $scope.showEvent || (isLink() ? 'click' : 'focus');
	                    $scope.hideEvent = $scope.hideEvent || 'blur';
	
	                    $scope.toggle = function (event) {
	
	                        if (event) {
	                            event.stopPropagation();
	                            event.preventDefault();
	                        }
	
	                        if (toolTip.length && $(toolTip).is(':visible')) {
	                            $scope.close();
	                        } else {
	                            $scope.show();
	                        }
	                    };
	
	                    $scope.show = function (event) {
	
	                        if (event) {
	                            event.stopPropagation();
	                            event.preventDefault();
	                        }
	
	                        // Associate toolTipId with trigger element aria-describedby
	                        var describedByIds;
	                        if ($trigger.attr('aria-describedby')) {
	                            describedByIds = $trigger.attr('aria-describedby').split(' ');
	                        } else {
	                            describedByIds = [];
	                        }
	
	                        if (!~describedByIds.indexOf(toolTipID)) {
	                            describedByIds.push(toolTipID);
	                        }
	
	                        $trigger.attr('aria-describedBy', describedByIds.join(' '));
	
	                        // Show the tooltip and position the page scroll to include the element on page
	                        $($element).show();
	                        $(toolTip).slideDown({
	                            progress: function progress() {
	                                var windowBot = $(window).scrollTop() + $(window).height();
	                                var toolTipBot = toolTip.offset().top + toolTip.outerHeight();
	                                if (toolTipBot > windowBot) {
	                                    $(window).scrollTop(toolTipBot - $(window).height());
	                                }
	                            }
	                        });
	                    };
	
	                    $scope.close = function (event) {
	                        if (event) {
	                            event.stopPropagation();
	                            event.preventDefault();
	                        }
	
	                        if (!isMouseOver) {
	                            if (toolTip.length && $(toolTip).is(':visible')) {
	                                $(toolTip).slideUp(100, function () {
	                                    $($element).hide();
	                                });
	                            } else {
	                                $($element).hide();
	                            }
	
	                            // Remove tooltipId from aria-describedby
	                            var describedByIds = $trigger.attr('aria-describedby');
	                            if (describedByIds && ~describedByIds.indexOf(toolTipID)) {
	                                describedByIds = describedByIds.split(' ').filter(function (id) {
	                                    return id !== toolTipID;
	                                });
	                                $trigger.attr('aria-describedby', describedByIds.join(' '));
	                            }
	                        }
	                    };
	
	                    $($element).on('click', '.close', function (event) {
	                        $scope.close(event);
	                    });
	
	                    $($element).on('mouseover', function (event) {
	                        isMouseOver = true;
	                    });
	
	                    $($element).on('mouseleave', function (event) {
	                        isMouseOver = false;
	                    });
	
	                    $(document).on('click.toolTip', function (event) {
	                        $scope.close();
	                    });
	
	                    if (isLink()) {
	                        $trigger.on('click.toolTip', $scope.toggle);
	                        $trigger.on('blur.toolTip', $scope.close);
	                    } else if ($scope.showEvent === $scope.hideEvent) {
	                        $trigger.on($scope.showEvent + '.toolTip', function (event) {
	                            $scope.toggle(event);
	                        });
	                    } else {
	                        $trigger.on($scope.showEvent + '.toolTip', function (event) {
	                            $scope.show(event);
	                        });
	
	                        $trigger.on($scope.hideEvent + '.toolTip', function (event) {
	                            $scope.close(event);
	                        });
	                    }
	
	                    // Clean up document listener on close
	                    $scope.$on('$destroy', function () {
	                        $(document).off('click.toolTip');
	                        $trigger.off($scope.showEvent + '.toolTip');
	                        $trigger.off($scope.hideEvent + '.toolTip');
	                        $scope.close();
	                    });
	                }, 50);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/tooltip/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"toolTip {{align}}\" ng-class=\"{'displayInline': displayInline, 'balloon': !displayInline}\" ng-transclude role=\"tooltip\" id=\"{{toolTipID}}\">\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/cardExpiry/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"expirationField inputField\" id=\"expirationField\" directionality content>\n    <label class=\"expires\" for=\"expiry_value\">{{ content('creditcard.expiresLabel') }}</label>\n    <div class=\"inputField\" directionality>\n        <input ng-model=\"expiryDate\"\n               name=\"expiry_value\"\n               id=\"expiry_value\"\n               value=\"\"\n               maxlength=\"{{maxlength}}\"\n               autocapitalize=\"off\"\n               aria-describedby=\"expiryHelp\"\n               autocomplete=\"off\"\n               ui-validate=\"'validate($value)'\"\n               ng-keyup=\"formatExpiry($event)\"\n               placeholder=\"{{content('creditcard.expiresPlaceholder')}}\"\n               data-error-text=\"{{content('validation.validExpirationDate')}}\"\n               xo-error-tooltip\n               required />\n        <span id=\"expiryHelp\" class=\"accessAid\" ng-bind=\"content('creditcard.expiresPlaceholder')\"></span>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/cardMetaData/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$CardMetaData = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CARD_META_DATA = {
	    DEFAULT: {
	        fields: {
	            address: true,
	            cvv: true,
	            dob: false,
	            expiry: true,
	            issue: false,
	            phone: false
	        },
	        length: {
	            cvv: 3,
	            min: 16,
	            max: 16
	        },
	        luhn: true,
	        phoneType: 'Mobile',
	        spaces: '4,8,12'
	    },
	
	    PLCC: {
	        fields: {
	            expiry: false,
	            cvv: false,
	            address: false
	        },
	        length: {
	            min: 10,
	            max: 16
	        }
	    },
	
	    MAESTRO: {
	        pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
	        length: {
	            min: 12,
	            max: 19
	        },
	        spaces: '4,8,12,16'
	    },
	
	    SWITCH: {
	        pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
	        fields: {
	            issue: true
	        },
	        length: {
	            min: 12,
	            max: 19
	        },
	        spaces: '4,8,12,16'
	    },
	
	    DINERSCLUB: {
	        pattern: /^(36|38|30[0-5])/,
	        length: {
	            min: 14,
	            max: 14
	        }
	    },
	
	    DISCOVER: {
	        pattern: /^(6011|65|64[4-9]|622|36|38|30[0-5])/,
	        length: {
	            min: 14
	        }
	    },
	
	    MASTERCARD: {
	        pattern: /^(5[1-5]|2(2(2[1-9]|[3-9]\d)|[3-6]\d\d|7[0-1]\d|720))/
	    },
	
	    AMEX: {
	        pattern: /^3[47]/,
	        length: {
	            cvv: 4,
	            min: 15,
	            max: 15
	        },
	        spaces: '4,10'
	    },
	
	    VISA: {
	        pattern: /^4/,
	        length: {
	            min: 13
	        },
	        subTypes: {
	            QIWI: {
	                pattern: /^(428122|489049|469395|446942|462012)/
	            }
	        }
	    },
	
	    JCB: {
	        pattern: /^(?:2131|1800|35[0-9]{3})/,
	        length: {
	            min: 15
	        }
	    },
	
	    CBNATIONALE: {},
	
	    CETELEM: {
	        fields: {
	            dob: true
	        },
	        length: {
	            max: 19
	        },
	        spaces: '4,8,12,16'
	    },
	
	    COFIDIS: {
	        fields: {
	            dob: true,
	            expiry: false,
	            cvv: false
	        },
	        length: {
	            min: 8,
	            max: 9
	        },
	        spaces: '4,8',
	        luhn: false
	    },
	
	    COFINOGA: {
	        fields: {
	            dob: true,
	            cvv: false
	        },
	        length: {
	            min: 17,
	            max: 17
	        },
	        spaces: '4,8,12,16'
	    },
	
	    ELO: {
	        pattern: /^9/,
	        length: {
	            min: 13
	        }
	    },
	
	    HIPER: {
	        pattern: /^6/,
	        length: {
	            min: 13
	        }
	    },
	
	    HIPERCARD: {
	        pattern: /^7/,
	        length: {
	            min: 13
	        }
	    },
	
	    CUPCREDIT: {
	        fields: {
	            address: false,
	            phone: true
	        },
	        length: {
	            max: 19
	        }
	    },
	
	    CUPAMEXCREDIT: {
	        fields: {
	            address: false,
	            phone: true
	        },
	        length: {
	            cvv: 4,
	            min: 15,
	            max: 15
	        }
	    },
	
	    CUPDEBIT: {
	        fields: {
	            address: false,
	            cvv: false,
	            expiry: false,
	            phone: true
	        },
	        length: {
	            max: 19
	        }
	    },
	
	    CUPAMEXDEBIT: {
	        fields: {
	            address: false,
	            cvv: false,
	            expiry: false,
	            phone: true
	        },
	        length: {
	            min: 15,
	            max: 15
	        }
	    }
	};
	
	Object.keys(CARD_META_DATA).forEach(function (key) {
	    CARD_META_DATA[key] = $.extend(true, {}, CARD_META_DATA.DEFAULT, CARD_META_DATA[key]);
	});
	
	Object.keys(CARD_META_DATA).forEach(function (key) {
	    CARD_META_DATA[key].spaces = CARD_META_DATA[key].spaces.split(',').map(Number);
	});
	
	function getTypeByPattern(cardMetaData, types, number) {
	    var result = void 0;
	    types.some(function (type) {
	        var metaData = cardMetaData[type];
	        if (metaData && metaData.pattern && metaData.pattern.test(number)) {
	            result = type;
	            return true;
	        }
	    });
	    return result;
	}
	
	var $CardMetaData = exports.$CardMetaData = {
	    getMetaData: function getMetaData(card, field) {
	        var cardType = card && card.type || 'DEFAULT';
	        if (cardType === 'CUP') {
	            cardType = cardType + (card.dualType ? card.dualType : '');
	            cardType = cardType + (['DEBIT', 'DEBITCARD'].indexOf(card.productType) > -1 ? 'DEBIT' : 'CREDIT');
	        }
	        return _squid.$Class.get(CARD_META_DATA[cardType], field);
	    },
	    getCardType: function getCardType(types, number) {
	        var cardType = {};
	        if (_angular2['default'].isArray(types) && number) {
	            cardType.type = getTypeByPattern(CARD_META_DATA, types, number);
	            var metaData = CARD_META_DATA[cardType.type];
	            if (metaData && metaData.subTypes) {
	                cardType.subType = getTypeByPattern(metaData.subTypes, types, number);
	            }
	        }
	        return cardType;
	    }
	};
	
	_angular2['default'].value("$CardMetaData", $CardMetaData);
	_squid.$Class;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/cvv/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoCvvDirective = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _cardMetaData = __webpack_require__("./components/xo-wallet-components/src/add-card/cardMetaData/index.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/add-card/cvv/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoCvvDirective = exports.$xoCvvDirective = _squid.$Component.extend('$xoCvvDirective', {
	    tag: 'xo-cvv',
	    template: _template2['default'],
	
	    props: {
	        card: {
	            type: 'var'
	        },
	        showLabel: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.maskCVV = (0, _squid.$feature)('maskCVV', false, _squid.$locale.country);
	            this.cvvLength = function () {
	                return _cardMetaData.$CardMetaData.getMetaData(_this.props.card, 'length.cvv');
	            };
	            this.cvvRequired = function () {
	                return _this.props.card.type !== 'MAESTRO' || (0, _squid.$feature)('maestroCvvRequired', false, _squid.$locale.country);
	            };
	        }
	    }
	});
	
	angular.value("$xoCvvDirective", $xoCvvDirective);
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$feature;
	
	_cardMetaData.$CardMetaData;

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/cvv/template.html":
/***/ function(module, exports) {

	module.exports = "<div content class=\"inputField cvvField\" id=\"cvvField\" directionality>\n    <label ng-if=\"showLabel\" class=\"cvv nolap\" for=\"cvv\">{{ content('creditcard.cscLabel') }}</label>\n\n    <div class=\"cvvSecurityCode inputField\" directionality>\n        <input type=\"{{maskCVV ? 'password' : 'tel'}}\" id=\"cvv\" name=\"cvv\" ng-model=\"card.security_code\"\n               aria-describedby=\"securityCodeHelp\"\n               ng-pattern=\"/^[0-9]{1,4}$/\" ng-minlength=\"cvvLength()\" maxlength=\"{{cvvLength()}}\"\n               placeholder=\"{{cvvLength() === 3 ? content('creditcard.threeDigits') : content('creditcard.fourDigits')}}\"\n               ng-required=\"cvvRequired()\" ng-class=\"{'four': cvvLength() === 4}\" autocomplete=\"off\"\n               data-error-text=\"{{content('validation.validCSC')}}\" xo-error-tooltip />\n\n        <span id=\"securityCode\" class=\"creditCard\" role=\"img\" ng-class=\"{'four': cvvLength() === 4}\"\n              aria-label=\"{{cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')}}\">\n        </span>\n        <span id=\"securityCodeHelp\" class=\"accessAid\" ng-bind=\"cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')\"></span>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/init/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _util = __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js");
	
	var _index = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/spinner-button/directive.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/init/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoInitOtpDirective', {
	    tag: 'xo-init-otp',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        phone: {
	            type: 'var',
	            required: false
	        },
	        cardmodel: {
	            type: 'var',
	            required: true
	        },
	        onSuccess: {
	            type: 'var',
	            required: true
	        },
	        flag: {
	            type: 'var',
	            required: true
	        },
	        message: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    actions: {
	        initOtp: function initOtp() {
	            var _this = this;
	
	            var handleContingencies = function handleContingencies() {
	                var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	                var prop = arguments[1];
	
	                var errorData = void 0;
	                if (result.errorCodes) {
	                    errorData = result;
	                } else {
	                    errorData = {
	                        errorCodes: [result['0'] || 'ISSUER_DECLINE']
	                    };
	                }
	
	                _this.message(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));
	
	                if (window.scrollTo) {
	                    window.scrollTo(0, 0);
	                }
	            };
	
	            this.isProcessing = true;
	
	            var resolveOTP = new _index.$ResolveOTP({ id: this.cardmodel.id });
	
	            resolveOTP.action('init', {
	                silent: true,
	                data: {
	                    phone: {
	                        country_code: this.phone.IntDialingCountryCode,
	                        number: this.phone.telephone
	                    }
	                },
	                resultModel: {},
	                success: function success() {
	                    _this.onSuccess();
	                },
	
	                error: function error() {
	                    handleContingencies();
	                },
	
	                contingencies: {
	                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
	                        // prop for last 4 digits of card in error message
	                        var prop = {
	                            number: _this.cardmodel.card.number.slice(-4)
	                        };
	
	                        handleContingencies(result, prop);
	                        _util.$fiErrorUtil.addFieldErrors(result, _this.$element);
	                    },
	                    DEFAULT: function DEFAULT() {
	                        handleContingencies();
	                    }
	                }
	            })['finally'](function () {
	                _this.isProcessing = false;
	            });
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this2 = this;
	
	            this.$watch('isProcessing', function (isProcessing) {
	                if (isProcessing) {
	                    _this2.$element.addClass('processing');
	                } else {
	                    _this2.$element.removeClass('processing');
	                }
	            });
	            $('#upopConfirmation .modalContainer').focus();
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_util.$fiErrorUtil;
	
	_index.$ResolveOTP;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-wallet-components/src/fi-contingency-list/util.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/contingencies.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, contingencyList) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('fi.errorUtil', ['squid']).factory('$fiErrorUtil', function ($renderContent) {
	        return {
	            addPageErrors: function addPageErrors(errorData, contentBundle, prop, defaultKey) {
	
	                // error handling for filifecycle and fimanagement. 
	                if (!errorData.errorCodes) {
	                    errorData.errorCodes = errorData && [errorData['0']];
	                }
	
	                var messages = [];
	                if (errorData.errorCodes && errorData.errorCodes.length) {
	                    errorData.errorCodes.forEach(function (errorCode) {
	                        var contentKey = contingencyList[errorCode] || defaultKey || 'errorGeneral';
	                        var message;
	                        if (angular.isArray(contentKey)) {
	                            for (var i = 0; i < contentKey.length; i++) {
	                                message = $renderContent(contentBundle + '.' + contentKey[i], prop);
	                                if (message) {
	                                    break;
	                                }
	                            }
	                        } else {
	                            message = $renderContent(contentBundle + '.' + contentKey, prop);
	                        }
	
	                        messages.push(message);
	                    });
	
	                    return {
	                        msgs: messages,
	                        type: 'error'
	                    };
	                }
	            },
	
	            /**
	             * Highlight the Error Fields by ng-model
	             * @param errorData
	             * @param element
	             * @param modelPrefix
	             */
	            addFieldErrors: function addFieldErrors(errorData, element, modelPrefix) {
	
	                if (errorData.fields && errorData.fields.length) {
	                    errorData.fields.forEach(function (field) {
	                        var $field = $(element).find('[ng-model="' + (modelPrefix ? modelPrefix : '') + field.field + '"]');
	                        $field.addClass('backendError');
	                        $field.attr('aria-invalid', true);
	                    });
	                }
	                $(element).find('.backendError:first').focus();
	            },
	
	            /**
	             * Highlight the Error Fields by element name
	             * @param errorData
	             * @param element
	             * @param modelPrefix
	             */
	            addFieldErrorsByName: function addFieldErrorsByName(errorData, element, modelPrefix) {
	
	                if (errorData.fields && errorData.fields.length) {
	                    errorData.fields.forEach(function (field) {
	                        var fieldName = void 0;
	                        if (modelPrefix && field.field && field.field.length > 0) {
	                            // Add prefix with CamelCase of field name
	                            fieldName = modelPrefix + field.field[0].toUpperCase() + field.field.substring(1);
	                        } else {
	                            fieldName = field.field;
	                        }
	                        var $field = $(element).find('[name="' + fieldName + '"]');
	                        $field.addClass('backendError');
	                        $field.attr('aria-invalid', true);
	                    });
	                }
	                $(element).find('.backendError:first').focus();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/fi-contingency-list", "components/xo-wallet-components/src/fi-contingency-list/util.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/fi-contingency-list/contingencies.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var contingencyList = {
	        INSTRUMENT_COUNT_EXCEEDED: 'errorInstrumentCountExceeded',
	        INSTRUMENT_COUNT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
	        INSTRUMENT_COUNT_LIMIT_EXCEEDED: 'errorInstrumentCountExceeded',
	        INSTRUMENT_COUNT_LIMIT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
	        INSTRUMENT_UNAVAILABLE: 'errorInstrumentUnavailable',
	        INSTRUMENT_REFUSED_DUE_TO_MAX_LIMIT: 'errorInstrumentRefused',
	        INSTRUMENT_REFUSED_DUE_TO_MAX_SHARED_INSTRUMENT_LIMIT: ['errorInstrumentUnavailable', 'errorInstrumentRefused'],
	        INSTRUMENT_ALREADY_EXISTS: 'errorInstrumentAlreadyExists',
	        INSTRUMENT_BILLING_ADDRESS_NOT_ACCEPTED: 'errorInstrumentBillingAddressNotAccepted',
	        BILLING_ADDRESS1: 'errorInstrumentBillingAddressNotAccepted',
	        BILLING_CITY: 'errorInstrumentBillingAddressNotAccepted',
	        BILLING_COUNTRY: 'errorInstrumentBillingAddressNotAccepted',
	        BILLING_DIFFERENT_COUNTRY: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
	        INSTRUMENT_UPDATE_NO_CHANGE: 'errorInstrumentUpdateNoChange',
	        INSTRUMENT_DUPLICATE_LIMIT_REACHED: 'errorInstrumentRefused',
	        NOT_ELIGIBLE_TO_EDIT_CARD: 'notEligibleToEditCard',
	        INTERNAL_ERROR: 'errorInternalError',
	        INSTRUMENT_REFUSED: 'errorInstrumentRefused',
	        INSTRUMENT_INTERNATIONAL: 'errorIssuerRejectIntl',
	        REJECT_REFUSED: ['errorIssuerReject', 'errorInstrumentRefused'],
	        PAYPAL_DEBIT_CARD_REFUSED: ['errorPaypalDebitRefused', 'errorGeneral'],
	        PAYPAL_CREDIT_CARD_REFUSED: ['errorPaypalCreditRefused', 'errorGeneral'],
	        PAYPAL_CARD_REFUSED: ['errorPaypalRefused', 'errorGeneral'],
	        EXCESSIVE_REJECTIONS: ['errorExcessiveRejectGuest', 'errorInstrumentRefused'],
	        CC_INVALID_CSC: ['errorCheckDigits', 'errorGeneral'],
	        INVALID_EXPIRATION_DATE: 'errorInvalidExpirationDate',
	        CHECK_DIGITS_NOT_PRESENT: ['errorCheckDigitsNotPresent', 'errorGeneral'],
	        REJECT_UNKNOWN: ['errorIssuerReject', 'errorInstrumentRefused'],
	        SETTLEMENT_DENIED: 'errorInstrumentRefused',
	        MAX_AMOUNT_EXCEEDED: ['errorMaxAmountExceeded', 'errorInstrumentRefused'],
	        ISSUER_ERROR: ['errorIssuerDenied', 'errorInstrumentRefused'],
	        MISSING_FIELD: ['errorInvalidData', 'errorGeneral'],
	        INVALID_PARAMETERS: ['errorInvalidData', 'errorGeneral'],
	        INVALID_DATA: ['errorInvalidData', 'errorGeneral'],
	        INVALID_ACCOUNT: ['errorInvalidAccount', 'errorGeneral'],
	        INVALID_INSTRUMENT_ID: ['errorInvalidAccount', 'errorGeneral'],
	        ACCOUNT_RESTRICTED: ['errorAccountRestricted', 'errorGeneral'],
	        ISSUER_RESTRICTED: ['errorIssuerReject', 'errorGeneral'],
	        ISSUER_REJECTED: ['errorIssuerReject', 'errorGeneral'],
	        ADDRESS_MISMATCH: 'errorInstrumentBillingAddressNotMatch',
	        CHECK_DIGITS_NOT_PROC: ['errorCheckDigitsNotPresent', 'errorGeneral'],
	        CHECK_DIGITS_UNSUPPORTED: ['errorCheckDigits', 'errorGeneral'],
	        CHECK_DIGITS_UNAVAILABLE: ['errorCheckDigits', 'errorGeneral'],
	        BILL_ADDR_UNAVAILABLE: ['errorInstrumentBillingAddressUnavailable', 'errorInstrumentBillingAddressNotAccepted'],
	        BILL_ADDR_UNSUPPORTED: ['errorInstrumentBillingAddressUnsupported', 'errorInstrumentBillingAddressNotAccepted'],
	        BILL_ADDR_UNAVAILABLE_GLOBAL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
	        BILL_ADDR_NOT_ALLOWED: ['errorInstrumentBillingAddressNotAccepted', 'errorAddressNotAllowed'],
	        BILL_ADDR_UNAVAILABLE_INTL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
	        INSTRUMENT_DISABLED: 'errorInstrumentRefused',
	        PI_TYPE_NOT_SUPPORTED: 'errorInvalidCCNumberOrType_global',
	        REJECT_AMEX_ADULT: ['errorAmexAdult', 'errorGeneral'],
	        INVALID_BANK_ROUTING_NUMBER: 'invalidRoutingNumber',
	        BANK_ROUTING_NUMBER_IS_EMPTY: 'invalidPINumber',
	        INVALID_BANK_ACCOUNT_NUMBER: 'invalidPINumber',
	        BANK_ACCOUNT_NUMBER_IS_EMPTY: 'invalidPINumber',
	        INVALID_BANK_IBAN: 'invalidPINumber',
	        INVALID_IBAN_CODE: 'invalidPINumber',
	        INVALID_BANK_IBAN_CONVERSION_ERROR: 'invalidPINumber',
	        INVALID_BENEFICIARY_FIRST_NAME: 'errorInvalidFirstName',
	        INVALID_BENEFICIARY_NAME: 'errorInvalidFirstName',
	        INVALID_BANK_BENEFICIARY_NUMBER: 'errorGeneral',
	        INVALID_BANK_ADDRESS: 'errorGeneral',
	        INVALID_CARD_NUMBER: 'errorInvalidCCNumberOrType',
	        INVALID_CARD_TYPE: 'errorInvalidCCNumberOrType',
	        INVALID_SECURITY_CODE: 'errorInvalidCSC',
	        INVALID_FIRST_NAME: 'errorInvalidFirstName',
	        INVALID_LAST_NAME: 'errorInvalidLastName',
	        INVALID_EXPIRY: 'errorInvalidExpirationDate',
	        INVALID_PHONE: 'errorInvalidPhone',
	        BANK_ADDRESS_IS_EMPTY: 'errorGeneral',
	        INVALID_BANK_BRANCH_NUMBER: 'errorGeneral',
	        ADD_REFUSED_DUE_TO_EXCEEDING_MAX_DUPLICATE_INSTRUMENT_LIMIT: 'errorInstrumentUnavailable',
	        EMPTY_DATA: 'errorGeneral',
	        ISSUER_DECLINE: 'errorIssuerReject',
	        WRONG_CONFIRMATION_VALUES: 'wrongConfirmationValue',
	        CONFIRMATION_RESEND_COUNT_EXCEEDED: 'resendValExceeded',
	        FREQUENT_REQUEST_VERIFICATION_CODE: 'frequentVerificationCodeReq',
	        TRANSACTION_TIMEOUT: 'transactionTimeout',
	        NOT_CONFIRMED: 'notConfirmed',
	        CONTACT_CARD_ISSUER_TO_VERIFY: 'issuerVerify',
	        CARD_NOT_ACTIVATED_FOR_UPOP: 'cardNotActivatedUpop',
	        RESTRICTED_CARD: 'cardRestricted',
	        INVALID_ONE_TIME_PASSWORD: 'errorInvalidOtpCode',
	        DUPLICATED_TRANSACTION: 'duplicateTransaction'
	
	    };
	
	    return contingencyList;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-models/src/fi/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var BILLING_ADDRESS_FORMAT = {
	    DEFAULT: {
	        ',': ', ',
	        ' ': ' '
	    },
	    IL: {
	        he: {
	            ',': '‏, ‏',
	            ' ': '‏ ‏'
	        }
	    }
	};
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.fi', ['squid']).factory('$CardModel', function ($Model, $util) {
	        return $Model.extend('CardModel', {
	
	            serialize: function serialize() {
	
	                return {
	                    type: this.type,
	                    number: this.number.replace(/[^\d]+/g, ''),
	                    security_code: this.security_code,
	                    expiry_month: this.expiry_month && $util.pad(this.expiry_month, 2),
	                    expiry_year: this.expiry_year,
	                    issue_number: this.issue_number ? this.issue_number : undefined,
	                    start_month: this.start_month ? $util.pad(this.start_month, 2) : undefined,
	                    start_year: this.start_year ? this.start_year : undefined
	                };
	            },
	
	            last4: function last4() {
	                var cardNumber = this.number;
	
	                return cardNumber.substr(cardNumber.length - 4);
	            },
	
	            isExisting: function isExisting() {
	                return this.number && Boolean(this.number.match(/^xxxx-xxxx-xxxx-[\d]{4}$/));
	            }
	        });
	    }).factory('$AddCardModel', function ($Model, $Api, $CardModel) {
	        return $Model.extend('AddCardModel', {
	
	            api: new $Api({
	                uri: '/api/fi/card/:id?'
	            }),
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.card = new $CardModel();
	            },
	
	            serialize: function serialize() {
	                var id = this.address.id && this.address.id !== '0' ? this.address.id : undefined;
	
	                return {
	                    cardType: this.cardType ? this.cardType : 'creditCard',
	                    sponsor_id: this.sponsor_id,
	                    preference: this.preference,
	                    user: this.user,
	                    card: this.card.serialize(),
	                    address: id ? {
	                        id: id
	                    } : this.address.serialize()
	                };
	            },
	
	            clearId: function clearId() {
	                delete this.id;
	            }
	        });
	    }).factory('$CardTypesModel', function ($Model, $Api, $locale, $util, $feature) {
	        return $Model.extend('CardTypesModel', {
	
	            api: new $Api({
	                uri: '/api/fi/card/types?country=:country&token=:token'
	            }),
	
	            retrieve: function retrieve() {
	                return this._super.retrieve.apply(this, arguments).then(function (result) {
	                    // QIWI is VISA cobranded card supported currently in Russia.
	                    if ($feature('qiwiCardSupported') && result.allowed && result.allowed.indexOf('VISA') > -1 && result.allowed.indexOf('QIWI') === -1) {
	                        result.allowed.push('QIWI');
	                    }
	                    return result;
	                });
	            },
	
	            supportedNames: function supportedNames() {
	                return $util.map(this.allowed, function (type) {
	                    return $locale.content.cardTypes[type];
	                });
	            }
	        });
	    }).factory('$BankModel', function ($Model) {
	        return $Model.extend('BankModel', {
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.bank_account_number = '';
	                this.bank_routing_number = '';
	                this.iban_number = '';
	            },
	
	            serialize: function serialize() {
	                var data = {};
	
	                if (this.bank_account_number) {
	                    data.bank_account_number = this.bank_account_number;
	                }
	                if (this.bank_routing_number) {
	                    data.bank_routing_number = this.bank_routing_number;
	                }
	                if (this.iban_number) {
	                    data.iban_number = this.iban_number.replace(/\s/g, '').toUpperCase();
	                }
	                return data;
	            }
	        });
	    }).factory('$AddBankModel', function ($Model, $Api, $BankModel) {
	
	        return $Model.extend('AddBankModel', {
	
	            api: new $Api({
	                uri: '/api/fi/bank'
	            }),
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.user = this.user || {
	                    first_name: '',
	                    dob_day: '',
	                    dob_month: '',
	                    dob_year: '',
	                    currency_code: '',
	                    country: ''
	                };
	                this.bank = this.bank || new $BankModel();
	                this.address = this.address || {};
	                this.creditorDetails = this.creditorDetails || {};
	                this.fiDetails = this.fiDetails || {};
	            },
	
	            getBankData: function getBankData() {
	                var data = {};
	
	                // Set user info
	                data.user = this.user;
	
	                // Set bank info
	                var bank = {};
	
	                this.bank = this.bank || {};
	
	                if (this.candidate_id) {
	                    data.candidate_id = this.candidate_id;
	                }
	
	                if (this.bank.bank_account_number) {
	                    bank.bank_account_number = this.bank.bank_account_number;
	                }
	
	                if (this.bank.bank_routing_number) {
	                    bank.bank_routing_number = this.bank.bank_routing_number;
	                }
	
	                if (this.bank.iban_number) {
	                    bank.iban_number = this.bank.iban_number.replace(/\s/g, '');
	                }
	                data.bank = bank;
	
	                // Set address info
	                if (this.address) {
	                    data.address = {
	                        line1: this.address.line1,
	                        line2: this.address.line2,
	                        city: this.address.city,
	                        country: this.address.country,
	                        postal_code: this.address.postal_code
	                    };
	                }
	
	                return data;
	            }
	        });
	    }).factory('$SepaModel', function ($Model, $Api) {
	        return $Model.extend('SepaModel', {
	            api: new $Api({
	                uri: '/api/fi/bank'
	            })
	        });
	    }).factory('$DeleteCardModel', function ($Model, $Api) {
	        return $Model.extend('DeleteCardModel', {
	            api: new $Api({
	                uri: '/api/fi/card/:id/delete'
	            })
	        });
	    }).factory('$BillingAddressModel', function ($Model, $Api, $config, $util, $locale) {
	        return $Model.extend('BillingAddressModel', {
	            api: new $Api({
	                uri: '/api/fi/billingaddress/validate'
	            }),
	
	            format: function format() {
	
	                var langConfig = (BILLING_ADDRESS_FORMAT[$locale.country] || {})[$locale.lang] || {};
	
	                var comma = angular.isUndefined(langConfig[',']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][','] : langConfig[','];
	                var space = angular.isUndefined(langConfig[' ']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][' '] : langConfig[' '];
	
	                return $util.filter([this.line1, this.line2, this.city, this.state, this.country]).join(comma) + space + $util.filter([this.postal_code]);
	            },
	
	            serialize: function serialize() {
	                return {
	                    line1: this.line1,
	                    line2: this.line2,
	                    city: this.city,
	                    state: this.state,
	                    postal_code: this.postal_code,
	                    normalization_status: this.normalization_status,
	                    country: this.country
	                };
	            }
	        });
	    }).factory('$BillingAddressesModel', function ($Model, $BillingAddressModel, $Api, $config, $util) {
	        return $Model.extend('BillingAddressesModel', {
	            api: new $Api({
	                uri: '/api/fi/billingaddress'
	            }),
	
	            onPopulate: function onPopulate() {
	                this.addresses = this.children($BillingAddressModel, this.addresses);
	            }
	        });
	    }).factory('$CardTypeFromBinModel', function ($Model, $Api) {
	        return $Model.extend('CardTypeFromBinModel', {
	            api: new $Api({
	                uri: '/api/fi/cardTypeFromBin?country=:country&bin=:bin&user_country=:user_country'
	            })
	        });
	    }).factory('$Resolve3DS', function ($Model, $Api) {
	        return $Model.extend('Resolve3DS', {
	            api: new $Api({
	                uri: '/api/fi/3ds/:id'
	            })
	        });
	    }).factory('$ResolveOTP', function ($Model, $Api) {
	        return $Model.extend('ResolveOTP', {
	            api: new $Api({
	                uri: '/api/fi/otp/:id'
	            })
	        });
	    }).factory('$WalletPreferences', function ($Model, $Api, $config) {
	        return $Model.extend('WalletPreferences', {
	            api: new $Api({
	                uri: '/api/fi/wallet/preferences'
	            }),
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.topup = {};
	            },
	
	            serialize: function serialize() {
	                return {
	                    topup: {
	                        amount: this.topup.amount,
	                        instrument_id: this.topup.fundingSource.instrument_id,
	                        autoload_minimum_threshold: $config.topup.autoload_minimum_threshold
	                    }
	                };
	            }
	        });
	    }).factory('$WalletInstrumentNameMapping', function ($Model) {
	        return $Model.extend('WalletInstrumentNameMapping', {
	            getInstrumentNameNormalized: function getInstrumentNameNormalized(fsName) {
	                if (!fsName) {
	                    return;
	                }
	
	                var map = {
	                    AMSOUTH: /AMSOUTH,/,
	                    BOFA: /BANK OF AMERICA/,
	                    CAPITAL: /CAPITAL/,
	                    CHASE: /CHASE/,
	                    CITI: /CITIBANK/,
	                    FIFTHTHIRD: /FIFTH THIRD BANK/,
	                    HUNTINGTON: /HUNTINGTON/,
	                    INGDIRECT: /ING DIRECT/,
	                    NATIONALCITY: /NATIONAL CITY/,
	                    PNC: /PNC/,
	                    REGIONS: /REGIONS/,
	                    SUNTRUST: /SUNTRUST/,
	                    TDWATERHOUSE: /TD WATERHOUSE/,
	                    USAA: /USAA/,
	                    USBANK: /US BANK/,
	                    VISA: /VISA/,
	                    WAMUTUAL: /WASHINGTON MUTUAL/,
	                    WELLSFARGO: /WELLS FARGO/
	                };
	
	                fsName = fsName.toUpperCase();
	
	                return Object.keys(map).find(function (key) {
	                    if (map[key].test(fsName)) {
	                        return true;
	                    }
	                    return false;
	                });
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/fi", "components/xo-models/src/fi/index.js"))

/***/ },

/***/ "./components/xo-ui-components/src/spinner-button/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner-button/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	    return angular.module('xo-spinner-button.directive', []).directive('xoSpinnerButton', function () {
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                track: '@',
	                onClick: '=',
	                buttonText: '@',
	                isProcessing: '=',
	                validate: '='
	            },
	            controller: function controller($scope) {
	
	                $scope.submit = function () {
	                    if ($scope.onClick) {
	                        $scope.onClick();
	                    } else {
	                        $scope.validate = true;
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner-button/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"spinnerBtn\" content>\n    <button track-submit={{track}} ng-click=\"submit()\" class=\"btn full\">\n        <div ng-show=\"isProcessing\" class=\"spinner\"></div>\n        <div ng-hide=\"isProcessing\" class=\"text\" ng-bind-html=\"htmlContent(buttonText)\"></div>\n    </button>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/init/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"initOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent(flag('fields.expiry') ? 'confirmUpop.creditInitOtp' : 'confirmUpop.debitInitOtp')\"></div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.initOtp()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n        <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"flag('fields.expiry') || flag('fields.cvv')\">\n            <xo-card-expiry ng-if=\"flag('fields.expiry')\" expiry-month=\"cardmodel.card.expiry_month\" expiry-year=\"cardmodel.card.expiry_year\"></xo-card-expiry>\n            <xo-cvv ng-if=\"flag('fields.cvv')\" card=\"cardmodel.card\" show-label=\"true\"></xo-cvv>\n        </div>\n        <xo-phone-input token=\"token\" ng-if=\"flag('fields.phone')\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n\n        <xo-spinner-button track='init_otp_code' token=\"token\" validate=\"validated\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnsendOtpCode\"></xo-spinner-button>\n    </form>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/confirm/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _util = __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js");
	
	var _index = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/spinner-button/directive.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/confirm/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var VERIFICATION_CODE_COUNTDOWN_IN_SECS = 180; // 3 minutes
	var RESEND_CODE_LINK_TIMEOUT_MILLI_SECS = 60000; // 1 minute
	var ONE_MINUTE_IN_SECS = 60;
	
	exports['default'] = _squid.$Component.extend('$xoConfirmOtpDirective', {
	    tag: 'xo-confirm-otp',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        phone: {
	            type: 'var',
	            required: false
	        },
	        cardmodel: {
	            type: 'var',
	            required: true
	        },
	        onSuccess: {
	            type: 'var',
	            required: true
	        },
	        message: {
	            type: 'var',
	            required: true
	        }
	    },
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	    actions: {
	        addMessage: function addMessage(type, contentKey) {
	            if (contentKey) {
	                this.message({
	                    msgKeys: [_angular2['default'].isArray(contentKey) ? contentKey[0] : contentKey],
	                    type: type || 'error'
	                });
	            }
	        },
	        stopConfirmCodeTimer: function stopConfirmCodeTimer() {
	            if (this.confirmCodeTimer) {
	                _angular.$interval.cancel(this.confirmCodeTimer);
	            }
	            this.countdown = 0;
	        },
	        stopResendCodeTimer: function stopResendCodeTimer() {
	            if (this.resendCodeTimer) {
	                _angular.$timeout.cancel(this.resendCodeTimer);
	            }
	            this.showResendLink = false;
	        },
	        updateCountdown: function updateCountdown() {
	            if (this.countdown > 0) {
	                this.countdown--;
	                this.timer = Math.floor(this.countdown / ONE_MINUTE_IN_SECS) + ':' + ('0' + this.countdown % ONE_MINUTE_IN_SECS).slice(-2);
	            } else {
	                if (!this.isConfirmProcessing) {
	                    this.actions.addMessage('warning', 'confirmUpop.codeExpired');
	                }
	                this.actions.stopConfirmCodeTimer();
	                this.actions.stopResendCodeTimer();
	            }
	        },
	        startCountdown: function startCountdown(resetTimer) {
	            var _this = this;
	
	            if (resetTimer) {
	                this.actions.stopConfirmCodeTimer();
	                this.countdown = VERIFICATION_CODE_COUNTDOWN_IN_SECS;
	                this.actions.updateCountdown();
	                this.confirmCodeTimer = (0, _angular.$interval)(this.actions.updateCountdown, 1000);
	            }
	
	            this.actions.stopResendCodeTimer();
	            this.showResendLink = false;
	            this.resendCodeTimer = (0, _angular.$timeout)(function () {
	                _this.showResendLink = true;
	            }, RESEND_CODE_LINK_TIMEOUT_MILLI_SECS);
	            this.actions.addMessage('success', 'confirmUpop.codeSent');
	        },
	        processed: function processed() {
	            if (!this.countdown && this.isConfirmProcessing) {
	                this.actions.addMessage('warning', 'confirmUpop.codeExpired');
	            }
	            this.isProcessing = this.isConfirmProcessing = false;
	        },
	        handleContingencies: function handleContingencies() {
	            var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var prop = arguments[1];
	
	            var errorData = void 0;
	            if (result.errorCodes) {
	                errorData = result;
	            } else {
	                errorData = {
	                    errorCodes: [result['0'] || 'ISSUER_DECLINE']
	                };
	            }
	
	            this.message(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));
	
	            if (window.scrollTo) {
	                window.scrollTo(0, 0);
	            }
	        },
	        sendNewCode: function sendNewCode() {
	            // reset the code field.
	            if (this.cardmodel && this.cardmodel.card) {
	                this.cardmodel.card.otp_code = '';
	            }
	            this.actions.resendCode(true);
	        },
	        resendCode: function resendCode(resetTimer) {
	            var _this2 = this;
	
	            this.isProcessing = true;
	
	            this.resolveOTP.action('init', {
	                silent: true,
	                data: {
	                    phone: {
	                        country_code: this.phone.IntDialingCountryCode,
	                        number: this.phone.telephone
	                    }
	                },
	                resultModel: {},
	                success: function success() {
	                    _this2.actions.startCountdown(resetTimer);
	                },
	
	                error: function error() {
	                    _this2.actions.handleContingencies();
	                },
	
	                contingencies: {
	                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
	                        // prop for last 4 digits of card in error message
	                        var prop = {
	                            number: _this2.cardLast4
	                        };
	
	                        _this2.actions.handleContingencies(result, prop);
	                        _util.$fiErrorUtil.addFieldErrors(result, _this2.$element);
	                    },
	                    DEFAULT: function DEFAULT() {
	                        _this2.actions.handleContingencies();
	                    }
	                }
	            })['finally'](this.actions.processed);
	        },
	        confirmOTP: function confirmOTP() {
	            var _this3 = this;
	
	            this.isProcessing = this.isConfirmProcessing = true;
	
	            this.resolveOTP.action('complete', {
	                silent: true,
	                data: {
	                    code: this.cardmodel.card.otp_code,
	                    phone: {
	                        country_code: this.phone.IntDialingCountryCode,
	                        number: this.phone.telephone
	                    },
	                    card_data: {
	                        expiration_time: {
	                            month: this.cardmodel.card.expiry_month,
	                            year: this.cardmodel.card.expiry_year
	                        },
	                        card_verification_code: this.cardmodel.card.security_code
	                    }
	                },
	
	                success: this.onSuccess,
	
	                error: function error() {
	                    _this3.actions.handleContingencies({}, 'confirmUpop');
	                    _this3.actions.processed();
	                },
	
	                contingencies: {
	                    COMPLETE_OTP_CONTINGENCY: function COMPLETE_OTP_CONTINGENCY(name, result) {
	                        // prop for last 4 digits of card in error message
	                        var prop = {
	                            number: _this3.cardLast4
	                        };
	
	                        _this3.actions.handleContingencies(result, prop);
	                        _util.$fiErrorUtil.addFieldErrors(result, _this3.$element);
	                        _this3.actions.processed();
	                    }
	                }
	            })['catch'](function () {
	                _this3.actions.handleContingencies();
	                _this3.actions.processed();
	            });
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            var _this4 = this;
	
	            this.resolveOTP = new _index.$ResolveOTP({ id: this.cardmodel.id });
	            this.isProcessing = this.showResendLink = false;
	            this.cardLast4 = this.cardmodel.card.number.slice(-4);
	            this.phoneLast4 = this.phone && this.phone.telephone && this.phone.telephone.slice(-4);
	            this.actions.startCountdown(true);
	
	            this.$watch('isProcessing', function (isProcessing) {
	                if (isProcessing) {
	                    _this4.$element.addClass('processing');
	                } else {
	                    _this4.$element.removeClass('processing');
	                }
	            });
	            $('#upopConfirmation .modalContainer').focus();
	        }
	    }
	});
	
	
	_angular.$interval;
	
	_angular.$timeout;
	
	_squid.$Component;
	
	_util.$fiErrorUtil;
	
	_index.$ResolveOTP;
	
	_index2.$CheckoutSessionModel;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/confirm/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"confirmOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent('confirmUpop.verificationCodeMsg', {phoneLastFour: phoneLast4})\"></div>\n\n    <div class=\"timer\">\n        <span class=\"left\">{{content('confirmUpop.timeRemaining')}}</span>\n        <span class=\"timeLeft\">{{timer}} {{content('confirmUpop.minutes')}}</span>\n        <a link-button class=\"resendLink right focusableIcon\" href=\"\" ng-if=\"showResendLink\" ng-click=\"actions.resendCode(false)\">{{content('confirmUpop.resendCode')}}</a>\n    </div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.confirmOTP()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n        <div class=\"confirmFields\" ng-show=\"countdown || isConfirmProcessing\">\n            <div class=\"inputField confidential\">\n                <input id=\"otp_code\"\n                       class=\"otp_code\"\n                       type=\"tel\"\n                       ng-model=\"cardmodel.card.otp_code\"\n                       name=\"otp_code\"\n                       value=\"\"\n                       placeholder=\"{{ content('confirmUpop.verificationCodeHint') }}\"\n                       autocapitalize=\"off\"\n                       autocomplete=\"off\"\n                       aria-required=\"false\"\n                       required\n                       scroll-to-top\n                       data-error-text=\"{{ content('confirmUpop.fieldInvalidOTP') }}\"\n                       xo-error-tooltip/>\n\n            </div>\n            <xo-spinner-button track='confirm_otp_code' token=\"token\" validate=\"validated\"\n                               is-processing=\"isProcessing\" button-text=\"common.confirm\"></xo-spinner-button>\n        </div>\n    </form>\n    <div class=\"sendNewOtp\">\n        <xo-spinner-button ng-if=\"!countdown && !isConfirmProcessing\" track='resend_otp_code' token=\"token\" on-click=\"actions.sendNewCode\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnResendCode\"></xo-spinner-button>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/confirm-upop/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/confirm-upop/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#upopConfirmation .modalMask,#upopConfirmation .modalWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}#upopConfirmation .close{position:absolute;top:20px;right:20px;width:19px;height:19px;padding:5px;border-radius:3px}#upopConfirmation .close:before{content:\"\";position:absolute;width:19px;height:19px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#upopConfirmation .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#upopConfirmation .close:focus:before,#upopConfirmation .close:hover:before{background-position:-223px -22px}#upopConfirmation .modalMask{background:#cbd2d6;opacity:.7}#upopConfirmation .modalWrapperAnimation{-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}#upopConfirmation .modalWrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:80px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}#upopConfirmation .modalWrapper .logo{position:relative;margin-top:-60px;width:25px;height:30px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#upopConfirmation .modalWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#upopConfirmation .modalContainer{min-height:99%;width:380px;display:block}#upopConfirmation .modalContainer .pushlogo{height:90px}#upopConfirmation .processing input{background-color:#f2f3f4}#upopConfirmation .upopOpen .modalWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}#upopConfirmation .upopConfirm .header{border-bottom:none}#upopConfirmation .upopConfirm .timingFields{padding-bottom:35px}#upopConfirmation .upopConfirm .counter{float:left}#upopConfirmation .upopConfirm a.resendCode{float:right}#upopConfirmation .upopConfirm #notifications{padding:0 0 5px}#upopConfirmation .expiration{display:inline-flex}#upopConfirmation .expiration .expires{position:relative;top:auto;left:auto}#upopConfirmation .expiration .expirationField{margin-right:10px}#upopConfirmation .expiration input.ng-invalid{padding-right:13px}#upopConfirmation .expiration label{margin-bottom:5px;color:#000}#upopConfirmation .telephoneField{clear:both;padding:0;float:none}#upopConfirmation .heading{margin:5px 0 10px;font-size:1.6em;font-family:HelveticaNeue-Light,Helvetica Neue Light,Helvetica,Arial,sans-serif}#upopConfirmation .timer{margin-bottom:20px}#upopConfirmation .timeLeft{margin-left:5px;font-weight:700}#upopConfirmation .confirmMsg{color:#6c7378;margin-bottom:20px}#upopConfirmation .resendLink{font-size:.85em}#upopConfirmation .btn{margin-top:10px}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#upopConfirmation .modalWrapper{width:100%;padding:60px 15px 0}#upopConfirmation .modalWrapper .modalContainer{width:auto}}#addCard.aside #upopConfirmation #notifications{padding:0 0 5px;margin-bottom:0}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"upopConfirmation\">\n    <div class=\"upopConfirm\">\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper\" modal-box modal-cancel=\"closeModal()\" ng-class=\"{'modalWrapperAnimation': !fromLoginOverlay}\">\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n                <a link-button track-submit=\"{{collectOtpInput ? 'close_otp_init' : 'close_otp_confirm'}}\" class=\"close focusableIcon\" href=\"#\" ng-click=\"closeModal($event)\"></a>\n                <xo-message message=\"message\"></xo-message>\n                <div class=\"heading\" ng-bind-html=\"htmlContent('confirmUpop.heading', {acctLastFour: cardLast4})\"></div>\n\n                <xo-init-otp token=\"token\" message=\"setMessage\" phone=\"props.phone\" cardmodel=\"cardmodel\" on-success=\"initSuccess\" flag=\"flag\" ng-if=\"collectOtpInput\"></xo-init-otp>\n                <xo-confirm-otp token=\"token\" message=\"setMessage\" phone=\"props.phone\" cardmodel=\"cardmodel\" on-success=\"confirmed\" ng-if=\"!collectOtpInput\"></xo-confirm-otp>\n                <div class=\"pushlogo\"></div>\n            </div>\n            <div class=\"logo\"></div>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-credit-components/src/apply-ppc/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _directive = __webpack_require__("./components/xo-credit-components/src/apply-ppc/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Route.extend('$xoApplyPPCRoute', {
	    path: 'applyPPC',
	    directive: _directive2['default'],
	    loginRequired: true,
	    children: []
	});
	
	
	_squid.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-credit-components/src/apply-ppc/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	exports['default'] = _squid.$Component.extend('$xoApplyPPCDirective', {
	    tag: 'apply-ppc',
	    template: '<div></div>',
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        redirect: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            var _this = this;
	
	            var country = this.models.checkoutAppData.merchant.merchant_country;
	
	            return (0, _squid.$pxp)('xo_hermes_cape_migration', {
	                'ctx.COUNTRY': country
	            }, 'xo_cape_migration_test').then(function (result) {
	                if (result && result.treatment_name === 'xo_cape_migration_test') {
	                    _this.goto('checkout.redirectToCape');
	                } else {
	                    var queryString = _squid.$util.queryStringSplice(_squid.$util.queryString(), {
	                        'flow': '1-P',
	                        'token': _this.token,
	                        'applyCredit': '1'
	                    }, ['cmd']);
	
	                    throw new _squid.$FallbackError({
	                        reason: 'bml_not_supported',
	                        product: 'aries',
	                        entryPoint: 'bml',
	                        params: {
	                            state: queryString
	                        }
	                    });
	                }
	            });
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$FallbackError;
	
	_squid.$util;
	
	_squid.$pxp;
	
	_checkout.$CheckoutAppDataModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-login-components/src/onetouch-interstitial/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-login-components/src/onetouch-interstitial/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-onetouch-upsell.route', ['squid', 'xo-onetouch-upsell.directive']).factory('$OneTouchUpsellRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('OneTouchUpsellRoute', {
	
	            name: 'oneTouchUpsell',
	            directive: 'xo-onetouch-upsell',
	            trackingData: {},
	            query: ['oneTouchFlowName'],
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/onetouch-interstitial", "components/xo-login-components/src/onetouch-interstitial/route.js"))

/***/ },

/***/ "./components/xo-login-components/src/onetouch-interstitial/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/onetouch-interstitial/template.html"), __webpack_require__("./components/xo-ui-components/src/accessibility/ui.js"), __webpack_require__("./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js"), __webpack_require__("./components/xo-tracking/dist/index.js"), __webpack_require__("./components/ul-inline/dist/inject.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template, ui) {
	
	    return angular.module('xo-onetouch-upsell.directive', ['squid', 'xolocale', 'tracking', 'xo-device-info']).directive('xoOnetouchUpsell', function () {
	
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                onComplete: '=',
	                disableCloseButton: '=',
	                ignoreBgClicks: '='
	            },
	            controller: function controller($scope, $rootScope, $state, $element, $timeout, $logger, $KmliUpsell, $LocaleModel, $locale, $CalDataModel, $config, $meta, $DeviceInfo, $stateParams, $AuthModel) {
	                $scope.oneTouchFlowName = $stateParams.oneTouchFlowName;
	                $scope.modalActive = false;
	                $scope.locale = $LocaleModel.instance();
	                $scope.disableCloseButton = $scope.disableCloseButton || $DeviceInfo.isDevice();
	                $scope.upsellOptInDisplayed = false;
	                var ulMeta = $config.ulMeta || {};
	                var PAYPAL = window.PAYPAL || {};
	                var ulTimeOutValue = 5000;
	                var ulTimeoutPromise = null;
	
	                var fptiData = $KmliUpsell.getFPTIAttributes();
	
	                function closeInterstitial() {
	                    $('#wrapper > xo-spinner').attr('style', '');
	                    $('body').removeClass('kmliUpsellActive');
	                    $element.removeClass('upsellOpen');
	                    $scope.onComplete();
	                }
	
	                function failureHandler(reason) {
	                    $logger.info('KMLI_UPSELL_error_' + reason);
	                    closeInterstitial();
	                }
	
	                var startTimerTS;
	                function startTimer(tag) {
	                    startTimerTS = Date.now();
	                    $logger.info('KMLI_UPSELL_START_TIMER_' + tag, {
	                        startTime: startTimerTS
	                    });
	
	                    $logger.info('checkout_fpti', {
	                        'from': 'Interstitial_Timer',
	                        'to': 'prepare_' + tag
	                    });
	
	                    ulTimeoutPromise = $timeout(function () {
	                        var stop_time = Date.now();
	                        var time_taken = stop_time - startTimerTS;
	                        $logger.info('checkout_fpti', {
	                            'from': 'Interstitial_Timer',
	                            'to': 'process_timeout',
	                            'int_error_code': 'ULLOGIN_TIMEOUT',
	                            'int_error_description': 'ULLOGIN_TIMEOUT',
	                            'error_source': 'unifiedloginnodeweb',
	                            'error_type': 'soft_decline',
	                            'page_load_time': time_taken
	                        });
	                        failureHandler('timedout');
	                        $rootScope.$emit('loaded');
	                    }, ulTimeOutValue);
	                }
	
	                function stopTimer(tag) {
	                    var stopTimerTS = Date.now();
	                    var timeTaken = stopTimerTS - startTimerTS;
	                    $logger.info('KMLI_UPSELL_STOP_TIMER_' + tag, {
	                        stopTimer: stopTimerTS,
	                        page_load_time: timeTaken
	                    });
	
	                    $logger.info('checkout_fpti', {
	                        'from': 'Interstitial_Timer',
	                        'to': 'process_' + tag,
	                        'page_load_time': timeTaken
	                    });
	
	                    if (ulTimeoutPromise) {
	                        $timeout.cancel(ulTimeoutPromise);
	                    }
	                }
	
	                function logSubmit(data) {
	                    var fptiPayload = {
	                        'from': fptiData.stateName,
	                        'to': 'process' + fptiData.transInfix + 'optin'
	                    };
	                    if (data && data.errorCode) {
	                        angular.extend(fptiPayload, {
	                            'int_error_code': data.errorCode,
	                            'error_type': 'hard_decline',
	                            'error_source': 'unifiedloginnodeweb'
	                        });
	                    }
	                    $logger.info('checkout_fpti', fptiPayload);
	                }
	
	                $scope.hideModal = function (event) {
	                    if (event) {
	                        event.preventDefault();
	                    } else if ($scope.ignoreBgClicks) {
	                        return;
	                    }
	
	                    $logger.info('checkout_fpti', {
	                        'from': fptiData.stateName,
	                        'to': 'process' + fptiData.transInfix + 'decline',
	                        'click_source': 'close_button'
	                    });
	
	                    closeInterstitial();
	                };
	
	                var ulEventHandlers = {
	                    'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        $('#wrapper > xo-spinner').hide();
	                        $('body').addClass('kmliUpsellActive');
	
	                        // CSS transition to open upsell modal and set modal to trap focus after open
	                        $timeout(function () {
	                            $element.addClass('upsellOpen');
	                            $element.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
	                                $scope.$apply(function () {
	                                    $scope.modalActive = true;
	                                    // Focus Continue button in iframe
	                                    $('#injectedOneTouchInterstitial').focus();
	
	                                    var escHandler = function escHandler(event) {
	                                        if (event.keyCode === ui.KEYS.ESC) {
	                                            $scope.hideModal();
	                                        }
	                                    };
	
	                                    // Add handler to iframe document, as events do not propagate past the iframe
	                                    $element.find('iframe').contents().on('keydown', escHandler);
	                                    $element.on('keydown', escHandler);
	                                });
	                            });
	                        });
	                    },
	                    'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
	                        $rootScope.$emit('loading');
	                        startTimer(data.event);
	                    },
	                    'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        logSubmit();
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        logSubmit({ errorCode: data.event });
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
	                        stopTimer(data.event);
	                        logSubmit({ errorCode: data.event });
	                        $rootScope.$emit('loaded');
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInNotNowClicked': function oneTouchInterstitialOptInNotNowClicked(data) {
	                        $logger.info('checkout_fpti', {
	                            'from': fptiData.stateName,
	                            'to': 'process' + fptiData.transInfix + 'decline',
	                            'click_source': 'not_now_link'
	                        });
	                        closeInterstitial(data);
	                    }
	                };
	
	                function postMessageHandler(response) {
	                    $timeout(function () {
	                        $logger.info('ul_postmessaged_received', response);
	                        var data = response.data || response.error;
	                        var eventId = data && data.event;
	                        if (eventId) {
	                            $logger.debug('KMLI_UPSELL_' + eventId, response);
	                            var handler = ulEventHandlers[eventId];
	                            if (handler) {
	                                handler(data);
	                            }
	                        }
	                    });
	                }
	
	                function upsellOptInDisplayed() {
	                    return $AuthModel.instance().retrieve().then(function (auth) {
	                        if (auth.upsellOptInDisplayed) {
	                            $scope.upsellOptInDisplayed = true;
	                        }
	                    });
	                }
	
	                function loadOneTouchUpsell() {
	                    upsellOptInDisplayed().then(function () {
	                        // If the optin upsell is already displayed, no need to display again.
	                        if ($scope.upsellOptInDisplayed) {
	                            $scope.onComplete();
	                        } else {
	                            $rootScope.$emit('loading');
	
	                            var options = {
	                                targetElement: document.getElementById('injectedOneTouchInterstitial'),
	                                queryParams: {
	                                    'stsRedirectUri': ulMeta.stsReturnUrl,
	                                    'country.x': $scope.locale.country,
	                                    'locale.x': $scope.locale.getLocaleCode(),
	                                    'flowId': $scope.token,
	                                    'correlationId': $CalDataModel.getCalCorrId(),
	                                    'flowName': $scope.oneTouchFlowName
	                                },
	                                iframePathname: '/signin/activate-one-touch',
	                                onPostMessage: postMessageHandler
	                            };
	
	                            angular.extend(options.queryParams, $KmliUpsell.getOptions());
	
	                            if ($config.deploy.isLocal()) {
	                                options.origin = 'https://' + $meta.stage;
	                            }
	
	                            if (PAYPAL && PAYPAL.unifiedLogin) {
	                                startTimer('initializeUpsell');
	                                PAYPAL.unifiedLogin.inject(options);
	                            } else {
	                                failureHandler('PAYPAL.unifiedLogin_undefined');
	                            }
	                        }
	                    });
	                }
	
	                loadOneTouchUpsell();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/onetouch-interstitial/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"kmliUpsell\" ng-class=\"{mobile: isDevice}\" content>\n    <div class=\"upsellMask\"></div>\n    <div class=\"upsellWrapper\" simple-modal=\"modalActive\" modal-cancel=\"hideModal()\">\n        <div class=\"upsellContainer\">\n            <xo-spinner></xo-spinner>\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" title=\"Close\" ng-click=\"hideModal($event)\" ng-hide=\"disableCloseButton\" aria-label=\"{{content('common.back')}}\"></a>\n                <section class=\"login\" id=\"login\">\n                    <div id=\"injectedOneTouchInterstitial\" tabindex=\"-1\">\n                    </div>\n                </section>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-sidebar/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	__webpack_require__("./components/xo-wallet-components/src/add-bank/route.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/route.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/add-shipping/route.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/delete-shipping/route.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/update-shipping/route.js");
	
	__webpack_require__("./pages/xo-shipping/route.js");
	
	__webpack_require__("./pages/xo-sidebar/directive.js");
	
	__webpack_require__("./pages/xo-sidebar-add-shipping/route.js");
	
	__webpack_require__("./pages/xo-sidebar-update-shipping/route.js");
	
	__webpack_require__("./pages/xo-sidebar-add-card/route.js");
	
	__webpack_require__("./pages/xo-sidebar-add-bank/route.js");
	
	__webpack_require__("./pages/xo-sidebar-currency-conversion/route.js");
	
	__webpack_require__("./pages/xo-sidebar-installment-options/route.js");
	
	__webpack_require__("./pages/xo-wallet/route.js");
	
	var _route = __webpack_require__("./pages/xo-sidebar-manage-wallet/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	var _route3 = __webpack_require__("./pages/xo-sidebar-update-card/route.js");
	
	var _route4 = _interopRequireDefault(_route3);
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$SidebarRoute', {
	
	    path: 'sidebar',
	    directive: 'xo-sidebar',
	    children: [{
	        name: '$SidebarShippingRoute',
	        attributes: {
	            token: 'props.token'
	        }
	    }, {
	        name: '$SidebarAddShippingRoute',
	        attributes: {
	            token: 'props.token'
	        }
	    }, {
	        name: '$SidebarAddCardRoute',
	        attributes: {
	            token: 'props.token',
	            promotion: 'props.promotion'
	        }
	    }, {
	        name: '$SidebarAddBankRoute',
	        attributes: {
	            token: 'props.token'
	        }
	    }, {
	        name: '$SidebarWalletRoute',
	        props: function props() {
	            return {
	                token: this.props.token,
	                promotion: this.props.promotion,
	                installment: this.props.installment
	            };
	        },
	        config: function config() {
	            return {
	                heading: 'asideHeader.fundingInstruments',
	                subHeading: 'asideHeader.fundingInstrumentsSubHead',
	                addRoute: 'checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'
	            };
	        }
	    }, {
	        name: '$AddBankFlowRoute',
	        attributes: {
	            token: 'props.token',
	            'parent-callbacks': 'callbacks'
	        }
	    }, {
	        name: '$AddCardPageRoute',
	        attributes: {
	            token: 'props.token',
	            'parent-callbacks': 'callbacks'
	        }
	    }, {
	        name: '$AddShippingRoute',
	        attributes: {
	            token: 'props.token',
	            'parent-callbacks': 'callbacks',
	            'done-fn': 'callbacks.done',
	            sidebar: 'sidebar',
	            update: 'props.update'
	        }
	    }, {
	        name: '$UpdateShippingRoute',
	        attributes: {
	            token: 'props.token',
	            'parent-callbacks': 'callbacks',
	            'done-fn': 'callbacks.done',
	            sidebar: 'sidebar'
	        }
	    }, {
	        name: '$DeleteShippingRoute',
	        attributes: {
	            token: 'props.token',
	            'parent-callbacks': 'callbacks',
	            sidebar: 'sidebar'
	        }
	    }, {
	        name: '$SidebarCurrencyConversionRoute',
	        attributes: {
	            token: 'props.token'
	        }
	    }, {
	        name: '$SidebarInstallmentOptionsRoute',
	        attributes: {
	            token: 'props.token'
	        }
	    }, {
	        route: _route2['default'],
	        props: function props() {
	            return {
	                token: this.token
	            };
	        }
	    }, {
	        route: _route4['default'],
	        props: function props() {
	            return {
	                token: this.token
	            };
	        }
	    }]
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-bank/directive.js"), __webpack_require__("./components/xo-wallet-components/src/add-bank/addbank/route.js"), __webpack_require__("./components/xo-wallet-components/src/add-bank/sepa/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-bank.route', ['squid', 'xo-add-bank.directive', 'xo-add-bank.addbank.route', 'xo-add-bank.sepa.route']).factory('$AddBankFlowRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('BankRoute', {
	            name: 'bank',
	            directive: 'xo-add-bank-flow',
	            titleContent: 'asideHeader.addBank',
	            children: [{
	                name: '$XOAddBankRoute',
	                attributes: {
	                    token: 'token',
	                    'parent-callbacks': 'callbacks',
	                    'error-message': 'errorMessage',
	                    bank: 'bank',
	                    sidebar: 'sidebar',
	                    hideparenthead: 'hideparenthead',
	                    'page-level': 'pageLevel'
	                }
	            }, {
	                name: '$XOSepaRoute',
	                attributes: {
	                    token: 'token',
	                    'parent-callbacks': 'callbacks',
	                    model: 'bank',
	                    sidebar: 'sidebar',
	                    hideparenthead: 'hideparenthead'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-bank", "components/xo-wallet-components/src/add-bank/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    return squid.module('xo-add-bank.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xo-message.directive', 'xo-error-tooltip.directive', 'fi.errorUtil']).directive('xoAddBankFlow', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                sidebar: '=',
	                hideparenthead: '=',
	                pageLevel: '='
	            },
	
	            controller: function controller($scope, $rootScope, $AddBankModel, $CheckoutCartModel, $populate, $CheckoutSessionModel, $state, $locale, $element, $fiErrorUtil) {
	
	                function handleContingency(name, result) {
	
	                    $scope.errorMessage = $fiErrorUtil.addPageErrors(result, 'bank');
	                    $fiErrorUtil.addFieldErrors(result, $element, 'model.');
	                    $state.go('^.add');
	                }
	
	                function updateFundingOptions() {
	                    $scope.checkoutSession.fundingOptions.action('update', {
	
	                        resultModel: $scope.checkoutSession,
	
	                        data: {
	                            planId: $scope.bankId
	                        },
	                        success: function success(result) {
	
	                            $scope.checkoutSession.message = {
	                                type: 'success',
	                                msgKeys: ['paymentMethod.paymentMethodUpdated']
	                            };
	                            $scope.parentCallbacks.done();
	                        },
	                        contingencies: {
	                            ADD_BANK_CONTINGENCY: handleContingency
	                        }
	
	                    });
	                }
	
	                $scope.callbacks = {
	
	                    addBankDone: function addBankDone(bank) {
	                        $scope.bank = bank;
	                        $state.go('^.sepa');
	                    },
	
	                    sepaDone: function sepaDone() {
	
	                        $populate($scope, {
	                            checkoutSession: $CheckoutSessionModel.instance($scope.token),
	                            cart: $CheckoutCartModel.instance($scope.token)
	                        }).then(function () {
	
	                            $scope.locale = $locale;
	
	                            var addBankReq = $scope.bank.getBankData();
	                            $scope.bank.action('add', {
	
	                                data: addBankReq,
	
	                                resultModel: {},
	
	                                success: function success(data) {
	
	                                    $scope.bankId = data.id;
	                                    var sepaStatus = data.sepaStatus;
	                                    if (sepaStatus === 'AUTHORIZED') {
	                                        return updateFundingOptions();
	                                    }
	                                    $scope.bank.action('sepaAccept', {
	
	                                        data: {
	                                            bank: {
	                                                id: data.id
	                                            }
	                                        },
	
	                                        resultModel: {},
	
	                                        success: updateFundingOptions,
	                                        contingencies: {
	                                            DEFAULT: handleContingency
	                                        }
	
	                                    });
	                                },
	
	                                contingencies: {
	                                    ADD_BANK_CONTINGENCY: handleContingency
	                                }
	
	                            });
	                        });
	                    }
	
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/template.html":
/***/ function(module, exports) {

	module.exports = "<div ui-view></div>"

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/addbank/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-bank/addbank/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-bank.addbank.route', ['squid', 'xo-add-bank.addbank.directive']).factory('$XOAddBankRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddRoute', {
	
	            name: 'add',
	            titleContent: 'asideHeader.addBank',
	            directive: 'xo-add-bank',
	            trackingData: {
	                fptiState: 'add_bank'
	            },
	            loginRequired: true,
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-bank/addbank", "components/xo-wallet-components/src/add-bank/addbank/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/addbank/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/addbank/template.html"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-bank/bank-input/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-ui-components/src/popup/directive.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return squid.module('xo-add-bank.addbank.directive', ['squid', 'xomodel.fi', 'xomodel.checkout', 'xomodel.auth', 'xo-add-bank.bank-input.directive', 'xo-message.directive', 'xo-popup.directive', 'xo-tray-height.directive', 'xo-aside-header.directive', 'xo-error-tooltip.directive', 'fi.errorUtil']).directive('xoAddBank', function () {
	        return {
	            template: template,
	
	            scope: {
	                parentCallbacks: '=',
	                errorMessage: '=',
	                bank: '=',
	                sidebar: '=',
	                hideparenthead: '=',
	                message: '=',
	                pageLevel: '='
	            },
	
	            controller: function controller($scope, $populate, $AddBankModel, $BillingAddressesModel, $AuthModel, $element, $locale, $fiErrorUtil) {
	                $scope.model = $scope.bank || new $AddBankModel({
	                    id: 123
	                });
	
	                $scope.locale = $locale;
	
	                if ($scope.hideparenthead) {
	                    $scope.hideparenthead.toggle = false;
	                }
	
	                $scope.onSubmit = function () {
	                    if ($scope.pageLevel) {
	                        $scope.pageLevel.message = null;
	                    }
	
	                    var data = $scope.model.getBankData();
	
	                    function mapValidationErrors(err) {
	                        var fields = err && err.fields || [];
	                        fields.forEach(function (fieldError) {
	                            if (fieldError && fieldError.property) {
	                                fieldError.field = fieldError.property;
	                            }
	                        });
	                        return {
	                            fields: fields
	                        };
	                    }
	
	                    $scope.model.action('validate', {
	
	                        data: data,
	
	                        resultModel: {},
	
	                        success: function success(successData) {
	                            $scope.model.creditorDetails = successData.creditorDetails;
	                            $scope.model.fiDetails = successData.fiDetails;
	                            $scope.parentCallbacks.addBankDone($scope.model);
	                        },
	
	                        contingencies: {
	                            VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, contingencyData) {
	                                $scope.errorMessage = $fiErrorUtil.addPageErrors(contingencyData, 'bank');
	                                $fiErrorUtil.addFieldErrors(contingencyData, $element, 'model.');
	                            }
	                        },
	                        validation: function validation(res) {
	                            $fiErrorUtil.addFieldErrors(mapValidationErrors(res), $element, 'model.');
	                        }
	                    });
	                };
	
	                $populate($scope, {
	                    auth: $AuthModel.instance(),
	                    billingAddresses: $BillingAddressesModel.instance()
	
	                }).then(function () {
	
	                    $scope.model.address = $scope.billingAddresses.addresses && $scope.billingAddresses.addresses[0];
	
	                    $scope.model.user.first_name = $scope.auth.first_name;
	                    $scope.model.user.last_name = $scope.auth.last_name;
	                    $scope.model.user.country = $scope.model.address && $scope.model.address.country;
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/addbank/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-aside-header back-url=\"checkout.review.sidebar.wallet\" heading='asideHeader.addBank' ng-if=\"sidebar\"></xo-aside-header>\n<xo-message message=\"errorMessage\"></xo-message>\n<div class=\"container\" ng-class=\"{asideContent: sidebar}\" xo-tray-height>\n\t<form id=\"bankForm\" name=\"bankForm\" method=\"post\" class=\"asideProceed formSmall\" novalidate=\"novalidate\">\n        <div id=\"bankFields\" class=\"clearfix\" content>\n\n\n            <div id=\"name\" class=\"fieldGroup clearfix\">\n                <div class=\"inputField  half confidential firstname\">\n                    <label for=\"firstName\" class=\"focus accessAid\">\n                        {{ content('common.firstName') }}\n                    </label>\n                    <input ng-model=\"model.user.first_name\" name=\"firstName\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" placeholder=\"{{ content('common.firstName') }}\" xo-error-tooltip required />\n                </div>\n\n                <div class=\"inputField half last-child confidential lastname\">\n                    <label for=\"lastName\" class=\"focus accessAid\">\n                        {{ content('common.lastName') }}\n                    </label>\n                    <input ng-readonly=\"model.user.last_name\" ng-model=\"model.user.last_name\" name=\"lastName\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" placeholder=\"{{ content('common.lastName') }}\" xo-error-tooltip required />\n                </div>\n            </div>\n\n            <xo-bank-input user=\"model.user\" bank=\"model.bank\"></xo-bank-input>\n\n            <p class=\"infoTxt secondary \" data-ng-bind-html=\"htmlContent( 'bank.addBankDisclaimer') \"></p>\n\n            <div class=\"buttons\">\n                <input track-submit id=\"proceedButton\" type=\"submit\" value=\"{{ content('common.continuetext') }}\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n            </div>\n        </div>\n    </form>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/bank-input/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/bank-input/template.html"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-add-bank.bank-input.directive', ['squid', 'xomodel.fi', 'xo-dropdown.directive', 'xo-error-tooltip.directive']).directive('xoBankInput', function ($rootScope) {
	        return {
	            template: template,
	
	            scope: {
	                user: '=',
	                bank: '='
	            },
	
	            /* auto formatting the user entered IBAN input */
	            link: function link(scope, element, attr) {
	                var IBANMask = 'AA00 0000 0000 0000 0000 0000 0000 0000 00';
	
	                element.on('keyup', function (event) {
	
	                    $('#ibanNumber').mask(IBANMask, {
	                        'translation': {
	                            0: { pattern: /[A-Za-z0-9]/ }
	                        }
	                    });
	                });
	            },
	
	            controller: function controller($scope, $AddBankModel) {
	
	                $scope.showIBAN = false;
	
	                var days = [];
	                var months = [];
	                var years = [];
	
	                var i;
	                for (i = 1; i <= 31; i += 1) {
	                    var d = i < 10 ? '0' + i : i.toString();
	                    days.push(d);
	                }
	
	                for (i = 1; i <= 12; i += 1) {
	                    var m = i < 10 ? '0' + i : i.toString();
	                    months.push(m);
	                }
	
	                var year = new Date().getFullYear();
	
	                for (i = year - 17; i >= year - 100; i -= 1) {
	                    years.push(i);
	                }
	
	                $scope.days = days;
	                $scope.months = months;
	                $scope.years = years;
	
	                $scope.toggleIBAN = function () {
	                    $scope.showIBAN = !$scope.showIBAN;
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/bank-input/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"bankFields\" content>\n\n    <div class=\"bban\" ng-if = \"!showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterBBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadIBAN')}}</a>\n        </p>\n\n        <div class=\"inputField restricted\">\n            <label for=\"bankAccountNumber\" class=\"accessAid nolap\">\n                {{content('DEMemberGuest.account')}}\n            </label>\n            <input id=\"bankAccountNumber\" name=\"bankAccountNumber\" type=\"text\" value=\"\" ng-model=\"bank.bank_account_number\" placeholder=\"{{content('DEMemberGuest.accountPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"10\" aria-required=\"true\"\n                   xo-validation='{\n                \"validator\": \"validBankAccount\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-text=\"{{content('scripts.validNumber')}}\" xo-error-tooltip />\n        </div>\n\n        <div class=\"inputField restricted\">\n            <label for=\"blz\" class=\"accessAid nolap\">\n                {{content('DEMemberGuest.sort')}}\n            </label>\n            <input id=\"blz\" name=\"blz\" type=\"text\" value=\"\" ng-model=\"bank.bank_routing_number\" placeholder=\"{{content('DEMemberGuest.sortPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"8\" aria-required=\"true\"  xo-validation='{\n                \"validator\": \"validRouting\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-text=\"{{content('scripts.validNumber')}}\" xo-error-tooltip />\n        </div>\n    </div>\n    <div class=\"iban\" ng-if=\"showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterIBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadBBAN')}}</a>\n        </p>\n        <div class=\"inputField restricted\">\n            <label for=\"ibanNumber\" class=\"accessAid nolap\">\n                {{content('bank.iban')}}\n            </label>\n            <input id=\"ibanNumber\" name=\"ibanNumber\" type=\"text\" value=\"\" placeholder=\"{{content('bank.IBANPlaceholder')}}\" autocomplete=\"off\" maxlength=\"42\" aria-required=\"true\" ng-model=\"bank.iban_number\" xo-validation='{ \"validator\": \"validIBANWithValidCountryCode\",\n            \"required\":  \"{{showIBAN}}\"} ' data-error-text=\"{{content('scripts.validIBAN')}}\" xo-error-tooltip />\n        </div>\n    </div>\n\n    <div id=\"dobBank\" class=\"dobbank\">\n        <fieldset>\n            <legend class=\"fieldLegend\" for=\"dob\">{{content('DEMemberGuest.dob')}}</legend>\n\n            <div class=\"dropdown fidobDay\">\n                <select xo-dropdown name=\"dobDay\" ng-model=\"user.dob_day\" id=\"dobDay\" aria-label=\"{{content('applyForBml.bmlApplyDay')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyDD')}}</option>\n                    <option ng-repeat=\"day in days\" value=\"{{day}}\" ng-selected=\"user.dob_day==='{{day}}'\">{{day}}</option>\n                </select>\n            </div>\n\n\n            <div class=\"dropdown fidobMonth\">\n                <select xo-dropdown name=\"dobMonth\" ng-model=\"user.dob_month\" id=\"dobMonth\" aria-label=\"{{content('applyForBml.bmlApplyMonth')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyMM')}}</option>\n                    <option ng-repeat=\"month in months\" value=\"{{month}}\" ng-selected=\"user.dob_month==='{{month}}'\">{{month}}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobYear\">\n                <select xo-dropdown name=\"dobYear\" ng-model=\"user.dob_year\" id=\"dobYear\" aria-label=\"{{content('applyForBml.bmlApplyYear')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyYYYY')}}</option>\n                    <option ng-repeat=\"year in years\" value=\"{{year}}\" ng-selected=\"user.dob_year==='{{year}}'\">{{year}}</option>\n                </select>\n            </div>\n\n        </fieldset>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-ui-components/src/dropdown/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(console) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, $) {
	
	    $.fn.dropdown = function () {
	        console.warn('Dropdown deprecated');
	    };
	
	    squid.module('xo-dropdown.directive', ['squid']).directive('xoDropdown', function ($parse, $window, $timeout, $injector, $rootScope, $config, $locale, $experiment, $util, $compile) {
	
	        var userAgent = ($window.navigator || {}).userAgent;
	        var isWinOS = Boolean(userAgent.match(/\(win/i));
	
	        return {
	
	            restrict: 'A',
	
	            scope: {
	                dropdownTextBindVar: '='
	            },
	
	            link: function link($scope, $element, attrs) {
	                var $parentScope = $scope.$parent;
	
	                var $select = $($element);
	
	                var selectInitialValue = '';
	
	                var ngChange = '';
	                // TODO: This html should be refactored out into a template.
	                var $span = $('<span class="custom-select" aria-hidden="true"><span><span></span></span></span>');
	
	                $select.parent().addClass('custom-select-container');
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseenter', function () {
	                    $span.addClass('active');
	                });
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('focus', function () {
	                    selectInitialValue = $parse(attrs.ngModel)($parentScope);
	                    $span.addClass('active');
	                });
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseleave', function () {
	                    $span.removeClass('active');
	                });
	
	                function executeSelectChange() {
	                    // setTimeout here is to ensure activeElement is set before our function executes
	                    $timeout(function () {
	                        var val = $parse(attrs.ngModel)($parentScope);
	                        if (selectInitialValue !== val) {
	                            if (ngChange) {
	                                ngChange($parentScope);
	                            }
	                            selectInitialValue = val;
	                        }
	                    }, 10);
	                }
	
	                if (isWinOS) {
	                    if (attrs['ngChange']) {
	                        ngChange = $parse(attrs.ngChange);
	                        attrs['ngChange'] = '';
	                    }
	
	                    $select.bind('blur', function () {
	                        executeSelectChange();
	                        $span.removeClass('active');
	                    });
	
	                    $select.bind('click', function () {
	                        executeSelectChange();
	                    });
	                } else {
	                    $select.bind('blur', function () {
	                        $span.removeClass('active');
	                    });
	                }
	
	                $select.after($span);
	
	                $select.addClass('replaced');
	
	                if (attrs['default']) {
	                    var defaultOption = document.createElement('option');
	                    defaultOption.innerText = attrs['default'];
	                    $select.append(defaultOption);
	                }
	
	                var match = (attrs.ngOptions || '').match(/in ([\w\.]+)/);
	                // Text Update Method 1(new): ng-bind on variable passed in directive and that is updated in parent/sibling scope
	                if (angular.isDefined($scope.dropdownTextBindVar)) {
	                    var selectTextElement = $span.find('span span');
	                    if (selectTextElement.length) {
	                        $(selectTextElement).attr('ng-bind', 'dropdownTextBindVar');
	                        $(selectTextElement).html($compile(selectTextElement[0])($scope));
	                    }
	
	                    $scope.$watch('dropdownTextBindVar', function (newVal) {
	                        if (document.documentElement.getAttribute('dir') === 'rtl') {
	                            $span.toggleClass('ltrOverride', !$util.hasRTL(newVal));
	                        }
	                    });
	                }
	                // Text Update Method 2(old): jQuery text update on various conditions (not as reliable for me, ran into timing edge cases)
	                else {
	                        var updateCover = function updateCover() {
	                            $timeout(function () {
	                                var text = $select.find(':selected').text().trim();
	                                $span.find('span span').text(text);
	                                if (document.documentElement.getAttribute('dir') === 'rtl') {
	                                    $span.toggleClass('ltrOverride', !$util.hasRTL(text));
	                                }
	                            }, 10);
	                        };
	
	                        $parentScope.$watch(attrs.ngModel, updateCover);
	
	                        $scope.$on('contentChange', updateCover);
	
	                        if (match) {
	                            $parentScope.$watch(match[1], updateCover);
	                        }
	                        // Update cover on arrow key press, for case where menu is not open
	                        // but user is interacting with dropdown (eg. Firefox)
	                        $select.bind('keyup', function (event) {
	                            // Arrow keys are 37 - 40
	                            if (event.which >= 37 || event.which <= 40) {
	                                updateCover();
	                            }
	                        });
	                    }
	
	                toggleOptionsLTROverride();
	                if (match) {
	                    $parentScope.$watch(match[1], function (newVal) {
	                        toggleOptionsLTROverride();
	                    });
	                }
	
	                function toggleOptionsLTROverride() {
	                    if (document.documentElement.getAttribute('dir') === 'rtl') {
	                        $timeout(function () {
	                            var options = $select.find('option');
	                            for (var i = 0; i < options.length; i++) {
	                                $(options.get(i)).toggleClass('ltrOverride', !$util.hasRTL(options.get(i).text));
	                            }
	                        });
	                    }
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "./components/xo-tray-height/dist/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global define:true */
	
	
	/* grab the logger so we can warn about being in the fallback mode */
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	/** Name:  Tray height helper */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, $) {
	    squid.module('xo-tray-height.directive', ['squid']).directive('xoTrayHeight', function ($timeout) {
	        return {
	            restrict: 'A',
	            link: function link($scope, element, attrs) {
	                // Check to see if we can use the safer full height approach
	                // or if we need to fallback to calculating the height using
	                // math and relying on the "right" timing.
	                var topClass = 'xo-sidebar-wrapper';
	                var topSelector = '.' + topClass;
	                var topElem = document.querySelector(topSelector);
	                var inScope = topElem && topElem.querySelector('[xo-tray-height]');
	                var useNewFlow = topElem && inScope;
	
	                /**
	                 * NOTE:
	                 * The following code, despite being the "new" flow, is still
	                 * a stopgap solution until such time as the markup and or
	                 * CSS undergo an overhaul. It relies on the more stable
	                 * cascading relative/absolute positioning and 100% height
	                 * *and* the fact that the code is an instance of xo-tray-height
	                 * within the xo-sidebar-wrapper.
	                 */
	                function calculate() {
	                    var curElem = element[0];
	
	                    while (!~curElem.className.indexOf(topClass)) {
	                        var style = getComputedStyle(curElem, null);
	
	                        if (style.position !== 'absolute') {
	                            curElem.style.position = 'relative';
	                        }
	                        curElem.style.height = '100%';
	                        curElem = curElem.parentNode;
	                    }
	                }
	
	                /**
	                 * NOTE:
	                 * The following DEPRECATED version of the calculate method
	                 * relies on calculating the heights using math. This heavy
	                 * handed approach is fine if it is called at the right times
	                 * and often enough; however, this criteria is hard to achieve.
	                 *
	                 * A markup and styles overhaul is recommended to do away with
	                 * both of these methods.
	                 */
	                function deprecatedCalculate() {
	                    // DEPRECATED
	                    _logger.$logger.warn('xo-tray-height-fallback', {
	                        message: 'Using the fallback sidebar height calculation. ' + 'height may not be 100%. You should not be here!'
	                    });
	                    var height;
	                    var headerHeight;
	                    var mainHeight;
	                    var trayMinheight = 400;
	                    var asideContentHeight;
	                    var $aside = $(element).parents('aside:visible');
	                    var $asideContent = $aside.find('.asideContent');
	
	                    if (!$aside || !$asideContent) {
	                        return;
	                    }
	
	                    // Updates the tray height to the section height
	                    headerHeight = $aside.find('.header').outerHeight(true);
	                    mainHeight = $('#main').outerHeight(true);
	
	                    height = mainHeight - headerHeight;
	                    asideContentHeight = $asideContent.outerHeight(true);
	                    if ($scope.miniBrowser) {
	                        $aside.find('.aside').css('height', '534px');
	                        var minHeight = 534 - headerHeight;
	
	                        $asideContent.css('height', minHeight);
	                    } else if (asideContentHeight > height) {
	                        $asideContent.css('height', height);
	                        $aside.find('aside:visible').addClass('hasScroll');
	                    } else {
	                        height = height > trayMinheight ? height : trayMinheight;
	                        $asideContent.css('height', height);
	                        $aside.removeClass('hasScroll');
	                    }
	                }
	
	                if (useNewFlow) {
	                    calculate();
	                } else {
	                    $timeout(deprecatedCalculate, 1);
	
	                    $scope.$on('SidebarError', function () {
	                        deprecatedCalculate();
	                    });
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_logger.$logger;

/***/ },

/***/ "./components/xo-page-components/src/aside-header/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/aside-header/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-aside-header.directive', ['squid']).directive('xoAsideHeader', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                hdrtype: '@',
	                heading: '@',
	                subHead: '@',
	                addLink: '@',
	                backUrl: '@',
	                closeUrl: '@',
	                hidex: '@',
	                headerLeftLink: '=',
	                headerLeft: '@',
	                headerLeftIcon: '@',
	                headerRightLink: '=',
	                headerRight: '@',
	                headerRightIcon: '@',
	                subHeaderLeftLink: '@',
	                subHeaderLeft: '@',
	                subHeaderLeftIcon: '@',
	                subHeaderRightLink: '@',
	                subHeaderRight: '@',
	                subHeaderRightIcon: '@',
	                showDualFi: '='
	            },
	            controller: function controller($scope, $state, $timeout) {
	                $timeout(function () {
	                    $('.header').find('a:visible').focus();
	                });
	
	                if (angular.isUndefined($scope.closeUrl)) {
	                    $scope.closeUrl = 'checkout.review';
	                }
	
	                if ($scope.addLink) {
	                    $scope.subHeaderRight = 'asideHeader.add';
	                    $scope.subHeaderRightLink = $scope.addLink;
	                }
	
	                $scope.onClickLink = function (event, target, showDualFi) {
	                    event.preventDefault();
	                    if (showDualFi) {
	                        $scope.showFiOptions = true;
	                    } else if (angular.isFunction(target)) {
	                        target();
	                    } else {
	                        $state.go(target);
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/aside-header/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"header noButtons\" ng-class=\"[hdrtype]\" content>\n    <div class=\"primaryHeader\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content(heading) }}</h1>\n        <a link-button ui-sref=\"{{backUrl}}\" class=\"backArrow focusableIcon goTray\" ng-if=\"backUrl\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerLeftLink)\" class=\"left\" ng-if=\"headerLeftLink\">\n            <span ng-if=\"headerLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{closeUrl}}\" class=\"close focusableIcon\" ng-if=\"!backUrl && !hidex\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerRightLink)\" class=\"right focusableIcon\" ng-if=\"headerRightLink\">\n            <span ng-if=\"headerRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerRight) }}</span>\n        </a>\n    </div>\n\n    <div class=\"subHeader\" ng-class=\"{'addOptions': !subHeaderLeftLink}\" ng-if=\"subHeaderLeftLink || subHeaderRightLink\">\n        <h2 class=\"subheading gamma\" ng-if=\"!subHeaderLeftLink\">{{ content(subHead) }}</h2>\n        <a link-button ui-sref=\"{{subHeaderLeftLink}}\" ng-click=\"onClickLink($event, subHeaderLeftLink, showDualFi)\" ng-if=\"subHeaderLeftLink\" id=\"leftLink\" class=\"left\">\n            <span ng-if=\"subHeaderLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"leftText\">{{ content(subHeaderLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{subHeaderRightLink}}\" ng-class=\"{'addLink': !subHeaderLeftLink}\"  ng-click=\"onClickLink($event, subHeaderRightLink)\" ng-if=\"subHeaderRightLink\" id=\"rightLink\" class=\"right\">\n            <span ng-if=\"subHeaderRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"rightText\">{{ content(subHeaderRight) }}</span>\n        </a>\n    </div>\n</div>\n<div class=\"fundingInstrumentList\" id=\"fundingInstrumentList\" ng-if=\"showFiOptions\">\n    <ul>\n        <li class=\"bank\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddBank.bank.add\" id=\"addBank\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addBank')}}</span>\n            </a>\n        </li>\n        <li class=\"cards\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard\" id=\"addCC\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addCC')}}</span>\n            </a>\n        </li>\n    </ul>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/sepa/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-bank/sepa/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-bank.sepa.route', ['squid', 'xo-add-bank.sepa.directive']).factory('$XOSepaRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('SepaRoute', {
	
	            name: 'sepa',
	            directive: 'xo-sepa',
	            titleContent: 'DEMemberGuest.sepaTitle',
	            trackingData: {
	                fptiState: 'sepa_mandate'
	            },
	            loginRequired: true,
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-bank/sepa", "components/xo-wallet-components/src/add-bank/sepa/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/sepa/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/sepa/template.html"), __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/contingencies.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-add-bank.sepa.directive', ['squid', 'xo-aside-header.directive', 'xo-error-tooltip.directive']).directive('xoSepa', function ($state, $timeout) {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                model: '=',
	                sidebar: '=',
	                hideparenthead: '='
	            },
	
	            controller: function controller($scope) {
	
	                if (!$scope.model) {
	                    return $state.go('^.add');
	                }
	
	                $('body').addClass('pageSepaMandate');
	
	                $scope.$on('$destroy', function () {
	                    $('body').removeClass('pageSepaMandate');
	                });
	
	                if ($scope.hideparenthead) {
	                    $scope.hideparenthead.toggle = true;
	                }
	
	                function getDate() {
	                    var today = new Date();
	                    var dd = today.getDate();
	                    var mm = today.getMonth() + 1; // January is 0!
	
	                    var yyyy = today.getFullYear();
	                    if (dd < 10) {
	                        dd = '0' + dd;
	                    }
	                    if (mm < 10) {
	                        mm = '0' + mm;
	                    }
	                    return dd + '.' + mm + '.' + yyyy;
	                }
	
	                $scope.date = getDate();
	
	                $scope.onSubmit = function () {
	                    $scope.parentCallbacks.sepaDone();
	                };
	            },
	
	            link: function link($scope, element, attrs) {
	                $timeout(function () {
	                    $(element).find('.asideContent').height($('#main').height() - $('#tray').find('.header').height() + 10);
	                }, 10);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/sepa/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"sepaMandate\">\n<xo-aside-header back-url=\"^.add\" heading='DEMemberGuest.ddAgreementHead' ng-if=\"sidebar\"></xo-aside-header>\n<h1 class=\"gamma noHead\" ng-if=\"!sidebar\">{{ content('DEMemberGuest.ddAgreementHead') }}</h1>\n<div class=\"container\" ng-class=\"{asideContent: sidebar}\" content>\n    <form ng-submit=\"onSubmit()\" id=\"sepaMandateForm\" method=\"post\" class=\"asideProceed formSmall\"\n          novalidate=\"novalidate\">\n            <div class=\"sepaText\">\n                <p>{{ content('DEMemberGuest.ddAgreementPara1') }}</p>\n                <div class=\"sepaDetails\">\n                    <div class=\"span\">\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.accountCarrier')}} </span>\n                            <span class=\"col2\">\n                                <span>{{model.user.first_name}}</span>\n                                <span>{{model.user.last_name}}</span>\n                                <br/>{{model.address.line1}}\n                                <br/>{{model.address.line2}}\n                                <br/>{{model.address.postal_code}} {{model.address.city}}\n                            </span>\n                        </p>\n                    </div>\n                    <div class=\"span\">\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.IBAN')}}</span>\n                            <span class=\"col2\">{{model.fiDetails.piDetails.piAccountNumber}}</span>\n                        </p>\n\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.bankName')}}</span>\n                            <span class=\"col2\">{{model.fiDetails.piDetails.isssuerDetails.name}}</span>\n                        </p>\n\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.bic')}}</span>\n                            <span class=\"col2\">{{model.fiDetails.piDetails.bic}}</span>\n                        </p>\n                    </div>\n                    <div class=\"span\">\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.creditor')}}</span>\n                            <span class=\"col2\">\n                                <span>{{model.creditorDetails.creditorName}}</span>\n                                <br/><span class=\"confidential streets street-address\">{{model.creditorDetails.address.address1}}</span>\n                                <br/><span class=\"confidential postal-code\">{{model.creditorDetails.address.zip}}</span>\n                                    <span class=\"confidential locality\">{{model.creditorDetails.address.city}}</span>\n                                    <span class=\"confidential country adr-break\">{{model.creditorDetails.address.isoCountry}}</span>\n\n                            </span>\n                        </p>\n\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.creditorId')}}</span>\n                            <span class=\"col2 creditorId\">{{model.creditorDetails.creditorId}}</span>\n                        </p>\n                    </div>\n                </div>\n                <p class=\"secondary\">{{content('DEMemberGuest.ddAgreementPara2WithoutLink')}}</p>\n\n                <p class=\"help\">{{date}}, {{model.address.city}}, {{content('DEMemberGuest.country'+model.address.country)}}</p>\n            </div>\n\n                <div class=\"buttons\">\n                    <input id=\"proceedButton\" type=\"submit\" value=\"{{ content('DEMemberGuest.agreeBtn') }}\"\n                           class=\"btn full \" ng-click=\"validated=true \"/>\n                    <a id=\"cancelBtn\" ui-sref=\"^.add\" class=\"btn full btn-secondary goTray\"\n                       role=\"button\">\n                        {{content('DEMemberGuest.cancelBtn')}}\n                    </a>\n                </div>\n\n    </form>\n\n</div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/directive.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addcard/route.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/selectcard/route.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addbilling/route.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addCep/route.js"), __webpack_require__("./components/xo-wallet-components/src/confirm-upop/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-card.route', ['squid', 'xo-add-card.directive', 'xo-add-card.addcard.route', 'xo-add-card.selectcard.route', 'xo-add-card.addbilling.route', 'xo-add-card.addcep.route', 'xo-confirm-upop.route']).factory('$AddCardFlowRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('CardRoute', {
	
	            name: 'addCardFlow',
	            directive: 'xo-add-card-flow',
	            titleContent: 'asideHeader.addCard',
	            children: [{
	                name: '$AddCardRoute',
	                attributes: {
	                    token: 'token',
	                    cardmodel: 'cardmodel',
	                    done: 'addCCDone',
	                    message: 'message',
	                    pagetitle: 'pagetitle',
	                    sidebar: 'sidebar',
	                    showmeftsection: 'showmeftsection',
	                    hideparenthead: 'hideparenthead',
	                    billingaddressupdated: 'billingaddressupdated',
	                    isupdatecard: 'isupdatecard',
	                    'parent-callbacks': 'callbacks',
	                    'selected-promotion-card-type': 'selectedPromotionCardType',
	                    promotion: 'promotion',
	                    'page-level': 'pageLevel',
	                    logout: 'logout',
	                    phone: 'phone',
	                    'show-cancel': 'showCancel'
	                }
	
	            }, {
	                name: '$SelectCardRoute',
	                attributes: {
	                    token: 'token',
	                    'parent-callbacks': 'callbacks',
	                    message: 'message',
	                    pagetitle: 'pagetitle',
	                    sidebar: 'sidebar',
	                    'selected-promotion-card-type': 'selectedPromotionCardType',
	                    promotion: 'promotion'
	                }
	            }, {
	                name: '$AddBillingRoute',
	                attributes: {
	                    token: 'token',
	                    sidebar: 'sidebar',
	                    showmeftsection: 'showmeftsection',
	                    'parent-callbacks': 'callbacks',
	                    hideparenthead: 'hideparenthead',
	                    billingaddressupdated: 'billingaddressupdated',
	                    'prefill-address': 'prefillAddress'
	                }
	            }, {
	                name: '$AddCepRoute',
	                attributes: {
	                    token: 'token',
	                    sidebar: 'sidebar',
	                    'done-fn': 'cepDone',
	                    'prefill-address': 'prefillAddress'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card", "components/xo-wallet-components/src/add-card/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/address/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return squid.module('xo-add-card.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xomodel.address']).directive('xoAddCardFlow', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                message: '=',
	                pagetitle: '=',
	                sidebar: '=',
	                showmeftsection: '=',
	                hideparenthead: '=',
	                promotion: '=',
	                pageLevel: '=',
	                logout: '=',
	                phone: '=',
	                fundingid: '=',
	                showCancel: '='
	            },
	
	            controller: function controller($scope, $state, $populate, $AddCardModel, $CardModel, $CheckoutSessionModel, $PrefillAddressModel, $util, $renderContent) {
	
	                $scope.addCCDone = function () {
	                    $scope.parentCallbacks.finish();
	                };
	
	                $scope.callbacks = {
	                    done: $scope.parentCallbacks.finish,
	                    cancel: $scope.parentCallbacks.cancel,
	                    showCep: function showCep() {
	                        $scope.prefillAddress = new $PrefillAddressModel({
	                            id: $scope.token
	                        });
	
	                        $state.go('^.addCep');
	                    },
	
	                    cardTypeSelected: function cardTypeSelected(type) {
	                        $scope.selectedPromotionCardType = {
	                            type: type
	                        };
	                        $state.go('^.addCard');
	                    }
	                };
	
	                $scope.cepDone = function () {
	                    $state.go('^.addBilling');
	                };
	
	                $scope.selectedPromotionCardType = {
	                    type: $scope.promotion && $scope.promotion.type
	                };
	
	                if ($scope.promotion) {
	                    $scope.promotion.type = null;
	                }
	
	                $scope.billingaddressupdated = {
	                    value: false
	                };
	
	                $scope.phone = {
	                    hide_type: true
	                };
	
	                $scope.cardmodel = new $AddCardModel({
	                    card: new $CardModel()
	                });
	
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
	                        contingencies: {
	                            NEED_CREDIT_CARD: angular.noop,
	                            EXPIRED_CREDIT_CARD: angular.noop
	                        }
	                    })
	                }).then(function () {
	
	                    if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.resolution) {
	                        var card = $scope.checkoutSession.errorData.resolution.data;
	
	                        if (card.fundingId && card.fi && card.fi.type) {
	                            $scope.cardmodel.id = card.fundingId;
	                            $scope.cardmodel.card = new $CardModel({
	                                number: 'xxxx-xxxx-xxxx-' + card.fi.number,
	                                type: card.fi.type.toUpperCase(),
	                                productType: card.fi.productType
	                            });
	                        }
	                    }
	                    if ($scope.fundingid) {
	                        var fundingSource = $util.find($scope.checkoutSession.fundingOptions.instruments, function (funding) {
	                            if (funding && funding.id === $scope.fundingid) {
	                                return funding;
	                            }
	                        });
	
	                        if (fundingSource) {
	                            $scope.cardmodel.id = fundingSource.id;
	                            $scope.cardmodel.card = new $CardModel({
	                                number: 'xxxx-xxxx-xxxx-' + fundingSource.lastDigits,
	                                lastDigits: fundingSource.lastDigits,
	                                type: fundingSource.name,
	                                name: $renderContent('fsMappings.' + fundingSource.name)
	                            });
	                        }
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/template.html":
"../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/template.html",

/***/ "./components/xo-models/src/address/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.address', ['squid']).factory('$AddressNormalizationModel', function ($Model, $Api) {
	        return $Model.extend('AddressNormalizationModel', {
	            api: new $Api({
	                uri: '/api/address/normalize'
	            })
	        });
	    }).factory('$PrefillAddressModel', function ($Model, $Api) {
	        return $Model.extend('PrefillAddressModel', {
	            api: new $Api({
	                uri: '/api/address/prefill'
	            })
	        });
	    }).factory('$ValidateAddressModel', function ($Model, $Api) {
	        return $Model.extend('ValidateAddressModel', {
	            api: new $Api({
	                uri: '/api/address/validate'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/address", "components/xo-models/src/address/index.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/addcard/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _route = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addcard/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-card.addcard.route', ['squid', 'xo-add-card.addcard.directive']).factory('$AddCardRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddCardRoute', {
	
	            name: 'addCard',
	            directive: 'xo-add-card',
	            titleContent: 'asideHeader.addCard',
	
	            trackingData: {
	                fptiState: 'add_or_update_cc'
	            },
	            loginRequired: true,
	            children: [{
	                route: _route2['default'],
	                attributes: {
	                    token: 'token',
	                    phone: 'phone',
	                    cardmodel: 'cardmodel'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card/addcard", "components/xo-wallet-components/src/add-card/addcard/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/addcard/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _cardMetaData = __webpack_require__("./components/xo-wallet-components/src/add-card/cardMetaData/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addcard/template.html"), __webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/creditcard-input/directive.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/angular-ui-utils/ui-utils.min.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js"), __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, module, template, $) {
	
	    return module('xo-add-card.addcard.directive', ['squid', 'xomodel.checkout', 'xomodel.auth', 'xomodel.fi', 'xo-add-card.creditcard-input.directive', 'xo-dropdown.directive', 'xo-tray-height.directive', 'xo-aside-header.directive', 'xo-message.directive', 'xo-error-tooltip.directive', 'ui.validate', 'xo-accessibility.directive', 'fi.errorUtil']).directive('xoAddCard', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                done: '=',
	                message: '=',
	                pagetitle: '=',
	                sidebar: '=',
	                showmeftsection: '=',
	                hideparenthead: '=',
	                billingaddressupdated: '=',
	                cardmodel: '=',
	                parentCallbacks: '=',
	                selectedPromotionCardType: '=',
	                promotion: '=',
	                pageLevel: '=',
	                logout: '=',
	                phone: '=',
	                manageCardFlow: '=',
	                showCancel: '='
	            },
	            controller: function controller($scope, $populate, $state, $stateParams, $BillingAddressesModel, $CardTypesModel, $CheckoutSessionModel, $AuthModel, $CheckoutCartModel, $timeout, $element, $rootScope, $locale, $util, $feature, $ResolveOTP, $Class, $fiErrorUtil, $renderContent, $meta, $FlowEligibilityModel) {
	
	                $populate($scope, {
	                    cart: $CheckoutCartModel.instance($scope.token),
	                    auth: $AuthModel.instance(),
	                    billingAddresses: $BillingAddressesModel.instance(),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
	                        contingencies: {
	                            NEED_CREDIT_CARD: angular.noop,
	                            EXPIRED_CREDIT_CARD: angular.noop
	                        }
	                    }),
	                    flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
	                        params: {
	                            geolocation: $meta.geolocation,
	                            localeCountry: $locale.country
	                        }
	                    })
	                }).then(function () {
	
	                    if ($scope.cart.isWalletTokenization()) {
	                        _logger.$logger.info('tokenized_wallet', {
	                            'from': 'ADD_DEBIT_CARD',
	                            'to': 'prepare_ADD_DEBIT_CARD',
	                            'context_id': $scope.token,
	                            'context_type': 'BA-Token',
	                            'ba_token': $meta.baToken
	                        });
	                    }
	
	                    $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';
	
	                    if ($scope.showmeftsection) {
	                        $scope.showmeftsection.toggle = true;
	                    }
	
	                    if ($scope.hideparenthead) {
	                        $scope.hideparenthead.toggle = false;
	                    }
	
	                    $scope.manageCardFlow = $scope.sidebar && $scope.cardmodel.card.isExisting();
	
	                    var type = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type;
	
	                    if ($scope.checkoutSession.plccOffer && !type && $scope.promotion) {
	                        $state.go('^.selectCard');
	                    }
	
	                    $scope.showplcc = type === 'plcc';
	                    $scope.country = $locale.country;
	
	                    $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && $scope.logout;
	
	                    $scope.cardmodel.cardType = 'creditCard';
	
	                    if ($scope.checkoutSession.plccOffer && $scope.showplcc) {
	                        $scope.cardmodel.cardType = 'privateLabel';
	                        $scope.cardmodel.sponsor_id = $scope.checkoutSession.plccOffer.sponsor_id;
	                    }
	
	                    $scope.cardmodel.user = {
	                        first_name: $scope.auth.first_name,
	                        last_name: $scope.auth.last_name
	                    };
	
	                    $scope.cardmodel.address = $scope.billingAddresses.addresses[0];
	
	                    if ($scope.billingaddressupdated.value) {
	                        $scope.billingaddressupdated = {
	                            msgs: [$locale.content.get('editCard.newAddressAdded')],
	                            type: 'success',
	                            value: true
	                        };
	                    }
	
	                    $scope.gotoBilling = function (address) {
	                        if ($scope.pageLevel) {
	                            $scope.pageLevel.message = null;
	                        }
	                        if (!address) {
	                            if ($locale.country === 'BR') {
	                                $scope.parentCallbacks.showCep();
	                            } else {
	                                // page transition
	                                var el = $('.tokenization #sidepageAddCard');
	                                if (el) {
	                                    el.addClass('slideLeft');
	                                }
	                                $state.go('^.addBilling');
	                            }
	                        }
	                    };
	
	                    $scope.isCUP = function () {
	                        return $scope.cardmodel.card && $scope.cardmodel.card.type && $scope.cardmodel.card.type === 'CUP';
	                    };
	
	                    $scope.isUpdateDebitCard = function () {
	                        return $stateParams.message === 'EXPIRED_DEBIT_CARD';
	                    };
	
	                    $scope.flag = function (field) {
	                        return _cardMetaData.$CardMetaData.getMetaData($scope.cardmodel.card, field);
	                    };
	
	                    $scope.buttonText = function () {
	                        if ($scope.debitCardFlow) {
	                            return 'creditcard.saveBtn';
	                        }
	
	                        var contentString = 'creditcard.addBtn';
	                        if ($scope.cardmodel.card.isExisting()) {
	                            contentString = 'creditcard.updateBtn';
	                        } else if ($scope.isCUP()) {
	                            contentString = 'creditcard.continuetext';
	                        }
	                        return contentString;
	                    };
	
	                    $scope.cardTypeChanged = function () {
	                        $scope.phone.phoneType = $scope.flag('phoneType');
	                    };
	
	                    function addErrorMessage(contentKey) {
	                        if (contentKey) {
	                            contentKey = angular.isArray(contentKey) ? contentKey[0] : contentKey;
	                            var message = $locale.content.get('creditcard.' + contentKey);
	                            $scope.message.msgs.push(message);
	                        }
	                    }
	
	                    function handleContingencies(result, contentBundle, defaultErrorKey, prop) {
	                        var errorData;
	
	                        if (result.errorCodes) {
	                            errorData = result;
	                        } else {
	                            errorData = {
	                                errorCodes: result && [result['0']]
	                            };
	                        }
	                        $scope.message = $fiErrorUtil.addPageErrors(errorData, contentBundle, prop, defaultErrorKey);
	
	                        if (window.scrollTo) {
	                            window.scrollTo(0, 0);
	                        }
	                    }
	
	                    $scope.cancelFn = function () {
	                        if ($scope.sidebar) {
	                            if (!$scope.checkoutSession.plccOffer) {
	                                $state.go('checkout.review.sidebar.wallet');
	                            } else {
	                                $state.go('^.selectCard');
	                            }
	                        } else {
	                            $scope.done();
	                        }
	                    };
	
	                    function initiateOTP() {
	                        var resolveOTP = new $ResolveOTP({ id: $scope.cardmodel.id });
	                        resolveOTP.action('init', {
	                            data: {
	                                phone: {
	                                    country_code: $scope.phone.IntDialingCountryCode,
	                                    number: $scope.phone.telephone
	                                }
	                            },
	                            resultModel: {},
	                            success: function success() {
	                                $state.go('.confirmUpop');
	                            },
	
	                            error: function error() {
	                                handleContingencies({}, 'confirmUpop', 'declineMessage');
	                            },
	
	                            contingencies: {
	                                INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
	                                    // prop for last 4 digits of card in error message
	                                    var prop = {
	                                        number: $scope.cardmodel && $scope.cardmodel.card && $scope.cardmodel.card.last4()
	                                    };
	
	                                    handleContingencies(result, 'confirmUpop', 'declineMessage', prop);
	                                    $fiErrorUtil.addFieldErrors(result, $element);
	                                },
	                                DEFAULT: function DEFAULT() {
	                                    handleContingencies({}, 'confirmUpop', 'declineMessage');
	                                }
	                            }
	                        });
	                    }
	
	                    function handleCheckoutSession(result, isNewCard) {
	                        if ($scope.cardmodel && $scope.cardmodel.cardType === 'privateLabel') {
	                            delete $scope.checkoutSession.plccOffer;
	                        }
	
	                        delete $scope.checkoutSession.errorData;
	
	                        var cardAdded = $scope.cardmodel && $scope.cardmodel.card;
	                        var numberAdded;
	                        var cardTypeAdded;
	
	                        if (cardAdded) {
	                            numberAdded = angular.isString(cardAdded.number) && cardAdded.number.replace(/\s/g, '');
	                            cardTypeAdded = cardAdded.type;
	                        }
	
	                        var last4Added = angular.isString(numberAdded) && numberAdded.substr(numberAdded.length - 4);
	                        var cvvData = $scope.checkoutSession.cvvData;
	                        var last4ToUse;
	                        var cardTypeToUse;
	
	                        if (cvvData) {
	                            last4ToUse = cvvData.number;
	                            cardTypeToUse = cvvData.type;
	                        }
	
	                        if (last4ToUse === last4Added && cardTypeAdded === cardTypeToUse) {
	                            $scope.checkoutSession.set('cvvData.security_code', $scope.cardmodel.get('card.security_code'));
	                        }
	
	                        var updateCardSidebarMessage = $renderContent('wallet.cardUpdated', {
	                            type: cardTypeAdded,
	                            number: last4Added
	                        });
	                        var updateCardPageMessage = $renderContent('smallToolTip.cardUpdated');
	                        var addCardMessage = $renderContent('smallToolTip.cardAdded');
	
	                        var msgs = [addCardMessage];
	
	                        if (!isNewCard) {
	                            msgs = $scope.manageCardFlow ? [updateCardSidebarMessage] : [updateCardPageMessage];
	                        }
	
	                        $scope.checkoutSession.message = {
	                            type: 'success',
	                            msgs: msgs
	                        };
	
	                        $scope.done();
	                    }
	
	                    $scope.onSubmit = function () {
	                        if ($scope.pageLevel) {
	                            $scope.pageLevel.message = null;
	                        }
	                        var isNewCard = !$scope.cardmodel.card.isExisting();
	
	                        if (isNewCard) {
	                            delete $scope.cardmodel.id;
	                        }
	
	                        if ($('#plccAgree').is(':checked')) {
	                            $scope.cardmodel.preference = true;
	                        }
	
	                        // Only initiateOTP needs to be called for unconfirmed CUP contingency. Add card call does not need to be made.
	                        if ($scope.isCUP() && $scope.cardmodel.id && ($scope.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD' || $scope.checkoutSession.get('errorData.cause') === 'EXPIRED_CREDIT_CARD')) {
	
	                            initiateOTP();
	                        } else {
	                            $scope.cardmodel.save({
	
	                                success: function success() {
	                                    if ($scope.isCUP()) {
	                                        initiateOTP();
	                                    } else if ($scope.cart.isWalletTokenization()) {
	                                        var fpti_payload = {
	                                            'from': 'ADD_DEBIT_CARD',
	                                            'to': 'process_ADD_debit_card',
	                                            'context_id': $scope.token,
	                                            'context_type': 'BA-Token',
	                                            'ba_token': $meta.baToken
	                                        };
	                                        $scope.checkoutSession.fundingOptions.action('notifyChange', {
	                                            resultModel: $scope.checkoutSession,
	
	                                            data: {
	                                                planId: $scope.cardmodel.id,
	                                                operation: 'ADDED'
	                                            },
	
	                                            success: function success(result) {
	                                                _logger.$logger.info('tokenized_wallet', fpti_payload);
	                                                handleCheckoutSession(result, isNewCard);
	                                            },
	
	                                            contingencies: {
	                                                TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
	                                                    fpti_payload.int_error_desc = "TRANSACTION_REFUSED_addedButCannotUse";
	                                                    fpti_payload.error_source = "ppas";
	                                                    _logger.$logger.info('tokenized_wallet', fpti_payload);
	                                                    $scope.message.msgs = [];
	                                                    $scope.message.type = 'info';
	                                                    addErrorMessage('addedButCannotUse');
	                                                }
	                                            }
	                                        });
	                                    } else {
	                                        $scope.checkoutSession.fundingOptions.action('update', {
	
	                                            resultModel: $scope.checkoutSession,
	
	                                            data: {
	                                                planId: $scope.cardmodel.id
	                                            },
	
	                                            success: function success(result) {
	                                                handleCheckoutSession(result, isNewCard);
	                                            },
	
	                                            contingencies: {
	                                                TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
	                                                    $scope.message.msgs = [];
	                                                    $scope.message.type = 'info';
	                                                    addErrorMessage('addedButCannotUse');
	                                                }
	                                            }
	                                        });
	                                    }
	                                },
	
	                                contingencies: {
	                                    ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(name, result) {
	                                        if ($scope.sidebar) {
	                                            $scope.$emit('SidebarError');
	                                        }
	                                        $scope.billingaddressupdated.value = false;
	                                        if (result && result.errorCodes) {
	                                            handleContingencies(result, 'creditcard', 'errorInvalidData');
	                                            $fiErrorUtil.addFieldErrors(result, $element);
	                                        } else if (result && result['0']) {
	                                            handleContingencies(result, 'creditcard');
	                                        } else {
	                                            handleContingencies({}, 'creditcard', 'errorInternalError');
	                                        }
	                                    },
	                                    DISALLOWED_CUPSECURE_ADDITION: function DISALLOWED_CUPSECURE_ADDITION(name, result) {
	                                        handleContingencies({}, 'creditcard', 'errorInternalError');
	                                    },
	                                    VALIDATION_ERROR: function VALIDATION_ERROR(name, result) {
	                                        var $field = $($element).find('[ng-model="card.number"]');
	                                        $field.addClass('backendError');
	                                        $field.attr('aria-invalid', true);
	                                        $field.focus();
	                                    },
	                                    DEFAULT: function DEFAULT(name, result) {
	                                        handleContingencies({ errorCodes: [name] }, 'creditcard', 'errorInternalError');
	                                    }
	
	                                },
	
	                                error: function error() {
	                                    handleContingencies({}, 'creditcard', 'errorInternalError');
	                                },
	
	                                validation: function validation(res) {}
	                            });
	                        }
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_cardMetaData.$CardMetaData;
	
	_logger.$logger;

/***/ },

/***/ "./components/squid/dist/module.js":
/***/ function(module, exports) {

	
	
	module.exports = angular.module;

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addcard/template.html":
/***/ function(module, exports) {

	module.exports = "\n<div content modal-box=\"!!sidebar\" modal-cancel=\"cancelFn()\" xo-tray-height>\n    <xo-aside-header back-url=\"checkout.review.sidebar.wallet\" heading=\"asideHeader.addCard\" ng-if=\"!debitCardFlow && sidebar && !checkoutSession.plccOffer && !cardmodel.card.isExisting()\"></xo-aside-header>\n    <div class=\"header noButtons\" ng-if=\"manageCardFlow\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content('asideHeader.updateCard', {type: cardmodel.card.name, number: cardmodel.card.lastDigits}) }}</h1>\n        <a link-button ui-sref=\"checkout.review.sidebar.wallet\" class=\"backArrow goTray\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n    </div>\n    <xo-aside-header back-url=\"^.selectCard\" heading='asideHeader.selectCard' ng-if=\"sidebar && checkoutSession.plccOffer\"></xo-aside-header>\n    <xo-message message=\"message\" ng-if=\"!sidebar\"></xo-message>\n    <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n        {{ content('memberReview.welcomeBack', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout(auth)\">{{ content('memberReview.notYou')}}</a>\n                </span>\n    </p>\n    <h1 class=\"gamma\" ng-if=\"pagetitle\">{{ pagetitle }}</h1>\n\n    <div ng-class=\"{true: 'sidebar'}[asideContent]\" xo-tray-height>\n        <form id=\"creditCardForm\" name=\"creditCardForm\" class=\"addCard asideView asideContent\" content form-autofocus novalidate>\n            <div class=\"trayInner container\">\n                <p id=\"addCardDebitCardFlow\" ng-if=\"debitCardFlow && !isUpdateDebitCard()\">\n                    {{ content('addCard.addTopupDebitCard') }}\n                </p>\n                <xo-message message=\"message\" ng-if=\"sidebar\"></xo-message>\n                <xo-message id=\"billingAddressUpdatedMsg\" ng-if=\"billingaddressupdated.value\" message=\"billingaddressupdated\"></xo-message>\n                <xo-name-input user=\"cardmodel.user\" country=\"{{country}}\"></xo-name-input>\n\n                <xo-credit-card token=\"token\" card=\"cardmodel.card\" user=\"cardmodel.user\"\n                                selected-promotion-card-type=\"selectedPromotionCardType\"\n                                card-type-changed=\"cardTypeChanged\" promotion=\"promotion\"\n                                manage-card-flow=\"manageCardFlow\"></xo-credit-card>\n\n                <div ng-if=\"flag('fields.address')\" id=\"billingAddress\" class=\"dropdown billingAddress confidential\">\n                    <label for=\"billingAddressDropdown\" class=\"billingAddressLabel\">\n                        {{ content(\"addressBook.billingAddress\") }}\n                        <a href=\"\" link-button ng-click=\"gotoBilling()\" class=\"addNewBillingAddress\" aria-label=\"{{ content('addCard.addNewBillingAddress') }}\">{{ content(\"addressBook.add\") }}</a>\n                    </label>\n                    <div class=\"dropdown billingAddress nullable\">\n                        <select xo-dropdown default=\"{{content('addCard.addNewBillingAddress')}}\" ng-model=\"cardmodel.address\"\n                                ng-change=\"gotoBilling(cardmodel.address)\"\n                                ng-options=\"address.full_address for address in billingAddresses.addresses\"\n                                name=\"billingAddress\" id=\"billingAddressDropdown\" required>\n                        </select>\n                    </div>\n                </div>\n\n                <div ng-if=\"flag('fields.phone')\">\n                    <div class=\"otpVerification\" ng-bind-html=\"htmlContent('confirmUpop.debitInitOtp')\"></div>\n                    <xo-phone-input token=\"token\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n                </div>\n\n                <div class=\"addressLabel\">\n                    <a href=\"\" link-button ng-click=\"gotoBilling()\">{{ content(\"addCard.addNewBillingAddress\") }}</a>\n                </div>\n\n                <div ng-if=\"showplcc\">\n                    <div class=\"plccAgree checkbox\">\n                        <input type=\"checkbox\" checked=\"true\" name=\"plccAgree\" id=\"plccAgree\" />\n                        <label class=\"noBottom\" for=\"plccAgree\">{{content('addCard.plccPreferMethod', { merchant: promotion.name})}}</label>\n                    </div>\n                    <div class=\"legal\">{{content('addCard.plccLegal', { merchant: promotion.name})}}</div>\n                </div>\n\n\n                <input track-submit=\"{{cardmodel.card.isExisting() ? 'update_cc' : 'add_cc' }}\" type=\"submit\" value=\"{{ content(buttonText()) }}\" id=\"proceedButton\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n\n                <div ng-if=\"showCancel\" class=\"linkButton\">\n                    <a link-button prevent-default href=\"#\" ng-click=\"parentCallbacks.cancel()\">{{content('common.cancel')}}</a>\n                </div>\n            </div>\n        </form>\n    </div>\n\n    <div ui-view></div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/creditcard-input/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _cardMetaData = __webpack_require__("./components/xo-wallet-components/src/add-card/cardMetaData/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/cardExpiry/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/cvv/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/dob/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/creditcard-input/template.html"), __webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/angular-ui-utils/ui-utils.min.js"), __webpack_require__("./components/xo-form-components/src/name-input/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template, $) {
	
	    squid.module('xo-add-card.creditcard-input.directive', ['squid', 'xomodel.fi', 'xo-tooltip.directive', 'xo-error-tooltip.directive', 'xo-name-input.directive', 'ui.validate']).directive('scrollToTop', function () {
	        return {
	            link: function link(scope, element, attr) {
	                $(element).on('focus', function () {
	                    if ($('#mxCardTitle').is(':visible')) {
	                        $('#creditCardForm').scrollTop($(element).offset().top);
	                    }
	                });
	            }
	        };
	    }).directive('xoCreditCard', function ($timeout, $util) {
	        return {
	            template: template,
	            restrict: 'E',
	
	            scope: {
	                token: '=',
	                card: '=',
	                user: '=',
	                selectedPromotionCardType: '=',
	                promotion: '=',
	                cardTypeChanged: '=',
	                cardNumberChanged: '=',
	                manageCardFlow: '='
	            },
	            controller: function controller($scope, $populate, $CardTypesModel, $Class, $locale, $CardTypeFromBinModel, $config, $feature, $pxp, $logger, $stateParams, $FlowEligibilityModel, $meta) {
	                $populate($scope, {
	                    flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
	                        params: {
	                            geolocation: $meta.geolocation,
	                            localeCountry: $locale.country
	                        }
	                    })
	                }).then(function () {
	                    $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';
	
	                    $scope.locale = $locale;
	                    $scope.country = $scope.locale.country;
	
	                    var cardTypeServiceCall = $feature('cardTypeServiceCallRequired', false, $scope.country) || $scope.debitCardFlow;
	                    var isUnsupportedCard;
	                    var lastVerifiedBin = '';
	                    var lastRequestedBin; // bin requested to service to fetch card type and pending response.
	
	                    $scope.mxDebitCards = ['BANAMEX', 'BANCOARFACA', 'BBVA', 'BANORTE', 'HSBC', 'INBURSA', 'SANTANDER'];
	
	                    $scope.cardLengthValid = function (number) {
	                        if ($scope.card && $scope.card.isExisting()) {
	                            return true;
	                        }
	
	                        number = (number || '').replace(/[^0-9]+/g, '');
	
	                        return number.length >= $scope.flag('length.min') && number.length <= $scope.flag('length.max');
	                    };
	
	                    $scope.cardLuhnValid = function (input) {
	
	                        if (!$scope.flag('luhn')) {
	                            return true;
	                        }
	
	                        if ($scope.card && $scope.card.isExisting()) {
	                            return true;
	                        }
	
	                        input = (input || '').replace(/[^0-9]+/g, '');
	
	                        var sum = 0;
	                        var numdigits = input.length;
	                        var parity = numdigits % 2;
	                        var i = 0;
	                        var digit;
	
	                        for (; i < numdigits; i++) {
	
	                            digit = parseInt(input.charAt(i), 10);
	
	                            if (i % 2 === parity) {
	                                digit *= 2;
	                            }
	
	                            if (digit > 9) {
	                                digit -= 9;
	                            }
	
	                            sum += digit;
	                        }
	
	                        return sum % 10 === 0;
	                    };
	
	                    $scope.isPlcc = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type === 'plcc' ? true : false;
	
	                    $scope.flag = function (field) {
	                        if ($scope.isPlcc && !$scope.card.type) {
	                            $scope.card.type = 'PLCC';
	                        }
	                        return _cardMetaData.$CardMetaData.getMetaData($scope.card, field);
	                    };
	
	                    $scope.maxLength = function () {
	
	                        if ($scope.card && $scope.card.isExisting()) {
	                            return 30;
	                        }
	
	                        return $scope.flag('length.max') + $scope.flag('spaces.length');
	                    };
	
	                    if ($scope.card && $scope.card.number) {
	                        $scope.unformattedCardNumber = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
	                    }
	
	                    $scope.showMXCardLogos = function () {
	                        return $locale.country === 'MX';
	                    };
	
	                    function pxpMXCardLabels() {
	                        if ($scope.showMXCardLogos()) {
	                            $pxp('xo_hermes_mx_cardlogo', {}, 'xo_hermes_mx_cardlogo_treatment').then(function (result) {
	                                $scope.showLabels = result && result.treatment_name === 'xo_hermes_mx_cardlogo_treatment';
	                            });
	                        } else {
	                            $scope.showLabels = false;
	                        }
	                    }
	
	                    $populate($scope, {
	                        cardTypes: $CardTypesModel.instance($scope.token + ':' + $locale.country, {
	                            token: $scope.token,
	                            country: $locale.country
	                        })
	                    }).then(function () {
	                        var forceDropDown = false;
	
	                        function str(item) {
	                            var s = item.toString();
	                            return item < 10 ? '0' + s : s;
	                        }
	
	                        $scope.supportedCardNamesCommaSeparated = $scope.cardTypes.supportedNames().join(', ');
	
	                        $scope.$on('localeChange', function () {
	
	                            $scope.cardTypes = $CardTypesModel.instance($scope.token + ':' + $locale.country, {
	                                token: $scope.token,
	                                country: $locale.country
	                            });
	
	                            $scope.cardTypes.retrieve().then(function () {
	                                if ($scope.card.type && $scope.cardTypes.allowed.indexOf($scope.card.type) === -1) {
	                                    delete $scope.card.type;
	                                    forceDropDown = false;
	                                    $scope.changeCardNumber(true);
	                                }
	                            });
	
	                            $scope.country = $locale.country;
	
	                            pxpMXCardLabels();
	                        });
	
	                        pxpMXCardLabels();
	
	                        $scope.cvvShown = function () {
	                            if ($scope.card.type === 'CETELEM' && $scope.locale.country === 'FR') {
	                                return false;
	                            }
	
	                            if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
	                                return false;
	                            }
	
	                            if ($scope.isPlcc && $scope.card.type) {
	                                return true;
	                            }
	
	                            return $scope.flag('fields.cvv');
	                        };
	
	                        $scope.expiryShown = function () {
	
	                            if ($scope.isPlcc && $scope.card.type) {
	                                return true;
	                            }
	                            if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
	                                return false;
	                            }
	
	                            return $scope.flag('fields.expiry');
	                        };
	
	                        $scope.enableDropDown = function () {
	                            return Boolean(['ES', 'FR', 'GB', 'IT'].indexOf($scope.locale.country) > -1) || forceDropDown;
	                        };
	
	                        $scope.showDropDown = function () {
	
	                            if ($scope.enableDropDown()) {
	                                return true;
	                            }
	
	                            if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 4 && !cardTypeServiceCall && !$scope.isPlcc) {
	                                return true;
	                            }
	
	                            if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 7 && cardTypeServiceCall && isUnsupportedCard) {
	                                return true;
	                            }
	
	                            return false;
	                        };
	
	                        $scope.showAcceptedCardLogos = function () {
	                            return !$scope.showDropDown() && $feature('showAcceptedCardLogos', false, $scope.country);
	                        };
	
	                        $scope.getCardTypeByNumber = function (types, number) {
	                            if ($scope.isPlcc && number.length > 6 || !$scope.isPlcc) {
	                                return _cardMetaData.$CardMetaData.getCardType(types, number);
	                            }
	                        };
	
	                        function formatCardNumber(number) {
	                            var spaces = $scope.flag('spaces');
	                            var formatted = [];
	
	                            for (var i = 0; i < number.length; i++) {
	                                if (spaces.indexOf(i) > -1) {
	                                    formatted.push(' ');
	                                }
	
	                                formatted.push(number.charAt(i));
	                            }
	
	                            number = formatted.join('');
	                            return number;
	                        }
	
	                        $scope.$watch('card.type', function () {
	                            if ($scope.cardTypeChanged) {
	                                $scope.cardTypeChanged();
	                            }
	                        });
	
	                        /**
	                         * Hit Callback(unformatted cc no) when user gets out of the cardNumber field.
	                         */
	                        $scope.ccOnBlur = function () {
	                            if ($scope.cardNumberChanged) {
	                                $scope.cardNumberChanged($scope.unformattedCardNumber);
	                            }
	                        };
	
	                        // e.g for a dual brand = ['CUP' ,'VISA'], select VISA or CUP based
	                        // on regex defined for card type. If not regex was defined, pick one
	                        // of the allowed card type.
	                        function selectCardTypeForDualBrands(result) {
	                            var dualCardTypes = $feature('dualCardTypes', {});
	                            var match;
	                            Object.keys(dualCardTypes).some(function (key) {
	                                return result.some(function (cardType) {
	                                    if (cardType.type === key) {
	                                        match = key;
	                                        return true;
	                                    }
	                                });
	                            });
	
	                            if (match) {
	                                var regex = new RegExp(dualCardTypes[match]);
	                                var selected = $util.find(result, function (cardType) {
	                                    if (regex.test(cardType.type)) {
	                                        return true;
	                                    }
	                                });
	                                if (selected && selected.type === 'CUP') {
	                                    $util.some(result, function (cardType) {
	                                        if (/^AMEX$/.test(cardType.type)) {
	                                            selected.dualType = cardType.type;
	                                            return true;
	                                        }
	                                    });
	                                }
	
	                                return selected;
	                            } else {
	                                return $util.find(result, function (cardType) {
	                                    return $scope.cardTypes.allowed.indexOf(cardType.type) > -1;
	                                });
	                            }
	                        }
	
	                        function selectCardType(result) {
	                            if (angular.isArray(result)) {
	                                if (result.length >= 2) {
	                                    result = selectCardTypeForDualBrands(result);
	                                } else {
	                                    result = result[0];
	                                }
	                            }
	
	                            return result || {};
	                        }
	
	                        function clearCardType() {
	                            $scope.card.type = '';
	                            $scope.card.dualType = '';
	                            $scope.card.productType = '';
	                        }
	
	                        function getCardTypeByNumberServiceCall(number) {
	                            if (number.length >= 6) {
	                                var bin = number.slice(0, 6);
	
	                                if (lastVerifiedBin && lastVerifiedBin.bin === bin) {
	                                    $scope.card.type = lastVerifiedBin.type;
	                                    $scope.card.dualType = lastVerifiedBin.dualType;
	                                    $scope.card.productType = lastVerifiedBin.productType;
	                                    return;
	                                }
	
	                                if (isUnsupportedCard === bin || bin === lastRequestedBin) {
	                                    return;
	                                }
	
	                                lastRequestedBin = bin;
	
	                                var params = {
	                                    country: $scope.country,
	                                    user_country: $scope.country,
	                                    bin: bin
	                                };
	
	                                $scope.cardTypeFromBinModel = new $CardTypeFromBinModel(params);
	
	                                $scope.cardTypeFromBinModel.retrieve({
	                                    silent: true,
	                                    success: function success(result) {
	                                        result = selectCardType(result);
	                                        var type = result.type;
	                                        lastRequestedBin = undefined;
	
	                                        var disallowedCard = false;
	                                        if ($scope.cardTypes.allowed.indexOf(type) === -1) {
	                                            disallowedCard = true;
	                                        } else if ($scope.debitCardFlow) {
	                                            if (result.productType !== 'DEBIT') {
	                                                disallowedCard = true;
	                                            }
	                                        }
	
	                                        if (disallowedCard) {
	                                            clearCardType();
	                                            isUnsupportedCard = bin;
	                                            $scope.allowedCardsTooltip = true;
	                                            return;
	                                        }
	
	                                        isUnsupportedCard = undefined;
	                                        forceDropDown = false;
	                                        if (!$scope.showDropDown()) {
	                                            $scope.card.type = type;
	                                            $scope.card.dualType = result.dualType;
	                                            $scope.card.productType = result.productType;
	                                        }
	
	                                        lastVerifiedBin = {
	                                            bin: bin,
	                                            type: type,
	                                            dualType: result.dualType,
	                                            productType: result.productType
	                                        };
	
	                                        // This logic is to handle copy paste case when all numbers are entered at once
	                                        if ($scope.card.type && number.length >= $scope.flag('length.min')) {
	                                            if (/android/i.test(navigator.userAgent)) {
	                                                return;
	                                            }
	
	                                            var ccNumber = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
	
	                                            if (ccNumber.indexOf(number) >= 0) {
	                                                $scope.card.number = formatCardNumber(ccNumber);
	                                            }
	                                        }
	
	                                        return;
	                                    },
	                                    contingencies: {
	                                        GET_FI_ISSUER_DETAILS_ERR: function GET_FI_ISSUER_DETAILS_ERR(name, result) {
	                                            clearCardType();
	                                            isUnsupportedCard = bin;
	                                            lastRequestedBin = undefined;
	                                        }
	                                    },
	                                    error: function error() {
	                                        clearCardType();
	                                        isUnsupportedCard = bin;
	                                    }
	                                });
	                            } else {
	                                isUnsupportedCard = undefined;
	                                lastRequestedBin = undefined;
	                                forceDropDown = false;
	                                clearCardType();
	                            }
	                        }
	
	                        $scope.getAllowedCardTypeByNumber = function (number) {
	                            return $scope.getCardTypeByNumber($scope.cardTypes.allowed, number);
	                        };
	
	                        $scope.getDisallowedCardTypeByNumber = function (number) {
	                            return $scope.getCardTypeByNumber($scope.cardTypes.disallowed, number);
	                        };
	
	                        $scope.enableAddMode = function () {
	
	                            if ($scope.card.isExisting()) {
	                                $scope.card.number = '';
	                            }
	                        };
	
	                        $scope.changeType = function () {
	                            forceDropDown = true;
	
	                            $scope.changeCardNumber(true);
	
	                            // Blank out unsupported fields
	
	                            if (!$scope.flag('fields.expiry')) {
	                                delete $scope.card.expiry_month;
	                                delete $scope.card.expiry_year;
	                            }
	
	                            if (!$scope.flag('fields.issue')) {
	                                delete $scope.card.start_month;
	                                delete $scope.card.start_year;
	                                delete $scope.card.issue_number;
	                            }
	
	                            if (!$scope.flag('fields.dob')) {
	                                delete $scope.card.dob_day;
	                                delete $scope.card.dob_month;
	                                delete $scope.card.dob_year;
	                            }
	
	                            if (!$scope.flag('fields.cvv')) {
	                                delete $scope.card.security_code;
	                            }
	                        };
	
	                        $scope.changeCardNumber = function (isCardTypeChanged) {
	                            // If buyer tries to modify an update card number. We remove the whole string
	                            // so buyer can add a card instead.
	                            $scope.enableAddMode();
	                            $scope.allowedCardsTooltip = false;
	
	                            var regex = /[０-９]/;
	                            if ($feature('disableFullWidthCharacters') && regex.test($scope.card.number)) {
	                                $logger.info('checkout_fpti', {
	                                    'is_fullwidth_character': true
	                                });
	                            }
	
	                            var number = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
	                            var formattedNumber;
	
	                            $scope.unformattedCardNumber = number;
	
	                            // Attempt to determine the card type
	
	                            var cardType;
	
	                            if (cardTypeServiceCall) {
	                                if (!isCardTypeChanged) {
	                                    getCardTypeByNumberServiceCall(number);
	                                }
	
	                                if (isUnsupportedCard) {
	                                    $scope.allowedCardsTooltip = true;
	                                }
	                            } else {
	                                if (!isCardTypeChanged) {
	                                    // Hide dropdown and trigger bin matching when the cc number is < 4 digits
	                                    if (number.length < 4) {
	                                        forceDropDown = false;
	                                    }
	
	                                    if (!$scope.enableDropDown()) {
	                                        cardType = $scope.getAllowedCardTypeByNumber(number);
	                                        $scope.card.type = cardType.type;
	                                        $scope.card.subType = cardType.subType;
	                                    }
	                                }
	
	                                if ($scope.isPlcc && $scope.card.type) {
	                                    $scope.cvvShown();
	                                    $scope.expiryShown();
	                                }
	
	                                if (!$scope.card.type && !$scope.isPlcc && (number.length >= 4 || $scope.getDisallowedCardTypeByNumber(number).type)) {
	                                    $scope.allowedCardsTooltip = true;
	                                }
	                            }
	
	                            // Format the card number
	
	                            /*
	                             * PPPLMER-1563 commented out to fix this bug
	                             if (/android/i.test(navigator.userAgent)) {
	                             return;
	                             }
	                             */
	
	                            formattedNumber = formatCardNumber(number);
	
	                            // If the card is already formatted correctly, we can leave the user to continue in peace.
	                            if ($scope.card.number === formattedNumber) {
	                                return;
	                            }
	
	                            // Wait for the user's input to be reflected on the page (necessary for safari 5 otherwise selectionStart is incorrect)
	                            $timeout(function () {
	
	                                // re-formatting the number, since the card type may not have resolved before the first call
	                                $scope.card.number = formatCardNumber(number);
	
	                                // Save the current cursor positions
	                                var ccField = document.getElementById('cc');
	                                if (!ccField) {
	                                    return;
	                                }
	                                var inputLength = ccField.value.length;
	                                var cursorStart = ccField.selectionStart;
	
	                                // Wait for the formatted card to be reflected on the page
	                                $timeout(function () {
	
	                                    // If the cursor was at the end of the input field, keep it at the end
	                                    if (cursorStart === inputLength) {
	                                        ccField.selectionStart = ccField.selectionEnd = ccField.value.length;
	                                        // Otherwise place the cursor to the position it was in before we replaced with the formatted number
	                                    } else {
	                                        ccField.selectionStart = ccField.selectionEnd = cursorStart;
	                                    }
	                                });
	                            });
	                        };
	
	                        var year = new Date().getFullYear();
	                        $scope.months = $util.map($util.range(1, 13), str);
	                        $scope.startYears = $util.map($util.range(year - 10, year), str);
	                    });
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_cardMetaData.$CardMetaData;

/***/ },

/***/ "./components/xo-ui-components/src/directionality/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/styles.less");
	
	/**
	 * This directive watches the model and listens to user input to look for arabic/hebrew/right-to-left language
	 * unicode chars, then adds dir="rtl" or dir="ltr" attribute to input field
	 *
	 * Add directionality to the container html div element of a input field.
	 * <div directionality><input type=text ng-model="user.name"></div>
	 */
	(0, _angular.$registerDirective)('directionality', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            var currentWatchDeregister = void 0;
	            var input = element.find('input');
	            if (!input.length) {
	                listenForInputRendered();
	                return;
	            }
	
	            // If the input has not yet been rendered inside the container, listen for dom node inserted
	            // then, if the node inserted is an input, we will use that element and init the directionality 
	            // listeners. The first input rendered is the one that will be captured by this directive.
	            function listenForInputRendered() {
	                element.bind('DOMNodeInserted', checkDOMNodeInserted);
	
	                function checkDOMNodeInserted(event) {
	                    if (event && event.target && event.target.tagName === 'INPUT') {
	                        element.unbind('DOMNodeInserted', checkDOMNodeInserted);
	                        input = angular.element(event.target);
	                        init();
	                    }
	                }
	            }
	
	            function setDirectionality(value) {
	                if (value) {
	                    // set directionality to 'rtl' if the value has hebrew/arabic unicode chars.
	                    element.toggleClass('ltrOverride', !_squid.$util.hasRTL(value));
	                } else {
	                    element.toggleClass('ltrOverride', _angular.$document.prop('documentElement').getAttribute('dir') !== 'rtl');
	                }
	            }
	
	            function jqueryOnKeyupHandler(event) {
	                setDirectionality(event.target.value);
	            }
	
	            // Reset directionality listeners when we transition from ltr -> rtl locale or vice versa
	            function resetDirectionalityListener() {
	                // remove directionality listeners that were set on prior locale
	                input.unbind('keyup', jqueryOnKeyupHandler);
	                if (currentWatchDeregister) {
	                    currentWatchDeregister();
	                }
	
	                // set new directionality listeners for the current locale if 'rtl'
	                if (document.documentElement.getAttribute('dir') === 'rtl') {
	                    (0, _angular.$timeout)(function () {
	                        // Watch ng-model on input to set directionality if it contains RTL char
	                        currentWatchDeregister = scope.$watch(input.attr('ng-model'), function (value) {
	                            setDirectionality(value);
	                        });
	                        // jQuery listener for cases where ng-model is not populated until post validation
	                        input.on('keyup', jqueryOnKeyupHandler);
	                    });
	                }
	            }
	
	            function init() {
	                resetDirectionalityListener();
	                scope.$on('localeChange', function () {
	                    resetDirectionalityListener();
	                });
	            }
	
	            init();
	        }
	    };
	});
	
	/**
	 * This directive watches the model for arabic/hebrew/right-to-left language unicode chars, then adds dir="rtl"
	 * or dir="ltr" attribute to the html element.
	 *
	 * Add directionality-text="<<model>>" to the div or span or any element containing text.
	 * <span directionality-text="user.name"><{{user.name}}</span>
	 */
	(0, _angular.$registerDirective)('directionality-text', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            if (document.documentElement.getAttribute('dir') === 'rtl') {
	                var $element = $(element);
	
	                (0, _angular.$timeout)(function () {
	                    if (attrs.directionalityText) {
	                        scope.$watch(attrs.directionalityText, function () {
	                            $element.toggleClass('ltrOverride', !_squid.$util.hasRTL((0, _angular.$parse)(attrs.directionalityText)(scope)));
	                        });
	                    } else {
	                        $element.toggleClass('ltrOverride', !_squid.$util.hasRTL(element.text()));
	                    }
	                });
	            }
	        }
	    };
	});
	
	_angular.$document;
	
	_angular.$parse;
	
	_angular.$registerDirective;
	
	_angular.$timeout;
	
	_squid.$util;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-ui-components/src/directionality/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/directionality/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/directionality/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".ltrOverride{direction:ltr!important;unicode-bidi:bidi-override!important}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-wallet-components/src/add-card/dob/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/add-card/dob/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoDobCardInputDirective', {
	    tag: 'xo-dob-card-input',
	    template: _template2['default'],
	
	    props: {
	        user: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            function pad() {
	                var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
	
	                return function (num) {
	                    return (new Array(length + 1).join('0') + num).substr(-length);
	                };
	            }
	
	            var year = new Date().getFullYear();
	            this.days = _squid.$util.map(_squid.$util.range(1, 32), pad());
	            this.months = _squid.$util.map(_squid.$util.range(1, 13), pad());
	            this.years = _squid.$util.map(_squid.$util.range(year - 100, year), pad(4)).reverse();
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$util;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/dob/template.html":
/***/ function(module, exports) {

	module.exports = "<div content id=\"cardDOB\" class=\"cardDOB inputField invisiField confidential last-child\">\n    <label class=\"dobLabel nolap\" for=\"dobDayCC\">{{ content('creditcard.dob') }}</label>\n\n    <div class=\"dropdown fidobDay nullable\">\n        <select xo-dropdown name=\"dobDayCC\" id=\"dobDayCC\" ng-model=\"user.dob_day\"\n                ng-options=\"day for day in days track by day\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyDD') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobMonth nullable\">\n        <select xo-dropdown name=\"dobMonthCC\" id=\"dobMonthCC\" ng-model=\"user.dob_month\"\n                ng-options=\"month for month in months track by month\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyMM') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobYear nullable\">\n        <select xo-dropdown name=\"dobYearCC\" id=\"dobYearCC\" ng-model=\"user.dob_year\"\n                ng-options=\"year for year in years track by year\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyYYYY') }}</option>\n        </select>\n    </div>\n</div>\n"

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/creditcard-input/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"creditCardInput\" content>\n    <!-- These two hidden fields are added to avoid autofill issue by chome for password and login field -->\n    <input style=\"display:none\">\n    <input type=\"password\" style=\"display:none\">\n\n    <div class=\"cardIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showAcceptedCardLogos()\">\n        <div class=\"icons\" ng-repeat = \"cardType in cardTypes.allowed\"><div class = \"cardIcon {{cardType}}\"></div></div>\n    </div>\n\n    <div class=\"debitAndCreditIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showMXCardLogos()\">\n        <p id=\"mxCardTitle\" class=\"cardIconTitle\">{{content('creditcard.cardIconTitle')}} </p>\n        <div class=\"cardIconsSection\">\n            <p class=\"creditIconLabel\" ng-if=\"showLabels\">{{content('creditcard.creditIconLabel')}}</p>\n            <div class=\"mxCardIconGroup\">\n                <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed\">\n                    <div class=\"cardIcon {{cardType}}\"></div>\n                </div>\n            </div>\n            <br>\n            <p class=\"debitIconLabel\" ng-if=\"showLabels\">{{content('creditcard.debitIconLabel')}}</p>\n            <div class=\"icons\"\n                 ng-repeat=\"cardType in mxDebitCards\">\n                <div class=\"debitcardIcon {{cardType}}\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isPlcc\" class=\"plccCardNumberTitle\" >{{content('addCard.plccAddCard', { merchant: promotion.name})}}</div>\n\n    <div class=\"dropdown cardType confidential nullable\" ng-if=\"!manageCardFlow && showDropDown()\">\n        <label for=\"cardType\" id=\"cardTypeLabel\" class=\"accessAid\">{{ content('creditcard.typeLabel') }}</label>\n        <select xo-dropdown name=\"cardType\" ng-model=\"card.type\" ng-change=\"changeType()\" ng-required=\"true\"\n                ng-options=\"cardType as content('cardTypes.' + cardType) for cardType in cardTypes.allowed track by cardType\"\n                id=\"cardType\" aria-labelledby=\"cardTypeLabel\" data-show-card-type=\"false\">\n            <option value=\"\" selected>{{ content('creditcard.typeLabel') }}</option>\n        </select>\n    </div>\n\n    <div ng-if=\"!manageCardFlow\" class=\"inputField confidential cardNumber creditCardField\" directionality>\n        <label for=\"cc\" class=\"focus accessAid\">\n            {{ content('creditcard.cardNumber') }}\n        </label>\n\n        <input type=\"tel\" ui-validate=\"{luhn: 'cardLuhnValid($value)', len: 'cardLengthValid($value)'}\"\n                ui-validate-watch=\"'card.type'\"\n                ng-model=\"card.number\" name=\"cardNumber\" id=\"cc\" value=\"\" ng-change=\"changeCardNumber(false)\"\n                ng-blur=\"ccOnBlur()\"\n                maxlength=\"{{maxLength()}}\" data-number=\"{{unformattedCardNumber}}\"\n                autocapitalize=\"off\" data-country=\"{{ locale.country }}\" autocomplete=\"off\"\n                placeholder=\"{{ content('creditcard.cardNumber') }}\"\n                ng-pattern=\"/.*/\"\n                pattern=\"[0-9]*\"\n                scroll-to-top\n                data-error-text=\"{{content('validation.validCreditCard')}}\" xo-error-tooltip />\n\n        <xo-tooltip trigger=\"#cc\" ng-if=\"allowedCardsTooltip\" show-event=\"keyup\">\n            <div class=\"tip tipDesc tipCreditCard\">\n                {{ !debitCardFlow ? content('creditcard.acceptableCards') : content('creditcard.acceptDebitCardOnly') }}\n                <span class=\"acceptedCards\" ng-if=\"!debitCardFlow\">\n                    {{supportedCardNamesCommaSeparated}}\n                </span>\n            </div>\n        </xo-tooltip>\n\n        <span ng-if=\"card.type\" class=\"creditCard {{card.type}} {{card.subType}}\" aria-label=\"{{card.type}}\" id=\"creditCard\" role=\"img\">{{card.type}}</span>\n    </div>\n\n    <!-- Issue no and start date for maestro cards -->\n    <div id=\"cardIssueInfo\" data-cardspecific=\"true\" class=\"fieldGroup clearfix\" ng-if=\"flag('fields.issue')\">\n\n        <div class=\"startDate inputField invisiField half confidential\">\n            <label class=\"starts nolap\" for=\"startmonth\">{{ content('creditcard.startDate') }}</label>\n\n            <div class=\"dropdown startmonth expmonth nullable\">\n                <select xo-dropdown ng-model=\"card.start_month\" id=\"startmonth\" name=\"startmonth\"\n                        ng-required=\"true\" ng-options=\"month for month in months\">\n                    <option value=\"\">{{ content('creditcard.monthPlaceholder') }}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown startyear expyear nullable\">\n                <select xo-dropdown ng-model=\"card.start_year\" id=\"startyear\" name=\"startyear\"\n                        ng-required=\"true\" ng-options=\"year for year in startYears\">\n                    <option value=\"\">{{ content('creditcard.yearPlaceholder') }}</option>\n                </select>\n            </div>\n        </div>\n\n        <div class=\"issueNo inputField half last-child confidential last-child\">\n            <input id=\"issueNo\" name=\"issueNo\" placeholder=\"{{content('creditcard.issueNoLabel')}}\" type=\"text\" ng-model=\"card.issue_number\" autocapitalize=\"off\" autocomplete=\"off\" maxlength=\"2\" ng-pattern=\"/^[0-9]+$/\" pattern=\"[0-9]*\"/>\n\n            <xo-tooltip trigger=\"#issueNo\">\n                <div class=\"tip tipDesc tipIssueNo\">\n                    {{ content('creditcard.issueNoLabelToolTip') }}\n                </div>\n            </xo-tooltip>\n        </div>\n    </div>\n\n    <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"expiryShown() || cvvShown()\">\n        <xo-card-expiry ng-if=\"expiryShown()\" expiry-month=\"card.expiry_month\" expiry-year=\"card.expiry_year\"></xo-card-expiry>\n        <xo-cvv ng-if=\"cvvShown()\" card=\"card\" show-label=\"true\"></xo-cvv>\n    </div>\n    \n    <!-- DOB fields for Country specific cards -->\n    <xo-dob-card-input ng-if=\"flag('fields.dob')\" user=\"user\"></xo-dob-card-input>\n</div>\n"

/***/ },

/***/ "./components/xo-form-components/src/name-input/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/name-input/template.html"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/floating-label/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	
	    return angular.module('xo-name-input.directive', ['squid', 'xo-error-tooltip.directive', 'floating-label.directive']).directive('xoNameInput', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                user: '=',
	                country: '@'
	            },
	
	            controller: function controller($populate, $scope, $locale, $MetadataModel) {
	
	                $scope.locale = $locale;
	                $scope.metadata = $MetadataModel.create();
	
	                // Normalizes Griffin's address-related content for rendering.
	
	                $scope.$watch('country', function () {
	                    $scope.metadata.choose($scope.country || $locale.country);
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/name-input/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"fieldGroup name clearfix\" ng-class=\"country || locale.country\" content>\n  <div ng-if=\"metadata.nameEntry.layout\" ng-repeat=\"layoutItem in metadata.nameEntry.layout\">\n\n    <!-- First name -->\n    <div ng-if=\"layoutItem.$ === 'givenName'\">\n      <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" floating-label directionality>\n\n        <input ng-model=\"user.first_name\"\n               id=\"firstName\"\n               name=\"firstName\"\n               value=\"\"\n               pattern=\"(?!^\\d+$)^.+$\"\n               autocapitalize=\"off\"\n               aria-required=\"false\"\n               autocomplete=\"off\"\n               maxlength=\"100\"\n               xo-error-tooltip\n               ng-required=\"{{layoutItem.required}}\" />\n          <label for=\"firstName\">\n              {{content('common.firstName')}}\n          </label>\n      </div>\n    </div>\n\n    <!-- Last name -->\n    <div ng-if=\"layoutItem.$ === 'surname'\">\n      <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" floating-label directionality>\n        <input ng-model=\"user.last_name\"\n               id=\"lastName\"\n               name=\"lastName\"\n               value=\"\"\n               pattern=\"(?!^\\d+$)^.+$\"\n               autocapitalize=\"off\"\n               aria-required=\"false\"\n               autocomplete=\"off\"\n               maxlength=\"100\"\n               xo-error-tooltip\n               ng-required=\"{{layoutItem.required}}\" />\n          <label for=\"lastName\">\n              {{content('common.lastName')}}\n          </label>\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"!metadata.nameEntry.layout\">\n    <div class=\"inputField half confidential\" floating-label directionality>\n\n      <input ng-model=\"user.first_name\"\n             id=\"firstName\"\n             name=\"firstName\"\n             value=\"\"\n             pattern=\"(?!^\\d+$)^.+$\"\n             autocapitalize=\"off\"\n             aria-required=\"false\"\n             autocomplete=\"off\"\n             maxlength=\"100\"\n             xo-error-tooltip\n             ng-required=\"true\" />\n        <label for=\"firstName\">\n            {{content('common.firstName')}}\n        </label>\n    </div>\n\n    <!-- Last name -->\n    <div class=\"inputField half confidential last-child\" floating-label directionality>\n\n      <input ng-model=\"user.last_name\"\n             id=\"lastName\"\n             name=\"lastName\"\n             value=\"\"\n             pattern=\"(?!^\\d+$)^.+$\"\n             autocapitalize=\"off\"\n             aria-required=\"false\"\n             autocomplete=\"off\"\n             maxlength=\"100\"\n             xo-error-tooltip\n             ng-required=\"true\" />\n        <label for=\"lastName\">\n            {{content('common.lastName')}}\n        </label>\n    </div>\n  </div>\n</div>\n"

/***/ },

/***/ "./components/xo-ui-components/src/floating-label/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/floating-label/styles.less");
	
	var treatmentType;
	var newLocale;
	var oldLocale;
	
	function getTreatment() {
	
	    if (treatmentType !== undefined) {
	        return treatmentType;
	    }
	    if ((0, _squid.$feature)('floatingLabels')) {
	        return true;
	    }
	    var token = _angular.$rootScope.token;
	    var throttle = _squid.$config['floatingLabelLocales'] && _squid.$config['floatingLabelLocales'][_squid.$locale.country] && _squid.$config['floatingLabelLocales'][_squid.$locale.country][_squid.$locale.lang];
	    var id = _squid.$locale.lang + '_' + _squid.$locale.country + token;
	    treatmentType = throttle && (0, _squid.$experiment)('floating_label_exp', throttle, id, {}) ? true : false;
	    return treatmentType;
	}
	
	(0, _angular.$registerDirective)('floating-label', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	
	            scope.$on('localeChange', function () {
	                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;
	                if (oldLocale !== newLocale) {
	                    treatmentType = undefined;
	                    oldLocale = newLocale;
	                }
	                scope.showFloatingLabels = getTreatment();
	            });
	
	            (0, _angular.$timeout)(function () {
	                scope.showFloatingLabels = getTreatment();
	
	                scope.$watch('showFloatingLabels', function (val) {
	                    // remove else block after experimentation is complete
	                    if (val) {
	                        element.addClass('floatingLabel');
	                        element.removeClass('noFloatingLabel');
	                    } else {
	                        element.removeClass('floatingLabel');
	                        element.addClass('noFloatingLabel');
	                    }
	                });
	
	                var input = element.find('input');
	
	                if (input.attr('placeholder')) {
	                    input.addClass('hasPlaceholder');
	                }
	
	                // To hide the placeholder labels for pre-populated input fields
	                scope.$watch(input.attr('ng-model'), function (value) {
	                    input.toggleClass('focused', !!value);
	                });
	
	                // We're using this as an alternative to watching 'ng-model' since this properly triggers the focused CSS property on email input.
	                input.on('keyup', function (event) {
	                    var val = event.target.value;
	                    input.toggleClass('focused', !!val);
	                });
	
	                input.on('focus blur click', function (event) {
	                    if (scope.showFloatingLabels) {
	                        input.toggleClass('focused', event.type === 'focus' || this.value.length > 0);
	                    }
	                }).trigger('blur');
	            });
	        }
	    };
	});
	
	(0, _angular.$registerDirective)('floating-label-dropdown', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	
	            scope.$on('localeChange', function () {
	                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;
	                if (oldLocale !== newLocale) {
	                    treatmentType = undefined;
	                    oldLocale = newLocale;
	                }
	                scope.showFloatingLabels = getTreatment();
	            });
	
	            (0, _angular.$timeout)(function () {
	
	                scope.showFloatingLabels = getTreatment();
	
	                scope.$watch('showFloatingLabels', function (val) {
	                    // remove else block after experimentation is complete
	                    if (val) {
	                        element.addClass('floatingLabel');
	                        element.removeClass('noFloatingLabel');
	                    } else {
	                        element.removeClass('floatingLabel');
	                        element.addClass('noFloatingLabel');
	                    }
	                });
	
	                var select = element.find('select');
	                var label = element.find('label');
	                var flSpan = element.find('.custom-select span span');
	
	                select.on('change mouseenter mouseleave blur', function (event) {
	                    select.toggleClass('focused', event.type === 'change' || this.value.length > 0);
	                    flSpan.toggleClass('noValue', this.value.length < 1);
	                    label.toggleClass('hide', this.value.length < 1);
	                }).trigger('mouseleave');
	            });
	        }
	    };
	});
	
	_angular.$timeout;
	
	_angular.$rootScope;
	
	_angular.$registerDirective;
	
	_squid.$locale;
	
	_squid.$experiment;
	
	_squid.$config;
	
	_squid.$feature;

/***/ },

/***/ "./components/xo-ui-components/src/floating-label/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/floating-label/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/floating-label/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}.inputField.floatingLabel input{height:49px}.inputField.floatingLabel select{height:48px;font-size:15px}.inputField.floatingLabel select.focused~label.hide,.inputField.floatingLabel select:focus~label.hide{display:none}.inputField.floatingLabel.dropdown label{color:transparent}.inputField.floatingLabel.dropdown .custom-select span{padding:0 14px;position:relative;height:47px}.inputField.floatingLabel.dropdown .custom-select span span{top:18px;padding:0}.inputField.floatingLabel.dropdown .custom-select span span.noValue{top:9px}.inputField.floatingLabel input.focused,.inputField.floatingLabel input:focus,.inputField.floatingLabel select.focused,.inputField.floatingLabel select:focus{padding-top:16px}.inputField.floatingLabel input.focused::-webkit-input-placeholder,.inputField.floatingLabel input:focus::-webkit-input-placeholder,.inputField.floatingLabel select.focused::-webkit-input-placeholder,.inputField.floatingLabel select:focus::-webkit-input-placeholder{color:#6c7378}.inputField.floatingLabel input.focused:-moz-placeholder,.inputField.floatingLabel input.focused::-moz-placeholder,.inputField.floatingLabel input:focus:-moz-placeholder,.inputField.floatingLabel input:focus::-moz-placeholder,.inputField.floatingLabel select.focused:-moz-placeholder,.inputField.floatingLabel select.focused::-moz-placeholder,.inputField.floatingLabel select:focus:-moz-placeholder,.inputField.floatingLabel select:focus::-moz-placeholder{color:#6c7378}.inputField.floatingLabel input.focused:-ms-input-placeholder,.inputField.floatingLabel input:focus:-ms-input-placeholder,.inputField.floatingLabel select.focused:-ms-input-placeholder,.inputField.floatingLabel select:focus:-ms-input-placeholder{color:#6c7378}.inputField.floatingLabel input.focused~label,.inputField.floatingLabel input:focus~label,.inputField.floatingLabel select.focused~label,.inputField.floatingLabel select:focus~label{color:#0070ba;-webkit-transform:translate3d(0,-7px,0) scale(.8);transform:translate3d(0,-7px,0) scale(.8);text-overflow:ellipsis;overflow-x:hidden;width:100%;display:inline-block;white-space:nowrap}.inputField.floatingLabel input.focused:not(:focus)~label,.inputField.floatingLabel select.focused:not(:focus)~label{color:#6c7378}.inputField.floatingLabel input::-webkit-input-placeholder,.inputField.floatingLabel select::-webkit-input-placeholder{color:transparent}.inputField.floatingLabel input:-moz-placeholder,.inputField.floatingLabel input::-moz-placeholder,.inputField.floatingLabel select:-moz-placeholder,.inputField.floatingLabel select::-moz-placeholder{color:transparent}.inputField.floatingLabel input:-ms-input-placeholder,.inputField.floatingLabel select:-ms-input-placeholder{color:transparent}.inputField.floatingLabel label{color:#6c7378;position:absolute;top:14px;left:14px;pointer-events:none;-webkit-transform:translateZ(0) scale(1);transform:translateZ(0) scale(1);transform-origin:left top 0;transition:all .25s ease-in-out;text-overflow:ellipsis;overflow-x:hidden;width:90%;display:inline-block;white-space:nowrap}.validated .inputField.floatingLabelDropdown input.ng-invalid.focused::-webkit-input-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus::-webkit-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused::-webkit-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus::-webkit-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused::-webkit-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus::-webkit-input-placeholder{color:#6c7378}.validated .inputField.floatingLabelDropdown input.ng-invalid.focused:-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid.focused::-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus:-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus::-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused:-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused::-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus:-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus::-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused:-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused::-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus:-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus::-moz-placeholder{color:#6c7378}.validated .inputField.floatingLabelDropdown input.ng-invalid.focused:-ms-input-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus:-ms-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused:-ms-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus:-ms-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused:-ms-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus:-ms-input-placeholder{color:#6c7378}.validated .inputField.floatingLabelDropdown input.ng-invalid:not(:focus):not(.focused)~label,.validated .inputField.floatingLabel input.ng-invalid:not(:focus):not(.focused)~label,.validated .inputField.noFloatingLabel input.ng-invalid:not(:focus):not(.focused)~label{color:#c72e2e}.validated .inputField.floatingLabelDropdown input.ng-invalid::-webkit-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid::-webkit-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid::-webkit-input-placeholder{color:transparent}.validated .inputField.floatingLabelDropdown input.ng-invalid:-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid::-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid:-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid::-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid::-moz-placeholder{color:transparent}.validated .inputField.floatingLabelDropdown input.ng-invalid:-ms-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid:-ms-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:-ms-input-placeholder{color:transparent}.validated .inputField.floatingLabelDropdown input.ng-invalid~label,.validated .inputField.floatingLabel input.ng-invalid~label,.validated .inputField.noFloatingLabel input.ng-invalid~label{color:#c72e2e}.validated .inputField.floatingLabelDropdown input.ng-invalid~label.hide,.validated .inputField.floatingLabel input.ng-invalid~label.hide,.validated .inputField.noFloatingLabel input.ng-invalid.focused~label,.validated .inputField.noFloatingLabel input.ng-invalid~label.hide{color:transparent}.inputField.noFloatingLabel label{color:transparent;left:14px;text-overflow:ellipsis;overflow-x:hidden;width:90%;white-space:nowrap;pointer-events:none}.inputField.noFloatingLabel input{height:49px}.inputField.noFloatingLabel input::-webkit-input-placeholder{color:transparent}.inputField.noFloatingLabel input:-moz-placeholder,.inputField.noFloatingLabel input::-moz-placeholder{color:transparent}.inputField.noFloatingLabel input:-ms-input-placeholder{color:transparent}.inputField.noFloatingLabel input:focus.focused~label{color:transparent}.inputField.noFloatingLabel input:not(.focused):focus~label{color:#6c7378}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder~label{color:transparent}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder::-webkit-input-placeholder{color:#6c7378}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder:-moz-placeholder,.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder::-moz-placeholder{color:#6c7378}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder:-ms-input-placeholder{color:#6c7378}.inputField.noFloatingLabel input:not(:focus):not(.focused)~label{color:#6c7378}.inputField.noFloatingLabel select{height:48px;font-size:15px}.inputField.noFloatingLabel select.focused~label,.inputField.noFloatingLabel select:focus~label{color:transparent}.inputField.noFloatingLabel .custom-select span{padding:0 14px;position:relative;height:47px}.inputField.noFloatingLabel .custom-select span span{top:11px;padding:0}.inputField.noFloatingLabel#countryOfResidenceDropDown,.inputField.noFloatingLabel#nationalityDropDown{min-height:87px}.inputField.noFloatingLabel#countryOfResidenceDropDown .custom-select,.inputField.noFloatingLabel#countryOfResidenceDropDown select,.inputField.noFloatingLabel#nationalityDropDown .custom-select,.inputField.noFloatingLabel#nationalityDropDown select{top:20px}.inputField.noFloatingLabel#countryOfResidenceDropDown label,.inputField.noFloatingLabel#nationalityDropDown label{color:#6c7378;top:0;left:0}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-wallet-components/src/add-card/selectcard/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/selectcard/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-add-card.selectcard.route', ['xo-add-card.selectcard.directive']).factory('$SelectCardRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('SelectCardRoute', {
	
	            name: 'selectCard',
	            directive: 'xo-select-card',
	            titleContent: 'asideHeader.selectCard',
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card/selectcard", "components/xo-wallet-components/src/add-card/selectcard/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/selectcard/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/selectcard/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	
	    return angular.module('xo-add-card.selectcard.directive', []).directive('xoSelectCard', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                parentCallbacks: '=',
	                token: '=',
	                promotion: '='
	            },
	
	            controller: function controller($scope, $populate, $CheckoutSessionModel) {
	
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(function () {
	                    $scope.selectCardType = function (type) {
	                        // card type is either 'cc' or 'plcc'
	                        $scope.parentCallbacks.cardTypeSelected(type);
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/selectcard/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"selectCardType\">\n\t<xo-aside-header hdrtype='tall' heading='asideHeader.selectCard' sub-head='asideHeader.fundingInstrumentsSubHead' back-url=\"checkout.review.sidebar.wallet\"></xo-aside-header>\n\n\t<div class=\"asideContent fundingCards\" id=\"selectFundingType\" content>\n\t\t<div class=\"allCards\">\n\t\t\t<ul class=\"allFundingInstrumentsList clearfix\">\n\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('cc')\">\n\t\t\t\t\t\t<span class=\"fsIcon\"></span>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">Debit or Credit Card</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('plcc')\">\n\t\t\t\t\t\t<img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">{{content('addCard.plccAddCard', { merchant: promotion.name})}}</span>\n\t\t\t\t\t\t\t<span class=\"secondary\">{{content('addCard.plccSelectIncentive')}}</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/addbilling/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addbilling/directive.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-address-components/src/address-normalization/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-card.addbilling.route', ['squid', 'xo-add-card.addbilling.directive', 'xo-add-address.directive', 'xo-address-normalization.route']).factory('$AddBillingRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddBillingRoute', {
	
	            name: 'addBilling',
	            directive: 'xo-add-billing',
	            titleContent: 'addBillingAddress.title',
	
	            trackingData: {
	                fptiState: 'edit_billing'
	            },
	            loginRequired: true,
	            children: [{
	                name: '$AddressNormalizationRoute',
	                attributes: {
	                    id: 'token',
	                    sidebar: 'sidebar',
	                    address: 'address',
	                    'done-fn': 'uponNormalization'
	                }
	            }]
	
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card/addbilling", "components/xo-wallet-components/src/add-card/addbilling/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/addbilling/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addbilling/template.html"), __webpack_require__("./components/angular-ui-utils/ui-utils.min.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, module, template) {
	
	    return module('xo-add-card.addbilling.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xomodel.address', 'xo-add-address.directive', 'xo-aside-header.directive', 'xo-error-tooltip.directive', 'ui.validate', 'xo-accessibility.directive']).directive('xoAddBilling', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                auth: '=',
	                token: '=',
	                doneFn: '=',
	                parentCallbacks: '=',
	                sidebar: '=',
	                showmeftsection: '=',
	                hideparenthead: '=',
	                billingaddressupdated: '=',
	                prefillAddress: '='
	            },
	
	            controller: function controller($scope, $populate, $BillingAddressesModel, $BillingAddressModel, $PrefillAddressModel, $feature, $state, $element, $config, $locale, $timeout, $FlowEligibilityModel, $meta) {
	                var country = $locale.getCountryCodeISO();
	                $scope.billing = true; // to denote its billing address page still
	                $scope.normalize = $feature('addressNormalization');
	                $scope.country = country;
	                var $el = $($element);
	                if ($scope.showmeftsection) {
	                    $scope.showmeftsection.toggle = false;
	                }
	
	                if ($scope.hideparenthead) {
	                    $scope.hideparenthead.toggle = true;
	                }
	
	                function isUserInputtedAddress(address) {
	                    return address.id === '0';
	                }
	
	                // Label fields has having error if needed to, and focus the first error if needed
	                function handleValidation(res) {
	                    if (res && res.fields && res.fields.length) {
	                        res.fields.forEach(function (field) {
	                            if (field.field) {
	                                var $field = $($el.find('[name="' + field.field + '"]'));
	                                if ($field.length === 0 && field.field === 'zip') {
	                                    $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
	                                }
	
	                                $field.addClass('backendError');
	                                $field.attr('aria-invalid', true);
	                            }
	                        });
	                    }
	
	                    $el.find('form').find('.backendError, .ng-invalid').first().focus();
	                }
	
	                var prefilledAddress = $scope.prefillAddress && $scope.prefillAddress.address;
	
	                if (prefilledAddress) {
	                    $scope.prefilled = true;
	                }
	
	                $scope.address = $scope.address || prefilledAddress || { country: country };
	
	                $populate($scope, {
	                    billingAddresses: $BillingAddressesModel.instance(),
	                    flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
	                        params: {
	                            geolocation: $meta.geolocation,
	                            localeCountry: $locale.country
	                        }
	                    })
	                }).then(function () {
	                    $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';
	
	                    $scope.cancelFn = function () {
	                        $scope.done();
	                    };
	
	                    $scope.done = function (target) {
	                        var el = $('.tokenization #sidepageAddCard');
	                        if (el) {
	                            el.removeClass('slideLeft');
	                        }
	
	                        target = target || '^.addCard';
	                        $state.go(target);
	                    };
	
	                    $scope.onSubmit = function () {
	                        $scope.updateAddress();
	                    };
	
	                    $scope.prefill = function () {
	                        $scope.address.country = $scope.country;
	                        $scope.prefillAddress = new $PrefillAddressModel({
	                            id: $scope.token,
	                            address: $scope.address
	                        });
	
	                        $scope.prefillAddress.save({
	                            data: $scope.prefillAddress,
	
	                            success: function success(result) {
	                                $scope.address = result;
	                                $scope.prefilled = true;
	                                $scope.showAddressFields = true;
	
	                                $timeout(function () {
	                                    var value = $scope.address.state;
	
	                                    var $option = $el.find('[value="' + value + '"]');
	                                    $option.prop('selected', 'selected');
	                                    $option.trigger('change');
	
	                                    value = $option.attr('label');
	                                }, 1000);
	                            }
	                        });
	                    };
	
	                    $scope.updateAddress = function () {
	
	                        var newBilling = new $BillingAddressModel({
	                            line1: $scope.address.line1,
	                            line2: $scope.address.line2,
	                            city: $scope.address.city,
	                            state: $scope.address.state,
	                            postal_code: $scope.address.postal_code,
	                            normalization_status: $scope.address.normalization_status,
	                            country: country,
	                            id: '0'
	                        });
	
	                        newBilling.save({
	                            data: $scope.billingAddress,
	
	                            success: function success() {
	                                if ($scope.normalize) {
	                                    // set to false so that html related to billing address is hidden when child is shown
	                                    $scope.billing = false;
	                                    $scope.address.full_address = newBilling.full_address;
	                                    $state.go('.addressNormalization');
	                                } else {
	                                    $scope.updateBillingAddressAndReturn('^.addCard', newBilling);
	                                }
	                            },
	
	                            validation: function validation(res) {
	                                handleValidation(res);
	                            }
	
	                        });
	                    };
	
	                    $scope.uponNormalization = function (normalizedAddress, isBack) {
	                        if (isBack) {
	                            $scope.billing = true;
	                            $state.go('^');
	                        } else {
	                            $scope.updateBillingAddressAndReturn('^.^.addCard', normalizedAddress);
	                        }
	                    };
	
	                    $scope.updateBillingAddressAndReturn = function (target, address) {
	                        var newBillingAddress;
	                        if (address && address instanceof $BillingAddressModel) {
	                            newBillingAddress = address;
	                        } else {
	                            newBillingAddress = new $BillingAddressModel({
	                                line1: address.line1,
	                                line2: address.line2,
	                                city: address.city,
	                                state: address.state,
	                                postal_code: address.postal_code,
	                                normalization_status: address.normalization_status,
	                                country: address.country || $scope.country,
	                                full_address: address.full_address || $scope.address.full_address,
	                                id: '0'
	                            });
	                        }
	
	                        var addresses = $scope.billingAddresses.addresses;
	                        if (!isUserInputtedAddress(addresses[0])) {
	                            addresses.unshift(newBillingAddress);
	                        } else {
	                            addresses[0] = newBillingAddress;
	                        }
	                        $scope.billingaddressupdated.value = true;
	
	                        $scope.done(target);
	                    };
	
	                    // page transition after the page is loaded
	                    var el = $('.tokenization #sidepageAddCard');
	                    if (el) {
	                        el.addClass('slideLeft');
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addbilling/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"addBillingAddress\" ng-if=\"billing\" modal-box=\"address\" modal-cancel=\"cancelFn()\">\n    <xo-aside-header heading='asideHeader.addBillingAddress' ng-if=\"debitCardFlow\"\n                     hidex=\"true\"\n                     header-left-link=\"done\"\n                     header-left=\"common.back\"\n                     header-left-icon=\"true\"></xo-aside-header>\n\n    <xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n    <h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar && !debitCardFlow\">{{ content('addBillingAddress.title') }}</h1>\n\n    <form id=\"billingAddressForm\" name=\"billingAddressForm\" class=\"asideView addressForm\" content form-autofocus novalidate>\n        <div class=\"trayInner container\">\n            <div class=\"clearfix\">\n                <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n            </div>\n\n            <div class=\"buttons clearfix\">\n                <a ng-hide=\"sidebar || debitCardFlow\" id=\"backButton\" ui-sref=\"^.addCard\" class=\"btn btn-secondary\" role=\"button\">{{ content('common.back') }}</a>\n                <input ng-if=\"country==='BR' && !prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"prefill()\" />\n                <input track-submit ng-if=\"country!=='BR' || prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.save') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"onSubmit()\" />\n            </div>\n        </div>\n    </form>\n</div>\n<div ui-view></div>\n"

/***/ },

/***/ "./components/xo-address-components/src/add-address/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-address-components/src/add-address/template.html"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-ui-components/src/dropdown-multiline/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-form-components/src/name-input/directive.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-form-components/src/zipcode/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-add-address.directive', ['squid', 'xo-dropdown.directive', 'xo-dropdown-multiline.directive', 'xo-error-tooltip.directive', 'xo-name-input.directive', 'xomodel.address', 'xo-zipcode.directive']).directive('discriminate', function ($timeout, $parse) {
	        // scans through the rendered elements within a container and
	        // applies the supplied discriminator function to all the 'id'
	        // and 'for' attributes. NOTE: Use the string 'baseId' when
	        // entering the expression for the directive.
	        //
	        // e.g. discriminate='someDiscriminator(baseId)'
	        //
	        return {
	            restrict: 'A',
	            link: function link(scope, element, attrs) {
	                // wait for the DOM to settle down
	                $timeout(function () {
	                    var discriminatorFn = $parse(attrs.discriminate);
	
	                    $(element).find('[for],[id],[name]').each(function () {
	                        // apply the discriminator to the attributes
	                        var baseFor = $(this).attr('for');
	                        var baseId = $(this).attr('id');
	                        var baseName = $(this).attr('name');
	
	                        if (baseFor) {
	                            $(this).attr('for', discriminatorFn(scope, { baseId: baseFor }));
	                        }
	
	                        if (baseId) {
	                            $(this).attr('id', discriminatorFn(scope, { baseId: baseId }));
	                        }
	
	                        if (baseName) {
	                            $(this).attr('name', discriminatorFn(scope, { baseId: baseName }));
	                        }
	                    });
	                });
	            }
	        };
	    }).directive('xoAddAddress', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                address: '=',
	                isShipping: '=',
	                country: '=',
	                metadata: '@',
	                hideButtonHandler: '=',
	                hideCep: '=',
	                hideName: '=',
	                triggerZipCodeBlur: '=',
	                triggerZipCodeKeyPress: '='
	            },
	
	            controller: function controller($scope, $populate, $rootScope, $locale, $window, $feature, $PrefillAddressModel, $MetadataModel) {
	
	                var country = $scope.country || $scope.address && $scope.address.country;
	
	                $scope.country = country;
	                $scope.locale = $locale;
	                $scope.metadata = $MetadataModel.create();
	
	                // If the user changes their shipping/billing address country, fetch that metadata (if needed) and re-render.
	                $scope.$watch('country', function setMetadata() {
	                    $scope.metadata.choose($scope.country, $scope.locale.lang);
	                });
	
	                // If the user changes languagle toggle, fetch that metadata (if needed) and re-render.
	                $scope.$on('contentChange', function setMetadata() {
	                    $scope.metadata.choose($scope.country, $scope.locale.lang);
	                });
	
	                // this function is used on ids and fors in the template to add 'shipping' or 'billing'
	                // in front of the identifier in camelCase. Use in conjunction with the 'discriminate' directive
	                $scope.addPrefix = function (baseId) {
	                    return ($scope.isShipping ? 'shipping' : 'billing') + baseId.replace(/^(.)/, function (match) {
	                        return match[0].toUpperCase();
	                    });
	                };
	
	                $scope.normalizeCountry = function (countryCode) {
	                    return $feature('AddressFormat', countryCode, countryCode) || countryCode;
	                };
	
	                $scope.isAddPreferred = $feature('preferredShipping', false, $scope.country) && $scope.isShipping;
	
	                $scope.isAddressLookupEnabled = $feature('addressLookup', false, $scope.country);
	                var sortStates = $feature('sortStatesForAddress', false, $scope.country);
	
	                $scope.isShowLookupFields = $scope.isAddressLookupEnabled;
	
	                if ($scope.isShowLookupFields) {
	                    // Show the Address Lookup Fields only when the hideButtonHandler function is passed by the caller.
	                    if ($scope.hideButtonHandler) {
	                        $scope.hideButtonHandler(true);
	                    } else {
	                        $scope.isShowLookupFields = false;
	                    }
	                }
	
	                function getSortedStateList() {
	                    var states = $locale.content.get(sortStates, {});
	                    var statesList = [];
	                    angular.forEach(states, function (key, value) {
	                        statesList.push({
	                            code: value,
	                            sname: key
	                        });
	                    });
	
	                    statesList.sort(function (a, b) {
	                        return a.sname.localeCompare(b.sname);
	                    });
	                    $scope.sortedStatesList = statesList;
	                }
	
	                if (sortStates) {
	                    getSortedStateList();
	                }
	
	                $scope.formatZip = function () {
	                    var unformatted = $scope.address.postal_code.replace(/[^0-9]/gi, '');
	                    var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3)]].map(function (x) {
	                        return x[1] && x[0] + x[1] || '';
	                    }).join('');
	                    $scope.address.postal_code = formatted;
	                };
	
	                function getAddress(address) {
	                    var COMMA = ', ';
	                    var SPACE = ' ';
	                    var line1, line2;
	
	                    function prefix(str, prefixStr) {
	                        if (str) {
	                            return (prefixStr ? prefixStr : '') + str;
	                        }
	                        return '';
	                    }
	
	                    if (!address.deliveryAddresses || angular.isArray(address.deliveryAddresses) && address.deliveryAddresses.length === 0) {
	                        // if deliveryAddresses is not an array or is empty
	                        // line would be empty, hence return to caller.
	                        return;
	                    }
	
	                    var array = address.deliveryAddresses;
	                    if (array.length > 1) {
	                        // populate line2 from the last element
	                        line2 = array.pop();
	                    }
	                    line1 = array.join(COMMA);
	
	                    var displayLine1 = line1 + prefix(line2, COMMA);
	                    var displayLine2 = prefix(address.city) + prefix(address.state, COMMA) + prefix(address.postal_code, SPACE);
	                    var displayLine3 = prefix(address.country);
	
	                    return {
	                        line1: line1,
	                        line2: line2,
	                        city: address.city,
	                        state: address.state,
	                        postal_code: address.postal_code,
	                        country: address.country,
	
	                        displayLine1: displayLine1,
	                        displayLine2: displayLine2,
	                        displayLine3: displayLine3,
	
	                        dropDownAddress: displayLine1 + prefix(displayLine2, ' \\n ') + prefix(displayLine3, ' \\n ')
	                    };
	                }
	
	                function populateAddressFormFields(address) {
	                    $scope.address.line1 = address.line1;
	                    $scope.address.line2 = address.line2;
	                    $scope.address.city = address.city;
	                    $scope.address.state = address.state;
	                    $scope.address.postal_code = address.postal_code;
	                    $scope.address.neighborhood = address.neighborhood;
	                }
	
	                /**
	                 * Show error message and display the full-address fields
	                 */
	                function populateErrorMessage() {
	                    var messages = [];
	                    messages.push($scope.locale.content.get('addressBook.lookupError'));
	
	                    $scope.lookupFailureMessage = {
	                        msgs: messages,
	                        type: 'warning'
	                    };
	
	                    $scope.isShowLookupFields = false;
	                    $scope.isLookupFailure = true;
	                }
	
	                function processLookupResult(list) {
	                    if (list.length > 1) {
	                        // Show drop-down list of all addresses
	                        $scope.isLookupSuccess = true;
	                        $scope.isShowLookupDropDown = true;
	                        $scope.lookupAddressList = list.map(function (addr) {
	                            return getAddress(addr);
	                        });
	                    } else if (list.length === 1) {
	                        // Show single address component
	                        $scope.isLookupSuccess = true;
	                        $scope.isShowLookupDropDown = false;
	
	                        var address = getAddress(list[0]);
	                        $scope.singleAddress = address;
	                        populateAddressFormFields(address);
	                    } else {
	                        populateErrorMessage();
	                    }
	                }
	
	                if ($scope.address) {
	                    $scope.lastPrefilledZip = $scope.address.postal_code;
	                }
	                $scope.prefill = function () {
	                    var cepPattern = /^(\d{5}-\d{3}|\d{5}|\d{8})$/;
	                    var first_name;
	                    var last_name;
	
	                    if ($scope.lastPrefilledZip === $scope.address.postal_code || !cepPattern.test($scope.address.postal_code)) {
	                        return;
	                    }
	
	                    if ($scope.isShipping) {
	                        first_name = $scope.address.first_name;
	                        last_name = $scope.address.last_name;
	                    }
	
	                    $scope.prefillAddress = new $PrefillAddressModel({
	                        id: $scope.token,
	                        address: {
	                            country: $scope.address.country,
	                            postal_code: $scope.address.postal_code
	                        }
	                    });
	
	                    $scope.prefillAddress.save({
	                        data: $scope.prefillAddress,
	
	                        success: function success(result) {
	                            if (result) {
	                                populateAddressFormFields(result);
	                                $scope.lastPrefilledZip = $scope.address.postal_code;
	                                if ($scope.isShipping) {
	                                    $scope.address.first_name = first_name;
	                                    $scope.address.last_name = last_name;
	                                }
	                            }
	                        }
	                    });
	                };
	
	                $scope.findAddress = function () {
	                    $scope.lookupAddress = $PrefillAddressModel.create($scope.token, {
	                        address: {
	                            country: $scope.address.country,
	                            postal_code: $scope.address.postal_code,
	                            house_number: $scope.address.house_number,
	                            building_name: $scope.address.building_name
	                        }
	                    });
	
	                    if (document.querySelector('#lookupZip.ng-invalid')) {
	                        document.querySelector('#addressLookupFields').classList.add('validated');
	                    } else {
	                        $scope.isLookupProcessing = true;
	                        $scope.lookupAddress.save({
	                            data: $scope.lookupAddress,
	                            silent: true,
	
	                            success: function success(result) {
	                                processLookupResult(result);
	                                $scope.hideButtonHandler(false);
	                            },
	
	                            contingencies: {
	                                INTERNAL_ERROR: populateErrorMessage
	                            }
	                        });
	                    }
	                };
	
	                $scope.changeAddressDropDown = function () {
	                    populateAddressFormFields($scope.address.selectedAddress);
	                };
	
	                $scope.showFullAddress = function () {
	                    $scope.isShowLookupFields = false;
	                    $scope.hideButtonHandler(false);
	                };
	
	                /**
	                 * Pass an array of group names to retrieve the list of states
	                 * e.g. ['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies']
	                 */
	                var stateNamesInGroup = [];
	                $scope.retrieveStateNamesInGroup = function (groups) {
	                    if (stateNamesInGroup.length) {
	                        // Angular keeps watching for this method as its used in ng-model, hence return cached data.
	                        return stateNamesInGroup;
	                    }
	                    var content = $locale.content;
	                    angular.forEach(groups, function (group) {
	                        var groupName = content.common[group];
	                        var statesList = content[group];
	                        angular.forEach(statesList, function (value, key) {
	                            stateNamesInGroup.push({
	                                key: key,
	                                value: value,
	                                group: groupName
	                            });
	                        });
	                    });
	                    return stateNamesInGroup;
	                };
	
	                $scope.zipCodeBlur = function () {
	                    if ($scope.triggerZipCodeBlur) {
	                        $rootScope.$emit('zip_code_blur');
	                    }
	                };
	
	                $scope.zipCodeKeyPress = function (event) {
	                    if ($scope.triggerZipCodeKeyPress) {
	                        $rootScope.$emit('zip_code_keypress', { event: event });
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-address-components/src/add-address/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"addressForm\" class=\"addressForm\" content ng-class=\"country\">\n\n    <xo-name-input user=\"address\" country=\"{{country}}\" ng-if=\"isShipping && !hideName\"></xo-name-input>\n\n    <div ng-switch=\"normalizeCountry(country)\" discriminate=\"addPrefix(baseId)\" class=\"addressGroup clearfix\">\n\n        <div ng-switch-when=\"BR\">\n            <xo-zipcode id=\"zipcode\" country=\"BR\" zip-code=\"address.postal_code\" zip-label=\"{{content('common.cep')}}\" zip-error-text=\"{{content('common.valueInvalid')}}\" done-fn=\"prefill\" ng-if=\"!hideCep\"></xo-zipcode>\n\n            <div name=\"addressFields\" id=\"addressFields\">\n                <div class=\"streetName clearfix\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"60\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip required />\n                        <label for=\"line1\" id=\"line1Label\">{{ content('common.streetAddress') }}</label>\n                    </div>\n                    <div class=\"inputField streetNumber\" floating-label>\n                        <input type=\"text\" name=\"streetNumber\" id=\"streetNumber\" ng-pattern=\"/^(?=.*[0-9])([a-zA-Z0-9]+)$/\" ng-model=\"address.streetNumber\" value=\"\" maxlength=\"6\" ariaRequired=\"true\" autocomplete=\"off\" data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip required />\n                        <label for=\"streetNumber\" id=\"streetNumberLabel\">{{ content('common.streetNumber') }}</label>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" />\n                    <label for=\"line2\" id=\"line2Label\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential neighborhood\" floating-label>\n                    <input type=\"text\" name=\"neighborhood\" id=\"neighborhood\" ng-model=\"address.neighborhood\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" ariaRequired=\"true\" data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip required />\n                    <label for=\"neighborhood\" id=\"neighborhoodLabel\">{{ content('common.neighborhood') }}</label>\n                </div>\n                <div class=\"inputField confidential clearfix\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"  data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip required />\n                        <label for=\"city\" id=\"cityLabel\">{{ content('common.onlyCity') }}</label>\n                    </div>\n                    <div class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-options=\"state.code as state.sname for state in sortedStatesList\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"true\" required >\n                            <option value=\"\">{{ content('common.otherState') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\">{{ content('common.otherState') }}</label>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-switch-when=\"GB\">\n            <!-- start: Show all the fields for Add Address if isShowLookupFields is false -->\n            <div ng-if=\"!isShowLookupFields\">\n                <div ng-if=\"isAddressLookupEnabled\">\n                    <div ng-if=\"isShipping\" class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                    </div>\n                    <div ng-show=\"isLookupFailure\" class=\"lookupFailureMsg\">\n                        <xo-message message=\"lookupFailureMessage\"></xo-message>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line1\" floating-label>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"  data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip required />\n                    <label for=\"line1\" id=\"line1Label\">{{ content('common.streetAddress') }}</label>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" data-error-text=\"{{ content('common.valueInvalid') }}\" />\n                    <label for=\"line2\" id=\"line2Label\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential city\" floating-label>\n                    <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"  data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\">{{ content('common.onlyCity') }}</label>\n                </div>\n                <div class=\"stateZip clearfix\">\n                    <div class=\"dropdown confidential state inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\"\n                                aria-required=\"true\"\n                                ng-options=\"c.key as c.value group by c.group for c in retrieveStateNamesInGroup(['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies'])\">\n                            <option value=\"\">{{ content('common.countyOptional') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\">{{ content('common.countyOptional') }}</label>\n                    </div>\n                    <div class=\"inputField confidential postalCode\" floating-label>\n\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" value=\"\"\n                               autocapitalize=\"off\" aria-required=\"true\" ng-blur=\"zipCodeBlur()\"  ng-keypress=\"zipCodeKeyPress()\" autocomplete=\"off\" data-error-text=\"{{content('validation.validZipCode')}}\"\n                               xo-validation='{\n                                    \"validator\": \"validZip\",\n                                    \"options\": {\n                                        \"country\": \"GB\"\n                                    }\n                                }'\n                               xo-error-tooltip required />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\">{{ content('common.zip') }}</label>\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show all the fields -->\n            <!-- start: Show only the address lookup fields -->\n            <div ng-if=\"isShowLookupFields\" id=\"addressLookup\" class=\"addressLookup\">\n                <div ng-hide=\"isLookupSuccess\" id=\"addressLookupFields\"> <!-- class=\"validated\" -->\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addBillingAddress.lookupTitle') }}</span>\n                        <a class=\"editAddress\" ng-click=\"showFullAddress()\">{{content('addressBook.enterFullAddress')}}</a>\n                    </div>\n                    <div class=\"fieldGroup\">\n                        <div class=\"inputField confidential lookupZip\">\n                            <input type=\"text\" name=\"lookupZip\" id=\"lookupZip\" ng-model=\"address.postal_code\" value=\"\"\n                                   autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                                   data-error-text=\"{{content('validation.validZipCode')}}\"\n                                   xo-validation='{\n                                     \"validator\": \"validZip\",\n                                     \"options\": {\n                                       \"country\": \"GB\"\n                                     }\n                                   }'\n                                   ng-disabled=\"isLookupProcessing\" xo-error-tooltip required />\n                            <label for=\"lookupZip\" id=\"postalCodeLabel\">{{ content('common.zip') }}</label>\n                        </div>\n                    </div>\n                    <div class=\"inputField confidential houseNo\" floating-label>\n                        <input type=\"text\" id=\"houseNo\" ng-model=\"address.house_number\"\n                               value=\"\" maxlength=\"50\"\n                               autocapitalize=\"off\" aria-required=\"false\" autocomplete=\"off\"\n                               data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip\n                               ng-disabled=\"isLookupProcessing\" />\n                        <label for=\"houseNo\" id=\"houseNoLabel\">{{ content('common.houseBldgNo')}}\n                        </label>\n                    </div>\n                    <div class=\"inputField confidential buildingName\" floating-label>\n                        <input type=\"text\" id=\"buildingName\" ng-model=\"address.building_name\"\n                               value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\"\n                               data-error-text=\"{{ content('common.valueInvalid') }}\"\n                               ng-disabled=\"isLookupProcessing\" />\n                        <label for=\"buildingName\" id=\"buildingNameLabel\"\n                            {{ content('common.houseBldgName') }}\n                        </label>\n                    </div>\n                    <button track-submit ng-click=\"findAddress()\" id=\"findAddressButton\" class=\"btn full continue\"\n                            ng-class=\"{processing: isLookupProcessing}\">\n                        <div ng-show=\"isLookupProcessing\" class=\"spinner\">\n                            <p class=\"loader\" ></p>\n                        </div>\n                        <div ng-hide=\"isLookupProcessing\" class=\"text\">{{ content('addressBook.findAddress') }}</div>\n                    </button>\n                </div>\n                <div ng-show=\"isLookupSuccess\">\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                        <a class=\"editAddress\"\n                           ng-click=\"showFullAddress()\">{{ content('common.change') }}</a>\n                    </div>\n                    <div ng-if=\"isShowLookupDropDown\" id=\"lookedupDropDown\"\n                         class=\"dropdown confidential clearfix\">\n\n                        <select xo-dropdown-multiline ng-model=\"address.selectedAddress\"\n                                ng-change=\"changeAddressDropDown()\"\n                                id=\"addressDropDown\" ng-required=\"isShowLookupDropDown\">\n                            <option value=\"\" selected=\"selected\"> {{ content('addressBook.selectYourAddress',\n                                { count: lookupAddressList.length}) }}</option>\n                            <option ng-repeat=\"addr in lookupAddressList\" value=\"{{$index}}\">\n                                {{ addr.dropDownAddress }}\n                            </option>\n                        </select>\n                    </div>\n                    <div ng-hide=\"isShowLookupDropDown\" class=\"singleAddress\">\n                        {{singleAddress.displayLine1}}<br/>\n                        {{singleAddress.displayLine2}}<br/>\n                        {{singleAddress.displayLine3}}\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show only the address lookup fields -->\n        </div>\n        <!-- GB end -->\n        <!-- IE begin -->\n        <div ng-switch-when=\"IE\">\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip ng-required=\"{{layoutItem.required}}\" />\n                        <label for=\"line1\" id=\"line1Label\">{{locale.metadata.addressEntry.strings[country].line1Label}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" data-error-text=\"{{ content('common.valueInvalid') }}\" />\n                        <label for=\"line2\" id=\"line2Label\">{{locale.metadata.addressEntry.strings[country].line2Label}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip ng-required=\"{{layoutItem.required}}\" />\n                        <label for=\"city\" id=\"cityLabel\">{{locale.metadata.addressEntry.strings[country].cityLabel}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country].stateList\"\n                         class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown ng-options=\"state.$id as state.$id for state in locale.metadata.addressEntry.strings[country].stateList\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"true\" ng-required=\"{{layoutItem.required}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</label>\n                    </div>\n                    <div ng-if=\"!locale.metadata.addressEntry.strings[country].stateList\" class=\"inputField confidential state\"\n                         floating-label>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" />\n                        <label for=\"state\" id=\"stateLabel\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <div class=\"inputField confidential postalCode\" floating-label>\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" ng-blur=\"zipCodeBlur()\"  ng-keypress=\"zipCodeKeyPress()\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"  data-error-text=\"{{content('validation.validZipCode')}}\" maxlength=\"{{layoutItem.maxLength}}\" xo-error-tooltip />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\">{{ locale.metadata.addressEntry.strings[country].postcodeLabel }} </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- IE end -->\n\n        <div ng-switch-default>\n            <!-- Griffin metadata DOES exist for this country -->\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label directionality>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip ng-required=\"{{layoutItem.required}}\" />\n                        <label for=\"line1\" id=\"line1Label\">{{locale.metadata.addressEntry.strings[country].line1Label}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label directionality>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" data-error-text=\"{{ content('common.valueInvalid') }}\" />\n                        <label for=\"line2\" id=\"line2Label\">{{locale.metadata.addressEntry.strings[country].line2Label}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label directionality>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip ng-required=\"{{layoutItem.required}}\" />\n                        <label for=\"city\" id=\"cityLabel\">{{locale.metadata.addressEntry.strings[country].cityLabel}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country].stateList\"\n                         class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown ng-options=\"state.$id as state.$elt for state in locale.metadata.addressEntry.strings[country].stateList\" ng-model=\"address.state\" id=\"state\" aria-required=\"true\" ng-required=\"{{layoutItem.required}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</label>\n                    </div>\n                    <div ng-if=\"!locale.metadata.addressEntry.strings[country].stateList\" class=\"inputField confidential state\"\n                         floating-label directionality>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" />\n                        <label for=\"state\" id=\"stateLabel\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <xo-zipcode id=\"zipcode\" zip-entry=\"layoutItem\" country=\"{{country}}\"\n                                max-length=\"layoutItem.maxLength\" zip-code=\"address.postal_code\"\n                                done-fn=\"zipCodeBlur\"\n                                key-press-fn=\"zipCodeKeyPress\"\n                                zip-label=\"{{ locale.metadata.addressEntry.strings[country].postcodeLabel }}\"\n                                zip-error-text=\"{{content('validation.validZipCode')}}\"\n                                zip-required=\"layoutItem.required\"></xo-zipcode>\n                </div>\n            </div>\n            <!-- Griffin metadata DOES NOT exist for this country -->\n            <div ng-if=\"!metadata.addressEntry.layout\">\n                <div class=\"inputField confidential line1\" floating-label directionality>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip required />\n                    <label for=\"line1\" id=\"line1Label\">{{ content('common.stAddress') }}</label>\n                </div>\n\n                <div class=\"inputField confidential city\" floating-label directionality>\n                    <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-text=\"{{ content('common.valueInvalid') }}\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\">{{ content('common.otherCity') }}</label>\n                </div>\n\n                <div class=\"inputField confidential state\" floating-label directionality>\n                    <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" />\n                    <label for=\"state\" id=\"stateLabel\">{{ content('common.optionalState') }}</label>\n                </div>\n\n                <div class=\"inputField confidential postalCode\" floating-label directionality>\n                    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" value=\"\"  ng-blur=\"zipCodeBlur()\" ng-keypress=\"zipCodeKeyPress()\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-text=\"{{content('validation.validZipCode')}}\"/>\n                    <label for=\"postalCode\" id=\"zipLabel\">{{ content('common.optionalPostalCode') }}</label>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isAddPreferred\" class=\"addPreferredShipping sCheckbox checkbox\">\n        <input type=\"checkbox\" ng-model=\"address.preferred_address\" name=\"addPreferred\" id=\"addPreferred\" />\n        <label for=\"addPreferred\">{{ content('memberReview.makePreferredShipping') }}</label>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-ui-components/src/dropdown-multiline/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, $) {
	
	    squid.module('xo-dropdown-multiline.directive', ['squid']).directive('xoDropdownMultiline', function ($timeout) {
	        return {
	            restrict: 'A',
	
	            require: '?ngModel',
	
	            link: function link($scope, $select, attrs, ngModel) {
	
	                var isListVisible = false;
	                var listCreated = false;
	
	                $select = $($select);
	
	                var $span = $('<span class="custom-select" aria-hidden="true"><div class="arrow"></div><span class="innerContainer"><span></span></span></span>');
	                var $container = $('<div class="custom-select-container multiline-select-container" tabindex="0" />');
	                var $list;
	
	                function updateCover() {
	                    $timeout(function () {
	                        $span.find('span span').html($select.find('[selected]').text().replace(/\\n/gi, '<br>').trim());
	                    }, 10);
	                }
	
	                function createList($options) {
	                    if ($options.length < 2) {
	                        return;
	                    }
	
	                    function getModel() {
	                        var modelName;
	                        var model;
	                        var subParts;
	
	                        if ($select.attr('ng-options')) {
	                            modelName = $select.attr('ng-options').substring($select.attr('ng-options').indexOf('in ') + 3, $select.attr('ng-options').length);
	                        } else {
	                            var $option = $($select.find('[ng-repeat]')[0]);
	                            modelName = $option.attr('ng-repeat').substring($option.attr('ng-repeat').indexOf('in ') + 3, $option.attr('ng-repeat').length);
	                        }
	
	                        // This is to handle cases like card.billingAddress
	                        if (modelName.indexOf('.') !== -1) {
	                            subParts = modelName.split('.');
	                            model = $scope;
	
	                            for (var i = 0; i < subParts.length; i++) {
	                                model = model[subParts[i]];
	                            }
	                        } else {
	                            // And this is to handle straightforward model names
	                            model = $scope[modelName];
	                        }
	
	                        return model;
	                    }
	
	                    function hideList(event) {
	                        $list.hide();
	                        $container.append($list);
	                        isListVisible = false;
	                        $container.removeClass('open');
	                    }
	
	                    function positionList() {
	                        $list.css('left', $container.offset().left + 'px');
	                        $list.css('top', $container.offset().top + $container.height() + 'px');
	                        $list.css('width', $container.width() + 'px');
	                    }
	
	                    function setFocusOnSelected() {
	                        var $selected = $select.find('[selected]');
	
	                        if ($selected.length) {
	                            var $item = $list.find('[data-value="' + $selected.attr('value') + '"]');
	                            $item.focus();
	                        } else {
	                            $list.find('li')[0].focus();
	                        }
	                    }
	
	                    function showList() {
	                        $('body').append($list);
	                        $container.addClass('open');
	                        $list.show();
	                        positionList();
	                        isListVisible = true;
	                        setFocusOnSelected();
	                    }
	
	                    function processContainerKeypress(event) {
	                        var keyCode = event.keyCode;
	
	                        if (keyCode === 13 || keyCode === 40) {
	                            // enter or down arrow
	                            if (!isListVisible) {
	                                showList();
	                            } else {
	                                hideList();
	                                $container.focus();
	                            }
	                        } else if (keyCode === 27) {
	                            // escape
	                            if (isListVisible) {
	                                hideList();
	                                $container.focus();
	                            }
	                        }
	                    }
	
	                    if ($list) {
	                        $list.remove();
	                    }
	
	                    $list = $('<ul class="multiline-select-list" tabindex="0"></ul>');
	
	                    Array.prototype.forEach.call($options, function (option) {
	                        var $option = $(option);
	                        var value = $option.attr('value');
	                        var text = option.innerHTML.replace(/\\n/gi, '<br>');
	
	                        if (text.indexOf('content(') !== -1) {
	                            text = $scope.content(text.substring(text.indexOf('(\'') + 2, text.indexOf('\')')));
	                        }
	
	                        var html = '<li tabindex="0"';
	                        if (value !== $option.text()) {
	                            html = html + ' data-value="' + value + '"';
	                        }
	                        html = html + '>' + text + '</li>';
	                        $list.append($(html));
	                    });
	
	                    $container.append($list);
	                    $list.hide();
	
	                    $($list.find('li')).click(function (event) {
	                        var $target = $(event.target);
	                        var value = $target.data('value');
	
	                        if (typeof value !== 'undefined') {
	                            $select.find('option').removeAttr('selected');
	                            $select.find('option[value="' + value + '"]').attr('selected', 'selected');
	                            $select.find('option').removeProp('selected');
	                            $select.find('option[value="' + value + '"]').prop('selected', 'selected');
	                        } else {
	                            value = $target.html().replace(/\/<br\/>/gi, '\\n');
	                            $select.val(value);
	                        }
	
	                        if ($select.attr('ng-model')) {
	                            if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
	                                /* This parses the 'ng-options' directive and returns the options model.
	                                For example: If you have: ng-options='opt as opt.label for opt in options'
	                                Here it will parse this attribute and return 'options */
	                                var model = getModel();
	
	                                ngModel.$setViewValue(model[value]);
	                            } else {
	                                ngModel.$setViewValue(value);
	                            }
	                        }
	
	                        updateCover();
	                        hideList();
	                    });
	
	                    var $innerContainer = $container.find('.innerContainer');
	
	                    $container.click(function (event) {
	                        if (isListVisible) {
	                            hideList();
	                            $container.focus();
	                        } else {
	                            showList();
	                        }
	                    });
	
	                    $container.keydown(function (event) {
	                        processContainerKeypress(event);
	                    });
	
	                    $innerContainer.keydown(function (event) {
	                        processContainerKeypress(event);
	                    });
	
	                    $list.find('li').keydown(function (event) {
	                        var keyCode = event.keyCode;
	                        var $target = $(event.target);
	
	                        if (keyCode === 13) {
	                            // enter
	                            $target.click();
	                            event.stopPropagation();
	                        } else if (keyCode === 27) {
	                            // escape
	                            if (isListVisible) {
	                                hideList();
	                                $container.focus();
	                                event.stopPropagation();
	                            }
	                        } else if (keyCode === 40) {
	                            // down arrow
	                            if (!$target.is(':last-of-type')) {
	                                $target.next().focus();
	                                event.preventDefault();
	                                event.stopPropagation();
	                            }
	                        } else if (keyCode === 38) {
	                            // up arrow
	                            if (!$target.is(':first-of-type')) {
	                                $target.prev().focus();
	                            }
	                            event.preventDefault();
	                            event.stopPropagation();
	                        }
	                    });
	
	                    $(window).resize(function () {
	                        if (isListVisible) {
	                            positionList();
	                        }
	                    });
	
	                    $(window).bind('hashchange', function () {
	                        if (isListVisible) {
	                            hideList();
	                        }
	                    });
	
	                    $(document).click(function (event) {
	                        var $target = $(event.target);
	
	                        if (!($target.is($container) || $.contains($container.get()[0], $target.get()[0])) && isListVisible) {
	                            hideList();
	                        }
	                    });
	
	                    $container.blur(function (event) {
	                        // The setTimeout here is to ensure activeElement is set before our function executes
	                        $timeout(function () {
	                            var $newTarget = $(event.explicitOriginalTarget || document.activeElement);
	
	                            if (!($.contains($container.get()[0], $newTarget.get()[0]) || $.contains($list.get()[0], $newTarget.get()[0]))) {
	                                hideList(event);
	                            }
	                        }, 1);
	                    });
	
	                    listCreated = true;
	                    updateCover();
	                }
	
	                function render() {
	                    var options = $select.find('option');
	                    if (!listCreated) {
	                        createList(options);
	                    }
	                }
	
	                $select.wrap($container);
	                $container = $select.parent();
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseenter focus', function () {
	                    $span.addClass('active');
	                });
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseleave blur', function () {
	                    $span.removeClass('active');
	                });
	
	                $select.after($span);
	
	                $select.addClass('replaced');
	
	                $select.attr('tabindex', '-1');
	
	                if (attrs['default']) {
	                    var defaultOption = document.createElement('option');
	                    defaultOption.innerText = attrs['default'];
	                    $select.append(defaultOption);
	                }
	
	                if ($select.attr('ng-options')) {
	                    $scope.$watch(attrs.ngModel, function () {
	                        render();
	                    });
	                } else {
	                    $timeout(function () {
	                        $scope.$broadcast('pageRendered');
	                    }, 0);
	                }
	
	                $scope.$on('pageRendered', function () {
	                    render();
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-form-components/src/zipcode/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/zipcode/template.html"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	    return angular.module('xo-zipcode.directive', ['squid', 'xo-error-tooltip.directive']).directive('xoZipcode', function () {
	        return {
	            template: template,
	            scope: {
	                country: '@',
	                zipLabel: '@',
	                postalCodeLabel: '@',
	                zipErrorText: '@',
	                doneFn: '=',
	                keyPressFn: '=',
	                zipCode: '=',
	                zipEntry: '=',
	                maxLength: '='
	            },
	
	            controller: function controller($scope, $feature) {
	                var formatRegex;
	                var inputParams = $feature('zipcodeInputParams', undefined, $scope.country);
	                if (inputParams) {
	                    $scope.minLength = inputParams.minLength;
	                    $scope.maxLength = inputParams.maxLength;
	                    if (inputParams.formatPattern) {
	                        formatRegex = new RegExp(inputParams.formatPattern, 'g');
	                    }
	                }
	
	                function formatZipWithDash(zipcode, index) {
	                    if (zipcode.length > index) {
	                        zipcode = [zipcode.slice(0, index), '-', zipcode.slice(index)].join('');
	                    }
	                    return zipcode;
	                }
	
	                $scope.changeZip = function (zipcode) {
	                    if (zipcode) {
	
	                        if (formatRegex) {
	                            zipcode = zipcode.replace(formatRegex, '');
	                        }
	
	                        if (inputParams && inputParams.formatZip) {
	                            zipcode = formatZipWithDash(zipcode, inputParams.minLength);
	                        }
	
	                        $scope.zipCode = zipcode;
	                    }
	                };
	
	                $scope.doneFunction = function () {
	                    if ($scope.doneFn) {
	                        $scope.doneFn();
	                    }
	                };
	
	                $scope.keyPressHandler = function (event) {
	                    if ($scope.keyPressFn) {
	                        $scope.keyPressFn(event);
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/zipcode/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"zipField\" class=\"inputField confidential postalCode\" floating-label directionality content>\n    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"zipCode\"\n       autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" ng-change=\"changeZip(zipCode)\" xo-validation='{\"validator\": \"validZip\"}'\n       minlength=\"{{minLength}}\" maxlength=\"{{maxLength}}\" ng-blur=\"doneFunction()\" ng-keypress=\"keyPressHandler($event)\"\n       data-error-text=\"{{zipErrorText}}\" xo-error-tooltip ng-required=\"{{zipRequired}}\"/>\n    <label for=\"postalCode\" id=\"postalCodeLabel\" >{{zipLabel}}</label>\n</div>\n\n"

/***/ },

/***/ "./components/xo-address-components/src/address-normalization/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-address-components/src/address-normalization/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-address-normalization.route', ['squid', 'xo-address-normalization.directive']).factory('$AddressNormalizationRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddressNormalizationRoute', {
	
	            name: 'addressNormalization',
	            titleContent: 'addressNormalization.addressmatch',
	            directive: 'xo-address-normalization',
	            trackingData: {
	                fptiState: 'address_normalization'
	            },
	            loginRequired: true,
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-address-components/src/address-normalization", "components/xo-address-components/src/address-normalization/route.js"))

/***/ },

/***/ "./components/xo-address-components/src/address-normalization/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-address-components/src/address-normalization/template.html"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-address-normalization.directive', ['squid', 'xomodel.address', 'xo-aside-header.directive', 'xomodel.address', 'xo-tray-height.directive']).directive('xoAddressNormalization', function () {
	        return {
	            template: template,
	            scope: {
	                id: '=',
	                address: '=',
	                doneFn: '=',
	                sidebar: '=',
	                hideBackButton: '='
	            },
	            controller: function controller($scope, $populate, $feature, $util, $AddressNormalizationModel, $timeout) {
	                $util.assert($scope.address, 'Original Address cannot be empty');
	
	                $scope.showNormalization = false;
	
	                var normalize = $feature('addressNormalization', false, $scope.address.country);
	                if (!normalize) {
	                    $scope.doneFn($scope.address, false);
	                    return;
	                }
	
	                var userEnteredAddress;
	                var addrFormat = $feature('FormatAddressForNormalization', $scope.address.country, $scope.address.country);
	
	                $scope.addressSelected = 'normalizedAddress';
	                $scope.transitionName = 'address_normalization_normalizedAddress';
	
	                // Brazil specific format
	                if (addrFormat === 'AddressBR') {
	                    userEnteredAddress = angular.fromJson(angular.toJson($scope.address));
	                    userEnteredAddress.line1 = $scope.address.line1 + '  ' + $scope.address.streetNumber;
	                    userEnteredAddress.line2 = $scope.address.neighborhood;
	                }
	
	                $scope.servAddress = userEnteredAddress ? userEnteredAddress : $scope.address;
	                $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';
	
	                $scope.addressNormalization = new $AddressNormalizationModel({
	                    id: $scope.id,
	                    address: $scope.servAddress
	                });
	
	                function centerLightBox() {
	                    var element = $('#lbox');
	                    if (!element.length) {
	                        return;
	                    }
	
	                    var windowElement = $(window);
	                    var lboxContainerElem = $('#lboxContainer');
	                    element.css('top', Math.max(0, (windowElement.height() - element.outerHeight()) / 2) + 'px');
	                    element.css('width', '65%');
	                    var computedLeft = (windowElement.width() - element.outerWidth()) / 2;
	                    var leftBound = lboxContainerElem.offset().left + lboxContainerElem.width() * 0.1;
	                    var elementLeft = computedLeft < leftBound ? leftBound : computedLeft;
	                    if (computedLeft < leftBound) {
	                        element.css('width', lboxContainerElem.width() * 0.8);
	                    }
	                    element.css('left', Math.max(0, elementLeft) + 'px');
	                    return element;
	                }
	
	                function trinityResponseCallback() {
	                    $scope.showNormalization = true;
	
	                    // default behavior of $timeout with no 2nd param is to wait for dom to finish rendering before executing callback
	                    $timeout(function () {
	                        centerLightBox();
	                        $(window).resize(centerLightBox);
	                    });
	                }
	
	                $scope.addressNormalization.save({
	                    data: $scope.addressNormalization,
	
	                    contingencies: {
	                        VALIDATION_ERROR: function VALIDATION_ERROR() {
	                            trinityResponseCallback();
	                            $scope.transitionName = 'address_normalization_enteredAddress';
	                            return;
	                        }
	                    },
	
	                    success: function success(result) {
	                        trinityResponseCallback();
	                        if (result === false) {
	                            // trinity doesn't find any match
	                            $scope.transitionName = 'address_normalization_enteredAddress';
	                            return;
	                        }
	                        $scope.normalizedAddress = result;
	                        $scope.normalizedAddress.normalization_status = 'NORMALIZED';
	
	                        if (addrFormat === 'AddressBR') {
	                            $scope.normalizedAddress.line1 = $scope.normalizedAddress.streetName + '  ' + $scope.normalizedAddress.streetNumber;
	                            $scope.normalizedAddress.line2 = $scope.normalizedAddress.neighborhood;
	                        }
	
	                        // if the two addresses equal, no need to show the panel
	                        if ($scope.isEqual($scope.normalizedAddress, $scope.servAddress)) {
	                            if ($scope.servAddress.preferred_address) {
	                                $scope.normalizedAddress.preferred_address = true;
	                            }
	
	                            if (addrFormat === 'AddressBR' && $scope.address.line2) {
	                                $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + ' ' + $scope.address.line2;
	                            }
	                            $scope.callback($scope.normalizedAddress, false);
	                        } else if (addrFormat === 'AddressBR' && $scope.address.line2) {
	                            $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + ' ' + $scope.address.line2;
	                        }
	                    },
	
	                    error: trinityResponseCallback
	                });
	
	                // make space and case insensitive. sub empty vals for undefined.
	                function desensitizedAddress(addr) {
	                    for (var key in addr) {
	                        var val = addr[key];
	                        if (addr.hasOwnProperty(key)) {
	                            if (val && val.length) {
	                                addr[key] = val.trim().toLowerCase();
	                            } else {
	                                addr[key] = undefined;
	                            }
	                        }
	                    }
	                    return addr;
	                }
	
	                // check if the two address are the same
	                $scope.isEqual = function (address1, address2) {
	                    var addressOne = desensitizedAddress(JSON.parse(JSON.stringify(address1)));
	                    var addressTwo = desensitizedAddress(JSON.parse(JSON.stringify(address2)));
	
	                    if (!addressOne || !addressTwo) {
	                        return false;
	                    }
	
	                    return addressOne.line1 === addressTwo.line1 && addressOne.line2 === addressTwo.line2 && addressOne.city === addressTwo.city && addressOne.state === addressTwo.state && addressOne.postal_code === addressTwo.postal_code && addressOne.country === addressTwo.country;
	                };
	
	                // Australia displays address line2 first
	                $scope.isLine2First = function () {
	                    return $scope.address.country === 'AU';
	                };
	
	                $scope.onBack = function () {
	                    $scope.callback($scope.address, true);
	                };
	
	                $scope.selection = function (value) {
	                    $scope.transitionName = 'address_normalization_' + value;
	                };
	
	                $scope.onContinue = function () {
	                    $scope.addressSelected = $scope.addressNormalizationForm.addressSelected;
	
	                    if ($scope.addressSelected && $scope.addressSelected.$modelValue === 'normalizedAddress') {
	                        if ($scope.servAddress.preferred_address) {
	                            $scope.normalizedAddress.preferred_address = true;
	                        }
	                        $scope.callback($scope.normalizedAddress, false);
	                    } else {
	                        $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';
	                        if (addrFormat === 'AddressBR' && $scope.address.line2) {
	                            $scope.servAddress.line1 = $scope.servAddress.line1 + ' ' + $scope.address.line2;
	                        }
	                        $scope.callback($scope.servAddress, false);
	                    }
	                };
	
	                $scope.callback = function (address, isBack) {
	                    $scope.doneFn(address, isBack);
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-address-components/src/address-normalization/template.html":
/***/ function(module, exports) {

	module.exports = "<div ng-show=\"showNormalization\" content id=\"addressNormalization\" xo-tray-height>\n    <xo-aside-header heading='asideHeader.selectNormalizedAddress' hidex='true' ng-if=\"sidebar\"></xo-aside-header>\n    <div class=\"asideContent\">\n    <form method=\"post\" class=\"formSmall asideView container\" novalidate=\"novalidate\" name=\"addressNormalizationForm\">\n        <div ng-if=\"normalizedAddress\">\n            <h2 class=\"gamma\">{{ content('addressNormalization.title') }}</h2>\n            <p class=\"theta\">{{ content('addressNormalization.intro') }}</p>\n            <div class=\"normalizedAdrSection radio\">\n                <p class=\"theta\" data-ng-bind-html=\"htmlContent('addressNormalization.addressmatch')\"></p>\n                <label class=\"noBottom narrow addrLabel row-fluid\">\n                    <input type=\"radio\" id=\"defaultAddress\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"normalizedAddress\" ng-click=\"selection('normalizedAddress')\" class=\"addrRadio span2\" checked=\"true\">\n                    <div class=\"adr span20\">\n                        <div class=\"confidential streets street-address\">\n                            <div ng-if=\"normalizedAddress.line2\">{{normalizedAddress.line1}}, {{normalizedAddress.line2}},</div>\n                            <div ng-if=\"!normalizedAddress.line2\">{{normalizedAddress.line1}},</div>\n                        </div>\n                        <div class=\"confidential\">\n                            <span class=\"locality\">{{normalizedAddress.city}}</span>, <span class=\"state\">{{normalizedAddress.state}}</span>\n                            <span class=\"postal-code adr-break\">{{normalizedAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                        </div>\n                    </div>\n                </label>\n            </div>\n            <div class=\"enteredAddrSection radio subContainer\">\n                <p class=\"addressNormalizationIntro\" data-ng-bind-html=\"htmlContent('addressNormalization.addressenter')\"></p>\n\n                <label class=\"noBottom narrow addrLabel row-fluid\">\n                    <input type=\"radio\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"enteredAddress\" ng-click=\"selection('enteredAddress')\" class=\"addrRadio span2\">\n                    <div class=\"adr span20\">\n                        <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                            <div ng-if=\"servAddress.line2\">{{servAddress.line2}}, </div>{{servAddress.line1}},\n                        </div>\n                        <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                            <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}},</div>\n                            <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}},</div>\n                        </div>\n                        <div class=\"confidential\">\n                            <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                            <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                        </div>\n                    </div>\n                </label>\n            </div>\n        </div>\n        <div ng-if=\"!normalizedAddress\">\n            <h2 class=\"gamma\">{{ content('addressNormalization.noaddressmatchTitle') }}</h2>\n            <p class=\"theta\">{{ content('addressNormalization.noaddressmatchMsg') }}</p>\n            <input type=\"hidden\" name=\"addressdisplay\" value=\"enteredAddress\">\n            <div class=\"enteredAddrSection subContainer\">\n                <p class=\"theta\">{{ content('addressNormalization.addressyouenter') }}</p>\n                <div class=\"adr\">\n                    <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                        {{servAddress.line2}} {{servAddress.line1}},\n                    </div>\n                    <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                        <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}}</div>\n                        <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}}</div>\n                    </div>\n                    <div class=\"confidential\">\n                        <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                        <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"buttons\" ng-if=\"!hideBackButton\">\n            <input id=\"back\" type=\"submit\" value=\"{{ content('common.back') }}\" class=\"btn firstHalf btn-secondary\" ng-click=\"onBack()\" >\n            <input track-submit=\"{{transitionName}}\" id=\"continue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn secondHalf\" ng-click=\"onContinue()\">\n        </div>\n        <div class=\"buttons\" ng-if=\"hideBackButton\">\n            <input track-submit=\"{{transitionName}}\" id=\"fullContinue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-click=\"onContinue()\">\n        </div>\n    </form>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/addCep/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addCep/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-card.addcep.route', ['squid', 'xo-add-card.addcep.directive']).factory('$AddCepRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddCepRoute', {
	
	            name: 'addCep',
	            directive: 'xo-add-cep',
	            titleContent: 'addBillingAddress.title',
	            loginRequired: true,
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card/addCep", "components/xo-wallet-components/src/add-card/addCep/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/addCep/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addCep/template.html"), __webpack_require__("./components/angular-ui-utils/ui-utils.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-form-components/src/zipcode/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	    return angular.module('xo-add-card.addcep.directive', ['squid', 'xomodel.address', 'ui.validate', 'xo-zipcode.directive']).directive('xoAddCep', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                sidebar: '=',
	                prefillAddress: '=',
	                doneFn: '='
	            },
	
	            controller: function controller($scope, $populate, $state, $PrefillAddressModel, $locale) {
	                $scope.country = $locale.country;
	
	                $scope.onSubmit = function () {
	                    $scope.prefillAddress.address = {
	                        country: $locale.country,
	                        postal_code: $scope.postal_code
	                    };
	
	                    $scope.prefillAddress.save({
	                        data: $scope.prefillAddress,
	
	                        success: function success(result) {
	                            $scope.prefillAddress.address = result;
	                            $scope.doneFn();
	                        }
	                    });
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addCep/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n<h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar\">{{ content('addBillingAddress.title') }}</h1>\n\n<form id=\"cepForm\" name=\"cepForm\" class=\"asideView addressForm\" content novalidate>\n    <div class=\"trayInner container\">\n        <xo-zipcode id=\"zipcode\" country=\"{{country}}\" zip-code=\"postal_code\" zip-label=\"{{content('common.cep')}}\"\n                    zip-error-text=\"{{content('common.valueInvalid')}}\"></xo-zipcode>\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\"\n                   value=\"{{ content('common.continueLabel') }}\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n        </div>\n    </div>\n</form>\n\n"

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/add-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/add-shipping/directive.js"), __webpack_require__("./components/xo-address-components/src/address-normalization/route.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/shipping-address/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-shipping.route', ['squid', 'xo-shipping-address.directive', 'xo-add-address.directive', 'xo-address-normalization.route']).factory('$AddShippingRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddShippingRoute', {
	            name: 'addShipping',
	            directive: 'xo-add-shipping',
	            titleContent: 'addShipping.addAddress',
	            trackingData: {
	                fptiState: 'add_shipping'
	            },
	            loginRequired: true,
	            children: [{
	                name: '$AddressNormalizationRoute',
	                attributes: {
	                    id: 'token',
	                    sidebar: 'sidebar',
	                    address: 'address',
	                    'done-fn': 'uponNormalization'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-member-components/src/select-shipping/add-shipping", "components/xo-member-components/src/select-shipping/add-shipping/route.js"))

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/add-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/add-shipping/template.html"), __webpack_require__("./components/xo-member-components/src/select-shipping/shipping-address/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-select-shipping.add-shipping.directive', ['squid', 'xo-shipping-address.directive']).directive('xoAddShipping', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                auth: '=',
	                token: '=',
	                doneFn: '=',
	                sidebar: '=',
	                update: '='
	            },
	
	            controller: function controller($scope) {}
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/add-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-shipping-address token=\"token\" done-fn=\"doneFn\" sidebar=\"sidebar\"></xo-shipping-address>\n"

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/shipping-address/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/shipping-address/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-form-components/src/select-shipping-country/directive.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-form-components/src/zipcode/directive.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-select-shipping.xo-shipping-address.directive', ['squid', 'xomodel.address', 'xomodel.checkout', 'xo-add-address.directive', 'xo-select-shipping-country.directive', 'xo-tray-height.directive', 'xo-error-tooltip.directive', 'xo-dropdown.directive', 'xo-message.directive', 'xo-zipcode.directive', 'xo-accessibility.directive']).directive('xoShippingAddress', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                auth: '=',
	                token: '=',
	                doneFn: '=',
	                sidebar: '=',
	                update: '='
	            },
	
	            controller: function controller($scope, $populate, $element, $timeout, $ShippingAddressModel, $CheckoutSessionModel, $logger, $PrefillAddressModel, $CheckoutAppDataModel, $state, $config, $locale, $feature, $renderContent) {
	
	                if (!$scope.sidebar) {
	                    $scope.pageTitle = $renderContent('addShipping.addAddress');
	                }
	
	                $scope.buttonLabel = function () {
	                    if (!$scope.sidebar || $scope.address.country === 'BR' && !$scope.prefilled) {
	                        return $renderContent('common.continueLabel');
	                    } else {
	                        return $renderContent('common.save');
	                    }
	                };
	
	                $scope.address = {
	                    country: $locale.getCountryCodeISO()
	                };
	                $scope.isShipping = true;
	                $scope.normalize = function () {
	                    return $feature('shippingAddressNormalization') && $scope.address.country === $locale.country // Should be domestic address
	                    && !$scope.normalized;
	                };
	
	                $scope.showshipping = true;
	                $scope.country = $locale.country;
	                $scope.recipient = {
	                    first_name: '',
	                    last_name: ''
	                };
	
	                var $el = $($element);
	
	                function focusFirstError() {
	                    $el.find('form').find('.backendError, .ng-invalid').first().focus();
	                }
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(function () {
	                    var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
	                    var contingencyPrefilledAddress;
	
	                    if ($feature('supportBlockNonDomesticShipping', false, merchantCountry)) {
	
	                        $scope.disableChangeShippingCountry = $scope.checkoutAppData.get('flags.block_non_domestic_shipping', false);
	
	                        if ($scope.disableChangeShippingCountry) {
	
	                            $scope.address.country = merchantCountry;
	
	                            contingencyPrefilledAddress = $scope.checkoutSession.get('errorData.resolution.data', null);
	                            if (!$scope.sidebar && contingencyPrefilledAddress) {
	                                angular.extend($scope.address, {
	                                    line1: contingencyPrefilledAddress.line1,
	                                    line2: contingencyPrefilledAddress.line2,
	                                    city: contingencyPrefilledAddress.city,
	                                    state: contingencyPrefilledAddress.state,
	                                    postal_code: contingencyPrefilledAddress.postal_code
	                                });
	                            }
	
	                            $logger.info('member_block_non_domestic_shipping', {
	                                block_non_domestic_shipping: $scope.disableChangeShippingCountry,
	                                sidebar: $scope.sidebar
	                            });
	
	                            var countryName = $renderContent('shippingCountry.' + merchantCountry);
	                            var infoMessage = $renderContent('largeScreenPayment.blockNonDomesticShippingAlert', {
	                                shippingCountry: countryName
	                            });
	                            $scope.message = {
	                                msgs: [infoMessage],
	                                type: 'warning'
	                            };
	                        }
	                    }
	
	                    $scope.prefill = function () {
	                        $scope.prefillAddress = new $PrefillAddressModel({
	                            id: $scope.token,
	                            address: {
	                                country: $locale.country,
	                                postal_code: $scope.address.postal_code
	                            }
	                        });
	
	                        $scope.prefillAddress.save({
	                            data: $scope.prefillAddress,
	
	                            success: function success(result) {
	                                if (result) {
	                                    $scope.address = result;
	                                }
	                                $scope.prefilled = true;
	                                $scope.address.first_name = $scope.recipient.first_name;
	                                $scope.address.last_name = $scope.recipient.last_name;
	
	                                $timeout(function () {
	                                    var value = $scope.address.state;
	
	                                    var $option = $el.find('[value="' + value + '"]');
	                                    $option.prop('selected', 'selected');
	                                    $option.trigger('change');
	
	                                    value = $option.attr('label');
	                                    focusFirstError();
	                                }, 1000);
	                            }
	                        });
	                    };
	
	                    if ($scope.update) {
	                        if ($scope.checkoutSession.shipping.name) {
	                            var name = $scope.checkoutSession.shipping.name.trim();
	                            var index = name.indexOf(' ');
	                            $scope.recipient.first_name = name.substr(0, index);
	                            $scope.recipient.last_name = name.substr(index + 1);
	                        }
	                        $scope.address.postal_code = $scope.checkoutSession.get('shipping.postal_code', '');
	                        $scope.prefill();
	                    }
	
	                    function handleValidation(res) {
	                        if (res && res.fields && res.fields.length) {
	                            res.fields.forEach(function (field) {
	                                if (field.field) {
	                                    var $field = $($el.find('[ng-model="address.' + field.field + '"]'));
	                                    if ($field.length === 0 && field.field === 'zip') {
	                                        $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
	                                    }
	                                    $field.addClass('backendError');
	                                    $field.attr('aria-invalid', true);
	                                }
	                            });
	                            focusFirstError();
	                        }
	                    }
	
	                    $scope.cancelFn = function () {
	                        $state.go('checkout.review.sidebar.shipping');
	                    };
	
	                    $scope.onSubmit = function () {
	                        if ($scope.address.country === 'BR' && $scope.address.country === $locale.country && !$scope.prefilled) {
	                            return $scope.prefill();
	                        }
	
	                        if ($scope.normalize()) {
	                            $scope.showshipping = false;
	                            $state.go('.addressNormalization');
	                        } else {
	                            $scope.submitAddress();
	                        }
	                    };
	
	                    $scope.removeValidation = function () {
	                        $el.find('form').removeClass('validated');
	                    };
	
	                    function prefilledAddressUnchanged(prefilledAddress, addressToSubmit) {
	
	                        function lowercaseEquals(str1, str2) {
	                            return angular.lowercase(str1) === angular.lowercase(str2);
	                        }
	
	                        return lowercaseEquals(prefilledAddress.recipient_name, addressToSubmit.recipient_name) && lowercaseEquals(prefilledAddress.line1, addressToSubmit.line1) && lowercaseEquals(prefilledAddress.line2, addressToSubmit.line2) && lowercaseEquals(prefilledAddress.city, addressToSubmit.city) && lowercaseEquals(prefilledAddress.state, addressToSubmit.state) && lowercaseEquals(prefilledAddress.postal_code, addressToSubmit.postal_code) && lowercaseEquals(prefilledAddress.country_code, addressToSubmit.country);
	                    }
	
	                    $scope.submitAddress = function () {
	
	                        if ($scope.address.preferred_address) {
	                            $logger.info('addAddrPreferred.selected', {});
	                        }
	
	                        var country = $scope.address.country;
	                        var recipient_name = $scope.address.first_name + ' ' + $scope.address.last_name;
	                        if ($feature('nameFormat', country, country) === 'LastFirst') {
	                            recipient_name = $scope.address.last_name + ' ' + $scope.address.first_name;
	                        }
	
	                        var data = {
	                            recipient_name: recipient_name,
	                            line1: $scope.address.line1,
	                            line2: $scope.address.line2,
	                            city: $scope.address.city,
	                            state: $scope.address.state,
	                            postal_code: $scope.address.postal_code,
	                            country: country,
	                            normalization_status: $scope.address.normalization_status,
	                            preferred_address: $scope.address.preferred_address,
	                            default_address: true
	                        };
	
	                        if (contingencyPrefilledAddress && prefilledAddressUnchanged(contingencyPrefilledAddress, data)) {
	                            data.address_id = contingencyPrefilledAddress.id;
	                        }
	                        // Update is used for the address normalization flow.
	                        data.address_id = data.address_id ? data.address_id : $scope.checkoutSession.get('shipping.id');
	                        if ($scope.update && data.address_id) {
	                            updateAddress(data);
	                        } else {
	                            addAddress(data);
	                        }
	                    };
	
	                    function updateAddress(payload) {
	                        $scope.checkoutSession.shipping.action('update', {
	                            data: payload,
	
	                            resultModel: $scope.checkoutSession,
	
	                            success: function success(result) {
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['smallToolTip.addressAdded']
	                                };
	
	                                $scope.doneFn();
	                            },
	
	                            validation: function validation(res) {
	                                handleValidation(res);
	                            }
	                        });
	                    }
	
	                    function addAddress(payload) {
	                        // make sure this param is not passed as behavior from symphony is erratic. 
	                        delete payload.address_id;
	
	                        $scope.shippingAddress = $ShippingAddressModel.create($scope.token, payload);
	
	                        $scope.shippingAddress.save({
	                            data: payload,
	
	                            resultModel: $scope.checkoutSession,
	
	                            success: function success(result) {
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['smallToolTip.addressAdded']
	                                };
	                                $scope.doneFn();
	                            },
	
	                            validation: function validation(res) {
	                                handleValidation(res);
	                            }
	                        });
	                    }
	
	                    $scope.uponNormalization = function (normalizedAddress, isBack) {
	                        if (isBack) {
	                            $scope.normalized = false;
	                            $scope.showshipping = true;
	                            $state.go('^');
	                        } else {
	                            $scope.address = normalizedAddress;
	                            $scope.normalized = true;
	                            $scope.address.first_name = $scope.recipient.first_name;
	                            $scope.address.last_name = $scope.recipient.last_name;
	                            $scope.submitAddress();
	                        }
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/shipping-address/template.html":
/***/ function(module, exports) {

	module.exports = "<div ng-class=\"{'aside': sidebar, 'fullpage': !sidebar}\" id=\"addShipping\" modal-box modal-refresh-on=\"'metadataChange'\" modal-cancel=\"cancelFn()\">\n    <div ng-if=\"showshipping\">\n    <xo-aside-header ng-if=\"!update && sidebar\" back-url=\"checkout.review.sidebar.shipping\" heading='asideHeader.addShipping'></xo-aside-header>\n    <xo-aside-header ng-if=\"update && sidebar\" back-url=\"checkout.review.sidebar.shipping\"\n                     heading='addressNormalization.update'></xo-aside-header>\n\n    <div class=\"container\" ng-class=\"{'asideContent': sidebar}\" xo-tray-height>\n\n        <xo-message ng-if=\"message\" message=\"message\"></xo-message>\n        <h1 class=\"gamma\" ng-if=\"pageTitle\">{{ pageTitle }}</h1>\n\n        <div ng-if=\"update\" content>\n            <p class=\"theta\">{{ content('addressNormalization.updateIntro') }}</p>\n        </div>\n\n            <form id=\"shippingAddressForm\" name=\"shippingAddressForm\" class=\"asideView addressForm\"\n                  content novalidate form-autofocus>\n\n                <div ng-if=\"!update\">\n                    <xo-select-shipping-country shipping-address=\"address\"\n                                                disable-change-shipping-country=\"disableChangeShippingCountry\"\n                                                token=\"token\" ng-click=\"removeValidation()\"></xo-select-shipping-country>\n                </div>\n\n                <div ng-if=\"prefilled || address.country!=='BR'\">\n                    <xo-add-address country=\"address.country\" address=\"address\" is-shipping=\"true\"\n                                    token=\"token\"></xo-add-address>\n                </div>\n\n                <div ng-if=\"!prefilled && address.country==='BR'\">\n                    <xo-name-input user=\"recipient\"></xo-name-input>\n                    <xo-zipcode country=\"{{address.country}}\" zip-code=\"address.postal_code\" zip-label=\"{{content('common.cep')}}\"\n                                zip-error-text=\"{{content('common.valueInvalid')}}\"></xo-zipcode>\n                </div>\n                <div class=\"buttons\">\n                    <input track-submit type=\"submit\" id=\"proceedButton\"\n                           type=\"submit\" value=\"{{buttonLabel()}}\" class=\"btn full\"  validate-submit=\"onSubmit()\"/>\n                </div>\n\n            </form>\n        </div>\n\n    </div>\n    <div ui-view></div>\n</div>\n\n"

/***/ },

/***/ "./components/xo-form-components/src/select-shipping-country/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/select-shipping-country/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-models/src/app/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return angular.module('xo-select-shipping-country.directive', ['squid', 'xomodel.app', 'xomodel.checkout', 'xo-dropdown.directive', 'xo-error-tooltip.directive']).directive('xoSelectShippingCountry', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                shippingAddress: '=',
	                disableChangeShippingCountry: '='
	            },
	
	            controller: function controller($rootScope, $scope, $populate, $locale, $LocaleConfigModel, $CheckoutAppDataModel) {
	
	                var defaultCountry = $scope.shippingAddress && $scope.shippingAddress.country || $locale.country;
	
	                var countries = $locale.content.get('countryList', {});
	                var countryList = [];
	
	                function insertDefaultCountryTop() {
	                    countryList.unshift({
	                        key: defaultCountry,
	                        value: countries[defaultCountry]
	                    });
	                }
	
	                insertDefaultCountryTop();
	
	                $scope.countryList = countryList;
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                }).then(function () {
	                    return $populate($scope, {
	                        localeConfigModel: $LocaleConfigModel.instance($scope.checkoutAppData.merchant.merchant_country)
	                    }).then(function () {
	
	                        var shippingCountries = $scope.localeConfigModel && $scope.localeConfigModel.xBorderCountries;
	
	                        function getSortedCountryList() {
	                            countries = $locale.content.get('countryList', {});
	                            countryList = [];
	
	                            angular.forEach(shippingCountries, function (shippingCountry) {
	                                if (shippingCountry && angular.isString(shippingCountry)) {
	                                    var countryCode = shippingCountry.split(',')[0];
	                                    if (countryCode && countryCode !== defaultCountry && countries[countryCode]) {
	                                        countryList.push({
	                                            key: countryCode,
	                                            value: countries[countryCode]
	                                        });
	                                    }
	                                }
	                            });
	
	                            countryList.sort(function (a, b) {
	                                return a.value.localeCompare(b.value);
	                            });
	
	                            insertDefaultCountryTop();
	                            $scope.countryList = countryList;
	                        }
	
	                        $scope.$on('contentChange', getSortedCountryList);
	
	                        getSortedCountryList();
	                    });
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/select-shipping-country/template.html":
/***/ function(module, exports) {

	module.exports = "<span id=\"selectShippingCountry\" feature=\"changeShippingCountry\">\n    <div class=\"dropdown confidential country clearfix inputField\"\n         ng-class=\"{'disabled': disableChangeShippingCountry}\" content floating-label-dropdown>\n        <select xo-dropdown name=\"country\" ng-change=\"chooseCountry()\" ng-model=\"shippingAddress.country\" ng-options=\"country.key as country.value for country in countryList\" id=\"country\" aria-labelledby=\"countryLabel\" xo-error-tooltip required ng-disabled=\"disableChangeShippingCountry\">\n        </select>\n        <label for=\"country\" id=\"countryLabel\">{{ content('common.country') }}</label>\n    </div>\n</span>\n"

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/delete-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/delete-shipping/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-select-shipping.xo-delete-shipping.route', ['squid', 'xo-select-shipping.xo-delete-shipping.directive']).factory('$DeleteShippingRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('DeleteShippingRoute', {
	            name: 'deleteShipping',
	            directive: 'xo-delete-shipping',
	            titleContent: 'asideHeader.deleteShipping',
	            trackingData: {
	                fptiState: 'delete_shipping'
	            },
	            loginRequired: true,
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-member-components/src/select-shipping/delete-shipping", "components/xo-member-components/src/select-shipping/delete-shipping/route.js"))

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/delete-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/delete-shipping/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-address-components/src/address-display/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-select-shipping.xo-delete-shipping.directive', ['squid', 'xomodel.checkout', 'xo-address-display.directive', 'xo-aside-header.directive', 'xo-tray-height.directive', 'xo-accessibility.directive']).directive('xoDeleteShipping', function () {
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                sidebar: '='
	            },
	            controller: function controller($scope, $log, $populate, $state, $rootScope, $timeout, $CheckoutShippingAddressesModel) {
	
	                var contingencyMapping = {
	                    RISK_CHECK_FAILED: 'deleteShipping.genericError',
	                    ADDRESS_ALREADY_REMOVED: 'deleteShipping.genericError',
	                    ADDRESS_CANNOT_REMOVE_PRIMARY: 'deleteShipping.primaryOrBillingAddress',
	                    ADDRESS_CANNOT_REMOVE_BILLING: 'deleteShipping.primaryOrBillingAddress',
	                    ADDRESS_CANNOT_REMOVE_SELECTED: 'deleteShipping.selectedAddress',
	                    ACCOUNT_NEGATIVE_BALANCE: 'deleteShipping.genericError',
	                    ADDRESS_CANNOT_REMOVE: 'deleteShipping.genericError'
	                };
	
	                function isPrimaryOrSelected(address) {
	                    return address.primary_address || address.default_address;
	                }
	
	                function removeAddress(address) {
	                    $('#deleteShipping .address' + address.idx).addClass('collapse');
	                    $timeout(function () {
	                        $scope.checkoutShippingAddresses.addresses = $scope.checkoutShippingAddresses.addresses.filter(function (item) {
	                            return item.id !== address.id;
	                        });
	                        $scope.$broadcast('addressUpdated');
	                    }, 600);
	                }
	
	                $populate($scope, {
	                    checkoutShippingAddresses: $CheckoutShippingAddressesModel.instance($scope.token)
	                }).then(function () {
	                    $scope.checkoutShippingAddresses.addresses.forEach(function (address, index) {
	                        address.showDelete = address.isDeletable = !isPrimaryOrSelected(address);
	                        address.idx = index;
	                    });
	                    $scope.$broadcast('addressUpdated');
	                });
	
	                $scope.backUrl = 'checkout.review.sidebar.shipping';
	
	                // Return on modal cancel
	                $scope.goBack = function () {
	                    $state.go($scope.backUrl);
	                };
	
	                // Needed the three variables for animating buttons slide in/out
	                $scope.onDelete = function (address) {
	                    address.showConfirm = true;
	                    $scope.checkoutShippingAddresses.addresses.filter(function (item) {
	                        if (item.deleteClicked) {
	                            $('#deleteShipping .address' + item.idx + ' .address').removeClass('slide');
	                            $('#deleteShipping .address' + item.idx + ' .confirm').removeClass('slidein');
	                            item.showDelete = true;
	                            $timeout(function () {
	                                item.deleteClicked = false;
	                                item.showConfirm = false;
	                                $('#deleteShipping .address' + item.idx + ' .delete:not(.confirm)').removeClass('slideOut');
	                            }, 500);
	                        }
	                    });
	
	                    address.deleteClicked = true;
	                    $('#deleteShipping .address' + address.idx + ' .delete:not(.confirm)').addClass('slideOut');
	                    $timeout(function () {
	                        $('#deleteShipping .address' + address.idx + ' .confirm').addClass('slidein');
	                        $('#deleteShipping .address' + address.idx + ' .address').addClass('slide');
	                        address.showDelete = false;
	                    });
	                    // Focus the confirm link when it comes into view after the css animation
	                    $timeout(function () {
	                        $('#deleteShipping .address' + address.idx + ' .confirmBtn').focus();
	                    }, 500);
	                };
	
	                $scope.showDelete = function (address) {
	                    return address.isDeletable && address.showDelete;
	                };
	
	                $scope.showConfirmDelete = function (address) {
	                    return address.isDeletable && address.showConfirm;
	                };
	
	                $scope.showInfoMsgIcon = function (address) {
	                    return isPrimaryOrSelected(address) && !address.contingencyInfoMsgKey;
	                };
	
	                $scope.showInfoMessage = function (address) {
	                    if (address.default_address) {
	                        address.contingencyInfoMsgKey = contingencyMapping.ADDRESS_CANNOT_REMOVE_SELECTED;
	                    } else if (address.primary_address) {
	                        address.contingencyInfoMsgKey = contingencyMapping.ADDRESS_CANNOT_REMOVE_PRIMARY;
	                    }
	                    // Expand the info message and focus on the first delete link to keep focus within form
	                    $timeout(function () {
	                        $('#deleteShipping .address' + address.idx + ' .msg-inline').addClass('expand');
	                        $('#deleteShipping .deleteBtn').first().focus();
	                    });
	                };
	
	                $scope.onConfirmDelete = function (address) {
	                    address.action('delete', {
	                        success: function success() {
	                            removeAddress(address);
	                        },
	                        contingencies: {
	                            DEFAULT: function DEFAULT(name) {
	                                if (name === 'ADDRESS_ALREADY_REMOVED') {
	                                    removeAddress(address);
	                                    return;
	                                }
	
	                                address.isDeletable = false;
	                                address.contingencyErrorMsgKey = contingencyMapping[name] || contingencyMapping.ADDRESS_CANNOT_REMOVE;
	                                $('#deleteShipping .address' + address.idx + ' .address').removeClass('slide');
	                                $('#deleteShipping .address' + address.idx + ' .address').addClass('slideFast');
	                                $timeout(function () {
	                                    $('#deleteShipping .address' + address.idx + ' .msg-inline').addClass('expand');
	                                }, 500);
	                            }
	                        }
	                    });
	                };
	
	                // Provide watch value for modal-box and select-box to recalculate keyboard behavior based on number of infoMsgIcons and confirmLinks
	                $scope.numModalElements = function () {
	                    if (!$scope.checkoutShippingAddresses.addresses) {
	                        return 0;
	                    }
	                    // Track messages by index, if they have flags active, seeing which flags they have active
	                    return $scope.checkoutShippingAddresses.addresses.reduce(function (sum, address, index) {
	                        var item = $scope.showInfoMsgIcon(address) || $scope.showConfirmDelete(address) ? index + 1 : 0;
	                        return sum + item;
	                    }, 0);
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/delete-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<div ng-class=\"{'aside': sidebar, 'fullpage': !sidebar}\" id=\"deleteShipping\" modal-box=\"numModalElements()\" modal-cancel=\"goBack()\">\n    <xo-aside-header heading='asideHeader.deleteShipping' back-url=\"{{backUrl}}\"></xo-aside-header>\n\n    <div class=\"asideContent showAll\" xo-tray-height content>\n        <ul class=\"items\" select-box=\"numModalElements()\" select-allow-tab-escape focus-when focus-refresh-on=\"'addressUpdated'\">\n            <li ng-repeat=\"address in checkoutShippingAddresses.addresses\" role=\"presentation\" class=\"item address{{address.idx}}\">\n                <div class=\"itemInner\">\n                    <div class=\"address\" ng-class=\"{'notDeletable': !address.isDeletable}\">\n                        <span class=\"display fullName\">{{address.recipient_name}}</span>\n                        <xo-address-display address=address country-code=countryCode show-preferred=\"true\"></xo-address-display>\n                    </div>\n                    <div>\n                        <span class=\"msgIcon\" ng-if=\"showInfoMsgIcon(address)\" ng-click=\"showInfoMessage(address)\" title=\"More Info\"></span>\n                    </div>\n                    <div ng-if=\"address.isDeletable\">\n                        <div class=\"delete\" ng-if=\"showDelete(address)\">\n                            <a track-link=\"address_delete\" href=\"\" ng-click=\"onDelete(address)\" class=\"deleteBtn\">\n                                <span>{{content('deleteShipping.delete')}}</span>\n                            </a>\n                        </div>\n                        <div class=\"delete confirm\" ng-if=\"showConfirmDelete(address)\">\n                            <a track-link=\"address_delete_confirm\" href=\"\" ng-click=\"onConfirmDelete(address)\" class=\"confirmBtn\">\n                                <span>{{content('deleteShipping.confirm')}}</span>\n                            </a>\n                        </div>\n                    </div>\n                    <div class=\"msg-inline\" ng-if=\"address.contingencyInfoMsgKey\">\n                        <div class=\"msg-inlineInner\" tabindex=\"-1\" focus-when=\"address.contingencyInfoMsgKey\">\n                            <span>{{content(address.contingencyInfoMsgKey)}}</span>\n                        </div>\n                    </div>\n                    <div class=\"msg-inline msg-error\" ng-if=\"address.contingencyErrorMsgKey\">\n                        <div class=\"msg-inlineInner\" tabindex=\"-1\" focus-when=\"address.contingencyErrorMsgKey\">\n                            <span class=\"icon\"></span>\n                            <div class=\"content\">{{content(address.contingencyErrorMsgKey)}}</div>\n                        </div>\n                    </div>\n                </div>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-address-components/src/address-display/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoAddressDisplayComponent = undefined;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-address-components/src/address-display/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-address-components/src/address-display/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoAddressDisplayComponent = exports.$xoAddressDisplayComponent = _index.$Component.extend('$xoAddressDisplayComponent', {
	
	    tag: 'xo-address-display',
	    template: _template2['default'],
	
	    props: {
	        address: {
	            type: 'var'
	        },
	        showPreferred: {
	            type: 'str',
	            required: false
	        },
	        countryCode: {
	            type: 'var',
	            required: false
	        },
	        displayFormattedAddr: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            var _this = this;
	
	            var address = this.props.address || {};
	            var countryCode = typeof this.props.countryCode === 'undefined' ? address.country || address.country_code : this.props.countryCode;
	            this.isPreferred = this.props.showPreferred && address.preferred_address && (0, _index.$feature)('preferredShipping', false, countryCode);
	
	            if (this.props.displayFormattedAddr) {
	                this.formattedAddr = this.actions.formatAddress(address);
	                this.$watchCollection('props.address', function (newVal) {
	                    _this.formattedAddr = _this.actions.formatAddress(newVal);
	                });
	            }
	        }
	    },
	
	    actions: {
	        formatAddress: function formatAddress(address) {
	            var COMMA = ', ';
	            var SPACE = ' ';
	
	            function prefix(str, prefixStr) {
	                if (str) {
	                    return (prefixStr ? prefixStr : '') + str;
	                }
	                return '';
	            }
	
	            var displayLine1 = (address.line1 ? address.line1 : '') + (address.line2 ? prefix(address.line2, COMMA) : '');
	            var displayLine2 = (address.city ? prefix(address.city) : '') + (address.state ? prefix(address.state, COMMA) : '') + (address.postal_code ? prefix(address.postal_code, SPACE) : '');
	            var displayLine3 = address.country ? prefix(address.country) : '';
	
	            return {
	                displayLine1: displayLine1,
	                displayLine2: displayLine2,
	                displayLine3: displayLine3
	            };
	        }
	    }
	});
	
	angular.value("$xoAddressDisplayComponent", $xoAddressDisplayComponent);
	_index.$Component;
	
	_index.$feature;

/***/ },

/***/ "./components/xo-address-components/src/address-display/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"adr\" ng-class=[props.countryCode] content>\n    <div ng-if=\"props.address.full_address && !props.displayFormattedAddr\" class=\"confidential\">\n        <span class=\"full-address\" directionality-text=\"props.address.full_address\">{{props.address.full_address}}</span>\n        <span class=\"country adr-break\">{{content('countryList.'+props.address.country)}}</span>\n    </div>\n\n    <div ng-if=\"props.displayFormattedAddr\" class=\"shippingAddress\">\n        {{formattedAddr.displayLine1}}<br/>\n        {{formattedAddr.displayLine2}}<br/>\n        {{formattedAddr.displayLine3}}\n    </div>\n\n    <div ng-if=\"isPreferred\" class=\"preferred\">\n        <span>\n            {{content('shippingAddress.preferred')}}\n        </span>\n    </div>\n</div>"

/***/ },

/***/ "./components/xo-address-components/src/address-display/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-address-components/src/address-display/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-address-components/src/address-display/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".adr{margin-top:3px;color:#6c7378;font-size:.85em;width:90%}.adr .adr-break{display:block}.adr .country,.adr .singleline{display:none}.adr .preferred{margin:15px 0 7px}.adr .preferred span{padding:5px 10px;background-color:#eaf7e9;color:#2a5327;font-size:1em}.addressDisplay .adr .streets{display:inline;white-space:normal}.addressDisplay .adr .adr-break,.addressDisplay .adr .postal-code,.addressDisplay .adr .singleline,.addressDisplay .adr .streets,.addressDisplay .adr .streets+div{display:inline}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-member-components/src/select-shipping/update-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/update-shipping/directive.js"), __webpack_require__("./components/xo-address-components/src/address-normalization/route.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/shipping-address/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-update-shipping.route', ['squid', 'xo-shipping-address.directive', 'xo-add-address.directive', 'xo-address-normalization.route']).factory('$UpdateShippingRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('UpdateShippingRoute', {
	            name: 'updateShipping',
	            directive: 'xo-update-shipping',
	            titleContent: 'addShipping.addAddress',
	            trackingData: {
	                fptiState: 'update_shipping'
	            },
	            loginRequired: true,
	            children: [{
	                name: '$AddressNormalizationRoute',
	                attributes: {
	                    id: 'token',
	                    sidebar: 'sidebar',
	                    address: 'address',
	                    'done-fn': 'uponNormalization'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-member-components/src/select-shipping/update-shipping", "components/xo-member-components/src/select-shipping/update-shipping/route.js"))

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/update-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/update-shipping/template.html"), __webpack_require__("./components/xo-member-components/src/select-shipping/shipping-address/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-select-shipping.update-shipping.directive', ['squid', 'xo-shipping-address.directive']).directive('xoUpdateShipping', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                auth: '=',
	                token: '=',
	                doneFn: '=',
	                sidebar: '='
	            },
	            controller: function controller($scope) {}
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/update-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-shipping-address token=\"token\" done-fn=\"doneFn\" sidebar=\"sidebar\" update=\"true\"></xo-shipping-address>"

/***/ },

/***/ "./pages/xo-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarShippingRoute = undefined;
	
	__webpack_require__("./pages/xo-shipping/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SidebarShippingRoute = exports.$SidebarShippingRoute = _squid.$ComponentRoute.extend('$SidebarShippingRoute', {
	
	    path: 'shipping',
	    directive: 'xo-shipping',
	    titleContent: 'asideHeader.selectShipping',
	    trackingData: {
	        fptiState: 'select_shipping_address',
	        templateName: 'selectShipping.dust',
	        pageGoal: 'Select Shipping',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-select-shipping-address',
	                'pagename2': '%::fullpage-select-shipping-address:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    }
	});
	
	angular.value("$SidebarShippingRoute", $SidebarShippingRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoShippingComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-shipping/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoShippingComponent = exports.$xoShippingComponent = _squid.$Component.extend('$xoShippingComponent', {
	    tag: 'xo-shipping',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $location) {
	        $scope.token = $rootScope.token;
	        $scope.onComplete = function (result) {
	            $location.path('/checkout/review');
	        };
	    }
	});
	
	angular.value("$xoShippingComponent", $xoShippingComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"selectShipping\">\n    <xo-select-shipping done-fn=\"onComplete\" token=\"token\"></xo-select-shipping>\n</section>\n"

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/xo-member-components/src/select-shipping/select-shipping/directive.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/add-shipping/directive.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/delete-shipping/directive.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/update-shipping/directive.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/shipping-address/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function () {}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/select-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/select-shipping/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-address-components/src/address-display/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-select-shipping.directive', ['squid', 'xomodel.checkout', 'xo-address-display.directive', 'xo-aside-header.directive', 'xo-tray-height.directive', 'xo-accessibility.directive']).directive('xoSelectShipping', function () {
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                doneFn: '='
	            },
	            controller: function controller($scope, $log, $populate, $state, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutShippingAddressesModel, $config, $feature, $renderContent, $locale) {
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
	                    checkoutShippingAddresses: $CheckoutShippingAddressesModel.create($scope.token)
	                }).then(function () {
	                    $scope.checkoutSession.message = null;
	                    $scope.deleteShipping = $scope.checkoutShippingAddresses.addresses.some(function (address) {
	                        return !(address.primary_address || address.default_address);
	                    });
	                });
	
	                $scope.onSelect = function (address) {
	                    if (!address.disable_for_transaction) {
	                        address.action('select', {
	                            resultModel: $scope.checkoutSession,
	                            success: function success(result) {
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['smallToolTip.addressUpdated']
	                                };
	                                $scope.checkoutShippingAddresses.invalidate();
	                                $scope.doneFn(address);
	                            }
	                        });
	                    }
	                };
	
	                $scope.locale = $locale;
	
	                $scope.onAdd = function () {
	                    $state.go('checkout.review.sidebar.addShipping');
	                };
	
	                // Construct message object for block non-domestic shipping alert
	                var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
	
	                var countryName = $renderContent('countryList.' + merchantCountry);
	                var infoMessage = $renderContent('selectShipping.blockNonDomesticShippingInfo', {
	                    shippingCountry: countryName
	                });
	                $scope.blkNonDomesticShippingMsg = {
	                    msgs: [infoMessage],
	                    type: 'desc'
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/select-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"selectShipping\" content modal-box modal-refresh-on=\"'populated'\" modal-cancel=\"doneFn()\">\n    <xo-aside-header ng-if=\"deleteShipping\" hdrtype='tall' heading='asideHeader.selectShipping'\n                     sub-header-left-link='checkout.review.sidebar.addShipping'\n                     sub-header-left=\"asideHeader.add\"\n                     sub-header-left-icon=\"true\"\n                     sub-header-right-link='checkout.review.sidebar.deleteShipping'\n                     sub-header-right=\"asideHeader.delete\"\n                     sub-header-right-icon=\"true\"></xo-aside-header>\n\n    <xo-aside-header hdrtype='tall' heading='asideHeader.selectShipping'\n                     ng-if=\"!deleteShipping\"\n                     sub-header-left-link='checkout.review.sidebar.addShipping'\n                     sub-header-left=\"asideHeader.add\"\n                     sub-header-left-icon=\"true\"></xo-aside-header>\n\n    <div class=\"asideContent showAll\" xo-tray-height>\n        <ul class=\"items\" select-box=\"checkoutShippingAddresses.addresses\" select-allow-tab-escape>\n            <li ng-repeat=\"address in checkoutShippingAddresses.addresses\"\n                role=\"presentation\"\n                class=\"address trayInner trayInnerDefault\"\n                ng-class=\"{selectable: !address.default_address, disabled: address.disable_for_transaction}\">\n\n                <xo-message ng-if=\"address.disable_for_transaction\" message=\"blkNonDomesticShippingMsg\"\n                            class=\"shippingBlk\"></xo-message>\n\n                <a track-submit href=\"\" ng-click=\"onSelect(address)\" class=\"shippingBlk\" select-option=\"address.default_address\" focus-when=\"address.default_address\" role=\"option\" ng-attr-aria-selected=\"{{ address.default_address ? 'true' : undefined }}\">\n                    <span class=\"display fullName\">{{address.recipient_name}}</span>\n                    <xo-address-display address=address country-code=countryCode\n                                        show-preferred=\"true\"></xo-address-display>\n                    <span class=\"checkIcon\" ng-if=\"address.default_address\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                </a>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-sidebar/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _template = __webpack_require__("./pages/xo-sidebar/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoSidebarComponent', {
	
	    tag: 'xo-sidebar',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            required: true,
	            type: 'var'
	        },
	        backUri: {
	            required: true,
	            type: 'var'
	        },
	        promotion: {
	            required: false,
	            type: 'var'
	        },
	        update: {
	            required: false,
	            type: 'var'
	        },
	        installment: {
	            required: false,
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            _squid.$util.assert(this.props.backUri, 'Expected backUri');
	
	            this.sidebar = true;
	
	            this.onPageClick = function ($event) {
	                $event.stopPropagation();
	            };
	
	            /*
	                Stores history of sidebar nested routes to be able to go to
	                previous sidebar routes by calling back() on sidebar.
	             */
	            this.history = [this.props.backUri];
	            this.cancelStateListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
	                var index = _this.history.indexOf(to.name);
	
	                if (index === -1) {
	                    _this.history.push(from.name);
	                } else {
	                    _this.history = _this.history.slice(0, index);
	                }
	            });
	
	            this.back = function () {
	                _uiRouter.$state.go(_this.history[_this.history.length - 1]);
	            };
	
	            this.close = function () {
	                _uiRouter.$state.go(_this.props.backUri);
	            };
	
	            this.callbacks = {
	                done: function done() {
	                    _uiRouter.$state.go('checkout.review');
	                }
	            };
	        },
	        populate: function populate() {
	            (0, _jquery2['default'])('body').addClass('trayOpen');
	            (0, _jquery2['default'])('#wrapper').addClass('maskMember');
	
	            var payButton = (0, _jquery2['default'])('.confirmButton');
	
	            if (payButton) {
	                payButton.attr('disabled', true);
	            }
	        },
	        exit: function exit() {
	            (0, _jquery2['default'])('body').removeClass('trayOpen');
	
	            var payButton = (0, _jquery2['default'])('.confirmButton');
	
	            if (payButton) {
	                payButton.attr('disabled', false);
	            }
	
	            this.cancelStateListener();
	        }
	    }
	});
	
	
	_angular.$rootScope;
	
	_uiRouter.$state;
	
	_squid.$Component;
	
	_squid.$util;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-sidebar/template.html":
/***/ function(module, exports) {

	module.exports = "<aside class=\"sidebar\" id=\"tray\" ng-click=\"onPageClick($event)\" modal-box modal-cancel=\"back()\" tabindex=\"-1\">\n\n    <div class=\"aside\" id=\"{{viewConfig.aside}}\">\n        <xo-aside-header ng-if=\"viewConfig.aside\" hdrtype=\"tall\" heading=\"{{viewConfig.heading}}\" sub-head='{{viewConfig.subHeading}}' add-link='{{viewConfig.addRoute}}'></xo-aside-header>\n        <div ui-view></div>\n    </div>\n</aside>\n\n<span class=\"trayViewMask\" ng-click=\"close()\"></span>\n"

/***/ },

/***/ "./pages/xo-sidebar-add-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarAddShippingRoute = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./pages/xo-sidebar-add-shipping/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/add-shipping/route.js");
	
	var $SidebarAddShippingRoute = exports.$SidebarAddShippingRoute = _squid.$ComponentRoute.extend('$SidebarAddShippingRoute', {
	
	    path: 'sidebarAddShipping',
	    directive: 'xo-sidebar-add-shipping-page',
	    titleContent: 'addShipping.addAddress',
	    trackingData: {
	        templateName: 'tray/addShippingAddress.dust',
	        pageGoal: 'Add Shipping',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-shipping-address',
	                'pagename2': '%::fullpage-add-shipping-address:member:hermes:tray',
	                'version': 'member:%:tray'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddShippingRoute',
	        attributes: {
	            token: 'token'
	        },
	        message: 'message',
	        sidebar: 'sidebar',
	        'parent-callbacks': 'callbacks'
	    }]
	});
	
	angular.value("$SidebarAddShippingRoute", $SidebarAddShippingRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidebar-add-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarAddShippingPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-sidebar-add-shipping/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarAddShippingPageComponent = exports.$xoSidebarAddShippingPageComponent = _squid.$Component.extend('$xoSidebarAddShippingPageComponent', {
	    tag: 'xo-sidebar-add-shipping-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state) {
	        $scope.token = $rootScope.token;
	        $scope.sidebar = true;
	
	        $scope.onComplete = function () {
	            $state.go('checkout.review');
	        };
	    }
	});
	
	angular.value("$xoSidebarAddShippingPageComponent", $xoSidebarAddShippingPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidebar-add-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"addShipping\">\n\n</div>\n"

/***/ },

/***/ "./components/xo-validation/dist/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid) {
	    squid.module('xo-validation.directive', ['squid']).directive('xoValidation', function () {
	        return {
	            template: '',
	            restrict: 'A',
	            require: 'ngModel',
	
	            link: function link(scope, elem, attr, ngModel) {
	
	                var validationUtil = {
	
	                    // because IE8 doesnt have String.prototype.trim()
	                    trim: function trim(value) {
	                        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	                        return value.replace(rtrim, '');
	                    },
	
	                    /**
	                     * Generic function that runs a given input against
	                     * a given regular expression
	                     *
	                     * @param {String} value input to test
	                     * @param {String/RegExp} regex Regular expression to test against
	                     * @returns {Boolean} matches or does not match given pattern
	                     */
	                    valid: function valid(value, regex) {
	                        if (this.empty(value)) {
	                            return false;
	                        }
	
	                        if (angular.isString(regex)) {
	                            regex = new RegExp(regex);
	                        }
	
	                        return regex ? regex.test(value) : true;
	                    },
	
	                    // returns whether empty or not
	                    empty: function empty(value) {
	                        if (!value) {
	                            return true;
	                        }
	
	                        // IE8 and below doesn't have native .trim()
	                        return !this.trim(value);
	                    },
	
	                    // returns whether alphabetic or not
	                    alphabetic: function alphabetic(value) {
	                        return this.valid(value, /[A-Za-z]+$/);
	                    },
	
	                    // returns whether numeric or not
	                    numeric: function numeric(value) {
	                        var NUMERIC_REGEX = new RegExp('^[0-9]+$');
	
	                        return this.valid(value, NUMERIC_REGEX);
	                    },
	
	                    validBankAccount: function validBankAccount(value) {
	                        if (!scope.showIBAN) {
	                            return this.numeric(value);
	                        }
	
	                        return true;
	                    },
	
	                    validRouting: function validRouting(value) {
	                        if (!scope.showIBAN) {
	                            return this.valid(value, /^\d{8}$/);
	                        }
	                        return true;
	                    },
	
	                    validIBANCode: function validIBANCode(value) {
	                        if (scope.showIBAN) {
	                            value = value && value.replace(/ +/g, '');
	                            return this.valid(value, /^([A-Z]){2}\d{2}[A-Z0-9]{1,30}$/);
	                        }
	                        return true;
	                    },
	
	                    validIBAN: function validIBAN(value) {
	                        if (scope.showIBAN) {
	                            value = value && value.replace(/ +/g, '');
	                            return this.valid(value, /^DE\d{20}$/);
	                        }
	                        return true;
	                    },
	
	                    validIBANCountry: function validIBANCountry(value) {
	                        value = value && value.replace(/ +/g, '');
	                        return !this.valid(value, /^([^D0-9][E]|[D][^E0-9]|[^D0-9][^E0-9])\d{2}[A-Z0-9]{1,30}$/i);
	                    },
	
	                    // first two letters are the country code the rest are the bank account numbers max length 32
	                    validIBANWithValidCountryCode: function validIBANWithValidCountryCode(value) {
	                        value = value && value.replace(/ +/g, '');
	                        return this.valid(value, /^(AT|BE|CY|EE|FI|FR|DE|EL|IE|IT|LV|LT|LU|MT|MC|NL|PT|SK|SI|ES)\d{3,32}$/i);
	                    },
	
	                    validLast4: function validLast4(value) {
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var LAST_4 = /^([0-9]{4})?$/; // eslint-disable-line fasec/no-unsafe-regex
	                        return this.valid(value, LAST_4);
	                    },
	
	                    validStreet: function validStreet(value) {
	                        return this.valid(value, /^([A-Za-z0-9-. ]*)$/);
	                    },
	
	                    // Validating phone format with metadata from griffin
	                    validPhone: function validPhone(value) {
	                        var regex = scope.pattern;
	                        /*
	                         * User can enter phone format in various manner according to griffin mask
	                         * (00) 0000-0000
	                         * 00 000 0000
	                         * Since the griffin pattern only validates against numbers, need to trim the input
	                         * to only validate the numbers
	                         */
	                        value = value && value.replace(/[^0-9]/gi, '');
	                        return this.valid(value, regex);
	                    },
	
	                    validDobYear: function validDobYear(value) {
	                        return value !== 'YYYY';
	                    },
	
	                    validDobDay: function validDobDay(value) {
	                        return value !== 'DD';
	                    },
	
	                    validDobMonth: function validDobMonth(value) {
	                        return value !== 'MM';
	                    },
	
	                    validPoBox: function validPoBox(value) {
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var boxRE = /\b(((general\s+)?post\s+(office|mail)?)|((g\.?)?p[-\.]?\s?[om][\.-]?))\s?(b(ox|\.)?)?(\s+\d+)\b/i; // eslint-disable-line fasec/no-unsafe-regex
	
	                        if (boxRE.test(value)) {
	                            return true;
	                        }
	                        return false;
	                    },
	
	                    validAddressSansPoBox: function validAddressSansPoBox(value) {
	                        var boxRE = /(p[-.]? ?[om]?[-.]? ?|post ?(office|mail)?)? ?b(.|ox)[^,]*\d+/i;
	                        var cassRE = /(drawer|locker|bin|firm caller)\s?#?[0-9]+/i;
	
	                        if (boxRE.test(value) || cassRE.test(value)) {
	                            return false;
	                        }
	                        return true;
	                    },
	
	                    validEmailOrPhone: function validEmailOrPhone(value) {
	                        if (!value) {
	                            return false;
	                        }
	
	                        return this.validEmail(value) || this.validPhone(value);
	                    },
	
	                    validEmail: function validEmail(value) {
	                        if (!value) {
	                            return false;
	                        }
	                        var trimmedValue = this.trim(value); // Trim leading and trailing whitespace
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i; // eslint-disable-line
	
	                        return this.valid(trimmedValue, EMAIL_REGEX) && !this.highAscii(trimmedValue);
	                    },
	
	                    highAscii: function highAscii(value) {
	                        var trimmedValue = this.trim(value);
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var HIGH_ASCII_REGEX = /[^\x00-\x7F]/; // eslint-disable-line no-control-regex
	
	                        return this.valid(trimmedValue, HIGH_ASCII_REGEX);
	                    },
	
	                    // expected format: MM/DD/YYYY
	                    validDate: function validDate(value) {
	                        var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
	                        var dArr = value.split('/');
	                        var d = new Date(value);
	                        var isValid = false;
	
	                        if (re.test(value)) {
	                            isValid = d.getMonth() + 1 === dArr[0] && d.getDate() === dArr[1] && d.getFullYear() === dArr[2];
	                        }
	
	                        return isValid;
	                    },
	
	                    /* Expects value and state. state can be "past" or "future".
	                     NOTE: This function validates only month and year, not day!
	                     Please use validDate() if you need to validate the whole date. */
	                    validDateWithoutDay: function validDateWithoutDay(value, options) {
	                        var state = options.state;
	
	                        value = value.replace(/\s/g, '');
	
	                        if (value === '') {
	                            return true;
	                        }
	
	                        var split = value.split('/');
	                        var month = split[0];
	                        var year = split[1];
	                        var currentYear = parseInt(new Date().getFullYear().toString().substr(2, 2), 10);
	                        var currentMonth = parseInt(new Date().getMonth(), 10) + 1;
	                        var validYear = true;
	                        var validMonth = true;
	
	                        if (value.length < 5) {
	                            return false;
	                        }
	
	                        if (this.validDobMonth(month)) {
	                            month = parseInt(month, 10);
	                        } else {
	                            return false;
	                        }
	
	                        year = parseInt(year, 10);
	
	                        if (state === 'past') {
	                            validYear = year <= currentYear;
	                            if (!validYear) {
	                                return false;
	                            }
	                            if (year === currentYear) {
	                                validMonth = month <= currentMonth;
	                            }
	                        } else if (state === 'future') {
	                            validYear = year >= currentYear;
	                            if (!validYear) {
	                                return false;
	                            }
	                            if (year === currentYear) {
	                                validMonth = month >= currentMonth;
	                            }
	                        }
	
	                        if (!validYear || !validMonth) {
	                            return false;
	                        }
	
	                        return true;
	                    },
	
	                    // formats to MM/DD/YYYY
	                    mmddyyyy: function mmddyyyy(day, month, year) {
	                        if (year.length < 4) {
	                            year = '20' + year;
	                        }
	
	                        return this.twoDigits(month) + '/' + this.twoDigits(day) + '/' + this.twoDigits(year);
	                    },
	
	                    // formats to YY-MMM-DDDD
	                    yyyymmdd: function yyyymmdd(day, month, year) {
	                        if (year.length < 4) {
	                            year = '20' + year;
	                        }
	
	                        return year + '-' + this.twoDigits(month) + '-' + this.twoDigits(day);
	                    },
	
	                    // pads a number to two digits
	                    twoDigits: function twoDigits(value) {
	                        return value < 10 ? '0' + value : '' + value;
	                    },
	
	                    // expects YYYY-MM-DD
	                    legalAge: function legalAge(value) {
	                        if (this.empty(value)) {
	                            return false;
	                        }
	
	                        var dateParts = value.split('-'); // expecting YYYY-MM-DD
	                        var birthDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
	                        var yr = 365.25 * 24 * 60 * 60 * 1000; // milliseconds in a year
	                        var validBD = new Date(new Date() - 18 * yr);
	
	                        return validBD >= birthDate;
	                    },
	
	                    validZip: function validZip(value, options) {
	
	                        var postalCodeRegex = {
	                            // TODO: Once this is removed from the xo-add-address template, we can remove it...
	                            'GB': /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/,
	                            /*
	                             * Note: These are "nice to have".
	                             * Once we add support for these countries, we can remove these.
	                             */
	                            'BA': /^\d{5}$/,
	                            'CY': /^\d{4}$/,
	                            'EE': /^\d{5}$/,
	                            'HR': /^\d{5}$/,
	                            'LU': /^\d{4}$/,
	                            'LV': /^\d{4}$/,
	                            'MT': /^\d{3,4}$/,
	                            'SI': /^\d{4}$/,
	                            'SK': /^[0-9]{3}[\s][0-9]{2}$/,
	                            'NZ': /^\d{4}$/,
	                            'LT': /^\d{5}$/,
	                            'BG': /^\d{4}$/,
	                            'CZ': /^\d{5}$/,
	                            'GR': /^\d{3}[\s]\d{2}$/,
	                            'HU': /^\d{4}$/,
	                            'MX': /^\d{5}$/
	                        };
	
	                        var country = options && options.country;
	                        var regex = scope.zipEntry && scope.zipEntry.validationPattern || postalCodeRegex[country];
	                        var isRequired = scope.zipEntry && scope.zipEntry.required;
	
	                        if (!isRequired && this.empty(value)) {
	                            return true;
	                        }
	
	                        // If there is no regex, or it's not populated yet...
	                        if (!regex || angular.isString(regex) && regex.indexOf('validationPattern') > -1) {
	                            return !this.empty(value);
	                        }
	
	                        value = value && value.toUpperCase();
	
	                        return this.valid(value, regex);
	                    },
	
	                    validExpiry: function validExpiry(value, options) {
	                        var $monthEl = $('[ng-model="card.expiry_month"]');
	                        var $yearEl = $('[ng-model="card.expiry_year"]');
	                        var month = $monthEl.val();
	                        var year = $yearEl.val();
	                        var isValid = false;
	                        var monthElName = 'card.expiry_month';
	                        var yearElName = 'card.expiry_year';
	                        var cardType = options.cardType;
	
	                        if (month) {
	                            month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
	                        }
	
	                        if (year) {
	                            year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
	                        }
	
	                        if (month && year) {
	                            isValid = this.validExpires(month, year);
	                        }
	
	                        var formName = $monthEl.closest('form').attr('id');
	                        var form = scope[formName] || scope.$parent[formName];
	                        var monthFieldName = monthElName;
	                        var yearFieldName = yearElName;
	
	                        if (monthFieldName.indexOf('.') !== -1) {
	                            monthFieldName = monthFieldName.split('.')[1];
	                        }
	
	                        if (yearFieldName.indexOf('.') !== -1) {
	                            yearFieldName = yearFieldName.split('.')[1];
	                        }
	
	                        var cardsDontNeedExpiry = ['COFIDIS', 'COFINOGA', 'CETELEM'];
	
	                        if (cardType && cardsDontNeedExpiry.indexOf(cardType) !== -1) {
	                            isValid = true;
	                        }
	
	                        if (form) {
	                            form[monthFieldName].$setValidity('validExpiry', isValid);
	                            form[yearFieldName].$setValidity('validExpiry', isValid);
	                        }
	
	                        return isValid;
	                    },
	
	                    validExpires: function validExpires(month, year) {
	                        var date = new Date();
	                        var currentYear = parseInt(date.getFullYear().toString().substr(2, 2), 10);
	                        var currentMonth;
	
	                        if (year < currentYear) {
	                            return false;
	                        } else if (year > currentYear) {
	                            return this.validDobMonth(month);
	                        }
	
	                        // account for display date vs. system date
	                        currentMonth = date.getMonth() + 1;
	                        return this.validDobMonth(month) && month >= currentMonth;
	                    },
	
	                    startDate: function startDate(value, options) {
	                        var valueOptions = {
	                            cardType: scope.card.type
	                        };
	                        valueOptions[elem.attr('id')] = value;
	
	                        return this.setStartDateValidity(valueOptions);
	                    },
	
	                    setExpiryValidity: function setExpiryValidity(options) {
	                        if (!options) {
	                            return true;
	                        }
	
	                        var cardType = options.cardType || '',
	                            expiryValidity = this.validExpiry(null, {
	                            cardType: cardType
	                        });
	
	                        return expiryValidity;
	                    },
	
	                    // start date validation for Maestro card
	                    setStartDateValidity: function setStartDateValidity(options) {
	                        if (!options) {
	                            return true;
	                        }
	
	                        var cardType = options.cardType || '';
	                        var startDateValidity = true;
	                        var $monthEl = $('#startmonth');
	                        var $yearEl = $('#startyear');
	                        var month = $monthEl.val();
	                        var year = $yearEl.val();
	
	                        if (cardType === 'MAESTRO') {
	                            if (!month || !year) {
	                                startDateValidity = false;
	                            }
	                        }
	
	                        var formName = $monthEl.closest('form').attr('id'),
	                            form = scope[formName] || scope.$parent[formName];
	
	                        if (form) {
	                            form.startmonth.$setValidity('startDate', startDateValidity);
	                            form.startyear.$setValidity('startDate', startDateValidity);
	                        }
	
	                        return startDateValidity;
	                    },
	
	                    dobField: function dobField(value, options) {
	                        var valueOptions = {};
	                        var fieldMap = {
	                            'dobDayCC': 'day',
	                            'dobMonthCC': 'month',
	                            'dobYearCC': 'year'
	                        };
	
	                        valueOptions.cardType = scope.card.type;
	                        valueOptions[fieldMap[elem.attr('id')]] = value;
	
	                        return this.setDOBValidity(valueOptions);
	                    },
	
	                    setDOBValidity: function setDOBValidity(options) {
	                        if (!options) {
	                            return true;
	                        }
	
	                        var dobEnabledCards = ['COFIDIS', 'COFINOGA', 'CETELEM'];
	
	                        var dobValidity = true;
	
	                        var $monthEl = $('#dobMonthCC');
	                        var $dayEl = $('#dobDayCC');
	                        var $yearEl = $('#dobYearCC');
	
	                        var month = options.month || $monthEl.val();
	                        var year = options.year || $yearEl.val();
	                        var day = options.day || $dayEl.val();
	
	                        if (month) {
	                            month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
	                        }
	
	                        if (day) {
	                            day = $dayEl.find('option')[$dayEl.val() * 1 + 1].label;
	                        }
	
	                        if (year) {
	                            year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
	                        }
	
	                        var cardType = options.cardType;
	                        if (cardType && dobEnabledCards.indexOf(cardType) !== -1) {
	                            if (!month || !year || !day) {
	                                dobValidity = false;
	                                // invalidate if < 18 y/o.
	                            } else if (!this.legalAge(this.yyyymmdd(day, month, year))) {
	                                dobValidity = false;
	                            } else if (!this.validDate(this.mmddyyyy(day, month, year))) {
	                                dobValidity = false;
	                            }
	                        }
	
	                        var formName = $monthEl.closest('form').attr('id');
	                        var form = scope[formName] || scope.$parent[formName];
	
	                        if (form) {
	                            form.dobMonthCC.$setValidity('dobField', dobValidity);
	                            form.dobDayCC.$setValidity('dobField', dobValidity);
	                            form.dobYearCC.$setValidity('dobField', dobValidity);
	                        }
	
	                        return dobValidity;
	                    },
	
	                    validName: function validName(value) {
	                        return this.valid(value, /^([a-zA-Z,\xC0-\xFF,\u00C0-\u017F\,\-\s\,\'])*$/);
	                        // ' this comment is to un-confuse editors on synax coloring because of the single quote above
	                    },
	
	                    isChecked: function isChecked(value, options) {
	                        // $.is does not exist in $
	                        // eslint-disable-line angular/ng_angularelement
	                        var $el = $(options.el);
	
	                        return $el.is(':checked');
	                    },
	
	                    validRUPassport: function validRUPassport(value, options) {
	                        if (scope.user.countryOfResidence === 'RU') {
	                            return this.valid(value, /^\d{10}$/);
	                        }
	                        return true;
	                    }
	                };
	
	                var customValidator = function customValidator(value) {
	                    var ruleJson = angular.fromJson(elem.attr('xo-validation'));
	                    var validator = ruleJson.validator;
	                    var options = ruleJson.options;
	
	                    ngModel.$setValidity(validator, validationUtil[validator](value, options));
	
	                    return value;
	                };
	
	                ngModel.$parsers.unshift(customValidator);
	                ngModel.$formatters.unshift(customValidator);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./pages/xo-sidebar-update-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarUpdateShippingRoute = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./pages/xo-sidebar-update-shipping/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/update-shipping/route.js");
	
	var $SidebarUpdateShippingRoute = exports.$SidebarUpdateShippingRoute = _squid.$ComponentRoute.extend('$SidebarUpdateShippingRoute', {
	
	    path: 'sidebarUpdateShipping',
	    directive: 'xo-sidebar-Update-shipping-page',
	    titleContent: 'addShipping.addAddress',
	    trackingData: {
	        templateName: 'tray/addShippingAddress.dust',
	        pageGoal: 'Update Shipping',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-shipping-address',
	                'pagename2': '%::fullpage-add-shipping-address:member:hermes:tray',
	                'version': 'member:%:tray'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$UpdateShippingRoute',
	        attributes: {
	            token: 'token'
	        },
	        message: 'message',
	        sidebar: 'sidebar',
	        'parent-callbacks': 'callbacks'
	    }]
	});
	
	angular.value("$SidebarUpdateShippingRoute", $SidebarUpdateShippingRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./js/app.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	__webpack_require__("./css/app.less");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _route = __webpack_require__("./pages/xo-checkout/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	var _middleware = __webpack_require__("./js/lib/middleware.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_logger.$logger.info('app_bootstrap', {
	    hash: window.location.hash
	});
	
	var xoCheckoutRoute = new _route2['default']();
	
	xoCheckoutRoute.bootstrap('checkout.landing', _middleware.$Middleware);
	
	window.bootstrap = true;
	
	_logger.$logger;
	
	_middleware.$Middleware;

/***/ },

/***/ "./pages/xo-sidebar-update-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"updateShipping\">\n\n</div>\n"

/***/ },

/***/ "./pages/xo-sidebar-add-card/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarAddCardRoute = undefined;
	
	__webpack_require__("./pages/xo-sidebar-add-card/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/route.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SidebarAddCardRoute = exports.$SidebarAddCardRoute = _squid.$ComponentRoute.extend('$SidebarAddCardRoute', {
	
	    path: 'sidebarAddCard',
	    directive: 'xo-sidebar-add-card-page',
	    titleContent: 'asideHeader.addCard',
	    trackingData: {
	        templateName: 'tray/addCard.dust',
	        pageGoal: 'Add Card',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-cc',
	                'pagename2': '%::fullpage-add-cc:member:hermes:tray',
	                'version': 'member:%:tray'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            sidebar: 'sidebar',
	            'parent-callbacks': 'callbacks',
	            promotion: 'promotion'
	        }
	    }]
	});
	
	angular.value("$SidebarAddCardRoute", $SidebarAddCardRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidebar-add-card/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarAddCardPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-sidebar-add-card/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarAddCardPageComponent = exports.$xoSidebarAddCardPageComponent = _squid.$Component.extend('$xoSidebarAddCardPageComponent', {
	    tag: 'xo-sidebar-add-card-page',
	    template: _template2['default'],
	
	    scope: {
	        promotion: '='
	    },
	
	    controller: function controller($scope, $rootScope, $state) {
	        // eslint-disable-line no-shadow
	        $scope.billingaddressupdated = {
	            value: false
	        };
	        $scope.sidebar = true;
	        $scope.token = $rootScope.token;
	        $scope.message = {};
	        $scope.callbacks = {
	            finish: function finish() {
	                $state.go('checkout.review');
	            }
	        };
	    }
	});
	
	angular.value("$xoSidebarAddCardPageComponent", $xoSidebarAddCardPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidebar-add-card/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"addCard\" content>\n\t<ui-view sidebar=\"sidebar\"></ui-view>\n</div>\n"

/***/ },

/***/ "./pages/xo-sidebar-add-bank/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarAddBankRoute = undefined;
	
	__webpack_require__("./pages/xo-sidebar-add-bank/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-bank/route.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SidebarAddBankRoute = exports.$SidebarAddBankRoute = _squid.$ComponentRoute.extend('$SidebarAddBankRoute', {
	
	    path: 'sidebarAddBank',
	    directive: 'xo-sidebar-add-bank-page',
	    titleContent: 'asideHeader.addBank',
	    trackingData: {
	        templateName: 'tray/addBank.dust',
	        pageGoal: 'Add Bank',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::add-bank',
	                'pagename2': '%::add-bank:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddBankFlowRoute',
	        attributes: {
	            token: 'token',
	            sidebar: 'sidebar',
	            'parent-callbacks': 'callbacks'
	        }
	    }]
	});
	
	angular.value("$SidebarAddBankRoute", $SidebarAddBankRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidebar-add-bank/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarAddBankPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-sidebar-add-bank/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/add-bank/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarAddBankPageComponent = exports.$xoSidebarAddBankPageComponent = _squid.$Component.extend('$xoSidebarAddBankPageComponent', {
	    tag: 'xo-sidebar-add-bank-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state) {
	        // eslint-disable-line no-shadow
	        $scope.sidebar = true;
	        $scope.token = $rootScope.token;
	        $scope.message = {};
	        $scope.callbacks = {
	            done: function done() {
	                $state.go('checkout.review');
	            }
	        };
	    }
	});
	
	angular.value("$xoSidebarAddBankPageComponent", $xoSidebarAddBankPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidebar-add-bank/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"addBank\" content>\n    <ui-view></ui-view>\n</div>\n"

/***/ },

/***/ "./pages/xo-sidebar-currency-conversion/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarCurrencyConversionRoute = undefined;
	
	__webpack_require__("./pages/xo-sidebar-currency-conversion/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SidebarCurrencyConversionRoute = exports.$SidebarCurrencyConversionRoute = _squid.$ComponentRoute.extend('$SidebarCurrencyConversionRoute', {
	    path: 'currencyConversion',
	    directive: 'xo-sidebar-currency-conversion-page',
	    titleContent: 'asideHeader.currencyOptions',
	    trackingData: {
	        fptiState: 'currency_conversion',
	        templateName: 'tray/currencyOptions.dust',
	        pageGoal: 'Currency Conversion',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-currency-options',
	                'pagename2': '%::fullpage-currency-options::hermes:',
	                'version': ':%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: []
	});
	
	angular.value("$SidebarCurrencyConversionRoute", $SidebarCurrencyConversionRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidebar-currency-conversion/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarCurrencyConversionPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-sidebar-currency-conversion/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/currency-conversion/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarCurrencyConversionPageComponent = exports.$xoSidebarCurrencyConversionPageComponent = _squid.$Component.extend('$xoSidebarCurrencyConversionPageComponent', {
	    tag: 'xo-sidebar-currency-conversion-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state) {
	        $scope.token = $rootScope.token;
	
	        $scope.onComplete = function () {
	            $state.go('checkout.review');
	        };
	
	        $scope.$emit('populated');
	    }
	});
	
	angular.value("$xoSidebarCurrencyConversionPageComponent", $xoSidebarCurrencyConversionPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidebar-currency-conversion/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"currencyConversion\">\n    <xo-aside-header heading='asideHeader.currencyOptions'></xo-aside-header>\n    <div class=\"currencyConversion asideContent container\" xo-tray-height>\n       <xo-currency-conversion token=\"token\" done-fn=\"onComplete\"></xo-currency-conversion>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/currency-conversion/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/user/index.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/currency-conversion/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoCurrencyConversionDirective', {
	    tag: 'xo-currency-conversion',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        doneFn: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        changeConversionChoice: function changeConversionChoice() {
	            // The button will usually be Agree but for Brazil, when Vendor is chosen,
	            // the button changes to Continue.
	            this.continueButton = _squid.$locale.content.get('buttons.agree');
	
	            if (this.conversion.from_code === 'BRL' && !this.models.ppconversion) {
	                this.continueButton = _squid.$locale.content.get('buttons.continue');
	            }
	        },
	        onSubmit: function onSubmit() {
	            var _this = this;
	
	            if (this.models.ppconversion === this.conversion.paypal) {
	                this.props.doneFn();
	                return;
	            }
	
	            var conversionType = this.models.ppconversion ? 'PAYPAL' : 'VENDOR';
	            var payload = {
	                conversionType: conversionType,
	                planId: this.checkoutInputData.funding_option_id || this.models.checkoutSession.plan.id
	            };
	
	            if (payload.planId) {
	                this.models.checkoutSession.fundingOptions.action('updateConversion', {
	
	                    data: payload,
	
	                    success: function success(result) {
	                        _this.models.checkoutSession.reload({
	                            success: function success() {
	                                var conversion = _this.models.checkoutSession.plan.conversion || {};
	                                if (!_this.models.ppconversion) {
	                                    if (conversion.paypal) {
	                                        _logger.$logger.info('currency_conversion_not_honored', {
	                                            type: _this.currencyConverion,
	                                            from: conversion.from,
	                                            to: conversion.to,
	                                            changeable: conversion.changeable
	                                        });
	                                    } else {
	                                        _this.models.checkoutSession.plan.conversion = {
	                                            changeable: true,
	                                            paypal: false
	                                        };
	                                    }
	                                }
	                            }
	                        });
	
	                        _this.props.doneFn(result);
	                    }
	                });
	            }
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            this.conversion = this.models.checkoutSession.plan.conversion;
	            this.models.ppconversion = this.conversion.paypal;
	            this.continueButton = _squid.$locale.content.get('buttons.agree');
	            this.checkoutInputData = _index2.$CheckoutInputDataModel.instance(this.props.token);
	
	            var fundingOptionId = this.checkoutInputData.funding_option_id;
	            if (fundingOptionId && fundingOptionId !== this.models.checkoutSession.plan.id) {
	                this.models.checkoutSession.fundingOptions.action('getConversion', {
	
	                    data: {
	                        planId: fundingOptionId
	                    },
	
	                    success: function success(result) {
	                        this.conversion = result;
	                    }
	                });
	            }
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$locale;
	
	_logger.$logger;
	
	_index.$CheckoutSessionModel;
	
	_index2.$CheckoutInputDataModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/currency-conversion/template.html":
/***/ function(module, exports) {

	module.exports = "<form method=\"post\" class=\"curr_conv asideProceed formSmall\" novalidate=\"novalidate\" ng-submit=\"actions.onSubmit()\" content>\n    <p>{{ content('currencyOptions.subHead') }}</p>\n    <ul class=\"conversionoptions\">\n        <li>\n            <div class=\"radioButton\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"ppconversion\" id=\"converionPayPal\" ng-value=\"true\" tabindex=\"0\" ng-change='actions.changeConversionChoice()'/>\n                <label for=\"converionPayPal\">{{ content('currencyOptions.ppRateDesc') }}</label>\n            </div>\n            <p class=\"conversion\" ng-if=\"conversion.paypal\">\n                {{ content('currencyOptions.conversionRate', { currencyFrom: conversion.from, currencyTo: conversion.to}) }}\n            </p>\n            <div ng-if=\"models.checkoutSession.plan.conversion.from_code !== 'BRL'\">\n                <ul>\n                    <li>{{content('currencyOptions.ppUpSell1')}}</li>\n                    <li>{{content('currencyOptions.ppUpSell2')}}</li>\n                </ul>\n            </div>\n            <div ng-if=\"models.checkoutSession.plan.conversion.from_code === 'BRL'\">\n                <ul>\n                    <li><strong>{{content('currencyOptions.ppUpSell3')}}</strong> {{content('currencyOptions.ppUpSell4')}} {{content('currencyOptions.ppUpSell5')}}</li>\n                </ul>\n            </div>\n        </li>\n        <li>\n            <div class=\"radioButton\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"ppconversion\" id=\"converionVendor\" ng-value=\"false\" tabindex=\"0\" ng-change='actions.changeConversionChoice()'/>\n                <label for=\"converionVendor\">{{content('currencyOptions.cardIssuerRate')}}</label>\n            </div>\n            <div ng-if=\"models.checkoutSession.plan.conversion.from_code !== 'BRL'\">\n                <ul>\n                    <li>{{content('currencyOptions.cardIssuerRate1')}}</li>\n                    <li>{{content('currencyOptions.cardIssuerRate2')}}</li>\n                </ul>\n            </div>\n            <div ng-if=\"models.checkoutSession.plan.conversion.from_code === 'BRL'\">\n                <ul>\n                    <li><strong>{{content('currencyOptions.cardIssuerRate3')}}</strong> {{content('currencyOptions.cardIssuerRate4')}} <strong>{{content('currencyOptions.cardIssuerRate5')}}</strong></li>\n                </ul>\n            </div>\n        </li>\n    </ul>\n    <div class=\"buttons\">\n        <input id=\"proceedButton\" type=\"submit\" value=\"{{continueButton}}\" class=\"btn full\">\n    </div>\n</form>\n\n"

/***/ },

/***/ "./pages/xo-sidebar-installment-options/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarInstallmentOptionsRoute = undefined;
	
	__webpack_require__("./pages/xo-sidebar-installment-options/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SidebarInstallmentOptionsRoute = exports.$SidebarInstallmentOptionsRoute = _squid.$ComponentRoute.extend('$SidebarInstallmentOptionsRoute', {
	    path: 'installmentOptions',
	    directive: 'xo-sidebar-installment-options-page',
	    titleContent: 'asideHeader.installmentsPanel',
	    trackingData: {
	        fptiState: 'installment_options',
	        templateName: 'tray/installmentOptions.dust',
	        pageGoal: 'Installment Options',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-installment-options',
	                'pagename2': '%::fullpage-installment-options::hermes:',
	                'version': ':%:'
	            }
	        }
	    },
	    children: []
	});
	
	angular.value("$SidebarInstallmentOptionsRoute", $SidebarInstallmentOptionsRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidebar-installment-options/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarInstallmentOptionsPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-sidebar-installment-options/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/installment-options/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarInstallmentOptionsPageComponent = exports.$xoSidebarInstallmentOptionsPageComponent = _squid.$Component.extend('$xoSidebarInstallmentOptionsPageComponent', {
	    tag: 'xo-sidebar-installment-options-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state) {
	        $scope.token = $rootScope.token;
	
	        $scope.onComplete = function () {
	            $state.go('checkout.review');
	        };
	
	        $scope.$emit('populated');
	    }
	});
	
	angular.value("$xoSidebarInstallmentOptionsPageComponent", $xoSidebarInstallmentOptionsPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidebar-installment-options/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"installmentOptions\">\n    <xo-aside-header heading='asideHeader.installmentsPanel'></xo-aside-header>\n    <xo-installment-options token=\"token\" done-fn=\"onComplete\"></xo-installment-options>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/installment-options/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/installment-options/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-installment-options.directive', ['squid', 'xomodel.checkout', 'xomodel.auth', 'xo-tray-height.directive']).directive('xoInstallmentOptions', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                doneFn: '=',
	                cardNumber: '='
	            },
	
	            controller: function controller($AuthModel, $scope, $populate, $CheckoutSessionModel, $InstallmentOptionsModel, $CheckoutPayeeModel, $CheckoutCartModel, $CheckoutAppDataModel) {
	
	                $populate($scope, {
	                    auth: $AuthModel.instance($scope.token)
	                }).then(function () {
	
	                    if ($scope.auth.logged_in) {
	
	                        // Installment support for authenticated user
	                        $populate($scope, {
	                            checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                        }).then(function () {
	                            $scope.cardInfo = $scope.checkoutSession.plan.sources[0];
	                            $scope.installments = $scope.checkoutSession.installments;
	                        });
	                    } else {
	                        // Installment support added for not authenticated user, e.g. BR signup flow
	                        var installmentsModel = $InstallmentOptionsModel.instance($scope.token);
	
	                        installmentsModel.save({
	                            data: {
	                                cc: $scope.cardNumber,
	                                payee: $CheckoutPayeeModel.instance($scope.token),
	                                checkoutCart: $CheckoutCartModel.instance($scope.token),
	                                checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                            },
	
	                            success: function success(result) {
	                                $scope.cardInfo = result.cardInfo;
	                                $scope.installments = result.installment_options;
	                            }
	                        });
	                    }
	                });
	
	                $scope.onSelect = function (index) {
	                    var selectedInstallmentData = $scope.installments[index];
	                    $scope.installmentsModel = $InstallmentOptionsModel.instance($scope.token);
	
	                    var param = {
	                        term: selectedInstallmentData.term,
	                        payment_value: selectedInstallmentData.monthly_payment.value,
	                        payment_currency: selectedInstallmentData.monthly_payment.currency
	                    };
	
	                    if (selectedInstallmentData.discount_amount) {
	                        param.discount_value = selectedInstallmentData.discount_amount.value;
	                        param.discount_currency = selectedInstallmentData.monthly_payment.currency;
	                    }
	
	                    if (selectedInstallmentData.discount_percentage) {
	                        param.discount_percentage = selectedInstallmentData.discount_percentage;
	                    }
	
	                    return $scope.installmentsModel.action('select', {
	                        data: param,
	
	                        success: function success(result) {
	                            if ($scope.auth.logged_in) {
	                                $scope.checkoutSession.selectedInstallmentData = selectedInstallmentData;
	                            }
	                            $scope.doneFn(result);
	                        }
	                    });
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/installment-options/template.html":
/***/ function(module, exports) {

	module.exports = "<div content class=\"aside installmentOptions\" ng-class=\"{true: 'signupflow'}[!auth.logged_in]\" >\n    <div class=\"cardInfo\" ng-if=\"cardInfo\">\n        <span class=\"ccard {{cardInfo.card_type}}\" id=\"creditCard\" role=\"img\" aria-label=\"{{cardInfo.name}}\"></span> {{cardInfo.name}} x-{{cardInfo.last4}}&nbsp;<span class=\"installmentText\" ng-if=\"installments\">{{content('installments.upto')}}&nbsp;{{installments.length}}x</span>\n    </div>\n    <ul class=\"asideContent items\" ng-if=\"installments\">\n        <li class=\"installment\" ng-repeat=\"installment in installments\" ng-click=\"onSelect($index)\" track-submit>\n            <div class=\"term\">\n                <span>{{installment.term}}x {{content('installments.of')}}&nbsp;</span>\n            </div>\n            <div class=\"display\">\n                <span>{{installment.monthly_payment.formatted_value}}</span>\n                <div class=\"confidential total\">\n                    <span>{{content('installments.total')}}: {{installment.total}}</span>\n                    <span class=\"save\" ng-if=\"installment.discount_amount\">\n                        {{content('installments.save')}} {{installment.discount_amount.formatted_value}}\n                    </span>\n                </div>\n            </div>\n\n        </li>\n    </ul>\n</div>"

/***/ },

/***/ "./pages/xo-wallet/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarWalletRoute = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _route = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	var _route3 = __webpack_require__("./components/xo-credit-components/src/apply-ppc/route.js");
	
	var _route4 = _interopRequireDefault(_route3);
	
	__webpack_require__("./pages/xo-wallet/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $SidebarWalletRoute = exports.$SidebarWalletRoute = _squid.$ComponentRoute.extend('$SidebarWalletRoute', {
	
	    path: 'wallet',
	    directive: 'xo-wallet',
	    titleContent: 'asideHeader.wallet',
	    trackingData: {
	        fptiState: 'funding_option_selection',
	        templateName: 'fundingInstruments.dust',
	        pageGoal: 'Change Instruments',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-wallet-fundingsources',
	                'pagename2': '%::fullpage-wallet-fundingsources:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        route: _route2['default'],
	        attributes: {
	            token: 'token',
	            phone: 'phone',
	            cardmodel: 'cardModel'
	        }
	    }, {
	        route: _route4['default'],
	        props: function props() {
	            return {
	                token: this.token
	            };
	        }
	    }]
	});
	
	angular.value("$SidebarWalletRoute", $SidebarWalletRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-wallet/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/credit/index.js");
	
	__webpack_require__("./components/xo-tray-height/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/popup/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/accessibility/directive.js");
	
	var _template = __webpack_require__("./pages/xo-wallet/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-wallet/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend({
	
	    tag: 'xo-wallet',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        promotion: {
	            type: 'var',
	            required: false
	        },
	
	        installment: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var $scope = this;
	
	            $scope.locale = _squid.$locale;
	            $scope.showDisallowedMessage = false;
	            $scope.toggleDisallowedMessage = function () {
	                $scope.showDisallowedMessage = !$scope.showDisallowedMessage;
	            };
	
	            $scope.doneFn = function (result) {
	                if ($scope.checkoutSession.plan.paypal_credit && $scope.installment.showCYCO) {
	                    _uiRouter.$state.go('checkout.chooseCreditOffer');
	                } else {
	                    _uiRouter.$state.go('checkout.review');
	                }
	            };
	
	            $scope.showDualFi = (0, _squid.$feature)('addBank');
	
	            (0, _squid.$populate)($scope, {
	                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
	                cart: _index.$CheckoutCartModel.create($scope.token),
	                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
	            }).then(function () {
	                $scope.disallowedPreferredInstrument = $scope.checkoutSession.getDisallowedPreferred();
	                $scope.isBillingNoPurchase = $scope.cart.isBillingNoPurchase();
	
	                if ((0, _squid.$feature)('giftCard')) {
	                    $scope.showGC = Math.random() < 0.01 && !$scope.isBillingNoPurchase;
	
	                    if ($scope.showGC) {
	                        _logger.$logger.info('wallet_gift_card_redeem_link_shown');
	                    } else {
	                        _logger.$logger.info('wallet_gift_card_redeem_link_not_shown');
	                    }
	                }
	
	                // Manage wallet feature can be turned on by country.
	                // User will see manage link on wallet page if feature is turned on and has FIs allowed to edit.
	                if ((0, _squid.$feature)('enableManageWallet')) {
	                    var instruments = $scope.checkoutSession.get('fundingOptions.instruments');
	                    var managebleFIs = _squid.$util.filter(instruments, function (funding) {
	                        if (funding && !funding.editDisallowedMsg) {
	                            return funding;
	                        }
	                    });
	
	                    $scope.showManageLink = managebleFIs && managebleFIs.length > 0;
	                }
	
	                var creditDataModel = _index3.$CreditDataModel.instance($scope.token);
	                $scope.checkoutSession.message = null;
	                $scope.showAddLink = _squid.$locale.country !== 'DE';
	                $scope.showPlcc = $scope.checkoutSession.plccOffer && !$scope.cart.isBilling();
	                $scope.showBML = function () {
	                    return _squid.$locale.country !== 'GB' && ($scope.checkoutSession.bmlOffer === 1 || $scope.checkoutSession.bmlOffer === 2) && !$scope.isBillingNoPurchase && !$scope.installment.showBanner && !creditDataModel.isRedirectFromCape();
	                };
	
	                $scope.bml = function () {
	                    _uiRouter.$state.go('.applyPPC');
	                };
	
	                $scope.onRedeemGC = function () {
	                    throw new _squid.$FallbackError({
	                        reason: 'redeem_coupon_feature_not_supported',
	                        product: 'ux',
	                        entryPoint: 'giftCard'
	                    });
	                };
	
	                $scope.addPlcc = function () {
	                    if ($scope.promotion) {
	                        $scope.promotion.type = 'plcc';
	                    }
	                    _uiRouter.$state.go('checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard');
	                };
	
	                $scope.sacEligible = function (fsName) {
	                    // Return false for non BML products
	                    if (fsName !== 'BILL_ME_LATER') {
	                        return false;
	                    }
	
	                    if (!$scope.installment.showCYCO && parseFloat($scope.cart.purchase.amounts.total.amount) >= _index.$CreditOptionsModel.sacEligibleAmount[_squid.$locale.country]) {
	                        return true;
	                    }
	                };
	
	                $scope.cardModel = new _index2.$AddCardModel({
	                    card: new _index2.$CardModel()
	                });
	
	                $scope.creditOffer = function () {
	                    _uiRouter.$state.go('checkout.chooseCreditOffer');
	                };
	
	                $scope.userSelectedFI = $scope.checkoutSession.getSelectedStickyInstrument() && $scope.checkoutSession.getSelectedStickyInstrument().instrument_id;
	
	                $scope.updateStickyFS = function (stickyFI) {
	                    if (stickyFI.instrument_id !== $scope.userSelectedFI) {
	                        $scope.checkoutSession.action('setStickyFI', {
	                            data: {
	                                instrument_id: stickyFI.instrument_id
	                            },
	                            success: function success(result) {
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['paymentMethod.paymentMethodUpdated']
	                                };
	                                $scope.doneFn(result);
	                            }
	                        });
	                    } else {
	                        _uiRouter.$state.go('checkout.review');
	                    }
	                };
	
	                $scope.updateFS = function (fundingsource, $index) {
	
	                    if (fundingsource.infoMsg) {
	                        $scope.disallowedIndex = $index;
	                        return;
	                    }
	
	                    $scope.checkoutSession.message = null;
	
	                    if (fundingsource.planId === $scope.checkoutSession.plan.id) {
	                        $scope.doneFn();
	                        return;
	                    }
	
	                    $scope.checkoutSession.fundingOptions.action('select', {
	
	                        data: {
	                            planId: fundingsource.planId
	                        },
	                        success: function success(result) {
	
	                            $scope.checkoutSession.populate(result);
	
	                            if (result) {
	                                // Update the installments to support the user selecting a card that does not support installments.
	                                $scope.checkoutSession.installments = result.installments;
	                            }
	
	                            if ($scope.checkoutSession.plan.paypal_credit && $scope.installment.showCYCO) {
	                                _uiRouter.$state.go('checkout.chooseCreditOffer');
	                            } else {
	                                if (!fundingsource.selected) {
	                                    $scope.checkoutSession.message = {
	                                        type: 'success',
	                                        msgKeys: ['paymentMethod.paymentMethodUpdated']
	                                    };
	                                    if ($scope.checkoutSession.selectedInstallmentData && !$scope.checkoutSession.selectedInstallmentData.preventChange) {
	                                        // Resetting selected installment data, if installment change is not explicitly prohibited.
	                                        $scope.checkoutSession.selectedInstallmentData = undefined;
	                                    }
	                                }
	
	                                $scope.doneFn(result);
	                            }
	                        },
	                        contingencies: {
	                            NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
	                                if (result && result.resolution) {
	                                    var card = result.resolution.data;
	
	                                    if (card.fundingId && card.fi && card.fi.type) {
	                                        $scope.cardModel.id = card.fundingId;
	                                        $scope.cardModel.card = new _index2.$CardModel({
	                                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
	                                            type: card.fi.type.toUpperCase(),
	                                            productType: card.fi.productType
	                                        });
	                                    }
	                                }
	
	                                _uiRouter.$state.go('.confirmUpop');
	                            }
	                        }
	                    });
	                };
	            });
	        }
	    }
	});
	
	
	_uiRouter.$state;
	
	_squid.$Component;
	
	_squid.$populate;
	
	_squid.$FallbackError;
	
	_squid.$feature;
	
	_squid.$locale;
	
	_squid.$util;
	
	_logger.$logger;
	
	_index.$CheckoutSessionModel;
	
	_index.$CheckoutCartModel;
	
	_index.$CheckoutAppDataModel;
	
	_index.$CreditOptionsModel;
	
	_index2.$AddCardModel;
	
	_index2.$CardModel;
	
	_index3.$CreditDataModel;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-wallet/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-aside-header ng-if=\"showManageLink\" hdrtype='tall' heading='asideHeader.fundingInstruments'\n                 sub-header-left-link='checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'\n                 sub-header-left=\"asideHeader.add\"\n                 sub-header-left-icon=\"true\"\n                 sub-header-right-link='checkout.review.sidebar.sidebarManageWallet'\n                 sub-header-right=\"asideHeader.manage\"\n                 sub-header-right-icon=\"true\"\n                 show-dual-fi=\"showDualFi\"></xo-aside-header>\n<xo-aside-header hdrtype='tall' heading='asideHeader.fundingInstruments'\n                 ng-if=\"!showManageLink\"\n                 sub-header-left-link='checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'\n                 sub-header-left=\"asideHeader.add\"\n                 sub-header-left-icon=\"true\"\n                 show-dual-fi=\"showDualFi\"></xo-aside-header>\n<div class=\"asideContent fundingCards\" id=\"selectFunding\" content xo-tray-height>\n    <div class=\"allCards\">\n        <ul class=\"allPlanList clearfix\" select-box=\"checkoutSession.fundingOptions.plans\" select-allow-tab-escape>\n            <!--Disallowed Preferred Instrument-->\n            <li ng-if=\"disallowedPreferredInstrument && !isBillingNoPurchase\" class=\"fundingsource\">\n                <a href=\"#\" prevent-default class=\"source\" role=\"button\">\n                    <div class=\"disallowedContainer\">\n                        <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"disallowedPreferredInstrument.isPinlessDebit\"></span>\n                        <span class=\"fsIcon\" ng-class=\"[disallowedPreferredInstrument.type, disallowedPreferredInstrument.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                        <p class=\"fsdetails\">\n                            <span ng-if=\"disallowedPreferredInstrument.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                            <span ng-if=\"!disallowedPreferredInstrument.isPinlessDebit\">{{content('fsMappings.'+disallowedPreferredInstrument.name) || disallowedPreferredInstrument.name}}</span>\n                            <span class=\"lastdigits\" ng-if=\"disallowedPreferredInstrument.lastDigits\">x-{{disallowedPreferredInstrument.lastDigits}}\n                                <span class=\"subtype\" ng-if=\"locale.country === 'DE' && disallowedPreferredInstrument.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                <span class=\"subtype\" ng-if=\"locale.country === 'DE' && disallowedPreferredInstrument.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                <span class=\"subtype\" ng-if=\"disallowedPreferredInstrument.subtype === 'ECHECK'\">{{content('fundingInstruments.eCheck')}}</span>\n                            </span>\n                        </p>\n                        <span class=\"infoIcon\" ng-click=\"toggleDisallowedMessage()\"></span>\n\n                    </div>\n                    <div ng-class=\"{showMsg: showDisallowedMessage}\">\n                        <p class=\"infoMsg\">\n                            {{content('wallet.'+disallowedPreferredInstrument.declineReason)}}\n                        </p>\n                    </div>\n                </a>\n            </li>\n            <!--List of Plans-->\n            <li role=\"presentation\" class=\"fundingsource\" ng-repeat=\"plan in checkoutSession.getPlanList()\" ng-if=\"!isBillingNoPurchase\">\n                <a track-submit href=\"#\" prevent-default class=\"source\" ng-click=\"updateFS(plan, $index)\" role=\"button\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !plan.infoMsg}\" select-option=\"plan.selected\" focus-when=\"plan.selected\" ng-attr-aria-selected=\"{{ plan.selected ? 'true' : undefined }}\">\n\n                    <span class=\"checkIcon\" ng-if=\"plan.selected\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                    <div class=\"instrumentContainer\" ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length\">\n                        <p class=\"fsdetails\" ng-class=\"[plan.secondaryFIs[0].type]\">\n                            <span class=\"fsIcon\" ng-class=\"[plan.secondaryFIs[0].type, plan.secondaryFIs[0].name]\"></span>\n                            <span class=\"fsName\">{{content('fsMappings.'+ plan.secondaryFIs[0].name) || plan.secondaryFIs[0].name}}</span>\n                            <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                            <span class=\"amount\" ng-if=\"plan.secondaryFIs.length === 1 && plan.secondaryFIs[0].amount\">{{plan.secondaryFIs[0].amount.amount_formatted}}</span>\n                        </p>\n                    </div>\n                    <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\">\n                        <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                        <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                        <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                            <span ng-switch=\"plan.primaryFs.subtype\">\n                                <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                    <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span><br>\n                                    <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}}</span>\n                                    <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                </span>\n                                <span ng-switch-default>\n                                    <span class=\"fsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                    <!--<span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\" ng-bind-html=\"content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name + '&#8207;').toString()\"></span>-->\n                                    <span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                    <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}\n                                        <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                        <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                        <span class=\"subtype\" ng-if=\"plan.primaryFs.subtype === 'ECHECK'\">{{content('fundingInstruments.eCheck')}}</span>\n                                    </span>\n                                    <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                                </span>\n                            </span>\n                            <span class=\"amount\" ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length === 1 && plan.primaryFs.amount\">{{plan.primaryFs.amount.amount_formatted}}</span>\n                            <span ng-if=\"sacEligible(plan.primaryFs.name)\">\n                                <span class=\"bmlDetails\" bind-html-compile=\"htmlContent('fundingInstruments.bmlDetailsWallet')\"></span>\n                            </span>\n                        </p>\n                    </div>\n                </a>\n            </li>\n\n            <li role=\"presentation\" class=\"fundingsource fs-item\" ng-repeat=\"stickyFI in checkoutSession.futurePaymentInstruments\" ng-if=\"isBillingNoPurchase\">\n                <a class=\"source\" ng-click=\"updateStickyFS(stickyFI)\" select-option role=\"button\" ng-attr-aria-selected=\"{{ (stickyFI.instrument_id===userSelectedFI) ? 'true' : undefined }}\">\n                    <span class=\"fsIcon\" ng-class=\"[stickyFI.type, stickyFI.name, stickyFI.card_type]\"></span>\n                    <p class=\"fsdetails\">\n                        <span ng-switch=\"fundingsource.subtype\">\n                            <span ng-switch-default>\n                                <span class=\"name\">{{content('fsMappings.'+ stickyFI.name) || stickyFI.name}}</span>\n                                <span class=\"lastdigits\" ng-if=\"stickyFI.last4\">x-{{stickyFI.last4}}</span>\n                            </span>\n                        </span>\n                    </p>\n                    <span class=\"checkIcon\" ng-if=\"stickyFI.instrument_id===userSelectedFI\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                </a>\n            </li>\n\n            <li role=\"presentation\" ng-if=\"showBML()\"\n                class=\"trayInner trayInnerDefault offerTile\">\n                <form class=\"bmlAsideOffer\">\n                    <div class=\"fundingContainerBml\">\n                        <div ng-if=\"checkoutSession.bmlOffer===1\" class=\"largeOffer\">\n                            <div class=\"bmlHeader clearfix\">\n                                <p class=\"bmlTitle\" ng-bind-html=\"content('offers.bmlOfferLargeTitle')\"></p>\n                                <a ng-click=\"bml()\" id=\"bmlApplyLink\" class=\"bmlApply\" link-button>{{content('offers.bmlOfferBtn')}}</a>\n                            </div>\n                            <div class=\"fundingContainerBmlOffer disclaimer clearfix\"\n                                  bind-html-compile=\"content('offers.bmlOfferLarge')\"></div>\n                            <div class=\"seeTermsLink fundingContainerBmlOffer disclaimer\">\n                                {{content('applyForBml.subjectApproval')}}\n                                <a ng-click=\"$event.stopPropagation()\" href='https://www.securecheckout.billmelater.com/paycapture-content/fetch?hash=AU826TU8&content=/bmlweb/bmlppaiw.html' class='popup bmlTermsLink' target='_blank' xo-popup>{{content('applyForBml.seeTerms')}}</a>\n                            </div>\n                        </div>\n\n                        <div ng-if=\"checkoutSession.bmlOffer===2\" class=\"smallOffer\">\n                            <div class=\"bmlHeader\">\n                                <p class=\"bmlTitle\" ng-bind-html=\"content('offers.bmlOfferSmallTitle')\"></p>\n                                <a ng-click=\"bml()\" id=\"bmlApplyLink\" class=\"bmlApply\" link-button>{{content('offers.bmlOfferBtn')}}</a>\n                            </div>\n                            <div class=\"fundingContainerBmlOffer disclaimer clearfix\"\n                                  bind-html-compile=\"content('offers.bmlOfferSmall')\"></div>\n                            <div class=\"seeTermsLink fundingContainerBmlOffer disclaimer\">\n                                {{content('applyForBml.subjectApproval')}}\n                                <a ng-click=\"$event.stopPropagation()\" href='https://www.securecheckout.billmelater.com/paycapture-content/fetch?hash=AU826TU8&content=/bmlweb/bmlppaiw.html' class='popup bmlTermsLink' target='_blank' xo-popup>{{content('applyForBml.seeTerms')}}</a>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </li>\n\n            <li role=\"presentation\" ng-if=\"installment.showBanner\"\n                class=\"trayInner trayInnerDefault editable offerTile\" ng-click=\"creditOffer()\">\n                <form class=\"bmlAsideOffer\">\n                    <div class=\"fundingContainerBml\">\n                            <div>\n                            <div class=\"creditOffer\" ng-if=\"locale.country !== 'GB'\" class=\"proceed\"\n                               select-option>{{content('offers.bmlOfferSmallTitle')}}</div>\n                            <div class=\"creditOffer\" ng-if=\"locale.country === 'GB'\" ng-click=\"creditOffer()\"\n                                 class=\"proceed\"\n                               select-option>{{content('offers.bmlWalletTitle')}}</div>\n                            <div class=\"cycoApplyLink\">\n                            <a link-button ng-click=\"creditOffer()\" class=\"proceed\">{{content('offers.cycoOfferBtn')}}\n                                <span class=\"frontArrow goTray\"></span>\n                            </a>\n                            </div>\n                            </div>\n                            <div class=\"fundingContainerBmlOffer disclaimer clearfix\"\n                                      bind-html-compile=\"htmlContent('applyForBml.subjectApproval')\">\n                            </div>\n                    </div>\n                </form>\n            </li>\n\n            <!-- Gift Card link offer -->\n            <!-- changes for the coupon remdeem -->\n            <li role=\"presentation\" ng-if=\"showGC\" class=\"fundingsource redeemGC\" ng-click=\"onRedeemGC()\">\n                <p class=\"addOption\">\n                    <span>\n                        <a ng-click=\"onRedeemGC()\" class=\"proceed\" select-option> {{ content('memberReview.redeemGiftLink') }} {{ content('memberReview.giftCardDec') }}</a>\n                    </span>\n                </p>\n            </li>\n\n            <li role=\"presentation\" ng-if=\"showPlcc\" class=\"trayInner trayInnerDefault editable offerTile\"\n                ng-click=\"addPlcc()\">\n                <form class=\"bmlAsideOffer\">\n                    <div class=\"fundingContainerPlcc\">\n                        <div class=\"plccOfferHeader\">\n                            <img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n                            <p class=\"headerText\"> {{ content('memberReview.plccCardOfferHeader',{merchantName:promotion.name}) }}</p>\n                            <p class=\"plccOfferDesc\">{{ content('memberReview.plccCardOfferDesc',{merchantName:promotion.name})}}</p>\n                        </div>\n\n                    </div>\n                    <input type=\"hidden\" name=\"_csrf\" value=\"{data._csrf}\"/>\n                </form>\n            </li>\n        </ul>\n    </div>\n\n    <ui-view></ui-view>\n\n</div>\n"

/***/ },

/***/ "./pages/xo-wallet/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-wallet/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-wallet/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#selectFunding .infoIcon{background-position:-139px -1px;top:26px;right:12px}#selectFunding.asideContent{clear:both}#selectFunding .items{margin:0;width:100%;list-style:none}#selectFunding .items .addBtnItem{margin:0;padding:20px 10px;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out}#selectFunding .items .addBtnItem:focus,#selectFunding .items .addBtnItem:hover{background-color:#f7f9fa}#selectFunding .address:after{content:\"\";width:100%;display:block;position:absolute;bottom:-2px;left:0}#selectFunding .backArrowContainer{margin-left:41px}#selectFunding .display .adr{margin-top:3px;color:#6c7378;font-weight:lighter;font-size:.85em;width:90%}#selectFunding .secondHalf{float:right}#selectFunding .review{float:left;width:65%}#selectFunding .editCard{font-size:1em}#selectFunding .add{cursor:pointer;display:block}#selectFunding .add:hover{text-decoration:none}#selectFunding .add .btn{display:inline-block;vertical-align:middle;width:29px;height:29px;background:url(https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_flat.png) 7px -895px no-repeat}#selectFunding .fundingContainerPAD .lastdigits,#selectFunding .fundingContainerPAD .name{color:#6c7378;font-size:.85em;margin-bottom:0}#selectFunding .checkIcon{width:24px;height:17px;display:inline-block;position:absolute;top:40%;right:11px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-192px -2px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectFunding .checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectFunding .addAddressContent{width:73%;display:inline-block;vertical-align:middle;color:#0070ba;font-weight:400}#selectFunding .addAddressContent:focus,#selectFunding .addAddressContent:hover{text-decoration:underline}#selectFunding .addIcon{display:inline-block;width:20px;height:20px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectFunding .addIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectFunding .bmlAsideOffer{padding:15px 10px}#selectFunding .offerTile{background-color:#f7f9fa}#selectFunding .fundingContainerBml{padding-left:5px;position:relative;min-height:35px}#selectFunding .fundingContainerBmlOffer{font-size:.85em;line-height:1.15em;padding:0;display:block}#selectFunding .bmlTitle{display:inline-block;width:65%;font-size:1em;margin-bottom:5px}#selectFunding .bmlApply{display:inline-block;float:right;width:35%;font-size:.85em;text-align:right}#selectFunding .seeTermsLink{font-size:.75em;margin-top:10px}#selectFunding .fundingContainerPlcc{cursor:pointer;position:relative;min-height:35px}#selectFunding .fundingContainerPlcc .p{margin-left:30px}#selectFunding .redeemGC{margin-top:0;cursor:pointer}#selectFunding .bmlTermsLink{color:#0079ad}#selectFunding .bmlTermsLink:focus,#selectFunding .bmlTermsLink:hover{text-decoration:underline;background-color:transparent}#selectFunding .bmlDetails{display:inline-block;width:100%;font-size:.85em;padding-top:0}#selectFunding .plccAddNowLink{cursor:pointer;position:absolute;top:2px;right:0;font-size:.85em}#selectFunding .plccOfferDesc{margin-top:3px;font-size:.68em;color:#666}#selectFunding .headerText,#selectFunding .plccOfferDesc{margin-left:40px;margin-bottom:0}#selectFunding .fsIcon{float:left;position:inherit}#selectFunding .plccInstIcon{float:left;display:inline-block;height:20px;top:22px;left:15px;background:none;width:25px}#selectFunding .fsIcon.PLCC{background-image:none}#selectFunding #bmlApplyLink{line-height:1.75em}#selectFunding .creditOffer{display:inline-block;width:70%;line-height:1.25em}#selectFunding .cycoApplyLink{display:inline-block;top:-3px}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-sidebar-manage-wallet/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-sidebar-manage-wallet/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Route.extend('$SidebarManageWalletRoute', {
	
	    path: 'sidebarManageWallet',
	    directive: _directive2['default'],
	    trackingData: {
	        fptiState: 'manage_wallet',
	        templateName: 'tray/manageWallet',
	        pageGoal: 'Manage Instruments',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-manage-wallet',
	                'pagename2': '%::fullpage-manage-wallet:member:hermes:tray',
	                'version': 'member:%:tray'
	            }
	        }
	    },
	    loginRequired: true,
	    children: []
	});
	
	
	_squid.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-sidebar-manage-wallet/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-tray-height/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/popup/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/accessibility/directive.js");
	
	var _template = __webpack_require__("./pages/xo-sidebar-manage-wallet/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-sidebar-manage-wallet/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$SidebarManageWalletDirective', {
	
	    tag: 'xo-manage-wallet',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        showInfoMsg: function showInfoMsg($index) {
	            this.disallowedIndex = $index;
	        },
	        confirm: function confirm($index) {
	            this.selectedIndex = $index;
	            this.deleteCard = true;
	        },
	        deleteFS: function deleteFS(fundingsource) {
	            var _this = this;
	
	            /* Call walletfiserv to delete selected card and call Symphony's notifyChangeFundingInstruments api
	             to get back updated funding options.
	             */
	            this.deleteCardModel = new _index.$DeleteCardModel({
	                id: fundingsource.id
	            });
	
	            this.deleteCardModel.save({
	                data: this.deleteCardModel,
	
	                contingencies: {
	                    DELETE_CARD_CONTINGENCY: function DELETE_CARD_CONTINGENCY() {
	                        _this.handleSingleContingency('creditcard.errorDeleteCard');
	                        return;
	                    }
	                },
	
	                error: function error() {
	                    _this.handleSingleContingency('creditcard.errorDeleteCard');
	                    return;
	                },
	
	                /* Call notifyChangeFundingInstruments to get updated funding options from checkout session
	                 During this call if any error or contignecies return back, just remove the deleted FI from checkout
	                 session as its already deleted successfully
	                 */
	
	                success: function success() {
	                    _this.models.checkoutSession.fundingOptions.action('notifyChange', {
	                        resultModel: _this.models.checkoutSession,
	
	                        data: {
	                            planId: fundingsource.id,
	                            operation: 'REMOVED'
	                        },
	                        success: function success() {
	                            _logger.$logger.info('manage_wallet: deleted FI - 1', fundingsource.id);
	                            _this.selectedIndex = -1;
	                            _this.disallowedIndex = -1;
	                        },
	                        contingencies: {
	                            NOTIFY_FUNDING_CHANGE_CONTINGENCY: function NOTIFY_FUNDING_CHANGE_CONTINGENCY() {
	                                _this.removeFIFromCheckoutSession(fundingsource);
	                                return;
	                            }
	                        },
	                        error: function error() {
	                            _this.removeFIFromCheckoutSession(fundingsource);
	                            return;
	                        }
	                    });
	                }
	            });
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            this.models.checkoutSession.reload();
	            if (this.models.checkoutSession) {
	                this.message = this.models.checkoutSession.message;
	                this.isSysmtemError = this.message && this.message.type === 'error';
	                this.models.checkoutSession.message = null;
	            }
	        },
	        enter: function enter() {
	
	            this.locale = _squid.$locale;
	            this.doneFn = function (result) {
	                _uiRouter.$state.go('checkout.review');
	            };
	
	            this.handleSingleContingency = function (errorKey) {
	                var messages = [];
	
	                messages.push(_squid.$locale.content.get(errorKey));
	
	                this.message = {
	                    msgs: messages,
	                    type: 'error'
	                };
	                this.isSysmtemError = true;
	                this.selectedIndex = -1;
	                this.disallowedIndex = -1;
	            };
	
	            this.removeFIFromCheckoutSession = function (fundingsource) {
	                this.models.checkoutSession.fundingOptions.instruments = this.models.checkoutSession.fundingOptions.instruments.filter(function (item) {
	                    return item.id !== fundingsource.id;
	                });
	            };
	        }
	    }
	});
	
	
	_uiRouter.$state;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_logger.$logger;
	
	_index.$DeleteCardModel;
	
	_index2.$CheckoutSessionModel;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-sidebar-manage-wallet/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-aside-header heading='asideHeader.manageWallet' back-url='checkout.review.sidebar.wallet'></xo-aside-header>\n\n    <div class=\"asideContent fundingCards\" id=\"manageFunding\" content xo-tray-height>\n        <xo-message message=\"message\"></xo-message>\n        <div class=\"allCards\">\n            <ul class=\"allFundingInstrumentsList clearfix\" select-box=\"models.checkoutSession.fundingOptions.instruments\" select-allow-tab-escape>\n                <li role=\"presentation\" class=\"fundingsource item\" ng-repeat=\"fundingsource in models.checkoutSession.fundingOptions.instruments\" ng-if=\"!isBillingNoPurchase\">\n                    <div class=\"source\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !fundingsource.editDisallowedMsg}\">\n                        <div ng-class=\"{'rowMask':fundingsource.editDisallowedMsg, slide: ($index == selectedIndex && deleteCard)}\">\n                            <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fundingsource.isPinlessDebit\"></span>\n                            <span class=\"fsIcon\" ng-class=\"[fundingsource.type, fundingsource.name]\" ng-if=\"!fundingsource.isPinlessDebit\">\n                                <img class=\"plccInstIcon\" ng-src=\"{{fundingsource.productUrl}}\" ng-show=\"fundingsource.type === 'PLCC'\">\n                            </span>\n                            <p class=\"fsdetails\">\n                                <span ng-switch=\"fundingsource.subtype\">\n                                    <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                        <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span>\n                                        <span class=\"name\">{{content('fsMappings.'+fundingsource.name) || fundingsource.name}}</span>\n                                        <span class=\"lastdigits\" ng-if=\"fundingsource.lastDigits\">x-{{fundingsource.lastDigits}}</span>\n                                    </span>\n                                    <span ng-switch-default>\n                                        <span class=\"name\" ng-if=\"fundingsource.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                        <span class=\"name\" ng-if=\"!fundingsource.isPinlessDebit\">{{content('fsMappings.'+fundingsource.name) || fundingsource.name}}</span>\n                                        <span class=\"lastdigits\" ng-if=\"fundingsource.lastDigits\">x-{{fundingsource.lastDigits}}</span>\n                                    </span>\n                                </span>\n                            </p>\n                        </div>\n\n                        <a ng-if=\"fundingsource.editDisallowedMsg && (disallowedIndex !== $index)\" ui-sref=\"checkout.review.sidebar.sidebarManageWallet\" ng-click=\"actions.showInfoMsg($index)\" class=\"infoIcon\" ></a>\n                        <p ng-if=\"fundingsource.editDisallowedMsg\" class=\"infoMsg\" ng-class=\"{showMsg: ($index == disallowedIndex)}\">\n                            {{content('wallet.'+fundingsource.editDisallowedMsg)}}\n                        </p>\n\n                        <div class=\"manageLinks\" ng-class=\"{slideOut: ($index == selectedIndex && deleteCard)}\" ng-if=\"!fundingsource.editDisallowedMsg &&  ($index !== selectedIndex) && !isSysmtemError \">\n                            <a track-submit=\"update_card\" ui-sref='checkout.review.sidebar.sidebarUpdateCard.addCardFlow.addCard({planId: fundingsource.id})' class=\"updateButton\">\n                                <span>{{content('wallet.update')}}</span>\n                            </a>\n                            <span class=\"vertical\"></span>\n                            <a href=\"\" link-button class=\"deleteButton\" ng-click=\"actions.confirm($index)\">{{content('wallet.delete')}}</a>\n                        </div>\n                        <div ng-class=\"{slideIn: ($index == selectedIndex && deleteCard)}\" class=\"confirm\" ng-if=\"!fundingsource.editDisallowedMsg && ($index === selectedIndex) && !isSysmtemError\">\n                            <a href=\"\" link-button track-submit=\"delete_card\" class=\"confirmButton\" ng-click=\"actions.deleteFS(fundingsource)\">{{content('common.confirm')}}</a>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n\n\n"

/***/ },

/***/ "./pages/xo-sidebar-manage-wallet/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-sidebar-manage-wallet/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-sidebar-manage-wallet/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#manageFunding .item{margin:0;position:relative;max-height:200px;overflow:hidden;border-bottom:1px solid #e3e3e3;-webkit-transition:max-height .5s ease;transition:max-height .5s ease}#manageFunding .infoIcon{background-position:-139px -1px;top:26px;right:12px}#manageFunding .pinlessIcon{margin:18px 18px 0 8px}#manageFunding .showMsg .infoMsg{padding:0 15px 5px;position:relative;left:0;width:90%;max-height:40px}#manageFunding .rowMask{opacity:.5}#manageFunding .vertical{height:15px;overflow:visible;border-right:1px solid #ccc}#manageFunding .slide{-webkit-transform:translate(-20%);transform:translate(-20%);-webkit-transition:-webkit-transform .5s ease;transition:transform .5s ease}#manageFunding .confirm,#manageFunding .slideOut{-webkit-transform:translate(102%);transform:translate(102%);-webkit-transition:-webkit-transform .5s ease;transition:transform .5s ease}#manageFunding .confirm{font-size:.85em;display:inline-flex;position:absolute;height:100%;top:0;right:0;padding:0 15px;text-align:center;align-items:center;overflow:hidden;background-color:#009cde}#manageFunding .confirm a{font-weight:700;color:#fff}#manageFunding .slideIn{-webkit-transform:translate(0);transform:translate(0);-webkit-transition:-webkit-transform 1s ease-in-out;transition:transform 1s ease-in-out}#manageFunding .show .confirmButton{right:0;-webkit-transition:all 1s ease-in-out;transition:all 1s ease-in-out}#manageFunding .hide .confirmButton,#manageFunding .show .confirmButton{position:absolute;top:0;display:inline-block;font-size:.8em;color:#fff;border:1px solid #009cde;border-sizing:border-box;background-color:#009cde;height:100%;text-align:center;vertical-align:middle;width:87px;line-height:68px}#manageFunding .hide .confirmButton{right:-223px}#manageFunding .confirmButton:hover{text-decoration:underline;background-color:transparent}#manageFunding .deleteButton{font-size:.8em;color:#0079ad;padding:0 15px 0 10px}#manageFunding .deleteButton:hover{text-decoration:underline;background-color:transparent}#manageFunding .updateButton{font-size:.8em;color:#0079ad;padding-right:5px}#manageFunding .updateButton:hover{text-decoration:underline;background-color:transparent}#manageFunding li a{text-decoration:none;color:#292929}#manageFunding.asideContent{clear:both}#manageFunding .items{margin:0;width:100%;list-style:none}#manageFunding .items .addBtnItem{margin:0;padding:20px 10px;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out}#manageFunding .items .addBtnItem:focus,#manageFunding .items .addBtnItem:hover{background-color:#f7f9fa}#manageFunding .address:after{content:\"\";width:100%;display:block;position:absolute;bottom:-2px;left:0}#manageFunding .backArrowContainer{margin-left:41px}#manageFunding .display .adr{margin-top:3px;color:#6c7378;font-weight:lighter;font-size:.85em;width:90%}#manageFunding .secondHalf{float:right}#manageFunding .review{float:left;width:65%}#manageFunding .editCard{font-size:1em}#manageFunding .add{cursor:pointer;display:block}#manageFunding .add:hover{text-decoration:none}#manageFunding .add .btn{display:inline-block;vertical-align:middle;width:29px;height:29px;background:url(https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_flat.png) 7px -895px no-repeat}#manageFunding .fundingContainerPAD .name{color:#6c7378;font-size:.85em;margin-bottom:0}#manageFunding .checkIcon{width:24px;height:17px;display:inline-block;position:absolute;top:40%;right:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-192px -2px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#manageFunding .checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#manageFunding .addAddressContent{width:73%;display:inline-block;vertical-align:middle;color:#0070ba;font-weight:400}#manageFunding .addAddressContent:focus,#manageFunding .addAddressContent:hover{text-decoration:underline}#manageFunding .addIcon{display:inline-block;width:20px;height:20px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#manageFunding .addIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#manageFunding .fundingContainerPlcc{cursor:pointer;position:relative;min-height:35px}#manageFunding .fundingContainerPlcc .p{margin-left:30px}#manageFunding .plccAddNowLink{cursor:pointer;position:absolute;top:2px;right:0;font-size:.85em}#manageFunding .plccOfferDesc{margin-top:3px;font-size:.68em;color:#666}#manageFunding .headerText,#manageFunding .plccOfferDesc{margin-left:40px;margin-bottom:0}#manageFunding .fsIcon{float:left;position:inherit}#manageFunding .plccInstIcon{float:left;display:inline-block;height:20px;top:22px;left:15px;background:none;width:25px}#manageFunding .fsIcon.PLCC{background-image:none}#manageFunding .manageLinks{position:absolute;top:25px;right:0}#manageFunding .leftIcon{display:inline-block;float:left;width:10px;margin:4px 6px 0 0;background-position:-180px -180px}#manageFunding .leftIcon,#manageFunding .rightIcon{height:10px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v12.png\");background-repeat:no-repeat}#manageFunding .rightIcon{float:right;width:6px;margin:4px 0 0 6px;background-position:-200px -180px}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-sidebar-update-card/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	__webpack_require__("./pages/xo-sidebar-update-card/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-bank/route.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	exports['default'] = _squid.$Route.extend('$SidebarUpdateCardRoute', {
	
	    params: {
	        planId: null
	    },
	    path: 'sidebarUpdateCard',
	    directive: 'xo-sidebar-update-card',
	    titleContent: 'asideHeader.updateCard',
	    trackingData: {
	        templateName: 'tray/updateCard.dust',
	        pageGoal: 'update Card',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-update-cc',
	                'pagename2': '%::fullpage-update-cc:member:hermes:tray',
	                'version': 'member:%:tray'
	            }
	        }
	    },
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            sidebar: 'sidebar',
	            'parent-callbacks': 'callbacks',
	            logout: 'logout',
	            fundingid: 'fundingid'
	        }
	    }]
	});
	
	
	_squid.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-sidebar-update-card/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarUpdateCardComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _template = __webpack_require__("./pages/xo-sidebar-update-card/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarUpdateCardComponent = exports.$xoSidebarUpdateCardComponent = _squid.$Component.extend('$xoSidebarUpdateCardComponent', {
	    tag: 'xo-sidebar-update-card',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.fundingid = _uiRouter.$stateParams.planId;
	            this.sidebar = true;
	            this.callbacks = {
	                finish: function finish() {
	                    _uiRouter.$state.go('checkout.review.sidebar.sidebarManageWallet');
	                }
	            };
	        }
	    }
	});
	
	angular.value("$xoSidebarUpdateCardComponent", $xoSidebarUpdateCardComponent);
	_squid.$Component;
	
	_uiRouter.$state;
	
	_uiRouter.$stateParams;

/***/ },

/***/ "./pages/xo-sidebar-update-card/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside addCard\" id=\"addCard\" content>\n    <ui-view sidebar=\"sidebar\"></ui-view>\n</div>\n"

/***/ },

/***/ "./pages/xo-sidepage/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-sidepage/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	var _route = __webpack_require__("./components/xo-wallet-components/src/topup/topup-amount/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	var _route3 = __webpack_require__("./components/xo-wallet-components/src/topup/topup-funding/route.js");
	
	var _route4 = _interopRequireDefault(_route3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$SidepageRoute', {
	
	    path: 'sidepage',
	    directive: _directive2['default'],
	    children: [{
	        route: _route4['default'],
	        props: function props() {
	            return {
	                token: this.token,
	                success: this.actions.done
	            };
	        }
	    }, {
	        route: _route2['default'],
	        props: function props() {
	            return {
	                token: this.token,
	                success: this.actions.done
	            };
	        }
	    }]
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-sidepage/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _template = __webpack_require__("./pages/xo-sidepage/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoSidepage', {
	
	    tag: 'xo-sidepage',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            required: true,
	            type: 'var'
	        }
	    },
	
	    actions: {
	        done: function done() {
	            (0, _jquery2['default'])('body').removeClass('sidePageOpen');
	            (0, _angular.$timeout)(function () {
	                return _uiRouter.$state.go('checkout.review');
	            }, 300);
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            (0, _jquery2['default'])('body').addClass('sidePageOpen');
	        },
	        exit: function exit() {
	            this.actions.done();
	        }
	    }
	});
	
	
	_angular.$timeout;
	
	_squid.$Component;
	
	_uiRouter.$state;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-sidepage/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"sidepage\" modal-box tabindex=\"-1\">\n    <div ui-view></div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-amount/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./components/xo-wallet-components/src/topup/topup-amount/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoTopupAmountRoute', {
	    path: 'topupAmount',
	    directive: _directive2['default'],
	    children: []
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-amount/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _fi = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/topup/topup-amount/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/topup/topup-amount/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoTopupAmountDirective', {
	    tag: 'xo-topup-amount',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        },
	        success: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                walletPreferences: _fi.$WalletPreferences.instance(this.props.token)
	            };
	        }
	    },
	
	    actions: {
	        selectAmount: function selectAmount(amount) {
	            this.models.walletPreferences.topup.amount = amount;
	            this.success();
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.topupAmounts = _squid.$config.topup.topupAmounts;
	            this.locale = _squid.$locale;
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$config;
	
	_squid.$locale;
	
	_fi.$WalletPreferences;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-amount/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"topupAmountList\" class=\"aside\" modal-box content>\n    <xo-aside-header heading='asideHeader.topupAmount'\n                     hidex=\"true\"\n                     header-left=\"common.back\"\n                     header-left-link=\"success\"\n                     header-left-icon=\"true\"></xo-aside-header>\n    <div class=\"content\">\n        <div tabindex=\"-1\" focus-when=\"true\">{{content(\"topup.topupAmountDesc\")}}</div>\n        <ul>\n            <li ng-repeat=\"amount in topupAmounts\">\n                <a class=\"listItem\" ng-click=\"actions.selectAmount(amount)\" focusable>\n                    <format-currency class=\"formatCurrency amount\" code=\"models.walletPreferences.topup.currency\"\n                                     amount=\"amount\"\n                                     currency-style=\"Currency\"></format-currency>\n                    <span class=\"checkIcon\" ng-if=\"amount === models.walletPreferences.topup.amount\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                </a>\n            </li>\n        </ul>\n    </div>\n</section>\n\n"

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-amount/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/topup/topup-amount/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/topup/topup-amount/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#topupAmountList ul{margin:7px 0 0;position:relative}#topupAmountList li{cursor:pointer;list-style:none;width:99.8%;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out}#topupAmountList li a:hover{background-color:#f7f9fa}#topupAmountList li a:focus{border:2px solid #009cde}#topupAmountList .checkIcon{top:26px;right:2px;width:22px;height:17px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1.png\");background-repeat:no-repeat;background-position:-66px -183px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#topupAmountList .checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1_2x.png\");background-size:119px 209px}}#topupAmountList .listItem{display:block;padding:23px 0;position:relative;text-decoration:none;color:#000;border:2px solid transparent}#topupAmountList .listItem:focus{border:2px solid #009cde}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-funding/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./components/xo-wallet-components/src/topup/topup-funding/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	__webpack_require__("./pages/xo-sidepage-add-card/route.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoTopupFundingRoute', {
	    path: 'topupFunding',
	    directive: _directive2['default'],
	    children: [{
	        name: '$SidepageAddCardRoute',
	        attributes: {
	            token: 'token',
	            callbacks: 'addCardCallbacks'
	        }
	    }]
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-funding/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _fi = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/topup/topup-funding/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/topup/topup-funding/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoTopupFundingDirective', {
	    tag: 'xo-topup-funding',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        },
	        success: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
	                walletPreferences: _fi.$WalletPreferences.instance(this.props.token)
	            };
	        }
	    },
	
	    actions: {
	        selectFundingSource: function selectFundingSource(id) {
	            if (this.models.walletPreferences.topup.fundingSource.instrument_id !== id) {
	                this.models.walletPreferences.topup.fundingSource = this.models.checkoutSession.topupFundingSources.find(function (fs) {
	                    return fs.instrument_id === id;
	                });
	                this.models.checkoutSession.action('setTopupFI', {
	                    data: {
	                        instrument_id: id
	                    },
	                    silent: true
	                });
	            }
	            this.props.success();
	        },
	        addCard: function addCard() {
	            _uiRouter.$state.go('.sidepageAddCard.addCardFlow.addCard');
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.locale = _squid.$locale;
	            this.addCardCallbacks = {
	                finish: function finish() {
	                    if (_this.models.checkoutSession.selectedTopupFundingSource) {
	                        _this.models.walletPreferences.topup.fundingSource = _this.models.checkoutSession.selectedTopupFundingSource;
	                    }
	                    $('#sidepageAddCard').removeClass('sidepageAddCardOpen');
	                    (0, _angular.$timeout)(function () {
	                        return _uiRouter.$state.go('checkout.review');
	                    }, 300);
	                },
	                cancel: function cancel() {
	                    $('#sidepageAddCard').removeClass('sidepageAddCardOpen');
	                    (0, _angular.$timeout)(function () {
	                        return _uiRouter.$state.go('^.^.^');
	                    }, 300);
	                }
	            };
	
	            this.instrumentIconId = function (name) {
	                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
	            };
	        }
	    }
	});
	
	
	_angular.$timeout;
	
	_uiRouter.$state;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_checkout.$CheckoutSessionModel;
	
	_fi.$WalletPreferences;
	
	_fi.$WalletInstrumentNameMapping;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-funding/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"topupFundingList\" class=\"aside\" modal-box content>\n    <xo-aside-header heading='asideHeader.topupFunding'\n                     hidex=\"true\"\n                     header-left-link=\"success\"\n                     header-left=\"common.back\"\n                     header-left-icon=\"true\"\n                     header-right=\"fundingInstruments.addDebitCard=\"\n                     header-right-link=\"'checkout.review.sidepage.topupFunding.sidepageAddCard.addCardFlow.addCard'\"\n                     header-right-icon=\"true\"></xo-aside-header>\n    <div class=\"content\">\n        <div tabindex=\"-1\" focus-when=\"true\">{{content(\"topup.topupFundingDesc\")}}</div>\n        <ul>\n            <li ng-repeat=\"fundingSource in models.checkoutSession.topupFundingSources\" focusable>\n                <a class=\"listItem noLink\" ng-click=\"actions.selectFundingSource(fundingSource.instrument_id)\">\n                    <span class=\"walletIcons\" ng-class=\"[fundingSource.type,\n                                                        instrumentIconId(fundingSource.name),\n                                                        fundingSource.card_type]\"></span>\n                    <div class=\"fsItem\">\n                        <div>{{fundingSource.name}}</div>\n                        <div>x-{{fundingSource.last4 }}</div>\n                        <span class=\"checkIcon\" ng-if=\"fundingSource.instrument_id === models.walletPreferences.topup.fundingSource.instrument_id\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en' && fundingSource.instrument_id === models.walletPreferences.topup.fundingSource.instrument_id\">Selected</span>\n                    </span>\n                    </div>\n                </a>\n            </li>\n            <li>\n                <a href=\"#\" prevent-default link-button ng-click=\"actions.addCard()\" class=\"submit listItem addccLink\">\n                    <span class=\"icon\"></span>\n                    <span class=\"description\">{{content('fundingInstruments.addDebitCard')}}</span>\n                </a>\n            </li>\n        </ul>\n    </div>\n</section>\n<div ui-view></div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-funding/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/topup/topup-funding/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/topup/topup-funding/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#topupFundingList ul{margin:7px 0 0;position:relative;height:calc(100vh - 180px);overflow-y:auto}#topupFundingList li{cursor:pointer;list-style:none;width:99.8%;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out}#topupFundingList li a:hover{background-color:#f7f9fa}#topupFundingList li:last-child{border:none}#topupFundingList li:last-child a:hover{background-color:#f7f9fa}#topupFundingList .checkIcon{top:26px;right:2px;width:22px;height:17px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1.png\");background-repeat:no-repeat;background-position:-66px -183px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#topupFundingList .checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1_2x.png\");background-size:119px 209px}}#topupFundingList .noLink{text-decoration:none}#topupFundingList .listItem{display:block;padding:23px 0;position:relative;color:#000;border:2px solid transparent}#topupFundingList .listItem:focus{border:2px solid #009cde}#topupFundingList .listItem .walletIcons{top:25px}#topupFundingList .listItem .fsItem{margin-left:35px}#topupFundingList .description{color:#0070ba}#topupFundingList .description:focus{color:#005ea6}#topupFundingList .listItem.addccLink,#topupFundingList .listItem.addccLink:focus{border:none}#topupFundingList .listItem.addccLink .icon{display:inline-block;float:left;width:10px;height:10px;margin:4px 6px 0 0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-180px -180px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#topupFundingList .listItem.addccLink .icon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#topupFundingList .listItem.addccLink .icon:focus,#topupFundingList .listItem.addccLink .icon:hover{background-position:-180px -200px}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-sidepage-add-card/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidepageAddCardRoute = undefined;
	
	__webpack_require__("./pages/xo-sidepage-add-card/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/route.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SidepageAddCardRoute = exports.$SidepageAddCardRoute = _squid.$ComponentRoute.extend('$SidepageAddCardRoute', {
	
	    path: 'sidepageAddCard',
	    directive: 'xo-sidepage-add-card-page',
	    titleContent: 'asideHeader.addCard',
	    trackingData: {
	        templateName: 'tray/addCard.dust',
	        pageGoal: 'Add Card',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-cc',
	                'pagename2': '%::fullpage-add-cc:member:hermes:tray',
	                'version': 'member:%:tray'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            sidebar: 'sidebar',
	            'parent-callbacks': 'callbacks',
	            promotion: 'promotion',
	            'show-cancel': true
	        }
	    }]
	});
	
	angular.value("$SidepageAddCardRoute", $SidepageAddCardRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidepage-add-card/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidepageAddCardPageComponent = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _template = __webpack_require__("./pages/xo-sidepage-add-card/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidepageAddCardPageComponent = exports.$xoSidepageAddCardPageComponent = _squid.$Component.extend('$xoSidepageAddCardPageComponent', {
	    tag: 'xo-sidepage-add-card-page',
	    template: _template2['default'],
	
	    scope: {
	        token: '=',
	        callbacks: '='
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var interval = (0, _angular.$interval)(function () {
	                var el = (0, _jquery2['default'])('#sidepageAddCard');
	                if (el) {
	                    _angular.$interval.cancel(interval);
	                    el.addClass('sidepageAddCardOpen');
	                }
	            }, 100);
	        }
	    },
	
	    controller: function controller($scope, $rootScope, $stateParams) {
	        $scope.billingaddressupdated = {
	            value: false
	        };
	        $scope.isUpdateDebitCard = function () {
	            return $stateParams.message === 'EXPIRED_DEBIT_CARD';
	        };
	        $scope.token = $rootScope.token;
	        $scope.message = {};
	    }
	});
	
	angular.value("$xoSidepageAddCardPageComponent", $xoSidepageAddCardPageComponent);
	_angular.$interval;
	
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidepage-add-card/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"sidepageAddCard\" modal-box content>\n    <xo-aside-header heading=\"{{isUpdateDebitCard() ? 'asideHeader.updateDebitCard' : 'asideHeader.addDebitCard'}}\"\n                     hidex=\"true\"></xo-aside-header>\n    <div class=\"content\">\n\t    <ui-view></ui-view>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-review/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoReviewPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__("./js/lib/index.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-title/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/banner/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/select-shipping-method/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/review-address/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/review-paywith/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/messenger-plugin/directive.js");
	
	__webpack_require__("./components/xo-address-components/src/address-display/directive.js");
	
	__webpack_require__("./components/xo-credit-components/src/offer/directive.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	__webpack_require__("./components/xo-models/src/bml/index.js");
	
	__webpack_require__("./components/xo-models/src/fi/index.js");
	
	__webpack_require__("./components/xo-models/src/fi/lib/fiMessages.js");
	
	__webpack_require__("./components/xo-models/src/fi/lib/fiApis.js");
	
	__webpack_require__("./components/xo-device-info/dist/index.js");
	
	__webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-popup/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/done/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/cart/lib/pxp.js");
	
	__webpack_require__("./components/xo-wallet-components/src/3ds/directive.js");
	
	__webpack_require__("./components/xo-models/src/profilemanagement/index.js");
	
	__webpack_require__("./components/xo-models/src/inventory/index.js");
	
	__webpack_require__("./components/xo-models/src/shoppingcart/index.js");
	
	__webpack_require__("./components/xo-page-components/src/marketingOffers/directive.js");
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	__webpack_require__("./components/xo-member-components/src/review-topup/directive.js");
	
	var _template = __webpack_require__("./pages/xo-review/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _index = __webpack_require__("./components/xo-models/src/user/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoReviewPageComponent = exports.$xoReviewPageComponent = _squid.$Component.extend('$xoReviewPageComponent', {
	    tag: 'xo-review-page',
	    template: _template2['default'],
	    scope: {
	        redirectiframe: '=',
	        redirectLightbox: '='
	    },
	    lifecycle: {
	        reenter: function reenter() {
	            var msgKeys = this.checkoutSession.get('message.msgKeys', []);
	
	            if (msgKeys.indexOf('confirmUpop.confirmUpopOrChooseAltMethod') === -1) {
	                this.showUnconfirmedUpopMsg = !!this.checkoutSession.unconfirmed_upop;
	            }
	        }
	    },
	    controller: function controller($scope, $state, $rootScope, $FallbackError, $populate, $DeviceInfo, $logger, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutSessionModel, $ShippingRuleSummaryModel, $feature, $AuthModel, $pxp, $config, $meta, $experiment, $miniBrowser, $locale, $pxpFactors, $window, $util, $featureCountries, $BMLModel, $ApplyForBMLModel, $q, $CheckoutPayeeModel, $pxpCartAmt, $timeout, $unresolved, $BuyerEligibilityModel, $renderContent, $fiMessages, $fiApis, $element, $MerchantPreferenceModel, $AddCardModel, $CardModel, $CreditInstallmentModel, $InventoryModel, $CreditDataModel, $ShoppingCartModel, $WalletPreferences) {
	
	        $logger.info('buyer_info', {
	            fpti_buyer_type: 'Existinguser'
	        });
	
	        var showButtonPxp = false;
	        // show fixed button for mobile and incontext view
	        var allowFixedButton = $DeviceInfo.isMobile() || $miniBrowser.isMiniBrowser();
	
	        $scope.token = $rootScope.token;
	
	        $scope.backUri = 'checkout.review';
	
	        $scope.installmentNotSelected = false;
	
	        $scope.installment = {
	            showBanner: false,
	            showCYCO: false,
	            showRepresentativeInfo: false
	        };
	
	        // 'continue' or 'pay now' button text
	        $scope.payButtonText = function () {
	            return '';
	        };
	
	        $scope.isGCcountry = ($config.giftCardSupportedCountries || '').indexOf($locale.country) > -1;
	
	        $scope.showPaypalPolicies = $featureCountries('showPaypalPolicies').indexOf($locale.country) > -1;
	
	        $scope.makeAddrPreferred = {
	            shown: false,
	            selected: false
	        };
	
	        $scope.showPolicyAgreement = $feature('showPolicyAgreement');
	
	        $scope.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
	        $logger.info('IS_MESSENGER_BA_INTEGRATION: on review page: ' + $scope.isMessengerBAIntegration);
	
	        $scope.personalizedBanner = {};
	        function setPersonalizedBanner(buyer_id) {
	            $scope.personalizedBanner.show = true;
	            _index.$UserPhotoModel.instance(buyer_id).retrieve({
	                params: {
	                    'min_size': 45
	                },
	                success: function success(result) {
	                    if (result && result.photo_url) {
	                        $scope.personalizedBanner.imageUrl = result.photo_url;
	                        $logger.info('personalized_banner_retrieve_success');
	                    }
	                }
	            });
	        }
	
	        // Format the informal name if populated
	        function setInformalName() {
	            if ($scope.auth) {
	                $scope.formattedNameInformal = (0, _squid.formatNameInformal)({
	                    first_name: $scope.auth.first_name,
	                    last_name: $scope.auth.last_name
	                }) || $scope.auth.email;
	            }
	        }
	
	        function updateAddressAsPreferred() {
	            if ($scope.makeAddrPreferred.shown) {
	                $logger.info('makeAddrPreferred.shown', {});
	            }
	
	            if ($scope.makeAddrPreferred.selected) {
	                $logger.info('makeAddrPreferred.selected', {});
	
	                // Ignore all errors from setPreferred api, by passing transientError as true
	                return $scope.checkoutSession.shipping.action('setPreferred', {
	                    transientError: true
	                });
	            }
	
	            return $q.when();
	        }
	
	        function setStickyInstrument() {
	            if (!$config.features.DEFAULT.enableStickyFunding) {
	                return $q.when();
	            }
	
	            var stickyInstrument = $scope.checkoutSession.selectedFuturePaymentInstrument ? undefined : $scope.checkoutSession.getSelectedStickyInstrument();
	
	            if (stickyInstrument) {
	                return $scope.checkoutSession.action('setStickyFI', {
	                    data: {
	                        instrument_id: stickyInstrument.instrument_id
	                    }
	                });
	            }
	
	            return $q.when();
	        }
	
	        function setWalletTopupPreferences() {
	            if ($scope.checkoutCart.isWalletTokenization()) {
	                $scope.walletPreferences = $WalletPreferences.instance($scope.token);
	                return $scope.walletPreferences.save();
	            }
	        }
	
	        function show3DSLightbox() {
	            $scope.resolve_3ds_data = {
	                cc_id: $scope.checkoutSession.get('resolve_3ds.ccId'),
	                flow_id: 'HERMES',
	                merchant_id: $scope.payee.get('merchant.id'),
	                merchant_country_code: $scope.checkoutAppData.get('merchant.merchant_country'),
	                transaction_amount_currency: $scope.checkoutCart.get('purchase.amounts.total.currency_code'),
	                transaction_amount_value: $scope.checkoutCart.get('purchase.amounts.total.amount')
	            };
	            $scope.launch3DSResolver = true;
	        }
	
	        function showGenericError(code) {
	            return function () {
	                var encoded = code ? window.btoa(code) : code;
	                return $state.go('checkout.genericError', {
	                    code: encoded
	                });
	            };
	        }
	
	        function getMerchantPreferences() {
	
	            return $populate($scope, {
	                pref: $MerchantPreferenceModel.instance($scope.payee.merchant.id)
	            });
	        }
	
	        function setProcessorDeclineMessage() {
	
	            var processorDeclinedMsg = $fiMessages.processorDeclinedMsg($scope.checkoutSession, true);
	
	            if (processorDeclinedMsg) {
	                $scope.checkoutSession.message = {
	                    type: processorDeclinedMsg.type,
	                    msgs: [processorDeclinedMsg.msg]
	                };
	            }
	        }
	
	        function makePayment() {
	            var wpsParams = $util.decodeAndParse($meta.xclickParams);
	
	            return $scope.checkoutSession.action('createPayment', {
	                data: {
	                    payer_id: $scope.checkoutSession.payer.id,
	                    intent: $scope.checkoutCart.payment_action,
	                    wa_type: wpsParams && wpsParams.wa_type,
	                    correlation_id: $meta.correlationId,
	                    merchant_id: $scope.payee.get('merchant.id')
	                },
	
	                success: function success(result) {
	                    $rootScope.paymentComplete = true;
	                    $logger.info('wps_cart_to_txn_mapping', {
	                        cart_id: $scope.token,
	                        txn_id: result.transactionDetails && result.transactionDetails.id,
	                        txn_receipt_id: result.transactionDetails && result.transactionDetails.receipt_id
	                    });
	                    return 'success';
	                },
	
	                contingencies: {
	                    TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
	                    PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
	                    DUPLICATE_TRANSACTION: showGenericError('PAYMENT_ALREADY_DONE'),
	                    CC_PROCESSOR_DECLINED: function CC_PROCESSOR_DECLINED() {
	                        return $scope.checkoutSession.action('create', {
	                            success: function success(result) {
	                                setProcessorDeclineMessage();
	                                return $state.go('checkout.review');
	                            },
	                            contingencies: {
	                                DEFAULT: function DEFAULT(name, err) {
	                                    throw err;
	                                }
	                            }
	
	                        });
	                    }
	                }
	            });
	        }
	
	        function inventoryOperation() {
	            var cartHasInventory = $scope.checkoutCart.get('cartHasInventory');
	            if (cartHasInventory) {
	                var inventoryModel = $InventoryModel.instance($rootScope.token);
	                var inventoryItems = inventoryModel.getInventoryItems();
	                var inventoryPatchInput = {
	                    inventoryItems: inventoryItems,
	                    cartItems: $scope.checkoutCart.get('purchaseUnits')[0].item_list.items,
	                    merchantId: $scope.payee.get('merchant.id', '')
	                };
	                return inventoryModel.action('patchInventory', {
	                    data: inventoryPatchInput,
	                    success: function success(patchResponse) {
	                        if (patchResponse.showSoldoutPage) {
	                            // show soldout page
	                            return {
	                                soldoutpage: true,
	                                items: patchResponse.soldoutItems,
	                                soldOutUrl: patchResponse.soldoutUrl
	                            };
	                        } else if (patchResponse.patchCart) {
	                            var purchase_unit = $scope.checkoutCart.get('purchaseUnits')[0];
	                            purchase_unit.item_list.items = patchResponse.cartItems;
	                            var patchCartPayload = {
	                                id: $scope.token,
	                                patchEntities: [{
	                                    field: 'inventoryItems',
	                                    value: purchase_unit.item_list.items
	                                }]
	                            };
	
	                            return $scope.checkoutCart.action('patchCartData', {
	                                data: patchCartPayload
	                            });
	                        }
	                        return;
	                    }
	                });
	            } else {
	                return $q.when(); // not an inventory request proceed with existing flow
	            }
	        }
	
	        function markCartCheckedout() {
	            var shoppingCartModel = $ShoppingCartModel.instance($rootScope.token);
	            return shoppingCartModel.action('cartCheckedOut', {
	                data: {
	                    payee_email: $scope.checkoutAppData.get('merchant.merchant_email')
	                },
	                success: function success(result) {
	                    $logger.info('cart checked out successfully');
	                }
	            });
	        }
	
	        function authorize() {
	            if ($scope.checkoutSession.resolve_3ds) {
	                return show3DSLightbox();
	            }
	
	            function isXoonUpopRedirect() {
	                if (!($scope.checkoutSession && $scope.checkoutSession.get('errorData.resolution.data.fi.type'))) {
	                    return false;
	                }
	
	                return $util.param('redirectToHermesOnUpopCancel') === 'xoon' && $scope.checkoutSession.errorData.resolution.name === 'PAYER_TO_AUTHENTICATE_CARD' && !$scope.checkoutSession.errorData.resolution.data.alternate_options && $scope.checkoutSession.errorData.resolution.data.fi.type.toUpperCase() === 'CUP';
	            }
	
	            if ($scope.checkoutSession.unconfirmed_upop || isXoonUpopRedirect()) {
	                var card = void 0;
	                if ($scope.checkoutSession.unconfirmed_upop) {
	                    card = $scope.checkoutSession.unconfirmed_upop;
	                } else {
	                    card = $scope.checkoutSession.errorData.resolution.data;
	                }
	
	                $scope.cardModel = new $AddCardModel({});
	                $scope.cardModel.id = card.fundingId;
	                $scope.cardModel.card = new $CardModel({
	                    number: 'xxxx-xxxx-xxxx-' + card.fi.number,
	                    type: card.fi.type.toUpperCase(),
	                    productType: card.fi.productType
	                });
	
	                $state.go('.confirmUpop');
	                return;
	            }
	
	            return $scope.checkoutSession.action('authorize', {
	                success: function success() {
	                    if ($scope.checkoutSession.get('plan.paypal_credit')) {
	                        $logger.info('checkout_fpti', {
	                            'ppc_reuse_status': 'success'
	                        });
	                    }
	
	                    if ($scope.checkoutCart.isWalletTokenization()) {
	                        $logger.info('tokenized_wallet', {
	                            'from': 'TopUp_REVIEW',
	                            'to': 'process_review',
	                            'topup_amt': $scope.walletPreferences.topup.amount,
	                            'currency_code': $scope.walletPreferences.topup.currency,
	                            'context_id': $scope.token,
	                            'context_type': 'BA-Token',
	                            'ba_token': $meta.baToken
	                        });
	                    }
	
	                    if (window.xchild) {
	                        return $state.go('checkout.end');
	                    }
	
	                    if ($scope.checkoutAppData.doec_on_approve()) {
	                        return inventoryOperation().then(function (result) {
	                            if (result && result.soldoutpage) {
	                                return $state.go('checkout.soldout', {
	                                    items: encodeURIComponent(result.items),
	                                    soldOutUrl: encodeURIComponent(result.soldOutUrl)
	                                });
	                            }
	                            return $q.all([makePayment(), getMerchantPreferences()]).then(function () {
	                                if ($rootScope.paymentComplete) {
	                                    if ($config.enableShoppingCartWPS && $scope.checkoutAppData.flags.is_shopping_cart_flow) {
	                                        markCartCheckedout();
	                                    }
	
	                                    return $state.go('checkout.done');
	                                }
	                            });
	                        });
	                    } else {
	                        if ($scope.checkoutSession.get('sepa_mandate.bankId')) {
	                            return $state.go('checkout.sepapage');
	                        }
	
	                        return $state.go('checkout.end');
	                    }
	                }
	            });
	        }
	
	        function setShowShippingMethodProperty() {
	            return $populate($scope, {
	                shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
	                    params: {
	                        merchant_id: $scope.payee.get('merchant.id'),
	                        currency_code: $scope.checkoutCart.get('purchase.amounts.total.currency_code')
	                    }
	                })
	            }).then(function () {
	                if ($scope.shippingRulesSummary.isSnTEnabled) {
	                    $logger.info('shipping_rules_summary_snt_enabled');
	                } else {
	                    $logger.info('shipping_rules_summary_snt_disabled');
	                }
	                $scope.showShippingMethod = $scope.shippingRulesSummary.isSnTEnabled;
	                return;
	            });
	        }
	
	        function show3DSDeclineMsg(declineAfter3DSAccept) {
	            var key = 'threeDS.memberDecline';
	
	            if (declineAfter3DSAccept) {
	                key = 'threeDS.memberDeclineAfter3DSAccept';
	            }
	
	            var card = $scope.checkoutSession.resolve_3ds;
	
	            if (card) {
	                var msg = $renderContent(key, {
	                    cardType: card.type,
	                    last4: card.number
	                });
	
	                $scope.checkoutSession.message = {
	                    msgs: [msg],
	                    type: 'warning'
	                };
	            }
	        }
	
	        /**
	         * call patchXO API to clear the 3DS contingency and then call authorize API.
	         */
	        function clear3DSContingency() {
	            var resolve_3ds = $scope.checkoutSession.resolve_3ds || {};
	
	            return $scope.checkoutSession.action('clear3DSContingency', {
	                data: {
	                    ccId: resolve_3ds.ccId
	                },
	                success: function success(response) {
	                    if (!$scope.checkoutSession.resolve_3ds) {
	                        return authorize();
	                    } else {
	                        // Symphony is not able to clear the 3DS contingency
	                        show3DSDeclineMsg(true);
	                    }
	                }
	            });
	        }
	
	        $scope.onComplete3DSHandler = function (status) {
	            $scope.launch3DSResolver = false;
	            if (status === 'success') {
	                return clear3DSContingency();
	            } else if (status === 'decline') {
	                // 3DS got declined
	                show3DSDeclineMsg();
	            }
	        };
	
	        $scope.onConfirmUpopSuccess = function () {
	            $state.go('checkout.review');
	            $scope.checkoutSession.action('clearContingency', {
	                data: {
	                    contingency: 'UNCONFIRMED_UPOP',
	                    ccId: $scope.checkoutSession.get('unconfirmed_upop.fundingId') || $scope.checkoutSession.get('errorData.resolution.data.fundingId')
	                },
	                success: function success() {
	                    if (!$scope.checkoutSession.unconfirmed_upop) {
	                        return authorize();
	                    } else {
	                        $scope.checkoutSession.message = {
	                            type: 'warning',
	                            msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
	                        };
	                    }
	                }
	            });
	        };
	
	        $scope.onConfirmUpopCancel = function () {
	            $state.go('checkout.review');
	            $scope.showUnconfirmedUpopMsg = false;
	            $scope.checkoutSession.message = {
	                type: 'warning',
	                msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
	            };
	        };
	
	        $scope.returnFromCape = function (isCapeReturnKey) {
	            return $scope.creditDataModel.action('readCreditKey', {
	                data: {
	                    capeKey: isCapeReturnKey
	                },
	                success: function success(res) {
	
	                    if (res.financial_instrument_id) {
	                        var financial_instrument_id = res.financial_instrument_id.indexOf('BC') !== 0 ? 'BC' + res.financial_instrument_id : res.financial_instrument_id;
	
	                        return $scope.checkoutSession.fundingOptions.action('update', {
	                            resultModel: $scope.checkoutSession,
	                            data: {
	                                planId: financial_instrument_id
	                            },
	                            success: function success(result) {
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['offers.bmlInWalletSuccessMsg']
	                                };
	                            }
	                        });
	                    }
	
	                    // User does not have any FI in wallet and they choose to pay in full.
	                    else if (!$scope.checkoutSession.get('plan.sources') && $scope.checkoutSession.isCreditPromoted) {
	                            $state.go('checkout.pageAddCard.addCardFlow.addCard');
	                        } else if ($scope.creditDataModel.isCapeInternalServiceError()) {
	                            // Todo Show error message from CAPE
	                            return $q.when();
	                        } else {
	                            return $q.when();
	                        }
	                },
	                contingencies: {
	                    DEFAULT: function DEFAULT(name, err) {
	                        $logger.info('read_cape_key_failure');
	                        return $q.when();
	                    }
	                }
	
	            });
	        };
	
	        $populate($scope, {
	            auth: $AuthModel.instance(),
	            checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	            checkoutCart: $CheckoutCartModel.instance($scope.token),
	            checkoutSession: $CheckoutSessionModel.instance($scope.token),
	            payee: $CheckoutPayeeModel.instance($scope.token),
	            buyerEligibility: $BuyerEligibilityModel.instance($scope.token)
	        }).then(function () {
	            if ($util.param('redirectToHermesOnUpopCancel') === 'xoon') {
	                var fiModel = $scope.checkoutSession.get('plan.sources');
	                if (fiModel && fiModel.length && fiModel[0].card_type === 'CHINA_UNION_PAY') {
	                    $scope.checkoutSession.message = {
	                        msgKeys: ['confirmUpop.confirmUpopToPay'],
	                        type: 'warning'
	                    };
	                }
	            }
	
	            if ($scope.checkoutCart.isWalletTokenization()) {
	                $logger.info('tokenized_wallet', {
	                    'from': 'TopUp_REVIEW',
	                    'to': 'prepare_review',
	                    'context_id': $scope.token,
	                    'context_type': 'EC-Token',
	                    'ba_token': $meta.baToken
	                });
	            }
	
	            var merchantCountry = $scope.checkoutAppData.merchant.merchant_country;
	            var personalizationEnabled = $feature('oneTouchPersonalization');
	            if ($scope.auth.remembered && personalizationEnabled) {
	                $pxp('xo_hermesnode_config', { 'ctx.COUNTRY': merchantCountry }, 'xo_hermesnode_kmli_personalization_treatment').then(function (result) {
	                    var treatmentName = result && result.treatment_name || '';
	                    if (treatmentName) {
	                        $logger.info('personalized_banner_enabled');
	                        setPersonalizedBanner($scope.auth.buyer_id);
	                        delete $scope.checkoutSession.message;
	                    } else {
	                        $scope.personalizedBanner.show = false;
	                        delete $scope.auth.rtExchanged;
	                        $logger.info('personalized_banner_disabled');
	                    }
	                });
	            } else {
	                $logger.info('personalized_banner_ineligible', {
	                    'isFeature': personalizationEnabled,
	                    'isOneTouch': $scope.auth.remembered
	                });
	                if ($scope.auth.rtExchanged) {
	                    delete $scope.auth.rtExchanged;
	                }
	            }
	
	            $scope.logout = function () {
	                $logger.info('not_you_logout');
	
	                if (window.paypalCheckout && $util.isIFrame()) {
	
	                    window.paypalCheckout.hide();
	
	                    var url = window.location.href.split('#')[0];
	                    var props = window.paypalCheckout.props;
	
	                    return window.ppxo.Checkout.renderPopupTo(window.top, {
	
	                        url: url,
	                        payment: function payment() {
	                            return $scope.auth.action('logout').then(function () {
	                                return $scope.token;
	                            });
	                        },
	
	                        billingAgreement: props.billingAgreement,
	                        onAuthorize: props.onAuthorize,
	                        onCancel: props.onCancel
	
	                    });
	                }
	
	                $scope.auth.action('logout').then(function () {
	                    $state.go('checkout.login', {
	                        source: 'NOT_YOU'
	                    });
	                });
	            };
	
	            $scope.creditDataModel = $CreditDataModel.instance($scope.token);
	            var isChangeInstallments = $scope.creditDataModel.isChangeStatus();
	            var isCapeReturnKey = $scope.creditDataModel.getCapeKey();
	            var isCapeReturn = isCapeReturnKey && $util.param('success');
	
	            if (isChangeInstallments && $scope.creditDataModel && !$scope.creditDataModel.payInFull) {
	                $state.go('checkout.chooseCreditOffer');
	            }
	            if (isCapeReturn) {
	                $scope.returnFromCape(isCapeReturnKey);
	            }
	
	            if ($feature('creditInstallmentOffers') && ($scope.checkoutSession.get('plan.paypal_credit') || isCapeReturnKey)) {
	                $scope.creditOptions = $CreditInstallmentModel.instance($scope.token);
	                $scope.creditOptions.retrieve();
	            }
	
	            $scope.showInstallmentOption = function () {
	                return $feature('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.creditOptions && $scope.creditOptions.creditType;
	            };
	
	            $scope.cartCurrency = $scope.checkoutCart.get('purchase.amounts.total.currency_code');
	            $scope.showCYCO = function () {
	                $state.go('checkout.chooseCreditOffer');
	            };
	
	            $scope.showRepresentativeInfo = function () {
	                return $locale.country === 'GB' && $scope.installment.showRepresentativeInfo;
	            };
	
	            if (!$scope.buyerEligibility.eligible) {
	                throw new $FallbackError({
	                    reason: 'buyer_ineligible',
	                    product: 'ux'
	                });
	            }
	
	            if ($window.location.search.search('atoSuccess') !== -1) {
	                $logger.debug('PLANNING_ATO_SUCCESS');
	                var atoMsg = $locale.content.get('memberReview.stepupAuthSuccess');
	
	                if (atoMsg) {
	                    $scope.checkoutSession.message = {
	                        msgs: [atoMsg],
	                        type: 'success'
	                    };
	                }
	            }
	
	            $scope.$on('localeChange', setInformalName);
	            setInformalName();
	
	            $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && !$util.param('redirectToHermesOn3DSDecline');
	
	            if ($util.param('redirectToHermesOn3DSDecline')) {
	                // check and show the 3DS decline message when the app is redirected from Xoon app
	                show3DSDeclineMsg();
	            }
	
	            $scope.showAuthMsg = ['authorize', 'order'].indexOf($scope.checkoutCart.get('payment_action')) > -1 && !$scope.checkoutSession.get('plan.paypal_credit');
	
	            $scope.showUnconfirmedUpopMsg = !!$scope.checkoutSession.unconfirmed_upop;
	
	            $scope.useraction = $scope.checkoutAppData.useraction() && $scope.checkoutAppData.useraction().toLowerCase();
	
	            // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
	            // are not available and purchase amount is not zero.
	            var noLineItemDetails = $scope.useraction !== 'commit' && $scope.checkoutCart.get('purchase.items.length', 0) === 0;
	
	            if ($scope.checkoutSession.bmlOffer) {
	                if (!$rootScope.bml) {
	                    $rootScope.bml = new $BMLModel();
	                }
	                $rootScope.bmlApply = new $ApplyForBMLModel();
	            }
	
	            $scope.showSoftDescriptor = !$scope.checkoutAppData.flags.hide_soft_descriptor && $scope.checkoutCart.get('purchaseUnits.length', 0) <= 1;
	
	            return $pxpCartAmt($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
	                $scope.showAmt = showAmount;
	            });
	        }).then(function () {
	            var checkoutSession = $scope.checkoutSession,
	                negBals = checkoutSession.negBals,
	                nbrMsgContentKey,
	                tokenHash;
	
	            if (negBals) {
	
	                nbrMsgContentKey = 'memberReview.nbrMsg';
	                tokenHash = {
	                    neg_bal: (0, _squid.formatCurrency)(negBals[0].amount, negBals[0].currency_code, false),
	                    merchantName: $scope.checkoutAppData.get('merchant.brand_name')
	                };
	
	                if (negBals.length > 1) {
	                    nbrMsgContentKey += 'Plural';
	                    tokenHash.neg_bal2 = (0, _squid.formatCurrency)(negBals[1].amount, negBals[1].currency_code, false);
	                }
	
	                checkoutSession.message = {
	                    type: 'warning',
	                    msgs: [$renderContent(nbrMsgContentKey, tokenHash)]
	                };
	            }
	        }).then(function () {
	            if (allowFixedButton) {
	                return $pxp('xo_hermes_fixed_button', {}, 'xo_hermes_fixed_button_test_group').then(function (result) {
	                    showButtonPxp = result && result.treatment_name === 'xo_hermes_fixed_button_test_group';
	                });
	            }
	        }).then(function () {
	            if (!$miniBrowser.isMiniBrowser() && $locale.country === 'BR') {
	                var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_ryi_design;
	
	                $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
	                    $scope.ryiDesignExp = result;
	                });
	            }
	        }).then(function () {
	            $scope.showShippingMethod = false;
	            if ($scope.checkoutAppData.doec_on_approve()) {
	                return setShowShippingMethodProperty();
	            }
	            return $q.when();
	        }).then(function () {
	            $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
	
	            var isBilling = $scope.checkoutCart.isBilling();
	            var isBillingPurchase = $scope.checkoutCart.isBillingPurchase();
	            var isWPSFlow = $scope.checkoutAppData.doec_on_approve();
	            $scope.merchantMsg = $scope.checkoutCart.getBillingDescription();
	
	            /* -- refined by creating isBilling and isBillingPurchase variables -- */
	            $scope.showReviewLater = !$scope.showAmt && (!isBilling || isBillingPurchase);
	
	            // show shipping address based on merchant passed in parameter
	            $scope.showShippingAddress = Boolean(!$scope.checkoutAppData.flags.hide_shipping_address && $scope.checkoutAppData.flags.shipping_address_required && $scope.checkoutSession.shipping);
	
	            /* -- end refined -- */
	
	            // review page 'continue' or 'pay now' button logic to return the button text
	            $scope.payButtonText = function () {
	                var isAutoExecute = window.xchild && window.xchild.props.commit && $scope.checkoutCart.payment_action === 'sale';
	                if (isBilling) {
	                    if ($scope.useraction === 'commit' && isBillingPurchase) {
	                        return $locale.content.get('memberReview.agreeAndPayLabel');
	                    } else {
	                        return $locale.content.get('memberReview.agreeAndContinueLabel');
	                    }
	                } else if (isWPSFlow || $scope.useraction === 'commit' || isAutoExecute) {
	                    if ($scope.checkoutSession.unconfirmed_upop) {
	                        return $locale.content.get('memberReview.pay');
	                    } else {
	                        return $locale.content.get('memberReview.payLabel');
	                    }
	                } else {
	                    return $locale.content.get('memberReview.continueLabel');
	                }
	            };
	
	            $scope.onRedeemGC = function () {
	                throw new $FallbackError({
	                    reason: 'redeem_coupon_feature_not_supported',
	                    product: 'ux'
	                });
	            };
	
	            // Check if processor decline message needs to be set
	            setProcessorDeclineMessage();
	
	            var isButtonBelowScreen = function isButtonBelowScreen() {
	                var $button = $element.find('#button')[0];
	                var $windowElement = (0, _jquery2['default'])(window)[0];
	
	                var windowTop = $windowElement.scrollY;
	                var windowBottom = windowTop + $windowElement.screen.height;
	
	                var buttonTop = windowTop + $button.getBoundingClientRect().top;
	                var buttonBottom = buttonTop + $button.offsetHeight;
	
	                return !(buttonBottom <= windowBottom && buttonTop >= windowTop);
	            };
	
	            $scope.showFixedButton = function () {
	                return allowFixedButton && showButtonPxp && isButtonBelowScreen();
	            };
	
	            $timeout(function () {
	                if (!allowFixedButton) {
	                    return false;
	                }
	
	                if ($scope.showFixedButton()) {
	                    $logger.info('button_below_screen', {
	                        fpti_fixed_button_pxp: 'test'
	                    });
	                } else if (isButtonBelowScreen() && !showButtonPxp) {
	                    $logger.info('button_below_screen', {
	                        fpti_fixed_button_pxp: 'control'
	                    });
	                }
	            }, 500);
	
	            if (allowFixedButton && showButtonPxp) {
	                (0, _jquery2['default'])(window).bind('scroll', function () {
	                    $scope.$apply();
	                });
	            }
	
	            $scope.$on('$destroy', function () {
	                (0, _jquery2['default'])(window).unbind('scroll');
	            });
	
	            $scope.promotion = {
	                type: null,
	                name: ''
	            };
	
	            var plccOffer = $scope.checkoutSession.plccOffer;
	
	            if (plccOffer) {
	                $scope.promotion.logoUrl = plccOffer.product_logo;
	                $scope.promotion.name = plccOffer.product_name;
	            }
	
	            $scope.onFBBANotNow = function () {
	                window.xchild.close();
	            };
	
	            $scope.onPay = function (result) {
	                if ($scope.checkoutSession.installments && $scope.checkoutSession.installments.length > 1 && !$scope.checkoutSession.selectedInstallmentData) {
	                    $scope.installmentNotSelected = true;
	                    return;
	                }
	
	                if ($feature('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.installment.showCYCO && $scope.creditOptions && !$scope.creditOptions.creditType) {
	                    return $state.go('checkout.chooseCreditOffer');
	                }
	                // Address Normalization Checks
	                if ($scope.checkoutAppData.get('flags.allow_change_shipping', false) && $feature('shippingAddressNormalization') && $scope.checkoutSession.get('shipping.normalization_status') === 'UNKNOWN') {
	
	                    return $state.go('checkout.review.sidebar.updateShipping');
	                }
	
	                /* Call patchCvv first, if error, need buyers to input again */
	                /* Call to set Sticky Funding Instrument for Billing Agreement.
	                 *  We have to ensure the sticky call happens before authorize due to symphony spec.*/
	                /* We need to wait for the response from updateAddressAsPreferred before calling authorize */
	
	                $fiApis.patchCvv($scope.checkoutSession).then(function () {
	                    return $q.all([setWalletTopupPreferences(), setStickyInstrument(), updateAddressAsPreferred()])['catch'](function (err) {
	                        // should we have more elaborate error handling here?
	                        $logger.error('onPay() error', err);
	                    })['finally'](function () {
	                        return authorize();
	                    });
	                }, function (err) {
	                    $logger.error('onPay() patchCvv error', err);
	                });
	            };
	
	            /* This is used for a BML 'popup' that opens covering the whole review page,
	             hiding the rest of the review page when its open. */
	            $scope.bmlPopupOpen = false;
	
	            $scope.showBmlPopup = function () {
	                $scope.bmlPopupOpen = true;
	            };
	
	            $scope.hideBmlPopup = function () {
	                $scope.bmlPopupOpen = false;
	            };
	        });
	        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCredit');
	        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
	
	        $scope.onComplete = function () {
	            $state.go('checkout.review');
	        };
	        $scope.propValueObj = {};
	        if ($feature('propValue')) {
	            $scope.propValueObj.propHeader = 'memberReview.propHead';
	            $scope.propValueObj.propVal = 'memberReview.propVal';
	            $scope.propValueObj.propImage = 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png';
	        } else {
	            $scope.propValueObj.propHeader = 'login.propHeadAlt';
	            $scope.propValueObj.propVal = 'login.propValAlt';
	            $scope.propValueObj.propImage = 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png';
	        }
	    }
	});
	
	angular.value("$xoReviewPageComponent", $xoReviewPageComponent);
	_squid.formatCurrency;
	
	_squid.$Component;
	
	_squid.formatNameInformal;
	
	_integration.$integration;
	
	_index.$UserPhotoModel;

/***/ },

/***/ "./components/xo-ui-components/src/banner/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-ui-components/src/banner/styles.less");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/banner/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-banner.directive', ['squid']).directive('xoBanner', function () {
	        return {
	            scope: {
	                bannerImage: '='
	            },
	            template: template,
	            transclude: true,
	            link: function link(scope, element) {
	                var imageType = 'default';
	                var deregisterWatcher = scope.$watch('bannerImage', function () {
	                    if (scope.bannerImage) {
	                        var elem = document.getElementById('banner-picture');
	                        if (elem) {
	                            elem.style.backgroundImage = 'url("' + scope.bannerImage + '")';
	                            imageType = 'user';
	                        }
	                        deregisterWatcher(); // $watch returns a deregister function
	                        deregisterWatcher = 'deregisterd'; // converting deregisterWatcher into a non-function
	                    }
	
	                    // Todo : remove logger from ui once proven stable on production
	                    _logger.$logger.info('xoBanner', {
	                        'watcher_enabled': angular.isFunction(deregisterWatcher),
	                        'image_type': imageType
	                    });
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_logger.$logger;

/***/ },

/***/ "./components/xo-ui-components/src/banner/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/banner/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/banner/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#banner-wrapper{background-color:#f1f4f5;padding:5px;margin-bottom:10px;height:70px}@media not screen and (min-width:660px){#banner-wrapper{margin-left:-20px;margin-right:-20px}}@media screen and (min-width:660px){#banner-wrapper{margin-left:0;margin-right:0}}#banner-picture{width:40px;height:40px;border-radius:40px;-webkit-border-radius:40px;-moz-border-radius:40px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_phantom.png\") no-repeat;background-size:cover;float:left;margin:15px 10px 15px 15px}#banner-content{height:31px;font-family:HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:13px;font-weight:400;color:#000;padding:16px 15px 18px 10px;display:table-cell;vertical-align:middle}#banner-content>p{font-size:inherit;margin:0}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/banner/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"banner-wrapper\">\n    <div id=\"banner-picture\"></div>\n    <div id=\"banner-content\" ng-transclude></div>\n</div>\n"

/***/ },

/***/ "./components/xo-form-components/src/select-shipping-method/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/shippingMethod/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/modal/directive.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _template = __webpack_require__("./components/xo-form-components/src/select-shipping-method/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoSelectShippingMethod', {
	    tag: 'xo-select-shipping-method',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        showShippingAddress: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
	                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
	                checkoutPayee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
	                checkoutShippingAddresses: _index2.$CheckoutShippingAddressesModel.instance(this.props.token).retrieve(),
	                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        closeModal: function closeModal() {
	            this.showModal = false;
	        },
	        openModal: function openModal() {
	            this.showModal = true;
	        },
	        continueHandler: function continueHandler() {
	
	            if (this.selectedMethod.index !== this.selectedMethod.prevIndex) {
	
	                var selectedMethodCharges = void 0,
	                    taxAmtApplied = void 0;
	                this.selectedMethod.prevIndex = this.selectedMethod.index;
	                selectedMethodCharges = this.response.charges[this.selectedMethod.index];
	                taxAmtApplied = this.getTax(selectedMethodCharges);
	                this.shippingAmtApplied = this.safeConvert(selectedMethodCharges.shipping_charge.shipping_amount.value);
	                this.updateShippingTaxCharge(this.shippingAmtApplied, taxAmtApplied, selectedMethodCharges.shipping_charge.shipping_method_type);
	                this.selectedShippingMethod = selectedMethodCharges.shipping_charge.shipping_method;
	            }
	            this.actions.closeModal();
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.selectedMethod = {
	                index: 0,
	                prevIndex: 0
	            };
	
	            // Initialization
	            this.showModal = false;
	            this.shippingMethodDisplay = 'noHighlight';
	            this.addressChanged = false;
	
	            var timer = void 0;
	            this.previousCosts = {};
	
	            var responseHasShippingCharges = function responseHasShippingCharges() {
	                if (_this.response.charges.length === 0) {
	                    return false;
	                }
	                return !!_this.response.charges[0].shipping_charge;
	            };
	
	            var responseHasTaxCharges = function responseHasTaxCharges() {
	                if (_this.response.charges.length === 0) {
	                    return false;
	                }
	                return !!_this.response.charges[0].tax;
	            };
	
	            this.safeConvert = function (value) {
	                value = Number(value);
	                if (isNaN(value)) {
	                    throw new Error(value + ' cannot be divided');
	                }
	                return value / 100;
	            };
	
	            var highlight = function highlight(duration) {
	                _this.shippingMethodDisplay = 'highlight';
	                if (timer) {
	                    _angular.$timeout.cancel(timer);
	                }
	                timer = (0, _angular.$timeout)(function () {
	                    _this.shippingMethodDisplay = 'noHighlight';
	                }, duration);
	            };
	
	            this.getTax = function (charge) {
	                var tax = void 0;
	                if ((_this.isBuyNow || _this.isCartUpload) && _this.cartAmounts.taxAmt >= 0) {
	                    tax = _this.cartAmounts.taxAmt;
	                }
	                // tax calculation
	                else {
	                        charge = charge || responseHasTaxCharges() && _this.response.charges[0];
	                        if (charge && charge.tax && charge.tax.total_tax) {
	                            tax = _this.safeConvert(charge.tax.total_tax.value);
	                        }
	                    }
	                return tax;
	            };
	
	            var updatePreviousCosts = function updatePreviousCosts() {
	                _this.previousCosts = {};
	                if (_this.models.checkoutCart.purchase.amounts.shipping) {
	                    _this.previousCosts.shippingAmount = _this.models.checkoutCart.purchase.amounts.shipping.amount;
	                }
	                if (_this.models.checkoutCart.purchase.amounts.tax) {
	                    _this.previousCosts.taxAmount = _this.models.checkoutCart.purchase.amounts.tax.amount;
	                }
	            };
	
	            var hasShippingCostChanged = function hasShippingCostChanged(newShipping) {
	                if (newShipping !== undefined) {
	                    return newShipping.amount !== _this.previousCosts.shippingAmount;
	                }
	                return newShipping !== _this.previousCosts.shippingAmount;
	            };
	
	            var hasTaxCostChanged = function hasTaxCostChanged(newTax) {
	                if (newTax !== undefined) {
	                    return newTax.amount !== _this.previousCosts.taxAmount;
	                }
	                return newTax !== _this.previousCosts.taxAmount;
	            };
	
	            var setToolTipMessage = function setToolTipMessage() {
	                _this.models.checkoutSession.message.msgKeys = hasShippingCostChanged(_this.models.checkoutCart.purchase.amounts.shipping) || hasTaxCostChanged(_this.models.checkoutCart.purchase.amounts.tax) ? ['smallToolTip.addressShippingChargesUpdated'] : ['smallToolTip.onlyAddressUpdated'];
	            };
	
	            var getPatchReqData = function getPatchReqData(shippingAmt, taxAmt, shipMethod) {
	                var patchShippingAmt = false,
	                    patchTaxAmt = false;
	                if (shippingAmt) {
	                    shippingAmt = Number(shippingAmt);
	                    patchShippingAmt = true;
	                } else {
	                    shippingAmt = 0;
	                }
	
	                if (taxAmt) {
	                    taxAmt = Number(taxAmt);
	                    patchTaxAmt = true;
	                } else {
	                    taxAmt = 0;
	                }
	                var shippingAmtDiff = _this.cartAmounts.shippingAmt ? shippingAmt - _this.cartAmounts.shippingAmt : shippingAmt;
	                var taxAmtDiff = _this.cartAmounts.taxAmt ? taxAmt - _this.cartAmounts.taxAmt : taxAmt;
	                var amountValue = {
	                    'total': (_this.cartAmounts.total + shippingAmtDiff + taxAmtDiff).toFixed(2),
	                    'currency': _this.currencyCode,
	                    'details': {
	                        'subtotal': _this.cartAmounts.subTotal.toFixed(2)
	                    }
	                };
	
	                if (patchShippingAmt) {
	                    amountValue.details.shipping = shippingAmt.toFixed(2);
	                }
	                if (patchTaxAmt) {
	                    amountValue.details.tax = taxAmt.toFixed(2);
	                }
	                if (_this.cartAmounts.handlingAmt !== undefined) {
	                    amountValue.details.handling_fee = _this.cartAmounts.handlingAmt.toFixed(2);
	                }
	                if (_this.cartAmounts.insuranceAmt !== undefined) {
	                    amountValue.details.insurance = _this.cartAmounts.insuranceAmt.toFixed(2);
	                }
	                if (_this.cartAmounts.shippingDiscountAmt !== undefined) {
	                    amountValue.details.shipping_discount = _this.cartAmounts.shippingDiscountAmt.toFixed(2);
	                }
	                if (_this.cartAmounts.discountAmt !== undefined) {
	                    amountValue.details.discount = _this.cartAmounts.discountAmt.toFixed(2);
	                }
	
	                return {
	                    id: _this.token,
	                    patchEntities: [{
	                        field: 'purchaseAmount',
	                        value: amountValue
	                    }, {
	                        field: 'shippingMethod',
	                        value: shipMethod ? _this.shippingMethods.getShippingMethodId(shipMethod) : ''
	                    }]
	                };
	            };
	
	            this.updateShippingTaxCharge = function (shippingAmt, taxAmt, shipMethod) {
	                _this.models.checkoutCart.action('patchCartData', {
	                    data: getPatchReqData(shippingAmt, taxAmt, shipMethod),
	                    success: function success(result) {
	                        _this.models.checkoutSession.invalidate();
	                        (0, _squid.$populate)(_this, {
	                            checkoutSession: _index2.$CheckoutSessionModel.instance(_this.token)
	                        }).then(function () {
	                            highlight(4000);
	                            if (_this.addressChanged) {
	                                setToolTipMessage();
	                                _this.addressChanged = false;
	                            }
	                            updatePreviousCosts();
	                        });
	                    }
	                });
	            };
	
	            var setDefaultShippingMethod = function setDefaultShippingMethod() {
	                _this.showShippingOptions = true;
	                var chargesElement = void 0,
	                    methodType = void 0,
	                    taxAmtApplied = void 0;
	                for (var i = 0; i < _this.response.charges.length; i++) {
	                    chargesElement = _this.response.charges[i];
	                    if (chargesElement.shipping_charge.default_method) {
	                        _this.selectedMethod.index = i;
	                        _this.selectedMethod.prevIndex = i;
	                        _this.selectedShippingMethod = chargesElement.shipping_charge.shipping_method;
	                        methodType = chargesElement.shipping_charge.shipping_method_type;
	                        _this.shippingAmtApplied = _this.safeConvert(chargesElement.shipping_charge.shipping_amount.value);
	
	                        taxAmtApplied = _this.getTax(chargesElement);
	
	                        break;
	                    }
	                }
	                _this.updateShippingTaxCharge(_this.shippingAmtApplied, taxAmtApplied, methodType);
	            };
	
	            var isPatchCartRequired = function isPatchCartRequired(applicableShippingAmt, applicableTaxAmt) {
	                return applicableShippingAmt !== _this.previousCosts.shippingAmount || applicableTaxAmt !== _this.previousCosts.taxAmount;
	            };
	
	            var processShippingAndTaxResponse = function processShippingAndTaxResponse() {
	
	                var applicableShippingAmt = void 0,
	                    applicableTaxAmt = void 0;
	
	                // shipping calculation
	                if (_this.showShippingAddress) {
	                    if (responseHasShippingCharges()) {
	                        if (_this.response.show_shipping_options) {
	                            setDefaultShippingMethod(); // setDefaultShippingMethod takes care of both shipping and tax
	                            return;
	                        } else {
	                            applicableShippingAmt = _this.safeConvert(_this.response.charges[0].shipping_charge.shipping_amount.value);
	                        }
	                    }
	                }
	                // when no_shipping is 1, shipping is applied only when override is true and shipping is passed in button
	                else if (_this.response.profile_override_allowed) {
	                        if (_this.cartAmounts.shippingAmt !== undefined) {
	                            applicableShippingAmt = _this.cartAmounts.shippingAmt;
	                        }
	                    }
	
	                applicableTaxAmt = _this.getTax();
	
	                if (isPatchCartRequired(applicableShippingAmt, applicableTaxAmt)) {
	                    _this.updateShippingTaxCharge(applicableShippingAmt, applicableTaxAmt);
	                }
	            };
	
	            this.getShippingMethods = function () {
	                _this.showShippingOptions = false;
	                _this.selectedShippingMethod = '';
	                _this.shippingAmtApplied = 0;
	                _this.response = {};
	
	                // when no_shipping = 1, checkoutSession,shipping is undefined. Primary address is considered for SnT as per legacy
	                var shippingAddress = _this.models.checkoutSession.shipping ? _this.models.checkoutSession.getShippingAddressMinimalDetails() : _this.models.checkoutShippingAddresses.getPrimaryShippingAddress();
	                _this.shippingMethods = new _index.$ShippingMethodModel({
	                    'address': shippingAddress,
	                    'cart_weight': _this.cartWeight,
	                    'cart_handling': { value: _this.cartAmounts.handlingAmt, currency_code: _this.currencyCode },
	                    'discount': _this.cartDiscount,
	                    'item_list': _this.models.checkoutCart.purchase.items,
	                    'tax_on_shipping_required': _this.showShippingAddress, //    tax on shipping is not applicable when no_shipping is 1
	                    'merchant_id': _this.models.checkoutPayee.merchant.id,
	                    'locale': _squid.$locale.content.lang + '_' + _squid.$locale.chosenCountry
	                });
	                _logger.$logger.info('calculate_shipping_charges_call');
	                _this.shippingMethods.save({
	                    data: _this.shippingMethods,
	                    success: function success(result) {
	                        _this.response = result;
	                        processShippingAndTaxResponse();
	                    }
	                });
	            };
	        },
	        populate: function populate() {
	            var _this2 = this;
	
	            var set = function set(key, value) {
	                if (value) {
	                    _this2.cartAmounts[key] = Number(value.amount);
	                }
	            };
	
	            function hasAddressChanged(newValue, oldValue) {
	                // only these values determine if the shiptax service needs to be called again
	                return newValue.country !== oldValue.country || newValue.state !== oldValue.state || newValue.city !== oldValue.city || newValue.postal_code !== oldValue.postal_code;
	            }
	
	            this.currencyCode = this.models.checkoutCart.purchase.amounts.total.currency_code;
	
	            var appDataFlags = this.models.checkoutAppData && this.models.checkoutAppData.flags;
	
	            this.isBuyNow = appDataFlags && appDataFlags.is_buy_now_flow;
	
	            this.isCartUpload = appDataFlags && appDataFlags.is_cart_upload_flow;
	
	            this.cartAmounts = {};
	            set('shippingAmt', this.models.checkoutCart.purchase.amounts.shipping);
	            set('taxAmt', this.models.checkoutCart.purchase.amounts.tax);
	            set('subTotal', this.models.checkoutCart.purchase.amounts.subtotal);
	            set('total', this.models.checkoutCart.purchase.amounts.total);
	            set('handlingAmt', this.models.checkoutCart.purchase.amounts.handling_fee);
	            set('insuranceAmt', this.models.checkoutCart.purchase.amounts.insurance);
	            set('shippingDiscountAmt', this.models.checkoutCart.purchase.amounts.shipping_discount);
	            set('discountAmt', this.models.checkoutCart.purchase.amounts.discount);
	            this.previousCosts = {
	                shippingAmount: this.models.checkoutCart.purchase.amounts.shipping ? Number(this.models.checkoutCart.purchase.amounts.shipping.amount) : undefined,
	                taxAmount: this.models.checkoutCart.purchase.amounts.tax ? Number(this.models.checkoutCart.purchase.amounts.tax.amount) : undefined
	            };
	
	            if (this.models.checkoutCart.cartWeight) {
	                this.cartWeight = {};
	                if (this.models.checkoutCart.cartWeight.value) {
	                    this.cartWeight.value = Number(this.models.checkoutCart.cartWeight.value).toFixed(2);
	                }
	                this.cartWeight.unit = this.models.checkoutCart.cartWeight.unit;
	            }
	
	            if (this.models.checkoutCart.purchase.amounts.discount) {
	                this.cartDiscount = {
	                    value: Number(this.models.checkoutCart.purchase.amounts.discount.amount).toFixed(2),
	                    currency_code: this.currencyCode
	                };
	            }
	
	            if (this.showShippingAddress) {
	                this.$watch('this.models.checkoutSession.shipping', function (newValue, oldValue) {
	                    if (hasAddressChanged(newValue, oldValue)) {
	                        _this2.addressChanged = true;
	                        _this2.getShippingMethods();
	                    }
	                });
	            }
	            this.getShippingMethods();
	        }
	    }
	});
	
	
	_angular.$timeout;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$populate;
	
	_index.$ShippingMethodModel;
	
	_index2.$CheckoutSessionModel;
	
	_index2.$CheckoutPayeeModel;
	
	_index2.$CheckoutCartModel;
	
	_index2.$CheckoutShippingAddressesModel;
	
	_index2.$CheckoutAppDataModel;
	
	_logger.$logger;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-ui-components/src/modal/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-ui-components/src/modal/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(0, _squid.$registerDirective)('xoModal', function () {
	    return {
	        template: _template2['default'],
	        restrict: 'E',
	        replace: true,
	        transclude: true,
	
	        scope: {
	            show: '=?',
	            showCloseButton: '=?',
	            overrideDefaultContainer: '@?' // Boolean to determine if default styling should be applied to container
	        },
	
	        controller: function controller($scope) {
	            var $body = (0, _jquery2['default'])('body');
	            var keyupEvent = 'keyup.modal';
	
	            $scope.hideModal = function ($event) {
	                $event.preventDefault();
	                $scope.show = false;
	            };
	
	            $scope.$watch('show', function (showModal) {
	
	                if (showModal) {
	                    // move the focus to modal
	                    (0, _jquery2['default'])('.modalContent').focus();
	
	                    // when the esc key is pressed
	                    $body.on(keyupEvent, function ($event) {
	                        if ($event.which === 27) {
	                            $scope.$apply(function () {
	                                $scope.hideModal($event);
	                            });
	                            $body.off(keyupEvent);
	                        }
	                    });
	                } else {
	                    $body.off(keyupEvent);
	                }
	            });
	        }
	    };
	});
	
	_squid.$registerDirective;

/***/ },

/***/ "./components/xo-ui-components/src/modal/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-wrapper\" ng-show='show'>\n\t<div class=\"modal-overlay\" ng-click='hideModal()'></div>\n\t<div class=\"modal-dialog\">\n\t\t<div class=\"modal-content\" ng-class=\"{'modal-default': !overrideDefaultContainer}\">\n            <a href=\"#\" ng-if=\"showCloseButton\" ng-click=\"hideModal($event)\" class=\"close\">&nbsp;</a>\n            <div ng-transclude>\n            </div>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ },

/***/ "./components/xo-form-components/src/select-shipping-method/template.html":
/***/ function(module, exports) {

	module.exports = "<span id=\"selectShippingMethod\" content>\n    <div id=\"selectShippingMethodContainer\" ng-if=\"showShippingOptions\">\n        <div id=\"storePickUpDetails\" ng-if=\"models.checkoutCart.isShippingMethodStorePickUp()\">\n            <hr class=\"lightHR\">\n            <div class=\"shipTo\">{{ content('shippingMethod.shipTo') }}</div>\n            <div class=\"storeLocation\" >{{ content('shippingMethod.storeLocation') }}</div>\n            <p class=\"storeLocationInfo\">{{ content('shippingMethod.storeLocationInfo') }}</p>\n        </div>\n        <div id=\"methodCharges\" ng-class=\"shippingMethodDisplay\">\n            <span class=\"shippingText\">{{ content('shippingMethod.shipping') }}:</span>\n            <span>\n                <a id=\"shippingMethodCharge\" class=changeShippingMethod href=\"#\"  aria-label=\"Change shipping method\" ng-click=\"actions.openModal()\">\n                    <span class=\"selectedShippingMethod\">{{selectedShippingMethod}} - </span>\n                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"shippingAmtApplied\"></format-currency>\n                </a>\n            </span>\n        </div>\n        <xo-modal show=showModal>\n            <div class=\"shippingMethodsContainer\">\n                <a href=\"#\" ng-click=\"actions.closeModal()\" class=\"close closeModal\">&nbsp;</a>\n                <div>\n                    <div class=\"shippingOptions\">\n                        <span class=\"shippingHeader\" id=\"shippingHeader1\">{{ content('shippingMethod.selectMethod') }}</span>\n                        <span class=\"gamma\" id=\"shippingHeader2\">{{ content('shippingMethod.merchantOptions') }}</span>\n                        <br>\n                        <div>\n                            <div ng-repeat=\"charge in response.charges\">\n                                <div class=\"row-fluid radioButton\">\n                                    <input type=\"radio\" name=\"shippingMethodRadioButton\" id=\"{{$index}}\" value=\"{{$index}}\" ng-model=\"selectedMethod.index\"/>\n                                    <label class=\"noBottom\" for=\"{{$index}}\">\n                                            <span class=\"methodContents\">\n                                        <span>\n                                            <span>\n                                                <span class=\"methodName\">\n                                                    {{charge.shipping_charge.shipping_method}} -\n                                                </span>\n                                                <span class=\"shippingCharge\">\n                                                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"charge.shipping_charge.shipping_amount.value / 100\"></format-currency>\n                                                </span>\n                                            </span>\n                                            <span class=\"deliveryTime\">\n                                                {{charge.shipping_charge.delivery_time}}\n                                            </span>\n                                            <span class=\"description animate-show\" ng-if=\"shippingMethods.isStorePickUp(charge.shipping_charge.shipping_method_type)\" ng-show=\"selectedMethod.index == $index\">\n                                                {{ content('shippingMethod.storeLocationInfo') }}\n                                            </span>\n                                        </span>\n                                    </span>\n                                    </label>\n                                </div>\n                                <hr class=\"hr\" ng-if=\"!$last\">\n                            </div>\n                        </div>\n                        <input id=\"confirmShippingMethod\" type=\"button\" class=\"confirmation btn\" value=\"{{ content('shippingMethod.continue') }}\" ng-click=\"actions.continueHandler()\">\n                    </div>\n                </div>\n            </div>\n            <div class=\"logo\"></div>\n        </xo-modal>\n    </div>\n</span>\n"

/***/ },

/***/ "./components/xo-member-components/src/review-address/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	__webpack_require__("./components/xo-address-components/src/address-display/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/accessibility/directive.js");
	
	var _template = __webpack_require__("./components/xo-member-components/src/review-address/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend({
	    tag: 'xo-review-address',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        makeAddrPreferred: {
	            type: 'var',
	            required: false
	        },
	        countryCode: {
	            type: 'str',
	            required: false
	        },
	        storePickUpSelected: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
	                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
	                auth: _index2.$AuthModel.instance().retrieve()
	            };
	        }
	    },
	
	    actions: {
	        gotoShipping: function gotoShipping() {
	            if (this.models.checkoutAppData.flags.allow_change_shipping) {
	                _uiRouter.$state.go('checkout.review.sidebar.shipping');
	            } else {
	                this.cannotChangeShippingInfoMessages = true;
	            }
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            var updateMakePreferredFlag = function updateMakePreferredFlag(flag) {
	                if (_this.makeAddrPreferred) {
	                    // Update the makeAddrPreferred.shown flag, for the caller to know about it.
	                    _this.makeAddrPreferred.shown = flag;
	                }
	                return flag;
	            };
	
	            /**
	             * Decision on whether to show Make Preferred Checkbox
	             * @returns {boolean}
	             */
	            this.isMakePreferred = function () {
	                if (_this.models.auth.remembered) {
	                    return updateMakePreferredFlag(false);
	                }
	
	                if (_this.isPreferredShippingEnabled && !_this.models.checkoutSession.get('shipping.preferred_address') && !_this.models.checkoutSession.get('shipping.s2s_address')) {
	                    return updateMakePreferredFlag(true);
	                }
	
	                return updateMakePreferredFlag(false);
	            };
	        },
	        populate: function populate() {
	
	            // countryCode is not available, hence we use the shipping.county to retrieve the feature flag.
	            var shipping = this.models.checkoutSession && this.models.checkoutSession.shipping || {};
	
	            this.isPreferredShippingEnabled = (0, _squid.$feature)('preferredShipping', false, shipping.country);
	        }
	    }
	});
	
	
	_uiRouter.$state;
	
	_squid.$Component;
	
	_squid.$feature;
	
	_index.$CheckoutAppDataModel;
	
	_index.$CheckoutSessionModel;
	
	_index2.$AuthModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-member-components/src/review-address/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"shippingForm\" class=\"shipping asideView\" content>\n    <div class=\"trayInner trayInnerDefault\">\n        <div id=\"shippingAddress\">\n            <div ng-class=\"{editable:models.checkoutAppData.flags.allow_change_shipping}\" focusable=\"!cannotChangeShippingInfoMessages\" class=\"focusable\" select-button ng-click=\"actions.gotoShipping()\">\n                <h4 ng-show=\"!storePickUpSelected\" class=\"noBottom gamma\">{{ content('shippingAddress.shipTo') }}</h4>\n                <div ng-show=\"storePickUpSelected\">\n                    <h4 class=\"noBottom gamma\">{{ content('shippingAddress.yourAddress') }}</h4>\n                    <span class=\"merchantReq\">{{ content('shippingAddress.merchantReq') }}</span>\n                </div>\n                <div class=\"addressDisplay\">\n                    <div>\n                        <span class=\"given-name\">{{models.checkoutSession.shipping.name}}</span>\n                        <span class=\"family-name\"></span>\n                    </div>\n                    <xo-address-display address=models.checkoutSession.shipping country-code=countryCode></xo-address-display>\n                </div>\n            </div>\n            <a class=\"edits changeShipping ng-class:{disabled:cannotChangeShippingInfoMessages}\" select-button focusable=\"!cannotChangeShippingInfoMessages\" ng-click=\"actions.gotoShipping()\" aria-label=\"{{ content('shippingAddress.label') }}\" focus-when-state=\"checkout.review.sidebar.shipping\" transitions-to=\"checkout.review\">\n                {{ content('common.change') }}\n                <span class=\"frontArrow goTray ng-scope ng-class:{disabled:cannotChangeShippingInfoMessages}\"></span>\n            </a>\n        </div>\n    </div>\n    <div id=\"infoMessages\" class=\"msgPage msg-info shipNotification\" ng-if=\"cannotChangeShippingInfoMessages\">\n        <span class=\"icon\"></span>\n        <ul>\n            <li ng-if=\"models.checkoutAppData.useraction() === 'commit'\" focus-when=\"cannotChangeShippingInfoMessages\" tabindex=\"-1\">\n                {{ content('memberReview.cannotChangeShippingMsgUserActionCommit', {merchantName: models.checkoutAppData.merchant.brand_name, merchantName2: models.checkoutAppData.merchant.brand_name}) }}\n            </li>\n            <li ng-if=\"models.checkoutAppData.useraction() !== 'commit'\" focus-when=\"cannotChangeShippingInfoMessages\" tabindex=\"-1\">\n                {{ content('memberReview.cannotChangeShippingMsg', {merchantName: models.checkoutAppData.merchant.brand_name, merchantName2: models.checkoutAppData.merchant.brand_name}) }}\n            </li>\n        </ul>\n    </div>\n</div>\n\n<div class=\"reviewPreferredShipping sCheckbox checkbox\" ng-if=\"isMakePreferred()\">\n    <input type=\"checkbox\" ng-model=\"makeAddrPreferred.selected\" name=\"makePreferred\" id=\"makePreferred\" />\n    <label for=\"makePreferred\">{{ content('memberReview.makePreferredShipping') }}</label>\n</div>\n"

/***/ },

/***/ "./components/xo-member-components/src/review-paywith/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	__webpack_require__("./components/xo-wallet-components/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/accessibility/directive.js");
	
	__webpack_require__("./components/xo-credit-components/src/pay-with-credit/directive.js");
	
	var _pxp = __webpack_require__("./components/xo-page-components/src/cart/lib/pxp.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _template = __webpack_require__("./components/xo-member-components/src/review-paywith/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// <pay-with-credit>
	// <xo-tooltip>
	(0, _angular.$registerDirective)('xo-review-paywith', function () {
	    return {
	        template: _template2['default'],
	        restrict: 'E',
	        scope: {
	            token: '=',
	            showBmlPopup: '=',
	            installmentNotSelected: '=',
	            payButtonText: '=',
	            installment: '='
	        },
	
	        controller: function controller($scope) {
	
	            $scope.locale = _squid.$locale;
	            $scope.formatCurrency = _squid.formatCurrency;
	
	            // check for feature enabled in config/inc/ui.json for AU country
	            // this feature is there only in country AU as of June 29th, 2015
	            $scope.showUachFeatureDiscalimer = false;
	
	            (0, _squid.$populate)($scope, {
	                checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
	                checkoutCart: _checkout.$CheckoutCartModel.instance($scope.token),
	                checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token),
	                payee: _checkout.$CheckoutPayeeModel.instance($scope.token)
	            }).then(function () {
	
	                // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
	                // are not available and purchase amount is not zero.
	                var userAction = _squid.$util.param('useraction');
	                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && $scope.checkoutCart.get('purchase.items.length', 0) === 0;
	
	                return (0, _pxp.$pxpCartAmt)($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
	                    $scope.showAmt = $scope.checkoutCart.get('payment_action') !== 'authorize' && showAmount;
	                });
	            }).then(function () {
	
	                var merchant = $scope.checkoutAppData.merchant;
	                $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	
	                $scope.sacEligible = function (fsType) {
	                    if (fsType !== 'BILL_ME_LATER') {
	                        return false;
	                    }
	
	                    var total = $scope.checkoutCart.get('purchase.amounts.total');
	                    if (total && !$scope.installment.showCYCO && parseFloat(total.amount) >= _checkout.$CreditOptionsModel.sacEligibleAmount[_squid.$locale.country]) {
	                        return true;
	                    }
	                };
	
	                var isBilling = $scope.checkoutCart.isBilling();
	                var isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
	                var disableStickyForMerchant = _squid.$config.disableMerchantForStickyBA.indexOf($scope.payee.merchant.id) > -1;
	                var stickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();
	
	                // Hide 'change' link for sticky disabled merchants
	                $scope.showPayMerchantWithPayPal = isBillingNoPurchase && (disableStickyForMerchant || !stickyInstrument);
	
	                var checkoutPlan = $scope.checkoutSession.plan;
	                $scope.canChangeFI = true;
	                if ($scope.showPayMerchantWithPayPal || checkoutPlan.isMSB()) {
	                    $scope.canChangeFI = false;
	                } else if (checkoutPlan.isBalance()) {
	                    $scope.canChangeFI = $scope.checkoutSession.fundingOptions.hasECheck() || $scope.checkoutSession.fundingOptions.hasCredit() || Boolean($scope.checkoutSession.getDisallowedPreferred());
	                }
	
	                $scope.gotoWallet = function () {
	                    if ($scope.canChangeFI) {
	                        _uiRouter.$state.go('checkout.review.sidebar.wallet');
	                    }
	                };
	
	                $scope.bmlSeeTerms = function () {
	                    $scope.showBmlPopup();
	                };
	
	                var stickyEligible = isBilling && !disableStickyForMerchant;
	                // save sticky decision - to be used in the app and other components
	                _squid.$config.features.DEFAULT.enableStickyFunding = stickyEligible;
	
	                $scope.getPlanList = function () {
	                    // with purchase - always use plan
	                    var planList = stickyEligible && isBillingNoPurchase ? $scope.checkoutSession.getSelectedStickyInstrument() && [$scope.checkoutSession.getSelectedStickyInstrument()] : $scope.checkoutSession.plan.sources;
	
	                    $scope.showUachFeatureDiscalimer = false;
	
	                    // required to display direct debit agreement to AU buyers with unconfirmed bank as payment mode
	                    angular.forEach(planList, function (plan) {
	                        // display uach - direct debit agreement for AU as of July 1st, 2015
	                        if (plan && plan.type === 'BANK_ACCOUNT' && plan.unconfirmed_bank && (0, _squid.$feature)('directDebitAgreement', false, plan.country_code)) {
	                            $scope.showUachFeatureDiscalimer = true;
	                        }
	                    });
	
	                    return planList;
	                };
	
	                $scope.showBackupPlan = function () {
	                    return $scope.checkoutSession.plan.backup && !(stickyEligible && isBillingNoPurchase);
	                };
	
	                if (isBilling) {
	                    $scope.isRP = $scope.checkoutCart.billing.type === 'RECURRING_PAYMENTS';
	                }
	
	                function getBAContent() {
	                    var consentCode = $scope.checkoutCart.billing.consent_code;
	                    var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';
	                    var stickyFI = $scope.checkoutSession.getSelectedStickyInstrument();
	
	                    var contentKey;
	                    if (consentCode) {
	                        contentKey = 'enterpriseAgreement.' + consentCode + (stickyEligible && stickyFI ? '' : 'No') + 'FiStickyConsent';
	                    } else {
	                        contentKey = 'billingAgreement.';
	                        if (stickyEligible && stickyFI) {
	
	                            $scope.isCIB = $scope.checkoutCart.billing.type === 'CHANNEL_INITIATED_BILLING' && _squid.$locale.country === 'US' && _squid.$locale.lang === 'en';
	
	                            contentKey += $scope.isCIB ? 'memberAgreementCibSticky' : 'memberAgreementFiSticky' + useraction;
	                        } else {
	                            contentKey += 'memberAgreementNoFiSticky' + useraction;
	                        }
	                    }
	                    return contentKey;
	                }
	
	                function getRPContent() {
	                    var contentKey = 'billingAgreement.';
	                    var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';
	
	                    if (stickyEligible && $scope.checkoutSession.getSelectedStickyInstrument()) {
	                        contentKey += 'rpAgreementFiSticky' + useraction;
	                    } else {
	                        contentKey += 'rpAgreementNoFiSticky' + useraction;
	                    }
	                    return contentKey;
	                }
	
	                if (isBilling) {
	                    $scope.baContentKey = getBAContent();
	                    $scope.rpContentKey = getRPContent();
	                }
	
	                $scope.getStickyFiName = function () {
	                    var selectedStickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();
	                    return stickyEligible && selectedStickyInstrument && selectedStickyInstrument.name;
	                };
	
	                $scope.getStickyFiLast4 = function () {
	                    var selectedStickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();
	                    return stickyEligible && selectedStickyInstrument && selectedStickyInstrument.last4 && 'x-' + selectedStickyInstrument.last4;
	                };
	            }).then(function () {
	                var negBals = $scope.checkoutSession.negBals;
	
	                // re-order multiple currencies when first balance has different currency
	                if (negBals && negBals[0] !== $scope.checkoutCart.purchase.amounts.currency_code) {
	                    negBals = negBals.reverse();
	                }
	                $scope.negBals = negBals;
	            }); // end $populate chain
	        } // end controller function
	    };
	}); // accessibility directives
	// <xo-cvv>
	
	
	_pxp.$pxpCartAmt;
	
	_checkout.$CheckoutCartModel;
	
	_checkout.$CheckoutAppDataModel;
	
	_checkout.$CheckoutSessionModel;
	
	_checkout.$CreditOptionsModel;
	
	_checkout.$CheckoutPayeeModel;
	
	_squid.formatCurrency;
	
	_squid.$util;
	
	_squid.$config;
	
	_squid.$feature;
	
	_squid.$populate;
	
	_squid.$locale;
	
	_uiRouter.$state;
	
	_angular.$registerDirective;

/***/ },

/***/ "./components/xo-wallet-components/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _addCard = __webpack_require__("./components/xo-wallet-components/src/add-card/index.js");
	
	Object.keys(_addCard).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _addCard[key];
	    }
	  });
	});

/***/ },

/***/ "./components/xo-credit-components/src/pay-with-credit/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/pay-with-credit/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-pay-with-credit.directive', ['squid', 'xomodel.checkout']).directive('xoPayWithCredit', function () {
	        return {
	            template: template,
	
	            restrict: 'E',
	
	            scope: {
	                token: '=',
	                doneFn: '='
	            },
	
	            controller: function controller($scope, $populate, $state, $CheckoutCartModel, $CheckoutSessionModel, $locale, $window, $logger, $config) {
	
	                var stateName = 'gce_pay_with_credit';
	
	                $populate($scope, {
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(function () {
	
	                    // For US and GB if txn amount is >= 99 or 150 resp show pay with credit option if credit in
	                    // wallet and is not the current funding option
	
	                    // required to avoid looging every digest cycle.
	                    // TODO: remove this when debounce is fixed for logger
	                    var offerShown = false;
	
	                    $scope.showPayWithCredit = function () {
	
	                        if (!$scope.checkoutCart.get('purchase.amounts.total.amount')) {
	                            offerShown = false;
	                            return false;
	                        }
	
	                        var amount = parseFloat($scope.checkoutCart.purchase.amounts.total.amount);
	                        var minAmount = $window.config.minCreditAmtNoInterest[$locale.country];
	                        var hasCredit = $scope.checkoutSession.fundingOptions.hasCredit();
	                        var fundingSource = $scope.checkoutSession.plan.sources;
	                        var showOffer = $config.features.DEFAULT.showPayWithCreditOffer && !$scope.checkoutSession.plccOffer;
	
	                        if (showOffer && minAmount && amount >= minAmount && hasCredit) {
	                            for (var i in fundingSource) {
	                                if (fundingSource[i].type === 'BILL_ME_LATER') {
	                                    offerShown = false;
	                                    return false;
	                                }
	                            }
	                            if (!offerShown) {
	                                $logger.info(stateName + '_offer_shown');
	                            }
	                            offerShown = true;
	                            return true;
	                        }
	                        offerShown = false;
	                        return false;
	                    };
	
	                    $scope.onSubmit = function () {
	
	                        $logger.info(stateName + '_offer_clicked');
	
	                        $scope.checkoutSession.message = null;
	
	                        var instruments = $scope.checkoutSession.fundingOptions.instruments;
	                        var creditPlanId;
	
	                        for (var i in instruments) {
	                            if (instruments[i].type === 'CREDIT' && instruments[i].name === 'BILL_ME_LATER') {
	                                creditPlanId = instruments[i].planId;
	                            }
	                        }
	
	                        if (!creditPlanId) {
	                            $logger.info(stateName + '_credit_planid_not_found');
	                            return;
	                        }
	
	                        $scope.checkoutSession.fundingOptions.action('select', {
	
	                            resultModel: $scope.checkoutSession,
	                            data: {
	                                planId: creditPlanId
	                            },
	
	                            success: function success(result) {
	
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['paymentMethod.paymentMethodUpdated']
	                                };
	                                $logger.info(stateName + '_success');
	                            }
	                        });
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/pay-with-credit/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"pay-with-credit\" class=\"bmlCtaWrap\" ng-if=\"showPayWithCredit()\" content>\n    <div class=\"trayInner trayInnerDefault\">\n        <div class=\"decreasedWidth noBottom\">\n            <p>{{ content('memberReview.switchToBml') }}</p>\n            <span class=\"disclaimer\" bind-html-compile=\"htmlContent('offers.seeBmlTerms')\"></span>\n        </div>\n        <a href=\"\" track-submit class=\"button-as-link edits\" ng-click=\"onSubmit()\">{{ content('common.select') }}</a>\n    </div>\n</div>\t"

/***/ },

/***/ "./components/xo-page-components/src/cart/lib/pxp.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-cart.pxp', ['squid.pxp']).factory('$pxpCartAmt', function ($pxp, $q) {
	        return function (merchantCountry, merchantId, noLineItemDetails, isPurchase) {
	
	            if (merchantCountry !== 'AU' && noLineItemDetails && isPurchase) {
	
	                var pageName = 'xo_hermes_no_line_item_details';
	                var showAmtBlacklistTreatment = 'xo_hermes_no_line_items_show_amount_blacklist_test_group';
	                var showAmtTreatment = 'xo_hermes_no_line_items_show_amount_test_group';
	
	                return $q.all([$pxp(pageName, {
	                    'ctx.merchantID': merchantId,
	                    uid: merchantId
	                }, showAmtBlacklistTreatment), $pxp(pageName, {
	                    'ctx.merchantID': merchantId,
	                    uid: merchantId
	                }, showAmtTreatment)]).then(function (results) {
	                    var showAmtBlacklist = results[0];
	                    var showAmt = results[1];
	
	                    if (showAmtBlacklist && showAmtBlacklist.treatment_name === showAmtBlacklistTreatment) {
	                        return true;
	                    }
	
	                    if (showAmt && showAmt.treatment_name === showAmtTreatment) {
	                        return true;
	                    }
	
	                    return false; // default to hide
	                });
	            }
	
	            return $q.when(!noLineItemDetails && isPurchase);
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-page-components/src/cart/lib", "components/xo-page-components/src/cart/lib/pxp.js"))

/***/ },

/***/ "./components/xo-member-components/src/review-paywith/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"paywith asideView\" content>\n    <div class=\"trayInner trayInnerDefault\" ng-class=\"{installments:(checkoutSession.installments.length > 1)}\">\n        <div id=\"paymentMethod\">\n            <div ng-click=\"gotoWallet()\" focusable=\"canChangeFI\" ng-class=\"{editable:canChangeFI}\" class=\"focusable\">\n                <h4 class=\"noBottom paymentsHeader zeta\">\n                    <span ng-if=\"checkoutSession.plan.isPAD()\">\n                        {{ content('paymentMethod.payAfter') }}\n                    </span>\n                    <span ng-if=\"!checkoutSession.plan.isPAD()\">\n                        <span ng-if=\"showPayMerchantWithPayPal\">\n                            {{ content('paymentMethod.payMerchantWithPayPal', {merchantName: merchant}) }}\n                        </span>\n                        <span ng-if=\"!showPayMerchantWithPayPal\">\n                            {{ content('paymentMethod.payWith') }}\n                        </span>\n                    </span>\n                </h4>\n                <ul class=\"charges\">\n                    <li ng-repeat=\"fs in getPlanList()\" class=\"clearfix fs\" ng-if=\"fs.amount.doubleValue != 0\">\n                        <div ng-class=\"['method', fs.type, fs.sub_type, fs.card_type]\">\n                            <span class=\"fsIcons\" ng-if=\"!fs.is_pinless_debit\"></span>\n                            <span class=\"pinlessGlyphIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fs.is_pinless_debit\"></span>\n                            <span class=\"name\" ng-if=\"fs.type === 'PPCREDIT'\">\n                                {{ content('paymentMethod.billmelater') }}\n                            </span>\n                            <span class=\"name\" ng-if=\"fs.sub_type === 'DELAYED_TRANSFER'\" ng-bind-html=\"htmlContent('paymentMethod.padFs', {bank: fs.name, date: fs.hop_date, last4: fs.last4})\">\n                            </span>\n                            <span class=\"name\" ng-if=\"fs.type === 'INCENTIVE'\">\n                                {{ content('paymentMethod.msbOffer') }}\n                            </span>\n                            <span class=\"name forceRTL\" ng-if=\"fs.type === 'BALANCE'\">\n                                {{ content('paymentMethod.paypalBalance') }}\n                            </span>\n                            <span class=\"name\" ng-if=\"fs.type === 'PAYPAL_EXTRAS_MASTERCARD'\">\n                                {{ content('fsMappings.PAYPAL_EXTRAS_MASTERCARD') }}\n                            </span>\n                            <span class=\"name\" ng-if=\"fs.type !== 'PPCREDIT' && fs.type !== 'INCENTIVE' && fs.type !== 'BALANCE' && fs.sub_type !== 'DELAYED_TRANSFER' && fs.type !== 'PAYPAL_EXTRAS_MASTERCARD'\">\n                                <span class=\"fsNamePinlessDebit\" ng-if=\"fs.is_pinless_debit\">\n                                    {{ content('paymentMethod.pinlessDebit') }}\n                                </span>\n                                <span class=\"fsname\" ng-if=\"!fs.is_pinless_debit\">\n                                    {{fs.name}}\n                                </span>\n                                <p class=\"bmlDetails\" ng-if=\"sacEligible(fs.type)\" bind-html-compile=\"htmlContent('fundingInstruments.bmlDetails')\"></p>\n                                <span ng-if=\"fs.type === 'ECHECK'\">{{ content('paymentMethod.eCheck') }}</span>\n                                <span class=\"fsLastDigitsPinlessDebit\" ng-if=\"fs.is_pinless_debit\">\n                                    {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                                </span>\n                                <span class=\"fslastdigits\" ng-if=\"!fs.is_pinless_debit\">\n                                    {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                                </span>\n                                <span ng-if=\"countryCode === 'DE'\">\n                                    <span ng-if=\"fs.sub_type === 'MEFT'\">\n                                        {{ content('paymentMethod.meft') }}\n                                    </span>\n                                    <span ng-if=\"fs.sub_type === 'IACH'\">\n                                        {{ content('paymentMethod.iach') }}\n                                    </span>\n                                    <span ng-if=\"fs.sub_type === 'INSTANT_TRANSFER' && fs.type === 'BANK'\">\n                                        {{ content('paymentMethod.instantTransfer') }}\n                                    </span>\n                                </span>\n                            </span>\n                            <p class=\"msbHelpText secondary\" ng-if=\"fs.type === 'INCENTIVE'\">\n                                {{ content('paymentMethod.msbHelpText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)})}}\n\n                                <a class=\"msbDetails\" id=\"msb_{{$index}}\">{{ content('paymentMethod.msbDetails')}}</a>\n                            </p>\n\n                            <xo-tooltip ng-if=\"fs.type === 'INCENTIVE'\" trigger=\"#msb_{{$index}}\" show-event=\"click\" hide-event=\"click\" ng-click=\"$event.stopPropagation()\">\n                                <div class=\"tip tipDesc\">\n                                    <h4>{{ content('paymentMethod.msbToolTipOffer') }}</h4>\n                                    <div class=\"msbToolTipDescription\">\n                                        <p ng-if=\"fs.minPurchaseAmount\">\n                                            {{ content('paymentMethod.msbToolTipText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code), minimumPurchase:fs.minPurchaseAmount}) }}\n                                        </p>\n                                        <p ng-if=\"!fs.minPurchaseAmount\">\n                                            {{ content('paymentMethod.msbToolTipText2', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)}) }}\n                                        </p>\n                                        <p>\n                                        </p>\n                                    </div>\n                                </div>\n                            </xo-tooltip>\n\n                            <xo-tooltip class=\"tip tipHint padHelpToolTip\" ng-if=\"fs.sub_type === 'DELAYED_TRANSFER'\" trigger=\"#padHelp\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                <div class=\"tipText tipHintText\">\n                                    <p class=\"padHeader\">\n                                        {{content('paymentMethod.padHelpTxt')}}\n                                    </p>\n                                    <ul class=\"bul\">\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList1', {date: fs.hop_date, country: locale.country, lang: locale.lang})\"></span>\n                                        </li>\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList2', {country: locale.country, lang: locale.lang})\"></span>\n                                        </li>\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList3')\"></span>\n                                        </li>\n                                    </ul>\n                                    <p>\n                                        <span ng-bind-html=\"htmlContent('paymentMethod.padTnc', {country: locale.country, lang: locale.lang})\"></span>\n                                    </p>\n                                </div>\n                            </xo-tooltip>\n                        </div>\n                        <div ng-if=\"(checkoutSession.installments.length > 1)\">\n                            <div ng-if=\"!installmentNotSelected || checkoutSession.selectedInstallmentData\">\n                                <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallments btn btn-secondary\">\n                                <span ng-if=\"checkoutSession.selectedInstallmentData\">{{checkoutSession.selectedInstallmentData.term}}X {{content('paymentMethod.of')}} {{checkoutSession.selectedInstallmentData.monthly_payment.formatted_value}}</span>\n                                <span ng-if=\"!checkoutSession.selectedInstallmentData\">{{content('paymentMethod.changeInstallmentLink') }}</span>\n                                    <span class=\"raq\"></span>\n                                </a>\n                            </div>\n\n                            <div ng-if=\"installmentNotSelected && !checkoutSession.selectedInstallmentData\">\n                                <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallmentsError btn btn-secondary\">\n                                {{content('paymentMethod.changeInstallmentLink') }}\n                                    <span class=\"raq\"></span>\n                                </a>\n                            </div>\n                        </div>\n                        <span ng-if=\"showAmt && !(checkoutSession.installments.length > 1)\" class=\"methodAmount\">\n                            <span class=\"amountFormatted\"><format-currency code=\"fs.amount.currency_code\" amount=\"fs.amount.amount\"></format-currency></span>\n                        </span>\n                    </li>\n                    <li class=\"method backupFunding\" ng-if=\"showBackupPlan()\">\n                        {{checkoutSession.plan.backup.name}}\n                        <span ng-if=\"!checkoutSession.plan.isAuthRequired\">x-{{checkoutSession.plan.backup.last4}} {{ content('paymentMethod.backup') }}</span>\n                    </li>\n                    <li ng-repeat=\"fs in checkoutSession.plan.sources\" class=\"clearfix\" ng-if=\"fs.sub_type === 'ECHECK' || (countryCode === 'AU' && fs.sub_type === 'DELAYED_TRANSFER')\" ng-class=\"{'fsicon-margin': negBals}\">\n                        <span class=\"disclaimer\" ng-if=\"fs.sub_type === 'ECHECK'\">\n                            {{ content('paymentMethod.eCheckDescription') }}\n                        </span>\n                        <span class=\"disclaimer\" ng-if=\"countryCode === 'AU' && fs.sub_type === 'DELAYED_TRANSFER'\">\n                            <a id=\"pad_details\">{{ content('paymentMethod.payAfterDeliveryDetails') }}</a>\n                            <xo-tooltip trigger=\"#pad_details\" on-events=\"click\">\n                                <div class=\"tip tipDesc\">\n                                    {{ content('paymentMethod.padHelpTxt', {date: fs.HOPDate}) }}\n                                    {{ content('paymentMethod.padHelpTxtList') }}\n                                </div>\n                            </xo-tooltip>\n                        </span>\n                    </li>\n                    <li ng-if=\"showAmt && negBals\" class=\"nbr-line fsicon-margin\">\n                        <span ng-bind-html=\"content('memberReview.nbrMerchantCut', { merchantName: merchant })\"></span>:\n                        <span class=\"nbr-amt\">\n                            {{ checkoutCart.purchase.amounts.total.amount_formatted }}\n                            <span class=\"currencyCode\">{{ checkoutCart.purchase.amounts.total.currency_code }}</span>\n                        </span>\n                    </li>\n                    <li ng-if=\"showAmt\" ng-repeat=\"nb in negBals\" class=\"nbr-line fsicon-margin\">\n                        {{ content('memberReview.nbrPaypalCut') }}:\n                        <span class=\"nbr-amt\">\n                            {{ nb.amount_formatted }}\n                            <span class=\"currencyCode\">{{ nb.currency_code }}</span>\n                        </span>\n                    </li>\n                    <li ng-if=\"checkoutSession.cvvData\" class=\"clearfix reviewEnterCvvContainer\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                        <div class=\"reviewEnterCvv\">\n                            <span class=\"enterCvvPrompt\">{{ content('memberReview.enterCSC') }}</span>\n                            <xo-cvv card=\"checkoutSession.cvvData\" show-label=\"false\"></xo-cvv>\n                        </div>\n                    </li>\n\n                    <li id=\"currencyConversion\" class=\"conversion\" ng-if=\"checkoutSession.plan.conversion\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                        <span ng-if=\"checkoutSession.plan.conversion.paypal\">\n\n                            <a id=\"conversionLink\" ui-sref=\"{{checkoutSession.plan.conversion.changeable ? 'checkout.review.sidebar.currencyConversion' : 'checkout.review'}}\"\n                                bind-html-compile=\"content('currencyOptions.conversionRate', {currencyFrom: checkoutSession.plan.conversion.from, currencyTo: checkoutSession.plan.conversion.to})\">\n                            </a>\n\n                            <xo-tooltip trigger=\"#conversionLink\" show-event=\"mouseover\" hide-event=\"mouseleave\" align=\"right\">\n                                <div class=\"tip tipDesc\">\n                                    <div bind-html-compile=\"content('paymentMethod.conversionDate', {date: checkoutSession.plan.conversion.date})\"></div>\n                                    <div ng-if=\"checkoutSession.plan.ispad && checkoutSession.plan.countryCode === 'AU'\">\n                                        {{ content('paymentMethod.conversionToolTipStatement', {date: checkoutSession.plan.conversion.date_formatted}) }}\n                                        ({{ content('paymentMethod.conversionDate', {date: checkoutSession.plan.conversion.date}) }})\n                                    </div>\n                                    <div ng-if=\"checkoutSession.plan.conversion.changeable && checkoutSession.plan.countryCode !== 'AU'\"\n                                        bind-html-compile=\"htmlContent('paymentMethod.changeConversionLink')\">\n                                    </div>\n                                </div>\n                            </xo-tooltip>\n                            <div ng-if=\"checkoutSession.plan.countryCode === 'AU' && checkoutSession.plan.conversion.changeable\"\n                                bind-html-compile=\"htmlContent('paymentMethod.changeConversionLink')\">\n                            </div>\n                        </span>\n                        <span ng-if=\"!checkoutSession.plan.conversion.paypal && checkoutSession.plan.conversion.changeable\">\n                            <a ui-sref=\"checkout.review.sidebar.currencyConversion\">{{ content('paymentMethod.optInConversionLink')}}</a>\n                        </span>\n                    </li>\n                </ul>\n                <div ng-if=\"checkoutSession.plan.conversion.from_code === 'BRL'\">\n                    <p class=\"disclaimer\">{{ content('currencyOptions.noBrazilianReal1')}} {{ content('currencyOptions.noBrazilianReal2')}}</p>\n                    <p class=\"disclaimer\">{{ content('currencyOptions.foreignExchange1')}} {{ content('currencyOptions.foreignExchange2')}}</p>\n                </div>\n            </div>\n\n            <div class=\"cibBillingTxt secondary\" ng-if=\"checkoutCart.isBilling() && isCIB && !isRP\">\n                <div class=\"billingScrollBox\">\n                    <div class= \"cibTextBox\" data-ng-bind-html=\"htmlContent(baContentKey, { merchantName: merchant,\n                 fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\">\n                    </div>\n                </div>\n            </div>\n\n            <p class=\"billingTxt secondary\" ng-if=\"checkoutCart.isBilling() && !isCIB && !isRP\">\n                <span data-ng-bind-html=\"htmlContent(baContentKey, { merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n            <p id=\"rpAgreement\" class=\"billingTxt secondary\" ng-if=\"checkoutCart.isBilling() && isRP\">\n                <span data-ng-bind-html=\"htmlContent(rpContentKey, { merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n            <div class=\"payWithCredit\">\n                <xo-pay-with-credit token=\"token\"></xo-pay-with-credit>\n            </div>\n\n            <!-- AU only direct debit agreement message for a AU buyer with unconfirmed bank -->\n            <p bind-html-compile=\"htmlContent('paymentMethod.directDebitAgreement', { payButtonText: payButtonText })\" ng-if=\"showUachFeatureDiscalimer\" class=\"disclaimer directDebitAgreement\"></p>\n\n\n            <a ui-sref=\"checkout.review.sidebar.wallet\" class=\"edits changePayment\" ng-if=\"canChangeFI\" select-button aria-label=\"{{ content('paymentMethod.label') }}\" focus-when-state=\"checkout.review.sidebar.wallet\" transitions-to=\"checkout.review\">\n                {{ locale.country === 'BR' ? content('common.changePayment') : content('common.change') }}\n                <span class=\"frontArrow goTray\"></span>\n            </a>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/messenger-plugin/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-page-components/src/messenger-plugin/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/app/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoMessengerPluginDirective', {
	
	    tag: 'xo-messenger-plugin',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        pluginType: {
	            type: 'str',
	            required: false
	        }
	    },
	
	    resolve: {
	        models: function models() {
	
	            return {
	                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
	                messengerIntegration: _index3.$MessengerIntegrationDataModel.instance().retrieve()
	            };
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            var that = this;
	            var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
	            var localStorageFlag = window.localStorage.getItem('is_xo_wps_fb_messenger_plugin_match_withba_shown');
	
	            _logger.$logger.info('Messenger_plugin_props', {
	                'pluginType': this.props.pluginType,
	                'isMobile': isMobile
	            });
	            _logger.$logger.info('Messenger_plugin_data', this.models.messengerIntegration);
	
	            this.isChatEnabled = this.models.messengerIntegration.isChatEnabled;
	            if (this.isChatEnabled || localStorageFlag === 'true' && this.props.pluginType === 'STM') {
	                _logger.$logger.info('UNP_chat_prefernce_is_already_enabled');
	                (0, _jquery2['default'])('.fb-send-to-messenger').hide();
	                (0, _jquery2['default'])('#stm-upsell-content').hide();
	                return;
	            }
	            var txnId = void 0;
	            var checkoutSession = this.models.checkoutSession;
	
	            if (checkoutSession && checkoutSession.transactionDetails) {
	                txnId = checkoutSession.transactionDetails.receipt_id;
	            }
	            var identityMatchJSON = {
	                'email_hash': this.models.messengerIntegration.emailHash,
	                'name_hash': this.models.messengerIntegration.nameHash
	            };
	            this.identityMatchVal = JSON.stringify(identityMatchJSON);
	            this.dataRefVal = this.models.messengerIntegration.dataRefJWT + '_txnID_' + txnId + '_plugin_' + this.props.pluginType + '_token_' + this.props.token;
	            this.originVal = window.location.origin;
	            if (that.originVal.indexOf('qa.paypal.com') !== -1 || that.originVal.indexOf('localhost') !== -1 || that.originVal.indexOf('sandbox.paypal.com') !== -1) {
	                this.pageIdVal = '676472402496128';
	            } else {
	                this.pageIdVal = '55982004572';
	            }
	
	            this.generateUUID = function () {
	                function s4() {
	                    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	                }
	                return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	            };
	
	            if (that.props.pluginType === 'CHECKBOX') {
	                this.uuidVal = this.generateUUID();
	                window.sessionStorage.checkboxUUIDVal = this.uuidVal;
	            }
	
	            _squid.$dom.loadScript('facebook-jssdk', 'https://www.paypalobjects.com/js/xo/fb_sdk.js').then(function () {
	                if (window.FB) {
	                    that.fbAsyncInit();
	                    //  Note - Uncomment following on stage and localhost
	                    // that.cbSTMPlugin({
	                    //     event: 'identity_match',
	                    //     ref: that.dataRefVal,
	                    //     result: 'no_match'
	                    // });
	                }
	            });
	
	            this.cbSTMPlugin = function (evt) {
	                var _this = this;
	
	                // callback for events triggered by the STM plugin
	                if (evt.event === 'rendered' && that.props.pluginType === 'STM') {
	                    _logger.$logger.info('STM_plugin_rendered');
	                }
	
	                if (evt.event === 'identity_match' && evt.result === 'match' && that.props.pluginType === 'STM') {
	                    _logger.$logger.info('FBPP_ID_match');
	                    that.dataRefVal = evt.ref;
	                    (0, _squid.$pxp)('xo_wps_fb_messenger_plugin', {
	                        'ctx.COUNTRY': _squid.$locale.country,
	                        'ctx.CHANNEL': isMobile ? 'MOBILE' : 'WEB',
	                        'ctx.LANGUAGE': _squid.$locale.lang + '_' + _squid.$locale.country
	                    }, 'xo_wps_fb_messenger_plugin_match_withba').then(function (result) {
	                        _logger.$logger.info('Messenger_Plugin_PXP_RESULT', result);
	                        if (result && result.treatment_name === 'xo_wps_fb_messenger_plugin_match_withba') {
	                            _this.pxpMessengerBAIntegrationEnabled = true;
	                            _jquery2['default'].ajax({
	                                url: 'https://www.facebook.com/paypal/user_identifier',
	                                xhrFields: {
	                                    withCredentials: true
	                                }
	                            }).always(function (response) {
	                                var responseText = response.responseText;
	                                var json = responseText.substring(responseText.indexOf('{'));
	                                var data = _jquery2['default'].parseJSON(json);
	                                _logger.$logger.info('callFBToGetBAToken_call', data);
	                                that.models.messengerIntegration.action('callFBToGetBAToken', {
	                                    data: {
	                                        userIdentifier: data.user_identifier
	                                    },
	                                    success: function success(fbresult) {
	                                        if (fbresult.success) {
	                                            (function () {
	                                                _logger.$logger.info('BAToken_from_FB', {
	                                                    'batoken': fbresult.batoken
	                                                });
	                                                var fbBAToken = fbresult.batoken,
	                                                    BAUrl = void 0,
	                                                    xoJSData = void 0;
	
	                                                if (that.originVal.indexOf('localhost') !== -1) {
	                                                    fbBAToken = 'BA-7JB56787ER523553D';
	                                                }
	                                                if (that.originVal.indexOf('localhost') !== -1) {
	                                                    BAUrl = 'http://localhost.paypal.com:8000/webapps/hermes/agreements/approve?ul=0&messenger_ba=1';
	                                                    xoJSData = {
	                                                        'data-env': 'local',
	                                                        'data-stage': 'msrelease',
	                                                        'data-no-bridge': ''
	                                                    };
	                                                } else if (that.originVal.indexOf('sandbox.paypal.com') !== -1 || that.originVal.indexOf('qa.paypal.com') !== -1) {
	                                                    BAUrl = 'https://www.sandbox.paypal.com/agreements/approve?messenger_ba=1';
	                                                    xoJSData = {
	                                                        'data-env': 'sandbox',
	                                                        'data-no-bridge': ''
	                                                    };
	                                                } else {
	                                                    BAUrl = 'https://www.paypal.com/agreements/approve?messenger_ba=1';
	                                                    xoJSData = {
	                                                        'data-env': 'production',
	                                                        'data-no-bridge': ''
	                                                    };
	                                                }
	                                                var launchBAFlow = function launchBAFlow() {
	                                                    _logger.$logger.info('Launch_BA_flow_with_token', {
	                                                        'fbBAToken': fbBAToken
	                                                    });
	                                                    _logger.$logger.info('Launch_BA_flow_with_URL', {
	                                                        'BAUrl': BAUrl
	                                                    });
	                                                    window.ppxo.Checkout.contexts.lightbox = true;
	                                                    window.localStorage.setItem('is_xo_wps_fb_messenger_plugin_match_withba_shown', 'true');
	                                                    window.ppxo.Checkout.render({
	                                                        url: BAUrl,
	                                                        billingAgreement: fbBAToken,
	                                                        onAuthorize: function onAuthorize(authorizedResponse) {
	                                                            _logger.$logger.info('User_accepted_FB_BA');
	                                                            if (window.sessionStorage.checkboxPluginState === 'unchecked') {
	                                                                _logger.$logger.info('user_not_accepted_messenger_notifications');
	                                                                (0, _jquery2['default'])('.fb-send-to-messenger').hide();
	                                                                (0, _jquery2['default'])('#stm-upsell-content').hide();
	                                                                (0, _jquery2['default'])('#ba-integration-content').show();
	                                                            } else {
	                                                                _logger.$logger.info('user_accepted_checkbox_messenger_notifications');
	                                                                (0, _jquery2['default'])('.fb-send-to-messenger').hide();
	                                                                (0, _jquery2['default'])('#stm-upsell-content').hide();
	                                                                (0, _jquery2['default'])('#messenger-ba-integration-content').show();
	                                                            }
	                                                            that.confirmCheckboxPluginOptIn();
	                                                            that.models.messengerIntegration.action('notifyFBOntBAAuthorize', {
	                                                                data: {
	                                                                    baToken: authorizedResponse.billingToken
	                                                                },
	                                                                success: function success(fbCallResult) {
	                                                                    if (fbCallResult.success) {
	                                                                        _logger.$logger.info('notifyFBOntBAAuthorize_call_success!');
	                                                                    } else {
	                                                                        _logger.$logger.info('notifyFBOntBAAuthorize_call_failure!');
	                                                                    }
	                                                                }
	                                                            });
	                                                        }
	                                                    });
	                                                };
	                                                if (window.ppxo) {
	                                                    _logger.$logger.info('xo_JS_is_already_present');
	                                                    launchBAFlow();
	                                                } else {
	                                                    _squid.$dom.loadScript('xo-js', 'https://www.paypalobjects.com/api/paypal.checkout.v4.js', 0, xoJSData).then(function () {
	                                                        _logger.$logger.info('xo_JS_got_loaded');
	                                                        launchBAFlow();
	                                                    });
	                                                }
	                                            })();
	                                        } else {
	                                            _logger.$logger.info('callFBToGetBAToken_call_failure!');
	                                        }
	                                    }
	                                });
	                            });
	                        } else {
	                            _logger.$logger.info('no_pxp_for_ba');
	                            _this.pxpMessengerBAIntegrationEnabled = false;
	                        }
	                    });
	                } else if (evt.event === 'identity_match' && evt.result === 'no_match' && that.props.pluginType === 'STM') {
	                    _logger.$logger.info('No_FBPP_ID_match');
	                } else if (evt.event === 'identity_match' && evt.result === 'no_logged_in_user' && that.props.pluginType === 'STM') {
	                    _logger.$logger.info('No_loggedin_FBPP_ID_match');
	                } else if (evt.event === 'identity_match' && evt.result === 'failure' && that.props.pluginType === 'STM') {
	                    _logger.$logger.info('Fail_FBPP_ID_match');
	                } else if (evt.event === 'clicked' && that.props.pluginType === 'STM') {
	                    _logger.$logger.info('user_accepted_STM_messenger_notifications');
	                }
	            };
	            this.fbAsyncInit = function () {
	                _logger.$logger.info('Initializing_FB_scripts');
	                window.FB.init({
	                    appId: '1084613224964631',
	                    xfbml: true,
	                    version: 'v2.6'
	                });
	                // Subscribe to STM
	                window.FB.Event.subscribe('send_to_messenger', this.cbSTMPlugin);
	
	                // Subscribe to CHECKBOX
	                window.FB.Event.subscribe('messenger_checkbox', function (evt) {
	                    _logger.$logger.info('messenger_checkbox_event', evt);
	                    if (evt.event === 'checkbox') {
	                        window.sessionStorage.checkboxPluginState = evt.state;
	                        _logger.$logger.info('checkbox_plugin_state_' + that.checkboxPluginState);
	                    }
	                });
	            };
	
	            this.confirmCheckboxPluginOptIn = function () {
	                _logger.$logger.info('MessengerCheckboxPluginUserConfirmation_event_to_fb', {
	                    'uuidVal': window.sessionStorage.checkboxUUIDVal,
	                    'pageIdVal': this.pageIdVal,
	                    'dataRefVal': this.dataRefVal
	                });
	                window.FB.AppEvents.logEvent('MessengerCheckboxUserConfirmation', null, {
	                    'page_id': this.pageIdVal,
	                    'app_id': '1084613224964631',
	                    'ref': this.dataRefVal,
	                    'user_ref': window.sessionStorage.checkboxUUIDVal
	                });
	            };
	        },
	        exit: function exit() {
	            _logger.$logger.info('Messenger_plugin_EXIT_event');
	        }
	    }
	});
	
	_logger.$logger;
	
	_squid.$Component;
	
	_squid.$pxp;
	
	_squid.$dom;
	
	_squid.$locale;
	
	_index.$DeviceInfo;
	
	_index2.$CheckoutSessionModel;
	
	_index3.$MessengerIntegrationDataModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-page-components/src/messenger-plugin/template.html":
/***/ function(module, exports) {

	module.exports = "<messenger-plugin content>\n\t<div id=\"messenger-plugin\" ng-value=\"props.pluginType\">\n\n\t\t<div class=\"fb-send-to-messenger\" origin=\"{{originVal}}\" identity_match=\"{{identityMatchVal}}\" messenger_app_id=1084613224964631\n\t\t\tpage_id={{pageIdVal}} data-ref=\"{{dataRefVal}}\" color=\"blue\" size=\"xlarge\" ng-if=\"(props.pluginType == 'STM')\">\n\t\t</div>\n\n\t\t<div class=\"fb-messenger-checkbox\" origin=\"{{originVal}}\" page_id={{pageIdVal}} messenger_app_id=1084613224964631\n\t\t\tpixel_id=329481497393670 user_ref=\"{{uuidVal}}\" prechecked=\"true\" allow_login=\"true\" size=\"xlarge\"\n\t\t\tng-if=\"(props.pluginType == 'CHECKBOX')\">\n\t\t</div>\n        \n\t</div>\n</messenger-plugin>"

/***/ },

/***/ "./components/xo-credit-components/src/offer/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var ACQ_Banner_Type = 'acquisition';
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/offer/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-offer.directive', ['squid', 'xomodel.checkout']).directive('xoOffer', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                promotion: '=',
	                bmlaction: '=',
	                installment: '='
	            },
	
	            controller: function controller($scope, $FallbackError, $populate, $state, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel, $pxp, $logger, $InstallmentOptionsModel, $feature, $locale, $CheckoutPayeeModel, $util, $CreditDataModel, $CreditOptionsModel, $config) {
	
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    payee: $CheckoutPayeeModel.instance($scope.token)
	                }).then(function () {
	                    $scope.creditTerms = $config.urls.creditTerms;
	                    $scope.creditReuseTerms = $config.urls.creditReuseTerms;
	                    $scope.bmlOffer = $scope.checkoutSession.bmlOffer;
	                    $scope.buyerCountry = $locale.country;
	                    var country = $scope.checkoutAppData.merchant.merchant_country;
	                    var cart = $scope.checkoutCart;
	                    var isRedirectFromCape = $CreditDataModel.instance($scope.token).isRedirectFromCape();
	                    var fundingInstruments = $scope.checkoutSession.get('fundingOptions.instruments');
	                    var merchantId = $scope.payee.getId();
	                    $scope.showPPCLogo = false;
	                    var isCreditInWallet = $util.find(fundingInstruments, function (fi) {
	                        return fi.name === 'BILL_ME_LATER';
	                    });
	
	                    if ($feature('creditInstallmentOffers') && country === $locale.country && !cart.isBilling()) {
	
	                        var offers = $InstallmentOptionsModel.instance($scope.token);
	                        offers.save({
	                            data: {
	                                payee: $scope.payee,
	                                checkoutCart: $scope.checkoutCart,
	                                checkoutAppData: $scope.checkoutAppData,
	                                isMemberCredit: true
	                            },
	                            success: function success(result) {
	                                $scope.creditOffers = result.installments && result.installments[0];
	                                $scope.installmentCount = $scope.creditOffers && $scope.creditOffers.installment_options && $scope.creditOffers.installment_options.length;
	                                $scope.installmentOptionsPresent = $scope.checkoutSession.creditOffer && $scope.installmentCount > 0;
	                                $scope.showUKCape = $scope.checkoutAppData.is_second_button_txn || !$feature('blockCreditBanners');
	                                $scope.installment.showBanner = showBannerRules();
	                                $scope.installment.showCYCO = showCYCORules();
	                                $scope.showBml = $scope.installment.showBanner || isRedirectFromCape || $locale.country === 'GB' ? false : $scope.bmlOffer === 1 || $scope.bmlOffer === 2;
	                            },
	                            contingencies: {
	                                DEFAULT: function DEFAULT() {
	                                    $logger.info('GET_INSTALLMENT_CONTINGENCY');
	                                }
	                            }
	                        });
	                    } else {
	                        $scope.showBml = cart.isBillingNoPurchase() || isRedirectFromCape || $locale.country === 'GB' ? false : $scope.bmlOffer === 1 || $scope.bmlOffer === 2;
	                    }
	
	                    var showBannerRules = function showBannerRules() {
	                        if ($locale.country === 'GB') {
	                            $scope.offerTypeKey = $scope.installmentOptionsPresent ? 'offers.bmlInstallmentTitle' : $scope.isBmlOfferSmallOrLarge(ACQ_Banner_Type);
	                            return !!($scope.showUKCape && !isCreditInWallet && !isRedirectFromCape && ($scope.bmlOffer === 1 || $scope.bmlOffer === 2 || $scope.checkoutSession.creditOffer));
	                        } else {
	                            return !isCreditInWallet && $scope.installmentOptionsPresent && !isRedirectFromCape ? true : false;
	                        }
	                    };
	
	                    var showCYCORules = function showCYCORules() {
	                        var commonRules = isCreditInWallet && $scope.checkoutSession.creditOffer && $scope.installmentOptionsPresent;
	                        if ($locale.country === 'GB') {
	                            return $scope.showUKCape && commonRules;
	                        } else {
	                            return commonRules;
	                        }
	                    };
	
	                    $scope.selectExistingBml = function () {
	
	                        var fiList = $scope.checkoutSession.get('fundingOptions.instruments');
	
	                        var fundingSource = $util.find(fiList, function (fi) {
	                            return fi.name === 'BILL_ME_LATER';
	                        });
	
	                        $scope.checkoutSession.fundingOptions.action('select', {
	
	                            resultModel: $scope.checkoutSession,
	
	                            data: {
	                                planId: fundingSource.planId
	                            },
	                            success: function success(result) {
	                                if (result) {
	                                    // Update the installments to support the user selecting a card that does not support installments.
	                                    $scope.checkoutSession.installments = result.installments;
	                                }
	                                if (fundingSource.type === 'CREDIT' && $scope.installment.showCYCO) {
	                                    $state.go('checkout.chooseCreditOffer');
	                                } else {
	                                    if (!fundingSource.selected) {
	                                        $scope.checkoutSession.message = {
	                                            type: 'success',
	                                            msgKeys: ['paymentMethod.paymentMethodUpdated']
	                                        };
	                                        if ($scope.checkoutSession.selectedInstallmentData && !$scope.checkoutSession.selectedInstallmentData.preventChange) {
	                                            // Resetting selected installment data, if installment change is not explicitly prohibited.
	                                            $scope.checkoutSession.selectedInstallmentData = undefined;
	                                        }
	                                    }
	                                    $state.go('checkout.review');
	                                }
	                            }
	                        });
	                    };
	
	                    // US693795: Acquisition Banner PXP test
	                    var pxpGetAcquisitionBanner = function pxpGetAcquisitionBanner() {
	                        var pxpPrefix = 'xo_hermesnodeweb_us_ryi_ppc_';
	                        var bannerExperiment = pxpPrefix + 'ppcacquisitionbanner';
	                        var treatmentName = '';
	                        $scope.pxpCalledAcquisitionBanner = true;
	                        $pxp(bannerExperiment, {
	                            'ctx.COUNTRY': $locale.country,
	                            'ctx.MERCHANT_ID': merchantId
	                        }, '(xo_hermesnodeweb_us_ryi_ppc_)(.*)').then(function (result) {
	                            if (result && result.treatment_name) {
	                                treatmentName = result.treatment_name;
	                                $scope.acquisitionBannerTreatmentName = treatmentName;
	                                if (treatmentName === pxpPrefix + 'left_logo') {
	                                    $scope.showAcquisitionBannerLogo = true;
	                                } else if (treatmentName === pxpPrefix + 'OR') {
	                                    $scope.showAcquisitionBannerLogo = true;
	                                } else if (treatmentName === pxpPrefix + 'contentchange') {
	                                    $scope.showAcquisitionBannerLogo = true;
	                                    $scope.bmlOfferTitle = $scope.getTransactionAmount() === 0 ? $scope.htmlContent('offers.bmlOfferTitleWithAmountZero') : $scope.getBmlOfferTitle('WithAmount', {
	                                        cartAmount: $scope.checkoutCart.get('purchase.amounts.total.amount_formatted')
	                                    });
	                                } else if (treatmentName === pxpPrefix + 'right_logo') {
	                                    $scope.showAcquisitionBannerLogo = true;
	                                } else {
	                                    $scope.showAcquisitionBannerLogo = false;
	                                }
	                            }
	                        }, function () {
	                            $scope.pxpCalledAcquisitionBanner = false;
	                        });
	                    };
	
	                    // US693795: Acquisition Banner PXP test
	                    $scope.getBmlOfferTitle = function (suffix, data) {
	                        if ($scope.bmlOffer === 1) {
	                            return $scope.htmlContent('offers.bmlOfferLargeTitle' + suffix, data);
	                        } else if ($scope.bmlOffer === 2) {
	                            return $scope.htmlContent('offers.bmlOfferSmallTitle' + suffix, data);
	                        } else {
	                            return '';
	                        }
	                    };
	
	                    // US693795: Acquisition Banner PXP test
	                    $scope.showAcquisitionBanner = function () {
	                        if ($scope.showBml && $scope.buyerCountry === 'US' && !$scope.pxpCalledAcquisitionBanner) {
	                            // override bmlOffer
	                            if ($scope.isBmlOfferLarge()) {
	                                $scope.bmlOffer = 1;
	                            } else {
	                                $scope.bmlOffer = 2;
	                            }
	                            $scope.bmlOfferTitle = $scope.getBmlOfferTitle('');
	                            pxpGetAcquisitionBanner();
	                        }
	                        return $scope.showBml && $scope.buyerCountry !== 'GB';
	                    };
	
	                    /**
	                     * Only show PPC Reuse banner if
	                     * Country is US & Credit is not default AND There is credit in wallet AND pxp variant has banner
	                     **/
	                    $scope.showReuseBanner = function () {
	                        $scope.isCreditDefault = $scope.checkoutSession.get('plan.paypal_credit');
	                        var reuseRules = isCreditInWallet && !$scope.isCreditDefault;
	                        $scope.installment.showRepresentativeInfo = $scope.showUKCape && $locale.country === 'GB' && (reuseRules || $scope.installment.showBanner);
	                        $scope.showPPCLogo = true;
	
	                        if ($locale.country === 'US' && reuseRules) {
	                            return true;
	                        } else if ($scope.showUKCape && $locale.country === 'GB' && reuseRules) {
	                            $scope.reuseOfferTypeKey = $scope.installmentOptionsPresent ? 'offers.bmlExistingOfferInstallment' : $scope.isBmlOfferSmallOrLarge();
	                            return true;
	                        }
	                        return false;
	                    };
	
	                    /**
	                     * This function is to determine that the offer is large offer (transaction amount >= 99) or
	                     * smaller (transaction amount < 99) to display appropriate text on ui
	                     * @returns bmlExistingSmall/LargeOffer
	                     */
	                    $scope.isBmlOfferSmallOrLarge = function (bannerType) {
	                        var key;
	                        if ($scope.isBmlOfferLarge()) {
	                            key = bannerType === ACQ_Banner_Type ? 'offers.bmlOfferLargeTitle' : 'offers.bmlExistingOfferLarge';
	                        } else {
	                            key = bannerType === ACQ_Banner_Type ? 'offers.bmlOfferSmallTitle' : 'offers.bmlExistingOfferSmall';
	                        }
	                        return key;
	                    };
	
	                    // US693795: Acquisition Banner PXP test
	                    // small refactor of isBmlOfferSmallOrLarge() function
	                    $scope.isBmlOfferLarge = function () {
	                        var transactionAmount = $scope.getTransactionAmount();
	                        var sacEligibleAmount = $CreditOptionsModel.sacEligibleAmount[$locale.country];
	                        return transactionAmount >= sacEligibleAmount;
	                    };
	
	                    // US693795: Acquisition Banner PXP test
	                    $scope.getTransactionAmount = function () {
	                        var transactionAmount = $scope.checkoutCart.get('purchase.amounts.total.amount');
	                        return parseFloat(transactionAmount) || 0;
	                    };
	
	                    $scope.bml = function () {
	                        $state.go('checkout.redirectToCape');
	                    };
	
	                    $scope.creditOffer = function () {
	                        $state.go('checkout.chooseCreditOffer');
	                    };
	
	                    $scope.addPlcc = function () {
	                        $scope.promotion.type = 'plcc';
	                        $state.go('checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard');
	                    };
	
	                    $scope.showPlcc = $scope.checkoutSession.plccOffer;
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/offer/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"offerForm\" action=\"#\" method=\"POST\" class=\"offer asideView\" content>\n\n    <div id=\"installmentOffer\" class=\"bmlCtaWrap\" ng-if=\"installment.showBanner\">\n        <div class=\"trayInner\">\n            <p class=\"installmentDescription\" ng-if=\"offerTypeKey\"\n               ng-bind-html=\"htmlContent(offerTypeKey,{monthlyPayment: creditOffers.installment_options[installmentCount -1].monthlyPayment.formattedAmt, term:creditOffers.installment_options[installmentCount -1].term})\"></p>\n            <p ng-if=\"!offerTypeKey\" class=\"installmentDescription\"\n               ng-bind-html=\"htmlContent('offers.bmlOfferSmallTitle')\"></p>\n            <span class=\"cycoApplyLink\">\n                <a track-link=\"acquisition_offer_banner\" link-button ng-click=\"creditOffer()\" class=\"proceed\">{{content('offers.cycoOfferBtn')}}\n                    <span class=\"frontArrow goTray\"></span>\n                </a>\n            </span>\n\n            <p ng-if=\"buyerCountry !=='GB'\" class=\"bmlSeeTerms offerSmallText\">\n                <span class=\"ng-scope\">{{content('applyForBml.subjectApproval')}}</span>\n            </p>\n        </div>\n    </div>\n\n    <div id=\"bmlOffer\" class=\"bmlCtaWrap\" ng-class=\"acquisitionBannerTreatmentName\" ng-if=\"showAcquisitionBanner()\">\n        <div class=\"trayInner\">\n            <div class=\"acquisitionBannerSeparator\"><span ng-bind-html=\"htmlContent('common.or')\"></span></div>\n            <div class=\"acquisitionBannerLeft\">\n                <div ng-show=\"showAcquisitionBannerLogo\" class=\"creditIcon\"/>\n            </div>\n            <div class=\"acquisitionBannerRight\">\n                <p class=\"bmlOfferTitle\" ng-bind-html=\"bmlOfferTitle\"></p>\n                <p class=\"bmlSeeTerms offerSmallText\">\n                    <span class=\"clearfix bmlOfferText\" ng-if=\"bmlOffer===1 || bmlOffer===2\"\n                          ng-bind-html=\"htmlContent('offers.bmlOfferLarge')\"></span>\n                    <span class=\"seeTermsLink ng-scope\">{{content('applyForBml.subjectApproval')}} <a\n                            href='{{creditTerms}}'\n                            class='popup bmlTermsLink' target='_blank'\n                            xo-popup>{{content('applyForBml.seeTerms')}}</a></span>\n                </p>\n            </div>\n            <div class=\"clearfix\"></div>\n            <span class=\"bmlApplyLink\">\n                <a link-button ng-click=\"bml()\" class=\"proceed\">{{content('offers.bmlOfferBtn')}}</a>\n            </span>\n        </div>\n    </div>\n\n    <div id=\"bmlExistingOffer\" class=\"bmlCtaWrap\" ng-show=\"showReuseBanner()\">\n        <div class=\"trayInner\">\n            <div ng-show=\"showPPCLogo\" class=\"creditIcon\"/>\n            <p class=\"bmlExistingOfferTitle\" ng-bind-html=\"htmlContent('offers.bmlExistingOfferTitle')\"></p>\n\n            <span class=\"bmlChangeLink\">\n                <a track-link=\"reuse_offer_banner\" link-button ng-click=\"selectExistingBml()\" class=\"proceed\">{{content('common.select')}}</a>\n            </span>\n\n            <p class=\"bmlSeeTerms offerSmallText\">\n                <span ng-if=\"buyerCountry !=='GB'\" class=\"clearfix bmlExistingOfferText\"\n                      ng-bind-html=\"htmlContent(isBmlOfferSmallOrLarge())\"></span>\n                <span ng-if=\"buyerCountry ==='GB'\" class=\"clearfix bmlExistingOfferText\"\n                      ng-bind-html=\"htmlContent(reuseOfferTypeKey,{monthlyPayment: creditOffers.installment_options[installmentCount -1].monthlyPayment.formattedAmt, term:creditOffers.installment_options[installmentCount -1].term})\"></span>\n                <span ng-if=\"buyerCountry !=='GB'\" class=\"seeTermsLink ng-scope\"><a href='{{creditReuseTerms}}'\n                        class='popup bmlTermsLink' target='_blank'\n                        xo-popup>{{content('applyForBml.seeTerms')}}</a></span>\n            </p>\n\n        </div>\n    </div>\n\n    <div id=\"plccOffer\" class=\"bmlCtaWrap\" ng-if=\"showPlcc\">\n        <div class=\"trayInner\">\n            <div class=\"plccOfferHeader\">\n                <img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n                <p class=\"headerText\"> {{ content('offers.plccCardOfferHeader',{ merchantName:promotion.name}) }}</p>\n                <span class=\"plccAddNowLink\">\n                    <a link-button ng-click=\"addPlcc()\" class=\"proceed\">{{content('offers.plccAddNowLink')}}</a>\n                </span>\n                <p class=\"plccOfferDesc\">{{ content('offers.plccCardOfferDesc',{merchantName:promotion.name}) }}</p>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-models/src/bml/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.bml', ['squid']).factory('$ApplyForBMLModel', function ($Model, $Api) {
	
	        return $Model.extend('ApplyForBMLModel', {
	            api: new $Api({
	                uri: '/api/checkout/:id/cart',
	                cache: true
	            }),
	
	            personalInformation: {
	                day: '',
	                month: '',
	                year: '',
	                natId: '',
	                phone: {
	                    telephone: '',
	                    phoneType: ''
	                }
	            },
	
	            billingAdrress: {
	                phoneType: '',
	                phoneNumber: ''
	            }
	        });
	    }).factory('$BMLModel', function ($Model, $Api) {
	
	        return $Model.extend('BMLModel', {
	            api: new $Api({
	                uri: '/api/bml',
	                cache: false
	            }),
	
	            applicationStatus: function applicationStatus() {
	                return this.application_status;
	            },
	
	            applicationId: function applicationId() {
	                return this.application_id;
	            }
	        });
	    }).factory('$BMLApplicationModel', function ($Model, $Api) {
	
	        return $Model.extend('BMLApplicationModel', {
	            api: new $Api({
	                uri: '/api/bml/:application_id',
	                cache: false
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/bml", "components/xo-models/src/bml/index.js"))

/***/ },

/***/ "./components/xo-models/src/fi/lib/fiMessages.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('fi.messages', ['squid']).factory('$fiMessages', function ($renderContent, $logger) {
	
	        function getContentKeys(hasFi) {
	            if (hasFi) {
	                return {
	                    member: 'payment.processorDeclineMember',
	                    generic: 'payment.processorDeclineMemberGeneric',
	                    buyerCredit: 'payment.processorDeclineMemberBuyerCredit'
	                };
	            } else {
	                return {
	                    member: 'payment.processorDeclineMemberNoFI',
	                    generic: 'payment.processorDeclineMemberNoFIGeneric',
	                    buyerCredit: 'payment.processorDeclineMemberBuyerCreditNoFI'
	                };
	            }
	        }
	
	        function processorDeclinedMsg(checkoutSession, hasFi) {
	            var declinedInstruments = checkoutSession.get('declinedInstruments');
	
	            if (angular.isArray(declinedInstruments) && declinedInstruments.length) {
	                var msg;
	                var type = 'warning';
	                var instrument = declinedInstruments[0];
	                var contentKeys = getContentKeys(hasFi);
	
	                if (instrument.type === 'PAYMENT_CARD') {
	                    if (instrument.card_type && instrument.last4) {
	                        $logger.info('processor_decline', { hasFi: hasFi, message: 'member' });
	
	                        msg = $renderContent(contentKeys.member, {
	                            type: instrument.card_type,
	                            number: instrument.last4
	                        });
	                    } else {
	                        $logger.info('processor_decline', { hasFi: hasFi, message: 'generic' });
	
	                        msg = $renderContent(contentKeys.generic);
	                    }
	                } else {
	                    $logger.info('processor_decline', { hasFi: hasFi, message: 'buyerCredit' });
	
	                    msg = $renderContent(contentKeys.buyerCredit);
	                }
	
	                checkoutSession.set('declinedInstruments', null);
	                return {
	                    type: type,
	                    msg: msg
	                };
	            }
	        }
	
	        function errorMsg(isGambling) {
	            var msg;
	
	            if (isGambling) {
	                msg = $renderContent('creditcard.noEligibleFI');
	            } else {
	                msg = $renderContent('creditcard.noFIContingency');
	            }
	            return {
	                type: 'error',
	                msg: msg
	            };
	        }
	
	        return {
	            processorDeclinedMsg: processorDeclinedMsg,
	            errorMsg: errorMsg
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/fi/lib", "components/xo-models/src/fi/lib/fiMessages.js"))

/***/ },

/***/ "./components/xo-models/src/fi/lib/fiApis.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('fi.apis', ['squid']).factory('$fiApis', function ($q) {
	        return {
	            patchCvv: function patchCvv(checkoutSession) {
	                var cvvData = checkoutSession.get('cvvData');
	
	                if (cvvData) {
	                    return checkoutSession.action('patchCvv', {
	                        data: {
	                            id: cvvData.id,
	                            cvv: cvvData.security_code,
	                            type: cvvData.type,
	                            number: cvvData.number
	                        }
	                    });
	                }
	
	                return $q.when();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/fi/lib", "components/xo-models/src/fi/lib/fiApis.js"))

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-popup/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-popup/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/bml/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return angular.module('xo-bml-popup.directive', ['squid', 'xomodel.checkout', 'xomodel.bml', 'beaver']).directive('xoBmlPopup', function () {
	
	        return {
	            template: template,
	            controller: function controller($scope, $populate, $rootScope, $CheckoutSessionModel, $BMLModel, $logger) {
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($rootScope.token)
	                }).then(function () {
	                    if ($scope.checkoutSession.showDeclinePopup) {
	                        if (!$rootScope.bml) {
	                            $rootScope.bml = new $BMLModel();
	                        }
	                        if (!$scope.bml) {
	                            $scope.bml = $rootScope.bml;
	                        }
	
	                        $scope.bml.preferenceCheck = false;
	                        $scope.bml.showModal = true;
	                        $scope.bml.showModalBackdrop = true;
	
	                        if ($scope.bml.applicationStatus() || $scope.bml.contingency) {
	                            $scope.bml.showModalBackdrop = true;
	                        }
	                    }
	                });
	
	                $scope.bmlSetPreferrence = function () {
	                    if ($scope.bml.preferenceCheck) {
	                        $scope.bml.action('preference', {
	                            data: {
	                                financial_instrument_id: $scope.bml.financial_instrument_id
	                            },
	
	                            success: function success() {
	                                $logger.info('COMPLETEBMLAPPLY_PREFERRED');
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['memberReview.bmlPreferredConfirmation']
	                                };
	                            }
	                        });
	                    } else {
	                        $scope.checkoutSession.message = {
	                            type: 'success',
	                            msgKeys: ['paymentMethod.paymentMethodUpdated']
	                        };
	                    }
	                    $scope.bml.showModal = false;
	                };
	
	                $scope.bmlClickContinue = function ($event) {
	                    $event.preventDefault();
	                    $scope.bml.showModalBackdrop = false;
	                    $scope.bml.showModal = false;
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-popup/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"xoBmlPopup\" content>\n    <!-- BML Decision -->\n    <div ng-if=\"bml.application_status !== undefined || bml.contingency\">\n        <div ng-show=\"bml.showModal\" id=\"bmlModal\" style=\"display:block;\" class=\"modal bmlModal\" aria-labelledby=\"modal-title\" role=\"alertdialog\" tabindex=\"-1\">\n\n            <div ng-show=\"bml.showModalBackdrop\" class=\"modal-backdrop\"></div>\n\n            <div class=\"modal-wrap\">\n\n                <div ng-switch=\"bml.application_status == 'APPROVED' || bml.application_status == 'PENDING_COMPLETION_STATUS'\">\n                    <div ng-switch-when=\"true\">\n                        <span class=\"bmlLogoVert\"></span>\n                        <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('memberReview.bmlSuccessHeader') }}</h2>\n\n                        <div ng-if=\"bml.nape == 'napePositive'\">\n                            <p>{{ content('memberReview.bmlNapeLinkSuccess')}}</p>\n                        </div>\n                        <div ng-if=\"bml.nape !== 'napePositive' && bml.credit_line.value == 0\">\n                            <p>{{ content('memberReview.bmlApprovalMessage') }}</p>\n                        </div>\n                        <div ng-if=\"bml.nape !== 'napePositive' && bml.credit_line.value > 0\">\n                            <p ng-bind-html=\"htmlContent('memberReview.bmlSuccessMessage', {creditLine: bml.credit_line.value})\"></p>\n                            <p>{{ content('memberReview.bmlSuccessMessageSend', {email: bml.user_info.email_address}) }}</p>\n                        </div>\n\n                        <form method=\"post\" name=\"confirm\" ng-submit=\"bmlSetPreferrence()\">\n                            <div class=\"checkbox\">\n                                <input type=\"checkbox\" ng-model=\"bml.preferenceCheck\" name=\"bmlPreferred\" id=\"bmlPreferredCheckbox\" class=\"chkbx\">\n                                <label for=\"bmlPreferredCheckbox\" class=\"chkbxLabel\">{{ content('memberReview.bmlSetPreferred')}}</label>\n                            </div>\n                            <input class=\"btn btn-submit full\" type=\"submit\" value=\"{{ content('memberReview.bmlContinue')}}\">\n                        </form>\n\n                    </div>\n                    <div ng-switch-default>\n                        <div ng-switch=\"bml.application_status\">\n                            <!-- bmlMaxAttempts -->\n                            <div ng-switch-when=\"SOFT_DECLINED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('memberReview.bmlSorry')}}</h2>\n                                <p>{{ content('bmlDeclined.hardDeclineMsg')}}</p>\n                            </div>\n                            <!-- bmlDeclineLinkedToDiffMember -->\n                            <div ng-switch-when=\"FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.bmlAcctLinkedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.bmlAcctLinkedMsg')}}</p>\n                            </div>\n                            <!-- creditDeclineHard -->\n                            <div ng-switch-when=\"DECLINED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.hardDeclineHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.hardDeclineMsg')}}</p>\n                            </div>\n                            <!-- ??? creditPaymentNotAllowed -->\n                            <div ng-switch-when=\"CREDIT_PAYMENT_NOT_ALLOWED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.creditNotAllowedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.creditNotAllowedMsg')}}</p>\n                            </div>\n                            <!-- ??? creditEligibilityDeclined -->\n                            <div ng-switch-when=\"CREDIT_ELIGIBILITY_DECLINE\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.creditEligibilityDeniedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.creditEligibilityDeniedMsg')}}</p>\n                            </div>\n                            <!-- ??? declineOtherCreditInstrumentExists -->\n                            <div ng-switch-when=\"FP_DECLINED_DUE_TO_CREDIT_IN_WALLET_RULE\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.declineOtherCreditInstrumentExistsHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.declineOtherCreditInstrumentExistsLine1')}}</p>\n                                <p>{{ content('bmlDeclined.declineOtherCreditInstrumentExistsLine2\" merchantName=\"{bmlResult.merchantFullName}')}}</p>\n                            </div>\n                            <!-- systemError, bmlGenericError, invalidError -->\n                            <div ng-switch-default> <!-- ng-switch-when=\"UNKNOWN_DECISION\" -->\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.systemErrorHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.systemErrorMsg')}}</p>\n                            </div>\n                        </div>\n\n                        <!--\n                         && bml.application_status == 'APPROVED' || bml.application_status == 'PENDING_COMPLETION_STATUS'\n                        -->\n                        <div ng-if=\"bml.application_status !== undefined || bml.contingency\" >\n                            <div ng-if=\"locale.countryCode === 'DE'\">\n                                <p class=\"cancelUrl\">\n                                    <a href=\"{{cancel}}\" role=\"button\" class=\"btn full\">{{ content('common.returnToCart') }}</a>\n                                </p>\n                            </div>\n                            <div ng-if=\"locale.countryCode !== 'DE'\">\n                                <input class=\"btn btn-submit full buttonGroup button-spacing\" type=\"button\" id=\"continueBml\" value=\"{{ content('common.payWithPayPal') }}\" ng-click=\"bmlClickContinue($event)\" />\n                                <a href=\"{{cancel}}\" role=\"button\" class=\"btn btn-secondary full buttonGroup\" id=\"cancelLink\">\n                                    {{ merchant ? content('common.bmlCancelButtonLabel', { merchantName: merchant }) : content('common.cancelAndReturnToMerchant') }}\n                                </a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <!-- BML Decision -->\n</section>\n"

/***/ },

/***/ "./components/xo-page-components/src/done/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/done/template.html"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-return-to-merchant/dist/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, ng, squid, template) {
	
	    return angular.module('xo-done.directive', ['squid', 'beaver', 'xo-error-tooltip.directive', 'xo-return-to-merchant']).directive('xoDone', function () {
	
	        return {
	            template: template,
	            controller: function controller($rootScope, $scope, $populate, $logger, $CheckoutAppDataModel, $CheckoutSessionModel, $MerchantPreferenceModel, $CheckoutPayeeModel, $CheckoutCartModel, $locale, $ReturnToMerchant, $DeviceInfo, $state, $window, $stateParams, $pxp) {
	
	                $scope.isGuestSignup = $rootScope.mode && $rootScope.mode === 'signup';
	                $scope.locale = $locale;
	
	                function addPageMessage(code) {
	                    var CONTENT_KEY_MAPPING = {
	                        NO_UPGRADE: 'accountUpgradeFailed'
	                    };
	                    if (code && CONTENT_KEY_MAPPING[code]) {
	                        $scope.errorMessage = {
	                            msgs: [$locale.content.get('done.' + CONTENT_KEY_MAPPING[code])],
	                            type: 'warning'
	                        };
	                    }
	                }
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    payee: $CheckoutPayeeModel.instance($scope.token)
	                }).then(function () {
	
	                    return $populate($scope, {
	                        merchantPreferenceModel: $MerchantPreferenceModel.instance($scope.payee.merchant.id)
	                    }).then(function () {
	                        // Show auto return page when feature is enabled by merchant and txn
	                        $scope.isAutoReturn = $scope.merchantPreferenceModel.autoReturn();
	                        // Set content key based on device
	                        $scope.autoReturnContentKey = $DeviceInfo.isMobile() || $DeviceInfo.isTablet() ? 'done.autoReturnStatement' : 'done.autoReturnStatementWeb';
	                        $scope.guestSignupKey = $scope.isGuestSignup ? 'done.paymentGuest' : 'done.payment';
	                        if ($stateParams.code) {
	                            addPageMessage($stateParams.code);
	                        }
	                        var amount = $scope.checkoutSession.transactionDetails.amount.total;
	                        var code = $scope.checkoutSession.transactionDetails.amount.currency;
	                        $scope.formattedAmount = squid.formatCurrency(amount, code);
	                        var itemList = $scope.checkoutSession.itemsList;
	
	                        itemList.forEach(function (item) {
	                            item.quantity = squid.formatQuantity(item.quantity);
	                        });
	                    });
	                }).then(function () {
	                    var isMobile = $DeviceInfo.isMobile() || $DeviceInfo.isTablet();
	                    var pxpContext = {
	                        'ctx.COUNTRY': $locale.country,
	                        'ctx.CHANNEL': isMobile ? 'MOBILE' : 'WEB',
	                        'ctx.LANGUAGE': $locale.lang + '_' + $locale.country
	                    };
	
	                    $logger.info('pxp_xo_wps_fb_messenger_plugin_1_treatment ', pxpContext);
	                    $pxp('xo_wps_fb_messenger_plugin', pxpContext, 'xo_wps_fb_messenger_plugin_1_treatment').then(function (result) {
	                        $logger.info('Messenger_done_page_PXP_RESULT', result);
	                        if (result && result.treatment_name === 'xo_wps_fb_messenger_plugin_1_treatment' && !$scope.isAutoReturn) {
	                            $scope.pxpMessengerIntegrationEnabled = true;
	                        } else {
	                            $scope.pxpMessengerIntegrationEnabled = false;
	                        }
	                    });
	
	                    $('#outerWrapper').addClass('xo-done');
	
	                    $scope.expansion = false;
	                    $scope.toggle = function () {
	                        if ($scope.expansion === false) {
	                            $scope.maxHeight = document.getElementsByClassName('details-expand')[0].scrollHeight + 'px';
	                            $scope.expansion = true;
	                        } else {
	                            $scope.expansion = false;
	                        }
	                        return $scope.expansion;
	                    };
	
	                    $scope.autoReturnStatementClick = function (event) {
	                        event.preventDefault();
	                        if (event.target && event.target.nodeName === 'A') {
	                            $scope.returnToMerchant();
	                        }
	                    };
	
	                    if ($scope.isAutoReturn) {
	                        $logger.info('autoreturn_to_merchant', {});
	                        $window.setTimeout($scope.returnToMerchant, 3000);
	                    }
	                });
	
	                $scope.$on('localeChange', function () {
	                    if ($stateParams.code) {
	                        addPageMessage($stateParams.code);
	                    }
	                });
	
	                $scope.returnToMerchant = function () {
	                    return $state.go('checkout.end');
	                };
	
	                $rootScope.$on('$stateChangeStart', function (event, newState, newParams, oldState) {
	                    if (oldState.name === 'checkout.done') {
	                        $('#outerWrapper').removeClass('xo-done');
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/done/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"xo-done-content\" content>\n    <div ng-click=\"toggle()\"class=\"splash-receipt\">\n        <div class=\"receipt basics\">\n            <div class=\"done\" id=\"circle\"></div>\n            <div id=\"paid-text\" bind-html-compile=\"htmlContent(guestSignupKey, {amt: formattedAmount})\"/>\n            <div id=\"merchant-text\">{{content('done.payment_target', {merchantName: checkoutAppData.merchant.brand_name})}}</div>\n            <div id=\"details-text\">{{content('paymentMethod.msbDetails')}}</div>\n        </div>\n        <div class=\"details-expand\" ng-class=\"{ expansion : expansion}\" ng-style=\"expansion && {'max-height': maxHeight}\">\n            <div class=\"grouping\" ng-repeat=\"item in checkoutSession.itemsList\">\n                <div class=\"row\">\n                    <span><span ng-if=\"item.quantity\">{{item.quantity}} x </span>{{item.name}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\" amount=\"item.price\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"item.sku\" class=\"item-number-container\">\n                    <span>\n                        <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ item.sku }}</span>\n                    </span>\n                </div>\n                <div ng-if=\"item.item_option_selections\" class=\"item-selections\">\n                    <span class=\"item-selection\" ng-repeat=\"selection in item.item_option_selections track by $index\">\n                        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n                        <span class=\"item-selection-value\">{{ selection.select }}</span>\n                    </span>\n                </div>\n            </div>\n            <div class=\"grouping\">\n                <div ng-if=\"checkoutSession.transactionDetails.amount.subtotal\" class=\"row\">\n                    <span>{{content('header.subTotal')}}</span>\n                     <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.subtotal\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.tax\" class=\"row\">\n                    <span>{{content('header.tax')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.tax\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.shipping\" class=\"row\">\n                    <span>{{content('header.shipping')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.shipping\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.handling_fee\" class=\"row\">\n                    <span>{{content('header.handling')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.handling_fee\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.discount\" class=\"row\">\n                    <span>{{content('header.discount')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.discount\">\n                        </format-currency>\n                    </span>\n                </div>\n            </div>\n            <div class=\"row totalAmount\">\n                <b>\n                    <span>{{content('base.totalLabel')}}</span>\n                <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.total\">\n                        </format-currency>\n                    </span>\n                </b>\n            </div>\n        </div>\n        <div id=\"details-button\">\n            <span ng-hide=\"!expansion\" class=\"arrow collapse\"></span>\n            <span ng-hide=\"expansion\" class=\"arrow expand\"></span>\n        </div>\n    </div>\n    <div class=\"essentials\" ng-show=\"checkoutSession.transactionDetails.reason_code === 'REGULATORY_REVIEW'\">\n        <div class=\"alert\" role=\"alert\">\n            {{content('done.temporarily_pending')}}\n        </div>\n    </div>\n    <div class=\"essentials\" ng-if=\"!isAutoReturn\">\n        <xo-message message=\"errorMessage\"></xo-message>\n\n       <div id=\"messenger-ba-integration\" ng-if=\"pxpMessengerIntegrationEnabled\">\n\t\t\t<div id=\"messenger-ba-integration-content\" style=\"display:none\">\n\t\t\t\t<div class=\"text\">Be sure to check Messenger for your receipts whenever you shop using PayPal</div>\n\t\t\t</div>\n            <div id=\"ba-integration-content\" style=\"display:none\">\n\t\t\t\t<div class=\"receipt title\">You're all set to shop on Facebook</div>\n\t\t\t\t<div class=\"text\">When you're ready to shop, just choose PayPal at checkout!</div>\n\t\t\t</div>\n            <div id=\"stm-upsell-content\" class=\"text\">Get your PayPal receipts in Messenger</div>\n\t\t\t<xo-messenger-plugin plugin-type=\"STM\" token=\"token\"></xo-messenger-plugin>\n\t\t</div>\n\n        <div ng-if=\"checkoutSession.plan.sources.length > 0\" class=\"receipt title\">{{content('done.paidWith')}}</div>\n        <div ng-repeat=\"item in checkoutSession.plan.sources\">\n            <div class=\"row clearfix\">\n                <span class=\"money-source\">{{content('fsMappings.'+item.type) || item.name}} <span ng-if=\"item.last4\">x-</span>{{item.last4}}</span>\n                <span class='amount'>\n                        <format-currency code=\"item.amount.currency_code\"\n                                         amount=\"item.amount.amount\">\n                        </format-currency>\n                </span>\n            </div>\n        </div>\n        <div ng-if=\"checkoutSession.transactionDetails.soft_descriptor\" class=\"secondary receipt statement\">{{content('done.transactionInformation', {merchantName: checkoutSession.transactionDetails.soft_descriptor})}}\n        </div>\n        <div ng-if=\"checkoutSession.shipping\" class=\"receipt title\">{{content('done.shippedTo')}}</div>\n        <div class=\"text\" ng-if=\"!checkoutCart.isShippingMethodStorePickUp()\">\n            <div ng-if=\"checkoutSession.shipping.name\">{{checkoutSession.shipping.name}}</div>\n            <div><span directionality-text=\"checkoutSession.shipping.full_address\">{{checkoutSession.shipping.full_address}}</span></div>\n            <div><span>{{content('countryList.'+checkoutSession.shipping.country)}}</span></div>\n        </div>\n        <div class=\"text\" ng-if=\"checkoutCart.isShippingMethodStorePickUp()\">\n            <div class=\"storeLocation\" >{{ content('shippingMethod.storeLocation') }}</div>\n            <p class=\"storeLocationInfo\">{{ content('shippingMethod.storeLocationInfo') }}</p>\n        </div>\n        <div class=\"receipt title\">{{content('done.purchaseDetails')}}</div>\n        <div id=\"receiptNumber\"> {{content('done.receiptNumber')}} {{checkoutSession.transactionDetails.receipt_id}}</div>\n        <div class=\"text\">\n            <div>{{content('done.confirmation')}}</div>\n            <div id=\"buyerEmail\">{{checkoutSession.payer.email}}</div>\n        </div>\n        <div text-align=\"left\" class=\"receipt title\">{{content('done.merchantDetails')}}</div>\n        <div class=\"text\" id=\"merchantInfoSection\">\n            <div><span directionality-text=\"checkoutAppData.merchant.brand_name\">{{checkoutAppData.merchant.brand_name}}</span></div>\n            <div ng-if=\"checkoutAppData.merchant.phone\">{{checkoutAppData.merchant.phone}}</div>\n            <div id=\"merchantEmail\" ng-if=\"checkoutAppData.merchant.merchant_email\">{{checkoutAppData.merchant.merchant_email}}</div>\n        </div>\n        <div ng-if=\"checkoutAppData.urls.return_url\" id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{content('common.returnToDefaultMerchant')}}\" id=\"merchantReturnBtn\"\n                   class=\"btn btn-secondary full submit receipt ng-binding ng-scope\" ng-click=\"returnToMerchant()\" />\n        </div>\n    </div>\n    <div class=\"essentials autoReturnSection\" ng-if=\"isAutoReturn\">\n        <div>{{content('done.paymentCompleted')}}</div>\n        <div ng-click=\"autoReturnStatementClick($event)\" bind-html-compile=\"htmlContent(autoReturnContentKey, {merchantName: checkoutAppData.merchant.brand_name, autoReturnUrl: checkoutAppData.urls.return_url})\"/>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/3ds/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/3ds/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, template) {
	    return angular.module('xo-3ds.directive', ['squid']).directive('xo3ds', function () {
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                data: '=',
	                onComplete3dsHandler: '='
	            },
	            controller: function controller($scope, $rootScope, $timeout, $window, $Resolve3DS, $CheckoutAppDataModel, $config, $locale, $logger) {
	
	                var resolve3DS = $Resolve3DS.instance($scope.token);
	
	                $scope.termUrl = window.location.origin + $config.urls.baseUrl + '/process3DS';
	
	                $scope.data = $scope.data || {};
	
	                function handleInitFailure(message) {
	                    // Since init3DS call failed. We disable the feature and proceed to checkout.
	                    $CheckoutAppDataModel.instance($rootScope.token).action('updatePaymentExperience', {
	                        data: {
	                            payment_experience: 'HERMESNODE',
	                            '3d_secure_authentication_supported': false
	                        },
	                        silent: true,
	                        transientError: true
	                    }).then(function () {
	
	                        $logger.info('checkout_fpti', {
	                            from: '3DS_CHALLENGE',
	                            to: 'process_3ds_challenge',
	                            'int_error_description': message,
	                            'error_type': 'soft_decline',
	                            'error_source': 'fiLifecycle'
	                        });
	
	                        $scope.onComplete3dsHandler('success');
	                    });
	                }
	
	                function init3DSApi() {
	                    $rootScope.$emit('loadingMessage', $locale.content.get('threeDS.processing'));
	
	                    return resolve3DS.action('init3DS', {
	                        data: {
	                            cc_id: $scope.data.cc_id,
	                            flow_id: $scope.data.flow_id,
	                            merchant_id: $scope.data.merchant_id,
	                            merchant_country: $scope.data.merchant_country_code,
	                            currency: $scope.data.transaction_amount_currency,
	                            transaction_amount: $scope.data.transaction_amount_value
	                        },
	                        success: function success(response) {
	                            if (response.status === 'SUCCESS' && response.acsUrl) {
	
	                                $logger.info('checkout_fpti', { from: '3DS_CHALLENGE', to: 'prepare_3ds_challenge' });
	
	                                $scope.acsUrl = response.acsUrl;
	                                $scope.acsMethod = response.acsMethod || 'POST';
	                                $scope.acsPaReq = response.acsPaReq;
	
	                                var lightbox;
	                                var form = $('<form/>', {
	                                    action: $scope.acsUrl,
	                                    method: $scope.acsMethod,
	                                    id: 'iFrameForm',
	                                    target: 'threeDSFrame'
	                                });
	                                form.append($('<input/>', {
	                                    type: 'hidden',
	                                    name: 'TermUrl',
	                                    value: $scope.termUrl
	                                }));
	
	                                form.append($('<input/>', {
	                                    type: 'hidden',
	                                    name: 'PaReq',
	                                    value: $scope.acsPaReq
	                                }));
	                                $('#lightBoxAcsWrapper').append(form);
	                                $('#iFrameForm').submit();
	
	                                // put lightbox to display with transition
	                                lightbox = angular.element(document.getElementById('light-box'));
	                                lightbox.addClass('open');
	                            } else {
	                                $logger.info('checkout_fpti', {
	                                    from: '3DS_CHALLENGE',
	                                    to: 'process_3ds_challenge',
	                                    'int_error_description': 'acsUrl_not_presented_on_init',
	                                    'error_type': 'soft_decline',
	                                    'error_source': 'fiLifecycle'
	                                });
	
	                                // When there is no 3DS challenge page to be shown, we return success to the caller
	                                $scope.onComplete3dsHandler('success');
	                            }
	                        },
	                        error: function error() {
	                            handleInitFailure('unknown_error_on_init3DS');
	                        },
	                        validation: function validation() {
	                            handleInitFailure('validation_error_on_init3DS');
	                        },
	                        contingencies: {
	                            DEFAULT: function DEFAULT() {
	                                handleInitFailure('contingency_presented_on_init3DS');
	                            }
	                        }
	                    });
	                }
	
	                function complete3DSApi(paRes) {
	                    return resolve3DS.action('complete3DS', {
	                        data: {
	                            third_party_response: paRes,
	                            cc_id: $scope.data.cc_id,
	                            flow_id: $scope.data.flow_id
	                        },
	                        success: function success(response) {
	
	                            var status;
	
	                            if (response.status === 'SUCCESS') {
	                                status = 'success';
	
	                                $logger.info('checkout_fpti', {
	                                    from: '3DS_CHALLENGE',
	                                    to: 'process_3ds_challenge'
	                                });
	                            } else {
	                                status = 'decline';
	
	                                $logger.info('checkout_fpti', {
	                                    from: '3DS_CHALLENGE',
	                                    to: 'process_3ds_challenge',
	                                    'int_error_description': 'complete3DS_decline',
	                                    'error_type': 'soft_decline',
	                                    'error_source': 'fiLifecycle'
	
	                                });
	                            }
	
	                            $scope.onComplete3dsHandler(status);
	                        }
	                    });
	                }
	
	                $scope.close3DSFrame = function () {
	                    $logger.info('checkout_fpti', { from: '3DS_CHALLENGE', to: 'process_user_close' });
	
	                    var lightbox = angular.element(document.getElementById('light-box'));
	                    lightbox.removeClass('open');
	
	                    $timeout(function () {
	                        var lightboxMask = angular.element(document.getElementById('mask'));
	                        lightboxMask.remove();
	                        $scope.onComplete3dsHandler('close');
	                    }, 200);
	                };
	
	                init3DSApi();
	
	                $scope.complete3DS = function (paRes) {
	                    complete3DSApi(paRes);
	                };
	
	                $window.complete3DSFrame = function (paRes) {
	                    $scope.complete3DS(paRes);
	                };
	
	                // when the esc key is pressed
	                $('html').on('keyup', function (ev) {
	                    if (ev.which === 27) {
	                        $scope.close3DSFrame();
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/3ds/template.html":
/***/ function(module, exports) {

	module.exports = "<div content id=\"light-box-3ds\" class=\"light-box-3ds\">\n    <div content id=\"light-box\" class=\"light-box\" ng-class=\"{mobile: isDevice}\">\n        <div id=\"mask\" class=\"light-box mask\"></div>\n        <div class=\"light-box wrapper\">\n\n            <div class=\"light-box-container\">\n                <div class=\"aside\" id=\"lightBoxAcsWrapper\">\n                    <a class=\"close\" ng-click=\"close3DSFrame()\" href=\"#\">&nbsp;</a>\n                    <p class=\"light-box-header\">\n                        {{ content('threeDS.iFrameTitle') }}\n                    </p>\n                    <iframe name=\"threeDSFrame\" src=\"\" class=\"light-box-iframe\"></iframe>\n                </div>\n\n                <div class=\"logo\"></div>\n            </div>\n\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-models/src/profilemanagement/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.profilemanagement', ['squid']).factory('$MerchantPreferenceModel', function ($Model, $Api, $config, $util) {
	
	        return $Model.extend('MerchantPreferenceModel', {
	
	            init: function init() {
	
	                this._super.init.apply(this);
	
	                this.setProperties({
	                    rm: $util.param('rm'), // Return Method
	                    return_url: $util.param('return'),
	                    auto_return: {
	                        enabled: false
	                    },
	                    pdt: {
	                        enabled: false
	                    }
	                });
	            },
	
	            api: new $Api({
	                baseURI: $config.urls.baseUrl,
	                uri: '/api/profilemanagement/:id/getMerchantPreferences'
	            }),
	
	            autoReturn: function autoReturn() {
	                return this.auto_return.enabled;
	            },
	
	            pdtEnabled: function pdtEnabled() {
	                return this.pdt && this.pdt.enabled;
	            },
	
	            returnUrl: function returnUrl() {
	                return this.return_url || this.auto_return.url;
	            },
	
	            /**
	             * 0 – redirect using GET method ( default behavior )
	             * 1 – redirect using the GET method, but no payment variables are included
	             * 2 – redirect using the POST method, and include all payment variables
	             */
	            returnMethod: function returnMethod() {
	                var rm = this.rm;
	
	                if (rm === '2') {
	                    return this.pdtEnabled() ? 'GET' : 'POST';
	                } else {
	                    return 'GET';
	                }
	            },
	
	            returnMethodSupported: function returnMethodSupported() {
	                return this.returnMethod() === 'GET';
	            },
	
	            /**
	             * Determines if payment details need to be sent back to the merchant.
	             * @returns {boolean}
	             */
	            postPaymentData: function postPaymentData() {
	                return this.rm === '2' && !this.pdtEnabled() && this.returnUrl();
	            },
	
	            // charset of merchant having in profile
	            charSet: function charSet() {
	                return this.charset;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/profilemanagement", "components/xo-models/src/profilemanagement/index.js"))

/***/ },

/***/ "./components/xo-models/src/shoppingcart/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.shoppingcart', ['squid']).factory('$ShoppingCartModel', function ($Model, $Api) {
	        return $Model.extend('$ShoppingCartModel', {
	            api: new $Api({
	                uri: '/api/shoppingcart/:id',
	                postAttempts: 2,
	                cache: true
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/shoppingcart", "components/xo-models/src/shoppingcart/index.js"))

/***/ },

/***/ "./components/xo-page-components/src/marketingOffers/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/marketingOffers/template.html"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-models/src/marketingoffer/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	
	    return angular.module('xo-page-components.marketingOffers', ['squid', 'xo-title.directive', 'xomodel.marketingoffer', 'xomodel.checkout', 'xomodel.auth']).directive('xoMarketingOffers', function () {
	        return {
	            template: template,
	
	            scope: {
	                placementCode: '=',
	                titleTxtProperty: '=',
	                subtitleProperty: '=',
	                token: '=',
	                pageName: '=',
	                backgroundImage: '='
	            },
	
	            controller: function controller($scope, $sce, $rootScope, $populate, $state, $locale, $renderContent, $logger, $pxp, $config, $CheckoutCartModel, $MarketingOfferModel, $fireMORSBeacon, $element, $feature, $CheckoutSessionModel, $CheckoutPayeeModel, $AuthModel) {
	                var morsOfferFlag = $scope.placementCode === '202003' && $feature('morsValuePropOffers');
	                var populateObj;
	                if (morsOfferFlag) {
	                    populateObj = {
	                        checkoutCart: $CheckoutCartModel.instance($scope.token),
	                        checkoutSession: $CheckoutSessionModel.instance($scope.token),
	                        payee: $CheckoutPayeeModel.instance($scope.token),
	                        auth: $AuthModel.instance($scope.token)
	                    };
	                } else {
	                    populateObj = {
	                        checkoutCart: $CheckoutCartModel.instance($scope.token)
	                    };
	                }
	                $populate($scope, populateObj).then(function () {
	                    $scope.locale = $locale;
	                    $scope.token = $rootScope.token;
	                    function setDefaultValues() {
	                        $scope.ad = {
	                            Title: $renderContent($scope.titleTxtProperty),
	                            Body: $renderContent($scope.subtitleProperty),
	                            backgroundImage: $scope.backgroundImage
	                        };
	                    }
	
	                    $scope.$watch('ad.backgroundImage', function (imageUrl) {
	                        if (imageUrl) {
	                            var url = imageUrl;
	                            var propImg = angular.element($element[0].querySelector('div.prop-img'));
	                            var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;
	
	                            if (isRetina && url) {
	                                var index = url.lastIndexOf('.'); // index at which file extension start
	                                url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
	                                propImg.css({
	                                    'background-image': 'url(' + url + ')',
	                                    'height': '150px',
	                                    'margin-top': '0px'
	                                });
	                            } else {
	                                propImg.css({
	                                    'background-image': 'url(' + url + ')',
	                                    'height': '150px',
	                                    'margin-top': '0px'
	                                });
	                            }
	                        }
	                    });
	
	                    if ($scope.placementCode === '202002') {
	                        $scope.pu_type = 'ANONYMOUS';
	                        $scope.presentation_types = ['CompositeText'];
	                        $scope.pxpInfo = {
	                            name: 'xo_xoon_hermes_mors',
	                            pattern: '(xo_xoon_hermes_mors_)(.*)',
	                            treatment: 'xo_xoon_hermes_mors_treatment'
	                        };
	                    } else if ($scope.placementCode === '202003') {
	                        $scope.className = 'props';
	                        $scope.pu_type = 'PERSONAL';
	                        $scope.presentation_types = ['GenericComposite'];
	                        $scope.pxpInfo = {
	                            name: 'xo_mors_hermes_placements_ryi',
	                            pattern: '(xo_mors_hermes_placements_ryi_)(.*)',
	                            treatment: 'xo_mors_hermes_placements_ryi_treatment'
	                        };
	                    } else {
	                        setDefaultValues();
	                    }
	
	                    //  serve ads only if pxp is true, country is US and lang is en
	                    if ($locale.country === 'US' && $locale.lang === 'en' && $scope.placementCode && $feature('morsValuePropOffers')) {
	                        $scope.marketingOfferData = new $MarketingOfferModel({
	                            countryCode: $scope.locale.country,
	                            page: $scope.pageName,
	                            puType: $scope.pu_type,
	                            locale: $locale.lang + '_' + $locale.country,
	                            totalTransactionAmount: {
	                                'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
	                                'value': $scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100
	                            },
	                            totalShippingAmount: {
	                                'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
	                                'value': $scope.checkoutCart.get('purchase.amounts.shipping.amount', 0) * 100
	                            },
	                            payee: morsOfferFlag ? $scope.payee.merchant.id : '',
	                            payer: morsOfferFlag ? $scope.checkoutSession.payer.id : '',
	                            si: morsOfferFlag ? $scope.checkoutSession.id : '',
	                            visitor_id: morsOfferFlag ? $scope.auth.visitor_id : '',
	                            targetPlacements: [{
	                                'placement_code': $scope.placementCode,
	                                'presentation_types': $scope.presentation_types
	                            }]
	                        });
	                        $pxp($scope.pxpInfo.name, { 'ctx.COUNTRY': $locale.country }, $scope.pxpInfo.pattern).then(function (res) {
	
	                            $logger.info('MO treatment: ' + (res ? res.treatment_name : '[no pxp response!]'));
	                            if (res && res.treatment_name === $scope.pxpInfo.treatment) {
	
	                                return $MarketingOfferModel.instance($scope.token).save({
	
	                                    silent: true,
	                                    data: $scope.marketingOfferData.serialize(),
	                                    success: function success(result) {
	                                        var ads_arr = result && result.ads || [];
	                                        var adFound = false;
	
	                                        // MORS could serve multiple ads for a given page. Iterate to get the
	                                        // correct one based on the ad placement_id
	                                        ads_arr.forEach(function (ad) {
	                                            var adunit_id = ad.campaign.adunit_id;
	
	                                            if (adunit_id.toString() === $scope.placementCode.toString() && ad.valid) {
	                                                adFound = true;
	                                                $scope.ad = {};
	                                                var content = ad.content.nvp;
	                                                content.forEach(function (obj) {
	                                                    $scope.ad[obj.name] = obj.value;
	                                                });
	                                                $scope.ad['impressionUrl'] = ad.tracking.impression_url;
	                                                $scope.ad['clickUrl'] = ad.tracking.click_url;
	                                            }
	                                        });
	
	                                        if (adFound) {
	                                            $scope.ad.Body = $sce.trustAsHtml($scope.ad.Body);
	                                            $scope.ad.Title = $scope.ad.header;
	
	                                            // notify MORS of successful rendering by firing the impressionurl
	                                            // beacon and by setting the click url to be fired for future
	                                            // conversion.
	                                            // setting the placement_id helps to differentiate between multiple ads
	                                            // displayed on the same page
	
	                                            $logger.info('MORS_ad_displayed');
	                                            $fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);
	
	                                            $rootScope.$broadcast('MORSDisplayed', {
	                                                clickUrl: $scope.ad.clickUrl,
	                                                placementId: $scope.placementCode
	                                            });
	                                        } else {
	                                            $logger.info('MORS_ad_not_found');
	                                            setDefaultValues();
	                                            $rootScope.$broadcast('MORSNotDisplayed');
	                                        }
	                                    },
	
	                                    error: function error(err) {
	                                        setDefaultValues();
	                                        $logger.error('MORS_api_failure', { error: err });
	                                    }
	                                });
	                            } else {
	                                setDefaultValues();
	                                $rootScope.$broadcast('MORSNotDisplayed');
	                            }
	                        });
	                    } else {
	                        setDefaultValues();
	                        $rootScope.$broadcast('MORSNotDisplayed');
	                    }
	                    $scope.$on('localeChange', function () {
	                        setDefaultValues();
	                    });
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/marketingOffers/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"marketingOffers {{className}}\" content >\n    <div ng-if=\"ad.backgroundImage\" class=\"prop-img\"></div>\n    <xo-title title-txt=\"{{ ad.Title }}\"></xo-title>\n    <p class=\"subTitle\" ng-bind-html=\"ad.Body\"></p>\n</div>\n"

/***/ },

/***/ "./components/xo-models/src/marketingoffer/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/node-uuid/uuid.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, uuid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.marketingoffer', ['squid']).factory('$MarketingOfferModel', function ($Model, $Api) {
	        return $Model.extend('$MarketingOfferModel', {
	            api: new $Api({
	                uri: '/api/checkout/offer/search-ads',
	                postAttempts: 1
	
	            }),
	
	            serialize: function serialize() {
	                var data = {
	                    'locale': this.locale,
	                    'si': this.si,
	                    'visit_id': uuid.v4(),
	                    'page': this.page,
	                    'epu': this.payer,
	                    'pu_type': this.puType || 'ANONYMOUS',
	                    'country_code': this.countryCode,
	                    'payment_context': {
	                        'total_transaction_amount': this.totalTransactionAmount,
	                        'total_shipping_amount': this.totalShippingAmount,
	                        'business_case': 'NONE',
	                        'business_case_variation': '',
	                        'validate_existing_offer': 'false',
	                        'payment_units': [{
	                            'transaction_amount': this.totalTransactionAmount,
	                            'transaction_id': '',
	                            'encrypted_transaction_id': '',
	                            'activity_id': '',
	                            'payee': {
	                                'pu_type': 'BUSINESS',
	                                'country_code': this.countryCode,
	                                'epu': this.payee,
	                                'pu': ''
	                            }
	                        }]
	                    },
	                    'target_placements': this.targetPlacements
	                };
	
	                return data;
	            }
	        });
	    }).service('$fireMORSBeacon', function ($q) {
	        this.fireBeacon = function (uri) {
	            var img = document.createElement('img');
	
	            img.setAttribute('src', uri);
	            document.body.appendChild(img);
	
	            return;
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/marketingoffer", "components/xo-models/src/marketingoffer/index.js"))

/***/ },

/***/ "./components/xo-member-components/src/review-topup/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _fi = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	__webpack_require__("./components/xo-member-components/src/review-topup/styles.less");
	
	var _template = __webpack_require__("./components/xo-member-components/src/review-topup/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('xoReviewTopup', {
	    tag: 'xo-review-topup',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
	                walletPreferences: _fi.$WalletPreferences.instance(this.props.token)
	            };
	        }
	    },
	
	    actions: {
	        gotoTopupFunding: function gotoTopupFunding() {
	            _uiRouter.$state.go('checkout.review.sidepage.topupFunding');
	        },
	        gotoTopupAmount: function gotoTopupAmount() {
	            _uiRouter.$state.go('checkout.review.sidepage.topupAmount');
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.formatCurrency = _squid.formatCurrency;
	            this.instrumentIconId = function (name) {
	                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
	            };
	        },
	        populate: function populate() {
	            this.models.walletPreferences.topup.fundingSource = this.models.checkoutSession.selectedTopupFundingSource;
	            if (!this.models.walletPreferences.topup.fundingSource) {
	                this.models.walletPreferences.topup.fundingSource = this.models.checkoutSession.topupFundingSources && this.models.checkoutSession.topupFundingSources[0];
	            }
	
	            if (!this.models.walletPreferences.topup.amount) {
	                this.models.walletPreferences.topup.amount = this.models.walletPreferences.topup.amount || _squid.$config.topup.topupAmounts[0];
	                this.models.walletPreferences.topup.currency = _squid.$config.topup.currency;
	            }
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$config;
	
	_squid.formatCurrency;
	
	_uiRouter.$state;
	
	_checkout.$CheckoutSessionModel;
	
	_fi.$WalletPreferences;
	
	_fi.$WalletInstrumentNameMapping;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-member-components/src/review-topup/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-member-components/src/review-topup/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-member-components/src/review-topup/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#reviewTopup .listItem{cursor:pointer;margin-bottom:35px;position:relative}#reviewTopup .listItem .label{font-weight:500}#reviewTopup .listItem .listItemValue{float:right;padding-right:20px;display:inline-flex;max-width:55%}#reviewTopup .listItem .listItemValue .fsname{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-left:35px}#reviewTopup .listItem .listItemValue .fsLast4{vertical-align:top;white-space:nowrap}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-member-components/src/review-topup/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"reviewTopup\" content>\n    <div class=\"listItem\" ng-if=\"models.walletPreferences.topup.amount\" ng-click=\"actions.gotoTopupAmount()\">\n        <span class=\"label\">{{content('review.topupAmountLabel')}}</span>\n        <format-currency class=\"listItemValue\" code=\"models.walletPreferences.topup.currency\"\n                         amount=\"models.walletPreferences.topup.amount\"\n                         currency-style=\"Currency\"></format-currency>\n        <a ui-sref=\"checkout.review.sidepage.topupAmount\" class=\"edits changePayment\" select-button focus-when-state=\"checkout.review.sidepage.topupAmount\" transitions-to=\"checkout.review\">\n            <span class=\"frontArrow goTray\"></span>\n        </a>\n    </div>\n    <div class=\"listItem\" ng-click=\"actions.gotoTopupFunding()\">\n        <span class=\"label\">{{content('review.topupFundingLabel')}}</span>\n        <div class=\"listItemValue\">\n            <span class=\"walletIcons\" ng-class=\"[models.walletPreferences.topup.fundingSource.type,\n                                                instrumentIconId(models.walletPreferences.topup.fundingSource.name),\n                                                models.walletPreferences.topup.fundingSource.card_type]\"></span>\n            <span class=\"fsname\">{{models.walletPreferences.topup.fundingSource.name}}</span>\n            <span class=\"fsLast4\">&nbsp;x-{{models.walletPreferences.topup.fundingSource.last4}}</span>\n            <a ui-sref=\"checkout.review.sidepage.topupFunding\" class=\"edits changePayment\" select-button focus-when-state=\"checkout.review.sidepage.topupFunding\" transitions-to=\"checkout.review\">\n                <span class=\"frontArrow goTray\"></span>\n            </a>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-review/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"review\" content ng-click=\"onPageClick($event)\" id=\"memberReview\" tabindex=-1 role=\"presentation\">\n    <xo-title title-txt=\"{{content('memberReview.memberReviewTitle')}}\" class=\"accessAid\"></xo-title>\n    <div ng-if=\"!checkoutCart.isWalletTokenization()\" class=\"row-fluid justMember\" ng-class=\"{ bmlPopupOpen: bmlPopupOpen }\">\n        <div class=\"span14 trayInner reviewSections\" ng-show=\"!bmlPopupOpen\">\n\n            <xo-banner ng-if=\"personalizedBanner.show && !isMessengerBAIntegration\" banner-image=\"personalizedBanner.imageUrl\">\n                <p class=\"userEmail\" id=\"reviewUserInfo\">\n                    {{ content('memberReview.loggedInWithOneTouch', {userName: formattedNameInformal}) }}\n                    <span ng-if=\"showNotYou\">\n                        <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                    </span>\n                </p>\n            </xo-banner>\n            <xo-message message=\"checkoutSession.message\"></xo-message>\n\n            <div ng-if=\"!personalizedBanner.show && !isMessengerBAIntegration\">\n                <p class=\"userEmail\" id=\"reviewUserInfo\">\n                    {{ content('memberReview.welcomeBack', {userName: formattedNameInformal}) }}\n                    <span ng-if=\"showNotYou\">\n                        <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                    </span>\n                </p>\n            </div>\n\n            <form name=\"confirm\" class=\"proceed\" novalidate=\"novalidate\" id=\"ryiForm\">\n                <!-- {@if cond=\"'{data.updated}' === 'bmlSuccess'\" } -->\n\n                <div class=\"reviews\" ng-if=\"merchantMsg\">\n                    <h4 ng-if=\"!isMessengerBAIntegration\" class=\"noBottom gamma\" id=\"merchantMsgHeader\">\n                        {{ content('memberReview.merchantMsgHeader')}}\n                    </h4>\n                    <!--content-->\n                    <h1 ng-if=\"isMessengerBAIntegration\" class=\"messengerBAHeader\" id=\"merchantMsgHeader\">\n                        PayPal is on Messenger!\n                    </h1>\n                    <div class=\"merchantMsg\" id=\"merchantMsg\">\n                        <span class=\"given-name\">\n                            {{ merchantMsg }}\n                        </span>\n                    </div>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"showInstallmentOption()\">\n                    <div id=\"installmentPlanInfo\">\n                        <h4 class=\"noBottom gamma\" id=\"installmentInfoHeader\">\n                            {{content('chooseCreditOption.reviewPaymentPlan')}}\n                        </h4>\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"creditOptions.creditType === 'INST'\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText1',{term:creditOptions.term, monthlyPayment: creditOptions.monthlyPayment, currencyCode: cartCurrency})\"> </p>\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText2',{apr:creditOptions.apr, interest: creditOptions.totalInterest, totalPayment: creditOptions.totalPayment, currencyCode: cartCurrency})\"> </p>\n                        </div>\n\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"creditOptions.creditType === 'SAC' || creditOptions.creditType === 'NI'\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('fundingInstruments.bmlDetails')\"> </p>\n                        </div>\n                        <a class=\"edits creditEdit\" ng-click=\"showCYCO()\">\n                            {{ content('common.change') }}\n                            <span class=\"frontArrow goTray ng-scope\"></span>\n                        </a>\n                    </div>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"showShippingAddress\">\n                    <xo-review-address token=\"token\" make-addr-preferred=\"makeAddrPreferred\" store-pick-up-selected=\"checkoutCart.isShippingMethodStorePickUp()\"></xo-review-address>\n                </div>\n\n                <xo-select-shipping-method ng-if=\"showShippingMethod\" token=\"token\" show-shipping-address=\"showShippingAddress\"></xo-select-shipping-method>\n\n                <div class=\"reviews\">\n                    <xo-review-paywith token=\"token\" pay-button-text=\"payButtonText()\" show-auth-msg=\"showAuthMsg\" installment-not-selected=\"installmentNotSelected\" show-bml-popup=\"showBmlPopup\" installment=\"installment\"></xo-review-paywith>\n                </div>\n\n                <div class=\"offers\">\n                    <xo-offer token=\"token\" promotion=\"promotion\" bmlaction=\"bmlaction\" installment=\"installment\"></xo-offer>\n                </div>\n\n                <!--inc/bmlLearnMore-->\n                <div>\n                    <div class=\"buttons bmlSeeTermsBtn hide\">\n                        <button class=\"btn full hide\" name=\"authUserBtn\">{{content('authUserLearnMore.ok')}}</button>\n                    </div>\n                </div>\n\n                <!--Action button -->\n                <p class=\"paypalPoliciesLink disclaimer\" data-ng-bind-html=\"content('memberReview.viewPaypalPolicies')\" ng-if=\"showPaypalPolicies\">\n                </p>\n\n                <p class=\"unconfirmedUpopMsg\" ng-if=\"showUnconfirmedUpopMsg\">\n                    {{ content('confirmUpop.confirmUpopToPay')}}\n                </p>\n\n                <div ng-if=\"checkoutSession.isAuthRequired\">\n                    <input type=\"hidden\" name=\"email\" ng-value=\"auth.email\" />\n                    <div class=\"inputField password confidential\">\n                        <!-- take care of error class-->\n                        <label for=\"oneclickpassword\">{{ content('memberReview.enterPassword')}}</label>\n                        <input id=\"oneclickpassword\" name=\"password\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\" aria-required=\"true\" ng-maxlength=\"22\" />\n                    </div>\n                </div>\n\n                <p ng-if=\"showPolicyAgreement\" class=\"disclaimer\" id=\"policyAgreement\" data-ng-bind-html=\"content('memberReview.policyAgreement', {country: locale.country, lang: locale.lang})\">\n                </p>\n\n                <div id=\"fixedButton\" class=\"frame\" ng-if=\"showFixedButton()\">\n                    <hr class=\"frameborder\">\n                    <div class=\"buttons fixed\">\n                        <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\" class=\"btn full confirmButton continueButton\" validate-submit=\"onPay()\" />\n                    </div>\n                </div>\n\n                <div id=\"messengerPlugin\" class=\"messengerBAPlugin\" ng-if=\"isMessengerBAIntegration\">\n                    <!--content-->\n                    <h4 class=\"noBottom paymentsHeader zeta\"> Get PayPal receipts in Messenger</h4>\n                    <div>\n                        <xo-messenger-plugin token=\"token\" plugin-type=\"CHECKBOX\"></xo-messenger-plugin>\n                        <p class=\"messengerLegalTxt\">Any information sent or received on Messenger can be used according to Facebook’s Data Policy</p>\n                    </div>\n                </div>\n\n                <div id=\"button\" class=\"buttons reviewButton\">\n                    <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\" class=\"btn full confirmButton continueButton\" validate-submit=\"onPay()\" />\n                </div>\n\n                <!--content-->\n                <div class=\"messengerBANotnow\">\n                    <a href=\"\" ng-if=\"isMessengerBAIntegration\" ng-click=\"onFBBANotNow()\">Not Now</a>\n                </div>\n\n\n                <!-- checkoutSession.isRT need to review this -->\n                <p class=\"reviewLaterContainer disclaimer\" ng-if=\"showReviewLater\">\n                    {{ content('common.reviewLater')}}\n                </p>\n\n                <div id=\"disclaimerWithBmlCta\" class=\"disclaimer reviewMsg\" ng-if=\"showSoftDescriptor && checkoutSession.plan.soft_descriptor\"\n                     ng-bind-html=\"content('memberReview.disclaimer', {merchantName: checkoutSession.plan.soft_descriptor})\"></div>\n\n                <div class=\"disclaimer reviewMsg\" ng-if=\"checkoutSession.displayBankChargeDisclaimer\">{{ content('memberReview.bankChargeDisclaimer')}}</div>\n\n                <div class=\"billingAddressConsent reviewMsg\" ng-if=\"checkoutAppData.flags.billing_address_consent_required\">\n                    <p class=\"disclaimer\">{{ content('memberReview.billingRequired') }}\n                        <p>\n                </div>\n\n                <div class=\"disclaimer reviewMsg\" ng-if=\"checkoutSession.plan.isAuthSignupEnabled || showAuthMsg\">\n                    {{ content('memberReview.authUser') }} <a ui-sref=\"checkout.authorizationmessage\" class=\"authUserLink\" aria-describedby=\"authMsgHelp\">{{ content('memberReview.learnMore') }}</a>\n                    <span id=\"authMsgHelp\" class=\"accessAid\">{{content('authUserLearnMore.authUserTitle')}}</span>\n                </div>\n\n                <div id=\"creditExampleUK\" ng-if=\"showRepresentativeInfo()\">\n                    <p class=\"disclaimer reviewMsg bmlLender\">{{content('chooseCreditOption.representativeEx')}}</p>\n                    <table class=\"trayInner trayInnerDefault representativeEx row-fluid\">\n                        <tr class=\"span6\">\n                            <td class=\"representativeExKey\">{{content('chooseCreditOption.purchaseRate')}}</td>\n                            <td class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.purchaseRateValue')}}</td>\n                        </tr>\n                        <tr class=\"span6\">\n                            <td class=\"representativeExKey\">{{content('chooseCreditOption.representativeAPR')}}</td>\n                            <td class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.representativeAPRValue')}}</td>\n                        </tr>\n                        <tr class=\"span6 last\">\n                            <td class=\"representativeExKey\">{{content('chooseCreditOption.exCreditLimit')}}</td>\n                            <td class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.exCreditLimitValue')}}</td>\n                        </tr>\n                    </table>\n                    <p class=\"disclaimer reviewMsg bmlLender\">{{content('chooseCreditOption.terms')}}</p>\n                </div>\n            </form>\n\n        </div>\n\n        <xo-bml-popup></xo-bml-popup>\n\n        <div ng-show=\"bmlPopupOpen\" class=\"bmlPopup span14\">\n            <p>\n                {{ content('fundingInstruments.bmlLearnMoreDesc') }}\n            </p>\n\n            <input type=\"button\" class=\"btn full primary\" value=\"{{ content('fundingInstruments.ok') }}\" ng-click=\"hideBmlPopup()\" />\n        </div>\n\n        <div class=\"span10\">\n\n            <xo-marketing-offers placement-code=\"'202003'\"\n                                 token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"propValueObj.propHeader\"\n                                 subtitle-property=\"propValueObj.propVal\"\n                                 background-image= \"propValueObj.propImage\"\n                                 ng-if=\"!ryiDesignExp && !isMessengerBAIntegration\"\n            >\n            </xo-marketing-offers>\n\n            <xo-marketing-offers token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"'ryiDesignExp.propHeader'\"\n                                 subtitle-property=\"'ryiDesignExp.propText'\"\n                                 background-image=\"{{ryiDesignExp.propImage}}\"\n                                 ng-if=\"ryiDesignExp && !isMessengerBAIntegration\"\n\n            >\n            </xo-marketing-offers>\n        </div>\n    </div>\n    <div ng-if=\"checkoutCart.isWalletTokenization()\">\n        <xo-title title-txt=\"Review the details\"></xo-title>\n        <div class=\"topupMsg\">{{content('review.topup')}}</div>\n        <xo-review-topup token=\"token\"></xo-review-topup>\n        <div class=\"disclaimer reviewMsg\" ng-bind-html=\"content('review.topupSetupAgreements')\"></div>\n        <div id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\"\n                   class=\"btn full confirmButton continueButton\" ng-click=\"onPay()\" />\n        </div>\n    </div>\n    <div ui-view></div>\n    <xo-3ds on-complete-3ds-handler=\"onComplete3DSHandler\" token=\"token\" data=\"resolve_3ds_data\" ng-if=\"launch3DSResolver\"></xo-3ds>\n</section>\n"

/***/ },

/***/ "./pages/xo-authorization-message/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AuthorizationMessageRoute = undefined;
	
	__webpack_require__("./pages/xo-authorization-message/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AuthorizationMessageRoute = exports.$AuthorizationMessageRoute = _squid.$ComponentRoute.extend('$AuthorizationMessageRoute', {
	
	    path: 'authorizationmessage',
	    directive: 'xo-authorization-message',
	    titleContent: 'authUserLearnMore.authUserTitle',
	
	    trackingData: {
	        fptiState: 'authorizationmessage',
	        templateName: 'authorizationMessage.dust',
	        pageGoal: 'Authorization Message',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-authorizationmessage',
	                'pagename2': '%::fullpage-authorizationmessage:member:hermes:',
	                'version': 'member:%:'
	            }
	        }
	    }
	});
	
	angular.value("$AuthorizationMessageRoute", $AuthorizationMessageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-authorization-message/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-authorization-message/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoAuthorizationMessageComponent', {
	
	    tag: 'xo-authorization-message',
	    template: _template2['default']
	
	});
	
	
	_squid.$Component;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-authorization-message/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"review\" content id=\"memberReview\" form-autofocus>\n\n    <div class=\"row-fluid justMember\">\n        <div class=\"span14 trayInner reviewSections\">\n            <div id=\"authMsg\" tabindex=\"-1\" modal-box aria-labelledby=\"authUserTitle\" aria-describedby=\"authUserContent1 authUserContent2\">\n                <div id=\"authUserLearnMore\" class=\"trayInner trayInnerDefault\">\n                    <h4 id=\"authUserTitle\" class=\"authUserTitle zeta\">{{content('authUserLearnMore.authUserTitle')}}</h4>\n                    <p id=\"authUserContent1\" class=\"authUserContent\">{{content('authUserLearnMore.authUserContentPara1')}}</p>\n                    <p id=\"authUserContent2\" class=\"authUserContent\">{{content('authUserLearnMore.authUserContentPara2')}}</p>\n                </div>\n                <div class=\"buttons\">\n                    <button class=\"btn authUserBtn full\" ui-sref=\"checkout.review\" focus-after-transition=\".authUserLink\" name=\"authUserBtn\">{{content('authUserLearnMore.ok')}}</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-add-card/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AddCardPageRoute = undefined;
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/route.js");
	
	__webpack_require__("./pages/xo-add-card/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AddCardPageRoute = exports.$AddCardPageRoute = _squid.$ComponentRoute.extend('$AddCardPageRoute', {
	
	    path: 'pageAddCard',
	    directive: 'xo-page-add-card-page',
	    titleContent: 'asideHeader.addCard',
	    query: ['cause', 'message'],
	    trackingData: {
	        templateName: 'addCard.dust',
	        pageGoal: 'Add Card',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-cc',
	                'pagename2': '%::fullpage-add-cc:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            pagetitle: 'pagetitle',
	            'parent-callbacks': 'callbacks',
	            logout: 'logout'
	        }
	    }]
	});
	
	angular.value("$AddCardPageRoute", $AddCardPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-add-card/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoPageAddCardPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-add-card/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-models/src/fi/lib/fiMessages.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoPageAddCardPageComponent = exports.$xoPageAddCardPageComponent = _squid.$Component.extend('$xoPageAddCardPageComponent', {
	    tag: 'xo-page-add-card-page',
	    template: _template2['default'],
	    scope: {},
	
	    controller: function controller($scope, $rootScope, $state, $locale, $CheckoutSessionModel, $populate, $stateParams, $CheckoutPayeeModel, $CheckoutCartModel, $fiMessages) {
	        // eslint-disable-line max-params,no-shadow
	        $scope.token = $rootScope.token;
	        $scope.locale = $locale;
	        $scope.callbacks = {
	            finish: function finish() {
	                $state.go('checkout.review');
	            }
	        };
	
	        var models = {};
	
	        $populate(models, {
	            checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
	                contingencies: {
	                    NEED_CREDIT_CARD: angular.noop,
	                    EXPIRED_CREDIT_CARD: angular.noop,
	                    NEED_DEBIT_CARD: angular.noop,
	                    EXPIRED_DEBIT_CARD: angular.noop
	                }
	            }),
	            payee: $CheckoutPayeeModel.instance($scope.token),
	            cart: $CheckoutCartModel.instance($scope.token)
	        }).then(function () {
	
	            var message = $fiMessages.processorDeclinedMsg(models.checkoutSession, false);
	
	            // If no processor decline, get the message when contingency is anything but NEED_DEBIT_CARD
	            if (!message && models.checkoutSession.get('errorData.cause') && $stateParams.message !== 'NEED_DEBIT_CARD') {
	                message = $fiMessages.errorMsg(models.payee.isGambling());
	            }
	
	            $scope.message = undefined;
	            $scope.cart = models.cart;
	
	            if (message) {
	                $scope.message = {
	                    type: 'info',
	                    msgs: [message.msg]
	                };
	            }
	        });
	
	        $scope.isUpdateDebitCard = function () {
	            return $stateParams.message === 'EXPIRED_DEBIT_CARD';
	        };
	    }
	});
	
	angular.value("$xoPageAddCardPageComponent", $xoPageAddCardPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-add-card/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\" ng-if=\"!cart.isWalletTokenization()\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n    <div class=\"sidepage noSlide\" modal-box tabindex=\"-1\" ng-if=\"cart.isWalletTokenization()\">\n        <div class=\"aside noSlide\" id=\"sidepageAddCard\" modal-box>\n            <xo-aside-header heading=\"{{isUpdateDebitCard() ? 'asideHeader.updateDebitCard' : 'asideHeader.addDebitCard'}}\"\n                             hidex=\"true\"></xo-aside-header>\n            <div class=\"content\">\n                <ui-view></ui-view>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-add-fi/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AddFiPageRoute = undefined;
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/route.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-bank/route.js");
	
	__webpack_require__("./pages/xo-add-fi/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AddFiPageRoute = exports.$AddFiPageRoute = _squid.$ComponentRoute.extend('$AddFiPageRoute', {
	
	    path: 'pageAddFi',
	
	    directive: 'xo-page-add-fi-page',
	
	    query: ['cause', 'message'],
	
	    titleContent: 'addCard.addPaymentMethod',
	
	    trackingData: {
	        templateName: 'addFi.dust',
	        pageGoal: 'Add Funding Instrument',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-fi',
	                'pagename2': '%::fullpage-add-fi:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            hideparenthead: 'hideparenthead',
	            billingaddressupdated: 'billingaddressupdated',
	            'parent-callbacks': 'callbacks',
	            'page-level': 'pageLevel'
	        }
	    }, {
	        name: '$AddBankFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            hideparenthead: 'hideparenthead',
	            'parent-callbacks': 'callbacks',
	            'page-level': 'pageLevel'
	        }
	    }]
	});
	
	angular.value("$AddFiPageRoute", $AddFiPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-add-fi/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoPageAddFiPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-add-fi/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-models/src/fi/lib/fiMessages.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoPageAddFiPageComponent = exports.$xoPageAddFiPageComponent = _squid.$Component.extend('$xoPageAddFiPageComponent', {
	    tag: 'xo-page-add-fi-page',
	    template: _template2['default'],
	    scope: {
	        logout: '='
	    },
	    controller: function controller($scope, $rootScope, $util, $AuthModel, $state, $locale, $CheckoutSessionModel, $populate, $stateParams, $CheckoutPayeeModel, $fiMessages, $logger) {
	        // eslint-disable-line no-shadow
	        $scope.token = $rootScope.token;
	        $scope.locale = $locale;
	
	        $scope.billingaddressupdated = {
	            value: false
	        };
	
	        $scope.hideparenthead = {
	            toggle: false
	        };
	
	        $scope.title = $locale.content.get('addCard.addACard');
	
	        $scope.callbacks = {
	            finish: function finish() {
	                $state.go('checkout.review');
	            },
	            done: function done() {
	                $state.go('checkout.review');
	            }
	
	        };
	
	        var models = {};
	
	        $populate($scope, {
	            auth: $AuthModel.instance(),
	            payee: $CheckoutPayeeModel.instance($scope.token)
	        }).then(function () {
	
	            $scope.logout = function () {
	                $logger.info('not_you_logout');
	                $scope.auth.action('logout').then(function () {
	                    $state.go('checkout.login');
	                });
	            };
	
	            $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp';
	            $populate(models, {
	                checkoutSession: $CheckoutSessionModel.instance($scope.token)
	            }).then(function () {
	                var message = $fiMessages.processorDeclinedMsg(models.checkoutSession, false) || $fiMessages.errorMsg($scope.payee.isGambling());
	
	                if (message.msg) {
	                    $scope.pageLevel = $scope.pageLevel || {};
	                    $scope.pageLevel.message = {
	                        type: 'info',
	                        msgs: [message.msg]
	                    };
	                }
	            });
	        });
	    }
	});
	
	angular.value("$xoPageAddFiPageComponent", $xoPageAddFiPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-add-fi/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addFi\" id=\"addFi\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-message message=\"pageLevel.message\"></xo-message>\n            <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n                {{ content('memberReview.welcomeBack', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <div class=\"trayInner trayInnerDefault\">\n                <h1 class=\"gamma noHead\" ng-if=\"!hideparenthead.toggle\">\n    \t\t\t\t{{content('addCard.addPaymentMethod')}}\n\t\t\t\t</h1>\n                <ul class=\"form-tabs\" id=\"paymentTab\" ng-if=\"!hideparenthead.toggle\">\n                    <li class=\"bank\" ui-sref-active=\"active\">\n                        <a ui-sref=\".bank.add\" class=\"bankTab\">{{content('bank.bank')}}</a>\n                    </li>\n                    <li class=\"card\" ui-sref-active=\"active\">\n                        <a ui-sref=\".addCardFlow.addCard\" class=\"cardTab\" for=\"cardTab\">{{content('bank.card')}}</a>\n                    </li>\n                </ul>\n                <ui-view></ui-view>\n            </div>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props  type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-add-card-meft/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AddCardMeftRoute = undefined;
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/route.js");
	
	__webpack_require__("./pages/xo-add-card-meft/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AddCardMeftRoute = exports.$AddCardMeftRoute = _squid.$ComponentRoute.extend('$AddCardMeftRoute', {
	
	    path: 'pageAddCardMeft',
	    directive: 'xo-page-add-card-meft-page',
	    titleContent: 'asideHeader.addCard',
	    query: ['message'],
	    trackingData: {
	        templateName: 'meftDeclineAddCard.dust',
	        pageGoal: 'Add Card for MEFT Decline',
	        buzname: {
	            'fullpage': {
	                'pagename': '%:de:meft-addcard',
	                'pagename2': '%:de:meft-addcard:member:hermes:',
	                'hier1': '%de',
	                'version': 'member:%:',
	                'flowname': '%de',
	                'subfeature2': '%de'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            pagetitle: 'pagetitle',
	            billingaddressupdated: 'billingaddressupdated',
	            showmeftsection: 'showmeftsection',
	            'parent-callbacks': 'callbacks'
	        }
	    }]
	});
	
	angular.value("$AddCardMeftRoute", $AddCardMeftRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-add-card-meft/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoPageAddCardMeftPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-add-card-meft/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoPageAddCardMeftPageComponent = exports.$xoPageAddCardMeftPageComponent = _squid.$Component.extend('$xoPageAddCardMeftPageComponent', {
	    tag: 'xo-page-add-card-meft-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state, $CheckoutAppDataModel, $locale, $CheckoutSessionModel) {
	        // eslint-disable-line no-shadow
	        $scope.token = $rootScope.token;
	        $scope.locale = $locale;
	
	        $scope.checkoutAppData = $CheckoutAppDataModel.instance($scope.token);
	
	        function populateInfoMessage() {
	            var msg = $locale.content.get('DEMemberGuest.meftDeclinePageErrorMsg');
	
	            $scope.message = {
	                msgs: [msg],
	                type: 'info'
	            };
	        }
	
	        populateInfoMessage();
	
	        $scope.showmeftsection = {
	            toggle: true
	        };
	
	        $scope.useMeft = function () {
	            $scope.checkoutAppData.action('meft', {
	                success: function success(result) {
	                    // reload checkout session with new meft instrument.
	                    $CheckoutSessionModel.instance($scope.token).reload();
	                    $state.go('checkout.review');
	                }
	            });
	        };
	
	        $scope.callbacks = {
	            finish: function finish() {
	                $state.go('checkout.review');
	            }
	        };
	
	        $scope.billingaddressupdated = {
	            value: false
	        };
	    }
	});
	
	angular.value("$xoPageAddCardMeftPageComponent", $xoPageAddCardMeftPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-add-card-meft/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n            <div ng-show=\"showmeftsection.toggle\">\n                <p class=\"useMeftInstead\">{{content ('DEMemberGuest.useMeftInstead')}}</p>\n\n                <div>\n                    <a track-link=\"meft_done\" id=\"submitBtnMeft\" href=\"\" class=\"btn btn-secondary\n                            btn-large full submit\" ng-click=\"useMeft()\"\n                       role=\"button\">{{content ('DEMemberGuest.useMeftBtn')}}</a>\n                </div>\n            </div>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-add-tax-id/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AddTaxIdRoute = undefined;
	
	__webpack_require__("./pages/xo-add-tax-id/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AddTaxIdRoute = exports.$AddTaxIdRoute = _squid.$ComponentRoute.extend('$AddTaxIdRoute', {
	
	    path: 'addTaxId',
	    directive: 'xo-add-tax-id-page',
	    titleContent: 'addTaxId.addTaxId',
	    query: ['message'],
	    trackingData: {
	        templateName: 'addTaxId.dust',
	        pageGoal: 'Add Tax Id',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-tax-id',
	                'pagename2': '%::fullpage-add-tax-id:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    loginRequired: true,
	    children: []
	});
	
	angular.value("$AddTaxIdRoute", $AddTaxIdRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-add-tax-id/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _template = __webpack_require__("./pages/xo-add-tax-id/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-form-components/src/add-tax-id/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoAddTaxIdPageComponent', {
	
	    tag: 'xo-add-tax-id-page',
	
	    template: _template2['default'],
	
	    lifecycle: {
	        enter: function enter() {
	            this.token = _angular.$rootScope.token;
	            this.locale = _squid.$locale;
	
	            this.finish = function () {
	                _uiRouter.$state.go('checkout.review');
	            };
	        }
	    }
	
	});
	
	
	_angular.$rootScope;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_uiRouter.$state;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-add-tax-id/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addTaxId\" id=\"addTaxId\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-add-tax-id token=\"token\" finish=\"finish\"></xo-add-tax-id>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-form-components/src/add-tax-id/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/add-tax-id/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-add-tax-id.directive', ['squid', 'xomodel.checkout', 'xomodel.user', 'xo-error-tooltip.directive']).directive('xoAddTaxId', function () {
	        return {
	            scope: {
	                token: '=',
	                finish: '='
	            },
	            template: template,
	
	            controller: function controller($scope, $populate, $state, $element, $CheckoutSessionModel, $UserInfoModel, $CheckoutCartModel) {
	
	                function thenFunction() {
	                    var taxIdType = 'CPF';
	                    if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.cause === 'NEED_BUSINESS_TAX_INFO_TO_PAY') {
	                        taxIdType = 'CNPJ';
	                    }
	                    var issuer = 'BR_' + taxIdType;
	                    $scope.subType = taxIdType;
	
	                    $scope.userInfo = $UserInfoModel.instance($scope.token);
	
	                    $scope.onSubmit = function () {
	                        // Scrub the formatting when invoking the backend services.
	                        var unformatted = ($scope.taxId || '').replace(/[^0-9]+/g, '');
	                        var data = {
	                            newDocId: {
	                                type: 'TAX_ID',
	                                subType: $scope.subType,
	                                issuerCountry: 'BR',
	                                issuer: issuer,
	                                value: unformatted,
	                                collectionPoint: 'UNKNOWN',
	                                placeOfIssue: 'BR'
	                            }
	                        };
	
	                        $scope.userInfo.action('addTaxId', {
	                            data: data,
	
	                            success: function success() {
	                                var checkoutSession = $CheckoutSessionModel.instance($scope.token);
	                                var checkoutCart = $CheckoutCartModel.instance($scope.token);
	                                return checkoutSession.action('create', {
	                                    data: {
	                                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token
	                                    },
	                                    success: function success() {
	                                        // Clear the errors if create checkout session was successful
	                                        $scope.checkoutSession.errorData = undefined;
	                                        $scope.finish();
	                                    }
	                                });
	                            },
	
	                            validation: function validation(validationData) {
	                                var $el = $($element);
	                                var $field = $($el.find('[name="' + validationData.field + '"]'));
	                                $field.addClass('backendError');
	                                $field.attr('aria-invalid', true);
	                                $field.focus();
	                            }
	                        });
	                    };
	
	                    $scope.changeTaxId = function (newValue) {
	                        var unformatted = (newValue || '').replace(/[^0-9]+/g, '');
	                        var formatted = '';
	                        var i = 0;
	
	                        // For CPF we will format the output with dots and dashes like this:
	                        // 999.999.999-99
	                        if ($scope.subType === 'CPF') {
	                            for (i = 0; i < unformatted.length; i++) {
	                                if (i === 3 || i === 6) {
	                                    formatted = formatted + '.';
	                                }
	                                if (i === 9) {
	                                    formatted = formatted + '-';
	                                }
	                                formatted = formatted + unformatted.charAt(i);
	                            }
	                            $scope.taxId = formatted;
	                            // For CNPJ we will format the output with dots, dashes, and slashes like this:
	                            // 99.999.999/9999-99
	                        } else if ($scope.subType === 'CNPJ') {
	                            for (i = 0; i < unformatted.length; i++) {
	                                if (i === 2 || i === 5) {
	                                    formatted = formatted + '.';
	                                } else if (i === 8) {
	                                    formatted = formatted + '/';
	                                } else if (i === 12) {
	                                    formatted = formatted + '-';
	                                }
	                                formatted = formatted + unformatted.charAt(i);
	                            }
	                            $scope.taxId = formatted;
	                        } else {
	                            $scope.taxId = unformatted;
	                        }
	                    };
	                }
	
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(thenFunction());
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/add-tax-id/template.html":
/***/ function(module, exports) {

	module.exports = "<form id=\"taxIdForm\" name=\"taxIdForm\" class=\"taxIdForm\" content novalidate>\n    <div class=\"trayInner trayInnerDefault\">\n        <div ng-if=\"subType === 'CNPJ'\">\n            <h3 class=\"gamma noHead\">{{ content('addTaxId.addTaxIdCNPJ') }}</h3>\n            <p>{{ content('addTaxId.noteCNPJ') }}</p>\n            <h3 class=\"gamma taxIdHead\"> {{ content('addTaxId.cnpj') }}</h3>\n\n            <div class=\"inputField confidential\">\n                <label for=\"taxId\" class=\"nolap accessAid\">{{ content('common.taxIdCNPJ_length') }}</label>\n                <input id=\"taxId\" name=\"taxId\" maxlength=\"18\" ng-model=\"$parent.taxId\"\n                       xo-error-tooltip required placeholder=\"{{ content('common.taxIdCNPJ_length') }}\"\n                       data-error-text=\"{{content('validation.validCNPJ')}}\" ng-change=\"changeTaxId(taxId)\" />\n            </div>\n        </div>\n\n        <div ng-if=\"subType === 'CPF'\">\n            <h3 class=\"gamma noHead\">{{ content('addTaxId.addTaxId') }}</h3>\n            <p>{{ content('addTaxId.note') }}</p>\n            <h3 class=\"gamma taxIdHead\"> {{ content('addTaxId.cpf') }}</h3>\n\n            <div class=\"inputField confidential\">\n                <label for=\"taxId\" class=\"nolap accessAid\">{{ content('common.taxId_length') }}</label>\n                <input id=\"taxId\" name=\"taxId\" maxlength=\"14\" ng-model=\"$parent.taxId\"\n                       xo-error-tooltip required placeholder=\"{{ content('common.taxId_length') }}\"\n                       data-error-text=\"{{content('validation.validCPF')}}\" ng-change=\"changeTaxId(taxId)\" />\n            </div>\n        </div>\n\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\" value=\"{{ content('addTaxId.save') }}\" class=\"btn full btn-large\" validate-submit=\"onSubmit()\" />\n        </div>\n    </div>\n</form>"

/***/ },

/***/ "./pages/xo-add-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AddShippingPageRoute = undefined;
	
	__webpack_require__("./pages/xo-add-shipping/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AddShippingPageRoute = exports.$AddShippingPageRoute = _squid.$ComponentRoute.extend('$AddShippingPageRoute', {
	
	    path: 'pageAddShipping',
	    directive: 'xo-page-add-shipping-page',
	
	    titleContent: 'addShipping.addAddress',
	
	    query: ['message'],
	
	    trackingData: {
	        templateName: 'addShipping.dust',
	        pageGoal: 'Add Shipping',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-shipping-address-nonXB',
	                'pagename2': '%::fullpage-add-shipping-address-nonXB:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddShippingRoute',
	        attributes: {
	            token: 'token',
	            'done-fn': 'callbacks.done',
	            sidebar: 'sidebar'
	        }
	    }]
	});
	
	angular.value("$AddShippingPageRoute", $AddShippingPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-add-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoPageAddShippingPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-add-shipping/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-address-components/src/add-address/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/select-shipping-country/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoPageAddShippingPageComponent = exports.$xoPageAddShippingPageComponent = _squid.$Component.extend('$xoPageAddShippingPageComponent', {
	    tag: 'xo-page-add-shipping-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state, $populate, // eslint-disable-line no-shadow
	    $feature, $locale, $CheckoutAppDataModel) {
	
	        $scope.token = $rootScope.token;
	        $scope.locale = $locale;
	        $scope.sidebar = false;
	        $scope.callbacks = {
	            done: function done() {
	                $state.go('checkout.review');
	            }
	        };
	
	        $populate($scope, {
	            checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	        }).then(function () {
	            var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
	
	            if (!$feature('supportBlockNonDomesticShipping', false, merchantCountry)) {
	                $state.go('checkout.review');
	            }
	        });
	    }
	});
	
	angular.value("$xoPageAddShippingPageComponent", $xoPageAddShippingPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-add-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addShipping\" id=\"addShipping\" content>\n    <div class=\"row-fluid\">\n\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-add-national-id/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AddNationalIdRoute = undefined;
	
	__webpack_require__("./pages/xo-add-national-id/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AddNationalIdRoute = exports.$AddNationalIdRoute = _squid.$ComponentRoute.extend('$AddNationalIdRoute', {
	
	    path: 'addNationalId',
	
	    directive: 'xo-add-national-id-page',
	
	    titleContent: 'addTaxId.nationalityUpdate',
	
	    children: []
	});
	
	angular.value("$AddNationalIdRoute", $AddNationalIdRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-add-national-id/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoAddNationalIdPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-add-national-id/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-form-components/src/national-id-input/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoAddNationalIdPageComponent = exports.$xoAddNationalIdPageComponent = _squid.$Component.extend('$xoAddNationalIdPageComponent', {
	    tag: 'xo-add-national-id-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state, $locale, $AddKYCModel, $CheckoutSessionModel, $NationalIdModel, $logger) {
	
	        $scope.locale = $locale;
	        $scope.user = {
	            country: $locale.country,
	            countryOfResidence: $locale.country
	        };
	
	        $scope.validate = function () {
	            $scope.validated = true;
	            return true;
	        };
	
	        $scope.onContinue = function () {
	            $scope.nationalIdModel = $NationalIdModel.instance($rootScope.token);
	            $scope.checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
	            $scope.addKYC = new $AddKYCModel({
	                token: $rootScope.token
	            });
	
	            $scope.KYCData = {
	                nationalIdModel: $scope.nationalIdModel,
	                user: $scope.user
	            };
	
	            $scope.addKYC.save({
	
	                data: $scope.KYCData,
	
	                success: function success() {
	                    $state.go('checkout.review');
	                },
	
	                contingencies: {
	                    DEFAULT: function DEFAULT(err, message) {
	                        $logger.info('add_KYC_contingency', {
	                            name: err,
	                            message: message
	                        });
	                    }
	                },
	                validation: function validation(res) {}
	            });
	        };
	    }
	});
	
	angular.value("$xoAddNationalIdPageComponent", $xoAddNationalIdPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-add-national-id/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addNationalId\" id=\"addNationalId\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner reviewSections\">\n            <p>\n                {{ content('memberReview.welcomeBack', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span ng-if=\"auth.is_auth_api_call\">\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n\n            <div class=\"trayInner trayInnerDefault\">\n                <h1 class=\"gamma noHead\" ng-if=\"!hideparenthead.toggle\">\n                    {{ content( 'addTaxId.nationalityUpdate' ) }}\n                </h1>\n                <p>\n                    {{ content( 'addTaxId.nationalityNote' ) }}\n                </p>\n                <ui-view></ui-view>\n            </div>\n\n            <form id=\"addNationalIdForm\" name=\"addNationalIdForm\" ng-submit=\"addNationalIdForm.$valid && onContinue()\" ng-class=\"{'validated': validated}\" novalidate>\n                <xo-national-id-input country={{locale.country}} user=\"user\"></xo-national-id-input>\n\n                <div class=\"buttons\">\n                    <input track-submit id=\"nationalIdSubmit\" type=\"submit\" value=\"{{ content( 'common.agreeAndContinue' ) }}\" ng-click=\"validate()\" class=\"btn full signupFlowSubmit\"/>\n                </div>\n            </form>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props  type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-form-components/src/national-id-input/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/national-id-input/template.html"), __webpack_require__("./components/xo-ui-components/src/tooltip/directive.js"), __webpack_require__("./components/xo-form-components/src/dob-input/directive.js"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-national-id-input.directive', ['squid', 'xo-tooltip.directive', 'xo-dob-input.directive', 'xomodel.checkout']).directive('brIdValidations', function () {
	        return {
	            require: 'ngModel',
	
	            link: function link(scope, element, attr, ctrl) {
	                scope.cpfValidator = function cpfValidator(ngModelValue) {
	                    var value = ngModelValue.replace(/[^0-9]/gi, '');
	                    var len = value.length;
	
	                    if (len !== 11) {
	                        ctrl.$setValidity('nationalId', false);
	                        return ngModelValue;
	                    }
	
	                    var x = value.match(/\b(\d)\1+\b/);
	
	                    if (x) {
	                        ctrl.$setValidity('nationalId', false);
	                        return ngModelValue;
	                    }
	
	                    var v1 = 0;
	                    var v2 = 0;
	                    var dv1;
	                    var dv2;
	                    var i;
	                    var j;
	
	                    for (i = 0, j = 10; i < 9, j > 1; i++, j--) {
	                        // eslint-disable-line no-sequences
	                        v1 += j * +value[i];
	                    }
	
	                    v1 = v1 % 11;
	                    dv1 = 11 - v1 < 10 ? 11 - v1 : 0;
	
	                    for (i = 0, j = 11; i < 9, j > 2; i++, j--) {
	                        // eslint-disable-line no-sequences
	                        v2 += j * +value[i];
	                    }
	
	                    v2 += dv1 * 2;
	                    v2 = v2 % 11;
	                    dv2 = 11 - v2 < 10 ? 11 - v2 : 0;
	
	                    scope.isValid = dv1 === parseInt(value[9], 10) && dv2 === parseInt(value[10], 10);
	
	                    ctrl.$setValidity('nationalId', scope.isValid);
	
	                    return ngModelValue;
	                };
	
	                ctrl.$parsers.push(scope.cpfValidator);
	            }
	        };
	    }).directive('sgIdValidations', function () {
	        return {
	            require: 'ngModel',
	
	            link: function link(scope, element, attr, ctrl) {
	                scope.nricFinValidator = function nricFinValidator(ngModelValue) {
	                    var idType = scope.$parent.nationalIdModel.nationalId.type;
	                    if (idType === 'NATIONAL_ID') {
	                        scope.isValid = false;
	
	                        // Valid if first char is "S", "T", "F" or "G" and the rest 7 are digits.
	                        if (ngModelValue.match(/^[S|T|G|F]\d{7}$/gi)) {
	                            scope.isValid = true;
	                        }
	                    } else {
	                        scope.isValid = true;
	                    }
	                    ctrl.$setValidity('nationalId', scope.isValid);
	                    return ngModelValue;
	                };
	                ctrl.$parsers.push(scope.nricFinValidator);
	            }
	        };
	    }).directive('ruIdValidations', function () {
	        return {
	            require: 'ngModel',
	
	            link: function link(scope, element, attr, ctrl) {
	
	                function validateSNILSChunk(sum, checksum) {
	                    if (sum < 100 && sum === checksum) {
	                        return true;
	                    } else if ((sum === 100 || sum === 101) && checksum === 0) {
	                        return true;
	                    } else if (sum > 101) {
	                        var remainder = sum % 101;
	                        return validateSNILSChunk(remainder, checksum);
	                    }
	
	                    return false;
	                }
	
	                function validateSNILS(value) {
	                    if (value.length === 11) {
	                        if (Number(value) > 1001998) {
	                            var snilsNumber = value.substring(0, 9);
	                            var checksum = Number(value.substring(9));
	                            var sum = 0;
	                            var multiplier = 1;
	
	                            for (var i = snilsNumber.length - 1; i >= 0; i--) {
	                                sum = sum + Number(snilsNumber.charAt(i)) * multiplier;
	                                multiplier++;
	                            }
	
	                            return validateSNILSChunk(sum, checksum);
	                        }
	
	                        return true;
	                    }
	
	                    return false;
	                }
	
	                function validateINNChecksum(value, factor, valueLength, match) {
	                    var n;
	                    var sumn = 0;
	                    for (var i = 0; i < valueLength; i++) {
	                        sumn = sumn + Number(value[i]) * Number(factor[i]);
	                    }
	                    n = sumn % 11;
	                    n = n === 10 ? 0 : n;
	
	                    if (n !== Number(match)) {
	                        return false;
	                    }
	
	                    return true;
	                }
	
	                function validateINN(value) {
	                    if (value.length === 12) {
	                        var factor = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
	
	                        if (!validateINNChecksum(value, factor, value.length - 2, value[10])) {
	                            return false;
	                        }
	
	                        factor.unshift(3);
	
	                        if (!validateINNChecksum(value, factor, value.length - 1, value[11])) {
	                            return false;
	                        }
	
	                        return true;
	                    }
	
	                    return false;
	                }
	
	                function validateOMS(value) {
	                    if (value.length >= 11 && value.length <= 16) {
	                        return true;
	                    }
	
	                    return false;
	                }
	
	                scope.idValidator = function idValidator(ngModelValue) {
	                    var value = ngModelValue.replace(/[^0-9]/gi, '');
	                    var secondaryType = scope.nationalIdModel.secondaryIdType;
	
	                    if (secondaryType === 'SNILS') {
	                        scope.isValid = validateSNILS(value);
	                    } else if (secondaryType === 'INN') {
	                        scope.isValid = validateINN(value);
	                    } else if (secondaryType === 'OMS') {
	                        scope.isValid = validateOMS(value);
	                    }
	
	                    ctrl.$setValidity('secondaryId', scope.isValid);
	
	                    return ngModelValue;
	                };
	
	                ctrl.$parsers.push(scope.idValidator);
	            }
	        };
	    }).directive('xoNationalIdInput', function () {
	        return {
	            template: template,
	            scope: {
	                user: '=',
	                country: '@'
	            },
	
	            link: function link(scope, element, attr) {
	                var passportMask = '0000000000';
	
	                element.on('keyup', function (event) {
	                    if (scope.user.countryOfResidence === 'RU') {
	                        $('#nationalId').mask(passportMask, {
	                            'translation': {
	                                0: { pattern: /[0-9]/ }
	                            }
	                        });
	                    } else {
	                        $('#nationalId').unmask(passportMask);
	                    }
	                });
	            },
	
	            controller: function controller($scope, $feature, $locale, $rootScope, $CheckoutCartModel, $NationalIdModel, $util) {
	
	                $scope.nationalIdModel = $NationalIdModel.instance($rootScope.token);
	                $scope.checkoutCart = $CheckoutCartModel.instance($rootScope.token);
	                $scope.user = $scope.user || {};
	                $scope.user.countryOfResidence = $scope.user.countryOfResidence || $scope.country;
	                $scope.formattedValues = {};
	                $scope.showNationalIdFields = false;
	
	                function sortCountryList() {
	                    $scope.metadata = angular.copy($locale.metadata);
	                    return $scope.metadata.territory;
	                }
	
	                $scope.countries = sortCountryList();
	
	                if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.tax_id) {
	                    $scope.nationalIdModel.nationalId.value = $scope.checkoutCart.payer.tax_id;
	                }
	
	                $scope.countryChanged = function () {
	                    if ($scope.user.countryOfResidence === 'RU') {
	                        $scope.showNationalIdFields = true;
	                        $scope.minLengthNatId = 10;
	                        $scope.maxLengthNatId = 10;
	                    } else {
	                        $scope.showNationalIdFields = false;
	                        $scope.minLengthNatId = 6;
	                        $scope.maxLengthNatId = 15;
	                    }
	                };
	
	                $scope.cpfMasking = function (newValue) {
	                    if (newValue) {
	                        var unformatted = newValue.replace(/[^0-9]/gi, '');
	                        var formatted = [['', unformatted.slice(0, 3)], ['.', unformatted.slice(3, 6)], ['.', unformatted.slice(6, 9)], ['-', unformatted.slice(9)]].map(function (x) {
	                            return x[1] && x[0] + x[1] || '';
	                        }).join('');
	
	                        $scope.formattedValues.nationalId = formatted;
	                        $scope.nationalIdModel.nationalId.value = unformatted;
	                    } else {
	                        $scope.nationalIdModel.nationalId.value = '';
	                    }
	                };
	
	                $scope.secondaryIdFormatting = function () {
	                    var $el = $('#idValue');
	
	                    if ($scope.nationalIdModel.secondaryIdType === 'SNILS' && $el.length > 0) {
	                        var unformatted = $el.val().replace(/[^0-9]/gi, '');
	                        var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3, 6)], ['-', unformatted.slice(6, 9)], [' ', unformatted.slice(9)]].map(function (x) {
	                            return x[1] && x[0] + x[1] || '';
	                        }).join('');
	
	                        $scope.nationalIdModel.secondaryIdValue = formatted;
	                    }
	                };
	
	                $scope.secondaryIdChange = function () {
	                    var currentSecondaryId = $scope.secondaryIds[$scope.nationalIdModel.secondaryIdType];
	
	                    $scope.nationalIdModel.secondaryIdValue = '';
	                    $scope.maxLength = currentSecondaryId.length;
	                    $scope.minLength = currentSecondaryId.minlength ? currentSecondaryId.minlength : currentSecondaryId.length;
	
	                    $scope.maskCharLength = currentSecondaryId.maskCharLength ? currentSecondaryId.maskCharLength : 0;
	                };
	
	                $scope.sgIdChange = function () {
	                    $scope.nationalIdModel.nationalId.value = '';
	                };
	
	                function setLocalizedNatIDLabels() {
	                    $scope.nationalIds = {
	                        'NATID': { name: 'NATIONAL_ID', value: $locale.content.addTaxId.natid },
	                        'DL': { name: 'DRIVERS_LICENSE', value: $locale.content.addTaxId.dl },
	                        'PASSPORT': { name: 'PASSPORT_NUMBER', value: $locale.content.addTaxId.passport }
	                    };
	                }
	
	                if ($locale.country === 'BR') {
	                    $scope.nationalIdModel.nationalId.type = 'TAX_ID';
	                    $scope.nationalIdModel.nationalId.subType = 'CPF';
	
	                    $scope.cpfMasking($scope.nationalIdModel.nationalId.value);
	                } else if ($scope.country === 'RU') {
	                    $scope.nationalIdModel.nationalId.type = 'PASSPORT';
	                    $scope.nationalIdModel.nationalId.subType = '';
	                    $scope.user.nativeName = $scope.user.nativeName || {};
	                    $scope.secondaryIds = {
	                        'INN': { name: 'INN', value: $locale.content.addTaxId.INN, length: 12 },
	                        'SNILS': { name: 'SNILS', value: $locale.content.addTaxId.SNILS, length: 14, maskCharLength: 3 },
	                        'OMS': { name: 'OMS', value: $locale.content.addTaxId.OMS, length: 16, minlength: 11 }
	                    };
	
	                    if (!$scope.nationalIdModel.secondaryIdType) {
	                        $scope.nationalIdModel.secondaryIdType = $scope.secondaryIds.INN.name;
	                    }
	
	                    $scope.secondaryIdChange();
	
	                    $scope.countryChanged();
	                } else if ($scope.country === 'KR') {
	                    $scope.nationalIds = {
	                        'PASSPORT': { name: 'PASSPORT_NUMBER', value: $locale.content.addTaxId.passport },
	                        'DL': { name: 'DRIVERS_LICENSE', value: $locale.content.addTaxId.dl }
	
	                    };
	                    $scope.nationalIdModel.nationalId.type = 'PASSPORT_NUMBER';
	                    $scope.nationalIdModel.nationalId.subType = '';
	                } else {
	                    // Default behaviour - set to 3pl countries
	                    setLocalizedNatIDLabels();
	                    $scope.nationalIdModel.nationalId.type = 'NATIONAL_ID';
	                    $scope.nationalIdModel.nationalId.subType = '';
	                }
	
	                $scope.$on('contentChange', function () {
	                    setLocalizedNatIDLabels();
	                });
	            }
	        };
	    }).factory('$NationalIdModel', function ($Model) {
	
	        return $Model.extend('NationalIdModel', {
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.nationalId = this.nationalId || {};
	            },
	
	            serialize: function serialize() {
	                return this.nationalId;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-form-components/src/national-id-input", "components/xo-form-components/src/national-id-input/directive.js"))

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/national-id-input/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"nationalIdFields\" class=\"clearfix\" content>\n    <div class=\"bankField restricted\">\n        <div ng-switch=\"country\">\n            <div ng-switch-when=\"SG\">\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            ng-change=\"sgIdChange()\"\n                            aria-required=\"true\">\n                        <option ng-repeat=\"items in nationalIds\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type==='{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           valid-letters=\"data.validLetters\"\n                           sg-id-validations\n                           required/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n            </div>\n\n            <div ng-switch-when=\"BR\">\n\n                <div class=\"inputField confidential nationalId\" floating-label directionality>\n                    <input ng-model=\"formattedValues.nationalId\"\n                           name=\"nationalId\"\n                           id=\"nationalId\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           xo-error-tooltip\n                           br-id-validations\n                           maxlength=\"14\"\n                           ng-change=\"cpfMasking(formattedValues.nationalId)\"\n                           required/>\n                    <label for=\"nationalId\">{{content('addTaxId.cpf')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"KR\">\n\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            aria-required=\"false\">\n                        <option ng-repeat=\"items in nationalIds\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type==='{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"false\"\n                           autocomplete=\"off\"/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"RU\">\n\n                <div class=\"nationalId\">\n                    <div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"country\" ng-model=\"user.countryOfResidence\" id=\"country\"\n                                        aria-labelledby=\"countryLabel\" ng-change=\"countryChanged()\" xo-error-tooltip required>\n                            <option ng-repeat=\"country in countries\" value=\"{{country.code}}\" ng-selected=\"user.countryOfResidence === country.code\">{{country.name}}</option>\n                        </select>\n                        <label for=\"country\" id=\"countryLabel\">{{content('common.country')}}</label>\n                    </div>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <xo-name-input user=\"user.nativeName\"></xo-name-input>\n\n                        <div class=\"inputField confidential full\" floating-label directionality>\n                            <input ng-model=\"user.nativeName.middle_name\"\n                                   name=\"middleName\"\n                                   id=\"middleName\"\n                                   value=\"\"\n                                   autocapitalize=\"off\"\n                                   aria-required=\"true\"\n                                   autocomplete=\"off\"\n                                   required />\n                            <label for=\"middleName\" id=\"middleNameLabel\">{{content('common.middleName')}}</label>\n                        </div>\n                    </div>\n\n                    <div class=\"fieldGroup\">\n                        <div class=\"inputField full\" floating-label directionality>\n                                <input ng-model=\"nationalIdModel.nationalId.value\"\n                                       name=\"nationalId\"\n                                       id=\"nationalId\"\n                                       value=\"\"\n                                       autocapitalize=\"off\"\n                                       aria-required=\"true\"\n                                       autocomplete=\"off\"\n                                       minlength=\"{{minLengthNatId}}\"\n                                       maxlength=\"{{maxLengthNatId}}\"\n                                       placeholder=\"{{user.countryOfResidence === 'RU' && content('addTaxId.passportRU') || content('addTaxId.passportEN')}}\"\n                                       xo-validation='{\"validator\": \"validRUPassport\"}'\n                                       xo-error-tooltip\n                                       required />\n\n                                <label for=\"nationalId\">{{content('addTaxId.passport')}}</label>\n                        </div>\n\n                        <div class=\"full last-child\">\n                            <xo-dob-input user=\"user\"></xo-dob-input>\n                        </div>\n                    </div>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <legend class=\"fieldLegend\" for=\"additionalId\">{{content('addTaxId.additionalInfo')}}\n                            <div class=\"additionalIdHelper\">\n                                <a href=\"#\" id=\"verifyHelpAdditionalId\" alt=\"Why do we need this\" class=\"verifyHelp\"></a>\n                            </div>\n                            <div class=\"lineSpacing\">\n                                <xo-tooltip trigger=\"#verifyHelpAdditionalId\">\n                                    <div class=\"tip tipDesc\">\n                                        {{content('addTaxId.additionalInfoNote')}}\n                                    </div>\n                                </xo-tooltip>\n                            </div>\n                        </legend>\n\n                        <div id=\"additionalId\">\n                            <div class=\"dropdown additionalID inputField\" floating-label-dropdown>\n                                <select xo-dropdown name=\"idType\"\n                                        ng-model=\"nationalIdModel.secondaryIdType\"\n                                        id=\"idType\"\n                                        aria-label=\"{{ content('signup.accountCreationGuest.dobDay') }}\"\n                                        ng-change=\"secondaryIdChange()\"\n                                        aria-required=\"true\">\n                                    <option ng-repeat=\"items in secondaryIds\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.secondaryIdType==='{{items.name}}'\">{{items.value}}</option>\n                                </select>\n                                <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                            </div>\n\n                            <div class=\"inputField additionalIDValue\" floating-label directionality>\n                                <input ng-model=\"nationalIdModel.secondaryIdValue\"\n                                       name=\"idValue\"\n                                       id=\"idValue\"\n                                       class=\"additionalIDBox\"\n                                       value=\"\"\n                                       maxlength=\"{{maxLength}}\"\n                                       minlength=\"{{minLength}}\"\n                                       autocapitalize=\"off\"\n                                       aria-required=\"true\"\n                                       autocomplete=\"off\"\n                                       placeholder=\"{{(maxLength - maskCharLength)}} {{content('addTaxId.digits')}}\"\n                                       required\n                                       ru-id-validations\n                                       ng-change=\"secondaryIdFormatting()\"/>\n                                <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-switch-default>\n              <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                  <select xo-dropdown name=\"idType\"\n                          ng-model=\"nationalIdModel.nationalId.type\"\n                          id=\"idType\"\n                          aria-required=\"true\">\n                      <option ng-repeat=\"items in nationalIds\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type==='{{items.name}}'\">{{items.value}}</option>\n                  </select>\n                  <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n              </div>\n\n              <div class=\"inputField nationalIDValue\" floating-label directionality>\n                  <input ng-model=\"nationalIdModel.nationalId.value\"\n                         name=\"idValue\"\n                         id=\"idValue\"\n                         class=\"additionalIDBox\"\n                         value=\"\"\n                         autocapitalize=\"off\"\n                         aria-required=\"true\"\n                         autocomplete=\"off\"\n                         required/>\n                  <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n              </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-form-components/src/dob-input/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/dob-input/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-dob-input.directive', ['squid']).directive('dobValidation', function () {
	
	        return {
	            require: 'ngModel',
	            link: function link(scope, element, attr, ctrl) {
	
	                // init scope vars
	                // age - above 18 yrs
	                // validDate - months <= 12 and day <= 31 or based on month
	                scope.isValidDate = true;
	                scope.isValidAge = true;
	                scope.isValid = false;
	                scope.dobToolTip = 'hide';
	
	                function isValidDate(year, month, day) {
	                    // dates like 02/31 33/33 should return false
	                    var date = new Date(year, month, day);
	
	                    var fullYear = date.getFullYear();
	                    var dateMonth = date.getMonth();
	                    var dateDay = date.getDate();
	
	                    // If birth year is in the future or before 1900, dob is invalid
	                    var now = new Date();
	                    if (fullYear > now.getFullYear() || fullYear < 1900) {
	                        return false;
	                    }
	
	                    if (fullYear === parseInt(year, 10) && dateMonth === parseInt(month, 10) && dateDay === parseInt(day, 10)) {
	                        return true;
	                    }
	                    return false;
	                }
	
	                function isOfLegalAge(birthDate) {
	                    // user should be of exact 18 years of age or older
	                    var tempDate = new Date(birthDate.getFullYear() + 18, birthDate.getMonth(), birthDate.getDate());
	                    return tempDate <= new Date().setHours(0, 0, 0, 0);
	                }
	
	                /**
	                 * Parses input value to set corresponding day, month, year values for scope
	                 * @param {String} inputVal - the value to be parsed
	                 */
	                function parseDob(inputVal) {
	                    var day;
	                    var month;
	                    var year;
	
	                    var sep = scope.dateSeparator();
	                    var partsArr = inputVal.split(sep);
	                    var first = partsArr[0];
	                    var sec = partsArr[1];
	                    var third = partsArr[2];
	
	                    if (scope.dateFormat() === 'DMY') {
	                        day = first;
	                        month = sec;
	                        year = third;
	                    } else if (scope.dateFormat() === 'YMD') {
	                        year = first;
	                        month = sec;
	                        day = third;
	                    } else {
	                        month = first;
	                        day = sec;
	                        year = third;
	                    }
	
	                    // Validate only on entering the last digit of the dob
	                    var dayLen = ('' + day).length;
	                    var monLen = ('' + month).length;
	                    var yrLen = ('' + year).length;
	                    var validDay = dayLen === 1 || dayLen === 2;
	                    var validMon = monLen === 1 || monLen === 2;
	                    var validYr = yrLen === 4;
	                    var requirement = validDay && validMon && validYr;
	
	                    if (requirement) {
	                        scope.isValidDate = isValidDate(year, month - 1, day);
	
	                        scope.isValidAge = isOfLegalAge(new Date(year, month - 1, day));
	                        scope.isValid = scope.isValidDate && scope.isValidAge;
	                        scope.dobToolTip = scope.isValid ? 'hide' : 'show';
	
	                        scope.user.dob_day = day;
	                        scope.user.dob_month = month;
	                        scope.user.dob_year = year;
	                    } else {
	                        scope.isValid = false;
	                    }
	
	                    ctrl.$setValidity('dobText', scope.isValid);
	
	                    return inputVal;
	                }
	
	                /**
	                 * Validates the inputted DOB value
	                 * @param {string} ngModelValue - the to-be mutated input value
	                 * onComplete for mask listener - called when user copy/pastes DOB into the field
	                 */
	                scope.dobValidator = function dobValidator(ngModelValue) {
	                    var input = $('#dobText');
	                    var dateMask = scope.dateMask();
	                    input.mask(dateMask, {
	                        translation: {
	                            'Z': {
	                                pattern: /[0-9]/, optional: true
	                            },
	                            '0': {
	                                pattern: /[0-9]/, optional: false
	                            }
	                        },
	                        onComplete: function onComplete(val) {
	                            ngModelValue = val;
	                            return parseDob(ngModelValue);
	                        }
	                    });
	
	                    ngModelValue = input.val();
	                    return parseDob(ngModelValue);
	                };
	
	                scope.dobTester = function dobTester(val) {
	                    return parseDob(val);
	                };
	
	                ctrl.$parsers.push(scope.dobValidator);
	            }
	        };
	    }).directive('xoDobInput', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                user: '='
	            },
	            controller: function controller($scope, $locale) {
	
	                // To support additional date separators, simply add separator to getDateSeparators function
	                var DateManager = {
	                    dateSeparator: undefined,
	                    dateFormat: undefined,
	                    griffinDateEntry: undefined,
	
	                    _init_: function _init_() {
	                        this.griffinDateEntry = $locale.metadata.dateEntry;
	                        this.dateSeparator = this.getDateSeparator(this.griffinDateEntry);
	                        this.dateFormat = undefined;
	                        this.dateFormat = this.getDateFormat();
	                        this.dateRegex = this.getDateRegex();
	                        // dob validator depends on dateFormat function in $scope, so context is bound.
	                        $scope.dateFormat = this.getDateFormat.bind(this);
	                        $scope.dateSeparator = this.getDateSeparator.bind(this, this.griffinDateEntry);
	                        $scope.dateMask = this.getDateMask.bind(this, this.dateSeparator);
	                    },
	                    getDateFormat: function getDateFormat() {
	                        // cache date format value, must be unset on init
	                        if (this.dateFormat) {
	                            return this.dateFormat;
	                        }
	
	                        var griffinDateFormat = $locale.metadata.dateFormat.toUpperCase();
	                        var dateFormatComponents = griffinDateFormat.split(this.dateSeparator);
	
	                        var dIdx = dateFormatComponents.indexOf('DD'),
	                            mIdx = dateFormatComponents.indexOf('MM');
	
	                        var formatComponentMap = this.getFormatComponentIdxMappings();
	                        if (formatComponentMap['DMY'].day === dIdx && formatComponentMap['DMY'].month === mIdx) {
	                            return 'DMY';
	                        } else if (formatComponentMap['MDY'].day === dIdx && formatComponentMap['MDY'].month === mIdx) {
	                            return 'MDY';
	                        }
	                        return 'YMD';
	                    },
	                    setDobTextPlaceHolder: function setDobTextPlaceHolder() {
	                        $scope.dobTextPlaceholder = this.griffinDateEntry.toUpperCase();
	                    },
	                    dobTextKeyupHandler: function dobTextKeyupHandler(event) {
	                        this.updateDobBindings(true);
	                    },
	                    /**
	                     * Absolutely makes sure that dob input doesn't contain bad characters.
	                     * Called on any chatacter input AND on locale change.
	                     */
	                    updateDobBindings: function updateDobBindings(change) {
	                        var cleanedDob = ($scope.dob.value || '').replace(this.dateRegex, '');
	                        $scope.dob.value = cleanedDob;
	
	                        // This way, our dob value is always formatted correctly.
	                        if (change) {
	                            $scope.dob.value = $('#dobText').val();
	                        }
	                    },
	                    // Dynamically construct regex to only include date separator supported by country and nondigits
	                    getDateRegex: function getDateRegex() {
	                        var escapedRegexChars = ['.', '$', '^', '{', '[', '(', '|', ')', '*', '+', '?', '\\'];
	                        var sep = this.dateSeparator;
	                        var assembledRegex = '[^0-9' + (escapedRegexChars.indexOf(sep) !== -1 ? '\\' + sep : sep) + ']';
	                        return new RegExp(assembledRegex, 'gi');
	                    },
	                    getDateMask: function getDateMask(dateSeparator) {
	                        var dateFormat = this.dateFormat;
	                        if (dateFormat === 'DMY' || dateFormat === 'MDY') {
	                            return '0Z' + dateSeparator + '0Z' + dateSeparator + '0000';
	                        }
	
	                        return '0000' + dateSeparator + '0Z' + dateSeparator + '0Z';
	                    },
	                    getDateSeparator: function getDateSeparator(dateEntry) {
	                        var ret = '';
	                        this.getDateSeparators().forEach(function (ele, iter) {
	                            // eslint-disable-line
	                            if (dateEntry.indexOf(ele) !== -1) {
	                                ret = ele;
	                            }
	                        });
	                        return ret;
	                    },
	                    // To add any additional date separators, simply add them to the returned array.
	                    getDateSeparators: function getDateSeparators() {
	                        return ['-', '.', '/'];
	                    },
	                    // Handles changes in date component order or date separator change.
	                    updateDateInputForFormat: function updateDateInputForFormat(oldFormat, newFormat, oldSeparator) {
	                        var curDateVal = $scope.dob.value || '';
	
	                        // Clear dob input if date is incomplete so user can see updated placeholder
	                        if (curDateVal.length < 8) {
	                            $scope.dob.value = '';
	                            return;
	                        }
	
	                        var formatComponentIdxMappings = this.getFormatComponentIdxMappings(),
	                            oldFormatIdxMapping = formatComponentIdxMappings[oldFormat],
	                            newFormatIdxMapping = formatComponentIdxMappings[newFormat];
	                        var oldDateComponents = curDateVal.split(oldSeparator),
	                            newDateComponents = ['', '', ''];
	
	                        newDateComponents[newFormatIdxMapping.day] = oldDateComponents[oldFormatIdxMapping.day];
	                        newDateComponents[newFormatIdxMapping.month] = oldDateComponents[oldFormatIdxMapping.month];
	                        newDateComponents[newFormatIdxMapping.year] = oldDateComponents[oldFormatIdxMapping.year];
	                        $scope.dob.value = newDateComponents.join(this.dateSeparator);
	                    },
	                    getFormatComponentIdxMappings: function getFormatComponentIdxMappings() {
	                        return {
	                            'DMY': {
	                                'day': 0,
	                                'month': 1,
	                                'year': 2
	                            },
	                            'MDY': {
	                                'day': 1,
	                                'month': 0,
	                                'year': 2
	                            },
	                            'YMD': {
	                                'day': 2,
	                                'month': 1,
	                                'year': 0
	                            }
	                        };
	                    },
	                    prefillFetchedDob: function prefillFetchedDob() {
	                        if ($scope.user && $scope.user.dob_day && $scope.user.dob_month && $scope.user.dob_year) {
	                            if (!$scope.dob) {
	                                $scope.dob = {};
	                            }
	
	                            if (this.dateFormat === 'DMY') {
	                                $scope.dob.value = $scope.user.dob_day + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_year;
	                            } else if (this.dateFormat === 'YMD') {
	                                $scope.dob.value = $scope.user.dob_year + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day;
	                            } else {
	                                $scope.dob.value = $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day + this.dateSeparator + $scope.user.dob_year;
	                            }
	                        } else {
	                            $scope.dob = {
	                                value: ''
	                            };
	                        }
	                    }
	                };
	
	                DateManager._init_();
	                DateManager.setDobTextPlaceHolder();
	                DateManager.prefillFetchedDob();
	
	                $scope.onDobTextKeyup = function (event) {
	                    DateManager.dobTextKeyupHandler(event);
	                };
	
	                $scope.$on('localeChange', function () {
	                    var oldDateFormat = DateManager.dateFormat;
	                    var oldSeparator = DateManager.dateSeparator;
	                    DateManager._init_();
	                    DateManager.updateDateInputForFormat(oldDateFormat, DateManager.dateFormat, oldSeparator);
	                    DateManager.updateDobBindings(false);
	                    DateManager.setDobTextPlaceHolder();
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/dob-input/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"dobComp\" class=\"dobbank\" ng-class=\"{dobTXT: dobInputType()==='TXT'}\" content>\n    <div class=\"dobField full inputField last-child\" floating-label directionality>\n        <input ng-model=\"dob.value\"\n               name=\"dobText\"\n               id=\"dobText\"\n               value=\"\"\n               maxlength=\"10\"\n               autocapitalize=\"off\"\n               aria-required=\"true\"\n               autocomplete=\"off\"\n               placeholder=\"{{ dobTextPlaceholder }}\"\n               xo-error-tooltip\n               dob-validation\n               ng-keyup=\"onDobTextKeyup($event)\"\n               required />\n        <div ng-class=\"dobToolTip\">\n            <xo-tooltip trigger=\"#dobText\" show-event=\"keyup\" ng-class=\"dobToolTip\" id=\"dobToolTip\">\n                <div class=\"tip tipDesc dobToolTip\">\n                  <p class=\"tipInfoText restriction active\" ng-if=\"!isValidDate\">{{ content('scripts.validDate') }}</p>\n                  <p class=\"tipInfoText restriction active\" ng-if=\"isValidDate && !isValidAge\">{{ content('scripts.legalAge') }}</p>\n                </div>\n            </xo-tooltip>\n        </div>\n        <label id=\"dobLabel\" for=\"dob\">{{ content('signup.accountCreationGuest.dobLabel') }}</label>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-update-card/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$UpdateCardPageRoute = undefined;
	
	__webpack_require__("./pages/xo-update-card/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $UpdateCardPageRoute = exports.$UpdateCardPageRoute = _squid.$ComponentRoute.extend('$UpdateCardPageRoute', {
	
	    path: 'updateCard',
	    directive: 'xo-update-card-page',
	    titleContent: 'asideHeader.update',
	    query: ['message'],
	    trackingData: {
	        templateName: 'tray/editCard.dust',
	        pageGoal: 'Update Card',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-edit-cc',
	                'pagename2': '%::fullpage-edit-cc:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            pagetitle: 'pagetitle',
	            isUpdateFlow: 'isUpdateFlow',
	            cardmodel: 'cardmodel',
	            'parent-callbacks': 'callbacks'
	
	        }
	    }]
	});
	
	angular.value("$UpdateCardPageRoute", $UpdateCardPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-update-card/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoUpdateCardPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/directive.js");
	
	__webpack_require__("./components/xo-models/src/fi/index.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	var _template = __webpack_require__("./pages/xo-update-card/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoUpdateCardPageComponent = exports.$xoUpdateCardPageComponent = _squid.$Component.extend('$xoUpdateCardPageComponent', {
	
	    tag: 'xo-update-card-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $populate, $state, $renderContent, $locale, $CheckoutSessionModel, $stateParams) {
	        // eslint-disable-line no-shadow
	
	        $scope.callbacks = {
	            finish: function finish() {
	                $state.go('checkout.review');
	            }
	        };
	        $scope.token = $rootScope.token;
	        $scope.locale = $locale;
	
	        var models = {};
	
	        function setErrorMessage(contentKey, msgType) {
	            $scope.message = {
	                msgs: [$renderContent(contentKey)],
	                type: msgType
	            };
	        }
	
	        $populate(models, {
	            checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
	                contingencies: {
	                    NEED_CREDIT_CARD: angular.noop,
	                    EXPIRED_CREDIT_CARD: angular.noop,
	                    NEED_DEBIT_CARD: angular.noop,
	                    EXPIRED_DEBIT_CARD: angular.noop
	                }
	            })
	        }).then(function () {
	
	            if (models.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD') {
	                setErrorMessage('creditcard.errorUnconfirmedCard');
	            } else {
	                setErrorMessage('creditcard.errorExpiredCard', $stateParams.message === 'EXPIRED_DEBIT_CARD' ? 'error' : 'info');
	            }
	        });
	    }
	});
	
	angular.value("$xoUpdateCardPageComponent", $xoUpdateCardPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-update-card/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addCard updateCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-eConsent/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-eConsent/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoEConsentPageRoute', {
	
	    path: 'econsent',
	    directive: _directive2['default'],
	    titleContent: 'eConsent.title',
	
	    trackingData: {
	        fptiState: 'econsent',
	        templateName: 'eConsent.dust',
	        pageGoal: 'eConsent',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-econsent',
	                'pagename2': '%::fullpage-econsent:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	
	    children: []
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-eConsent/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/user/index.js");
	
	var _util = __webpack_require__("./pages/xo-login/util.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-title/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	var _template = __webpack_require__("./pages/xo-eConsent/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-eConsent/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Component.extend('$xoEConsentPageDirective', {
	
	    tag: 'xo-econsent-page',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	
	        success: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    resolve: {
	        models: function models() {
	
	            return {
	                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token),
	                eConsent: _index3.$EConsentModel.instance(),
	                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
	                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.locale = _index.$locale;
	        }
	    },
	
	    actions: {
	        submit: function submit() {
	            var _this = this;
	
	            var self = this;
	            return _angular.$q.all([this.models.eConsent.save({
	
	                batch: {
	                    name: 'econsent',
	                    id: 'accept'
	                }
	            }), this.models.checkoutSession.action('create', {
	
	                data: {
	                    baToken: this.models.checkoutCart.get('billing.ba_token'),
	                    preselected_fi_type: this.models.checkoutAppData.is_second_button_txn ? 'credit' : undefined
	                },
	
	                success: function success(result) {
	
	                    _logger.$logger.info('checkout_fpti', {
	                        from: 'CREATE_XO_SESSION',
	                        to: 'process_create_xo_session'
	                    });
	
	                    // consider negative balance first
	                    if (self.models.checkoutSession.negBals) {
	                        return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
	                    }
	
	                    // Handle routing to cape for second button
	                    if (self.models.checkoutAppData.is_second_button_txn) {
	                        return _util.$capeRedirectUtil.handleCapeRouting(result, self.props.token);
	                    }
	                },
	
	
	                batch: {
	                    name: 'econsent',
	                    id: 'createCheckout',
	                    dependencies: ['accept']
	                }
	            })]).then(function () {
	                if (!self.models.checkoutAppData.is_second_button_txn) {
	                    return _this.props.success();
	                }
	            });
	        }
	    }
	});
	
	
	_angular.$q;
	
	_logger.$logger;
	
	_index.$Component;
	
	_index.$locale;
	
	_index2.$CheckoutSessionModel;
	
	_index2.$CheckoutCartModel;
	
	_index2.$CheckoutAppDataModel;
	
	_index3.$EConsentModel;
	
	_util.$capeRedirectUtil;
	
	_uiRouter.$state;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-eConsent/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"eConsent\" id=\"eConsent\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <xo-title title-txt=\"{{content('eConsent.title')}}\"></xo-title>\n            <form name=\"eConsentForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\">\n                <p class=\"content\">{{content('eConsent.consent')}}</p>\n\n                <div class=\"agree checkbox legal\">\n                    <input ng-model=\"fields.agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" data-error-text=\"{{content('eConsent.eConsentError')}}\" xo-error-tooltip required />\n                    <label class=\"noBottom\" for=\"agree\" ng-bind-html=\"content('eConsent.agreement')\"></label>\n                </div>\n                <div class=\"buttons\">\n                    <input track-submit type=\"submit\" id=\"submitEConsent\" value=\"{{content('common.agreeAndContinue')}}\" class=\"btn full\" validate-submit=\"actions.submit()\" />\n                </div>\n            </form>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-eConsent/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-eConsent/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-eConsent/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#eConsent .content{line-height:1.35em}#eConsent .agree{position:relative}#eConsent label{line-height:1.2em}#eConsent .validated input[type=checkbox].ng-invalid+.errorTooltipRuleSpecific{width:300px;font-size:12px;top:30px;left:0;line-height:1.2em;width:275px}#eConsent .buttons{margin-top:20px}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-nbr/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-nbr/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoNbrDEPageRoute', {
	
	    path: 'negativeBalanceRecovery',
	    directive: _directive2['default'],
	    // titleContent: 'nbr.title',
	
	    // trackingData: {
	    //     fptiState: 'econsent',
	    //     templateName: 'eConsent.dust',
	    //     pageGoal: 'eConsent',
	    //     buzname: {
	    //         'fullpage': {
	    //             'pagename': '%::fullpage-econsent',
	    //             'pagename2': '%::fullpage-econsent:member:hermes:',
	    //             'version': 'member:%:'
	    //         }
	    //         // More page qualifiers come here...
	    //     }
	    // },
	
	    children: []
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-nbr/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _util = __webpack_require__("./pages/xo-login/util.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-title/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	var _template = __webpack_require__("./pages/xo-nbr/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-nbr/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoNbrDEPageDirective', {
	
	    tag: 'xo-nbr-page',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: false
	        },
	        isUnbranded: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            var props = this.props;
	
	            if (props.token) {
	                return {
	                    checkoutSession: _index.$CheckoutSessionModel.instance(props.token).retrieve({
	                        contingencies: {
	                            NEGATIVE_BALANCE_RECOVERY: _angular2['default'].noop,
	                            EXPIRED_CREDIT_CARD: _angular2['default'].noop
	                        }
	                    }),
	                    checkoutAppData: _index.$CheckoutAppDataModel.instance(props.token).retrieve()
	                };
	            }
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var self = this,
	                configUrls = _squid.$config.urls;
	
	            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
	            (0, _jquery2['default'])('.footerWrapper').addClass('nbr');
	
	            // this is only used by DE
	            self.nbrUrl = configUrls.nbrUrl;
	
	            // only invoked via DE view
	            self.meft = function (evt) {
	                evt.preventDefault();
	                // forward to negative legacy balance collection flow
	                _squid.$util.redirect(configUrls.nbrUrl);
	            };
	
	            self.resume = function (evt) {
	                var models = self.models;
	
	                evt.preventDefault();
	
	                // throw original contingency
	                if (models.checkoutSession.origContName) {
	                    throw new _squid.$Contingency(models.checkoutSession.origContName);
	                }
	
	                // consider CAPE scenario first
	                if (models.checkoutAppData.is_second_button_txn) {
	                    _util.$capeRedirectUtil.handleCapeRouting(models.checkoutSession, self.props.token);
	                } else {
	                    _uiRouter.$state.go('checkout.review');
	                }
	            };
	        },
	        exit: function exit() {
	            (0, _jquery2['default'])('.paypalHeaderWrapper').show();
	            (0, _jquery2['default'])('.footerWrapper').removeClass('nbr');
	        },
	        populate: function populate() {
	            var self = this,
	                checkoutSession = self.models.checkoutSession,
	                negBals = checkoutSession.negBals,
	                plan = checkoutSession.plan.sources && checkoutSession.plan.sources[0],
	                tokenHash = {
	                neg_bal: (0, _squid.formatCurrency)(negBals[0].amount, negBals[0].currency_code, false),
	                amt: plan && (0, _squid.formatCurrency)(plan.amount, plan.currency_code, false)
	            },
	                bodyContentKey = 'nbr.body',
	                preBankBtnKey = 'nbr.preBankBtn',
	                prePayBtnKey = 'nbr.prePayBtn';
	
	            if (negBals.length > 1) {
	                bodyContentKey += 'Plural';
	                preBankBtnKey += 'Plural';
	                tokenHash.neg_bal2 = (0, _squid.formatCurrency)(negBals[1].amount, negBals[1].currency_code, false);
	            }
	
	            if (!plan) {
	                prePayBtnKey += 'NoAmt';
	            }
	
	            self.bodyContentKey = bodyContentKey;
	            self.tokenHash = tokenHash;
	            self.isDE = _squid.$locale.metadata.country === 'DE';
	            self.prePayBtnKey = prePayBtnKey;
	            self.preBankBtnKey = preBankBtnKey;
	        }
	    }
	});
	
	_squid.formatCurrency;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$util;
	
	_squid.$config;
	
	_squid.$Contingency;
	
	_uiRouter.$state;
	
	_index.$CheckoutSessionModel;
	
	_index.$CheckoutAppDataModel;
	
	_util.$capeRedirectUtil;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-nbr/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"nbr\" content>\n    <div class=\"container\">\n        <div class=\"logo\" ng-if=\"!props.isUnbranded\"></div>\n        <div class=\"title\">\n            {{ content('nbr.title') }}\n        </div>\n        <div class=\"message\" ng-bind-html=\"content(bodyContentKey, tokenHash)\"></div>\n        <div ng-if=\"isDE\" class=\"actions message\">\n            <p class=\"bold\" ng-bind-html=\"content(prePayBtnKey, tokenHash)\"></p>\n            <button ng-click=\"resume($event)\" class=\"btn full\">\n                {{ content('nbr.payBtn') }}\n            </button>\n            <p class=\"small\">\n                {{ content('nbr.postPayBtn') }}\n            </p>\n            <p class=\"bold\" ng-bind-html=\"content(preBankBtnKey, tokenHash)\"></p>\n            <a href=\"{{nbrUrl}}\" ng-click=\"meft($event)\" class=\"btn full btn-secondary\">\n                {{ content('nbr.bankBtn') }}\n            </a>\n            <p class=\"small\">\n                {{ content('nbr.postBankBtn') }}\n            </p>\n        </div>\n        <p class=\"btn-spaced\" ng-if=\"!isDE\">\n            <button ng-click=\"resume($event)\" class=\"btn full\">\n                {{ content('nbr.payBtn') }}\n            </button>\n        </p>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-nbr/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-nbr/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-nbr/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}@media (min-width:41.3125em){section#nbr .container{width:400px}.nbr.footerWrapper{float:none;width:99.4%;padding:0 3px}.nbr.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#nbr{min-height:450px;display:table;margin:0 auto}section#nbr .container{position:relative;padding:0;display:table-cell;vertical-align:middle}section#nbr .title{font-size:1.5em;margin-bottom:15px;line-height:1.2}section#nbr .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#nbr .message .actions{padidng-top:.5em}section#nbr .message .bold{font-weight:700}section#nbr .message .small{margin:1em 0 2em;font-size:.85em}section#nbr .btn-spaced{padding-top:1em}section#nbr .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#nbr .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-framebust/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoFrameBustRoute = undefined;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-framebust/directive.js");
	
	var $xoFrameBustRoute = exports.$xoFrameBustRoute = _index.$Route.extend('$xoFrameBustRoute', {
	
	    path: 'framebust',
	    directive: _directive.$xoFrameBustPageDirective,
	
	    auth: false,
	
	    query: ['action', 'url'],
	
	    children: []
	});
	
	angular.value("$xoFrameBustRoute", $xoFrameBustRoute);
	_index.$Route;
	
	_directive.$xoFrameBustPageDirective;

/***/ },

/***/ "./pages/xo-framebust/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoFrameBustPageDirective = undefined;
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _icFallback = __webpack_require__("./js/lib/icFallback.js");
	
	var _template = __webpack_require__("./pages/xo-framebust/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-framebust/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoFrameBustPageDirective = exports.$xoFrameBustPageDirective = _index.$Component.extend('$xoFrameBustPageDirective', {
	
	    tag: 'xo-framebust-page',
	    template: _template2['default'],
	
	    props: {},
	
	    resolve: {},
	
	    actions: {
	        submit: function submit() {
	
	            window.paypalCheckout.hide();
	
	            var url = decodeURIComponent(_uiRouter.$stateParams.url);
	
	            if (_uiRouter.$stateParams.action === 'open') {
	
	                var props = window.paypalCheckout.props;
	
	                return window.ppxo.Checkout.renderPopupTo(window.top, {
	
	                    url: url,
	
	                    payment: props.payment,
	                    billingAgreement: props.billingAgreement,
	
	                    onAuthorize: props.onAuthorize,
	                    onCancel: props.onCancel
	
	                });
	            }
	
	            if (_uiRouter.$stateParams.action === 'fallback') {
	
	                var _props = window.paypalCheckout.props;
	
	                var component = window.ppxo.Checkout.init({
	
	                    url: url,
	
	                    payment: _props.payment,
	                    billingAgreement: _props.billingAgreement,
	
	                    onAuthorize: _props.onAuthorize,
	                    onCancel: _props.onCancel,
	
	                    dimensions: {
	                        width: 970,
	                        height: 850
	                    }
	                });
	
	                component.renderTo(window.top, null, 'popup');
	
	                (0, _icFallback.$incontextFallback)(component.window, url);
	            }
	        }
	    }
	});
	
	angular.value("$xoFrameBustPageDirective", $xoFrameBustPageDirective);
	_uiRouter.$stateParams;
	
	_index.$Component;
	
	_icFallback.$incontextFallback;

/***/ },

/***/ "./pages/xo-framebust/template.html":
/***/ function(module, exports) {

	module.exports = "<form content novalidate=\"novalidate\" autocomplete=\"off\">\n    <input type=\"submit\" value=\"{{ content('login.loginBtn') }}\" class=\"btn full loginBtn frameBustBtn\" ng-click=\"actions.submit()\" />\n</form>\n\n\n"

/***/ },

/***/ "./pages/xo-framebust/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-framebust/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-framebust/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".frameBustBtn{margin:20px auto!important}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-sepa/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SepaPageRoute = undefined;
	
	__webpack_require__("./pages/xo-sepa/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/member-sepa/route.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SepaPageRoute = exports.$SepaPageRoute = _squid.$ComponentRoute.extend('$SepaPageRoute', {
	
	    path: 'sepapage',
	    directive: 'xo-sepa-page',
	    titleContent: 'DEMemberGuest.sepaTitle',
	    query: ['message'],
	    trackingData: {
	        fptiState: 'membersepa',
	        templateName: 'membersepa.dust',
	        pageGoal: 'SEPA Review'
	    },
	    children: [{
	        name: '$MemberSepaRoute',
	        attributes: {
	            token: 'token',
	            'parent-callbacks': 'callbacks'
	        }
	    }]
	});
	
	angular.value("$SepaPageRoute", $SepaPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sepa/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSepaPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-sepa/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSepaPageComponent = exports.$xoSepaPageComponent = _squid.$Component.extend('$xoSepaPageComponent', {
	    tag: 'xo-sepa-page',
	    template: _template2['default'],
	
	    scope: {
	        token: '='
	    },
	
	    controller: function controller($scope, $state, $populate, $ReturnToMerchant, $CheckoutAppDataModel, $CheckoutSessionModel) {
	        $scope.callbacks = {
	            success: function success(sepaModel) {
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(function () {
	                    return sepaModel.action('clearSepa', {
	
	                        data: {
	                            bank: {
	                                id: sepaModel.bankId
	                            },
	                            token: $scope.token
	                        },
	
	                        success: function success() {
	                            $scope.checkoutSession.action('authorize', {
	                                success: function success() {
	                                    $state.go('checkout.end');
	                                }
	
	                            });
	                        }
	
	                    });
	                });
	            }
	        };
	        $state.go('checkout.sepapage.membersepa.sepaAgreement');
	    }
	
	});
	
	angular.value("$xoSepaPageComponent", $xoSepaPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sepa/template.html":
/***/ function(module, exports) {

	module.exports = "<ui-view></ui-view>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/member-sepa/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/member-sepa/directive.js"), __webpack_require__("./components/xo-wallet-components/src/member-sepa/sepaAgreement/route.js"), __webpack_require__("./components/xo-wallet-components/src/member-sepa/sepaMandate/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-member-sepa.route', ['squid', 'xo-member-sepa.directive', 'xo-member-sepa.sepaAgreement.route', 'xo-member-sepa.sepaMandate.route']).factory('$MemberSepaRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('MemberSepaRoute', {
	
	            name: 'membersepa',
	
	            directive: 'xo-member-sepa',
	            titleContent: 'directDebitAgreement.sepaTitle',
	
	            children: [{
	                name: '$XOSepaAgreementRoute',
	                attributes: {
	                    token: 'token',
	                    sepa: 'sepa',
	                    'parent-callbacks': 'callbacks'
	                }
	            }, {
	                name: '$XOSepaMandateRoute',
	                attributes: {
	                    token: 'token',
	                    sepa: 'sepa',
	                    'parent-callbacks': 'callbacks'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/member-sepa", "components/xo-wallet-components/src/member-sepa/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/member-sepa/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/member-sepa/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    return squid.module('xo-member-sepa.directive', ['squid', 'xomodel.checkout', 'xomodel.fi']).directive('xoMemberSepa', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '='
	            },
	
	            controller: function controller($scope, $CheckoutAppDataModel, $CheckoutSessionModel, $SepaModel, $populate, $rootScope) {
	
	                $scope.sepa = $SepaModel.instance({ id: 123 });
	
	                $scope.callbacks = {
	                    sepaAccept: function sepaAccept() {
	
	                        $populate($scope, {
	                            checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                            checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                        }).then(function () {
	                            $rootScope.$emit('loading');
	                            $scope.sepa.action('sepaAccept', {
	                                data: {
	                                    bank: {
	                                        id: $scope.sepa.bankId
	                                    }
	                                },
	                                success: function success() {
	                                    $scope.parentCallbacks.success($scope.sepa);
	                                }
	                            });
	                        });
	                    }
	
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/member-sepa/template.html":
"./pages/xo-sepa/template.html",

/***/ "./components/xo-wallet-components/src/member-sepa/sepaAgreement/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/member-sepa/sepaAgreement/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-member-sepa.sepaAgreement.route', ['squid', 'xo-member-sepa.sepaAgreement.directive']).factory('$XOSepaAgreementRoute', function ($ComponentRoute) {
	        return $ComponentRoute.extend('XOSepaAgreementRoute', {
	            name: 'sepaAgreement',
	
	            directive: 'xo-sepa-agreement',
	            titleContent: 'directDebitAgreement.sepaTitle',
	
	            trackingData: {
	                fptiState: 'sepa_agreement'
	            },
	
	            loginRequired: true,
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/member-sepa/sepaAgreement", "components/xo-wallet-components/src/member-sepa/sepaAgreement/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/member-sepa/sepaAgreement/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/member-sepa/sepaAgreement/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-member-sepa.sepaAgreement.directive', ['squid', 'xomodel.checkout', 'xomodel.fi']).directive('xoSepaAgreement', function ($rootScope) {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                sepa: '=',
	                parentCallbacks: '='
	            },
	
	            controller: function controller($scope, $CheckoutSessionModel, $SepaModel, $populate) {
	
	                $('body').addClass('pageSepaAgreementContingency');
	
	                $scope.$on('$destroy', function () {
	                    $('body').removeClass('pageSepaAgreementContingency');
	                });
	
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(function () {
	                    $scope.sepa.bankId = $scope.checkoutSession.sepa_mandate.bankId;
	                    $scope.sepa.action('sepaDirectMandate', {
	                        resultModel: $scope.sepa,
	
	                        data: {
	                            bank: {
	                                id: $scope.sepa.bankId
	                            }
	                        },
	
	                        success: function success() {
	                            $scope.onSubmit = function () {
	                                $scope.parentCallbacks.sepaAccept();
	                            };
	                        }
	                    });
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/member-sepa/sepaAgreement/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"sepaAgreementContingency\" content>\n    <div class=\"row-fluid\">\n        <div class=\"centerTray\">\n            <div class=\"trayInner trayInnerDefault loggingIn\">\n                <form ng-submit=\"onSubmit()\" method=\"post\" class=\"proceed ddAgreementForm\" id=\"payment_form\" novalidate>\n                    <h2 class=\"zeta\">{{content('directDebitAgreement.sepaTitle')}}</h2>\n\n                    <p ng-bind-html =\"content('directDebitAgreement.ddAgreementPara1')\"></p>\n                    <p>\n\n                        <span\n                                bind-html-compile=\"htmlContent('directDebitAgreement.ddAgreementPara2',{bankName:sepa.bank.bank_name, bankNumber:sepa.bank.bank_id, href: '^.sepaMandate'})\">\n                        </span>\n\n                    </p>\n\n                    <div class=\"buttons\">\n                        <input track-submit ng-if=\"model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndPay')}}\"  class=\"btn\" />\n                        <input track-submit ng-if=\"!model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndContinue')}}\" class=\"btn\" />\n                    </div>\n                </form>\n            </div>\n        </div>\n\n    </div>\n</section>\n\n"

/***/ },

/***/ "./components/xo-wallet-components/src/member-sepa/sepaMandate/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/member-sepa/sepaMandate/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-member-sepa.sepaMandate.route', ['squid', 'xo-member-sepa.sepaMandate.directive']).factory('$XOSepaMandateRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('XOSepaMandateRoute', {
	            name: 'sepaMandate',
	
	            directive: 'xo-sepa-mandate',
	            titleContent: 'directDebitAgreement.ddFullAgreementTitle',
	
	            trackingData: {
	                fptiState: 'sepa_mandate'
	            },
	
	            loginRequired: true,
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/member-sepa/sepaMandate", "components/xo-wallet-components/src/member-sepa/sepaMandate/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/member-sepa/sepaMandate/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/member-sepa/sepaMandate/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-member-sepa.sepaMandate.directive', ['squid']).directive('xoSepaMandate', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                sepa: '=',
	                parentCallbacks: '='
	            },
	
	            controller: function controller($scope) {
	                $('body').addClass('pageSepaMandateContingency');
	
	                $scope.$on('$destroy', function () {
	                    $('body').removeClass('pageSepaMandateContingency');
	                });
	
	                $scope.onSubmit = function () {
	                    $scope.parentCallbacks.sepaAccept();
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/member-sepa/sepaMandate/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"sepaMandateContingency\" content>\n    <div class=\"row-fluid\">\n        <div class=\"centerTray\">\n            <div class=\"trayInner trayInnerDefault loggingIn\">\n                <form ng-submit=\"onSubmit()\" method=\"post\" class=\"proceed\" id=\"payment_form\" novalidate>\n                    <h2 class=\"zeta\">{{content('directDebitAgreement.ddFullAgreementTitle')}}</h2>\n                    <p>{{content('DEMemberGuest.ddAgreementPara1')}}</p>\n                    <div class=\"row-fluid sepaInfo\">\n                        <div class=\"span\">\n                            <strong>{{content('DEMemberGuest.accountCarrier')}}</strong>\n                            <p>\n                                <span>{{sepa.user.name}}</span>\n                                <br/>{{sepa.user.address.line1}}\n                                <br/>{{sepa.user.address.line2}}\n                                <br/> {{sepa.user.address.city}}, {{sepa.user.address.postal_code}}\n                                <br/>{{sepa.user.address.country}}\n                            </p>\n                        </div>\n                        <div class=\"span bankDetails\">\n                            <p>\n                                <strong>{{content('DEMemberGuest.IBAN')}}</strong>\n                            </p>\n                            {{sepa.bank.iban_number}}\n                            <p class=\"marginTop\">\n                                <strong>{{content('DEMemberGuest.bankName')}}</strong>\n                            </p>\n                            {{sepa.bank.bank_name}}\n                            <p class=\"marginTop\">\n                                <strong>{{content('DEMemberGuest.bic')}}</strong>\n                            </p>\n                            {{sepa.bank.bic}}\n                        </div>\n                        <div class=\"span\">\n                            <p>\n                                <strong>{{content('DEMemberGuest.creditor')}}</strong>\n                            </p>\n                            {{sepa.creditor.name}}\n                            <p></p>\n                            <div class=\"adr\">\n                                <div class=\"confidential streets street-address darker\">\n                                    {{sepa.creditor.address.line1}}\n                                </div>\n\n                            <div class=\"confidential\">\n                                <span class=\"postal-code\">{{sepa.creditor.address.postal_code}}</span>\n                                <span class=\"locality\">{{sepa.creditor.address.country}}</span>\n                            </div>\n                            </div>\n                            <p></p>\n                            <p class=\"marginTop\">\n                                <strong>{{content('DEMemberGuest.creditorId')}}</strong>\n                            </p>\n                            {{sepa.creditor.id}}\n                        </div>\n                    </div>\n                    <p>\n                        <span ng-if=\"model.useraction.commit\" ng-bind-html=\"htmlContent('directDebitAgreement.ddAgreementPara2AcceptPay')\"></span>\n                        <span ng-if=\"!model.useraction.commit\" ng-bind-html=\"htmlContent('directDebitAgreement.ddAgreementPara2AcceptContinue')\"></span>\n                    </p>\n                    <p class=\"dateLocationMarker\">{{sepa.date}},{{sepa.user.address.city}},{{content('countryList.DE')}}</p>\n                    <div class=\"buttons\">\n                        <input track-submit ng-if=\"model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndPay')}}\"  class=\"btn\" />\n                        <input track-submit ng-if=\"!model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndContinue')}}\" class=\"btn\" />\n                    </div>\n                </form>\n            </div>\n        </div>\n\n    </div>\n</section>\n\n"

/***/ },

/***/ "./pages/xo-end/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$EndRoute = undefined;
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	var _returnParams = __webpack_require__("./components/xo-page-components/src/returnParams/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $EndRoute = exports.$EndRoute = _squid.$ComponentRoute.extend('EndRoute', {
	
	    path: 'end',
	
	    trackingData: {
	        fptiState: 'back_to_merchant',
	        trackStateExit: true
	    },
	
	    resolve: {
	        action: function action($q, $window, $util, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutSessionModel, $ReturnToMerchant, $rootScope, $populate, $MerchantPreferenceModel, $CheckoutPayeeModel, $unresolved) {
	
	            function returnMethod(merchantPreferences) {
	                if ($rootScope.wps && merchantPreferences) {
	                    return merchantPreferences.returnMethod();
	                } else {
	                    return 'GET';
	                }
	            }
	
	            function returnUrl(checkoutAppData, merchantPreferences) {
	                // When "redirect_uri" is passed as a query param
	                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
	                    return $util.param('redirect_uri');
	                }
	
	                // WPS
	                if ($rootScope.wps && merchantPreferences) {
	                    return checkoutAppData.urls.return_url || merchantPreferences.returnUrl();
	                }
	
	                // By default, use return_uri from checkout session
	                return checkoutAppData.urls.return_url;
	            }
	
	            function returnParams(checkoutCart, checkoutSession, checkoutAppData, returnToMerchantMethod) {
	
	                var params = {};
	
	                // When "redirect_uri" is passed as a query param
	                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
	                    params.return_uri = checkoutAppData.urls.return_url;
	                    params.opType = 'payment';
	                    params.token = $rootScope.token;
	                }
	
	                // Don't post PayerID for RT without purchase OR WPS
	                if (!$rootScope.wps && !checkoutCart.isBillingNoPurchase()) {
	                    params.PayerID = checkoutSession.payer.id;
	                }
	
	                var billingData = checkoutCart.billing;
	
	                if (billingData && billingData.ba_token && !checkoutAppData.legacy_billing_integration) {
	                    params.ba_token = billingData.ba_token;
	                }
	
	                if ($rootScope.wps) {
	                    var isCartUpload = checkoutAppData.flags.is_cart_upload_flow || checkoutAppData.flags.is_shopping_cart_flow;
	                    params = (0, _returnParams.$returnParams)(checkoutCart, checkoutSession, returnToMerchantMethod, 'WPS', isCartUpload);
	                }
	
	                return params;
	            }
	
	            function getMerchantPreferences(dataModel) {
	                if ($rootScope.wps) {
	                    return $populate(dataModel, {
	                        merchantPreferences: $MerchantPreferenceModel.instance(dataModel.payee.merchant.id)
	                    });
	                } else {
	                    return $q.when();
	                }
	            }
	
	            function setMerchantCharSet(merchantPreferences, params) {
	                params.charset = merchantPreferences && merchantPreferences.charSet();
	            }
	
	            var models = {};
	
	            return $populate(models, {
	                checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
	                checkoutCart: $CheckoutCartModel.instance($rootScope.token),
	                checkoutSession: $CheckoutSessionModel.instance($rootScope.token),
	                payee: $CheckoutPayeeModel.instance($rootScope.token)
	            }).then(function () {
	                return getMerchantPreferences(models);
	            }).then(function () {
	                var url = returnUrl(models.checkoutAppData, models.merchantPreferences);
	                var returnToMerchantMethod = returnMethod(models.merchantPreferences);
	                var params = returnParams(models.checkoutCart, models.checkoutSession, models.checkoutAppData, returnToMerchantMethod);
	
	                // check for merchant charset only for wps
	                if ($rootScope.wps) {
	                    setMerchantCharSet(models.merchantPreferences, params);
	                }
	
	                if (returnToMerchantMethod === 'POST') {
	                    $ReturnToMerchant.postTo(url, params);
	                } else {
	                    // if PDT is disabled don't send params in the url
	                    if (models.merchantPreferences && !models.merchantPreferences.pdtEnabled()) {
	                        return $ReturnToMerchant.goTo(url);
	                    }
	                    $ReturnToMerchant.goTo($util.buildURL(url, params));
	                }
	
	                return $unresolved;
	            });
	        }
	    }
	});
	
	angular.value("$EndRoute", $EndRoute);
	_returnParams.$returnParams;
	
	_squid.$ComponentRoute;
	
	_squid.$integration;

/***/ },

/***/ "./components/xo-page-components/src/returnParams/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var addValidParam = __webpack_require__("./components/xo-page-components/src/utils/index.js").addValidParam;
	
	function returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow) {
	    var params = {};
	    var customData = checkoutCart.get('purchase.custom');
	
	    if (returnToMerchantMethod === 'POST') {
	        var invoice = checkoutCart.get('purchase.invoice');
	        // TODO: find out why we get postbackData as undefined
	        // UPDATE: couldn't reproduce an issue on the stage for now
	        if (checkoutSession.postbackData) {
	            params = checkoutSession.postbackData;
	        }
	        addValidParam(params, 'custom', customData);
	        addValidParam(params, 'invoice', invoice);
	    } else {
	        var transactionDetail = checkoutSession.transactionDetails;
	
	        if (transactionDetail) {
	            addValidParam(params, 'tx', transactionDetail.id);
	            addValidParam(params, 'st', transactionDetail.state);
	
	            if (transactionDetail.amount) {
	                addValidParam(params, 'amt', transactionDetail.amount.total);
	                addValidParam(params, 'cc', transactionDetail.amount.currency);
	            }
	        }
	
	        // Cart uploads can have more than one item so we don't add any in return URL
	        if (!is_cart_upload_flow) {
	            var itemDetail = checkoutSession.get('itemsList.0');
	            if (itemDetail) {
	                addValidParam(params, 'item_name', itemDetail.name);
	                addValidParam(params, 'item_number', itemDetail.sku);
	            }
	        }
	
	        addValidParam(params, 'cm', customData);
	    }
	    return params;
	}
	
	/**
	 * this API function is used by hermesnodeweb/public/pages/xo-end and xoonboardingnodeweb/public/pages/xo-end
	 * Create params to return back to the merchant after clicking on "Return to merchant" on the Done page.
	 * buy-now and cart-upload params are slightly different: given cart-upload might have multiple items,
	 * we don't add the item name/number for cart-uploads.
	 *
	 * Example of returned params for GET method:
	 * {
	 *    amt: "16.00"
	 *    cc: "USD"
	 *    cm: "WPS IS @ WEIRD"
	 *    item_name: "Mango # Shake"
	 *    item_number: "2211335544"
	 *    st: "Completed"
	 *    tx: "2DD97043CY7805945"
	 * }
	 * Example of returned params for POST method:
	 * {
	 *    custom: "WPS IS @ WEIRD"
	 *    invoice: "MyInvoiceID"
	 * }
	 * @param {Object (angular model)} cart model
	 * @param {Object (angular model)} session model
	 * @param {String} http method, either "POST" or "GET"
	 * @param {String} feature type (WPS only for now)
	 * @param {Boolean} flag that indicates if it's a cart upload or not
	 * @returns {object} params to pass back to the merchant
	*/
	module.exports = {
	    $returnParams: function $returnParams(checkoutCart, checkoutSession, returnToMerchantMethod, feature, is_cart_upload_flow) {
	        if (feature === 'WPS') {
	            return returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow);
	        }
	        return {};
	    }
	};

/***/ },

/***/ "./components/xo-page-components/src/utils/index.js":
/***/ function(module, exports) {

	
	
	/* eslint-disable angular/typecheck-string */
	
	/**
	 * add non empty key, value to the object
	 * @param {Object} object where to add new key, value
	 * @param {String} key
	 * @param {Any type} value, can not be empty
	 * @returns {void}
	*/
	
	module.exports = {
	    addValidParam: function addValidParam(obj, key, val) {
	        if (!obj) {
	            return;
	        }
	        if (typeof key === 'string' && key && val !== undefined && val !== null) {
	            obj[key] = val;
	        }
	    }
	};

/***/ },

/***/ "./components/xo-login-components/src/fullpage-onetouch-upsell/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-login-components/src/fullpage-onetouch-upsell/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-fullpage-onetouch-upsell.route', ['squid', 'xo-fullpage-onetouch-upsell.directive']).factory('$FullpageOnetouchUpsellRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('FullpageOnetouchUpsellRoute', {
	
	            name: 'FullpageOnetouchUpsell',
	            directive: 'xo-fullpage-onetouch-upsell',
	            trackingData: {},
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/fullpage-onetouch-upsell", "components/xo-login-components/src/fullpage-onetouch-upsell/route.js"))

/***/ },

/***/ "./components/xo-login-components/src/fullpage-onetouch-upsell/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/fullpage-onetouch-upsell/template.html"), __webpack_require__("./components/xo-tracking/dist/index.js"), __webpack_require__("./components/ul-inline/dist/inject.js"), __webpack_require__("./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-fullpage-onetouch-upsell.directive', ['squid', 'xolocale', 'tracking', 'xo-device-info']).directive('xoFullpageOnetouchUpsell', function () {
	
	        return {
	            template: template,
	            scope: {
	                token: '='
	            },
	            controller: function controller($scope, $rootScope, $state, $element, $timeout, $logger, $LocaleModel, $locale, $CalDataModel, $config, $meta, $KmliUpsell, $DeviceInfo) {
	
	                $scope.locale = $LocaleModel.instance();
	                $scope.disableCloseButton = $DeviceInfo.isDevice();
	                var ulMeta = $config.ulMeta || {};
	                var PAYPAL = window.PAYPAL || {};
	                var ulTimeOutValue = 5000;
	                var ulTimeoutPromise = null;
	                var styleSet = false;
	
	                var fptiData = $KmliUpsell.getFPTIAttributes();
	
	                function deInitStyles() {
	                    $('#paypalLogo').show();
	                    $('.footer').show();
	                    $('.paypalHeaderWrapper.span14').attr('style', '');
	                    $('.row-fluid.paypalHeaderWrapper').show();
	                }
	
	                function closeInterstitial() {
	                    deInitStyles();
	                    $state.go('checkout.review');
	                }
	
	                function failureHandler(reason) {
	                    $logger.info('KMLI_UPSELL_error_' + reason);
	                    closeInterstitial();
	                }
	
	                var startTimerTS;
	                function startTimer(tag) {
	                    startTimerTS = Date.now();
	                    $logger.info('KMLI_UPSELL_START_TIMER_' + tag, {
	                        startTime: startTimerTS
	                    });
	
	                    $logger.info('checkout_fpti', {
	                        'from': 'Interstitial_Timer',
	                        'to': 'prepare_' + tag
	                    });
	
	                    ulTimeoutPromise = $timeout(function () {
	                        var stop_time = Date.now();
	                        var time_taken = stop_time - startTimerTS;
	                        $logger.info('checkout_fpti', {
	                            'from': 'Interstitial_Timer',
	                            'to': 'process_timeout',
	                            'int_error_code': 'ULLOGIN_TIMEOUT',
	                            'int_error_description': 'ULLOGIN_TIMEOUT',
	                            'error_source': 'unifiedloginnodeweb',
	                            'error_type': 'soft_decline',
	                            'page_load_time': time_taken
	                        });
	                        failureHandler('timedout');
	                        $rootScope.$emit('loaded');
	                    }, ulTimeOutValue);
	                }
	
	                function stopTimer(tag) {
	                    var stopTimerTS = Date.now();
	                    var timeTaken = stopTimerTS - startTimerTS;
	                    $logger.info('KMLI_UPSELL_STOP_TIMER_' + tag, {
	                        stopTimer: stopTimerTS,
	                        page_load_time: timeTaken
	                    });
	
	                    $logger.info('checkout_fpti', {
	                        'from': 'Interstitial_Timer',
	                        'to': 'process_' + tag,
	                        'page_load_time': timeTaken
	                    });
	
	                    if (ulTimeoutPromise) {
	                        $timeout.cancel(ulTimeoutPromise);
	                    }
	                }
	
	                function logSubmit(data) {
	                    var fptiPayload = {
	                        'from': fptiData.stateName,
	                        'to': 'process' + fptiData.transInfix + 'optin'
	                    };
	                    if (data && data.errorCode) {
	                        angular.extend(fptiPayload, {
	                            'int_error_code': data.errorCode,
	                            'error_type': 'hard_decline',
	                            'error_source': 'unifiedloginnodeweb'
	                        });
	                    }
	                    $logger.info('checkout_fpti', fptiPayload);
	                }
	
	                $scope.$on('$locationChangeStart', function (event, next, current) {
	                    if (styleSet) {
	                        deInitStyles();
	                    }
	                });
	
	                $scope.hideModal = function (event) {
	                    if (event) {
	                        event.preventDefault();
	                    }
	
	                    $logger.info('checkout_fpti', {
	                        'from': fptiData.stateName,
	                        'to': 'process' + fptiData.transInfix + 'decline',
	                        'click_source': 'close_button'
	                    });
	
	                    closeInterstitial();
	                };
	
	                var ulEventHandlers = {
	                    'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        $('#paypalLogo').hide();
	                        $('.footer').hide();
	                        $('.paypalHeaderWrapper.span14').attr('style', 'border:none;');
	                        $('.row-fluid.paypalHeaderWrapper').hide();
	                        styleSet = true;
	                    },
	                    'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
	                        $rootScope.$emit('loading');
	                        startTimer(data.event);
	                    },
	                    'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        logSubmit();
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        logSubmit({ errorCode: data.event });
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
	                        stopTimer(data.event);
	                        logSubmit({ errorCode: data.event });
	                        $rootScope.$emit('loaded');
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInNotNowClicked': function oneTouchInterstitialOptInNotNowClicked(data) {
	                        $logger.info('checkout_fpti', {
	                            'from': fptiData.stateName,
	                            'to': 'process' + fptiData.transInfix + 'decline',
	                            'click_source': 'not_now_link'
	                        });
	                        closeInterstitial(data);
	                    }
	                };
	
	                function postMessageHandler(response) {
	                    $timeout(function () {
	                        $logger.info('ul_postmessaged_received', response);
	                        var data = response.data || response.error;
	                        var eventId = data && data.event;
	                        if (eventId) {
	                            $logger.debug('KMLI_UPSELL_' + eventId, response);
	                            var handler = ulEventHandlers[eventId];
	                            if (handler) {
	                                handler(data);
	                            }
	                        }
	                    });
	                }
	
	                function loadOneTouchUpsell() {
	                    $rootScope.$emit('loading');
	                    var options = {
	                        targetElement: document.getElementById('injectedOneTouchInterstitial'),
	                        queryParams: {
	                            'stsRedirectUri': ulMeta.stsReturnUrl,
	                            'country.x': $scope.locale.country,
	                            'locale.x': $scope.locale.getLocaleCode(),
	                            'flowId': $scope.token,
	                            'correlationId': $CalDataModel.getCalCorrId(),
	                            'flowName': 'checkout'
	                        },
	                        iframePathname: '/signin/activate-one-touch',
	                        onPostMessage: postMessageHandler
	                    };
	
	                    angular.extend(options.queryParams, $KmliUpsell.getOptions());
	
	                    if ($config.deploy.isLocal()) {
	                        options.origin = 'https://' + $meta.stage;
	                    }
	
	                    if (PAYPAL && PAYPAL.unifiedLogin) {
	                        startTimer('initializeUpsell');
	                        PAYPAL.unifiedLogin.inject(options);
	                    } else {
	                        failureHandler('PAYPAL.unifiedLogin_undefined');
	                    }
	                }
	
	                loadOneTouchUpsell();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/fullpage-onetouch-upsell/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\">\n    <a class=\"close\" href=\"#\" title=\"Close\" ng-click=\"hideModal($event)\"></a>\n    <div id=\"injectedOneTouchInterstitial\">\n    </div>\n</div>\n<div class=\"pushLogo\"></div>\n<div class=\"logo\"></div>\n\n"

/***/ },

/***/ "./pages/xo-create-password/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-create-password/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	var _route = __webpack_require__("./components/xo-login-components/src/password-recovery-overlay/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Route.extend('$xoPageCreatePasswordRoute', {
	    path: 'createPassword',
	    directive: _directive2['default'],
	    trackingData: {
	        fptiState: 'quick_security_check'
	    },
	    params: {
	        targetPage: null
	    },
	    children: [{
	        route: _route2['default'],
	        props: function props() {
	            var _this = this;
	
	            return {
	                token: this.token,
	                cancel: function cancel() {
	                    return _this.goto('^');
	                },
	                success: function success() {
	                    return _this.goto('checkout.login');
	                }
	            };
	        }
	    }]
	});
	
	
	_squid.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-create-password/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-login-components/src/create-password/directive.js");
	
	__webpack_require__("./pages/xo-create-password/styles.less");
	
	var _template = __webpack_require__("./pages/xo-create-password/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoPageCreatePasswordDirective', {
	    tag: 'xo-page-create-password',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.auth = _auth.$AuthModel.instance();
	            this.reason = _uiRouter.$stateParams.targetPage;
	            this.onContinue = function () {
	                return _this.goto('.passwordRecovery');
	            };
	
	            this.logout = function () {
	                _logger.$logger.info('not_you_logout');
	                _this.auth.action('logout').then(function () {
	                    _this.goto('checkout.login', {
	                        source: 'NOT_YOU'
	                    });
	                });
	            };
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_uiRouter.$stateParams;
	
	_auth.$AuthModel;
	
	_logger.$logger;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-login-components/src/create-password/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-login-components/src/create-password/styles.less");
	
	var _template = __webpack_require__("./components/xo-login-components/src/create-password/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CONTENT_KEY_MAP = {
	    ADD_CARD: {
	        benefitsKey: 'passwordRecovery.stepUpBenefits',
	        reasonKey: 'passwordRecovery.stepUpAddCard'
	    },
	    ADD_SHIPPING: {
	        benefitsKey: 'passwordRecovery.stepUpBenefits',
	        reasonKey: 'passwordRecovery.stepUpAddShipping'
	    },
	    APPLY_PPC: {
	        benefitsKey: 'passwordRecovery.stepUpApplyPPCBenefits',
	        reasonKey: 'passwordRecovery.stepUpApplyPPC'
	    },
	    GENERIC: {
	        benefitsKey: 'passwordRecovery.stepUpGenericBenefits',
	        reasonKey: 'passwordRecovery.stepUpGeneric'
	    },
	    NEW_PHONE: {
	        reasonKey: 'passwordRecovery.stepUpNewPhone'
	    },
	    NEED_US_ADDRESS: {
	        reasonKey: 'passwordRecovery.stepUpNeedUSAddress'
	    },
	    CARD_EXPIRED: {
	        reasonKey: 'passwordRecovery.stepUpCardExpired'
	    },
	    MERCHANT_NOT_ACCEPT_AMEX: {
	        reasonKey: 'passwordRecovery.stepUpMerchantNotAcceptAmex'
	    },
	    NEED_CREDIT_CARD: {
	        reasonKey: 'passwordRecovery.stepUpContigencyAddCard'
	    },
	    PAYER_AUTHENTICATION_REQUIRED: {
	        reasonKey: 'passwordRecovery.stepUpNewAddress'
	    },
	    BILLING_AGREEMENTS: {
	        reasonKey: 'passwordRecovery.stepUpBillingAgreements'
	    },
	    GENERIC_CONTINGENCY: {
	        reasonKey: 'passwordRecovery.stepUpContigencyGeneric'
	    }
	};
	
	exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryLandingDirective', {
	    tag: 'xo-create-password',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        },
	        onContinue: {
	            type: 'var'
	        },
	        onCancel: {
	            type: 'var',
	            required: false
	        },
	        reason: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.contingencyName = this.reason && _squid.$util.camelToCapsUnderscore(this.reason) || 'GENERIC';
	            this.getReasonKey = function () {
	                return (CONTENT_KEY_MAP[_this.contingencyName] || CONTENT_KEY_MAP['GENERIC']).reasonKey;
	            };
	
	            this.getBenefitsKey = function () {
	                return (CONTENT_KEY_MAP[_this.contingencyName] || CONTENT_KEY_MAP['GENERIC']).benefitsKey;
	            };
	            this.onSubmit = function () {
	                _logger.$logger.info('checkout_fpti', {
	                    from: 'quick_security_check',
	                    to: 'process_quick_security_check'
	                });
	                _this.onContinue();
	            };
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$util;
	
	_logger.$logger;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-login-components/src/create-password/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-login-components/src/create-password/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-login-components/src/create-password/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#createPassword .heading{padding:5px 0 10px;font-size:1.6em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}#createPassword .msg{padding-top:10px}#createPassword .continueBtn{margin:10px 0}#createPassword .cancelLink{width:100%;text-align:center;padding-top:10px}#createPassword .cancelLink a{cursor:pointer}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#createPassword{padding-top:40px}}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-login-components/src/create-password/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"createPassword\" content>\n    <div class=\"heading\">{{content('passwordRecovery.quickSecurityCheck')}}</div>\n\n    <div class=\"msg\">{{content(getReasonKey())}}</div>\n\n    <div class=\"msg\">{{content(getBenefitsKey())}}</div>\n\n    <button class=\"btn full continueBtn\" ng-click=\"onSubmit()\">{{content('common.continueLabel')}}</button>\n    <div ng-if=\"onCancel\" class=\"cancelLink\"><a ng-click=\"onCancel($event)\">{{content('common.cancel')}}</a></div>\n</section>\n"

/***/ },

/***/ "./pages/xo-create-password/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-create-password/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-create-password/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#createPasswordPage .userEmail{margin:15px 0}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-create-password/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"createPasswordPage\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('memberReview.welcomeBack', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <xo-create-password token=\"token\" reason=\"reason\" on-continue=\"onContinue\"></xo-create-password>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ },

/***/ "./components/xo-login-components/src/password-recovery-overlay/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./components/xo-login-components/src/password-recovery-overlay/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Route.extend('$xoPasswordRecoveryOverlayRoute', {
	    path: 'passwordRecovery',
	    directive: _directive2['default'],
	    trackingData: {
	        fptiState: 'password_recovery'
	    },
	    children: []
	});
	
	
	_squid.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-login-components/src/password-recovery-overlay/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _template = __webpack_require__("./components/xo-login-components/src/password-recovery-overlay/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryOverlayDirective', {
	    tag: 'xo-password-recovery-overlay',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        },
	        cancel: {
	            type: 'var'
	        },
	        success: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            var auth = _auth.$AuthModel.instance();
	
	            _angular.$rootScope.$emit('loading');
	
	            var hideOverlay = function hideOverlay(callback) {
	                $('#wrapper #spinner').attr('style', '');
	                _this.$element.removeClass('overlayOpen');
	                (0, _angular.$timeout)(function () {
	                    return callback();
	                }, 300);
	            };
	
	            this.hideModal = function (event) {
	                event.preventDefault();
	                hideOverlay(auth.password_less ? _this.cancel : _this.success);
	            };
	
	            this.onPasswordRecoveryReady = function () {
	                (0, _angular.$timeout)(function () {
	                    _angular.$rootScope.$emit('loaded');
	                    _this.$element.addClass('overlayOpen');
	                });
	            };
	
	            this.onContinue = function () {
	                hideOverlay(_this.success);
	            };
	
	            this.onPasswordRecovery = function () {
	                auth.password_less = false;
	            };
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_angular.$rootScope;
	
	_angular.$timeout;
	
	_auth.$AuthModel;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-login-components/src/password-recovery-overlay/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"pwrOverlay\" ng-class=\"{mobile: isDevice}\">\n    <div class=\"overlayMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <xo-spinner></xo-spinner>\n            <div class=\"aside\">\n                <a track-link=\"user_cancel\" class=\"close\" href=\"#\" ng-click=\"hideModal($event)\"></a>\n                <section id=\"pwrOverlay\">\n                    <xo-password-recovery token=\"token\" on-password-recovery=\"onPasswordRecovery\" on-load=\"onPasswordRecoveryReady\" on-continue=\"onContinue\"></xo-password-recovery>\n                </section>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-tokenization-info/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-tokenization-info/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoTokenizationInfoPageRoute', {
	    path: 'tokenizationInfo',
	    directive: _directive2['default'],
	    titleContent: 'Tokenization Info Page',
	    trackingData: {
	        fptiState: 'tokenizationInfo'
	    },
	
	    children: []
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-tokenization-info/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _template = __webpack_require__("./pages/xo-tokenization-info/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-tokenization-info/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoTokenizationInfoPageDirective', {
	    tag: 'xo-tokenization-info',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        }
	    },
	
	    actions: {
	        logout: function logout() {
	            var _this = this;
	
	            this.auth.action('logout').then(function () {
	                _logger.$logger.info('tokenized_wallet', {
	                    'from': 'PP_AndroidPay_Info',
	                    'to': 'process_PP_AndroidPay_Info',
	                    'context_id': _this.props.token,
	                    'context_type': 'EC-Token'
	                });
	                _uiRouter.$state.go('checkout.login', {
	                    source: 'NOT_YOU'
	                });
	            });
	        },
	        'continue': function _continue() {
	            _logger.$logger.info('tokenized_wallet', {
	                'from': 'PP_AndroidPay_Info',
	                'to': 'process_PP_AndroidPay_Info',
	                'context_id': this.props.token,
	                'context_type': 'EC-Token'
	            });
	            _uiRouter.$state.go('checkout.review');
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.auth = _auth.$AuthModel.instance();
	            this.showNotYou = this.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp' && !_squid.$util.param('redirectToHermesOn3DSDecline');
	            this.userName = (0, _squid.formatNameInformal)({
	                first_name: this.auth.first_name,
	                last_name: this.auth.last_name
	            }) || this.auth.email;
	        }
	    }
	});
	
	
	_auth.$AuthModel;
	
	_squid.$Component;
	
	_squid.formatNameInformal;
	
	_squid.$util;
	
	_uiRouter.$state;
	
	_logger.$logger;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-tokenization-info/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"tokenizationInfo\" modal-box content>\n    <div class=\"infoPage\">\n        <span>\n            {{ content('memberReview.welcomeBack', {userName: userName}) }}\n            <span ng-if=\"showNotYou\">\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"actions.logout()\">{{ content('memberReview.notYou')}}</a>\n            </span>\n        </span>\n        <div class=\"info_content\">\n            <div class=\"heading\">{{content('topup.topupInfoHeading')}}</div>\n            <div class=\"content_wrapper\">\n                <div class=\"segment\">\n                    <div class=\"glyph\" id=\"glyph_a\"></div>\n                    <div class=\"text\">{{content('topup.topupInfo1')}}</div>\n                </div>\n                <div class=\"segment\">\n                    <div class=\"glyph\" id=\"glyph_b\"></div>\n                    <div class=\"text\">{{content('topup.topupInfo2')}}</div>\n                </div>\n                <div class=\"segment\">\n                    <div class=\"glyph\" id=\"glyph_c\"></div>\n                    <div class=\"text\">{{content('topup.topupInfo3')}}</div>\n                </div>\n            </div>\n        </div>\n        <input ng-click=\"actions.continue()\" value=\"{{content('common.next')}}\" class=\"btn full continueButton\">\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-tokenization-info/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-tokenization-info/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-tokenization-info/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#tokenizationInfo .infoPage{padding:20px 0 40px;display:flex;flex-direction:column;height:calc(100vh - 125px)}#tokenizationInfo .infoPage .info_content{margin-top:40px;flex:1 1 auto}#tokenizationInfo .infoPage .info_content .heading{font-size:1.2em}#tokenizationInfo .infoPage .info_content .content_wrapper{margin-top:20px}#tokenizationInfo .infoPage .info_content .content_wrapper .segment{margin-top:10px}#tokenizationInfo .infoPage .info_content .content_wrapper .segment .glyph{position:absolute;width:34px;height:34px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#tokenizationInfo .infoPage .info_content .content_wrapper .segment .glyph{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v1_2x.png\");background-size:119px 209px}}#tokenizationInfo .infoPage .info_content .content_wrapper .segment .glyph#glyph_a{background-position:-9px -74px}#tokenizationInfo .infoPage .info_content .content_wrapper .segment .glyph#glyph_b{background-position:-9px -117px}#tokenizationInfo .infoPage .info_content .content_wrapper .segment .glyph#glyph_c{background-position:-9px -158px}#tokenizationInfo .infoPage .info_content .content_wrapper .segment .text{margin-left:60px}#tokenizationInfo .infoPage #nextBtn{margin-bottom:auto;margin-top:auto}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-inventory-soldout/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSoldOutPageRoute = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-inventory-soldout/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSoldOutPageRoute = exports.$xoSoldOutPageRoute = _squid.$ComponentRoute.extend('$xoSoldOutPageRoute', {
	
	    path: 'soldout',
	    directive: _directive2['default'],
	    titleContent: 'soldout.title',
	    query: ['items', 'soldOutUrl'],
	    auth: false,
	    trackingData: {
	        fptiState: 'soldout',
	        templateName: 'soldout.dust',
	        pageGoal: 'soldout page',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-soldout',
	                'pagename2': '%::fullpage-soldout:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	
	    children: []
	});
	
	angular.value("$xoSoldOutPageRoute", $xoSoldOutPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-inventory-soldout/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _util = __webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	__webpack_require__("./components/xo-ui-components/src/modal/directive.js");
	
	var _template = __webpack_require__("./pages/xo-inventory-soldout/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoSoldoutPageDirective', {
	    tag: 'xo-soldout-page',
	    template: _template2['default'],
	    auth: false,
	
	    actions: {
	        continueShoppingHandler: function continueShoppingHandler() {
	            _util.$ReturnToMerchant.goTo(decodeURIComponent(_uiRouter.$state.params.soldOutUrl), true);
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            this.locale = _squid.$locale;
	            angular.element('.paypalHeader').css('display', 'none');
	            angular.element('#defaultCancelLink').css('display', 'none');
	        },
	        populate: function populate() {
	            this.item_name = decodeURIComponent(_uiRouter.$state.params.items);
	        }
	    }
	
	});
	
	
	_squid.$Component;
	
	_squid.$locale;
	
	_util.$ReturnToMerchant;
	
	_uiRouter.$state;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-inventory-soldout/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"soldOut\" content>\n    <div id=\"soldouticon\">\n        <div class=\"left_section\"> </div>\n\n        <div class=\"text_lines\">\n            <span id=\"text\">{{content ('soldout.icon')}}</span>\n        </div>\n\n        <div id=\"rightSection\">\n            <span class=\"shape-right\">   </span>\n        </div>\n    </div>\n\n    <div class=\"soldOutMessage\" ng-bind-html=\"htmlContent('soldout.message', {item: item_name})\">\n    </div>\n    <div>\n        <input id= \"Continue-Shopping\" class=\"btn full confirmButton continueButton\" type=\"button\" value=\"{{content ('soldout.continueShoppingButton')}}\" ng-click=\"actions.continueShoppingHandler()\"/>\n\n    </div>\n\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/done/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-page-components/src/done/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-done', ['squid', 'xo-done.directive']).factory('$DoneRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('DoneRoute', {
	            name: 'done',
	            directive: 'xo-done',
	            titleContent: 'done.paymentCompleted',
	            query: ['code'],
	            trackingData: {
	                fptiState: 'done_page',
	                templateName: 'memberDone.dust',
	                pageGoal: 'Payment Done Receipt',
	                trackStateExit: true,
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::fullpage-done',
	                        'pagename2': '%::fullpage-done:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-page-components/src/done", "components/xo-page-components/src/done/route.js"))

/***/ },

/***/ "./components/xo-form-components/src/phone/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-form-components/src/phone/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-phone.route', ['squid', 'xo-phone.directive']).factory('$AddPhoneRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddPhoneRoute', {
	
	            name: 'addPhone',
	
	            directive: 'xo-add-phone',
	
	            titleContent: 'addPhone.addPhoneNumber',
	
	            query: ['message'],
	
	            trackingData: {
	                templateName: 'addPhone.dust',
	                fptiState: 'add_phone',
	                pageGoal: 'Add Phone',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::fullpage-add-phone',
	                        'pagename2': '%::fullpage-add-phone:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                    // More page qualifiers come here...
	                }
	            },
	
	            loginRequired: true,
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-form-components/src/phone", "components/xo-form-components/src/phone/route.js"))

/***/ },

/***/ "./components/xo-form-components/src/phone/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/phone/template.html"), __webpack_require__("./components/xo-form-components/src/phone/phoneInput/directive.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-phone.directive', ['squid', 'xo-phone.phoneInput', 'xomodel.checkout', 'xomodel.user', 'xomodel.auth', 'xo-message.directive', 'xo-title.directive', 'xo-value-props.directive']).directive('xoAddPhone', function () {
	        return {
	            template: template,
	            scope: {},
	            controller: function controller($scope, $rootScope, $location, $populate, $contentVersion, $UserInfoModel, $state, $locale, $featureCountries, $CheckoutSessionModel, $util, $logger, $AuthModel, $feature) {
	
	                $scope.showPhoneDisclosure = $featureCountries('showPhoneDisclosure').indexOf($locale.country) > -1;
	                $scope.phoneConsent = $feature('phoneConsent');
	                $scope.consentContentKey = $scope.phoneConsent ? 'addPhone.phoneConsent' : 'addPhone.phoneDisclosure';
	                $scope.errorMessage = {
	                    msgKeys: ['addPhone.addPhoneNumberConsent'],
	                    type: 'info'
	                };
	
	                $scope.userInfo = $UserInfoModel.instance($rootScope.token);
	
	                var CONTENT_KEY = {
	                    INVALID_PHONE_NUMBER: 'validPhone'
	                };
	
	                var CONTENT_MAPPING = {
	                    numberError: CONTENT_KEY.INVALID_PHONE_NUMBER,
	                    typeError: CONTENT_KEY.INVALID_PHONE_NUMBER
	                };
	
	                var populateErrorMessage = function populateErrorMessage(name) {
	                    var contentKey = CONTENT_MAPPING[name];
	                    var msg = contentKey ? $locale.content.get('scripts.' + contentKey) : 'unresolved content for login error ' + name;
	
	                    $scope.errorMessage = {
	                        msgs: [msg],
	                        type: 'error'
	                    };
	                };
	
	                var validationErrorHandler = {
	                    numberError: populateErrorMessage,
	                    typeError: populateErrorMessage
	                };
	
	                $populate($scope, {
	                    auth: $AuthModel.instance()
	                }).then(function () {
	
	                    $scope.logout = function () {
	                        $logger.info('not_you_logout');
	                        $scope.auth.action('logout').then(function () {
	                            $state.go('checkout.login');
	                        });
	                    };
	
	                    $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && $scope.logout;
	
	                    $scope.onSubmit = function () {
	                        if ($scope.phoneConsent) {
	                            $scope.phone.consent = {
	                                agreed: true,
	                                contentId: $locale.country + ':' + $locale.lang + ':' + $scope.consentContentKey + ':' + $contentVersion()
	                            };
	                        }
	                        $scope.userInfo.action('addPhone', {
	
	                            data: $scope.phone,
	
	                            success: function success(data) {
	                                return $CheckoutSessionModel.instance($rootScope.token).action('create', {
	                                    success: function success() {
	                                        $state.go('checkout.review');
	                                    }
	                                });
	                            },
	
	                            contingencies: {
	                                NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
	                                    $location.path('/checkout/addCard');
	                                },
	
	                                EXPIRED_CREDIT_CARD: function EXPIRED_CREDIT_CARD() {
	                                    $location.path('/checkout/updateCard');
	                                }
	                            },
	
	                            validation: function validation(data) {
	                                angular.forEach(data, function (value, key) {
	                                    validationErrorHandler[key](key);
	                                });
	                            }
	                        });
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/phone/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addPhone\" id=\"addPhone\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n                {{ content('memberReview.welcomeBack', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <xo-title title-txt=\"{{content('addPhone.addPhoneNumber')}}\"></xo-title>\n            <form name=\"addPhoneForm\" class=\"proceed\" content autocomplete=\"off\" ng-submit=\"addPhoneForm.$valid && onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n                <xo-phone-input phone=\"phone\"></xo-phone-input>\n                <p class=\"disclaimer\" id=\"phoneDisclosure\" ng-if=\"showPhoneDisclosure\">\n                    <span data-ng-bind-html=\"htmlContent(consentContentKey)\"></span>\n                </p>\n                <input track-submit type=\"submit\" value=\"{{showPhoneDisclosure ? content('addPhone.agreeContinue') : content('common.continueLabel') }}\" class=\"btn full\" ng-click=\"validated=true\" />\n            </form>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-form-components/src/phone/phoneInput/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-form-components/src/phone/phoneInput/styles.less");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/phone/phoneInput/template.html"), __webpack_require__("./components/xo-form-components/src/phone/lib/territoriesByCode.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/floating-label/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template, countryPhoneCode) {
	
	    angular.module('xo-phone.phoneInput', ['squid', 'xo-dropdown.directive', 'xo-error-tooltip.directive', 'floating-label.directive']).directive('xoPhoneInput', function () {
	        return {
	            template: template,
	            scope: {
	                phone: '=',
	                showPhoneType: '=',
	                exclude: '@'
	            },
	
	            link: function link(scope, element, attr, controller) {
	                element.on('keyup', function (event) {
	                    $('.telephone').mask(scope.mask, {
	                        'translation': {
	                            0: { pattern: /[0-9]/ }
	                        }
	                    });
	                });
	            },
	
	            controller: function controller($scope, $feature, $locale) {
	                $scope.locale = $locale;
	                $scope.IntDialingCodes = countryPhoneCode;
	                $scope.defaultCountryPhoneCode = countryPhoneCode[$locale.country];
	                $scope.showPhoneType = $feature('phoneType', true, $scope.country) && $scope.showPhoneType !== false;
	
	                // dont display countries that are tagged with hideInOtherCountries flag in territoriesByCode.js.
	                // if localeCountry and dropdown country are same ignore hideInOtherCountries and display the countrycode.
	                $scope.hideCountry = function (dropdownCountry, hideInOtherCountries) {
	                    return $locale.country !== dropdownCountry && hideInOtherCountries;
	                };
	
	                $scope.phone = $scope.phone || {};
	                $scope.phone.phoneType = $scope.phone.phoneType || 'Mobile';
	                $scope.phone.IntDialingCountryCode = $scope.defaultCountryPhoneCode.phoneCountryCode;
	
	                angular.extend($scope.phone, {
	                    phoneCountryCode: $locale.country
	                });
	
	                function getPhoneMask(phoneType, phoneEntry) {
	                    var defaultMask = '0000000000000000';
	                    var masks = phoneEntry && phoneEntry.masks;
	                    var mobileMask = masks && masks.MOBILE ? masks.MOBILE : defaultMask;
	                    var fixedLineMask = masks && masks.FIXED_LINE ? masks.FIXED_LINE : defaultMask;
	                    return phoneType === 'Mobile' ? mobileMask : fixedLineMask;
	                }
	
	                function getPhonePattern(phoneEntry) {
	                    var defaultPattern = '^[0-9]+$';
	                    var patterns = phoneEntry && phoneEntry.patterns;
	                    // less stric regex validation in place for now, just use general regex to match mobile AND fixed-line formats
	                    // for now we use less strict regex validation because we are not ready for this more strict validation
	                    if (patterns) {
	                        return patterns.GENERAL ? patterns.GENERAL : defaultPattern;
	                    }
	                    return defaultPattern;
	
	                    // more strict regex validaiton based on phone type is found commented below
	                    // var ret;
	                    // switch ($scope.phone.phoneType) {
	                    //     case 'Mobile':
	                    //         ret = patterns.MOBILE;
	                    //         break;
	                    //     case 'Home':
	                    //     case 'Work':
	                    //         ret = patterns.FIXED_LINE;
	                    //         break;
	                    //     default:
	                    //         ret = patterns.GENERAL;
	                    //         break;
	                    // }
	                    // return ret ? ret : defaultPattern;
	                }
	
	                function populatePhoneMetadata() {
	                    if (!$scope.metadata || $scope.metadata.country !== $locale.metadata.country) {
	                        $scope.metadata = angular.copy($locale.metadata);
	                    }
	                    var phoneEntry = $scope.metadata.phoneEntry;
	                    $scope.mask = getPhoneMask($scope.phone.phoneType, phoneEntry);
	                    $scope.pattern = getPhonePattern(phoneEntry);
	                }
	
	                populatePhoneMetadata();
	
	                // Reset the phone number mask from according to the phone type
	                $scope.phoneTypeChanged = function () {
	                    $scope.mask = getPhoneMask($scope.phone.phoneType, $scope.metadata.phoneEntry);
	                    $scope.pattern = getPhonePattern($scope.metadata.phoneEntry);
	                    $('.telephone').mask($scope.mask);
	                };
	
	                $scope.$watch('phone.phoneCountryCode', function (newValue) {
	                    $scope.phone.IntDialingCountryCode = countryPhoneCode[newValue].phoneCountryCode;
	                });
	
	                $scope.$on('localeChange', function () {
	                    $scope.defaultCountryPhoneCode = countryPhoneCode[$locale.country];
	                    $scope.phone.phoneCountryCode = $locale.country;
	                    if (!$scope.metadata || $scope.metadata.country !== $locale.metadata.country) {
	                        populatePhoneMetadata();
	                        $('.telephone').mask($scope.mask);
	                    }
	                });
	
	                $scope.showWork = $scope.exclude === 'WORK';
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-form-components/src/phone/phoneInput/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-form-components/src/phone/phoneInput/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-form-components/src/phone/phoneInput/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".singleLineMobile{float:none!important}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/phone/phoneInput/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"row-fluid fieldGroup clearfix\" ng-class=\"{countryCodeSelect: defaultCountryPhoneCode.showCountryCodeList === true}\" content>\n    <div id=\"phoneTypeContainer\" class=\"phoneTypeContainer dropdown confidential inputField half\" ng-cloak\n         ng-if=\"showPhoneType === true\" ng-class=\"{'rtlPhoneType': locale.metadata.directionality === 'rtl'}\"\n         floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneType\" name=\"phoneType\" id=\"phoneType\" ng-change=\"phoneTypeChanged()\" xo-error-tooltip>\n            <option value=\"Mobile\" selected=\"\">{{content('common.mobile')}}</option>\n            <option value=\"Home\">{{content('common.home')}}</option>\n            <option ng-if=\"!showWork\" value=\"Work\">{{content('common.work')}}</option>\n        </select>\n        <label for=\"phoneType\" id=\"phoneTypeLabel\">{{content('common.phoneType')}}</label>\n    </div>\n\n    <div id=\"phoneCodeContainer\" class=\"phoneCodeContainer dropdown confidential half last-child inputField\" ng-cloak\n         ng-if=\"defaultCountryPhoneCode.showCountryCodeList\" floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneCountryCode\" name=\"phoneCountryCode\" id=\"phoneCountryCode\" aria-required=\"true\" xo-error-tooltip required>\n            <option ng-repeat=\"(key, value) in IntDialingCodes\" value=\"{{key}}\" ng-if=\"!hideCountry(key, value.hideInOtherCountries)\" ng-selected=\"phone.phoneCountryCode === key\">{{value.phoneCountryCode}} ({{key}})</option>\n        </select>\n        <label for=\"phoneCountryCode\" id=\"phoneCodeLabel\">{{content('common.phoneCountryCode')}}</label>\n    </div>\n\n    <div class=\"inputField confidential last-child\"\n         ng-class=\"{'half': showPhoneType || defaultCountryPhoneCode.showCountryCodeList, 'telephoneField': showPhoneType,\n         'telephoneFieldFull': !showPhoneType, 'rtlPhoneField': locale.metadata.directionality === 'rtl',\n         singleLineMobile: !showPhoneType && !defaultCountryPhoneCode.showCountryCodeList}\" floating-label directionality >\n\n        <input id=\"telephone\"\n               class=\"telephone\"\n               type=\"tel\"\n               ng-model=\"phone.telephone\"\n               name=\"telephone\"\n               value=\"\"\n               autocapitalize=\"off\"\n               autocomplete=\"off\"\n               aria-required=\"true\"\n               country-code=\"phone.phoneCountryCode\"\n               phone-pattern=\"{{pattern}}\"\n               xo-validation='{\"validator\": \"validPhone\"}'\n               data-error-text=\"{{content('validation.validPhone')}}\"\n               maxlength=\"{{mask.length}}\"\n               required\n               xo-error-tooltip />\n        <label for=\"telephone\" class=\"focus\">{{content('common.phone')}}</label>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-form-components/src/phone/lib/territoriesByCode.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return {
	        'AC': {
	            'status': 'reserved',
	            'phoneCountryCode': '247',
	            'showCountryCodeList': false
	        },
	        'AD': {
	            'status': 'assigned',
	            'phoneCountryCode': '376',
	            'showCountryCodeList': false
	        },
	        'AE': {
	            'status': 'assigned',
	            'phoneCountryCode': '971',
	            'showCountryCodeList': false
	        },
	        'AF': {
	            'status': 'assigned',
	            'phoneCountryCode': '93',
	            'showCountryCodeList': false
	        },
	        'AG': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'AI': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'AL': {
	            'status': 'assigned',
	            'phoneCountryCode': '355',
	            'showCountryCodeList': false
	        },
	        'AM': {
	            'status': 'assigned',
	            'phoneCountryCode': '374',
	            'showCountryCodeList': false
	        },
	        'AN': {
	            'status': 'assigned',
	            'phoneCountryCode': '599',
	            'showCountryCodeList': false
	        },
	        'AO': {
	            'status': 'assigned',
	            'phoneCountryCode': '244',
	            'showCountryCodeList': false
	        },
	        'AQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '672',
	            'showCountryCodeList': false
	        },
	        'AR': {
	            'status': 'assigned',
	            'phoneCountryCode': '54',
	            'showCountryCodeList': false
	        },
	        'AS': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'AT': {
	            'status': 'assigned',
	            'phoneCountryCode': '43',
	            'showCountryCodeList': true
	        },
	        'AU': {
	            'status': 'assigned',
	            'phoneCountryCode': '61',
	            'showCountryCodeList': true
	        },
	        'AW': {
	            'status': 'assigned',
	            'phoneCountryCode': '297',
	            'showCountryCodeList': false
	        },
	        'AZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '994',
	            'showCountryCodeList': false
	        },
	        'BA': {
	            'status': 'assigned',
	            'phoneCountryCode': '387',
	            'showCountryCodeList': false
	        },
	        'BB': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'BD': {
	            'status': 'assigned',
	            'phoneCountryCode': '880',
	            'showCountryCodeList': false
	        },
	        'BE': {
	            'status': 'assigned',
	            'phoneCountryCode': '32',
	            'showCountryCodeList': true
	        },
	        'BF': {
	            'status': 'assigned',
	            'phoneCountryCode': '226',
	            'showCountryCodeList': false
	        },
	        'BG': {
	            'status': 'assigned',
	            'phoneCountryCode': '359',
	            'showCountryCodeList': false
	        },
	        'BH': {
	            'status': 'assigned',
	            'phoneCountryCode': '973',
	            'showCountryCodeList': false
	        },
	        'BI': {
	            'status': 'assigned',
	            'phoneCountryCode': '257',
	            'showCountryCodeList': false
	        },
	        'BJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '229',
	            'showCountryCodeList': false
	        },
	        'BL': {
	            'status': 'assigned',
	            'phoneCountryCode': '590',
	            'showCountryCodeList': false
	        },
	        'BM': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'BN': {
	            'status': 'assigned',
	            'phoneCountryCode': '673',
	            'showCountryCodeList': false
	        },
	        'BO': {
	            'status': 'assigned',
	            'phoneCountryCode': '591',
	            'showCountryCodeList': false
	        },
	        'BQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '599',
	            'showCountryCodeList': false
	        },
	        'BR': {
	            'status': 'assigned',
	            'phoneCountryCode': '55',
	            'showCountryCodeList': false
	        },
	        'BS': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'BT': {
	            'status': 'assigned',
	            'phoneCountryCode': '975',
	            'showCountryCodeList': false
	        },
	        'BV': {
	            'status': 'assigned'
	        },
	        'BW': {
	            'status': 'assigned',
	            'phoneCountryCode': '267',
	            'showCountryCodeList': false
	        },
	        'BY': {
	            'status': 'assigned',
	            'phoneCountryCode': '375',
	            'showCountryCodeList': false
	        },
	        'BZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '501',
	            'showCountryCodeList': false
	        },
	        'C2': {
	            'status': 'assigned',
	            'phoneCountryCode': '86',
	            'showCountryCodeList': false
	        },
	        'CA': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'CC': {
	            'status': 'assigned',
	            'phoneCountryCode': '61',
	            'showCountryCodeList': false
	        },
	        'CD': {
	            'status': 'assigned',
	            'phoneCountryCode': '243',
	            'showCountryCodeList': false
	        },
	        'CF': {
	            'status': 'assigned',
	            'phoneCountryCode': '236',
	            'showCountryCodeList': false
	        },
	        'CG': {
	            'status': 'assigned',
	            'phoneCountryCode': '242',
	            'showCountryCodeList': false
	        },
	        'CH': {
	            'status': 'assigned',
	            'phoneCountryCode': '41',
	            'showCountryCodeList': true
	        },
	        'CI': {
	            'status': 'assigned',
	            'phoneCountryCode': '225',
	            'showCountryCodeList': false
	        },
	        'CK': {
	            'status': 'assigned',
	            'phoneCountryCode': '682',
	            'showCountryCodeList': false
	        },
	        'CL': {
	            'status': 'assigned',
	            'phoneCountryCode': '56',
	            'showCountryCodeList': false
	        },
	        'CM': {
	            'status': 'assigned',
	            'phoneCountryCode': '237',
	            'showCountryCodeList': false
	        },
	        'CN': {
	            'status': 'assigned',
	            'phoneCountryCode': '86',
	            'showCountryCodeList': false
	        },
	        'CO': {
	            'status': 'assigned',
	            'phoneCountryCode': '57',
	            'showCountryCodeList': false
	        },
	        'CR': {
	            'status': 'assigned',
	            'phoneCountryCode': '506',
	            'showCountryCodeList': false
	        },
	        'CU': {
	            'status': 'assigned',
	            'phoneCountryCode': '53',
	            'showCountryCodeList': false
	        },
	        'CV': {
	            'status': 'assigned',
	            'phoneCountryCode': '238',
	            'showCountryCodeList': false
	        },
	        'CW': {
	            'status': 'assigned',
	            'phoneCountryCode': '599',
	            'showCountryCodeList': false
	        },
	        'CX': {
	            'status': 'assigned',
	            'phoneCountryCode': '61',
	            'showCountryCodeList': false
	        },
	        'CY': {
	            'status': 'assigned',
	            'phoneCountryCode': '357',
	            'showCountryCodeList': false
	        },
	        'CZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '420',
	            'showCountryCodeList': false
	        },
	        'DE': {
	            'status': 'assigned',
	            'phoneCountryCode': '49',
	            'showCountryCodeList': false
	        },
	        'DJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '253',
	            'showCountryCodeList': false
	        },
	        'DK': {
	            'status': 'assigned',
	            'phoneCountryCode': '45',
	            'showCountryCodeList': true
	        },
	        'DM': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'DO': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'DZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '213',
	            'showCountryCodeList': false
	        },
	        'EC': {
	            'status': 'assigned',
	            'phoneCountryCode': '593',
	            'showCountryCodeList': false
	        },
	        'EE': {
	            'status': 'assigned',
	            'phoneCountryCode': '372',
	            'showCountryCodeList': false
	        },
	        'EG': {
	            'status': 'assigned',
	            'phoneCountryCode': '20',
	            'showCountryCodeList': false
	        },
	        'EH': {
	            'status': 'assigned',
	            'phoneCountryCode': '212',
	            'showCountryCodeList': false
	        },
	        'ER': {
	            'status': 'assigned',
	            'phoneCountryCode': '291',
	            'showCountryCodeList': false
	        },
	        'ES': {
	            'status': 'assigned',
	            'phoneCountryCode': '34',
	            'showCountryCodeList': false
	        },
	        'ET': {
	            'status': 'assigned',
	            'phoneCountryCode': '251',
	            'showCountryCodeList': false
	        },
	        'FI': {
	            'status': 'assigned',
	            'phoneCountryCode': '358',
	            'showCountryCodeList': false
	        },
	        'FJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '679',
	            'showCountryCodeList': false
	        },
	        'FK': {
	            'status': 'assigned',
	            'phoneCountryCode': '500',
	            'showCountryCodeList': false
	        },
	        'FM': {
	            'status': 'assigned',
	            'phoneCountryCode': '691',
	            'showCountryCodeList': false
	        },
	        'FO': {
	            'status': 'assigned',
	            'phoneCountryCode': '298',
	            'showCountryCodeList': false
	        },
	        'FR': {
	            'status': 'assigned',
	            'phoneCountryCode': '33',
	            'showCountryCodeList': false
	        },
	        'GA': {
	            'status': 'assigned',
	            'phoneCountryCode': '241',
	            'showCountryCodeList': false
	        },
	        'GB': {
	            'status': 'assigned',
	            'phoneCountryCode': '44',
	            'showCountryCodeList': false
	        },
	        'GD': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'GE': {
	            'status': 'assigned',
	            'phoneCountryCode': '995',
	            'showCountryCodeList': false
	        },
	        'GF': {
	            'status': 'assigned',
	            'phoneCountryCode': '594',
	            'showCountryCodeList': false
	        },
	        'GG': {
	            'status': 'assigned',
	            'phoneCountryCode': '44',
	            'showCountryCodeList': false
	        },
	        'GH': {
	            'status': 'assigned',
	            'phoneCountryCode': '233',
	            'showCountryCodeList': false
	        },
	        'GI': {
	            'status': 'assigned',
	            'phoneCountryCode': '350',
	            'showCountryCodeList': false
	        },
	        'GL': {
	            'status': 'assigned',
	            'phoneCountryCode': '299',
	            'showCountryCodeList': false
	        },
	        'GM': {
	            'status': 'assigned',
	            'phoneCountryCode': '220',
	            'showCountryCodeList': false
	        },
	        'GN': {
	            'status': 'assigned',
	            'phoneCountryCode': '224',
	            'showCountryCodeList': false
	        },
	        'GP': {
	            'status': 'assigned',
	            'phoneCountryCode': '590',
	            'showCountryCodeList': false
	        },
	        'GQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '240',
	            'showCountryCodeList': false
	        },
	        'GR': {
	            'status': 'assigned',
	            'phoneCountryCode': '30',
	            'showCountryCodeList': false
	        },
	        'GS': {
	            'status': 'assigned',
	            'phoneCountryCode': '500',
	            'showCountryCodeList': false
	        },
	        'GT': {
	            'status': 'assigned',
	            'phoneCountryCode': '502',
	            'showCountryCodeList': false
	        },
	        'GU': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'GW': {
	            'status': 'assigned',
	            'phoneCountryCode': '245',
	            'showCountryCodeList': false
	        },
	        'GY': {
	            'status': 'assigned',
	            'phoneCountryCode': '592',
	            'showCountryCodeList': false
	        },
	        'HK': {
	            'status': 'assigned',
	            'phoneCountryCode': '852',
	            'showCountryCodeList': true
	        },
	        'HM': {
	            'status': 'assigned'
	        },
	        'HN': {
	            'status': 'assigned',
	            'phoneCountryCode': '504',
	            'showCountryCodeList': false
	        },
	        'HR': {
	            'status': 'assigned',
	            'phoneCountryCode': '385',
	            'showCountryCodeList': false
	        },
	        'HT': {
	            'status': 'assigned',
	            'phoneCountryCode': '509',
	            'showCountryCodeList': false
	        },
	        'HU': {
	            'status': 'assigned',
	            'phoneCountryCode': '36',
	            'showCountryCodeList': false
	        },
	        'ID': {
	            'status': 'assigned',
	            'phoneCountryCode': '62',
	            'showCountryCodeList': false
	        },
	        'IE': {
	            'status': 'assigned',
	            'phoneCountryCode': '353',
	            'showCountryCodeList': false
	        },
	        'IL': {
	            'status': 'assigned',
	            'phoneCountryCode': '972',
	            'showCountryCodeList': false
	        },
	        'IM': {
	            'status': 'assigned',
	            'phoneCountryCode': '44',
	            'showCountryCodeList': false
	        },
	        'IN': {
	            'status': 'assigned',
	            'phoneCountryCode': '91',
	            'showCountryCodeList': false
	        },
	        'IO': {
	            'status': 'assigned',
	            'phoneCountryCode': '246',
	            'showCountryCodeList': false
	        },
	        'IQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '964',
	            'showCountryCodeList': false
	        },
	        'IR': {
	            'status': 'assigned',
	            'phoneCountryCode': '98',
	            'showCountryCodeList': false
	        },
	        'IS': {
	            'status': 'assigned',
	            'phoneCountryCode': '354',
	            'showCountryCodeList': false
	        },
	        'IT': {
	            'status': 'assigned',
	            'phoneCountryCode': '39',
	            'showCountryCodeList': false
	        },
	        'JE': {
	            'status': 'assigned',
	            'phoneCountryCode': '44',
	            'showCountryCodeList': false
	        },
	        'JM': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'JO': {
	            'status': 'assigned',
	            'phoneCountryCode': '962',
	            'showCountryCodeList': false
	        },
	        'JP': {
	            'status': 'assigned',
	            'phoneCountryCode': '81',
	            'showCountryCodeList': false
	        },
	        'KE': {
	            'status': 'assigned',
	            'phoneCountryCode': '254',
	            'showCountryCodeList': false
	        },
	        'KG': {
	            'status': 'assigned',
	            'phoneCountryCode': '996',
	            'showCountryCodeList': false
	        },
	        'KH': {
	            'status': 'assigned',
	            'phoneCountryCode': '855',
	            'showCountryCodeList': false
	        },
	        'KI': {
	            'status': 'assigned',
	            'phoneCountryCode': '686',
	            'showCountryCodeList': false
	        },
	        'KM': {
	            'status': 'assigned',
	            'phoneCountryCode': '269',
	            'showCountryCodeList': false
	        },
	        'KN': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'KP': {
	            'status': 'assigned',
	            'phoneCountryCode': '850',
	            'showCountryCodeList': false
	        },
	        'KR': {
	            'status': 'assigned',
	            'phoneCountryCode': '82',
	            'showCountryCodeList': false
	        },
	        'KW': {
	            'status': 'assigned',
	            'phoneCountryCode': '965',
	            'showCountryCodeList': false
	        },
	        'KY': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'KZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '7',
	            'showCountryCodeList': false
	        },
	        'LA': {
	            'status': 'assigned',
	            'phoneCountryCode': '856',
	            'showCountryCodeList': true
	        },
	        'LB': {
	            'status': 'assigned',
	            'phoneCountryCode': '961',
	            'showCountryCodeList': false
	        },
	        'LC': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'LI': {
	            'status': 'assigned',
	            'phoneCountryCode': '423',
	            'showCountryCodeList': false
	        },
	        'LK': {
	            'status': 'assigned',
	            'phoneCountryCode': '94',
	            'showCountryCodeList': false
	        },
	        'LR': {
	            'status': 'assigned',
	            'phoneCountryCode': '231',
	            'showCountryCodeList': false
	        },
	        'LS': {
	            'status': 'assigned',
	            'phoneCountryCode': '266',
	            'showCountryCodeList': false
	        },
	        'LT': {
	            'status': 'assigned',
	            'phoneCountryCode': '370',
	            'showCountryCodeList': false
	        },
	        'LU': {
	            'status': 'assigned',
	            'phoneCountryCode': '352',
	            'showCountryCodeList': false
	        },
	        'LV': {
	            'status': 'assigned',
	            'phoneCountryCode': '371',
	            'showCountryCodeList': false
	        },
	        'LY': {
	            'status': 'assigned',
	            'phoneCountryCode': '218',
	            'showCountryCodeList': false
	        },
	        'MA': {
	            'status': 'assigned',
	            'phoneCountryCode': '212',
	            'showCountryCodeList': false
	        },
	        'MC': {
	            'status': 'assigned',
	            'phoneCountryCode': '377',
	            'showCountryCodeList': false
	        },
	        'MD': {
	            'status': 'assigned',
	            'phoneCountryCode': '373',
	            'showCountryCodeList': false
	        },
	        'ME': {
	            'status': 'assigned',
	            'phoneCountryCode': '382',
	            'showCountryCodeList': false
	        },
	        'MF': {
	            'status': 'assigned',
	            'phoneCountryCode': '590',
	            'showCountryCodeList': false
	        },
	        'MG': {
	            'status': 'assigned',
	            'phoneCountryCode': '261',
	            'showCountryCodeList': false
	        },
	        'MH': {
	            'status': 'assigned',
	            'phoneCountryCode': '692',
	            'showCountryCodeList': false
	        },
	        'MK': {
	            'status': 'assigned',
	            'phoneCountryCode': '389',
	            'showCountryCodeList': false
	        },
	        'ML': {
	            'status': 'assigned',
	            'phoneCountryCode': '223',
	            'showCountryCodeList': false
	        },
	        'MM': {
	            'status': 'assigned',
	            'phoneCountryCode': '95',
	            'showCountryCodeList': false
	        },
	        'MN': {
	            'status': 'assigned',
	            'phoneCountryCode': '976',
	            'showCountryCodeList': false
	        },
	        'MO': {
	            'status': 'assigned',
	            'phoneCountryCode': '853',
	            'showCountryCodeList': false
	        },
	        'MP': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'MQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '596',
	            'showCountryCodeList': false
	        },
	        'MR': {
	            'status': 'assigned',
	            'phoneCountryCode': '222',
	            'showCountryCodeList': false
	        },
	        'MS': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'MT': {
	            'status': 'assigned',
	            'phoneCountryCode': '356',
	            'showCountryCodeList': false
	        },
	        'MU': {
	            'status': 'assigned',
	            'phoneCountryCode': '230',
	            'showCountryCodeList': false
	        },
	        'MV': {
	            'status': 'assigned',
	            'phoneCountryCode': '960',
	            'showCountryCodeList': false
	        },
	        'MW': {
	            'status': 'assigned',
	            'phoneCountryCode': '265',
	            'showCountryCodeList': false
	        },
	        'MX': {
	            'status': 'assigned',
	            'phoneCountryCode': '52',
	            'showCountryCodeList': false
	        },
	        'MY': {
	            'status': 'assigned',
	            'phoneCountryCode': '60',
	            'showCountryCodeList': false
	        },
	        'MZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '258',
	            'showCountryCodeList': false
	        },
	        'NA': {
	            'status': 'assigned',
	            'phoneCountryCode': '264',
	            'showCountryCodeList': false
	        },
	        'NC': {
	            'status': 'assigned',
	            'phoneCountryCode': '687',
	            'showCountryCodeList': false
	        },
	        'NE': {
	            'status': 'assigned',
	            'phoneCountryCode': '227',
	            'showCountryCodeList': false
	        },
	        'NF': {
	            'status': 'assigned',
	            'phoneCountryCode': '672',
	            'showCountryCodeList': false
	        },
	        'NG': {
	            'status': 'assigned',
	            'phoneCountryCode': '234',
	            'showCountryCodeList': false
	        },
	        'NI': {
	            'status': 'assigned',
	            'phoneCountryCode': '505',
	            'showCountryCodeList': false
	        },
	        'NL': {
	            'status': 'assigned',
	            'phoneCountryCode': '31',
	            'showCountryCodeList': true
	        },
	        'NO': {
	            'status': 'assigned',
	            'phoneCountryCode': '47',
	            'showCountryCodeList': true
	        },
	        'NP': {
	            'status': 'assigned',
	            'phoneCountryCode': '977',
	            'showCountryCodeList': false
	        },
	        'NR': {
	            'status': 'assigned',
	            'phoneCountryCode': '674',
	            'showCountryCodeList': false
	        },
	        'NU': {
	            'status': 'assigned',
	            'phoneCountryCode': '683',
	            'showCountryCodeList': false
	        },
	        'NZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '64',
	            'showCountryCodeList': false
	        },
	        'OM': {
	            'status': 'assigned',
	            'phoneCountryCode': '968',
	            'showCountryCodeList': false
	        },
	        'PA': {
	            'status': 'assigned',
	            'phoneCountryCode': '507',
	            'showCountryCodeList': false
	        },
	        'PE': {
	            'status': 'assigned',
	            'phoneCountryCode': '51',
	            'showCountryCodeList': false
	        },
	        'PF': {
	            'status': 'assigned',
	            'phoneCountryCode': '689',
	            'showCountryCodeList': false
	        },
	        'PG': {
	            'status': 'assigned',
	            'phoneCountryCode': '675',
	            'showCountryCodeList': false
	        },
	        'PH': {
	            'status': 'assigned',
	            'phoneCountryCode': '63',
	            'showCountryCodeList': false
	        },
	        'PK': {
	            'status': 'assigned',
	            'phoneCountryCode': '92',
	            'showCountryCodeList': false
	        },
	        'PL': {
	            'status': 'assigned',
	            'phoneCountryCode': '48',
	            'showCountryCodeList': true
	        },
	        'PM': {
	            'status': 'assigned',
	            'phoneCountryCode': '508',
	            'showCountryCodeList': false
	        },
	        'PN': {
	            'status': 'assigned',
	            'phoneCountryCode': '870',
	            'showCountryCodeList': false
	        },
	        'PR': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'PS': {
	            'status': 'assigned',
	            'phoneCountryCode': '970',
	            'showCountryCodeList': false
	        },
	        'PT': {
	            'status': 'assigned',
	            'phoneCountryCode': '351',
	            'showCountryCodeList': false
	        },
	        'PW': {
	            'status': 'assigned',
	            'phoneCountryCode': '680',
	            'showCountryCodeList': false
	        },
	        'PY': {
	            'status': 'assigned',
	            'phoneCountryCode': '595',
	            'showCountryCodeList': false
	        },
	        'QA': {
	            'status': 'assigned',
	            'phoneCountryCode': '974',
	            'showCountryCodeList': false
	        },
	        'RE': {
	            'status': 'assigned',
	            'phoneCountryCode': '262',
	            'showCountryCodeList': false
	        },
	        'RO': {
	            'status': 'assigned',
	            'phoneCountryCode': '40',
	            'showCountryCodeList': false
	        },
	        'RS': {
	            'status': 'assigned',
	            'phoneCountryCode': '381',
	            'showCountryCodeList': false
	        },
	        'RU': {
	            'status': 'assigned',
	            'phoneCountryCode': '7',
	            'showCountryCodeList': false
	        },
	        'RW': {
	            'status': 'assigned',
	            'phoneCountryCode': '250',
	            'showCountryCodeList': false
	        },
	        'SA': {
	            'status': 'assigned',
	            'phoneCountryCode': '966',
	            'showCountryCodeList': false
	        },
	        'SB': {
	            'status': 'assigned',
	            'phoneCountryCode': '677',
	            'showCountryCodeList': false
	        },
	        'SC': {
	            'status': 'assigned',
	            'phoneCountryCode': '248',
	            'showCountryCodeList': false
	        },
	        'SD': {
	            'status': 'assigned',
	            'phoneCountryCode': '249',
	            'showCountryCodeList': false
	        },
	        'SE': {
	            'status': 'assigned',
	            'phoneCountryCode': '46',
	            'showCountryCodeList': true
	        },
	        'SG': {
	            'status': 'assigned',
	            'phoneCountryCode': '65',
	            'showCountryCodeList': true
	        },
	        'SH': {
	            'status': 'assigned',
	            'phoneCountryCode': '290',
	            'showCountryCodeList': false
	        },
	        'SI': {
	            'status': 'assigned',
	            'phoneCountryCode': '386',
	            'showCountryCodeList': false
	        },
	        'SJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '47',
	            'showCountryCodeList': false
	        },
	        'SK': {
	            'status': 'assigned',
	            'phoneCountryCode': '421',
	            'showCountryCodeList': false
	        },
	        'SL': {
	            'status': 'assigned',
	            'phoneCountryCode': '232',
	            'showCountryCodeList': false
	        },
	        'SM': {
	            'status': 'assigned',
	            'phoneCountryCode': '378',
	            'showCountryCodeList': false
	        },
	        'SN': {
	            'status': 'assigned',
	            'phoneCountryCode': '221',
	            'showCountryCodeList': false
	        },
	        'SO': {
	            'status': 'assigned',
	            'phoneCountryCode': '252',
	            'showCountryCodeList': false
	        },
	        'SR': {
	            'status': 'assigned',
	            'phoneCountryCode': '597',
	            'showCountryCodeList': false
	        },
	        'SS': {
	            'status': 'assigned',
	            'phoneCountryCode': '211',
	            'showCountryCodeList': false
	        },
	        'ST': {
	            'status': 'assigned',
	            'phoneCountryCode': '239',
	            'showCountryCodeList': false
	        },
	        'SV': {
	            'status': 'assigned',
	            'phoneCountryCode': '503',
	            'showCountryCodeList': false
	        },
	        'SX': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'SY': {
	            'status': 'assigned',
	            'phoneCountryCode': '963',
	            'showCountryCodeList': false
	        },
	        'SZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '268',
	            'showCountryCodeList': false
	        },
	        'TC': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'TD': {
	            'status': 'assigned',
	            'phoneCountryCode': '235',
	            'showCountryCodeList': false
	        },
	        'TF': {
	            'status': 'assigned',
	            'phoneCountryCode': '262',
	            'showCountryCodeList': false
	        },
	        'TG': {
	            'status': 'assigned',
	            'phoneCountryCode': '228',
	            'showCountryCodeList': false
	        },
	        'TH': {
	            'status': 'assigned',
	            'phoneCountryCode': '66',
	            'showCountryCodeList': false
	        },
	        'TJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '992',
	            'showCountryCodeList': false
	        },
	        'TK': {
	            'status': 'assigned',
	            'phoneCountryCode': '690',
	            'showCountryCodeList': false
	        },
	        'TL': {
	            'status': 'assigned',
	            'phoneCountryCode': '670',
	            'showCountryCodeList': false
	        },
	        'TM': {
	            'status': 'assigned',
	            'phoneCountryCode': '993',
	            'showCountryCodeList': false
	        },
	        'TN': {
	            'status': 'assigned',
	            'phoneCountryCode': '216',
	            'showCountryCodeList': false
	        },
	        'TO': {
	            'status': 'assigned',
	            'phoneCountryCode': '676',
	            'showCountryCodeList': false
	        },
	        'TR': {
	            'status': 'assigned',
	            'phoneCountryCode': '90',
	            'showCountryCodeList': true
	        },
	        'TT': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'TV': {
	            'status': 'assigned',
	            'phoneCountryCode': '688',
	            'showCountryCodeList': false
	        },
	        'TW': {
	            'status': 'assigned',
	            'phoneCountryCode': '886',
	            'showCountryCodeList': true
	        },
	        'TZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '255',
	            'showCountryCodeList': false
	        },
	        'UA': {
	            'status': 'assigned',
	            'phoneCountryCode': '380',
	            'showCountryCodeList': false
	        },
	        'UG': {
	            'status': 'assigned',
	            'phoneCountryCode': '256',
	            'showCountryCodeList': false
	        },
	        'UM': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'US': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false,
	            'hideInOtherCountries': true
	        },
	        'UY': {
	            'status': 'assigned',
	            'phoneCountryCode': '598',
	            'showCountryCodeList': false
	        },
	        'UZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '998',
	            'showCountryCodeList': false
	        },
	        'VA': {
	            'status': 'assigned',
	            'phoneCountryCode': '39',
	            'showCountryCodeList': false
	        },
	        'VC': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'VE': {
	            'status': 'assigned',
	            'phoneCountryCode': '58',
	            'showCountryCodeList': false
	        },
	        'VG': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'VI': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'VN': {
	            'status': 'assigned',
	            'phoneCountryCode': '84',
	            'showCountryCodeList': false
	        },
	        'VU': {
	            'status': 'assigned',
	            'phoneCountryCode': '678',
	            'showCountryCodeList': false
	        },
	        'WF': {
	            'status': 'assigned',
	            'phoneCountryCode': '681',
	            'showCountryCodeList': false
	        },
	        'WS': {
	            'status': 'assigned',
	            'phoneCountryCode': '685',
	            'showCountryCodeList': false
	        },
	        'YE': {
	            'status': 'assigned',
	            'phoneCountryCode': '967',
	            'showCountryCodeList': false
	        },
	        'YT': {
	            'status': 'assigned',
	            'phoneCountryCode': '262',
	            'showCountryCodeList': false
	        },
	        'ZA': {
	            'status': 'assigned',
	            'phoneCountryCode': '27',
	            'showCountryCodeList': false
	        },
	        'ZM': {
	            'status': 'assigned',
	            'phoneCountryCode': '260',
	            'showCountryCodeList': false
	        },
	        'ZW': {
	            'status': 'assigned',
	            'phoneCountryCode': '263',
	            'showCountryCodeList': false
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/directive.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-apply/route.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-signature/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-bml-display.route', ['squid', 'xo-bml-display.directive', 'xo-bml-apply.route', 'xo-bml-terms-and-conditions.route', 'xo-bml-signature.route']).factory('$BMLDisplay', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('BmlDisplay', {
	
	            name: 'bmldisplay',
	            directive: 'xo-bml-display',
	            trackingData: {
	                fptiState: 'ppc_display'
	            },
	            titleContent: 'applyForBml.bmlApplyHeadline',
	            children: [{
	                name: '$BmlApplyRoute'
	            }, {
	                name: '$BmlTermsAndConditionsRoute'
	            }, {
	                name: '$BmlSignatureRoute'
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-credit-components/src/bml-display", "components/xo-credit-components/src/bml-display/route.js"))

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/template.html"), __webpack_require__("./components/xo-models/src/bml/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-bml-display.directive', ['squid', 'xomodel.bml', 'beaver']).factory('$BMLStateHandler', function ($state, $logger) {
	
	        var APPROVED = 'APPROVED';
	        var SOFT_DECLINED = 'SOFT_DECLINED';
	        var DECLINED = 'DECLINED';
	        var FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER = 'FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER';
	        var NEED_SIGNATURE = 'NEED_SIGNATURE';
	        var PENDING_COMPLETION_STATUS = 'PENDING_COMPLETION_STATUS';
	        var FULL_APPLY_REQUIRED = 'FULL_APPLY_REQUIRED';
	        var UNKNOWN_DECISION = 'UNKNOWN_DECISION';
	        var INELIGIBLE = 'INELIGIBLE'; // TODO; This state is returned by applybml but was not defined in Aries
	        var MAX_SOFT_DECLINES = config.bmlMaxSoftDeclines; // eslint-disable-line block-scoped-var,no-undef
	
	        var BMLStateHandler = function BMLStateHandler(bmlData) {
	            this.reviewUrl = bmlData.reviewUrl;
	            this.bml = bmlData.bml;
	            this.bmlApply = bmlData.bmlApply;
	            this.bmlComplete = bmlData.bmlComplete;
	            this.checkoutSession = bmlData.checkoutSession;
	            this.auth = bmlData.auth;
	            this.purchase = bmlData.purchase;
	            this.patchPhone = bmlData.patchPhone;
	            this.billingAddresses = bmlData.billingAddresses;
	            this.merchant = bmlData.merchant;
	            this.merchantId = bmlData.merchantId;
	
	            this.handlers = {};
	            this.handlers[APPROVED] = this.handleAppStatusApproved;
	            this.handlers[DECLINED] = this.handleAppStatusDeclined;
	            this.handlers[SOFT_DECLINED] = this.handleAppStatusSoftDeclined;
	            this.handlers[FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER] = this.handleAppStatusFundingInsExist;
	            this.handlers[NEED_SIGNATURE] = this.handleAppStatusNeedSignature;
	            this.handlers[PENDING_COMPLETION_STATUS] = this.handleAppStatusPendingCompletion;
	            this.handlers[UNKNOWN_DECISION] = this.handleAppStatusUnknownDecision;
	            this.handlers[FULL_APPLY_REQUIRED] = this.handleAppStatusFullApplyRequired;
	            this.handlers[INELIGIBLE] = this.handleAppStatusIneligible;
	        };
	
	        BMLStateHandler.prototype.payInFullRedirect = function payInFullRedirect(result) {
	            $logger.info('APPLYFORBML_VIEW_OPTOUTBML');
	            $state.go(this.reviewUrl);
	        };
	
	        BMLStateHandler.prototype.termsAndCondition = function termsAndCondition(result) {
	            $state.go('^.bmltermsandconditions');
	        };
	
	        BMLStateHandler.prototype.handleAppStatusIneligible = function handleAppStatusIneligible(result) {
	            $logger.info('APPLYFORBML_INELIGIBLE');
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'bmlIneligible'
	            });
	            this.checkoutSession.bmlOffer = false;
	            this.checkoutSession.creditOffer = false;
	            this.checkoutSession.showDeclinePopup = true;
	            $state.go(this.reviewUrl);
	        };
	
	        BMLStateHandler.prototype.handleAppStatusUnknownDecision = function handleAppStatusUnknownDecision(result) {
	            $logger.info('APPLYFORBML_UNKNOWN_DECISION');
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'bmlUnknownDecision'
	            });
	            this.checkoutSession.bmlOffer = false;
	            this.checkoutSession.creditOffer = false;
	            this.checkoutSession.showDeclinePopup = true;
	            $state.go(this.reviewUrl);
	        };
	
	        BMLStateHandler.prototype.handleAppStatusApproved = function handleAppStatusApproved(result) {
	            $logger.info('APPLYFORBML_ACTION_BMLSUCCESS');
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'bmlSuccess'
	            });
	            this.checkoutSession.fundingOptions.action('update', {
	                resultModel: this.checkoutSession,
	                data: {
	                    planId: this.bml.financial_instrument_id
	                },
	                success: $.proxy(function (successResult) {
	                    $state.go(this.reviewUrl);
	                }, this),
	                contingencies: {
	                    DEFAULT: function DEFAULT(name) {
	                        $state.go(this.reviewUrl);
	                    }
	                }
	            });
	        };
	
	        BMLStateHandler.prototype.handleAppStatusPendingCompletion = function handleAppStatusPendingCompletion(result) {
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'completeBmlApply'
	            });
	            this.completeApplication(result.application_id);
	        };
	
	        BMLStateHandler.prototype.handleAppStatusNeedSignature = function handleAppStatusNeedSignature(result) {
	            $logger.info('APPLYFORBML_NEED_SIGNATURE');
	            this.bml.application_id = result.application_id;
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'needSignature'
	            });
	            $state.go('^.bmlsignature');
	        };
	
	        BMLStateHandler.prototype.handleAppStatusDeclined = function handleAppStatusDeclined(result) {
	
	            $logger.info('APPLYFORBML_ACTION_BMLDECLINEHARD');
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'creditDeclineHard'
	            });
	            this.bml.application_status = 'DECLINED';
	            this.checkoutSession.bmlOffer = false;
	            this.checkoutSession.creditOffer = false;
	            this.checkoutSession.showDeclinePopup = true;
	
	            $state.go(this.reviewUrl);
	        };
	
	        BMLStateHandler.prototype.handleAppStatusSoftDeclined = function handleAppStatusSoftDeclined(result) {
	
	            this.bml.bmlSoftDeclineCtr = (this.bml.bmlSoftDeclineCtr || 0) + 1;
	            if (this.bml.bmlSoftDeclineCtr < MAX_SOFT_DECLINES) {
	                $logger.info('APPLYFORBML_ACTION_BMLDECLINESOFT');
	                $state.go('^.bmlapply');
	            } else {
	                $logger.info('checkout_fpti', {
	                    'ppc_status': 'bmlMaxAttempts'
	                });
	                $logger.info('APPLYFORBML_ACTION_BMLMAXATTEMPTS');
	                this.bml.application_status = 'DECLINED';
	                this.checkoutSession.bmlOffer = false;
	                this.checkoutSession.creditOffer = false;
	                this.checkoutSession.showDeclinePopup = true;
	
	                $state.go(this.reviewUrl);
	            }
	        };
	
	        BMLStateHandler.prototype.handleAppStatusFundingInsExist = function handleAppStatusFundingInsExist(result) {
	            $logger.info('APPLYFORBML_ACTION_BMLDECLINELINKEDTODIFFMEMBER');
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'bmlDeclineLinkedToDiffMember'
	            });
	            this.checkoutSession.bmlOffer = false;
	            this.checkoutSession.creditOffer = false;
	            this.checkoutSession.showDeclinePopup = true;
	            $state.go(this.reviewUrl);
	        };
	
	        BMLStateHandler.prototype.handleAppStatusFullApplyRequired = function handleAppStatusFullApplyRequired(result) {
	            $logger.info('APPLYFORBML_FULLAPPLYREQUIRED');
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'fullApplyRequired'
	            });
	            this.checkoutSession.bmlOffer = false;
	            this.checkoutSession.creditOffer = false;
	            this.bml.fullApplyRequired = true;
	            this.checkoutSession.showDeclinePopup = true;
	
	            $state.go(this.reviewUrl);
	        };
	
	        BMLStateHandler.prototype.handleBmlTransitions = function handleBmlTransitions(result) {
	            var handler = this.handlers[result.application_status];
	            if (!handler) {
	                throw new Error('no registered handler for bml transition for application status ' + result.application_status);
	            }
	            return $.proxy(handler, this, result)();
	        };
	
	        BMLStateHandler.prototype.completeApplication = function completeApplication(application_id) {
	
	            this.bmlComplete.application_id = application_id;
	            this.bmlComplete.action('complete', {
	
	                success: $.proxy(function (result) {
	                    $logger.info('COMPLETEBMLAPPLY_ACTION_BMLSUCCESS');
	                    var bml = this.bml;
	
	                    // Update the application_status & financial_instrument_id in bml model
	                    bml.setProperties({
	                        financial_instrument_id: result.financial_instrument_id,
	                        application_status: result.application_status
	                    });
	
	                    if (bml.phoneChanged && result && result.user_info && result.user_info.phones && result.user_info.phones.length > 0 && result.user_info.phones[0].id) {
	
	                        var newPhoneVO = {
	                            op: 'add',
	                            path: '/payer_info',
	                            value: {
	                                phone: this.bmlApply.personalInformation.phone.telephone
	                            }
	                        };
	                        this.patchPhone.save({
	                            data: {
	                                patch: newPhoneVO
	                            },
	                            success: $.proxy(function () {
	                                delete bml.phoneChanged;
	                                this.handleBmlTransitions(result);
	                            }, this),
	                            contingencies: {
	                                DEFAULT: $.proxy(function handleContingency(name, contingency) {
	                                    $logger.info('BMLPATCHPHONE_CONTINGENCY', name);
	                                    this.handleBmlTransitions(result);
	                                }, this)
	                            }
	                        });
	                    } else {
	                        this.handleBmlTransitions(result);
	                    }
	                }, this)
	            });
	        };
	
	        BMLStateHandler.prototype.getDefaultBillingAddress = function getDefaultBillingAddress(billingAddresses) {
	            var defaultBillingAddress = billingAddresses && billingAddresses.addresses;
	            defaultBillingAddress = defaultBillingAddress.map(function (address, index, array) {
	                if (address && address['default'] === true) {
	                    return address;
	                }
	            });
	
	            defaultBillingAddress = defaultBillingAddress.length > 0 && defaultBillingAddress[0];
	            return defaultBillingAddress;
	        };
	
	        BMLStateHandler.prototype.applyBML = function applyBML() {
	
	            var defaultBillingAddress = this.getDefaultBillingAddress(this.billingAddresses);
	
	            this.bml.action('apply', {
	                data: {
	                    flow: {
	                        nape: this.bml.nape,
	                        fullApplyRequired: this.bml.fullApplyRequired
	                    },
	                    payer: {
	                        email: this.checkoutSession.payer.email,
	                        id: this.checkoutSession.payer.id,
	                        phone: this.bmlApply.personalInformation.phone.telephone,
	                        phone_type: this.bmlApply.personalInformation.phone.phoneType
	                    },
	                    billing_address: {
	                        line1: defaultBillingAddress.line1,
	                        line2: defaultBillingAddress.line2,
	                        city: defaultBillingAddress.city,
	                        state: defaultBillingAddress.state,
	                        postal_code: defaultBillingAddress.postal_code,
	                        country: defaultBillingAddress.country,
	                        id: defaultBillingAddress.id
	                    },
	                    payment_info: {
	                        total_transaction_amount: {
	                            value: this.purchase.amounts.total.amount,
	                            currency: this.purchase.amounts.total.currency_code
	                        },
	                        recipient: {
	                            id: this.merchantId,
	                            total_amount: {
	                                value: this.purchase.amounts.total.amount,
	                                currency: this.purchase.amounts.total.currency_code
	                            },
	                            business_name: this.merchant.brand_name,
	                            type: 'PAYPAL_CORE',
	                            multi_seller_indicator: false,
	                            country_code: this.merchant.merchant_country
	                        },
	                        shipping_address: {
	                            id: this.checkoutSession.shipping.id,
	                            name: this.checkoutSession.shipping.name,
	                            line1: this.checkoutSession.shipping.line1,
	                            line2: this.checkoutSession.shipping.line2,
	                            city: this.checkoutSession.shipping.city,
	                            state: this.checkoutSession.shipping.state,
	                            country_code: this.checkoutSession.shipping.country,
	                            postal_code: this.checkoutSession.shipping.postal_code,
	                            'default': this.checkoutSession.shipping['default']
	                        },
	                        name: {
	                            first_name: this.auth.first_name,
	                            last_name: this.auth.last_name
	                        },
	                        item_info: this.purchase.items
	                    },
	                    dobSsn: {
	                        dobMonth: this.bmlApply.personalInformation.month,
	                        dobDay: this.bmlApply.personalInformation.day,
	                        dobYear: this.bmlApply.personalInformation.year,
	                        nationalId: this.bmlApply.personalInformation.natId
	                    }
	                },
	
	                resultModel: this.bml,
	
	                success: $.proxy(function (result) {
	                    this.handleBmlTransitions(result);
	                }, this),
	
	                contingencies: {
	                    DEFAULT: $.proxy(function handleContingency(name, contingency) {
	                        this.bml.contingency = name;
	                        this.checkoutSession.bmlOffer = false;
	                        this.checkoutSession.creditOffer = false;
	                        this.checkoutSession.showDeclinePopup = true;
	                        $state.go(this.reviewUrl);
	                    }, this)
	                }
	            });
	        };
	
	        return BMLStateHandler;
	    }).directive('xoBmlDisplay', function () {
	        return {
	            template: template,
	            scope: {
	                reviewUrl: '='
	            },
	
	            controller: function controller($scope, $state, $rootScope, $BMLModel, $ApplyForBMLModel, $BMLApplicationModel, $stateParams) {
	
	                if (!$rootScope.bml && !$rootScope.bmlApply) {
	                    $scope.bml = new $BMLModel();
	                    $scope.bmlApply = new $ApplyForBMLModel();
	                } else {
	                    $scope.bml = $rootScope.bml;
	                    $scope.bmlApply = $rootScope.bmlApply;
	                }
	                $scope.bmlComplete = new $BMLApplicationModel();
	
	                $state.go('^.bmlapply');
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-credit-components/src/bml-display", "components/xo-credit-components/src/bml-display/directive.js", __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/template.html":
/***/ function(module, exports) {

	module.exports = "<div ui-view>\n</div>\n"

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-apply/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-apply/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-bml-apply.route', ['squid', 'xo-bml-apply.directive']).factory('$BmlApplyRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('BmlApplyRoute', {
	
	            name: 'bmlapply',
	            trackingData: {
	                fptiState: 'ppc_apply'
	            },
	            directive: 'xo-bml-apply-page',
	            titleContent: 'applyForBml.bmlApplyHeadline',
	
	            children: []
	
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-credit-components/src/bml-display/xo-bml-apply", "components/xo-credit-components/src/bml-display/xo-bml-apply/route.js"))

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-apply/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-apply/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-form-components/src/phone/phoneInput/directive.js"), __webpack_require__("./components/xo-form-components/src/dob-nationalid/directive.js"), __webpack_require__("./components/xo-ui-components/src/tooltip/directive.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-models/src/bml/index.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-models/src/credit/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-bml-apply.directive', ['squid', 'xomodel.checkout', 'xo-title.directive', 'xo-message.directive', 'xo-address-display.directive', 'xo-phone.phoneInput', 'xo-dob-nationalid.directive', 'xo-tooltip.directive', 'xo-add-address.directive', 'xomodel.bml', 'xomodel.address', 'xomodel.user', 'xomodel.fi', 'xomodel.auth', 'beaver']).directive('xoBmlApplyPage', function () {
	
	        return {
	
	            template: template,
	
	            controller: function controller($scope, $rootScope, $state, $locale, $populate, $BillingAddressModel, $BillingAddressesModel, $AuthModel, $ValidateAddressModel, $element, $ValidatePhoneModel, $CheckoutSessionModel, $CheckoutAppDataModel, $BMLStateHandler, $CheckoutCartModel, $CheckoutPayeeModel, $CreditInstallmentModel, $logger, $PatchPhoneModel) {
	
	                $populate($scope, {
	                    auth: $AuthModel.instance(),
	                    payee: $CheckoutPayeeModel.instance($rootScope.token),
	                    billingAddresses: $BillingAddressesModel.instance(),
	                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($rootScope.token),
	                    checkoutCart: $CheckoutCartModel.instance($rootScope.token),
	                    creditOptions: $CreditInstallmentModel.instance($rootScope.token)
	                }).then(function () {
	                    var defaultBillingAddress = $scope.billingAddresses && $scope.billingAddresses.addresses;
	                    defaultBillingAddress = defaultBillingAddress.map(function (address, index, array) {
	                        if (address && address['default'] === true) {
	                            return address;
	                        }
	                    });
	
	                    defaultBillingAddress = defaultBillingAddress.length > 0 && defaultBillingAddress[0];
	                    if (defaultBillingAddress) {
	                        $scope.bml.action('napeLookUp', {
	
	                            data: {
	                                payer: $scope.checkoutSession.payer,
	                                billing_address: {
	                                    country: defaultBillingAddress.country,
	                                    line1: defaultBillingAddress.line1,
	                                    line2: defaultBillingAddress.line2,
	                                    city: defaultBillingAddress.city,
	                                    state: defaultBillingAddress.state,
	                                    postal_code: defaultBillingAddress.postal_code
	                                }
	                            },
	
	                            success: function success(result) {
	                                if (result && result.account_exists === true) {
	                                    $scope.bml.nape = 'napePotential';
	                                    $scope.bml.fullApplyRequired = false;
	                                }
	                            },
	                            contingencies: {
	                                DEFAULT: function DEFAULT() {
	                                    // add a log here
	                                }
	                            }
	                        });
	                    }
	
	                    if ($scope.billingAddresses && $scope.billingAddresses.addresses && $scope.billingAddresses.addresses.length > 0) {
	                        $scope.billingAddresses.addresses.forEach(function (address) {
	                            if (address['default']) {
	                                $scope.address = billingAddressObject(address);
	                                $scope.previousDefaultBillingAddress = address;
	                            }
	                        });
	                    }
	
	                    var bmlData = {
	                        reviewUrl: $scope.$parent.reviewUrl,
	                        bml: $scope.$parent.bml,
	                        bmlApply: $scope.$parent.bmlApply,
	                        bmlComplete: $scope.$parent.bmlComplete,
	                        checkoutSession: $scope.checkoutSession,
	                        auth: $scope.auth,
	                        purchase: $scope.checkoutCart.purchase,
	                        patchPhone: $scope.patchPhoneModel,
	                        billingAddresses: $scope.billingAddresses,
	                        merchant: $scope.checkoutAppData.merchant,
	                        merchantId: $scope.payee.merchant.id
	                    };
	
	                    $scope.bmlStateHandler = new $BMLStateHandler(bmlData);
	
	                    if ($scope.checkoutSession.payer) {
	                        $scope.bmlApply.personalInformation.phone.telephone = $scope.checkoutSession.payer.phone;
	                        $scope.bmlApply.personalInformation.phone.phoneType = 'MOBILE';
	                        // Set mobile as default to prevent unknown type.
	                    } else {
	                        $scope.bmlFlags.PhoneAdd = true;
	                    }
	                });
	
	                var $el = $($element);
	
	                $scope.showPhone = function () {
	                    return $scope.checkoutSession.payer.phone && $scope.checkoutSession.payer.phone_type === 'WORK';
	                };
	                $scope.patchPhoneModel = new $PatchPhoneModel();
	                $scope.patchPhoneModel.token = $scope.token;
	
	                $scope.init = function () {
	                    $scope.checkoutSession.message = null;
	
	                    $scope.previousDefaultBillingAddress = {};
	                    $scope.bmlFlags = {};
	                    $scope.address = {};
	                    $scope.token = $rootScope.token;
	                    $scope.countryCode = $locale.country;
	                    $scope.validateAddress = new $ValidateAddressModel();
	                    $scope.validatePhoneModel = new $ValidatePhoneModel();
	                    $scope.validatePhoneModel.token = $scope.token;
	
	                    $scope.bmlFlags.billingAddressUpdated = false;
	                    $scope.bmlFlags.AddressAdd = false;
	                    $scope.bmlFlags.AddressDisplay = true;
	                    $scope.bmlFlags.PhoneAdd = false;
	                    $scope.bmlFlags.ChangeLink = true;
	                    $scope.billingAddressUpdated = false;
	
	                    $('.paypalHeaderWrapper').addClass('paypalCredit');
	                    $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
	                    $('.paypalHeader').addClass('span14');
	                    $('.paypalHeader').removeClass('span24');
	
	                    if ($scope.bml && $scope.bml.application_status === 'SOFT_DECLINED') {
	                        $scope.checkoutSession.message = {
	                            type: 'warning',
	                            msgKeys: ['applyForBml.bmlDeclineSoft']
	                        };
	                    }
	                    $logger.info('APPLYFORBML_VIEW_RENDER');
	                };
	
	                $scope.redirectToReview = function () {
	                    $scope.bmlStateHandler.payInFullRedirect();
	                };
	
	                $scope.onContinue = function () {
	                    if ($scope.validateLegalAge()) {
	                        if ($scope.bmlFlags.billingAddressUpdated) {
	                            $scope.validateBillingAddress();
	                        } else {
	                            triggerNextState();
	                        }
	                    }
	                };
	
	                $scope.validateLegalAge = function () {
	                    var dobMonth = $scope.bmlApply.personalInformation.month,
	                        dobDay = $scope.bmlApply.personalInformation.day,
	                        dobYear = $scope.bmlApply.personalInformation.year,
	                        currentDate = new Date(),
	                        currentMonth = currentDate.getMonth() + 1,
	                        currentDay = currentDate.getDate(),
	                        currentYear = currentDate.getFullYear(),
	                        largestDOBYear = currentYear - 18; // Legal Age is 18
	
	                    var isLegal = dobYear < largestDOBYear || dobYear === largestDOBYear && dobMonth < currentMonth || // eslint-disable-line no-extra-parens
	                    dobYear === largestDOBYear && dobMonth === currentMonth && dobDay <= currentDay; // eslint-disable-line no-extra-parens
	
	                    if (!isLegal) {
	                        handleDobValidation();
	                    }
	
	                    return isLegal;
	                };
	
	                function handleDobValidation() {
	                    var $fields = $('#dobSelect .dropdown select');
	                    $fields.addClass('backendError');
	                    if (window.scrollTo) {
	                        window.scrollTo(0, 0);
	                    }
	                }
	
	                function triggerNextState() {
	                    $logger.info('APPLYFORBML_VIEW_SUBMIT');
	                    if ($scope.bml.nape === 'napePotential') {
	                        $scope.bmlStateHandler.applyBML();
	                    } else {
	                        $scope.checkoutSession.message = null;
	                        $scope.bmlStateHandler.termsAndCondition();
	                    }
	                }
	
	                $scope.changeAddress = function () {
	
	                    $scope.bmlFlags.billingAddressUpdated = true;
	                    $scope.bml.phoneChanged = true;
	                    $scope.bmlFlags.AddressAdd = true;
	                    $scope.bmlFlags.AddressDisplay = false;
	                    $scope.bmlFlags.PhoneAdd = true;
	                    $scope.bmlFlags.ChangeLink = false;
	                };
	
	                $scope.changePlan = function () {
	                    $state.go('checkout.chooseCreditOffer');
	                };
	
	                $scope.validateBillingAddress = function () {
	                    var newBilling = billingAddressObject($scope.address);
	                    newBilling['default'] = true;
	                    $scope.previousDefaultBillingAddress['default'] = false;
	                    $scope.validatePhoneModel.save({
	                        data: {
	                            telephone: $scope.bmlApply.personalInformation.phone.telephone,
	                            phoneType: $scope.bmlApply.personalInformation.phone.phoneType
	                        },
	                        success: function success(result) {
	
	                            if (result) {
	                                newBilling.save({
	                                    data: $scope.billingAddress,
	
	                                    success: function success() {
	                                        $scope.updateBillingAddress(newBilling);
	                                    },
	
	                                    validation: function validation(res) {
	                                        handleValidation(res);
	                                    }
	                                });
	                            } else {
	                                handlePhoneValidation(result);
	                            }
	                        },
	                        validation: function validation(result) {
	                            handlePhoneValidation(result);
	                        }
	                    });
	                };
	
	                $scope.updateBillingAddress = function (newBillingAddress) {
	                    var addresses = $scope.billingAddresses.addresses;
	                    if (!isUserInputtedAddress(addresses[0])) {
	                        addresses.unshift(newBillingAddress);
	                    } else {
	                        addresses[0] = newBillingAddress;
	                    }
	                    triggerNextState();
	                };
	
	                function isUserInputtedAddress(address) {
	                    return address.id === '0';
	                }
	
	                function handleValidation(res) {
	                    if (res && res.fields && res.fields.length) {
	                        res.fields.forEach(function (field) {
	                            if (field.field) {
	                                var $field = $($el.find('[name="' + field.field + '"]'));
	                                $field.addClass('backendError');
	                            }
	                        });
	                    }
	
	                    $scope.checkoutSession.message = {
	                        type: 'error',
	                        msgKeys: ['genericError.incontextGenericPageError']
	                    };
	
	                    if (window.scrollTo) {
	                        window.scrollTo(0, 0);
	                    }
	                }
	
	                function handlePhoneValidation() {
	                    var $field = $('.telephone');
	                    $field.addClass('backendError');
	                    if (window.scrollTo) {
	                        window.scrollTo(0, 0);
	                    }
	                }
	
	                function billingAddressObject(address) {
	                    return new $BillingAddressModel({
	                        line1: address.line1,
	                        line2: address.line2,
	                        city: address.city,
	                        state: address.state,
	                        postal_code: address.postal_code,
	                        country: $scope.countryCode,
	                        full_address: address.full_address,
	                        id: '0'
	                    });
	                }
	
	                $scope.init();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-apply/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"signupbml\" id=\"signupbml\" content>\n    <xo-title title-txt=\"{{content('signupBml.title')}}\" class=\"accessAid\"></xo-title>\n    <div class=\"row-fluid justMember\">\n        <div class=\"span14 trayInner\">\n\n            <div class=\"title\">\n                <xo-message message=\"checkoutSession.message\"></xo-message>\n            </div>\n\n            <!--Title-->\n            <div id=\"title\">\n                <h2 class=\"beta\">{{ content('applyForBml.bmlApplyHeadlineShort') }}</h2>\n                <p>{{ content('applyForBml.bmlApplyWithPayPal') }}</p>\n            </div>\n\n            <form id=\"userInfoForm\" name=\"userInfoForm\" ng-submit=\"userInfoForm.$valid && onContinue()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n                <!--Installment information-->\n                <div class=\"bmlRow\" ng-if=\"creditOptions.creditType\">\n                    <div class=\"billingAddressRow\">\n                        <h4 class=\"noBottom gamma sameLine\">{{ content('chooseCreditOption.paymentPlan') }}</h4>\n                        <a id=\"changePlanLink\" class=\"changeBillingAddress sameLine\" ng-click=\"changePlan()\">{{ content('common.change') }}</a>\n                    </div>\n\n                    <div class=\"installmentInfo\" ng-if=\"creditOptions.creditType==='INST'\">\n                        <p class=\"billingName\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText1',{term:creditOptions.term, monthlyPayment: creditOptions.monthlyPayment})\"></p>\n                        <p class=\"installmentDescription\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText2',{apr:creditOptions.apr, interest: creditOptions.totalInterest, totalPayment: creditOptions.totalPayment})\"></p>\n                    </div>\n\n                    <div class=\"installmentInfo\" ng-if=\"creditOptions.creditType==='SAC'\">\n                        <p class=\"billingName\" ng-bind-html=\"htmlContent('applyForBml.bmlSACOfferDetail')\"></p>\n                    </div>\n                </div>\n\n                <!--Personal information-->\n                <div class=\"bmlRow\">\n                    <h4 class=\"piHeight gamma\">{{ content('applyForBml.personalInfo') }}\n                        <a class=\"verifyHelp\" id=\"verifyHelp\"></a>\n\n                        <xo-tooltip trigger=\"#verifyHelp\" show-event=\"click\">\n                            {{ content('applyForBml.ssnToolTip') }}\n                        </xo-tooltip>\n                    </h4>\n\n                    <div class=\"dobNatlIdGroup\">\n                        <xo-dob-nationalid pi=\"bmlApply.personalInformation\"></xo-dob-nationalid>\n                    </div>\n                </div>\n\n\n                <!--Billing Address-->\n                <div class=\"bmlRow\">\n                    <div class=\"billingAddressRow\">\n                        <h4 class=\"noBottom gamma sameLine\">{{ content('applyForBml.bmlApplyBillingAddress') }}</h4>\n                        <a id=\"changeAddressLink\" class=\"changeBillingAddress sameLine\" ng-show=\"bmlFlags.ChangeLink\" ng-click=\"changeAddress()\">{{ content('common.change') }}</a>\n                    </div>\n\n                    <div id=\"bmlGivenName\">\n                        <p class=\"billingName\">{{auth.first_name}}&nbsp{{auth.last_name}}</p>\n                    </div>\n\n                    <div id=\"bmlAddressDisplay\" class=\"billingAddressRow\" ng-show=\"bmlFlags.AddressDisplay\">\n                        <xo-address-display address=address country-code=countryCode></xo-address-display>\n                        <div id=\"bmlBillingPhone\" class=\"bmlBillingPhone adr\">{{bmlApply.personalInformation.phone.telephone}}</div>\n                    </div>\n\n                    <div id=\"bmlAddressAdd\" class=\"bmlMargin\" ng-show=\"bmlFlags.AddressAdd\">\n                        <xo-add-address country=countryCode address=\"address\" token=\"token\"></xo-add-address>\n                    </div>\n\n                    <div id=\"addPhone\" class=\"addPhone\" ng-show=\"bmlFlags.PhoneAdd\">\n                        <xo-phone-input token=\"token\" exclude=\"WORK\" phone=\"bmlApply.personalInformation.phone\"></xo-phone-input>\n                    </div>\n\n                </div>\n\n                <!--Agree and Continue-->\n                <p class=\"bmlSeeTerms\" bind-html-compile=\"htmlContent('applyForBml.bmlApplyESign')\"></p>\n\n                <div class=\"buttons\">\n                    <input type=\"submit\" track-submit='bml_apply' id=\"bmlAgreeAndContinue\" name=\"bmlAgreeAndContinue\"\n                           value=\"{{content('applyForBml.bmlApplyTermsSubmit')}}\" class=\"btn full\" ng-click=\"validated=true\" />\n                </div>\n\n            </form>\n\n            <div class=\"bmlMargin\" id=\"bmlBottomText\">\n                <p class=\"bmlSeeTerms sameLine\">{{ content('applyForBml.notInterestedNoInstallments') }}</p>\n                <p class=\"bmlSeeTerms sameLine payInFullLink\" ng-bind-html=\"htmlContent('applyForBml.payInFull')\"\n                   ng-click=\"redirectToReview()\"></p>\n            </div>\n\n            <div id=\"bmlLender\">\n                <p class=\"bmlSeeTerms\">{{ content('base.bmlLender') }}</p>\n            </div>\n\n        </div>\n\n        <div class=\"span10 trayInner\" id=\"bmlApplyEdu\">\n            <h2 class=\"gamma\">{{ content('applyForBml.bmlApplyEduTitle') }}</h2>\n            <ul>\n                <li>{{ content('applyForBml.bmlApplyEduBullet1') }}</li>\n                <li>{{ content('applyForBml.bmlApplyEduBullet2') }}</li>\n                <li>{{ content('applyForBml.bmlApplyEduBullet3') }}</li>\n            </ul>\n            <p>{{ content('applyForBml.bmlApplyInterestTerms') }}</p>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ },

/***/ "./components/xo-form-components/src/dob-nationalid/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/dob-nationalid/template.html"), __webpack_require__("./components/xo-ui-components/src/tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-dob-nationalid.directive', ['squid', 'xo-tooltip.directive']).directive('xoDobNationalid', function () {
	        var padNumber = function padNumber(num) {
	            return num.toString().replace(/^(\d)$/, '0$1');
	        };
	        /**
	         * Create an array from a start and end number.
	         * @param  {Number} start
	         * @param  {Number} end
	         * @return {Array}
	         */
	        var getRange = function getRange(start, end) {
	            var arr = [];
	            // decide how this array shall be sorted
	            if (start < end) {
	                for (; start <= end; start++) {
	                    arr.push(padNumber(start));
	                }
	            } else {
	                for (; start >= end; start--) {
	                    arr.push(padNumber(start));
	                }
	            }
	            return arr;
	        };
	
	        return {
	            template: template,
	            scope: {
	                pi: '='
	            },
	
	            controller: function controller($scope) {
	
	                $scope.init = function () {
	                    var thisYear = new Date().getFullYear();
	                    $scope.days = getRange(1, 31);
	                    $scope.months = getRange(1, 12);
	                    $scope.years = getRange(thisYear - 18, thisYear - 110);
	                };
	                $scope.init();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/dob-nationalid/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"dobNationalId\" class=\"dobNatlIdGroup fieldGroup clearfix\" content>\n\n    <div id=\"dobSelect\" class=\"dob bankField restricted\">\n        <fieldset>\n            <legend class=\"fieldLegend\" for=\"dob\">{{content('applyForBml.bmlApplyDateOfBirth')}}</legend>\n\n            <div class=\"dropdown fidobMonth\">\n                <select xo-dropdown name=\"dobMonth\" ng-model=\"pi.month\" id=\"dobMonth\" aria-label=\"{{content('applyForBml.bmlApplyMonth')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyMM')}}</option>\n                    <option ng-repeat=\"month in months\" value=\"{{month}}\" ng-selected=\"pi.month==='{{month}}'\">{{month}}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobDay\">\n                <select xo-dropdown name=\"dobDay\" ng-model=\"pi.day\" id=\"dobDay\" aria-label=\"{{content('applyForBml.bmlApplyDay')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyDD')}}</option>\n                    <option ng-repeat=\"day in days\" value=\"{{day}}\" ng-selected=\"pi.day==='{{day}}'\">{{day}}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobYear\">\n                <select xo-dropdown name=\"dobYear\" ng-model=\"pi.year\" id=\"dobYear\" aria-label=\"{{content('applyForBml.bmlApplyYear')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyYYYY')}}</option>\n                    <option ng-repeat=\"year in years\" value=\"{{year}}\" ng-selected=\"pi.year==='{{year}}'\">{{year}}</option>\n                </select>\n            </div>\n\n        </fieldset>\n    </div>\n\n    <div class=\"inputField confidential nationalId\" floating-label>\n        <input ng-model=\"pi.natId\" name=\"nationalId\" id=\"nationalId\" value=\"\" pattern=\"\\d{4}\" maxlength=\"4\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" placeholder=\"{{ content('applyForBml.lastFour') }}\" xo-error-tooltip required />\n        <label for=\"nationalId\">{{ content('applyForBml.bmlApplyLast4SSN') }}</label>\n        <xo-tooltip trigger=\"#nationalId\" show-event=\"click\">\n            {{ content('applyForBml.bmlApplyToolTipSSN') }}\n        </xo-tooltip>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-bml-terms-and-conditions.route', ['squid', 'xo-bml-terms-and-conditions.directive']).factory('$BmlTermsAndConditionsRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('BmlTermsAndConditionsRoute', {
	
	            name: 'bmltermsandconditions',
	            trackingData: {
	                fptiState: 'ppc_termsandconditions'
	            },
	            directive: 'xo-bml-terms-and-conditions-page',
	            titleContent: 'applyForBml.bmlApplyHeadline',
	
	            children: []
	
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions", "components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js"))

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/bml/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-bml-terms-and-conditions.directive', ['squid', 'xomodel.checkout', 'xo-title.directive', 'xo-message.directive', 'xomodel.checkout', 'xomodel.fi', 'xomodel.bml', 'xomodel.auth', 'xomodel.user', 'xo-device-info', 'beaver']).directive('xoBmlTermsAndConditionsPage', function () {
	
	        var linkFn = function linkFn(scope, element, attrs) {
	            var $agreeButton = $('#bmlAgreeToTerms');
	
	            var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent',
	                eventer = window[eventMethod],
	                data,
	                messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
	
	            // Browsers that support postMessage
	            if (window.postMessage) {
	                /**
	                 * Event to listen for post messages sent from PayPal popup window.
	                 * Data from PayPal will contains return url and the localised content.
	                 */
	                eventer(messageEvent, function (event) {
	                    data = angular.fromJson(event.data);
	                    if (data.action === 'scroll') {
	
	                        if (data.toEnd && !scope.isMobile) {
	                            scope.scrollComplete();
	                        }
	                    } else if (data.action === 'setHeight' && scope.isMobile) {
	                        $('.bmlTermsBody iframe').css('height', data.height + 20 + 'px');
	                    }
	                }, false);
	            }
	
	            $agreeButton.click(function (event) {
	                event.preventDefault();
	                scope.handleAgreeToTermsClick();
	            });
	        };
	
	        return {
	            template: template,
	            link: linkFn,
	
	            controller: function controller($scope, $populate, $rootScope, $state, $CheckoutPayeeModel, $BillingAddressesModel, $CheckoutCartModel, $CheckoutSessionModel, $AuthModel, $CheckoutAppDataModel, $BMLApplicationModel, $BMLStateHandler, $PatchPhoneModel, $DeviceInfo, $logger) {
	
	                if ($scope.$parent && $scope.$parent.bml) {
	                    $scope.bml = $scope.$parent.bml;
	                    $scope.bmlApply = $scope.$parent.bmlApply;
	                    $scope.bmlComplete = $scope.$parent.bmlComplete;
	                }
	                $populate($scope, {
	                    auth: $AuthModel.instance(),
	                    payee: $CheckoutPayeeModel.instance($rootScope.token),
	                    billingAddresses: $BillingAddressesModel.instance(),
	                    checkoutCart: $CheckoutCartModel.instance($rootScope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($rootScope.token),
	                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
	                }).then(function () {
	                    $scope.patchPhoneModel = new $PatchPhoneModel();
	                    $scope.patchPhoneModel.token = $scope.token;
	
	                    if ($scope.$parent && $scope.$parent.bml) {
	                        var bmlData = {
	                            reviewUrl: $scope.$parent.reviewUrl,
	                            bml: $scope.bml,
	                            bmlApply: $scope.bmlApply,
	                            bmlComplete: $scope.bmlComplete,
	                            checkoutSession: $scope.checkoutSession,
	                            auth: $scope.auth,
	                            purchase: $scope.checkoutCart.purchase,
	                            patchPhone: $scope.patchPhoneModel,
	                            billingAddresses: $scope.billingAddresses,
	                            merchant: $scope.checkoutAppData.merchant,
	                            merchantId: $scope.payee.merchant.id
	                        };
	
	                        $scope.bmlStateHandler = new $BMLStateHandler(bmlData);
	                    }
	                });
	
	                $scope.init = function () {
	                    $scope.token = $rootScope.token;
	                    $('.paypalHeaderWrapper').addClass('paypalCreditTnc');
	                    $('.paypalHeader').removeClass('span14');
	                    $('.paypalHeader').addClass('span24');
	                    $('.paypalHeader').addClass('headerBar');
	                    $('.footerWrapper').addClass('hide');
	                    $scope.isMobile = $DeviceInfo.isMobile();
	                    $scope.isMiniBrowser = $rootScope.miniBrowser;
	                    $scope.bmlFlags = {
	                        bmlFooterShow: true,
	                        full: true,
	                        xoFooter: true,
	                        enableFooter: true,
	                        showConfirmationModal: false,
	                        showModalBackdrop: true
	                    };
	
	                    if (window.scrollTo) {
	                        window.scrollTo(0, 0);
	                    }
	                    $logger.info('TERMSNCONDITIONS_VIEW_RENDER');
	                };
	
	                $scope.handleAgreeToTermsClick = function () {
	                    this.showConfirmationModal();
	                    $logger.info('bmlAgreeToTerms', {});
	                };
	
	                $scope.showConfirmationModal = function (show) {
	                    show = angular.isUndefined(show) ? true : show;
	                    $scope.bmlFlags.showConfirmationModal = show;
	                };
	
	                $scope.agreeToTermsConfirmation = function (event) {
	                    event.preventDefault();
	
	                    $logger.info('bmlConfirmAgreeToTermsPopup', {});
	                    this.showConfirmationModal(false);
	                    this.onContinue();
	                };
	
	                $scope.cancelApplication = function (event) {
	                    event.preventDefault();
	                    $logger.info('bmlCancelApplication', {});
	                    $scope.bmlStateHandler.payInFullRedirect();
	                };
	
	                // when the esc key is pressed
	                $('html').on('keyup', function (ev) {
	                    if (ev.which === 27) {
	                        $scope.showConfirmationModal(false);
	                    }
	                });
	
	                $scope.onContinue = function () {
	                    $logger.info('BMLTERMSNCONDITIONS_VIEW_SUBMIT');
	                    $scope.bmlStateHandler.applyBML();
	                };
	
	                $scope.init();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"bmlTermsAndConditions\" id=\"bmlTermsAndConditions\" content>\n\n    <div ng-show=\"bmlFlags.showConfirmationModal\" id=\"creditConfirmation\" class=\"modal bmlModal\" role=\"alertdialog\" tabindex=\"-1\">\n\n        <div ng-show=\"bmlFlags.showModalBackdrop\" class=\"modal-backdrop\"></div>\n\n        <div class=\"modal-wrap\">\n\n            <div class=\"paypalHeaderWrapper paypalCredit\">\n                <div class=\"logo\">\n                    <span class=\"accessAid\">{{content('applyForBml.payPalCredit')}}</span>\n                </div>\n                <a class=\"close\" href=\"#\" ng-click=\"showConfirmationModal(false)\">\n                    {{content('applyForBml.close')}}\n                </a>\n            </div>\n\n            <div class=\"confirmationPopupContent\">\n                <h2>{{content('applyForBml.justToConfirm')}}</h2>\n                <ul>\n                    <li>\n                        {{content('applyForBml.confirmationPopupListItem1')}}\n                    </li>\n                    <li>\n                        {{content('applyForBml.confirmationPopupListItem2', { email: auth.email })}}\n                    </li>\n                </ul>\n                <form id=\"confirmAgreeToTerms\">\n                    <input ng-click=\"agreeToTermsConfirmation($event)\" id=\"confirmAgreeToTermsSubmit\"\n                        class=\"btn btn-submit full\" type=\"submit\" value=\"{{content('applyForBml.agreeApply')}}\">\n                </form>\n            </div>\n            <div class=\"cancelApplicationBlock\">\n                <a ng-click=\"cancelApplication($event)\" id=\"cancelCreditApplication\" href=\"#\">\n                    {{content('applyForBml.cancelApplication')}}\n                </a>\n            </div>\n        </div>\n    </div>\n\n\n    <xo-title title-txt=\"{{content('signupBml.title')}}\" class=\"accessAid\"></xo-title>\n    <div class=\"row-fluid justMember\">\n        <div class=\"trayInner\">\n            <xo-message message=\"checkoutSession.message\"></xo-message>\n\n            <div class=\"bmlTermsHeader\">\n                <h2 class=\"gamma zeta bmlTermsHead\">{{ content('applyForBml.agreementTermsTitle') }}</h2>\n                <p class=\"printContent\">\n                    <a href=\"https://www.paypalobjects.com/webstatic/checkout/hermes/html/PayPalCreditTerms_print.html\" xo-popup class=popup target=\"_blank\">\n                       <span ng-if= \"!isMobile\" >{{ content('applyForBml.printCopy') }} </span>\n                        <span ng-if=\"isMobile\">{{ content('applyForBml.download') }}</span>\n                    </a>\n                </p>\n            </div>\n\n            <div class=\"span24 trayInner\">\n\n                <div class=\"bmlTermsInnerWrap\">\n                    <div class=\"bmlTermsBody\" tabindex=\"-1\">\n                        <iframe id= \"tncFrame\" src=\"https://www.paypalobjects.com/webstatic/checkout/hermes/html/PayPalCreditTerms_v2.html\"></iframe>\n                   </div>\n                </div>\n\n                <div class=\"bmlTermsFooter buttons\"\n                     ng-class=\"{'bmlTermsFooter buttons bmlFooterShow': bmlFlags.bmlFooterShow ,\n                                'bmlTermsFooter buttons enabled' : bmlFlags.enableFooter,\n                                'bmlTermsFooter buttons': !bmlFlags.bmlFooterShow || !bmlFlags.enableFooter}\">\n                    <div class=\"proceed\">\n                        <button id=\"bmlAgreeToTerms\" track-submit='ppc_agree_terms' class=\"btn bmlAgreeToTerms\"\n                                name=\"bmlAgreeApply\">{{content('applyForBml.agreeApply')}}</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-signature/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-signature/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-bml-signature.route', ['squid', 'xo-bml-signature.directive']).factory('$BmlSignatureRoute', function ($ComponentRoute) {
	        return $ComponentRoute.extend('BmlSignatureRoute', {
	
	            name: 'bmlsignature',
	            trackingData: {
	                fptiState: 'ppc_signature'
	            },
	            titleContent: 'consumerCreditInfo.applicationApprovedMessage',
	            directive: 'xo-bml-signature-page',
	
	            children: []
	
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-credit-components/src/bml-display/xo-bml-signature", "components/xo-credit-components/src/bml-display/xo-bml-signature/route.js"))

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-signature/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-signature/template.html"), __webpack_require__("./components/xo-models/src/bml/index.js"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-bml-signature.directive', ['squid', 'xomodel.bml', 'xo-value-props.directive', 'xo-title.directive', 'xo-message.directive', 'xo-error-tooltip.directive']).directive('xoBmlSignaturePage', function () {
	
	        return {
	            template: template,
	
	            controller: function controller($scope, $AuthModel, $populate, $state, $rootScope, $BMLApplicationModel) {
	                $populate($scope, {
	                    auth: $AuthModel.instance()
	                }).then(function () {
	
	                    $scope.init = function () {
	                        $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
	                        $('.paypalHeaderWrapper').addClass('paypalCredit');
	                        $('.paypalHeader').removeClass('span14');
	                        $('.paypalHeader').addClass('span24');
	                        $('.paypalHeader').addClass('headerBar');
	                        $scope.token = $rootScope.token;
	                        $scope.bmlSign = new $BMLApplicationModel();
	                    };
	
	                    $scope.onSubmit = function () {
	                        var application_id = $scope.bml.application_id;
	                        $scope.bmlSign.application_id = application_id;
	                        $scope.bmlSign.action('sign', {
	
	                            resultModel: $scope.bml,
	
	                            success: function success(result) {
	                                $state.go('checkout.review');
	                            }
	                        });
	                    };
	
	                    $scope.redirectToReview = function () {
	                        $state.go('checkout.review');
	                    };
	
	                    $scope.init();
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-signature/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"bmlSignature\" id=\"bmlSignature\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <xo-title title-txt=\"{{content('consumerCreditInfo.applicationApprovedMessage')}}\"></xo-title>\n            <form name=\"bmlSignatureForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"bmlSignatureForm.$valid && onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n                <p class=\"content\">{{content('consumerCreditInfo.reviewSecciMessage')}}</p>\n\n                <div class=\"agree checkbox legal\" ng-class=\"{error: validated && !bmlSignatureForm.$valid}\">\n                    <input ng-model=\"fields.agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" data-error-text=\"{{content('eConsent.eConsentError')}}\" xo-error-tooltip xo-validation='{\n                        \"validator\": \"isChecked\",\n                        \"options\": {\n                            \"el\": \"#agree\"\n                        }\n                    }' />\n                    <label id=\"confirmationMessage\" class=\"noBottom\" for=\"agree\" ng-bind-html=\"htmlContent('consumerCreditInfo.secciReadConfirmationMessage')\"></label>\n                </div>\n                <div class=\"buttons\">\n                    <input track-submit='bml_signature' type=\"submit\" value=\"{{content('common.continueLabel')}}\"\n                           class=\"btn full\" ng-click=\"validated=true\" />\n                </div>\n\n                <div class=\"bmlMargin\" id=\"bmlBottomText\">\n                    <p class=\"bmlSeeTerms sameLine\">{{ content('applyForBml.notInterestedNoInstallments') }}</p>\n                    <p class=\"bmlSeeTerms sameLine\" ng-bind-html=\"htmlContent('applyForBml.payInFull')\" ng-click=\"redirectToReview()\"></p>\n                </div>\n            </form>\n        </div>\n        <div class=\"span10 bmlMargin\">\n            <xo-value-props type=\"signature\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-credit-components/src/choose-credit-offer/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ChooseCreditOfferRoute = undefined;
	
	__webpack_require__("./components/xo-credit-components/src/choose-credit-offer/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $ChooseCreditOfferRoute = exports.$ChooseCreditOfferRoute = _squid.$ComponentRoute.extend('$ChooseCreditOfferRoute', {
	
	    path: 'chooseCreditOffer',
	    directive: 'xo-choose-credit-offer',
	    titleContent: 'chooseCreditOffer.choose',
	    trackingData: {
	        fptiState: 'choose_credit_offer'
	    },
	    auth: false,
	    children: []
	});
	
	angular.value("$ChooseCreditOfferRoute", $ChooseCreditOfferRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./components/xo-credit-components/src/choose-credit-offer/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	__webpack_require__("./components/xo-credit-components/src/choose-credit-offer/styles.less");
	
	var _template = __webpack_require__("./components/xo-credit-components/src/choose-credit-offer/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/credit/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoChooseCreditOfferDirective', {
	    tag: 'xo-choose-credit-offer',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                auth: _auth.$AuthModel.instance().retrieve(),
	                checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve(),
	                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
	                payee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
	                creditOptions: _index2.$CreditInstallmentModel.instance(this.props.token).retrieve(),
	                flowEligibility: _index.$FlowEligibilityModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        redirectToReview: function redirectToReview() {
	            $('body').removeClass('CYCOPage');
	            this.creditDataModel.payInFull = true;
	            if (!this.models.auth.logged_in) {
	                _uiRouter.$state.go('checkout.login');
	            } else {
	                _uiRouter.$state.go('checkout.review');
	            }
	        },
	        toggleSacOffer: function toggleSacOffer(isExtended) {
	            this.sacExtended = isExtended ? false : true;
	        },
	        toggleInstallmentOffer: function toggleInstallmentOffer(isExtended) {
	            this.installmentExtended = isExtended ? false : true;
	        },
	
	
	        getCreditFinancingCodes: function getCreditFinancingCodes(creditOffers) {
	            var financingCodes = '';
	            var installmentOffer = creditOffers.installment_options;
	            var sacOffer = creditOffers.sac_options;
	
	            if (installmentOffer && installmentOffer.length) {
	                installmentOffer.forEach(function (installment) {
	                    financingCodes += installment.financingCode;
	                    financingCodes += ',';
	                });
	            }
	
	            if (sacOffer) {
	                financingCodes += sacOffer.financingCode;
	            }
	
	            return financingCodes;
	        },
	
	        handleRedirect: function handleRedirect() {
	            var creditMemberType = this.isCreditInWallet ? 'existingMember' : 'newMember';
	            var isBuyerSet = this.fundingInstruments;
	            var isSignUpFlow = this.creditDataModel.isCreditSignup();
	            var isChangeInstallment = this.creditDataModel.isChangeStatus();
	            $('body').removeClass('CYCOPage');
	
	            if (isBuyerSet && creditMemberType === 'newMember' || isSignUpFlow && isChangeInstallment) {
	                _uiRouter.$state.go('checkout.redirectToCape');
	            } else if (creditMemberType === 'existingMember') {
	                _uiRouter.$state.go('checkout.review');
	            } else {
	                _uiRouter.$state.go('checkout.login');
	            }
	        },
	        onSelect: function onSelect(index) {
	            var _this = this;
	
	            if (index === 'CORE') {
	                if (this.models.creditOptions && this.models.creditOptions.creditType) {
	                    delete this.models.creditOptions.creditType;
	                }
	                _logger.$logger.info('checkout_fpti', {
	                    'credit_type': 'CORE'
	                });
	                this.actions.handleRedirect();
	            } else {
	                var isPPCReuse = this.isCreditInWallet;
	                var selectedOffer = index === 'SAC' ? this.creditOffers.sac_options : this.creditOffers.installment_options[index];
	                var param = {
	                    'financing_code': selectedOffer.financingCode,
	                    'apr': selectedOffer.apr,
	                    'term': selectedOffer.term,
	                    'credit_type': selectedOffer.creditType,
	                    'paypal_subsidy': selectedOffer.paypalSubsidy
	                };
	
	                if (index !== 'SAC') {
	                    param.monthly_percentage_rate = selectedOffer.monthlyPercentageRate;
	                    param.total_cost = selectedOffer.totalPayment.value;
	                    param.total_interest = selectedOffer.totalInterest.value;
	                    param.monthly_payment = selectedOffer.monthlyPayment.value;
	                    param.currency = selectedOffer.monthlyPayment.currency;
	                }
	
	                return this.models.creditOptions.action('select', {
	                    data: param,
	                    success: function success() {
	                        _logger.$logger.info('checkout_fpti', {
	                            'is_ppc_reuse': isPPCReuse ? '1' : '0',
	                            'credit_type': selectedOffer.creditType,
	                            'financing_code_selected': selectedOffer.financingCode
	                        });
	
	                        _this.actions.handleRedirect();
	                    }
	                });
	            }
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            this.offers = _index.$InstallmentOptionsModel.instance(this.props.token);
	            this.checkoutSession = _index.$CheckoutSessionModel.instance(this.props.token);
	            this.creditOffers = this.offers.installments && this.offers.installments[0];
	            this.creditDataModel = _index2.$CreditDataModel.instance(this.props.token);
	            this.installmentCount = this.creditOffers && this.creditOffers.installment_options && this.creditOffers.installment_options.length;
	            $('.paypalHeaderWrapper').addClass('paypalCredit');
	            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
	            $('body').addClass('CYCOPage');
	        },
	        populate: function populate() {
	            var _this2 = this;
	
	            var self = this;
	            this.fundingInstruments = this.checkoutSession.get('fundingOptions.instruments');
	            if (this.models.auth.logged_in && this.fundingInstruments) {
	                this.checkoutSession.retrieve();
	            }
	            this.isCreditInWallet = this.fundingInstruments && _squid.$util.some(this.fundingInstruments, function (fi) {
	                return fi.name === 'BILL_ME_LATER';
	            });
	
	            this.country = this.models.checkoutAppData.get('merchant.merchant_country');
	
	            function getFlowEligibility() {
	                return self.models.flowEligibility.reload({
	                    params: {
	                        'localeCountry': self.country
	                    }
	                });
	            }
	
	            function getInstallmentContent() {
	                var contentKey = 'chooseCreditOption.singleInstallmentDescription';
	                var isZeroAprAvailable = false;
	
	                if (self.installmentCount > 1) {
	                    self.creditOffers.installment_options.forEach(function (installment) {
	                        if (installment.apr === '0.00') {
	                            isZeroAprAvailable = true;
	                            contentKey = 'chooseCreditOption.installmentDescriptionAprZero';
	                        }
	                    });
	
	                    if (!isZeroAprAvailable) {
	                        contentKey = 'chooseCreditOption.installmentDescription2';
	                    }
	                }
	                return contentKey;
	            }
	
	            this.offers.save({
	                data: {
	                    payee: this.models.payee,
	                    checkoutCart: this.models.checkoutCart,
	                    checkoutAppData: this.models.checkoutAppData,
	                    isMemberCredit: true
	                }, success: function success(result) {
	                    _this2.creditOffers = result.installments && result.installments[0];
	                    var installmentsPresent = _this2.creditOffers && _this2.creditOffers.installment_options;
	                    _this2.installmentCount = installmentsPresent && _this2.creditOffers.installment_options.length;
	                    _this2.termsUrl = _this2.creditOffers ? (0, _squid.$feature)('creditOfferSeeTermsUrl') + _this2.creditOffers.terms_param : undefined;
	                    if (_this2.creditOffers) {
	                        _logger.$logger.info('checkout_fpti', {
	                            'financing_code_offered': _this2.actions.getCreditFinancingCodes(_this2.creditOffers)
	                        });
	                    }
	                    _this2.installmentContentKey = getInstallmentContent();
	                    var isFlowInstallmentEligible = getFlowEligibility().then(function (eligibility) {
	                        return eligibility.installment;
	                    });
	                    _this2.defaultinstallmentExtended = _this2.country === 'GB' && installmentsPresent && _this2.models.checkoutAppData.is_second_button_txn && isFlowInstallmentEligible;
	                    _this2.showSingleOffer = _this2.country === 'GB' && (installmentsPresent && (_this2.models.checkoutAppData.is_second_button_txn ? isFlowInstallmentEligible : _this2.checkoutSession && _this2.checkoutSession.creditOffer) ? false : true);
	                    _this2.showNoInterestSection = _this2.country === 'GB' ? !_this2.defaultinstallmentExtended : _this2.creditOffers && _this2.creditOffers.sac_options;
	                }
	            });
	        }
	    }
	
	});
	
	
	_squid.$Component;
	
	_squid.$util;
	
	_squid.$feature;
	
	_logger.$logger;
	
	_uiRouter.$state;
	
	_auth.$AuthModel;
	
	_index.$CheckoutSessionModel;
	
	_index.$CheckoutCartModel;
	
	_index.$InstallmentOptionsModel;
	
	_index.$CheckoutPayeeModel;
	
	_index.$CheckoutAppDataModel;
	
	_index.$FlowEligibilityModel;
	
	_index2.$CreditInstallmentModel;
	
	_index2.$CreditDataModel;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-credit-components/src/choose-credit-offer/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-credit-components/src/choose-credit-offer/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-credit-components/src/choose-credit-offer/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 20px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#7b8388}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v9_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#creditoffer .cycoHeader{margin-bottom:5px}#creditoffer .mainDescription{color:#6c7378}#creditoffer .inputField input{height:40px}#creditoffer p{margin-bottom:5px}#creditoffer .ukOfferDescription{width:90%}#creditoffer .offerTitle{font-weight:700}#creditoffer .offerSmallText{width:100%;margin-bottom:0;font-size:1em}#creditoffer .moreInfoLink{padding:7px 33px 4px 18px;position:absolute;top:12px;right:0;color:#0070ba;cursor:pointer;font-weight:500}#creditoffer .noMargin{top:2px}#creditoffer .down{background-position:-219px -234px}#creditoffer .up{background-position:-219px -219px}#creditoffer .frontArrow{top:10px;right:0;width:22px}#creditoffer .bmlLender{font-size:.75em;margin-top:10px;color:#6c7378}#creditoffer .bmlMargin{margin-top:15px}#creditoffer .sameLine{display:inline}#creditoffer .payInFullLink{font-weight:700}#creditoffer .payInFullText{color:#6c7378}#creditoffer .buttons{width:100%;margin-top:10px;-ms-box-sizing:border-box;box-sizing:border-box;bottom:0}#creditoffer .btn{width:100%}#creditoffer .smallText{padding:3px 35px 0;font-size:.75em}#creditoffer .extendedOfferContent{display:inline-block;width:75%;padding:10px 0}#creditoffer .chooseOffer,#creditoffer .ukChooseOffer{width:25%;font-size:1em;display:inline-block;float:right;margin-bottom:0}#creditoffer .ukChooseOffer{margin-top:0}#creditoffer .terms{font-size:.85em;margin:0;font-weight:700}#creditoffer .installmentOfferWrapper,#creditoffer .sacOfferWrapper{margin-bottom:15px;margin-top:20px}#creditoffer .installmentOfferWrapper .extendedInstallmentCtaWrap,#creditoffer .installmentOfferWrapper .extendedSacCtaWrap,#creditoffer .installmentOfferWrapper .installmentCtaWrap,#creditoffer .installmentOfferWrapper .sacCtaWrap,#creditoffer .sacOfferWrapper .extendedInstallmentCtaWrap,#creditoffer .sacOfferWrapper .extendedSacCtaWrap,#creditoffer .sacOfferWrapper .installmentCtaWrap,#creditoffer .sacOfferWrapper .sacCtaWrap{padding:20px;background-color:#f7f9fa;position:relative;border-radius:5px;background-clip:padding-box}#creditoffer .installmentOfferWrapper .extendedInstallmentCtaWrap .trayInner,#creditoffer .installmentOfferWrapper .extendedSacCtaWrap .trayInner,#creditoffer .installmentOfferWrapper .installmentCtaWrap .trayInner,#creditoffer .installmentOfferWrapper .sacCtaWrap .trayInner,#creditoffer .sacOfferWrapper .extendedInstallmentCtaWrap .trayInner,#creditoffer .sacOfferWrapper .extendedSacCtaWrap .trayInner,#creditoffer .sacOfferWrapper .installmentCtaWrap .trayInner,#creditoffer .sacOfferWrapper .sacCtaWrap .trayInner{position:relative;margin:0;padding:0;background-color:transparent;overflow:hidden}#creditoffer .installmentOfferWrapper .extendedInstallmentCtaWrap,#creditoffer .sacOfferWrapper .extendedInstallmentCtaWrap{padding:0}#creditoffer .installmentOfferWrapper .extended,#creditoffer .sacOfferWrapper .extended{background-color:#fff;color:#6c7378;border:1px solid #e1e7eb}#creditoffer .installmentOfferWrapper .seeTermsWrap,#creditoffer .sacOfferWrapper .seeTermsWrap{padding:10px 0 10px 20px}#creditoffer .installmentOfferWrapper #extendedInstallmentOffer,#creditoffer .installmentOfferWrapper #extendedSacOffer,#creditoffer .sacOfferWrapper #extendedInstallmentOffer,#creditoffer .sacOfferWrapper #extendedSacOffer{margin-top:5px}#creditoffer .reverseOrder{display:table;width:100%}#creditoffer .reverseOrder .sacOfferWrapper{display:table-footer-group}#creditoffer .gceOffers .row-fluid .span12{width:49.9%}#creditoffer .gceOffers .row-fluid .span8{width:33.1%}#creditoffer .gceOffers .row-fluid .span6{width:24.8%}#creditoffer .gceOffers .row-fluid [class*=span]{margin-left:0}#creditoffer .gceOffers .postScriptCondition{clear:both;padding:10px 0 0;font-size:.73em}#creditoffer .gceOffers .span12.singleOffer{float:none}#creditoffer .gceOffers ul.installmentOptionsB{overflow:hidden;white-space:nowrap;border-radius:5px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner{padding:0;margin:0;background-color:#f7f9fa}#creditoffer .gceOffers ul.installmentOptionsB.trayInner.fullPageOffer{padding-bottom:20px;background-color:transparent}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .sacOffer{box-sizing:border-box;float:left;line-height:1.154em;list-style:outside none none;padding:20px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer{float:left;list-style:none;border-right:3px solid #fff;-ms-box-sizing:border-box;box-sizing:border-box;padding:15px 15px 0;line-height:1.154em}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form{position:relative;min-height:230px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.en{min-height:250px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.es,#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.fr,#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.zh{min-height:278px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer:last-child{border-right:none}#creditoffer .gceOffers ul.installmentOptionsB.trayInner ul.subSections{white-space:normal;margin:0;padding-bottom:10px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner ul.subSections li{list-style:none}#creditoffer .gceOffers ul.installmentOptionsB.trayInner ul.subSections li.offerHeading1{padding:0 0 5px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .theta{font-size:.85em}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .smallText{padding:3px 16px 0;font-size:.75em}#creditoffer .gceOffers .offerAmount{display:block;font-weight:700}#creditoffer .gceOffers .totalInstallment{margin:0 0 10px}#creditoffer .gceOffers .offerDetails{width:75%;white-space:normal;padding:10px 0 0}#creditoffer #creditExampleUK{margin:30px 0}#creditoffer #creditExampleUK .creditWorksTitle{margin-bottom:5px;color:#2c2e2f}#creditoffer #creditExampleUK .creditWorksDescription{color:#6c7378}#creditoffer #creditExampleUK .representativeExKey{font-size:.85em}#creditoffer #creditExampleUK .representativeExHeader{margin-top:-10px}#creditoffer #creditExampleUK .span6{text-align:center;margin:0}#creditoffer #creditExampleUK .representativeEx{margin:0 0 20px;list-style:none;padding:0;background:none;border-top:7px solid #e3e3e3;border-bottom:1px solid #e3e3e3}#creditoffer #creditExampleUK .representativeEx .creditExHeading{color:#6c7378}#creditoffer #creditExampleUK .representativeEx li{padding:10px 30px;vertical-align:middle;border-right:1px solid #e3e3e3;width:175px}#creditoffer #creditExampleUK .representativeEx li p{margin-bottom:5px}#creditoffer #creditExampleUK .representativeEx li .representativeExampleAPRAmount{margin:2px 0 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:700}#creditoffer #creditExampleUK .representativeEx li:last-child{border-right:none}#creditoffer .faq{text-align:center}@media (min-width:0) and (max-width:50em){#creditoffer .installmentOfferWrapper .installmentCtaWrap p,#creditoffer .installmentOfferWrapper .sacCtaWrap p,#creditoffer .sacOfferWrapper .installmentCtaWrap p,#creditoffer .sacOfferWrapper .sacCtaWrap p{width:52%}#creditoffer .buttons{position:absolute;top:40%;right:0;width:16px;height:16px;box-shadow:none;text-shadow:none;border:none;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -168px;text-indent:-200px;width:9px;height:18px}#creditoffer .buttons .btn{display:none}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.row-fluid .span6,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.row-fluid .span8,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.row-fluid .span12,#creditoffer .gceOffers ul.installmentOptionsB.row-fluid .span6,#creditoffer .gceOffers ul.installmentOptionsB.row-fluid .span8,#creditoffer .gceOffers ul.installmentOptionsB.row-fluid .span12{width:100%;border-right:none;border-bottom:1px solid #fff}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.trayInner li.offer,#creditoffer .gceOffers ul.installmentOptionsB.trayInner li.offer{padding:20px;border-bottom:5px solid #fff}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.trayInner li.offer form,#creditoffer .gceOffers ul.installmentOptionsB.trayInner li.offer form{min-height:0}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB ul.subSections,#creditoffer .gceOffers ul.installmentOptionsB ul.subSections{width:auto}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB ul.subSections:last-of-type,#creditoffer .gceOffers ul.installmentOptionsB ul.subSections:last-of-type{padding-bottom:0}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB .span6,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB .span8,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB .span12,#creditoffer .gceOffers ul.installmentOptionsB .span6,#creditoffer .gceOffers ul.installmentOptionsB .span8,#creditoffer .gceOffers ul.installmentOptionsB .span12{position:relative}#creditoffer .fourOffers .gceOffers .offerAmount,#creditoffer .gceOffers .offerAmount{display:inline}#creditoffer .fourOffers .gceOffers .offerDetails,#creditoffer .gceOffers .offerDetails{display:block;width:auto}#creditoffer #creditExampleUK .representativeEx li{padding:10px 30px 10px 0;vertical-align:middle;border-right:1px solid #e3e3e3;width:100%}}@media (min-width:0) and (max-width:50em) and only screen and (-webkit-min-device-pixel-ratio:2),(min-width:0) and (max-width:50em) and only screen and (min--moz-device-pixel-ratio:2),(min-width:0) and (max-width:50em) and only screen and (min-device-pixel-ratio:2),(min-width:0) and (max-width:50em) and only screen and (min-resolution:2dppx),(min-width:0) and (max-width:50em) and only screen and (min-resolution:192dpi){#creditoffer .buttons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-credit-components/src/choose-credit-offer/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"creditoffer\" id=\"creditoffer\" content>\n    <div class=\"row-fluid\">\n\n        <div class=\"trayInner\">\n            <!--Title-->\n            <div id=\"title\">\n                <h2 class=\"beta cycoHeader\">{{ content('chooseCreditOption.offerHeading')}}</h2>\n                <p ng-if=\"country === 'GB' || !isCreditInWallet\" class=\"theta mainDescription\">\n                    {{content('chooseCreditOption.offerDescription')}}</p>\n            </div>\n\n            <div class=\"sacOfferWrapper\" ng-if=\"showSingleOffer\">\n                <div id=\"sacOnlyOffer\" class=\"extendedSacCtaWrap\">\n                    <div class=\"trayInner\">\n                        <div class = \"extendedOfferContent\">\n                            <p class=\"offerTitle\" ng-if=\"creditOffers.sac_options\">{{content('chooseCreditOption.NIOnlyHeading')}}</p>\n                            <p class=\"offerTitle\" ng-if=\"!creditOffers.sac_options\">{{content('chooseCreditOption.noOfferHeading')}}</p>\n                            <p class=\"ukOfferDescription\" ng-if=\"creditOffers.sac_options\">{{content('chooseCreditOption.NIOnlyDescription')}}</p>\n                            <p class=\"ukOfferDescription\" ng-if=\"!creditOffers.sac_options\">{{content('chooseCreditOption.noOfferDescription')}}</p>\n                        </div>\n\n                        <div class=\"chooseOffer buttons\"\n                             ng-click=\"actions.handleRedirect()\">\n                            <input type=\"submit\" value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\" class=\"btn\"/>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-class=\"{reverseOrder:country === 'GB'}\" ng-if=\"!showSingleOffer\">\n                <div class=\"sacOfferWrapper\" ng-if=\"showNoInterestSection\">\n                    <div id=\"sacOffer\" class=\"sacCtaWrap\" ng-class=\"{extended:sacExtended}\">\n                        <div class=\"trayInner\">\n                            <p ng-if=\"creditOffers.sac_options\" class=\"offerTitle\">{{content('chooseCreditOption.sacHeading')}}</p>\n                            <p ng-if=\"!creditOffers.sac_options\" class=\"offerTitle\">{{content('chooseCreditOption.noOfferInstallmentHeading')}}</p>\n                            <a link-button track-link=\"more_info_sac\" class=\"moreInfoLink sacLink\"\n                               ng-click=\"actions.toggleSacOffer(sacExtended)\"\n                               ng-class=\"{noMargin:!creditOffers.sac_options}\"\n                               ng-if=\"!sacExtended\">{{ content('chooseCreditOption.moreInfo') }}\n                                <span class=\"frontArrow down\"></span>\n                            </a>\n                            <a link-button class=\"moreInfoLink \" ng-click=\"actions.toggleSacOffer(sacExtended)\"\n                               ng-if=\"sacExtended\"  ng-class=\"{noMargin:!creditOffers.sac_options}\">{{ content('chooseCreditOption.close') }}\n                                <span class=\"frontArrow up\"></span>\n                            </a>\n                            <p ng-if=\"creditOffers.sac_options\" class=\"offerSmallText\">{{content('chooseCreditOption.sacDescription')}}</p>\n                        </div>\n                    </div>\n                    <div class=\"extendedSacCtaWrap seeTermsWrap\" ng-if=\"sacExtended && country !== 'GB'\">\n                        <p class=\"terms\" ng-bind-html=\"htmlContent('chooseCreditOption.seeTermsSAC')\"></p>\n                    </div>\n                    <div id=\"extendedSacOffer\" class=\"extendedSacCtaWrap\" ng-if=\"sacExtended\">\n                        <div class=\"trayInner\">\n                            <div class=\"extendedOfferContent\">\n                                <p class= \"ukOfferDescription\" ng-if=\"creditOffers.sac_options\">{{content('chooseCreditOption.sacNote1')}}</p>\n                                <p class= \"ukOfferDescription\" ng-if=\"!creditOffers.sac_options\">{{content('chooseCreditOption.noOfferInstallmentNote1')}}</p>\n                                <p>{{content('chooseCreditOption.sacNote2')}}</p>\n                            </div>\n                            <div class=\"chooseOffer buttons\" ng-if=\"creditOffers.sac_options\" ng-click=\"actions.onSelect('SAC')\">\n                                <input id=\"sacOfferButton\" type=\"submit\" track-submit='choose_sac'\n                                       value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\" class=\"btn\"/>\n                                <p ng-if=\"country !== 'GB'\" class=\"smallText\"\n                                   ng-bind-html=\"htmlContent('chooseCreditOption.minimumAmt', {minAmount:'$99'})\"></p>\n                            </div>\n                            <div ng-if=\"!creditOffers.sac_options\" class=\"chooseOffer buttons\" ng-click=\"actions.onSelect('CORE')\">\n                                <input id=\"coreOfferButton\" type=\"submit\" track-submit='choose_core'\n                                       value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\" class=\"btn\"/>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n\n                <div class=\"installmentOfferWrapper\" ng-if=\"creditOffers.installment_options\">\n                    <div id=\"installmentOffer\" class=\"installmentCtaWrap\"\n                         ng-class=\"{extended:installmentExtended || defaultinstallmentExtended}\">\n                        <div class=\"trayInner\">\n                            <p class=\"offerTitle\">{{content('chooseCreditOption.installmentHeading')}}</p>\n                            <div class=\"expandableLinks\" ng-if=\"!defaultinstallmentExtended\">\n                                <a link-button ng-if=\"installmentCount === 1 && !installmentExtended\"\n                                   track-link=\"more_info_installment\"\n                                   class=\"moreInfoLink\" ng-click=\"actions.toggleInstallmentOffer(installmentExtended)\">{{\n                                    content('chooseCreditOption.moreInfo') }}\n                                    <span class=\"frontArrow down\"></span>\n                                </a>\n                                <a link-button ng-if=\"installmentCount > 1 && !installmentExtended\"\n                                   track-link=\"more_info_installment\" class=\"moreInfoLink\"\n                                   ng-click=\"actions.toggleInstallmentOffer(installmentExtended)\">{{content('chooseCreditOption.seeAllPlans')\n                                    }}\n                                    <span class=\"frontArrow down\"></span>\n                                </a>\n                                <a link-button class=\"moreInfoLink\"\n                                   ng-click=\"actions.toggleInstallmentOffer(installmentExtended)\"\n                                   ng-if=\"installmentExtended || defaultinstallmentExtended\">{{ content('chooseCreditOption.close') }}\n                                    <span class=\"frontArrow up\"></span>\n                                </a>\n                            </div>\n                            <p class=\"offerSmallText\"\n                               data-ng-bind-html=\"htmlContent(installmentContentKey,{monthlyPayment: creditOffers.installment_options[installmentCount -1].monthlyPayment.formattedAmt, term:creditOffers.installment_options[installmentCount -1].term , apr: creditOffers.installment_options[installmentCount -1].apr})\"></p>\n                        </div>\n                    </div>\n                    <div class=\"extendedInstallmentCtaWrap seeTermsWrap\" ng-if=\"installmentExtended && country !== 'GB' \">\n                        <p class=\"terms\"\n                           ng-bind-html=\"htmlContent('chooseCreditOption.seeTermsInstallment', {seeTermsUrl: termsUrl})\"></p>\n                    </div>\n                    <div id=\"extendedInstallmentOffer\" class=\"extendedInstallmentCtaWrap\" ng-if=\"installmentExtended || defaultinstallmentExtended\">\n                        <div class=\"row-fluid gceOffers\">\n                            <div class=\"span24\">\n                                <ul class=\"trayInner trayInnerDefault installmentOptionsB row-fluid\">\n                                    <li class=\"offer span6\" ng-repeat=\"installment in creditOffers.installment_options\"\n                                        ng-click=\"actions.onSelect($index)\" track-submit='choose_installment'>\n                                        <form>\n                                            <div ng-if=\"country !== 'GB'\"class=\"installmentPlanDetails\">\n                                                <ul class=\"subSections\">\n                                                    <li class=\"offerHeading1\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueMonths',{term: installment.term})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valuePerMonth',{ monthlyPayment: installment.monthlyPayment.formattedAmt})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\" ng-bind-html=\"\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueAPR',{apr: installment.apr})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueInterest', { interest: installment.totalInterest.formattedAmt})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueEveryMonth', {term: installment.term})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\">\n                                                        {{content('chooseCreditOption.valueTotalPayment')}}\n                                                    </li>\n                                                    <li class=\"theta\">\n                                                        <strong>{{installment.totalPayment.formattedAmt}}</strong></li>\n                                                    <li class=\"terms\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.seeTerms')\"></li>\n                                                </ul>\n                                            </div>\n                                            <div ng-if=\"country === 'GB'\" class=\"installmentPlanDetails\">\n                                                <ul class=\"subSections\">\n                                                    <li class=\"offerHeading1\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valuePerMonth',{ monthlyPayment: installment.monthlyPayment.formattedAmt})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueMonths',{term: installment.term})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\" ng-bind-html=\"\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.promotionalRate')\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueAPR',{apr: installment.apr})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.interestRate')\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueInterest', { interest: installment.totalInterest.formattedAmt})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\">\n                                                        {{content('chooseCreditOption.valueTotalPayment')}}\n                                                    </li>\n                                                    <li class=\"theta\">\n                                                        <strong>{{installment.totalPayment.formattedAmt}}</strong></li>\n                                                    <li class=\"terms\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.seeTerms')\"></li>\n                                                </ul>\n                                            </div>\n\n                                            <div class=\"buttons\">\n                                                <input type=\"submit\" track-submit='choose_installment'\n                                                       value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\"\n                                                       class=\"btn\"/>\n                                                <p ng-if=\"country !== 'GB'\" class=\"smallText\"\n                                                   ng-bind-html=\"htmlContent('chooseCreditOption.minimumAmt', {minAmount:installment.minimumAmount})\"></p>\n                                            </div>\n\n                                        </form>\n                                    </li>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n\n            <div class=\"bmlMargin\" id=\"bmlBottomText\">\n                <p class=\"sameLine payInFullText\" ng-bind-html=\"htmlContent('chooseCreditOption.payInFullText')\"></p>\n                <a link-button class=\"payInFullLink sameLine\" ng-bind-html=\"htmlContent('chooseCreditOption.payInFullLink')\"\n                   ng-click=\"actions.redirectToReview()\"></a>\n            </div>\n\n            <div id=\"creditExampleUK\" ng-if=\"country === 'GB'\">\n                <div class=\"creditWorks\">\n                <p class=\"creditWorksTitle\">{{content('chooseCreditOption.creditSampleHeader')}}</p>\n                <p class=\"creditWorksDescription\">{{content('chooseCreditOption.creditSamplePara')}}</p>\n                </div>\n                <p class=\"bmlLender\">{{content('chooseCreditOption.representativeEx')}}</p>\n                <p class=\"bmlLender representativeExHeader\">{{content('chooseCreditOption.representativeExHeader')}}</p>\n                <ul class=\"trayInner trayInnerDefault representativeEx row-fluid\">\n                    <li class=\"span6\">\n                        <p class=\"representativeExKey\">{{content('chooseCreditOption.purchaseRate')}}</p>\n                        <p class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.purchaseRateValue')}}</p>\n                    </li>\n                    <li class=\"span6\">\n                        <p class=\"representativeExKey\">{{content('chooseCreditOption.representativeAPR')}}</p>\n                        <p class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.representativeAPRValue')}}</p>\n                    </li>\n                    <li class=\"span6 last\">\n                        <p class=\"representativeExKey\">{{content('chooseCreditOption.exCreditLimit')}}</p>\n                        <p class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.exCreditLimitValue')}}</p>\n                    </li>\n                </ul>\n\n                <p class=\"faq\" ng-bind-html=\"htmlContent('chooseCreditOption.faqLink')\"></p>\n            </div>\n\n            <div id=\"bmlLender\">\n                <p ng-if=\"!isCreditInWallet\" class=\"sameLine bmlLender\">\n                    {{content('chooseCreditOption.disclaimerText1')}}</p>\n                <p ng-if=\"country === 'GB' && creditOffers.installment_options\" class=\"sameLine bmlLender\">{{content('chooseCreditOption.disclaimerTextInst')}}</p>\n                <p ng-if=\"!(country === 'GB' && creditOffers.installment_options)\" class=\"sameLine bmlLender\">{{content('chooseCreditOption.disclaimerText2')}}</p>\n            </div>\n\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n\n"

/***/ },

/***/ "./components/xo-credit-components/src/redirect-to-cape/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$RedirectToCapeRoute = undefined;
	
	__webpack_require__("./components/xo-credit-components/src/redirect-to-cape/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $RedirectToCapeRoute = exports.$RedirectToCapeRoute = _squid.$ComponentRoute.extend('$RedirectToCapeRoute', {
	
	    path: 'redirectToCape',
	    directive: 'xo-redirect-to-cape',
	    titleContent: 'redirectToCape',
	    trackingData: {
	        fptiState: 'redirect-to-cape'
	    },
	    loginRequired: true,
	    auth: false,
	    children: []
	});
	
	angular.value("$RedirectToCapeRoute", $RedirectToCapeRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./components/xo-credit-components/src/redirect-to-cape/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-credit-components/src/redirect-to-cape/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/credit/index.js");
	
	var _model = __webpack_require__("./components/xo-tracking/dist/model.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoRedirectToCapeDirective', {
	    tag: 'xo-redirect-to-cape',
	    template: _template2['default'],
	    props: { token: { type: 'var', required: true } },
	    resolve: {
	        models: function models() {
	            return {
	                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
	                auth: _auth.$AuthModel.instance().retrieve()
	            };
	        }
	    },
	    lifecycle: {
	        populate: function populate() {
	            var _this = this;
	
	            this.creditDataModel = _index3.$CreditDataModel.instance(this.props.token);
	            var url = 'https://' + window.location.host + _squid.$config.urls.baseUrl;
	            var returnUrl = _squid.$util.buildURL(url, { token: this.props.token });
	            var transactionType = this.models.checkoutAppData.is_second_button_txn ? 'SECOND_BUTTON' : 'HERMES';
	            var isSignupFlow = this.models.auth.logged_in ? 'false' : 'true';
	
	            var capeData = {
	                'flow_attributes': {
	                    'channel': _index.$DeviceInfo.isMobile() ? 'MOBILE' : 'WEB',
	                    'flow': 'CHECKOUT_CREDIT_BUTTON',
	                    'primary_actor': 'PAYPAL',
	                    'tracking_id': this.props.token,
	                    'business_case_variation': transactionType
	                },
	                'locale': _squid.$locale.lang + '_' + _squid.$locale.country,
	                'cart_id': this.props.token,
	                'fraudnet_id': this.props.token,
	                'context-type': 'Full-context',
	                'cal_correlation_id': _model.$CalDataModel.getCalCorrId(),
	                'return_uris': {
	                    'normal_return_uri': returnUrl + '&success=true',
	                    'system_error_uri': returnUrl + '&success=false&isInternalServiceError=true',
	                    'return_to_login_uri': returnUrl,
	                    'full_pay_uri': this.models.auth.logged_in ? returnUrl + '&success=false' : undefined,
	                    'cancel_uri': this.models.checkoutAppData.urls.cancel_url,
	                    'change_installments_uri': returnUrl + '&changeStatus=changeInstallment&creditSignup=' + isSignupFlow
	                }
	            };
	            var data = {
	                creditData: capeData,
	                newUserSignup: isSignupFlow
	            };
	
	            return this.creditDataModel.action('createCreditKey', {
	                data: data,
	                success: function success(res) {
	                    var capeUrl = (0, _squid.$feature)('capeUrl') + res.capeKey + '&token=' + _this.props.token;
	                    if (_this.creditDataModel.isChangeStatus()) {
	                        capeUrl += '&status=changeInstallment';
	                    }
	                    _this.creditDataModel.setCapeRedirectUri(capeUrl);
	                    _squid.$util.redirect(capeUrl);
	                }
	            });
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$util;
	
	_squid.$config;
	
	_squid.$locale;
	
	_squid.$feature;
	
	_index.$DeviceInfo;
	
	_auth.$AuthModel;
	
	_index2.$CheckoutAppDataModel;
	
	_index3.$CreditDataModel;
	
	_model.$CalDataModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-credit-components/src/redirect-to-cape/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"capeRedirect\">\n</div>\n"

/***/ },

/***/ "./pages/xo-checkout/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	var _index = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index3 = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _fn = __webpack_require__("./components/xo-login-components/src/login/fn.js");
	
	__webpack_require__("./components/xo-ui-components/src/spinner/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/merchant-header/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/header/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/footer/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/cart/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-login-components/src/login-overlay/directive.js");
	
	var _template = __webpack_require__("./pages/xo-checkout/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {
	
	    tag: 'xo-checkout',
	    template: _template2['default'],
	
	    resolve: {
	        pxp: function pxp() {
	            var pxp = _squid.$config.purchaseProtectionProp.pxp;
	
	            return {
	                purchaseProtectionAlt: (0, _squid.$pxp)(pxp.pgName, pxp.patterns)
	            };
	        },
	        models: function models() {
	            return {
	                checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve(),
	                checkoutPayee: _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve()
	            };
	        }
	    },
	
	    controller: function controller() {
	        if (_angular.$location.path() === '/checkout') {
	            _uiRouter.$state.go('checkout.review');
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
	            _logger.$logger.info('IS_MESSENGER_BA_INTEGRATION: on Footer ' + this.isMessengerBAIntegration);
	            this.token = _angular.$rootScope.token;
	            this.locale = _squid.$locale;
	            this.redirectiframe = _angular.$rootScope.partnerIntegration;
	            this.redirectLightbox = true;
	            this.escapeHatchInContext = !_angular.$rootScope.partnerIntegration;
	
	            this.reviewUrl = 'checkout.review';
	            this.isApp = _index3.$DeviceInfo.isApp();
	
	            _angular.$document.bind('click', function (event) {
	                _this.$broadcast('clickBody', event.target);
	            });
	
	            function rtl() {
	                if ((0, _squid.$feature)('rtl')) {
	                    _angular.$document.prop('documentElement').setAttribute('dir', _squid.$locale.metadata.directionality);
	                }
	            }
	
	            this.$on('metadataChange', rtl);
	            rtl();
	
	            _fn.$fn.trigger();
	        },
	        populate: function populate() {
	            var merchant = this.models.checkoutPayee.merchant;
	
	            if (merchant.id) {
	                var hcl = _squid.$config.hideCancelLink;
	
	                this.hideCancel = hcl && hcl.indexOf(merchant.id) !== -1;
	            }
	
	            if (this.pxp.purchaseProtectionAlt) {
	                _squid.$config.features.DEFAULT.propValue = false;
	            }
	
	            function requiresRiskyLogin(state) {
	                var auth = _index.$AuthModel.instance();
	                return state.loginRequired && auth.remembered;
	            }
	
	            function displayRiskyLogin(oldState, newState, newParams) {
	
	                if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
	                    _logger.$logger.info('login_overlay_suppressed');
	                    return;
	                }
	
	                var isUserinitiated = oldState.template && !oldState.name.match(/checkout\.login/);
	
	                if (isUserinitiated) {
	                    var stateName = newState && newState.name;
	                    var subFlowName = stateName && stateName.replace(/^.*\./, '');
	
	                    if (subFlowName === 'sepaAgreement') {
	                        _uiRouter.$state.go('checkout.review');
	                    }
	
	                    _angular.$rootScope.$broadcast('$insufficientPermission', {
	                        oldState: oldState.name,
	                        newState: newState.name,
	                        pageOnOverlay: newState.pageOnOverlay
	                    });
	                } else {
	                    var auth = _index.$AuthModel.instance();
	                    var cause = newParams && newParams.message ? newParams.message : newState.name.replace(/^.*\./, '');
	                    _logger.$logger.info('RISKY_LOGIN_TRANSITION_' + cause);
	                    var showPasswordRecovery = (0, _squid.$feature)('pomaPasswordRecovery') && auth.password_less;
	                    var transition = showPasswordRecovery ? 'checkout.createPassword' : 'checkout.login';
	                    _uiRouter.$state.go(transition, {
	                        targetPage: cause,
	                        showNotYou: true
	                    });
	                }
	
	                return false;
	            }
	
	            var cancelStateChangeEventListener = _angular.$rootScope.$on('$stateChangeStart', function (event, newState, newParams, oldState) {
	                if (requiresRiskyLogin(newState)) {
	                    event.preventDefault();
	                    displayRiskyLogin(oldState, newState, newParams);
	                }
	            });
	
	            this.$on('$destroy', cancelStateChangeEventListener);
	
	            if (requiresRiskyLogin(_uiRouter.$state.current)) {
	                displayRiskyLogin(_uiRouter.$state.current, _uiRouter.$state.current);
	            }
	        }
	    }
	});
	
	
	_angular.$rootScope;
	
	_angular.$document;
	
	_angular.$location;
	
	_squid.$Component;
	
	_squid.$config;
	
	_squid.$feature;
	
	_squid.$pxp;
	
	_squid.$locale;
	
	_logger.$logger;
	
	_uiRouter.$state;
	
	_integration.$integration;
	
	_index.$AuthModel;
	
	_index2.$CheckoutCartModel;
	
	_index2.$CheckoutPayeeModel;
	
	_index3.$DeviceInfo;
	
	_fn.$fn;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-ui-components/src/spinner/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner/template.html"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-spinner.directive', ['squid', 'beaver']).directive('xoSpinner', function () {
	
	        return {
	            scope: {},
	            template: template,
	            controller: function controller($scope, $element, $rootScope, $Api, $locale, $logger, $loader, $timeout) {
	
	                var $body = angular.element(document.getElementsByTagName('body'));
	                var $priorActiveElement = $();
	                var $capturedElement = $();
	                var $header = $('header');
	                var $slidingArea = $('#sliding-area');
	                var $footer = $('footer');
	
	                /**
	                 * This hides page content from any screen readers.
	                 * When the spinner's active, the only thing that should be read out is the "Loading..." text.
	                 *
	                 * The only crappy thing here is the spinner's nested deep in the content, so please excuse this jQuery crap.
	                 * At the very least, let's cache these selectors :|
	                 */
	                function hidePageContentFromScreenReader(toggle) {
	                    $header.attr('aria-disabled', toggle);
	                    $slidingArea.attr('aria-disabled', toggle);
	                    $footer.attr('aria-disabled', toggle);
	                }
	
	                function preventDefault(event) {
	                    event.preventDefault();
	                }
	
	                function captureFocus(event) {
	                    if (!$element.has(event.target).length) {
	                        $capturedElement = $(event.target);
	                    }
	                }
	
	                function setLoadingMessage(message) {
	                    if (angular.isObject(message)) {
	                        $scope.message = message.heading;
	                        $('#spinnerMessage').css('font-size', '17.5px');
	                        $('#spinnerMessage').html(message.heading);
	                        $('#spinnerSubHeading').html(message.subHeading);
	                    } else {
	                        $scope.message = message;
	                        $('#spinnerMessage').html(message);
	                    }
	                }
	
	                function showSpinner() {
	                    $scope.loading = true;
	                    $logger.info('show_loading_spinner');
	                    $body.addClass('loading');
	
	                    // remember what was previously focused
	                    $priorActiveElement = $(':focus');
	
	                    $(':input, a').blur();
	
	                    hidePageContentFromScreenReader(true);
	
	                    if ($loader.firstLoad()) {
	                        setLoadingMessage($locale.content.get('base.processing'));
	                    }
	
	                    // focus on the message so that screen readers will let the user know the page is loading
	                    $(document).on('keydown', preventDefault);
	                    $(document).on('focusin', captureFocus);
	                    $timeout(function () {
	                        $('#spinner-message').focus();
	                    });
	                }
	
	                function hideSpinner() {
	                    $scope.loading = false;
	                    $logger.info('hide_loading_spinner');
	                    $('#preloaderSpinner').hide();
	                    $body.removeClass('loading');
	                    $(document).off('keydown', preventDefault);
	                    $(document).off('focusin', captureFocus);
	
	                    hidePageContentFromScreenReader(false);
	
	                    // Focus captured element if focus was given to an element while spinner was active.
	                    if ($capturedElement.length && $(document.body).has($capturedElement).length) {
	                        $capturedElement.focus();
	                        // Focus element that had focus before if it is still within the document
	                    } else if ($priorActiveElement.length && $(document.body).has($priorActiveElement).length) {
	                        $priorActiveElement.focus();
	                    } else {
	                        // If focus is not managed, default to focusing sliding area. Fixes FF and IE bug where tab focus starts from
	                        // the element last clicked, rather than top of page.
	                        $slidingArea.focus();
	                    }
	                    $priorActiveElement = $();
	                    $capturedElement = $();
	                }
	
	                var cancelStartLoad = $rootScope.$on('startLoad', showSpinner);
	                var cancelAllLoaded = $rootScope.$on('allLoaded', hideSpinner);
	
	                var cancelSetLoadingMessage = $rootScope.$on('loadingMessage', function (event, text) {
	                    setLoadingMessage(text);
	                });
	
	                $scope.$on('$destroy', function () {
	                    hideSpinner();
	                    cancelStartLoad();
	                    cancelAllLoaded();
	                    cancelSetLoadingMessage();
	                });
	
	                if ($loader.isLoading()) {
	                    showSpinner();
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner/template.html":
/***/ function(module, exports) {

	module.exports = "<div ng-if=\"loading\" id=\"spinner\" class=\"spinner\">\n    <div class=\"spinWrap\">\n        <p class=\"spinnerImage\"></p>\n        <p class=\"loader\"></p>\n        <p id=\"spinner-message\" tabIndex=\"0\" role=\"alert\" class=\"loadingMessage\">{{message}}</p>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/merchant-header/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/user/index.js");
	
	var _template = __webpack_require__("./components/xo-page-components/src/merchant-header/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoMerchantHeaderDirective', {
	    tag: 'xo-merchant-header',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var',
	            required: false
	        },
	        merchant: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            if (this.props.token) {
	                return {
	                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()
	                };
	            }
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            if (this.props.token && !_index2.$CheckoutInputDataModel.instance(this.props.token).isEbayTxn()) {
	                this.merchant = this.models.checkoutAppData.merchant;
	            }
	        }
	    }
	});
	
	
	(0, _squid.$registerDirective)('xoMerchantImageResize', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            element.bind('load', function () {
	                var MAX_WIDTH = 780;
	                var MAX_HEIGHT = 90;
	
	                if (this.width > MAX_WIDTH) {
	                    var ratio = MAX_WIDTH / this.width;
	                    var height = this.height * ratio;
	
	                    this.width = MAX_WIDTH;
	                    this.height = height > MAX_HEIGHT ? MAX_HEIGHT : height;
	                }
	            });
	        }
	    };
	});
	
	_squid.$Component;
	
	_squid.$registerDirective;
	
	_index.$CheckoutAppDataModel;
	
	_index2.$CheckoutInputDataModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-page-components/src/merchant-header/template.html":
/***/ function(module, exports) {

	module.exports = "<header role=\"banner\">\n    <div id=\"header\" class=\"merchantHeader clearfix\">\n        <div class=\"headerWrapper\">\n            <span class=\"merchantName\" directionality-text=\"merchant.brand_name || merchant.merchant_name || merchant.merchant_email\" ng-if=\"!(merchant.logo_url || merchant.imageUrl)\">\n             {{ merchant.brand_name || merchant.merchant_name || merchant.merchant_email }}\n         \t</span>\n            <img ng-src=\"{{merchant.logo_url || merchant.imageUrl}}\" alt=\"{{ merchant.brand_name || merchant.merchant_name || merchant.merchant_email }}\" ng-if=\"merchant.logo_url || merchant.imageUrl\" xo-merchant-image-resize/>\n        </div>\n    </div>\n</header>\n"

/***/ },

/***/ "./components/xo-page-components/src/header/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-page-components/src/header/styles.less");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/header/template.html"), __webpack_require__("./components/xo-page-components/src/cart/directive.js"), __webpack_require__("./components/xo-ui-components/src/escape-hatch/closeFrame/directive.js"), __webpack_require__("./components/xo-form-components/src/language-options/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-header.directive', ['squid', 'xo-cart.directive', 'xo-escape-hatch.closeFrame.directive', 'xo-language-options.directive']).directive('xoHeader', function () {
	        return {
	            template: template,
	            scope: {
	                showCartTotal: '=',
	                renderCartContainer: '=',
	                token: '=',
	                isUnbranded: '=',
	                unbrandedTitle: '=',
	                unbrandedSubTitle: '=',
	                languageSwitch: '=?',
	                redirectiframe: '=',
	                redirectLightbox: '='
	            },
	            controller: function controller($scope, $rootScope, $renderContent) {
	                $scope.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
	                _logger.$logger.info('IS_MESSENGER_BA_INTEGRATION: on header ' + $scope.isMessengerBAIntegration);
	                // $util.assert($scope.token, 'Expected token');
	                $scope.title = $renderContent($scope.unbrandedTitle);
	                $scope.subTitle = $renderContent($scope.unbrandedSubTitle);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_squid.$integration;
	
	_logger.$logger;

/***/ },

/***/ "./components/xo-page-components/src/header/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-page-components/src/header/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-page-components/src/header/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".paypalHeader .languageToggleDisplay{position:relative;bottom:0;clear:left;right:0;top:20px;margin-bottom:20px}.paypalHeader #langDropdownBlock{right:auto}@media (max-width:41.3125em){.paypalHeaderWrapper.langDropdown{margin-bottom:30px}}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/header/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"row-fluid paypalHeaderWrapper\" ng-class=\"{ 'langDropdown': languageSwitch && languageSwitch.show }\" content>\n    <div class=\"span14 clearfix paypalHeader\">\n\n        <span class=\"pageTitle\" ng-if=\"unbrandedTitle\">{{title}}</span>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded\" id=\"paypalLogo\" class=\"logo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n        <div ng-if=\"isMessengerBAIntegration\">\n            <img src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_logo_lockup_2x.png\" style=\"margin-left: 25%; padding-top: 20px;\" width=\"50%\" height=\"50%\" alt=\"\">\n        </div>\n        <xo-cart token=\"token\" show-cart-total=\"showCartTotal\" render-cart-container=\"renderCartContainer\"></xo-cart>\n\n        <xo-language-options ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n\n        <div class=\"subTitle\" ng-if=\"unbrandedSubTitle\">{{subTitle}}</div>\n        <xo-close-frame redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-close-frame>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/cart/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/template.html"), __webpack_require__("./components/xo-page-components/src/cart/lib/pxp.js"), __webpack_require__("./components/xo-page-components/src/cart/lib/cart_pxp.js"), __webpack_require__("./components/xo-page-components/src/cart/lib/ui.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js"), __webpack_require__("./components/xo-page-components/src/cart/cartWrapper/directive.js"), __webpack_require__("./components/xo-page-components/src/cart/itemDetails/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-cart.directive', ['squid', 'xomodel.checkout', 'xo-cart.pxp', 'xo-cart.ui', 'xo-cart.cart-wrapper.directive', 'xo-cart.item-details.directive', 'xo-accessibility.directive']).directive('xoCart', function () {
	
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                showCartTotal: '=',
	                renderCartContainer: '=',
	                token: '='
	            },
	            controller: function controller( // eslint-disable-line max-params
	            $scope, $populate, $rootScope, $util, $state, $CheckoutCartModel, $CheckoutAppDataModel, $CheckoutPayeeModel, $pxpCartAmt, $pxpCartDesc) {
	
	                $util.assert($scope.token, 'Expected token');
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    payee: $CheckoutPayeeModel.instance($scope.token)
	                }).then($pxpCartDesc).then(function loadCartData(canShowCart) {
	
	                    var emptyCart = $scope.checkoutCart.get('purchase.items.length', 0) <= 0;
	                    var cartDesc = $scope.checkoutCart.get('purchase.description');
	                    $scope.note = $scope.checkoutCart.get('note');
	
	                    if (!canShowCart) {
	                        cartDesc = '';
	                    } else
	                        // resolve string in descriptions array since the only element may be `null`
	                        // TODO: fix backend to return a string, to avoid this conditional
	                        if (cartDesc && angular.isString(cartDesc[0])) {
	                            cartDesc = cartDesc[0];
	                        } else {
	                            cartDesc = '';
	                        }
	
	                    $scope.desc = cartDesc;
	                    $scope.hasItems = !$scope.renderCartContainer && !emptyCart;
	                    $scope.showArrow = !$scope.checkoutAppData.flags.hide_cart_details && (cartDesc || $scope.hasItems || $scope.note) && !$scope.checkoutCart.isMultiSellerPurchase();
	
	                    // add details to render to the checkoutCart items
	                    $scope.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
	                        item.details = {};
	
	                        if (item.quantity > 1) {
	                            item.details.price = item.price.amount;
	                            item.details.quantity = squid.formatQuantity(item.quantity);
	                        }
	
	                        if (item.description) {
	                            if (!item.name) {
	                                item.name = item.description;
	                            } else {
	                                item.details.description = item.description;
	                            }
	                        }
	
	                        // move options to detail section
	                        if (item.item_option_selections) {
	                            item.details.hasSelections = true;
	                            item.details.item_option_selections = item.item_option_selections;
	                        }
	
	                        if (item.sku) {
	                            item.details.sku = item.sku;
	                        }
	
	                        item.hasDetails = Object.keys(item.details).length > 0;
	                        item.details.hasMore = item.hasDetails || item.details.hasSelections;
	                    });
	
	                    // Mapping of field name as recieved by API to corresponding property key
	                    $scope.amountHeaders = {
	                        'total': 'header.total',
	                        'subtotal': 'header.itemTotal',
	                        'tax': 'header.tax',
	                        'shipping': 'header.shipping',
	                        'insurance': 'header.insurance',
	                        'handling_fee': 'header.handling',
	                        'shipping_discount': 'header.shippingDiscount',
	                        'description': 'header.description',
	                        'discount': 'header.discount'
	                    };
	
	                    // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
	                    // are not available and purchase amount is not zero.
	                    var userAction = $scope.userAction = $util.param('useraction');
	                    var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && emptyCart;
	
	                    return $pxpCartAmt($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
	                        $scope.showAmt = showAmount;
	                    });
	                }).then(function handleCartOpenClose() {
	                    // the cart is only automatically open under the following criteria:
	                    // 1. the cart has a 'note to buyer' ($scope.note is defined)
	                    // 2. the cart was not previously automatically opened before
	                    // 3. the state has transitioned to checkout.review or checkout.guest
	                    function decideShowCart(currentState) {
	                        if ($scope.note && !$scope.openedAlready && /^checkout\.(review|guest)$/.test(currentState)) {
	                            $scope.openedAlready = true; // may have been undefined before
	                            return true;
	                        }
	
	                        return false;
	                    }
	
	                    $scope.showCartItem = function (breakdown) {
	                        return breakdown.field_name !== 'total' && Number(breakdown.amount) !== 0;
	                    };
	
	                    $scope.showCart = decideShowCart($state.current.name);
	
	                    // TODO: Must we really couple this so tightly with the state transition names?
	                    var openCartListener = $rootScope.$on('$stateChangeSuccess', function (event, toState) {
	                        $scope.showCart = decideShowCart(toState.name);
	                    });
	                    $scope.$on('$destroy', openCartListener); // see http://stackoverflow.com/a/27016855 on why $destroy
	
	                    $scope.toggleCart = function ($event) {
	                        $scope.showCart = !$scope.showCart;
	                        $event.preventDefault();
	                    };
	
	                    $scope.closeCart = function ($event) {
	                        $scope.showCart = false;
	                        // for accessible autofocus on cart toggle link button
	                        $scope.$broadcast('cart-closed');
	                        if ($event) {
	                            $event.preventDefault();
	                        }
	                    };
	
	                    $scope.$on('clickBody', function ($event, target) {
	                        if ($scope.showCart && $(target).parents('.cartContainer').length === 0) {
	                            $scope.closeCart($event);
	                            $scope.$apply();
	                        }
	                    });
	
	                    // this listener / broadcast allows accessibility components to scan and focus inside the cart
	                    // when the cart is displayed
	                    $scope.$watch('showCart', function (showCart) {
	                        if (showCart) {
	                            $scope.$broadcast('cart-updated');
	                        }
	                    });
	                }).then(function handleEllipsisIssues() {
	                    // NOTE: the scattered broadcasts of "cart-updated" events are mostly
	                    // to allow the accessibility directives modal-box and focus-when to
	                    // know when to recalculate keyboard behavior / focus
	                    $scope.toolongTracker = {};
	
	                    // this function is invoked by the onEllipsis directive that tracks
	                    // if the item name won't fit within the restricted space.
	                    $scope.toolong = function (idx) {
	                        $scope.toolongTracker[idx] = true;
	                        $scope.$broadcast('cart-updated');
	                    };
	
	                    $scope.showMore = function (idx, type) {
	                        // there are 2 types of more, "floating" when the name is too long
	                        // and "inline" when the name can fit, but there are additional details.
	                        //
	                        // Show a more if the item
	                        // 1. has an expanded state
	                        // 2. is not already expanded
	                        // 3. if it is appropriate to show that type.
	                        var itemIsTooLong = $scope.toolongTracker[idx];
	                        var isAppropriateType = itemIsTooLong && type === 'floating' || !itemIsTooLong && type === 'inline';
	
	                        return $scope.hasExpandedState(idx) && !$scope.isExpanded(idx) && isAppropriateType;
	                    };
	
	                    $scope.expandedIndex = -1; // initially, none of the line items are expanded
	                    $scope.isExpanded = function isExpanded(idx) {
	                        return idx === $scope.expandedIndex;
	                    };
	                    $scope.hasExpandedState = function hasExpandedState(idx) {
	                        // A line item is exandable if
	                        // 1. the name cannot fit in one line ($scope.toolongTracker) and/or
	                        // 2. there are details (attached to purchase.items in the cart)
	                        // 3. there is item number (sku) in the item
	                        var item = $scope.checkoutCart.get('purchase.items', [])[idx] || {};
	                        var nameTooLong = $scope.toolongTracker[idx];
	                        return nameTooLong || item.hasDetails || item.sku;
	                    };
	                    $scope.expand = function expand(idx) {
	                        $scope.expandedIndex = idx;
	                        $scope.$broadcast('cart-updated');
	                    };
	                    $scope.collapse = function collapse() {
	                        $scope.expandedIndex = -1;
	                        $scope.$broadcast('cart-updated');
	                    };
	
	                    $scope.$emit('dataLoaded');
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-page-components/src/cart/lib/ui.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _decode_entities = __webpack_require__("./components/xo-page-components/src/cart/lib/decode_entities.js");
	
	var _decode_entities2 = _interopRequireDefault(_decode_entities);
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Register entity decoding filter in Angular
	_angular.$filterProvider.register('decodeEntities', _decode_entities2['default']);
	
	// if an element has an ellipsis text-overflow in effect (it must already have
	// the appropriate css styling) then invoke the function that is passed to the directive
	function getVisibleWidth(elem) {
	    var elemRect = elem.getBoundingClientRect();
	    // cross browser, returns decimals for ultra-precision
	    return elemRect.right - elemRect.left;
	}
	
	function getNaturalWidth(elem) {
	    var old = {
	        overflow: elem.style.overflow,
	        width: elem.style.width,
	        display: elem.style.display
	    };
	    var result;
	
	    elem.style.overflow = 'visible';
	    elem.style.width = 'auto';
	    elem.style.display = 'inline-block';
	    result = getVisibleWidth(elem);
	    elem.style.overflow = old.overflow;
	    elem.style.width = old.width;
	    elem.style.display = old.display;
	
	    return result;
	}
	
	// pre-determine approach to reading styles
	var getStyle = _angular.$window.getComputedStyle ?
	// modern browsers
	function (elem, style) {
	    return _angular.$window.getComputedStyle(elem)[style];
	} :
	// IE
	function (elem, style) {
	    return elem.currentStyle[style];
	};
	
	function hasEllipsis(elem) {
	    var overflowHidden = getStyle(elem, 'overflow') === 'hidden';
	    var textOverflowEllipsis = getStyle(elem, 'text-overflow') === 'ellipsis';
	    var whiteSpaceNowrap = getStyle(elem, 'white-space') === 'nowrap';
	
	    if (overflowHidden && textOverflowEllipsis && whiteSpaceNowrap) {
	        return getVisibleWidth(elem) < getNaturalWidth(elem);
	    }
	
	    return false;
	}
	
	(0, _angular.$registerDirective)('onEllipsis', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function invokeSubscriber() {
	                (0, _angular.$parse)(attrs.onEllipsis)(scope);
	                scope.$apply();
	            }
	
	            (0, _angular.$timeout)(function () {
	                if (hasEllipsis(element[0])) {
	                    invokeSubscriber();
	                }
	            });
	        }
	
	    };
	});
	
	// Makes an element examine the outerHeight of its siblings
	// and the max-height of its parent, then sets a max-height for itself
	// so that everything fits within the limits of the parent. Note that it assumes
	// no other sibling also has dynamic-maxheight.
	(0, _angular.$registerDirective)('dynamicMaxheight', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function resizeContainer() {
	                var $element = (0, _jquery2['default'])(element);
	                var parentHeight = parseFloat(getStyle($element.parent()[0], 'max-height'));
	                var siblings = $element.siblings().filter(function () {
	                    var pos = getStyle((0, _jquery2['default'])(this)[0], 'position');
	                    return pos !== 'fixed' && pos !== 'absolute';
	                }).map(function getOuterHeights() {
	                    return (0, _jquery2['default'])(this).outerHeight();
	                });
	                var siblingsHeight = 0;
	                var i;
	
	                for (i = 0; i < siblings.length; i += 1) {
	                    siblingsHeight += siblings[i];
	                }
	
	                var spaceAvailable = parentHeight - siblingsHeight;
	
	                if (!isNaN(spaceAvailable)) {
	                    $element.css('max-height', spaceAvailable + 'px');
	                }
	            }
	
	            // if an expression is provided, it is used as an event to listen for and recalculate the height
	            if (attrs.dynamicMaxheight) {
	                scope.$on((0, _angular.$parse)(attrs.dynamicMaxheight)(scope), resizeContainer);
	            }
	
	            (0, _angular.$timeout)(resizeContainer);
	        }
	    };
	});
	
	_angular.$registerDirective;
	
	_angular.$filterProvider;
	
	_angular.$parse;
	
	_angular.$timeout;
	
	_angular.$window;

/***/ },

/***/ "./components/xo-page-components/src/cart/lib/decode_entities.js":
/***/ function(module, exports) {

	
	
	/**
	 * Takes a string with HTML entities within and renders it as the unicode
	 * characters they represent. This is done by leveraging the browser to
	 * perform this transformation internally. InnerText is chosen as the output
	 * so as to kill any HTML itself that was supplied.
	 *
	 * @param {Element} element any HTML element supporting innerText and
	 * innerHTML. Preferably one not connected to the DOM or visible in any way.
	 * @param {String} input a String containing HTML entities that need to be
	 * decoded and HTML stripped.
	 * @return {String} the same string with HTML tags removed and entities
	 * decoded.
	 */
	
	exports.__esModule = true;
	exports.decodeEntities = decodeEntities;
	exports['default'] = decodeEntitiesAngularFilter;
	function decodeEntities(element, input) {
	    // Escape opening tags on vulnerable tags
	    input = input.replace(/<(\/?)(html|script|body|meta|style|img|iframe|svg|link)/ig, '&lt;$1$2');
	    element.innerHTML = input;
	    return element.textContent || element.innerText;
	}
	
	function decodeEntitiesAngularFilter() {
	    // A constant key that can be used to find the element
	    var ENTITY_ELEM = '__xpc_entitydecoder__';
	
	    // Create the element if this is the first time this is called
	    if (!window[ENTITY_ELEM]) {
	        window[ENTITY_ELEM] = document.createElement('p');
	    }
	
	    // Retrieve the converter element rather than create one every
	    // time. Angular may call this filter many times repeatedly and
	    // we should make a small effort to optimize the process
	    var converter = window[ENTITY_ELEM];
	
	    /**
	     * Takes a string with HTML entities within and renders it as the unicode
	     * characters they represent. This is done by leveraging the browser to
	     * perform this transformation internally. InnerText is chosen as the output
	     * so as to kill any HTML itself that was supplied.
	     *
	     * @param {String} input a String containing HTML entities that need to be
	     * decoded and HTML stripped.
	     * @return {String} the same string with HTML tags removed and entities
	     * decoded.
	     */
	    return decodeEntities.bind(null, converter);
	}

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"cartContainer\" content ng-if=\"showAmt || showArrow\">\n    <div class=\"transactionDetailsContainer\" ng-class=\"{cart:showCart, hasAmount:showAmt}\">\n\n        <a href=\"#transactionCartDetails\"\n           class=\"transactionDetails scTrack:hermes-cartExpanded\"\n           aria-controls=\"transctionCartDetails\" aria-label=\"{{ content('base.shoppingCart') }}\" aria-haspopup=\"true\"\n           role=\"button\" ng-click=\"toggleCart($event)\"\n           focus-when focus-refresh-on=\"'cart-closed'\" ng-if=\"showArrow\">\n            <cart-wrapper ng-if=\"showArrow\" show-amt=\"showAmt\" show-arrow=\"showArrow\" token=\"token\"></cart-wrapper>\n        </a>\n\n        <cart-wrapper ng-if=\"!showArrow\" show-amt=\"showAmt\" show-arrow=\"showArrow\"\n                      token=\"token\"></cart-wrapper>\n\n        <div class=\"transctionCartDetails\" modal-box modal-refresh-on=\"'cart-updated'\" modal-cancel=\"closeCart()\" aria-hidden=\"{{ !showArrow }}\" ng-if=\"showArrow\">\n            <div class=\"details\" role=\"document\" focus-when focus-refresh-on=\"'cart-updated'\" focus-element=\"expandedIndex === -1 ? 'a.more': 'a.less'\">\n\n                <a id=\"closeCart\" link-button=\"content('header.close')\" class=\"actions focusableIcon\" ng-click=\"closeCart($event)\" ></a>\n\n                <div>\n                    <h3 ng-if=\"checkoutAppData.merchant\" class=\"merchantName\" ng-class=\"{merchantTitle: showAmt && (note || desc)}\" id=\"merchantName\">\n                        <span ng-if=\"note\">{{ content('header.noteFromMerchant', {merchant: checkoutAppData.merchant.brand_name}) }}</span>\n                        <span ng-if=\"!note\">{{ checkoutAppData.merchant.brand_name }}</span>\n                    </h3>\n                    <p ng-if=\"note || desc\"class=\"note\" ng-class=\"{ noteHighlighted: desc || !showAmt }\">\n                        <span ng-if=\"note\">{{ note | decodeEntities }}</span>\n                        <span ng-if=\"!note\">{{ desc | decodeEntities }}</span>\n                    </p>\n                </div>\n\n                <div dynamic-maxheight=\"'cart-updated'\" class=\"scrollable-middle\">\n                    <ul class=\"detail-items\" ng-if=\"hasItems\">\n                        <li ng-repeat=\"item in checkoutCart.purchase.items\" class=\"items\">\n\n                            <div class=\"itemNameContainer\" ng-class=\"{expanded: isExpanded($index)}\">\n                                <a class=\"more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'floating')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a>\n                                <span on-ellipsis=\"toolong($index)\" title=\"{{ item.name }}\" class=\"itemName\">{{ item.name }} <a class=\"less\" link-button=\"content('header.srLess')\" ng-show=\"isExpanded($index) && !item.hasDetails\" ng-click=\"collapse()\">{{ content('header.less') }}</a><a class=\"more inline-more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'inline')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a></span>\n                            </div>\n                            <span class=\"itemPrice\">\n                                <format-currency code=\"item.amount.currency_code\" amount=\"item.amount.amount\"></format-currency>\n                            </span>\n                            <item-details ng-show=\"isExpanded($index) && item.hasDetails\" currency-code=\"item.amount.currency_code\" details=\"item.details\" on-click-less=\"collapse()\">\n                        </li>\n                    </ul>\n\n                    <ul class=\"detail-extras\" ng-if=\"showAmt && hasItems\">\n                        <li class=\"detail-breakdown\" ng-if=\"checkoutCart.purchase.amounts\">\n                            <li ng-repeat=\"breakdown in checkoutCart.purchase.amounts\" class=\"amounts\" ng-if=\"showCartItem(breakdown)\">\n                                <span class=\"itemNameContainer\">{{ content(amountHeaders[breakdown.field_name]) }}</span>\n                                <span class=\"itemPrice\">\n                                    <format-currency code=\"breakdown.currency_code\" amount=\"breakdown.amount\"></format-currency>\n                                </span>\n                            </li>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class=\"subTotal\" ng-if=\"showAmt && checkoutCart.purchase.amounts.total\">\n                    <span class=\"itemNameContainer\">{{ userAction === 'commit' || showCartTotal === true ? content('header.total') : content('header.subTotal') }}</span>\n                    <span class=\"itemPrice\">\n                        <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                                         amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                    </span>\n                </div>\n\n            </div>\n            <div class=\"pointer\"> </div>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/cart/lib/cart_pxp.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$pxpCartDesc = $pxpCartDesc;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function $pxpCartDesc() {
	    // ask if the show desc treatment is present
	    return (0, _squid.$pxp)('xo_hermesnodeweb_all_cart_DESC_v1', 'xo_hermesnodeweb_all_cart_DESC_Treatment').then(function (result) {
	        return !!result;
	    });
	}
	
	angular.value("$pxpCartDesc", $pxpCartDesc);
	_squid.$pxp;

/***/ },

/***/ "./components/xo-page-components/src/cart/cartWrapper/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/cartWrapper/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-cart.cart-wrapper.directive', ['squid', 'xomodel.checkout']).directive('cartWrapper', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                showAmt: '=',
	                showArrow: '=',
	                token: '='
	            },
	            controller: function controller($scope, $populate, $util, $CheckoutCartModel) {
	
	                $util.assert($scope.token, 'Expected token');
	
	                $populate($scope, {
	                    checkoutCart: $CheckoutCartModel.instance($scope.token)
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/cartWrapper/template.html":
/***/ function(module, exports) {

	module.exports = "<span class=\"totalWrapper clearfix\" id=\"totalWrapper\" content>\n    <span id=\"transactionCart\" ng-class=\"{hasItems:showArrow}\">\n        <span class=\"cartIcon\" aria-label=\"{{ content('base.shoppingCart') }}\"></span>\n        <span ng-if=\"showAmt\">\n            <format-currency class=\"formatCurrency\" code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                             amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n        </span>\n        <span ng-if=\"showArrow && checkoutCart.purchase.items\" class=\"arrow\" aria-label=\"{{ content('common.show') }}\"/>\n    </span>\n</span>"

/***/ },

/***/ "./components/xo-page-components/src/cart/itemDetails/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/itemDetails/template.html"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-cart.item-details.directive', ['squid', 'xo-accessibility.directive']).directive('itemDetails', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                details: '=',
	                sku: '=',
	                currencyCode: '=',
	                onClickLess: '&'
	            },
	            controller: function controller() {/* dumb component */}
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/itemDetails/template.html":
/***/ function(module, exports) {

	module.exports = "<!-- this directive requires\n  * visible boolean\n  * details object (with .price, .quantity, .description,\n  * possible .item_option_selections)\n  * currency-code string\n  * possible sku (item number)\n  * on-click-less - function invocation expression\n-->\n<ul content class=\"itemDetails\">\n  <li ng-if=\"details.sku\">\n      <span>\n          <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ details.sku }}</span>\n      </span>\n  </li>\n  <li ng-if=\"details.price\">{{ content('header.price') }}\n    <format-currency code=\"currencyCode\" amount=\"details.price\"></format-currency>\n  </li>\n  <li ng-if=\"details.quantity\">{{ content('header.quantity') }} <span class=\"item-quantity\">{{ details.quantity }}</span></li>\n  <li ng-if=\"details.hasMore\">\n    <div ng-if=\"details.hasSelections\" class=\"item-selections\">\n      <span class=\"item-selection\" ng-repeat=\"selection in details.item_option_selections\">\n        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n        <span class=\"item-selection-value\">{{ selection.select }}</span>\n      </span>\n    </div>\n\n    <div ng-if=\"details.description\">\n      <strong class=\"item-selection-name\">{{ content('header.description') }}</strong> <span class=\"item-description\">{{ details.description }}</span>\n    </div>\n    <a class=\"less\" link-button=\"content('header.srLess')\" ng-click=\"onClickLess()\">{{ content('header.less') }}</a>\n  </li>\n</ul>\n"

/***/ },

/***/ "./components/xo-ui-components/src/escape-hatch/closeFrame/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/closeFrame/template.html"), __webpack_require__("./components/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-escape-hatch.closeFrame.directive', ['squid', 'xomodel.user']).directive('xoCloseFrame', function () {
	        return {
	            template: template,
	
	            restrict: 'E',
	
	            scope: {
	                redirectiframe: '=',
	                redirectLightbox: '='
	            },
	
	            controller: function controller($scope, $rootScope, $populate, $CheckoutInputDataModel, $window, $CheckoutAppDataModel, $util, $injector, $logger, $ReturnToMerchant) {
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
	                }).then(function () {
	                    var cancel_url = $scope.checkoutAppData.urls.cancel_url;
	
	                    $scope.checkoutInputData = $CheckoutInputDataModel.instance($scope.token);
	                    $scope.isIFrame = $util.isIFrame();
	
	                    $scope.closeFrame = function (event) {
	                        event.preventDefault();
	                        event.stopPropagation();
	
	                        if (window.paypalCheckout) {
	                            if (window.paypalCheckout.props.onPaymentCancel) {
	                                return window.paypalCheckout.props.onPaymentCancel({
	                                    token: $scope.token,
	                                    cancelUrl: cancel_url
	                                });
	                            } else {
	                                return window.paypalCheckout.close();
	                            }
	                        }
	
	                        if ($scope.redirectLightbox) {
	                            var result = $ReturnToMerchant.postToMerchant({
	                                operation: 'return_to_merchant',
	                                returnUrl: cancel_url,
	                                updateParent: true
	                            });
	
	                            // Otherwise we have no choice but to return to the merchant
	                            if (!result) {
	                                $util.redirect(cancel_url);
	                            }
	
	                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
	                        } else if ($scope.redirectiframe) {
	                            $window.location.replace(cancel_url);
	
	                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
	                        } else {
	
	                            var iFrameFlow = $injector.get('$IFrameFlow');
	
	                            $logger.info('HELIOS_FLOW_FALLBACK'); // overall fallbacks
	                            $logger.info('HELIOS_FALLBACK_TO_MERCHANT');
	                            $logger.info('HELIOS_FALLBACK_MERCHANT_USER_CANCELLED');
	
	                            var url = $scope.checkoutInputData.errorUrl('user_cancelled');
	
	                            if ($scope.auth && $scope.auth.code) {
	                                url += '&code=' + $scope.auth.code;
	                            }
	
	                            iFrameFlow.findWindowAndRedirect($scope.checkoutInputData, url);
	                        }
	                        $scope.$emit('exitFrame');
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/closeFrame/template.html":
/***/ function(module, exports) {

	module.exports = "<a ng-show=\"isIFrame\" href=\"{{redirectURL}}\" id=\"closeButton\" target=\"_parent\" role=\"button\" ng-click=\"closeFrame($event)\">{{ content('base.closePayPalCheckoutLabel') }}</a>\n"

/***/ },

/***/ "./components/xo-page-components/src/footer/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/footer/template.html"), __webpack_require__("./components/xo-page-components/src/footer/opinionlab.js"), __webpack_require__("./components/xo-page-components/src/footer/footerMap.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-ui-components/src/modal/directive.js"), __webpack_require__("./components/xo-return-to-merchant/dist/util.js"), __webpack_require__("./components/xo-ui-components/src/escape-hatch/escapeHatch/directive.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-form-components/src/language-options/directive.js"), __webpack_require__("./components/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template, opinionlab, footerMap) {
	    squid.module('xo-footer.directive', ['squid', 'xomodel.checkout', 'xo-modal.directive', 'xo-return-to-merchant', 'xo-escape-hatch.escapeHatch.directive', 'xo-device-info', 'xo-language-options.directive', 'xomodel.user']).directive('xoFooter', function () {
	
	        return {
	            template: template,
	            restrict: 'EA',
	            scope: {
	                token: '=',
	                escapeHatchIncontext: '=',
	                cancel: '@',
	                hideCancel: '=',
	                merchant: '@',
	                languageSwitch: '=?'
	            },
	            controller: function controller($scope, $populate, $rootScope, $CheckoutAppDataModel, $ReturnToMerchant, $util, $integration, $locale, $window, $DeviceInfo, $feature, $config, $state, $CheckoutInputDataModel) {
	
	                $scope.isIFrame = $util.isIFrame();
	                if ($scope.escapeHatchIncontext) {
	                    $scope.showEscapeHatch = $scope.isIFrame;
	                }
	                $scope.locale = $locale;
	                $scope.proxSignUpFlow = $CheckoutInputDataModel.instance($scope.token).isEbayTxn();
	                $scope.year = new Date().getFullYear();
	
	                $scope.isApac = function () {
	                    return $config.apacCountries && $config.apacCountries.indexOf($scope.locale.country) > -1;
	                };
	
	                // Determine if country belongs to a region to serve correct footer links
	                var getRegion = function getRegion(country) {
	                    var regions = $config.regions;
	                    for (var region in regions) {
	                        if (regions[region].indexOf(country) > -1) {
	                            return region;
	                        }
	                    }
	
	                    return false;
	                };
	
	                $scope.footerLinks = function () {
	                    if ($scope.isApac()) {
	                        return footerMap.APAC;
	                    }
	
	                    return footerMap[$scope.locale.country] || footerMap[getRegion($scope.locale.country)] || footerMap.DEFAULT;
	                };
	
	                $scope.showPolicyInfo = function () {
	                    return $scope.isApac() || $scope.locale.country === 'AU';
	                };
	
	                $scope.cancelRedirect = function ($event) {
	                    $event.preventDefault();
	
	                    var cancelUri = $scope.cancel;
	                    var redirectUri;
	
	                    // "redirect_uri" as a query param overrides the cancel url in the checkout session
	                    if ($integration.getConfig('REDIRECT_QUERY_PARAM')) {
	                        redirectUri = $util.param('redirect_uri');
	
	                        cancelUri = $util.buildURL(redirectUri, {
	                            opType: 'cancel',
	                            return_uri: $scope.cancel,
	                            token: $scope.token
	                        });
	                    }
	
	                    $ReturnToMerchant.goTo(cancelUri);
	                };
	
	                if ($scope.token) {
	                    $populate($scope, {
	                        checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                    }).then(function () {
	                        var merchant = $scope.checkoutAppData.merchant;
	                        $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
	                        $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	
	                        // for ebay transactions, override the merchant name to ebay instead of the actual merchant.
	                        if ($scope.proxSignUpFlow) {
	                            $scope.merchant = $locale.content.signup.ebay;
	                        }
	                    });
	                }
	
	                var cancelShowModal = $rootScope.$on('showModal', function (event, config) {
	                    $scope.popupUrl = config && config.popupUrl;
	                    $scope.show = true;
	                    $scope.$digest(); // eslint-disable-line angular/ng_no_digest
	                });
	
	                $scope.$on('$destroy', cancelShowModal);
	
	                $scope.showOL = function showOL(event) {
	                    event.preventDefault();
	
	                    var placeholder = 'main:ec:hermes';
	                    var page = $state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
	
	                    var data = {
	                        opVars: {
	                            rlogId: $window.meta.rlogId || '',
	                            page: page || window.location.hash,
	                            csci: 'Unknown',
	                            calc: $window.meta.correlationId,
	                            custId: 'Unknown',
	                            merchantId: 'Unknown',
	                            token: $scope.token || 'Unknown'
	                        },
	                        locale: {
	                            country: $locale.country,
	                            languageCode: $locale.lang + '_' + $locale.country
	                        }
	                    };
	
	                    opinionlab(data);
	                };
	
	                $scope.showFeedback = function () {
	                    if ($DeviceInfo.isDevice()) {
	                        return false;
	                    }
	                    return true;
	                };
	
	                $scope.hideReturnCancelUrl = function () {
	                    return !$scope.cancel || $state.current && $state.current.name === 'checkout.done';
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-page-components/src/footer/opinionlab.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var _doc = document;
	    var _w = window;
	    var _tm = new Date().getTime();
	    var _sH = screen.height;
	    var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
	    var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
	    var _sW = screen.width;
	
	    function popUp(opinionlabURL) {
	        _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
	    }
	
	    function updateCustomVars(data) {
	
	        var opVars = data.opVars;
	        var locale = data.locale;
	
	        _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef
	
	        var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';
	        return customVar;
	    }
	
	    function _fC(_u) {
	        var _sp = '%3A\\/\\/';
	        var _rp = '%3A//';
	        var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
	        var _aA = _aT.split(',');
	
	        for (var i = 0; i < 5; i++) {
	            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
	        }
	        return _u;
	    }
	
	    return function (locale) {
	
	        var custom_var = updateCustomVars(locale);
	
	        var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;
	        popUp(opinionlabURL);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-page-components/src/footer/footerMap.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	!(module.exports = {
	    CA: [{
	        id: 'policy',
	        content: 'footer.policiesCA'
	    }, {
	        id: 'terms',
	        content: 'footer.termsCA'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacyCA'
	    }],
	
	    BE: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    DE: [{
	        id: 'imprint',
	        content: 'footer.DEImprint'
	    }, {
	        id: 'legal',
	        content: 'footer.DELegal'
	    }, {
	        id: 'privacy',
	        content: 'footer.DEPrivacy'
	    }, {
	        id: 'paymentdesc',
	        content: 'footer.DEKeyPaymentDesc'
	    }],
	
	    ES: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    FR: [{
	        id: 'legal',
	        content: 'footer.FRLegal'
	    }, {
	        id: 'useragreement',
	        content: 'footer.FRUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.FRPrivacy'
	    }],
	
	    IT: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    NL: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    IE: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    APAC: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    EMEA: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    EM: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    LATAM: [{
	        id: 'help',
	        content: 'footer.help'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    AU: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    AT: [{
	        id: 'imprint',
	        content: 'footer.ATImprint'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    CH: [{
	        id: 'imprint',
	        content: 'footer.CHImprint'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    DK: [{
	        id: 'useragreement',
	        content: 'footer.DKUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    SE: [{
	        id: 'useragreement',
	        content: 'footer.SEUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    PL: [{
	        id: 'useragreement',
	        content: 'footer.PLUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    NO: [{
	        id: 'useragreement',
	        content: 'footer.NOUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    TR: [{
	        id: 'useragreement',
	        content: 'footer.TRUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    BR: [{
	        id: 'help',
	        content: 'footer.help'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    MX: [{
	        id: 'help',
	        content: 'footer.help'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    RU: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    DEFAULT: [{
	        id: 'policy',
	        content: 'footer.policies'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }]
	});

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/footer/template.html":
/***/ function(module, exports) {

	module.exports = "<footer content>\n    <div class=\"footer clearfix commonFooter\" role=\"contentinfo\" ng-class=\"{APAC: isApac()}\">\n        <p ng-if=\"!hideCancel\" id=\"defaultCancelLink\" class=\"cancelUrl\">\n            <a track-link=\"cancel_and_return_to_merchant\" href=\"{{cancel}}\" ng-click=\"cancelRedirect($event)\" role=\"button\" id=\"cancelLink\" ng-hide=\"hideReturnCancelUrl()\">\n               <span bind-html-compile=\"merchant ? content('base.cancelUrl', { merchantName: merchant, modelName: 'merchant' }) : content('common.cancelAndReturnToMerchant')\"></span>\n            </a>\n        </p>\n\n        <div class=\"footerWrapper\">\n            <ul class=\"footerLinks\">\n                <li class=\"first\" bind-html-compile=\"htmlContent(link.content, {country: locale.country.toLowerCase(), lang: locale.lang})\" ng-repeat=\"link in footerLinks()\"\n                    id=\"footer_{{link.id}}\"></li>\n                <li class=\"feedback last\">\n                    <a ng-if=\"showFeedback()\" href=\"#\" id=\"footer_sfLink\" ng-click=\"showOL($event)\">{{ content('OpinionLab.SiteFeedback')\n                        }}</a>\n                </li>\n            </ul>\n            <p class=\"copyright\">\n                {{ content('footer.copyright', {year: year}) }}\n                <span class=\"secureIcon\"></span>\n                <span class=\"accessAid\">{{ content('memberReview.propHead') }}</span>\n            </p>\n\n            <xo-language-options ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n        </div>\n\n        <div class=\"policyInfoWrapper\" ng-if=\"showPolicyInfo()\">\n            <p class=\"moreInfo\" ng-bind-html=\"htmlContent('footer.policyInformation', {country: locale.country})\"> </p>\n            <p class=\"moreCopyRight\" ng-if=\"locale.country === 'AU'\">{{ content('footer.moreCopyright', {year: year}) }}</P>\n        </div>\n\n    </div>\n    <xo-modal>\n        <p>{{ content('footer.openLinks') }}</p>\n        <p class=\"popLink\">{{popupUrl}}</p>\n        <input class=\"btn btn-submit full\" type=\"button\" ng-click=\"hideModal()\" value=\"{{ content('footer.okBtn') }}\">\n    </xo-modal>\n</footer>\n"

/***/ },

/***/ "./components/xo-ui-components/src/escape-hatch/escapeHatch/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/escapeHatch/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-escape-hatch.escapeHatch.directive', ['squid']).directive('xoEscapeHatch', function () {
	        return {
	            template: template,
	
	            restrict: 'E',
	
	            controller: function controller($scope, $rootScope, $window, $util, $logger) {
	                $scope.isIFrame = $util.isIFrame();
	                $scope.closeFrame = function (event) {
	                    var url = $window.location.href && $window.location.href.split('#')[0] || '';
	
	                    if (url.indexOf('proxflow') > -1) {
	                        url = url.replace('proxflow', 'webapps/helios');
	                    }
	
	                    url += url.slice(-1) === '&' ? 'escape_hatch=1' : '&escape_hatch=1';
	
	                    if (url.indexOf('hermes') > -1 || url.indexOf('checkoutnow')) {
	                        $logger.info('HERMES_ESCAPE_HATCH_CLICKED');
	                    } else {
	                        $logger.info('HELIOS_ESCAPE_HATCH_CLICKED');
	                    }
	
	                    $window.top.location = url;
	                    $scope.$emit('exitFrame');
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/escapeHatch/template.html":
/***/ function(module, exports) {

	module.exports = "<button ng-show=\"isIFrame\" title=\"{{content('footer.escHatch')}}\" class='btn escapeHatch' ng-click=\"closeFrame()\"><span class=\"accessAid\">{{content('footer.escHatch')}}</span></button>\n"

/***/ },

/***/ "./components/xo-login-components/src/login-overlay/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-login-components/src/create-password/directive.js");
	
	__webpack_require__("./components/xo-login-components/src/password-recovery/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/login-overlay/template.html"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-login-overlay.directive', ['squid', 'xomodel.checkout']).directive('xoLoginOverlay', function () {
	
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                stateInfo: '=',
	                modalCallback: '='
	            },
	            controller: function controller($scope, $rootScope, $state, $element, $feature, $timeout, $logger, $util, $AuthModel, $CheckoutSessionModel, $CheckoutCartModel) {
	
	                $scope.autoLogin = false;
	                $scope.ulEligibility = true;
	                $scope.auth = $AuthModel.instance();
	
	                var stateInfo = {};
	                var subFlowTitles = {
	                    addCard: 'loginAddCard',
	                    bank: 'loginAddBank',
	                    addShipping: 'loginAddAddress',
	                    deleteShipping: 'loginDeleteAddress',
	                    confirmUpop: 'loginConfirmUpop',
	                    redirectToCape: 'loginApplyCredit',
	                    sepaAgreement: 'riskyLoginSepa',
	                    applyPPC: 'loginApplyCredit',
	                    DEFAULT: 'loginTitle'
	                };
	
	                function getFptiStateName() {
	                    if ($scope.createPassword) {
	                        return 'quick_security_check';
	                    } else if ($scope.passwordRecovery) {
	                        return 'password_recovery';
	                    } else {
	                        return 'LOGIN_STEP_UP_AUTH';
	                    }
	                }
	
	                var cancelInsufficientPermission = $rootScope.$on('$insufficientPermission', function (event, data) {
	                    $scope.showOverlay = true;
	
	                    $('#wrapper #spinner').hide();
	
	                    stateInfo = data;
	
	                    var subFlowName = (stateInfo.newState || '').replace(/^.*\./, '');
	
	                    if (subFlowName) {
	                        $scope.subFlowName = subFlowName;
	                        $scope.subFlowTitleKey = 'login.' + subFlowTitles[subFlowName] || subFlowTitles.DEFAULT;
	                    }
	
	                    $scope.createPassword = $feature('pomaPasswordRecovery') && $scope.auth.password_less;
	                    $scope.passwordRecovery = false;
	                    if ($scope.createPassword) {
	                        $logger.info('checkout_fpti', {
	                            from: getFptiStateName(),
	                            to: 'prepare_quick_security_check'
	                        });
	                    } else {
	                        $logger.info('checkout_fpti', {
	                            from: getFptiStateName(),
	                            to: 'prepare_login_step_up_AUTH'
	                        });
	                    }
	
	                    $timeout(function () {
	                        $element.addClass('overlayOpen');
	                    });
	                });
	
	                $scope.$on('$destroy', cancelInsufficientPermission);
	
	                var hideOverlay = function hideOverlay() {
	                    $('#wrapper #spinner').attr('style', '');
	                    $element.removeClass('overlayOpen');
	                    return $timeout(function () {
	                        $scope.showOverlay = false;
	                    }, 300);
	                };
	
	                function logCancel() {
	                    $logger.info('checkout_fpti', {
	                        from: getFptiStateName(),
	                        to: 'process_user_cancel'
	                    });
	                }
	
	                $scope.hideModal = function (event) {
	                    event.preventDefault();
	                    logCancel();
	                    hideOverlay();
	                    $state.go(stateInfo.oldState);
	                };
	
	                $scope.onCreatePassword = function () {
	                    $rootScope.$emit('loading');
	                    $scope.passwordRecovery = true;
	                };
	
	                $scope.onPasswordRecoveryReady = function () {
	                    $rootScope.$emit('loaded');
	                    $scope.createPassword = false;
	                };
	
	                $scope.onCompletePasswordRecovery = function () {
	                    $scope.passwordRecovery = false;
	                };
	
	                $scope.onPasswordRecovery = function () {
	                    $scope.auth.password_less = false;
	                };
	
	                $scope.onSuccess = function () {
	                    var checkoutSession = $CheckoutSessionModel.instance($scope.token);
	                    var checkoutCart = $CheckoutCartModel.instance($rootScope.token);
	                    return checkoutSession.action('create', {
	                        data: {
	                            baToken: checkoutCart.billing && checkoutCart.billing.ba_token
	                        },
	                        success: function success() {
	                            if (stateInfo.pageOnOverlay) {
	                                $state.go(stateInfo.newState, { fromLoginOverlay: true });
	                                $scope.showOverlay = false;
	                            } else {
	                                hideOverlay().then(function () {
	                                    $state.go(stateInfo.newState);
	                                });
	                            }
	
	                            $logger.info('checkout_fpti', {
	                                from: getFptiStateName(),
	                                to: 'process_login_step_up_AUTH'
	                            });
	                        }
	                    })['finally'](function () {
	                        hideOverlay();
	                    });
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-login-components/src/password-recovery/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _model = __webpack_require__("./components/xo-tracking/dist/model.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _template = __webpack_require__("./components/xo-login-components/src/password-recovery/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryDirective', {
	    tag: 'xo-password-recovery',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        },
	        onContinue: {
	            type: 'var'
	        },
	        onPasswordRecovery: {
	            type: 'var'
	        },
	        onLoad: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            var PAYPAL = window.PAYPAL;
	
	            this.loaded = false;
	            var postMessageHandler = function postMessageHandler(response) {
	                (0, _angular.$timeout)(function () {
	                    switch (response.event) {
	                        case 'render':
	                            if (response.pageName === 'authflow/password-recovery/done') {
	                                _this.onPasswordRecovery();
	                                _logger.$logger.info('checkout_fpti', {
	                                    from: 'password_recovery',
	                                    to: 'process_password_recovery'
	                                });
	                            } else if (response.pageName === 'authflow/password-recovery') {
	                                _this.onLoad();
	                                _this.loaded = true;
	                                _logger.$logger.info('checkout_fpti', {
	                                    from: 'password_recovery',
	                                    to: 'prepare_password_recovery'
	                                });
	                            } else {
	                                // Do nothing
	                            }
	                            break;
	                        case 'passwordSetSuccess':
	                            _this.onContinue();
	                            break;
	                        default:
	                            break;
	                    }
	                });
	            };
	
	            this.loadPasswordRecoveryFlow = function () {
	                var isHermesInsideIframe = _squid.$util.isIFrame();
	
	                if (isHermesInsideIframe) {
	                    _logger.$logger.info('MERCHANT_IFRAME_INTEGRATION');
	                }
	                var options = {
	                    targetElement: document.getElementById('injectedPasswordRecovery'),
	                    xhrRequest: isHermesInsideIframe,
	                    iframePathname: '/authflow/password-recovery',
	                    caller: 'secondaryIframe',
	                    queryParams: {
	                        'country.x': _squid.$locale.country,
	                        'locale.x': _squid.$locale.getLocaleCode(),
	                        'contextId': _this.token,
	                        'correlationId': _model.$CalDataModel.getCalCorrId()
	                    },
	                    onPostMessage: postMessageHandler
	                };
	
	                if (_squid.$config.deploy.isLocal()) {
	                    options.origin = 'https://' + _squid.$meta.stage;
	                }
	
	                if (PAYPAL && PAYPAL.unifiedLogin) {
	                    PAYPAL.unifiedLogin.inject(options);
	                }
	            };
	
	            (0, _angular.$timeout)(this.loadPasswordRecoveryFlow);
	        }
	    }
	});
	
	_squid.$Component;
	
	_squid.$config;
	
	_squid.$locale;
	
	_squid.$meta;
	
	_squid.$util;
	
	_model.$CalDataModel;
	
	_angular.$timeout;
	
	_logger.$logger;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-login-components/src/password-recovery/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"injectedPasswordRecovery\" ng-show=\"loaded\">\n</div>\n"

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/login-overlay/template.html":
/***/ function(module, exports) {

	module.exports = "<div ng-if=\"showOverlay\" class=\"pageOverlay\" ng-class=\"{mobile: isDevice}\">\n    <div class=\"overlayMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <xo-spinner></xo-spinner>\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" ng-click=\"hideModal($event)\"></a>\n                <section class=\"login\" id=\"login\">\n                    <xo-login-handler ng-if=\"!passwordRecovery && !createPassword\" token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\" ul-eligibility=\"ulEligibility\" sub-flow-title-key=\"subFlowTitleKey\" hideloginpp=\"true\"></xo-login-handler>\n                    <xo-create-password ng-if=\"createPassword\" token=\"token\" reason=\"subFlowName\" on-continue=\"onCreatePassword\" on-cancel=\"hideModal\"></xo-create-password>\n                    <xo-password-recovery ng-if=\"passwordRecovery\" token=\"token\" on-password-recovery=\"onPasswordRecovery\" on-load=\"onPasswordRecoveryReady\" on-continue=\"onCompletePasswordRecovery\" on-cancel=\"onCancel\"></xo-password-recovery>\n                </section>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n</div>\n\n"

/***/ },

/***/ "./pages/xo-checkout/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"outerWrapper\" ng-class=\"[locale.country, locale.lang, miniBrowser?'minibrowser':'', isApp?'mobileApp':'',  models.checkoutCart.isWalletTokenization() ? 'tokenization': '']\" id=\"outerWrapper\" >\n    <!-- Messenger BA .. HIDE this -->\n    <xo-merchant-header ng-if=\"!isMessengerBAIntegration\" token=\"token\" role=\"heading\" aria-level=\"1\"></xo-merchant-header>\n    <div id=\"wrapper\" class=\"clearfix\">\n        <div id=\"sliding-area\" tabindex=\"-1\">\n            <div id=\"main\">\n                <xo-header token=\"token\" role=\"heading\" aria-level=\"2\" redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-header>\n                <div id=\"contents\">\n                    <div ui-view></div>\n                </div>\n            </div>\n        </div>\n        <xo-spinner></xo-spinner>\n    </div>\n    <!-- Messenger BA .. HIDE this -->\n    <xo-footer ng-if=\"!isMessengerBAIntegration\" token=\"token\" escape-hatch-incontext=\"escapeHatchInContext\" hide-cancel=\"hideCancel\"></xo-footer>\n    <xo-login-overlay  token=\"token\"></xo-login-overlay>\n</div>\n"

/***/ },

/***/ "./..":
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/less-loader/index.js!./styles.less", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js!./../../../../../node_modules/less-loader/index.js!./styles.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "./..":
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/less-loader/index.js!./styles.less", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/less-loader/index.js!./styles.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "./pages/xo-sidebar-update-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarUpdateShippingPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-sidebar-update-shipping/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarUpdateShippingPageComponent = exports.$xoSidebarUpdateShippingPageComponent = _squid.$Component.extend('$xoSidebarUpdateShippingPageComponent', {
	    tag: 'xo-sidebar-update-shipping-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state) {
	        $scope.token = $rootScope.token;
	        $scope.sidebar = true;
	
	        $scope.onComplete = function () {
	            $state.go('checkout.review');
	        };
	    }
	});
	
	angular.value("$xoSidebarUpdateShippingPageComponent", $xoSidebarUpdateShippingPageComponent);
	_squid.$Component;

/***/ }

});


// WEBPACK FOOTER //
// js/main.js